import React__default, { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode, createPortal } from 'react-dom';
/**
 * From Tints and Shades Generator.
 * https://github.com/edelstone/tints-and-shades
 */

function pad(number, length) {
  var str = '' + number;

  while (str.length < length) {
    str = '0' + str;
  }

  return str;
}

function hexToRGB(colorValue) {
  return {
    red: parseInt(colorValue.substr(1, 2), 16),
    green: parseInt(colorValue.substr(3, 2), 16),
    blue: parseInt(colorValue.substr(5, 2), 16)
  };
}

function intToHex(rgbint) {
  return pad(Math.min(Math.max(Math.round(rgbint), 0), 255).toString(16), 2);
}

function rgbToHex(rgb) {
  return '#' + intToHex(rgb.red) + intToHex(rgb.green) + intToHex(rgb.blue);
}

function rgbShade(rgb, i) {
  return {
    red: rgb.red * (1 - 0.1 * i),
    green: rgb.green * (1 - 0.1 * i),
    blue: rgb.blue * (1 - 0.1 * i)
  };
}

function rgbTint(rgb, i) {
  return {
    red: rgb.red + (255 - rgb.red) * i * 0.1,
    green: rgb.green + (255 - rgb.green) * i * 0.1,
    blue: rgb.blue + (255 - rgb.blue) * i * 0.1
  };
}

function calculate(colorValue, shadeOrTint) {
  var color = hexToRGB(colorValue);
  var shadeValues = [];

  for (var i = 0; i < 10; i++) {
    shadeValues[i] = rgbToHex(shadeOrTint(color, i));
  }

  return shadeValues;
}

function calculateShades(colorValue) {
  return calculate(colorValue, rgbShade).concat('#000000');
}

function calculateTints(colorValue) {
  return calculate(colorValue, rgbTint).concat('#FFFFFF');
}
/**
 * Default Fincite Colors
 */


var colors = {
  primary: '#0D2440',
  secondary: '#3C4B9E',
  tertiary: '#E3AA30',
  quaternary: '#48545E',
  quinary: '#9BA1A6',
  senary: '#F0F0F0'
};
var shades = {
  primary: calculateShades(colors.primary),
  secondary: calculateShades(colors.secondary),
  tertiary: calculateShades(colors.tertiary),
  quaternary: calculateShades(colors.quaternary),
  quinary: calculateShades(colors.quinary),
  senary: calculateShades(colors.senary)
};
var tints = {
  primary: calculateTints(colors.primary),
  secondary: calculateTints(colors.secondary),
  tertiary: calculateTints(colors.tertiary),
  quaternary: calculateTints(colors.quaternary),
  quinary: calculateTints(colors.quinary),
  senary: calculateTints(colors.senary)
};
var colorsList = [colors.primary, colors.secondary, colors.tertiary, colors.quaternary, colors.quinary, colors.senary];
var defaultColors = {
  colors: colors,
  tints: tints,
  shades: shades,
  colorsList: colorsList
};
/**
 * Default Fincite Fixed Colors
 */

var fixedColors = {
  background: '#ffffff',
  backgroundLight: '#f9f9f9',
  mouseoverLightGrey: '#f0f0f2',
  lightGrey: '#e1e3e9',
  disabled: '#cdcfd6'
};
/**
 * Default Fincite Status Colors
 */

var green = '#23d374';
var red = '#FF0000';
var statusColors = {
  warning: red,
  loss: red,
  correct: green,
  profit: green
};
/**
 * Default Fincite Text Colors
 */

var textColors = {
  dark: '#4d4f5c',
  // Text Grey
  light: '#b1b1b1' // Text Light Grey

};
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var highstock = createCommonjsModule(function (module) {
  /*
   Highstock JS v7.0.3 (2019-02-06)
  
   (c) 2009-2018 Torstein Honsi
  
   License: www.highcharts.com/license
  */
  (function (Q, H) {
    module.exports ? (H["default"] = H, module.exports = Q.document ? H(Q) : H) : Q.Highcharts = H(Q);
  })("undefined" !== typeof window ? window : commonjsGlobal, function (Q) {
    var H = function () {
      var a = "undefined" === typeof Q ? "undefined" !== typeof window ? window : {} : Q,
          B = a.document,
          A = a.navigator && a.navigator.userAgent || "",
          G = B && B.createElementNS && !!B.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect,
          m = /(edge|msie|trident)/i.test(A) && !a.opera,
          g = -1 !== A.indexOf("Firefox"),
          t = -1 !== A.indexOf("Chrome"),
          u = g && 4 > parseInt(A.split("Firefox/")[1], 10);
      return a.Highcharts ? a.Highcharts.error(16, !0) : {
        product: "Highstock",
        version: "7.0.3",
        deg2rad: 2 * Math.PI / 360,
        doc: B,
        hasBidiBug: u,
        hasTouch: B && void 0 !== B.documentElement.ontouchstart,
        isMS: m,
        isWebKit: -1 !== A.indexOf("AppleWebKit"),
        isFirefox: g,
        isChrome: t,
        isSafari: !t && -1 !== A.indexOf("Safari"),
        isTouchDevice: /(Mobile|Android|Windows Phone)/.test(A),
        SVG_NS: "http://www.w3.org/2000/svg",
        chartCount: 0,
        seriesTypes: {},
        symbolSizes: {},
        svg: G,
        win: a,
        marginNames: ["plotTop", "marginRight", "marginBottom", "plotLeft"],
        noop: function noop() {},
        charts: []
      };
    }();

    (function (a) {
      a.timers = [];
      var B = a.charts,
          A = a.doc,
          G = a.win;

      a.error = function (m, g, t) {
        var u = a.isNumber(m) ? "Highcharts error #" + m + ": www.highcharts.com/errors/" + m : m;
        t && a.fireEvent(t, "displayError", {
          code: m
        });
        if (g) throw Error(u);
        G.console && console.log(u);
      };

      a.Fx = function (a, g, t) {
        this.options = g;
        this.elem = a;
        this.prop = t;
      };

      a.Fx.prototype = {
        dSetter: function dSetter() {
          var a = this.paths[0],
              g = this.paths[1],
              t = [],
              u = this.now,
              v = a.length,
              y;
          if (1 === u) t = this.toD;else if (v === g.length && 1 > u) for (; v--;) {
            y = parseFloat(a[v]), t[v] = isNaN(y) ? g[v] : u * parseFloat(g[v] - y) + y;
          } else t = g;
          this.elem.attr("d", t, null, !0);
        },
        update: function update() {
          var a = this.elem,
              g = this.prop,
              t = this.now,
              u = this.options.step;
          if (this[g + "Setter"]) this[g + "Setter"]();else a.attr ? a.element && a.attr(g, t, null, !0) : a.style[g] = t + this.unit;
          u && u.call(a, t, this);
        },
        run: function run(m, g, t) {
          var u = this,
              v = u.options,
              y = function y(a) {
            return y.stopped ? !1 : u.step(a);
          },
              q = G.requestAnimationFrame || function (a) {
            setTimeout(a, 13);
          },
              f = function f() {
            for (var e = 0; e < a.timers.length; e++) {
              a.timers[e]() || a.timers.splice(e--, 1);
            }

            a.timers.length && q(f);
          };

          m !== g || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date(), this.start = m, this.end = g, this.unit = t, this.now = this.start, this.pos = 0, y.elem = this.elem, y.prop = this.prop, y() && 1 === a.timers.push(y) && q(f)) : (delete v.curAnim[this.prop], v.complete && 0 === Object.keys(v.curAnim).length && v.complete.call(this.elem));
        },
        step: function step(m) {
          var g = +new Date(),
              t,
              u = this.options,
              v = this.elem,
              y = u.complete,
              q = u.duration,
              f = u.curAnim;
          v.attr && !v.element ? m = !1 : m || g >= q + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), t = f[this.prop] = !0, a.objectEach(f, function (a) {
            !0 !== a && (t = !1);
          }), t && y && y.call(v), m = !1) : (this.pos = u.easing((g - this.startTime) / q), this.now = this.start + (this.end - this.start) * this.pos, this.update(), m = !0);
          return m;
        },
        initPath: function initPath(m, g, t) {
          function u(b) {
            var a, c;

            for (n = b.length; n--;) {
              a = "M" === b[n] || "L" === b[n], c = /[a-zA-Z]/.test(b[n + 3]), a && c && b.splice(n + 1, 0, b[n + 1], b[n + 2], b[n + 1], b[n + 2]);
            }
          }

          function v(a, l) {
            for (; a.length < b;) {
              a[0] = l[b - a.length];
              var c = a.slice(0, r);
              [].splice.apply(a, [0, 0].concat(c));
              d && (c = a.slice(a.length - r), [].splice.apply(a, [a.length, 0].concat(c)), n--);
            }

            a[0] = "M";
          }

          function y(a, n) {
            for (var c = (b - a.length) / r; 0 < c && c--;) {
              l = a.slice().splice(a.length / w - r, r * w), l[0] = n[b - r - c * r], p && (l[r - 6] = l[r - 2], l[r - 5] = l[r - 1]), [].splice.apply(a, [a.length / w, 0].concat(l)), d && c--;
            }
          }

          g = g || "";
          var q,
              f = m.startX,
              e = m.endX,
              p = -1 < g.indexOf("C"),
              r = p ? 7 : 3,
              b,
              l,
              n;
          g = g.split(" ");
          t = t.slice();
          var d = m.isArea,
              w = d ? 2 : 1,
              E;
          p && (u(g), u(t));

          if (f && e) {
            for (n = 0; n < f.length; n++) {
              if (f[n] === e[0]) {
                q = n;
                break;
              } else if (f[0] === e[e.length - f.length + n]) {
                q = n;
                E = !0;
                break;
              }
            }

            void 0 === q && (g = []);
          }

          g.length && a.isNumber(q) && (b = t.length + q * w * r, E ? (v(g, t), y(t, g)) : (v(t, g), y(g, t)));
          return [g, t];
        },
        fillSetter: function fillSetter() {
          a.Fx.prototype.strokeSetter.apply(this, arguments);
        },
        strokeSetter: function strokeSetter() {
          this.elem.attr(this.prop, a.color(this.start).tweenTo(a.color(this.end), this.pos), null, !0);
        }
      };

      a.merge = function () {
        var m,
            g = arguments,
            t,
            u = {},
            v = function v(g, q) {
          "object" !== typeof g && (g = {});
          a.objectEach(q, function (f, e) {
            !a.isObject(f, !0) || a.isClass(f) || a.isDOMElement(f) ? g[e] = q[e] : g[e] = v(g[e] || {}, f);
          });
          return g;
        };

        !0 === g[0] && (u = g[1], g = Array.prototype.slice.call(g, 2));
        t = g.length;

        for (m = 0; m < t; m++) {
          u = v(u, g[m]);
        }

        return u;
      };

      a.pInt = function (a, g) {
        return parseInt(a, g || 10);
      };

      a.isString = function (a) {
        return "string" === typeof a;
      };

      a.isArray = function (a) {
        a = Object.prototype.toString.call(a);
        return "[object Array]" === a || "[object Array Iterator]" === a;
      };

      a.isObject = function (m, g) {
        return !!m && "object" === typeof m && (!g || !a.isArray(m));
      };

      a.isDOMElement = function (m) {
        return a.isObject(m) && "number" === typeof m.nodeType;
      };

      a.isClass = function (m) {
        var g = m && m.constructor;
        return !(!a.isObject(m, !0) || a.isDOMElement(m) || !g || !g.name || "Object" === g.name);
      };

      a.isNumber = function (a) {
        return "number" === typeof a && !isNaN(a) && Infinity > a && -Infinity < a;
      };

      a.erase = function (a, g) {
        for (var m = a.length; m--;) {
          if (a[m] === g) {
            a.splice(m, 1);
            break;
          }
        }
      };

      a.defined = function (a) {
        return void 0 !== a && null !== a;
      };

      a.attr = function (m, g, t) {
        var u;
        a.isString(g) ? a.defined(t) ? m.setAttribute(g, t) : m && m.getAttribute && ((u = m.getAttribute(g)) || "class" !== g || (u = m.getAttribute(g + "Name"))) : a.defined(g) && a.isObject(g) && a.objectEach(g, function (a, g) {
          m.setAttribute(g, a);
        });
        return u;
      };

      a.splat = function (m) {
        return a.isArray(m) ? m : [m];
      };

      a.syncTimeout = function (a, g, t) {
        if (g) return setTimeout(a, g, t);
        a.call(0, t);
      };

      a.clearTimeout = function (m) {
        a.defined(m) && clearTimeout(m);
      };

      a.extend = function (a, g) {
        var m;
        a || (a = {});

        for (m in g) {
          a[m] = g[m];
        }

        return a;
      };

      a.pick = function () {
        var a = arguments,
            g,
            t,
            u = a.length;

        for (g = 0; g < u; g++) {
          if (t = a[g], void 0 !== t && null !== t) return t;
        }
      };

      a.css = function (m, g) {
        a.isMS && !a.svg && g && void 0 !== g.opacity && (g.filter = "alpha(opacity\x3d" + 100 * g.opacity + ")");
        a.extend(m.style, g);
      };

      a.createElement = function (m, g, t, u, v) {
        m = A.createElement(m);
        var y = a.css;
        g && a.extend(m, g);
        v && y(m, {
          padding: 0,
          border: "none",
          margin: 0
        });
        t && y(m, t);
        u && u.appendChild(m);
        return m;
      };

      a.extendClass = function (m, g) {
        var t = function t() {};

        t.prototype = new m();
        a.extend(t.prototype, g);
        return t;
      };

      a.pad = function (a, g, t) {
        return Array((g || 2) + 1 - String(a).replace("-", "").length).join(t || 0) + a;
      };

      a.relativeLength = function (a, g, t) {
        return /%$/.test(a) ? g * parseFloat(a) / 100 + (t || 0) : parseFloat(a);
      };

      a.wrap = function (a, g, t) {
        var m = a[g];

        a[g] = function () {
          var a = Array.prototype.slice.call(arguments),
              g = arguments,
              q = this;

          q.proceed = function () {
            m.apply(q, arguments.length ? arguments : g);
          };

          a.unshift(m);
          a = t.apply(this, a);
          q.proceed = null;
          return a;
        };
      };

      a.datePropsToTimestamps = function (m) {
        a.objectEach(m, function (g, t) {
          a.isObject(g) && "function" === typeof g.getTime ? m[t] = g.getTime() : (a.isObject(g) || a.isArray(g)) && a.datePropsToTimestamps(g);
        });
      };

      a.formatSingle = function (m, g, t) {
        var u = /\.([0-9])/,
            v = a.defaultOptions.lang;
        /f$/.test(m) ? (t = (t = m.match(u)) ? t[1] : -1, null !== g && (g = a.numberFormat(g, t, v.decimalPoint, -1 < m.indexOf(",") ? v.thousandsSep : ""))) : g = (t || a.time).dateFormat(m, g);
        return g;
      };

      a.format = function (m, g, t) {
        for (var u = "{", v = !1, y, q, f, e, p = [], r; m;) {
          u = m.indexOf(u);
          if (-1 === u) break;
          y = m.slice(0, u);

          if (v) {
            y = y.split(":");
            q = y.shift().split(".");
            e = q.length;
            r = g;

            for (f = 0; f < e; f++) {
              r && (r = r[q[f]]);
            }

            y.length && (r = a.formatSingle(y.join(":"), r, t));
            p.push(r);
          } else p.push(y);

          m = m.slice(u + 1);
          u = (v = !v) ? "}" : "{";
        }

        p.push(m);
        return p.join("");
      };

      a.getMagnitude = function (a) {
        return Math.pow(10, Math.floor(Math.log(a) / Math.LN10));
      };

      a.normalizeTickInterval = function (m, g, t, u, v) {
        var y,
            q = m;
        t = a.pick(t, 1);
        y = m / t;
        g || (g = v ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], !1 === u && (1 === t ? g = g.filter(function (a) {
          return 0 === a % 1;
        }) : .1 >= t && (g = [1 / t])));

        for (u = 0; u < g.length && !(q = g[u], v && q * t >= m || !v && y <= (g[u] + (g[u + 1] || g[u])) / 2); u++) {
          ;
        }

        return q = a.correctFloat(q * t, -Math.round(Math.log(.001) / Math.LN10));
      };

      a.stableSort = function (a, g) {
        var m = a.length,
            u,
            v;

        for (v = 0; v < m; v++) {
          a[v].safeI = v;
        }

        a.sort(function (a, q) {
          u = g(a, q);
          return 0 === u ? a.safeI - q.safeI : u;
        });

        for (v = 0; v < m; v++) {
          delete a[v].safeI;
        }
      };

      a.arrayMin = function (a) {
        for (var g = a.length, m = a[0]; g--;) {
          a[g] < m && (m = a[g]);
        }

        return m;
      };

      a.arrayMax = function (a) {
        for (var g = a.length, m = a[0]; g--;) {
          a[g] > m && (m = a[g]);
        }

        return m;
      };

      a.destroyObjectProperties = function (m, g) {
        a.objectEach(m, function (a, u) {
          a && a !== g && a.destroy && a.destroy();
          delete m[u];
        });
      };

      a.discardElement = function (m) {
        var g = a.garbageBin;
        g || (g = a.createElement("div"));
        m && g.appendChild(m);
        g.innerHTML = "";
      };

      a.correctFloat = function (a, g) {
        return parseFloat(a.toPrecision(g || 14));
      };

      a.setAnimation = function (m, g) {
        g.renderer.globalAnimation = a.pick(m, g.options.chart.animation, !0);
      };

      a.animObject = function (m) {
        return a.isObject(m) ? a.merge(m) : {
          duration: m ? 500 : 0
        };
      };

      a.timeUnits = {
        millisecond: 1,
        second: 1E3,
        minute: 6E4,
        hour: 36E5,
        day: 864E5,
        week: 6048E5,
        month: 24192E5,
        year: 314496E5
      };

      a.numberFormat = function (m, g, t, u) {
        m = +m || 0;
        g = +g;
        var v = a.defaultOptions.lang,
            y = (m.toString().split(".")[1] || "").split("e")[0].length,
            q,
            f,
            e = m.toString().split("e");
        -1 === g ? g = Math.min(y, 20) : a.isNumber(g) ? g && e[1] && 0 > e[1] && (q = g + +e[1], 0 <= q ? (e[0] = (+e[0]).toExponential(q).split("e")[0], g = q) : (e[0] = e[0].split(".")[0] || 0, m = 20 > g ? (e[0] * Math.pow(10, e[1])).toFixed(g) : 0, e[1] = 0)) : g = 2;
        f = (Math.abs(e[1] ? e[0] : m) + Math.pow(10, -Math.max(g, y) - 1)).toFixed(g);
        y = String(a.pInt(f));
        q = 3 < y.length ? y.length % 3 : 0;
        t = a.pick(t, v.decimalPoint);
        u = a.pick(u, v.thousandsSep);
        m = (0 > m ? "-" : "") + (q ? y.substr(0, q) + u : "");
        m += y.substr(q).replace(/(\d{3})(?=\d)/g, "$1" + u);
        g && (m += t + f.slice(-g));
        e[1] && 0 !== +m && (m += "e" + e[1]);
        return m;
      };

      Math.easeInOutSine = function (a) {
        return -.5 * (Math.cos(Math.PI * a) - 1);
      };

      a.getStyle = function (m, g, t) {
        if ("width" === g) return Math.max(0, Math.min(m.offsetWidth, m.scrollWidth, m.getBoundingClientRect && "none" === a.getStyle(m, "transform", !1) ? Math.floor(m.getBoundingClientRect().width) : Infinity) - a.getStyle(m, "padding-left") - a.getStyle(m, "padding-right"));
        if ("height" === g) return Math.max(0, Math.min(m.offsetHeight, m.scrollHeight) - a.getStyle(m, "padding-top") - a.getStyle(m, "padding-bottom"));
        G.getComputedStyle || a.error(27, !0);
        if (m = G.getComputedStyle(m, void 0)) m = m.getPropertyValue(g), a.pick(t, "opacity" !== g) && (m = a.pInt(m));
        return m;
      };

      a.inArray = function (a, g, t) {
        return g.indexOf(a, t);
      };

      a.find = Array.prototype.find ? function (a, g) {
        return a.find(g);
      } : function (a, g) {
        var m,
            u = a.length;

        for (m = 0; m < u; m++) {
          if (g(a[m], m)) return a[m];
        }
      };
      a.keys = Object.keys;

      a.offset = function (a) {
        var g = A.documentElement;
        a = a.parentElement || a.parentNode ? a.getBoundingClientRect() : {
          top: 0,
          left: 0
        };
        return {
          top: a.top + (G.pageYOffset || g.scrollTop) - (g.clientTop || 0),
          left: a.left + (G.pageXOffset || g.scrollLeft) - (g.clientLeft || 0)
        };
      };

      a.stop = function (m, g) {
        for (var t = a.timers.length; t--;) {
          a.timers[t].elem !== m || g && g !== a.timers[t].prop || (a.timers[t].stopped = !0);
        }
      };

      a.objectEach = function (a, g, t) {
        for (var m in a) {
          a.hasOwnProperty(m) && g.call(t || a[m], a[m], m, a);
        }
      };

      a.objectEach({
        map: "map",
        each: "forEach",
        grep: "filter",
        reduce: "reduce",
        some: "some"
      }, function (m, g) {
        a[g] = function (a) {
          return Array.prototype[m].apply(a, [].slice.call(arguments, 1));
        };
      });

      a.addEvent = function (m, g, t, u) {
        var v,
            y = m.addEventListener || a.addEventListenerPolyfill;
        v = "function" === typeof m && m.prototype ? m.prototype.protoEvents = m.prototype.protoEvents || {} : m.hcEvents = m.hcEvents || {};
        a.Point && m instanceof a.Point && m.series && m.series.chart && (m.series.chart.runTrackerClick = !0);
        y && y.call(m, g, t, !1);
        v[g] || (v[g] = []);
        v[g].push(t);
        u && a.isNumber(u.order) && (t.order = u.order, v[g].sort(function (a, f) {
          return a.order - f.order;
        }));
        return function () {
          a.removeEvent(m, g, t);
        };
      };

      a.removeEvent = function (m, g, t) {
        function u(f, e) {
          var p = m.removeEventListener || a.removeEventListenerPolyfill;
          p && p.call(m, f, e, !1);
        }

        function v(f) {
          var e, p;
          m.nodeName && (g ? (e = {}, e[g] = !0) : e = f, a.objectEach(e, function (a, b) {
            if (f[b]) for (p = f[b].length; p--;) {
              u(b, f[b][p]);
            }
          }));
        }

        var y, q;
        ["protoEvents", "hcEvents"].forEach(function (a) {
          var e = m[a];
          e && (g ? (y = e[g] || [], t ? (q = y.indexOf(t), -1 < q && (y.splice(q, 1), e[g] = y), u(g, t)) : (v(e), e[g] = [])) : (v(e), m[a] = {}));
        });
      };

      a.fireEvent = function (m, g, t, u) {
        var v, y, q, f, e;
        t = t || {};
        A.createEvent && (m.dispatchEvent || m.fireEvent) ? (v = A.createEvent("Events"), v.initEvent(g, !0, !0), a.extend(v, t), m.dispatchEvent ? m.dispatchEvent(v) : m.fireEvent(g, v)) : ["protoEvents", "hcEvents"].forEach(function (p) {
          if (m[p]) for (y = m[p][g] || [], q = y.length, t.target || a.extend(t, {
            preventDefault: function preventDefault() {
              t.defaultPrevented = !0;
            },
            target: m,
            type: g
          }), f = 0; f < q; f++) {
            (e = y[f]) && !1 === e.call(m, t) && t.preventDefault();
          }
        });
        u && !t.defaultPrevented && u.call(m, t);
      };

      a.animate = function (m, g, t) {
        var u,
            v = "",
            y,
            q,
            f;
        a.isObject(t) || (f = arguments, t = {
          duration: f[2],
          easing: f[3],
          complete: f[4]
        });
        a.isNumber(t.duration) || (t.duration = 400);
        t.easing = "function" === typeof t.easing ? t.easing : Math[t.easing] || Math.easeInOutSine;
        t.curAnim = a.merge(g);
        a.objectEach(g, function (e, f) {
          a.stop(m, f);
          q = new a.Fx(m, t, f);
          y = null;
          "d" === f ? (q.paths = q.initPath(m, m.d, g.d), q.toD = g.d, u = 0, y = 1) : m.attr ? u = m.attr(f) : (u = parseFloat(a.getStyle(m, f)) || 0, "opacity" !== f && (v = "px"));
          y || (y = e);
          y && y.match && y.match("px") && (y = y.replace(/px/g, ""));
          q.run(u, y, v);
        });
      };

      a.seriesType = function (m, g, t, u, v) {
        var y = a.getOptions(),
            q = a.seriesTypes;
        y.plotOptions[m] = a.merge(y.plotOptions[g], t);
        q[m] = a.extendClass(q[g] || function () {}, u);
        q[m].prototype.type = m;
        v && (q[m].prototype.pointClass = a.extendClass(a.Point, v));
        return q[m];
      };

      a.uniqueKey = function () {
        var a = Math.random().toString(36).substring(2, 9),
            g = 0;
        return function () {
          return "highcharts-" + a + "-" + g++;
        };
      }();

      a.isFunction = function (a) {
        return "function" === typeof a;
      };

      G.jQuery && (G.jQuery.fn.highcharts = function () {
        var m = [].slice.call(arguments);
        if (this[0]) return m[0] ? (new a[a.isString(m[0]) ? m.shift() : "Chart"](this[0], m[0], m[1]), this) : B[a.attr(this[0], "data-highcharts-chart")];
      });
    })(H);

    (function (a) {
      var B = a.isNumber,
          A = a.merge,
          G = a.pInt;

      a.Color = function (m) {
        if (!(this instanceof a.Color)) return new a.Color(m);
        this.init(m);
      };

      a.Color.prototype = {
        parsers: [{
          regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
          parse: function parse(a) {
            return [G(a[1]), G(a[2]), G(a[3]), parseFloat(a[4], 10)];
          }
        }, {
          regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
          parse: function parse(a) {
            return [G(a[1]), G(a[2]), G(a[3]), 1];
          }
        }],
        names: {
          white: "#ffffff",
          black: "#000000"
        },
        init: function init(m) {
          var g, t, u, v;
          if ((this.input = m = this.names[m && m.toLowerCase ? m.toLowerCase() : ""] || m) && m.stops) this.stops = m.stops.map(function (g) {
            return new a.Color(g[1]);
          });else if (m && m.charAt && "#" === m.charAt() && (g = m.length, m = parseInt(m.substr(1), 16), 7 === g ? t = [(m & 16711680) >> 16, (m & 65280) >> 8, m & 255, 1] : 4 === g && (t = [(m & 3840) >> 4 | (m & 3840) >> 8, (m & 240) >> 4 | m & 240, (m & 15) << 4 | m & 15, 1])), !t) for (u = this.parsers.length; u-- && !t;) {
            v = this.parsers[u], (g = v.regex.exec(m)) && (t = v.parse(g));
          }
          this.rgba = t || [];
        },
        get: function get(a) {
          var g = this.input,
              m = this.rgba,
              u;
          this.stops ? (u = A(g), u.stops = [].concat(u.stops), this.stops.forEach(function (g, m) {
            u.stops[m] = [u.stops[m][0], g.get(a)];
          })) : u = m && B(m[0]) ? "rgb" === a || !a && 1 === m[3] ? "rgb(" + m[0] + "," + m[1] + "," + m[2] + ")" : "a" === a ? m[3] : "rgba(" + m.join(",") + ")" : g;
          return u;
        },
        brighten: function brighten(a) {
          var g,
              m = this.rgba;
          if (this.stops) this.stops.forEach(function (g) {
            g.brighten(a);
          });else if (B(a) && 0 !== a) for (g = 0; 3 > g; g++) {
            m[g] += G(255 * a), 0 > m[g] && (m[g] = 0), 255 < m[g] && (m[g] = 255);
          }
          return this;
        },
        setOpacity: function setOpacity(a) {
          this.rgba[3] = a;
          return this;
        },
        tweenTo: function tweenTo(a, g) {
          var m = this.rgba,
              u = a.rgba;
          u.length && m && m.length ? (a = 1 !== u[3] || 1 !== m[3], g = (a ? "rgba(" : "rgb(") + Math.round(u[0] + (m[0] - u[0]) * (1 - g)) + "," + Math.round(u[1] + (m[1] - u[1]) * (1 - g)) + "," + Math.round(u[2] + (m[2] - u[2]) * (1 - g)) + (a ? "," + (u[3] + (m[3] - u[3]) * (1 - g)) : "") + ")") : g = a.input || "none";
          return g;
        }
      };

      a.color = function (m) {
        return new a.Color(m);
      };
    })(H);

    (function (a) {
      var B,
          A,
          G = a.addEvent,
          m = a.animate,
          g = a.attr,
          t = a.charts,
          u = a.color,
          v = a.css,
          y = a.createElement,
          q = a.defined,
          f = a.deg2rad,
          e = a.destroyObjectProperties,
          p = a.doc,
          r = a.extend,
          b = a.erase,
          l = a.hasTouch,
          n = a.isArray,
          d = a.isFirefox,
          w = a.isMS,
          E = a.isObject,
          C = a.isString,
          F = a.isWebKit,
          c = a.merge,
          k = a.noop,
          x = a.objectEach,
          D = a.pick,
          h = a.pInt,
          z = a.removeEvent,
          L = a.splat,
          J = a.stop,
          W = a.svg,
          I = a.SVG_NS,
          O = a.symbolSizes,
          R = a.win;

      B = a.SVGElement = function () {
        return this;
      };

      r(B.prototype, {
        opacity: 1,
        SVG_NS: I,
        textProps: "direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),
        init: function init(h, c) {
          this.element = "span" === c ? y(c) : p.createElementNS(this.SVG_NS, c);
          this.renderer = h;
          a.fireEvent(this, "afterInit");
        },
        animate: function animate(h, c, b) {
          var k = a.animObject(D(c, this.renderer.globalAnimation, !0));
          D(p.hidden, p.msHidden, p.webkitHidden, !1) && (k.duration = 0);
          0 !== k.duration ? (b && (k.complete = b), m(this, h, k)) : (this.attr(h, null, b), a.objectEach(h, function (a, h) {
            k.step && k.step.call(this, a, {
              prop: h,
              pos: 1
            });
          }, this));
          return this;
        },
        complexColor: function complexColor(h, b, k) {
          var z = this.renderer,
              K,
              l,
              d,
              e,
              r,
              f,
              w,
              p,
              I,
              D,
              J,
              L = [],
              E;
          a.fireEvent(this.renderer, "complexColor", {
            args: arguments
          }, function () {
            h.radialGradient ? l = "radialGradient" : h.linearGradient && (l = "linearGradient");
            l && (d = h[l], r = z.gradients, w = h.stops, D = k.radialReference, n(d) && (h[l] = d = {
              x1: d[0],
              y1: d[1],
              x2: d[2],
              y2: d[3],
              gradientUnits: "userSpaceOnUse"
            }), "radialGradient" === l && D && !q(d.gradientUnits) && (e = d, d = c(d, z.getRadialAttr(D, e), {
              gradientUnits: "userSpaceOnUse"
            })), x(d, function (a, h) {
              "id" !== h && L.push(h, a);
            }), x(w, function (a) {
              L.push(a);
            }), L = L.join(","), r[L] ? J = r[L].attr("id") : (d.id = J = a.uniqueKey(), r[L] = f = z.createElement(l).attr(d).add(z.defs), f.radAttr = e, f.stops = [], w.forEach(function (h) {
              0 === h[1].indexOf("rgba") ? (K = a.color(h[1]), p = K.get("rgb"), I = K.get("a")) : (p = h[1], I = 1);
              h = z.createElement("stop").attr({
                offset: h[0],
                "stop-color": p,
                "stop-opacity": I
              }).add(f);
              f.stops.push(h);
            })), E = "url(" + z.url + "#" + J + ")", k.setAttribute(b, E), k.gradient = L, h.toString = function () {
              return E;
            });
          });
        },
        applyTextOutline: function applyTextOutline(h) {
          var c = this.element,
              k,
              z,
              K,
              l,
              d;
          -1 !== h.indexOf("contrast") && (h = h.replace(/contrast/g, this.renderer.getContrast(c.style.fill)));
          h = h.split(" ");
          z = h[h.length - 1];

          if ((K = h[0]) && "none" !== K && a.svg) {
            this.fakeTS = !0;
            h = [].slice.call(c.getElementsByTagName("tspan"));
            this.ySetter = this.xSetter;
            K = K.replace(/(^[\d\.]+)(.*?)$/g, function (a, h, c) {
              return 2 * h + c;
            });

            for (d = h.length; d--;) {
              k = h[d], "highcharts-text-outline" === k.getAttribute("class") && b(h, c.removeChild(k));
            }

            l = c.firstChild;
            h.forEach(function (a, h) {
              0 === h && (a.setAttribute("x", c.getAttribute("x")), h = c.getAttribute("y"), a.setAttribute("y", h || 0), null === h && c.setAttribute("y", 0));
              a = a.cloneNode(1);
              g(a, {
                "class": "highcharts-text-outline",
                fill: z,
                stroke: z,
                "stroke-width": K,
                "stroke-linejoin": "round"
              });
              c.insertBefore(a, l);
            });
          }
        },
        symbolCustomAttribs: "x y width height r start end innerR anchorX anchorY rounded".split(" "),
        attr: function attr(h, c, b, k) {
          var z,
              K = this.element,
              d,
              l = this,
              n,
              e,
              r = this.symbolCustomAttribs;
          "string" === typeof h && void 0 !== c && (z = h, h = {}, h[z] = c);
          "string" === typeof h ? l = (this[h + "Getter"] || this._defaultGetter).call(this, h, K) : (x(h, function (c, b) {
            n = !1;
            k || J(this, b);
            this.symbolName && -1 !== a.inArray(b, r) && (d || (this.symbolAttr(h), d = !0), n = !0);
            !this.rotation || "x" !== b && "y" !== b || (this.doTransform = !0);
            n || (e = this[b + "Setter"] || this._defaultSetter, e.call(this, c, b, K), !this.styledMode && this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(b) && this.updateShadows(b, c, e));
          }, this), this.afterSetters());
          b && b.call(this);
          return l;
        },
        afterSetters: function afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        },
        updateShadows: function updateShadows(a, h, c) {
          for (var b = this.shadows, k = b.length; k--;) {
            c.call(b[k], "height" === a ? Math.max(h - (b[k].cutHeight || 0), 0) : "d" === a ? this.d : h, a, b[k]);
          }
        },
        addClass: function addClass(a, h) {
          var c = this.attr("class") || "";
          -1 === c.indexOf(a) && (h || (a = (c + (c ? " " : "") + a).replace("  ", " ")), this.attr("class", a));
          return this;
        },
        hasClass: function hasClass(a) {
          return -1 !== (this.attr("class") || "").split(" ").indexOf(a);
        },
        removeClass: function removeClass(a) {
          return this.attr("class", (this.attr("class") || "").replace(a, ""));
        },
        symbolAttr: function symbolAttr(a) {
          var h = this;
          "x y r start end width height innerR anchorX anchorY".split(" ").forEach(function (c) {
            h[c] = D(a[c], h[c]);
          });
          h.attr({
            d: h.renderer.symbols[h.symbolName](h.x, h.y, h.width, h.height, h)
          });
        },
        clip: function clip(a) {
          return this.attr("clip-path", a ? "url(" + this.renderer.url + "#" + a.id + ")" : "none");
        },
        crisp: function crisp(a, h) {
          var c;
          h = h || a.strokeWidth || 0;
          c = Math.round(h) % 2 / 2;
          a.x = Math.floor(a.x || this.x || 0) + c;
          a.y = Math.floor(a.y || this.y || 0) + c;
          a.width = Math.floor((a.width || this.width || 0) - 2 * c);
          a.height = Math.floor((a.height || this.height || 0) - 2 * c);
          q(a.strokeWidth) && (a.strokeWidth = h);
          return a;
        },
        css: function css(a) {
          var c = this.styles,
              b = {},
              k = this.element,
              z,
              d = "",
              l,
              n = !c,
              K = ["textOutline", "textOverflow", "width"];
          a && a.color && (a.fill = a.color);
          c && x(a, function (a, h) {
            a !== c[h] && (b[h] = a, n = !0);
          });
          n && (c && (a = r(c, b)), a && (null === a.width || "auto" === a.width ? delete this.textWidth : "text" === k.nodeName.toLowerCase() && a.width && (z = this.textWidth = h(a.width))), this.styles = a, z && !W && this.renderer.forExport && delete a.width, k.namespaceURI === this.SVG_NS ? (l = function l(a, h) {
            return "-" + h.toLowerCase();
          }, x(a, function (a, h) {
            -1 === K.indexOf(h) && (d += h.replace(/([A-Z])/g, l) + ":" + a + ";");
          }), d && g(k, "style", d)) : v(k, a), this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), a && a.textOutline && this.applyTextOutline(a.textOutline)));
          return this;
        },
        getStyle: function getStyle(a) {
          return R.getComputedStyle(this.element || this, "").getPropertyValue(a);
        },
        strokeWidth: function strokeWidth() {
          if (!this.renderer.styledMode) return this["stroke-width"] || 0;
          var a = this.getStyle("stroke-width"),
              c;
          a.indexOf("px") === a.length - 2 ? a = h(a) : (c = p.createElementNS(I, "rect"), g(c, {
            width: a,
            "stroke-width": 0
          }), this.element.parentNode.appendChild(c), a = c.getBBox().width, c.parentNode.removeChild(c));
          return a;
        },
        on: function on(a, h) {
          var c = this,
              b = c.element;
          l && "click" === a ? (b.ontouchstart = function (a) {
            c.touchEventFired = Date.now();
            a.preventDefault();
            h.call(b, a);
          }, b.onclick = function (a) {
            (-1 === R.navigator.userAgent.indexOf("Android") || 1100 < Date.now() - (c.touchEventFired || 0)) && h.call(b, a);
          }) : b["on" + a] = h;
          return this;
        },
        setRadialReference: function setRadialReference(a) {
          var h = this.renderer.gradients[this.element.gradient];
          this.element.radialReference = a;
          h && h.radAttr && h.animate(this.renderer.getRadialAttr(a, h.radAttr));
          return this;
        },
        translate: function translate(a, h) {
          return this.attr({
            translateX: a,
            translateY: h
          });
        },
        invert: function invert(a) {
          this.inverted = a;
          this.updateTransform();
          return this;
        },
        updateTransform: function updateTransform() {
          var a = this.translateX || 0,
              h = this.translateY || 0,
              c = this.scaleX,
              b = this.scaleY,
              k = this.inverted,
              z = this.rotation,
              d = this.matrix,
              l = this.element;
          k && (a += this.width, h += this.height);
          a = ["translate(" + a + "," + h + ")"];
          q(d) && a.push("matrix(" + d.join(",") + ")");
          k ? a.push("rotate(90) scale(-1,1)") : z && a.push("rotate(" + z + " " + D(this.rotationOriginX, l.getAttribute("x"), 0) + " " + D(this.rotationOriginY, l.getAttribute("y") || 0) + ")");
          (q(c) || q(b)) && a.push("scale(" + D(c, 1) + " " + D(b, 1) + ")");
          a.length && l.setAttribute("transform", a.join(" "));
        },
        toFront: function toFront() {
          var a = this.element;
          a.parentNode.appendChild(a);
          return this;
        },
        align: function align(a, h, c) {
          var k,
              z,
              d,
              l,
              x = {};
          z = this.renderer;
          d = z.alignedObjects;
          var n, e;

          if (a) {
            if (this.alignOptions = a, this.alignByTranslate = h, !c || C(c)) this.alignTo = k = c || "renderer", b(d, this), d.push(this), c = null;
          } else a = this.alignOptions, h = this.alignByTranslate, k = this.alignTo;

          c = D(c, z[k], z);
          k = a.align;
          z = a.verticalAlign;
          d = (c.x || 0) + (a.x || 0);
          l = (c.y || 0) + (a.y || 0);
          "right" === k ? n = 1 : "center" === k && (n = 2);
          n && (d += (c.width - (a.width || 0)) / n);
          x[h ? "translateX" : "x"] = Math.round(d);
          "bottom" === z ? e = 1 : "middle" === z && (e = 2);
          e && (l += (c.height - (a.height || 0)) / e);
          x[h ? "translateY" : "y"] = Math.round(l);
          this[this.placed ? "animate" : "attr"](x);
          this.placed = !0;
          this.alignAttr = x;
          return this;
        },
        getBBox: function getBBox(a, h) {
          var c,
              b = this.renderer,
              k,
              z = this.element,
              d = this.styles,
              l,
              x = this.textStr,
              n,
              e = b.cache,
              K = b.cacheKeys,
              w = z.namespaceURI === this.SVG_NS,
              p;
          h = D(h, this.rotation);
          k = h * f;
          l = b.styledMode ? z && B.prototype.getStyle.call(z, "font-size") : d && d.fontSize;
          q(x) && (p = x.toString(), -1 === p.indexOf("\x3c") && (p = p.replace(/[0-9]/g, "0")), p += ["", h || 0, l, this.textWidth, d && d.textOverflow].join());
          p && !a && (c = e[p]);

          if (!c) {
            if (w || b.forExport) {
              try {
                (n = this.fakeTS && function (a) {
                  [].forEach.call(z.querySelectorAll(".highcharts-text-outline"), function (h) {
                    h.style.display = a;
                  });
                }) && n("none"), c = z.getBBox ? r({}, z.getBBox()) : {
                  width: z.offsetWidth,
                  height: z.offsetHeight
                }, n && n("");
              } catch (Y) {}

              if (!c || 0 > c.width) c = {
                width: 0,
                height: 0
              };
            } else c = this.htmlGetBBox();

            b.isSVG && (a = c.width, b = c.height, w && (c.height = b = {
              "11px,17": 14,
              "13px,20": 16
            }[d && d.fontSize + "," + Math.round(b)] || b), h && (c.width = Math.abs(b * Math.sin(k)) + Math.abs(a * Math.cos(k)), c.height = Math.abs(b * Math.cos(k)) + Math.abs(a * Math.sin(k))));

            if (p && 0 < c.height) {
              for (; 250 < K.length;) {
                delete e[K.shift()];
              }

              e[p] || K.push(p);
              e[p] = c;
            }
          }

          return c;
        },
        show: function show(a) {
          return this.attr({
            visibility: a ? "inherit" : "visible"
          });
        },
        hide: function hide() {
          return this.attr({
            visibility: "hidden"
          });
        },
        fadeOut: function fadeOut(a) {
          var h = this;
          h.animate({
            opacity: 0
          }, {
            duration: a || 150,
            complete: function complete() {
              h.attr({
                y: -9999
              });
            }
          });
        },
        add: function add(a) {
          var h = this.renderer,
              c = this.element,
              b;
          a && (this.parentGroup = a);
          this.parentInverted = a && a.inverted;
          void 0 !== this.textStr && h.buildText(this);
          this.added = !0;
          if (!a || a.handleZ || this.zIndex) b = this.zIndexSetter();
          b || (a ? a.element : h.box).appendChild(c);
          if (this.onAdd) this.onAdd();
          return this;
        },
        safeRemoveChild: function safeRemoveChild(a) {
          var h = a.parentNode;
          h && h.removeChild(a);
        },
        destroy: function destroy() {
          var a = this,
              h = a.element || {},
              c = a.renderer,
              k = c.isSVG && "SPAN" === h.nodeName && a.parentGroup,
              z = h.ownerSVGElement,
              d = a.clipPath;
          h.onclick = h.onmouseout = h.onmouseover = h.onmousemove = h.point = null;
          J(a);
          d && z && ([].forEach.call(z.querySelectorAll("[clip-path],[CLIP-PATH]"), function (a) {
            var h = a.getAttribute("clip-path"),
                c = d.element.id;
            (-1 < h.indexOf("(#" + c + ")") || -1 < h.indexOf('("#' + c + '")')) && a.removeAttribute("clip-path");
          }), a.clipPath = d.destroy());

          if (a.stops) {
            for (z = 0; z < a.stops.length; z++) {
              a.stops[z] = a.stops[z].destroy();
            }

            a.stops = null;
          }

          a.safeRemoveChild(h);

          for (c.styledMode || a.destroyShadows(); k && k.div && 0 === k.div.childNodes.length;) {
            h = k.parentGroup, a.safeRemoveChild(k.div), delete k.div, k = h;
          }

          a.alignTo && b(c.alignedObjects, a);
          x(a, function (h, c) {
            delete a[c];
          });
          return null;
        },
        shadow: function shadow(a, h, c) {
          var b = [],
              k,
              z,
              d = this.element,
              l,
              x,
              n,
              e;
          if (!a) this.destroyShadows();else if (!this.shadows) {
            x = D(a.width, 3);
            n = (a.opacity || .15) / x;
            e = this.parentInverted ? "(-1,-1)" : "(" + D(a.offsetX, 1) + ", " + D(a.offsetY, 1) + ")";

            for (k = 1; k <= x; k++) {
              z = d.cloneNode(0), l = 2 * x + 1 - 2 * k, g(z, {
                stroke: a.color || "#000000",
                "stroke-opacity": n * k,
                "stroke-width": l,
                transform: "translate" + e,
                fill: "none"
              }), z.setAttribute("class", (z.getAttribute("class") || "") + " highcharts-shadow"), c && (g(z, "height", Math.max(g(z, "height") - l, 0)), z.cutHeight = l), h ? h.element.appendChild(z) : d.parentNode && d.parentNode.insertBefore(z, d), b.push(z);
            }

            this.shadows = b;
          }
          return this;
        },
        destroyShadows: function destroyShadows() {
          (this.shadows || []).forEach(function (a) {
            this.safeRemoveChild(a);
          }, this);
          this.shadows = void 0;
        },
        xGetter: function xGetter(a) {
          "circle" === this.element.nodeName && ("x" === a ? a = "cx" : "y" === a && (a = "cy"));
          return this._defaultGetter(a);
        },
        _defaultGetter: function _defaultGetter(a) {
          a = D(this[a + "Value"], this[a], this.element ? this.element.getAttribute(a) : null, 0);
          /^[\-0-9\.]+$/.test(a) && (a = parseFloat(a));
          return a;
        },
        dSetter: function dSetter(a, h, c) {
          a && a.join && (a = a.join(" "));
          /(NaN| {2}|^$)/.test(a) && (a = "M 0 0");
          this[h] !== a && (c.setAttribute(h, a), this[h] = a);
        },
        dashstyleSetter: function dashstyleSetter(a) {
          var c,
              b = this["stroke-width"];
          "inherit" === b && (b = 1);

          if (a = a && a.toLowerCase()) {
            a = a.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");

            for (c = a.length; c--;) {
              a[c] = h(a[c]) * b;
            }

            a = a.join(",").replace(/NaN/g, "none");
            this.element.setAttribute("stroke-dasharray", a);
          }
        },
        alignSetter: function alignSetter(a) {
          var h = {
            left: "start",
            center: "middle",
            right: "end"
          };
          h[a] && (this.alignValue = a, this.element.setAttribute("text-anchor", h[a]));
        },
        opacitySetter: function opacitySetter(a, h, c) {
          this[h] = a;
          c.setAttribute(h, a);
        },
        titleSetter: function titleSetter(a) {
          var h = this.element.getElementsByTagName("title")[0];
          h || (h = p.createElementNS(this.SVG_NS, "title"), this.element.appendChild(h));
          h.firstChild && h.removeChild(h.firstChild);
          h.appendChild(p.createTextNode(String(D(a), "").replace(/<[^>]*>/g, "").replace(/&lt;/g, "\x3c").replace(/&gt;/g, "\x3e")));
        },
        textSetter: function textSetter(a) {
          a !== this.textStr && (delete this.bBox, this.textStr = a, this.added && this.renderer.buildText(this));
        },
        fillSetter: function fillSetter(a, h, c) {
          "string" === typeof a ? c.setAttribute(h, a) : a && this.complexColor(a, h, c);
        },
        visibilitySetter: function visibilitySetter(a, h, c) {
          "inherit" === a ? c.removeAttribute(h) : this[h] !== a && c.setAttribute(h, a);
          this[h] = a;
        },
        zIndexSetter: function zIndexSetter(a, c) {
          var b = this.renderer,
              k = this.parentGroup,
              z = (k || b).element || b.box,
              d,
              l = this.element,
              x,
              n,
              b = z === b.box;
          d = this.added;
          var e;
          q(a) ? (l.setAttribute("data-z-index", a), a = +a, this[c] === a && (d = !1)) : q(this[c]) && l.removeAttribute("data-z-index");
          this[c] = a;

          if (d) {
            (a = this.zIndex) && k && (k.handleZ = !0);
            c = z.childNodes;

            for (e = c.length - 1; 0 <= e && !x; e--) {
              if (k = c[e], d = k.getAttribute("data-z-index"), n = !q(d), k !== l) if (0 > a && n && !b && !e) z.insertBefore(l, c[e]), x = !0;else if (h(d) <= a || n && (!q(a) || 0 <= a)) z.insertBefore(l, c[e + 1] || null), x = !0;
            }

            x || (z.insertBefore(l, c[b ? 3 : 0] || null), x = !0);
          }

          return x;
        },
        _defaultSetter: function _defaultSetter(a, h, c) {
          c.setAttribute(h, a);
        }
      });
      B.prototype.yGetter = B.prototype.xGetter;

      B.prototype.translateXSetter = B.prototype.translateYSetter = B.prototype.rotationSetter = B.prototype.verticalAlignSetter = B.prototype.rotationOriginXSetter = B.prototype.rotationOriginYSetter = B.prototype.scaleXSetter = B.prototype.scaleYSetter = B.prototype.matrixSetter = function (a, h) {
        this[h] = a;
        this.doTransform = !0;
      };

      B.prototype["stroke-widthSetter"] = B.prototype.strokeSetter = function (a, h, c) {
        this[h] = a;
        this.stroke && this["stroke-width"] ? (B.prototype.fillSetter.call(this, this.stroke, "stroke", c), c.setAttribute("stroke-width", this["stroke-width"]), this.hasStroke = !0) : "stroke-width" === h && 0 === a && this.hasStroke && (c.removeAttribute("stroke"), this.hasStroke = !1);
      };

      A = a.SVGRenderer = function () {
        this.init.apply(this, arguments);
      };

      r(A.prototype, {
        Element: B,
        SVG_NS: I,
        init: function init(a, h, c, b, k, z, l) {
          var x;
          x = this.createElement("svg").attr({
            version: "1.1",
            "class": "highcharts-root"
          });
          l || x.css(this.getStyle(b));
          b = x.element;
          a.appendChild(b);
          g(a, "dir", "ltr");
          -1 === a.innerHTML.indexOf("xmlns") && g(b, "xmlns", this.SVG_NS);
          this.isSVG = !0;
          this.box = b;
          this.boxWrapper = x;
          this.alignedObjects = [];
          this.url = (d || F) && p.getElementsByTagName("base").length ? R.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20") : "";
          this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highstock 7.0.3"));
          this.defs = this.createElement("defs").add();
          this.allowHTML = z;
          this.forExport = k;
          this.styledMode = l;
          this.gradients = {};
          this.cache = {};
          this.cacheKeys = [];
          this.imgCount = 0;
          this.setSize(h, c, !1);
          var n;
          d && a.getBoundingClientRect && (h = function h() {
            v(a, {
              left: 0,
              top: 0
            });
            n = a.getBoundingClientRect();
            v(a, {
              left: Math.ceil(n.left) - n.left + "px",
              top: Math.ceil(n.top) - n.top + "px"
            });
          }, h(), this.unSubPixelFix = G(R, "resize", h));
        },
        definition: function definition(a) {
          function h(a, b) {
            var k;
            L(a).forEach(function (a) {
              var z = c.createElement(a.tagName),
                  d = {};
              x(a, function (a, h) {
                "tagName" !== h && "children" !== h && "textContent" !== h && (d[h] = a);
              });
              z.attr(d);
              z.add(b || c.defs);
              a.textContent && z.element.appendChild(p.createTextNode(a.textContent));
              h(a.children || [], z);
              k = z;
            });
            return k;
          }

          var c = this;
          return h(a);
        },
        getStyle: function getStyle(a) {
          return this.style = r({
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
            fontSize: "12px"
          }, a);
        },
        setStyle: function setStyle(a) {
          this.boxWrapper.css(this.getStyle(a));
        },
        isHidden: function isHidden() {
          return !this.boxWrapper.getBBox().width;
        },
        destroy: function destroy() {
          var a = this.defs;
          this.box = null;
          this.boxWrapper = this.boxWrapper.destroy();
          e(this.gradients || {});
          this.gradients = null;
          a && (this.defs = a.destroy());
          this.unSubPixelFix && this.unSubPixelFix();
          return this.alignedObjects = null;
        },
        createElement: function createElement(a) {
          var h = new this.Element();
          h.init(this, a);
          return h;
        },
        draw: k,
        getRadialAttr: function getRadialAttr(a, h) {
          return {
            cx: a[0] - a[2] / 2 + h.cx * a[2],
            cy: a[1] - a[2] / 2 + h.cy * a[2],
            r: h.r * a[2]
          };
        },
        truncate: function truncate(a, h, c, b, k, z, d) {
          var l = this,
              x = a.rotation,
              n,
              e = b ? 1 : 0,
              r = (c || b).length,
              f = r,
              w = [],
              I = function I(a) {
            h.firstChild && h.removeChild(h.firstChild);
            a && h.appendChild(p.createTextNode(a));
          },
              q = function q(z, x) {
            x = x || z;
            if (void 0 === w[x]) if (h.getSubStringLength) try {
              w[x] = k + h.getSubStringLength(0, b ? x + 1 : x);
            } catch (ea) {} else l.getSpanWidth && (I(d(c || b, z)), w[x] = k + l.getSpanWidth(a, h));
            return w[x];
          },
              D,
              J;

          a.rotation = 0;
          D = q(h.textContent.length);

          if (J = k + D > z) {
            for (; e <= r;) {
              f = Math.ceil((e + r) / 2), b && (n = d(b, f)), D = q(f, n && n.length - 1), e === r ? e = r + 1 : D > z ? r = f - 1 : e = f;
            }

            0 === r ? I("") : c && r === c.length - 1 || I(n || d(c || b, f));
          }

          b && b.splice(0, f);
          a.actualWidth = D;
          a.rotation = x;
          return J;
        },
        escapes: {
          "\x26": "\x26amp;",
          "\x3c": "\x26lt;",
          "\x3e": "\x26gt;",
          "'": "\x26#39;",
          '"': "\x26quot;"
        },
        buildText: function buildText(a) {
          var c = a.element,
              b = this,
              k = b.forExport,
              z = D(a.textStr, "").toString(),
              d = -1 !== z.indexOf("\x3c"),
              l = c.childNodes,
              n,
              e = g(c, "x"),
              r = a.styles,
              f = a.textWidth,
              w = r && r.lineHeight,
              q = r && r.textOutline,
              J = r && "ellipsis" === r.textOverflow,
              L = r && "nowrap" === r.whiteSpace,
              E = r && r.fontSize,
              K,
              C,
              F = l.length,
              r = f && !a.added && this.box,
              O = function O(a) {
            var k;
            b.styledMode || (k = /(px|em)$/.test(a && a.style.fontSize) ? a.style.fontSize : E || b.style.fontSize || 12);
            return w ? h(w) : b.fontMetrics(k, a.getAttribute("style") ? a : c).h;
          },
              m = function m(a, h) {
            x(b.escapes, function (c, b) {
              h && -1 !== h.indexOf(c) || (a = a.toString().replace(new RegExp(c, "g"), b));
            });
            return a;
          },
              y = function y(a, h) {
            var c;
            c = a.indexOf("\x3c");
            a = a.substring(c, a.indexOf("\x3e") - c);
            c = a.indexOf(h + "\x3d");
            if (-1 !== c && (c = c + h.length + 1, h = a.charAt(c), '"' === h || "'" === h)) return a = a.substring(c + 1), a.substring(0, a.indexOf(h));
          };

          K = [z, J, L, w, q, E, f].join();

          if (K !== a.textCache) {
            for (a.textCache = K; F--;) {
              c.removeChild(l[F]);
            }

            d || q || J || f || -1 !== z.indexOf(" ") ? (r && r.appendChild(c), d ? (z = b.styledMode ? z.replace(/<(b|strong)>/g, '\x3cspan class\x3d"highcharts-strong"\x3e').replace(/<(i|em)>/g, '\x3cspan class\x3d"highcharts-emphasized"\x3e') : z.replace(/<(b|strong)>/g, '\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g, '\x3cspan style\x3d"font-style:italic"\x3e'), z = z.replace(/<a/g, "\x3cspan").replace(/<\/(b|strong|i|em|a)>/g, "\x3c/span\x3e").split(/<br.*?>/g)) : z = [z], z = z.filter(function (a) {
              return "" !== a;
            }), z.forEach(function (h, z) {
              var d,
                  l = 0,
                  x = 0;
              h = h.replace(/^\s+|\s+$/g, "").replace(/<span/g, "|||\x3cspan").replace(/<\/span>/g, "\x3c/span\x3e|||");
              d = h.split("|||");
              d.forEach(function (h) {
                if ("" !== h || 1 === d.length) {
                  var r = {},
                      w = p.createElementNS(b.SVG_NS, "tspan"),
                      q,
                      D;
                  (q = y(h, "class")) && g(w, "class", q);
                  if (q = y(h, "style")) q = q.replace(/(;| |^)color([ :])/, "$1fill$2"), g(w, "style", q);
                  (D = y(h, "href")) && !k && (g(w, "onclick", 'location.href\x3d"' + D + '"'), g(w, "class", "highcharts-anchor"), b.styledMode || v(w, {
                    cursor: "pointer"
                  }));
                  h = m(h.replace(/<[a-zA-Z\/](.|\n)*?>/g, "") || " ");

                  if (" " !== h) {
                    w.appendChild(p.createTextNode(h));
                    l ? r.dx = 0 : z && null !== e && (r.x = e);
                    g(w, r);
                    c.appendChild(w);
                    !l && C && (!W && k && v(w, {
                      display: "block"
                    }), g(w, "dy", O(w)));

                    if (f) {
                      var K = h.replace(/([^\^])-/g, "$1- ").split(" "),
                          r = !L && (1 < d.length || z || 1 < K.length);
                      D = 0;
                      var F = O(w);
                      if (J) n = b.truncate(a, w, h, void 0, 0, Math.max(0, f - parseInt(E || 12, 10)), function (a, h) {
                        return a.substring(0, h) + "\u2026";
                      });else if (r) for (; K.length;) {
                        K.length && !L && 0 < D && (w = p.createElementNS(I, "tspan"), g(w, {
                          dy: F,
                          x: e
                        }), q && g(w, "style", q), w.appendChild(p.createTextNode(K.join(" ").replace(/- /g, "-"))), c.appendChild(w)), b.truncate(a, w, null, K, 0 === D ? x : 0, f, function (a, h) {
                          return K.slice(0, h).join(" ").replace(/- /g, "-");
                        }), x = a.actualWidth, D++;
                      }
                    }

                    l++;
                  }
                }
              });
              C = C || c.childNodes.length;
            }), J && n && a.attr("title", m(a.textStr, ["\x26lt;", "\x26gt;"])), r && r.removeChild(c), q && a.applyTextOutline && a.applyTextOutline(q)) : c.appendChild(p.createTextNode(m(z)));
          }
        },
        getContrast: function getContrast(a) {
          a = u(a).rgba;
          a[0] *= 1;
          a[1] *= 1.2;
          a[2] *= .5;
          return 459 < a[0] + a[1] + a[2] ? "#000000" : "#FFFFFF";
        },
        button: function button(a, h, b, k, z, d, l, x, n) {
          var e = this.label(a, h, b, n, null, null, null, null, "button"),
              f = 0,
              p = this.styledMode;
          e.attr(c({
            padding: 8,
            r: 2
          }, z));

          if (!p) {
            var q, I, D, J;
            z = c({
              fill: "#f7f7f7",
              stroke: "#cccccc",
              "stroke-width": 1,
              style: {
                color: "#333333",
                cursor: "pointer",
                fontWeight: "normal"
              }
            }, z);
            q = z.style;
            delete z.style;
            d = c(z, {
              fill: "#e6e6e6"
            }, d);
            I = d.style;
            delete d.style;
            l = c(z, {
              fill: "#e6ebf5",
              style: {
                color: "#000000",
                fontWeight: "bold"
              }
            }, l);
            D = l.style;
            delete l.style;
            x = c(z, {
              style: {
                color: "#cccccc"
              }
            }, x);
            J = x.style;
            delete x.style;
          }

          G(e.element, w ? "mouseover" : "mouseenter", function () {
            3 !== f && e.setState(1);
          });
          G(e.element, w ? "mouseout" : "mouseleave", function () {
            3 !== f && e.setState(f);
          });

          e.setState = function (a) {
            1 !== a && (e.state = f = a);
            e.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][a || 0]);
            p || e.attr([z, d, l, x][a || 0]).css([q, I, D, J][a || 0]);
          };

          p || e.attr(z).css(r({
            cursor: "default"
          }, q));
          return e.on("click", function (a) {
            3 !== f && k.call(e, a);
          });
        },
        crispLine: function crispLine(a, h) {
          a[1] === a[4] && (a[1] = a[4] = Math.round(a[1]) - h % 2 / 2);
          a[2] === a[5] && (a[2] = a[5] = Math.round(a[2]) + h % 2 / 2);
          return a;
        },
        path: function path(a) {
          var h = this.styledMode ? {} : {
            fill: "none"
          };
          n(a) ? h.d = a : E(a) && r(h, a);
          return this.createElement("path").attr(h);
        },
        circle: function circle(a, h, c) {
          a = E(a) ? a : void 0 === a ? {} : {
            x: a,
            y: h,
            r: c
          };
          h = this.createElement("circle");

          h.xSetter = h.ySetter = function (a, h, c) {
            c.setAttribute("c" + h, a);
          };

          return h.attr(a);
        },
        arc: function arc(a, h, c, b, k, z) {
          E(a) ? (b = a, h = b.y, c = b.r, a = b.x) : b = {
            innerR: b,
            start: k,
            end: z
          };
          a = this.symbol("arc", a, h, c, c, b);
          a.r = c;
          return a;
        },
        rect: function rect(a, h, c, b, k, z) {
          k = E(a) ? a.r : k;
          var d = this.createElement("rect");
          a = E(a) ? a : void 0 === a ? {} : {
            x: a,
            y: h,
            width: Math.max(c, 0),
            height: Math.max(b, 0)
          };
          this.styledMode || (void 0 !== z && (a.strokeWidth = z, a = d.crisp(a)), a.fill = "none");
          k && (a.r = k);

          d.rSetter = function (a, h, c) {
            g(c, {
              rx: a,
              ry: a
            });
          };

          return d.attr(a);
        },
        setSize: function setSize(a, h, c) {
          var b = this.alignedObjects,
              k = b.length;
          this.width = a;
          this.height = h;

          for (this.boxWrapper.animate({
            width: a,
            height: h
          }, {
            step: function step() {
              this.attr({
                viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
              });
            },
            duration: D(c, !0) ? void 0 : 0
          }); k--;) {
            b[k].align();
          }
        },
        g: function g(a) {
          var h = this.createElement("g");
          return a ? h.attr({
            "class": "highcharts-" + a
          }) : h;
        },
        image: function image(a, h, c, b, k, z) {
          var d = {
            preserveAspectRatio: "none"
          },
              l,
              x = function x(a, h) {
            a.setAttributeNS ? a.setAttributeNS("http://www.w3.org/1999/xlink", "href", h) : a.setAttribute("hc-svg-href", h);
          },
              n = function n(h) {
            x(l.element, a);
            z.call(l, h);
          };

          1 < arguments.length && r(d, {
            x: h,
            y: c,
            width: b,
            height: k
          });
          l = this.createElement("image").attr(d);
          z ? (x(l.element, "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"), d = new R.Image(), G(d, "load", n), d.src = a, d.complete && n({})) : x(l.element, a);
          return l;
        },
        symbol: function symbol(a, h, c, b, k, z) {
          var d = this,
              l,
              x = /^url\((.*?)\)$/,
              n = x.test(a),
              e = !n && (this.symbols[a] ? a : "circle"),
              f = e && this.symbols[e],
              w = q(h) && f && f.call(this.symbols, Math.round(h), Math.round(c), b, k, z),
              I,
              J;
          f ? (l = this.path(w), d.styledMode || l.attr("fill", "none"), r(l, {
            symbolName: e,
            x: h,
            y: c,
            width: b,
            height: k
          }), z && r(l, z)) : n && (I = a.match(x)[1], l = this.image(I), l.imgwidth = D(O[I] && O[I].width, z && z.width), l.imgheight = D(O[I] && O[I].height, z && z.height), J = function J() {
            l.attr({
              width: l.width,
              height: l.height
            });
          }, ["width", "height"].forEach(function (a) {
            l[a + "Setter"] = function (a, h) {
              var c = {},
                  b = this["img" + h],
                  k = "width" === h ? "translateX" : "translateY";
              this[h] = a;
              q(b) && (this.element && this.element.setAttribute(h, b), this.alignByTranslate || (c[k] = ((this[h] || 0) - b) / 2, this.attr(c)));
            };
          }), q(h) && l.attr({
            x: h,
            y: c
          }), l.isImg = !0, q(l.imgwidth) && q(l.imgheight) ? J() : (l.attr({
            width: 0,
            height: 0
          }), y("img", {
            onload: function onload() {
              var a = t[d.chartIndex];
              0 === this.width && (v(this, {
                position: "absolute",
                top: "-999em"
              }), p.body.appendChild(this));
              O[I] = {
                width: this.width,
                height: this.height
              };
              l.imgwidth = this.width;
              l.imgheight = this.height;
              l.element && J();
              this.parentNode && this.parentNode.removeChild(this);
              d.imgCount--;
              if (!d.imgCount && a && a.onload) a.onload();
            },
            src: I
          }), this.imgCount++));
          return l;
        },
        symbols: {
          circle: function circle(a, h, c, b) {
            return this.arc(a + c / 2, h + b / 2, c / 2, b / 2, {
              start: 0,
              end: 2 * Math.PI,
              open: !1
            });
          },
          square: function square(a, h, c, b) {
            return ["M", a, h, "L", a + c, h, a + c, h + b, a, h + b, "Z"];
          },
          triangle: function triangle(a, h, c, b) {
            return ["M", a + c / 2, h, "L", a + c, h + b, a, h + b, "Z"];
          },
          "triangle-down": function triangleDown(a, h, c, b) {
            return ["M", a, h, "L", a + c, h, a + c / 2, h + b, "Z"];
          },
          diamond: function diamond(a, h, c, b) {
            return ["M", a + c / 2, h, "L", a + c, h + b / 2, a + c / 2, h + b, a, h + b / 2, "Z"];
          },
          arc: function arc(a, h, c, b, k) {
            var z = k.start,
                d = k.r || c,
                l = k.r || b || c,
                x = k.end - .001;
            c = k.innerR;
            b = D(k.open, .001 > Math.abs(k.end - k.start - 2 * Math.PI));
            var n = Math.cos(z),
                e = Math.sin(z),
                r = Math.cos(x),
                x = Math.sin(x);
            k = .001 > k.end - z - Math.PI ? 0 : 1;
            d = ["M", a + d * n, h + l * e, "A", d, l, 0, k, 1, a + d * r, h + l * x];
            q(c) && d.push(b ? "M" : "L", a + c * r, h + c * x, "A", c, c, 0, k, 0, a + c * n, h + c * e);
            d.push(b ? "" : "Z");
            return d;
          },
          callout: function callout(a, h, c, b, k) {
            var z = Math.min(k && k.r || 0, c, b),
                d = z + 6,
                l = k && k.anchorX;
            k = k && k.anchorY;
            var x;
            x = ["M", a + z, h, "L", a + c - z, h, "C", a + c, h, a + c, h, a + c, h + z, "L", a + c, h + b - z, "C", a + c, h + b, a + c, h + b, a + c - z, h + b, "L", a + z, h + b, "C", a, h + b, a, h + b, a, h + b - z, "L", a, h + z, "C", a, h, a, h, a + z, h];
            l && l > c ? k > h + d && k < h + b - d ? x.splice(13, 3, "L", a + c, k - 6, a + c + 6, k, a + c, k + 6, a + c, h + b - z) : x.splice(13, 3, "L", a + c, b / 2, l, k, a + c, b / 2, a + c, h + b - z) : l && 0 > l ? k > h + d && k < h + b - d ? x.splice(33, 3, "L", a, k + 6, a - 6, k, a, k - 6, a, h + z) : x.splice(33, 3, "L", a, b / 2, l, k, a, b / 2, a, h + z) : k && k > b && l > a + d && l < a + c - d ? x.splice(23, 3, "L", l + 6, h + b, l, h + b + 6, l - 6, h + b, a + z, h + b) : k && 0 > k && l > a + d && l < a + c - d && x.splice(3, 3, "L", l - 6, h, l, h - 6, l + 6, h, c - z, h);
            return x;
          }
        },
        clipRect: function clipRect(h, c, b, k) {
          var z = a.uniqueKey(),
              l = this.createElement("clipPath").attr({
            id: z
          }).add(this.defs);
          h = this.rect(h, c, b, k, 0).add(l);
          h.id = z;
          h.clipPath = l;
          h.count = 0;
          return h;
        },
        text: function text(a, h, c, b) {
          var k = {};
          if (b && (this.allowHTML || !this.forExport)) return this.html(a, h, c);
          k.x = Math.round(h || 0);
          c && (k.y = Math.round(c));
          q(a) && (k.text = a);
          a = this.createElement("text").attr(k);
          b || (a.xSetter = function (a, h, c) {
            var b = c.getElementsByTagName("tspan"),
                k,
                z = c.getAttribute(h),
                l;

            for (l = 0; l < b.length; l++) {
              k = b[l], k.getAttribute(h) === z && k.setAttribute(h, a);
            }

            c.setAttribute(h, a);
          });
          return a;
        },
        fontMetrics: function fontMetrics(a, c) {
          a = !this.styledMode && /px/.test(a) || !R.getComputedStyle ? a || c && c.style && c.style.fontSize || this.style && this.style.fontSize : c && B.prototype.getStyle.call(c, "font-size");
          a = /px/.test(a) ? h(a) : 12;
          c = 24 > a ? a + 3 : Math.round(1.2 * a);
          return {
            h: c,
            b: Math.round(.8 * c),
            f: a
          };
        },
        rotCorr: function rotCorr(a, h, c) {
          var b = a;
          h && c && (b = Math.max(b * Math.cos(h * f), 4));
          return {
            x: -a / 3 * Math.sin(h * f),
            y: b
          };
        },
        label: function label(h, b, k, l, d, x, n, e, f) {
          var w = this,
              p = w.styledMode,
              I = w.g("button" !== f && "label"),
              D = I.text = w.text("", 0, 0, n).attr({
            zIndex: 1
          }),
              J,
              L,
              E = 0,
              g = 3,
              C = 0,
              F,
              W,
              O,
              m,
              y,
              R = {},
              v,
              t,
              K = /^url\((.*?)\)$/.test(l),
              u = p || K,
              S = function S() {
            return p ? J.strokeWidth() % 2 / 2 : (v ? parseInt(v, 10) : 0) % 2 / 2;
          },
              aa,
              A,
              T;

          f && I.addClass("highcharts-" + f);

          aa = function aa() {
            var a = D.element.style,
                h = {};
            L = (void 0 === F || void 0 === W || y) && q(D.textStr) && D.getBBox();
            I.width = (F || L.width || 0) + 2 * g + C;
            I.height = (W || L.height || 0) + 2 * g;
            t = g + Math.min(w.fontMetrics(a && a.fontSize, D).b, L ? L.height : Infinity);
            u && (J || (I.box = J = w.symbols[l] || K ? w.symbol(l) : w.rect(), J.addClass(("button" === f ? "" : "highcharts-label-box") + (f ? " highcharts-" + f + "-box" : "")), J.add(I), a = S(), h.x = a, h.y = (e ? -t : 0) + a), h.width = Math.round(I.width), h.height = Math.round(I.height), J.attr(r(h, R)), R = {});
          };

          A = function A() {
            var a = C + g,
                h;
            h = e ? 0 : t;
            q(F) && L && ("center" === y || "right" === y) && (a += {
              center: .5,
              right: 1
            }[y] * (F - L.width));
            if (a !== D.x || h !== D.y) D.attr("x", a), D.hasBoxWidthChanged && (L = D.getBBox(!0), aa()), void 0 !== h && D.attr("y", h);
            D.x = a;
            D.y = h;
          };

          T = function T(a, h) {
            J ? J.attr(a, h) : R[a] = h;
          };

          I.onAdd = function () {
            D.add(I);
            I.attr({
              text: h || 0 === h ? h : "",
              x: b,
              y: k
            });
            J && q(d) && I.attr({
              anchorX: d,
              anchorY: x
            });
          };

          I.widthSetter = function (h) {
            F = a.isNumber(h) ? h : null;
          };

          I.heightSetter = function (a) {
            W = a;
          };

          I["text-alignSetter"] = function (a) {
            y = a;
          };

          I.paddingSetter = function (a) {
            q(a) && a !== g && (g = I.padding = a, A());
          };

          I.paddingLeftSetter = function (a) {
            q(a) && a !== C && (C = a, A());
          };

          I.alignSetter = function (a) {
            a = {
              left: 0,
              center: .5,
              right: 1
            }[a];
            a !== E && (E = a, L && I.attr({
              x: O
            }));
          };

          I.textSetter = function (a) {
            void 0 !== a && D.textSetter(a);
            aa();
            A();
          };

          I["stroke-widthSetter"] = function (a, h) {
            a && (u = !0);
            v = this["stroke-width"] = a;
            T(h, a);
          };

          p ? I.rSetter = function (a, h) {
            T(h, a);
          } : I.strokeSetter = I.fillSetter = I.rSetter = function (a, h) {
            "r" !== h && ("fill" === h && a && (u = !0), I[h] = a);
            T(h, a);
          };

          I.anchorXSetter = function (a, h) {
            d = I.anchorX = a;
            T(h, Math.round(a) - S() - O);
          };

          I.anchorYSetter = function (a, h) {
            x = I.anchorY = a;
            T(h, a - m);
          };

          I.xSetter = function (a) {
            I.x = a;
            E && (a -= E * ((F || L.width) + 2 * g), I["forceAnimate:x"] = !0);
            O = Math.round(a);
            I.attr("translateX", O);
          };

          I.ySetter = function (a) {
            m = I.y = Math.round(a);
            I.attr("translateY", m);
          };

          var P = I.css;
          n = {
            css: function css(a) {
              if (a) {
                var h = {};
                a = c(a);
                I.textProps.forEach(function (c) {
                  void 0 !== a[c] && (h[c] = a[c], delete a[c]);
                });
                D.css(h);
                "width" in h && aa();
                "fontSize" in h && (aa(), A());
              }

              return P.call(I, a);
            },
            getBBox: function getBBox() {
              return {
                width: L.width + 2 * g,
                height: L.height + 2 * g,
                x: L.x - g,
                y: L.y - g
              };
            },
            destroy: function destroy() {
              z(I.element, "mouseenter");
              z(I.element, "mouseleave");
              D && (D = D.destroy());
              J && (J = J.destroy());
              B.prototype.destroy.call(I);
              I = w = aa = A = T = null;
            }
          };
          p || (n.shadow = function (a) {
            a && (aa(), J && J.shadow(a));
            return I;
          });
          return r(I, n);
        }
      });
      a.Renderer = A;
    })(H);

    (function (a) {
      var B = a.attr,
          A = a.createElement,
          G = a.css,
          m = a.defined,
          g = a.extend,
          t = a.isFirefox,
          u = a.isMS,
          v = a.isWebKit,
          y = a.pick,
          q = a.pInt,
          f = a.SVGElement,
          e = a.SVGRenderer,
          p = a.win;
      g(f.prototype, {
        htmlCss: function htmlCss(a) {
          var b = "SPAN" === this.element.tagName && a && "width" in a,
              l = y(b && a.width, void 0),
              n;
          b && (delete a.width, this.textWidth = l, n = !0);
          a && "ellipsis" === a.textOverflow && (a.whiteSpace = "nowrap", a.overflow = "hidden");
          this.styles = g(this.styles, a);
          G(this.element, a);
          n && this.htmlUpdateTransform();
          return this;
        },
        htmlGetBBox: function htmlGetBBox() {
          var a = this.element;
          return {
            x: a.offsetLeft,
            y: a.offsetTop,
            width: a.offsetWidth,
            height: a.offsetHeight
          };
        },
        htmlUpdateTransform: function htmlUpdateTransform() {
          if (this.added) {
            var a = this.renderer,
                b = this.element,
                l = this.translateX || 0,
                n = this.translateY || 0,
                d = this.x || 0,
                e = this.y || 0,
                f = this.textAlign || "left",
                p = {
              left: 0,
              center: .5,
              right: 1
            }[f],
                g = this.styles,
                c = g && g.whiteSpace;
            G(b, {
              marginLeft: l,
              marginTop: n
            });
            !a.styledMode && this.shadows && this.shadows.forEach(function (a) {
              G(a, {
                marginLeft: l + 1,
                marginTop: n + 1
              });
            });
            this.inverted && [].forEach.call(b.childNodes, function (h) {
              a.invertChild(h, b);
            });

            if ("SPAN" === b.tagName) {
              var g = this.rotation,
                  k = this.textWidth && q(this.textWidth),
                  x = [g, f, b.innerHTML, this.textWidth, this.textAlign].join(),
                  D;
              (D = k !== this.oldTextWidth) && !(D = k > this.oldTextWidth) && ((D = this.textPxLength) || (G(b, {
                width: "",
                whiteSpace: c || "nowrap"
              }), D = b.offsetWidth), D = D > k);
              D && (/[ \-]/.test(b.textContent || b.innerText) || "ellipsis" === b.style.textOverflow) ? (G(b, {
                width: k + "px",
                display: "block",
                whiteSpace: c || "normal"
              }), this.oldTextWidth = k, this.hasBoxWidthChanged = !0) : this.hasBoxWidthChanged = !1;
              x !== this.cTT && (c = a.fontMetrics(b.style.fontSize, b).b, !m(g) || g === (this.oldRotation || 0) && f === this.oldAlign || this.setSpanRotation(g, p, c), this.getSpanCorrection(!m(g) && this.textPxLength || b.offsetWidth, c, p, g, f));
              G(b, {
                left: d + (this.xCorr || 0) + "px",
                top: e + (this.yCorr || 0) + "px"
              });
              this.cTT = x;
              this.oldRotation = g;
              this.oldAlign = f;
            }
          } else this.alignOnAdd = !0;
        },
        setSpanRotation: function setSpanRotation(a, b, l) {
          var n = {},
              d = this.renderer.getTransformKey();
          n[d] = n.transform = "rotate(" + a + "deg)";
          n[d + (t ? "Origin" : "-origin")] = n.transformOrigin = 100 * b + "% " + l + "px";
          G(this.element, n);
        },
        getSpanCorrection: function getSpanCorrection(a, b, l) {
          this.xCorr = -a * l;
          this.yCorr = -b;
        }
      });
      g(e.prototype, {
        getTransformKey: function getTransformKey() {
          return u && !/Edge/.test(p.navigator.userAgent) ? "-ms-transform" : v ? "-webkit-transform" : t ? "MozTransform" : p.opera ? "-o-transform" : "";
        },
        html: function html(e, b, l) {
          var n = this.createElement("span"),
              d = n.element,
              w = n.renderer,
              r = w.isSVG,
              p = function p(a, b) {
            ["opacity", "visibility"].forEach(function (c) {
              a[c + "Setter"] = function (a, h, k) {
                f.prototype[c + "Setter"].call(this, a, h, k);
                b[h] = a;
              };
            });
            a.addedSetters = !0;
          },
              q = a.charts[w.chartIndex],
              q = q && q.styledMode;

          n.textSetter = function (a) {
            a !== d.innerHTML && delete this.bBox;
            this.textStr = a;
            d.innerHTML = y(a, "");
            n.doTransform = !0;
          };

          r && p(n, n.element.style);

          n.xSetter = n.ySetter = n.alignSetter = n.rotationSetter = function (a, b) {
            "align" === b && (b = "textAlign");
            n[b] = a;
            n.doTransform = !0;
          };

          n.afterSetters = function () {
            this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
          };

          n.attr({
            text: e,
            x: Math.round(b),
            y: Math.round(l)
          }).css({
            position: "absolute"
          });
          q || n.css({
            fontFamily: this.style.fontFamily,
            fontSize: this.style.fontSize
          });
          d.style.whiteSpace = "nowrap";
          n.css = n.htmlCss;
          r && (n.add = function (a) {
            var c,
                b = w.box.parentNode,
                l = [];

            if (this.parentGroup = a) {
              if (c = a.div, !c) {
                for (; a;) {
                  l.push(a), a = a.parentGroup;
                }

                l.reverse().forEach(function (a) {
                  function h(h, c) {
                    a[c] = h;
                    "translateX" === c ? k.left = h + "px" : k.top = h + "px";
                    a.doTransform = !0;
                  }

                  var k,
                      d = B(a.element, "class");
                  d && (d = {
                    className: d
                  });
                  c = a.div = a.div || A("div", d, {
                    position: "absolute",
                    left: (a.translateX || 0) + "px",
                    top: (a.translateY || 0) + "px",
                    display: a.display,
                    opacity: a.opacity,
                    pointerEvents: a.styles && a.styles.pointerEvents
                  }, c || b);
                  k = c.style;
                  g(a, {
                    classSetter: function (a) {
                      return function (h) {
                        this.element.setAttribute("class", h);
                        a.className = h;
                      };
                    }(c),
                    on: function on() {
                      l[0].div && n.on.apply({
                        element: l[0].div
                      }, arguments);
                      return a;
                    },
                    translateXSetter: h,
                    translateYSetter: h
                  });
                  a.addedSetters || p(a, k);
                });
              }
            } else c = b;

            c.appendChild(d);
            n.added = !0;
            n.alignOnAdd && n.htmlUpdateTransform();
            return n;
          });
          return n;
        }
      });
    })(H);

    (function (a) {
      var B = a.defined,
          A = a.extend,
          G = a.merge,
          m = a.pick,
          g = a.timeUnits,
          t = a.win;

      a.Time = function (a) {
        this.update(a, !1);
      };

      a.Time.prototype = {
        defaultOptions: {},
        update: function update(a) {
          var g = m(a && a.useUTC, !0),
              y = this;
          this.options = a = G(!0, this.options || {}, a);
          this.Date = a.Date || t.Date || Date;
          this.timezoneOffset = (this.useUTC = g) && a.timezoneOffset;
          this.getTimezoneOffset = this.timezoneOffsetFunction();
          (this.variableTimezone = !(g && !a.getTimezoneOffset && !a.timezone)) || this.timezoneOffset ? (this.get = function (a, f) {
            var e = f.getTime(),
                p = e - y.getTimezoneOffset(f);
            f.setTime(p);
            a = f["getUTC" + a]();
            f.setTime(e);
            return a;
          }, this.set = function (a, f, e) {
            var p;
            if ("Milliseconds" === a || "Seconds" === a || "Minutes" === a && 0 === f.getTimezoneOffset() % 60) f["set" + a](e);else p = y.getTimezoneOffset(f), p = f.getTime() - p, f.setTime(p), f["setUTC" + a](e), a = y.getTimezoneOffset(f), p = f.getTime() + a, f.setTime(p);
          }) : g ? (this.get = function (a, f) {
            return f["getUTC" + a]();
          }, this.set = function (a, f, e) {
            return f["setUTC" + a](e);
          }) : (this.get = function (a, f) {
            return f["get" + a]();
          }, this.set = function (a, f, e) {
            return f["set" + a](e);
          });
        },
        makeTime: function makeTime(g, t, y, q, f, e) {
          var p, r, b;
          this.useUTC ? (p = this.Date.UTC.apply(0, arguments), r = this.getTimezoneOffset(p), p += r, b = this.getTimezoneOffset(p), r !== b ? p += b - r : r - 36E5 !== this.getTimezoneOffset(p - 36E5) || a.isSafari || (p -= 36E5)) : p = new this.Date(g, t, m(y, 1), m(q, 0), m(f, 0), m(e, 0)).getTime();
          return p;
        },
        timezoneOffsetFunction: function timezoneOffsetFunction() {
          var g = this,
              m = this.options,
              y = t.moment;
          if (!this.useUTC) return function (a) {
            return 6E4 * new Date(a).getTimezoneOffset();
          };

          if (m.timezone) {
            if (y) return function (a) {
              return 6E4 * -y.tz(a, m.timezone).utcOffset();
            };
            a.error(25);
          }

          return this.useUTC && m.getTimezoneOffset ? function (a) {
            return 6E4 * m.getTimezoneOffset(a);
          } : function () {
            return 6E4 * (g.timezoneOffset || 0);
          };
        },
        dateFormat: function dateFormat(g, m, y) {
          if (!a.defined(m) || isNaN(m)) return a.defaultOptions.lang.invalidDate || "";
          g = a.pick(g, "%Y-%m-%d %H:%M:%S");
          var q = this,
              f = new this.Date(m),
              e = this.get("Hours", f),
              p = this.get("Day", f),
              r = this.get("Date", f),
              b = this.get("Month", f),
              l = this.get("FullYear", f),
              n = a.defaultOptions.lang,
              d = n.weekdays,
              w = n.shortWeekdays,
              E = a.pad,
              f = a.extend({
            a: w ? w[p] : d[p].substr(0, 3),
            A: d[p],
            d: E(r),
            e: E(r, 2, " "),
            w: p,
            b: n.shortMonths[b],
            B: n.months[b],
            m: E(b + 1),
            o: b + 1,
            y: l.toString().substr(2, 2),
            Y: l,
            H: E(e),
            k: e,
            I: E(e % 12 || 12),
            l: e % 12 || 12,
            M: E(q.get("Minutes", f)),
            p: 12 > e ? "AM" : "PM",
            P: 12 > e ? "am" : "pm",
            S: E(f.getSeconds()),
            L: E(Math.floor(m % 1E3), 3)
          }, a.dateFormats);
          a.objectEach(f, function (a, b) {
            for (; -1 !== g.indexOf("%" + b);) {
              g = g.replace("%" + b, "function" === typeof a ? a.call(q, m) : a);
            }
          });
          return y ? g.substr(0, 1).toUpperCase() + g.substr(1) : g;
        },
        resolveDTLFormat: function resolveDTLFormat(g) {
          return a.isObject(g, !0) ? g : (g = a.splat(g), {
            main: g[0],
            from: g[1],
            to: g[2]
          });
        },
        getTimeTicks: function getTimeTicks(a, t, y, q) {
          var f = this,
              e = [],
              p,
              r = {},
              b;
          p = new f.Date(t);
          var l = a.unitRange,
              n = a.count || 1,
              d;
          q = m(q, 1);

          if (B(t)) {
            f.set("Milliseconds", p, l >= g.second ? 0 : n * Math.floor(f.get("Milliseconds", p) / n));
            l >= g.second && f.set("Seconds", p, l >= g.minute ? 0 : n * Math.floor(f.get("Seconds", p) / n));
            l >= g.minute && f.set("Minutes", p, l >= g.hour ? 0 : n * Math.floor(f.get("Minutes", p) / n));
            l >= g.hour && f.set("Hours", p, l >= g.day ? 0 : n * Math.floor(f.get("Hours", p) / n));
            l >= g.day && f.set("Date", p, l >= g.month ? 1 : Math.max(1, n * Math.floor(f.get("Date", p) / n)));
            l >= g.month && (f.set("Month", p, l >= g.year ? 0 : n * Math.floor(f.get("Month", p) / n)), b = f.get("FullYear", p));
            l >= g.year && f.set("FullYear", p, b - b % n);
            l === g.week && (b = f.get("Day", p), f.set("Date", p, f.get("Date", p) - b + q + (b < q ? -7 : 0)));
            b = f.get("FullYear", p);
            q = f.get("Month", p);
            var w = f.get("Date", p),
                E = f.get("Hours", p);
            t = p.getTime();
            f.variableTimezone && (d = y - t > 4 * g.month || f.getTimezoneOffset(t) !== f.getTimezoneOffset(y));
            t = p.getTime();

            for (p = 1; t < y;) {
              e.push(t), t = l === g.year ? f.makeTime(b + p * n, 0) : l === g.month ? f.makeTime(b, q + p * n) : !d || l !== g.day && l !== g.week ? d && l === g.hour && 1 < n ? f.makeTime(b, q, w, E + p * n) : t + l * n : f.makeTime(b, q, w + p * n * (l === g.day ? 1 : 7)), p++;
            }

            e.push(t);
            l <= g.hour && 1E4 > e.length && e.forEach(function (a) {
              0 === a % 18E5 && "000000000" === f.dateFormat("%H%M%S%L", a) && (r[a] = "day");
            });
          }

          e.info = A(a, {
            higherRanks: r,
            totalRange: l * n
          });
          return e;
        }
      };
    })(H);

    (function (a) {
      var B = a.color,
          A = a.merge;
      a.defaultOptions = {
        colors: "#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),
        symbols: ["circle", "diamond", "square", "triangle", "triangle-down"],
        lang: {
          loading: "Loading...",
          months: "January February March April May June July August September October November December".split(" "),
          shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
          weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
          decimalPoint: ".",
          numericSymbols: "kMGTPE".split(""),
          resetZoom: "Reset zoom",
          resetZoomTitle: "Reset zoom level 1:1",
          thousandsSep: " "
        },
        global: {},
        time: a.Time.prototype.defaultOptions,
        chart: {
          styledMode: !1,
          borderRadius: 0,
          colorCount: 10,
          defaultSeriesType: "line",
          ignoreHiddenSeries: !0,
          spacing: [10, 10, 15, 10],
          resetZoomButton: {
            theme: {
              zIndex: 6
            },
            position: {
              align: "right",
              x: -10,
              y: 10
            }
          },
          width: null,
          height: null,
          borderColor: "#335cad",
          backgroundColor: "#ffffff",
          plotBorderColor: "#cccccc"
        },
        title: {
          text: "Chart title",
          align: "center",
          margin: 15,
          widthAdjust: -44
        },
        subtitle: {
          text: "",
          align: "center",
          widthAdjust: -44
        },
        plotOptions: {},
        labels: {
          style: {
            position: "absolute",
            color: "#333333"
          }
        },
        legend: {
          enabled: !0,
          align: "center",
          alignColumns: !0,
          layout: "horizontal",
          labelFormatter: function labelFormatter() {
            return this.name;
          },
          borderColor: "#999999",
          borderRadius: 0,
          navigation: {
            activeColor: "#003399",
            inactiveColor: "#cccccc"
          },
          itemStyle: {
            color: "#333333",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "bold",
            textOverflow: "ellipsis"
          },
          itemHoverStyle: {
            color: "#000000"
          },
          itemHiddenStyle: {
            color: "#cccccc"
          },
          shadow: !1,
          itemCheckboxStyle: {
            position: "absolute",
            width: "13px",
            height: "13px"
          },
          squareSymbol: !0,
          symbolPadding: 5,
          verticalAlign: "bottom",
          x: 0,
          y: 0,
          title: {
            style: {
              fontWeight: "bold"
            }
          }
        },
        loading: {
          labelStyle: {
            fontWeight: "bold",
            position: "relative",
            top: "45%"
          },
          style: {
            position: "absolute",
            backgroundColor: "#ffffff",
            opacity: .5,
            textAlign: "center"
          }
        },
        tooltip: {
          enabled: !0,
          animation: a.svg,
          borderRadius: 3,
          dateTimeLabelFormats: {
            millisecond: "%A, %b %e, %H:%M:%S.%L",
            second: "%A, %b %e, %H:%M:%S",
            minute: "%A, %b %e, %H:%M",
            hour: "%A, %b %e, %H:%M",
            day: "%A, %b %e, %Y",
            week: "Week from %A, %b %e, %Y",
            month: "%B %Y",
            year: "%Y"
          },
          footerFormat: "",
          padding: 8,
          snap: a.isTouchDevice ? 25 : 10,
          headerFormat: '\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
          pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>{point.y}</b><br/>",
          backgroundColor: B("#f7f7f7").setOpacity(.85).get(),
          borderWidth: 1,
          shadow: !0,
          style: {
            color: "#333333",
            cursor: "default",
            fontSize: "12px",
            pointerEvents: "none",
            whiteSpace: "nowrap"
          }
        },
        credits: {
          enabled: !0,
          href: "https://www.highcharts.com?credits",
          position: {
            align: "right",
            x: -10,
            verticalAlign: "bottom",
            y: -5
          },
          style: {
            cursor: "pointer",
            color: "#999999",
            fontSize: "9px"
          },
          text: "Highcharts.com"
        }
      };

      a.setOptions = function (B) {
        a.defaultOptions = A(!0, a.defaultOptions, B);
        a.time.update(A(a.defaultOptions.global, a.defaultOptions.time), !1);
        return a.defaultOptions;
      };

      a.getOptions = function () {
        return a.defaultOptions;
      };

      a.defaultPlotOptions = a.defaultOptions.plotOptions;
      a.time = new a.Time(A(a.defaultOptions.global, a.defaultOptions.time));

      a.dateFormat = function (A, m, g) {
        return a.time.dateFormat(A, m, g);
      };
    })(H);

    (function (a) {
      var B = a.correctFloat,
          A = a.defined,
          G = a.destroyObjectProperties,
          m = a.fireEvent,
          g = a.isNumber,
          t = a.merge,
          u = a.pick,
          v = a.deg2rad;

      a.Tick = function (a, q, f, e, p) {
        this.axis = a;
        this.pos = q;
        this.type = f || "";
        this.isNewLabel = this.isNew = !0;
        this.parameters = p || {};
        this.tickmarkOffset = this.parameters.tickmarkOffset;
        this.options = this.parameters.options;
        f || e || this.addLabel();
      };

      a.Tick.prototype = {
        addLabel: function addLabel() {
          var g = this,
              q = g.axis,
              f = q.options,
              e = q.chart,
              p = q.categories,
              r = q.names,
              b = g.pos,
              l = u(g.options && g.options.labels, f.labels),
              n = q.tickPositions,
              d = b === n[0],
              w = b === n[n.length - 1],
              p = this.parameters.category || (p ? u(p[b], r[b], b) : b),
              E = g.label,
              n = n.info,
              C,
              F,
              c,
              k;
          q.isDatetimeAxis && n && (F = e.time.resolveDTLFormat(f.dateTimeLabelFormats[!f.grid && n.higherRanks[b] || n.unitName]), C = F.main);
          g.isFirst = d;
          g.isLast = w;
          g.formatCtx = {
            axis: q,
            chart: e,
            isFirst: d,
            isLast: w,
            dateTimeLabelFormat: C,
            tickPositionInfo: n,
            value: q.isLog ? B(q.lin2log(p)) : p,
            pos: b
          };
          f = q.labelFormatter.call(g.formatCtx, this.formatCtx);
          if (k = F && F.list) g.shortenLabel = function () {
            for (c = 0; c < k.length; c++) {
              if (E.attr({
                text: q.labelFormatter.call(a.extend(g.formatCtx, {
                  dateTimeLabelFormat: k[c]
                }))
              }), E.getBBox().width < q.getSlotWidth(g) - 2 * u(l.padding, 5)) return;
            }

            E.attr({
              text: ""
            });
          };
          if (A(E)) E && E.textStr !== f && (!E.textWidth || l.style && l.style.width || E.styles.width || E.css({
            width: null
          }), E.attr({
            text: f
          }));else {
            if (g.label = E = A(f) && l.enabled ? e.renderer.text(f, 0, 0, l.useHTML).add(q.labelGroup) : null) e.styledMode || E.css(t(l.style)), E.textPxLength = E.getBBox().width;
            g.rotation = 0;
          }
        },
        getLabelSize: function getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        },
        handleOverflow: function handleOverflow(a) {
          var q = this.axis,
              f = q.options.labels,
              e = a.x,
              p = q.chart.chartWidth,
              r = q.chart.spacing,
              b = u(q.labelLeft, Math.min(q.pos, r[3])),
              r = u(q.labelRight, Math.max(q.isRadial ? 0 : q.pos + q.len, p - r[1])),
              l = this.label,
              n = this.rotation,
              d = {
            left: 0,
            center: .5,
            right: 1
          }[q.labelAlign || l.attr("align")],
              w = l.getBBox().width,
              g = q.getSlotWidth(this),
              C = g,
              F = 1,
              c,
              k = {};
          if (n || "justify" !== u(f.overflow, "justify")) 0 > n && e - d * w < b ? c = Math.round(e / Math.cos(n * v) - b) : 0 < n && e + d * w > r && (c = Math.round((p - e) / Math.cos(n * v)));else if (p = e + (1 - d) * w, e - d * w < b ? C = a.x + C * (1 - d) - b : p > r && (C = r - a.x + C * d, F = -1), C = Math.min(g, C), C < g && "center" === q.labelAlign && (a.x += F * (g - C - d * (g - Math.min(w, C)))), w > C || q.autoRotation && (l.styles || {}).width) c = C;
          c && (this.shortenLabel ? this.shortenLabel() : (k.width = Math.floor(c), (f.style || {}).textOverflow || (k.textOverflow = "ellipsis"), l.css(k)));
        },
        getPosition: function getPosition(g, q, f, e) {
          var p = this.axis,
              r = p.chart,
              b = e && r.oldChartHeight || r.chartHeight;
          g = {
            x: g ? a.correctFloat(p.translate(q + f, null, null, e) + p.transB) : p.left + p.offset + (p.opposite ? (e && r.oldChartWidth || r.chartWidth) - p.right - p.left : 0),
            y: g ? b - p.bottom + p.offset - (p.opposite ? p.height : 0) : a.correctFloat(b - p.translate(q + f, null, null, e) - p.transB)
          };
          m(this, "afterGetPosition", {
            pos: g
          });
          return g;
        },
        getLabelPosition: function getLabelPosition(a, q, f, e, p, r, b, l) {
          var n = this.axis,
              d = n.transA,
              w = n.reversed,
              g = n.staggerLines,
              C = n.tickRotCorr || {
            x: 0,
            y: 0
          },
              F = p.y,
              c = e || n.reserveSpaceDefault ? 0 : -n.labelOffset * ("center" === n.labelAlign ? .5 : 1),
              k = {};
          A(F) || (F = 0 === n.side ? f.rotation ? -8 : -f.getBBox().height : 2 === n.side ? C.y + 8 : Math.cos(f.rotation * v) * (C.y - f.getBBox(!1, 0).height / 2));
          a = a + p.x + c + C.x - (r && e ? r * d * (w ? -1 : 1) : 0);
          q = q + F - (r && !e ? r * d * (w ? 1 : -1) : 0);
          g && (f = b / (l || 1) % g, n.opposite && (f = g - f - 1), q += n.labelOffset / g * f);
          k.x = a;
          k.y = Math.round(q);
          m(this, "afterGetLabelPosition", {
            pos: k,
            tickmarkOffset: r,
            index: b
          });
          return k;
        },
        getMarkPath: function getMarkPath(a, q, f, e, p, r) {
          return r.crispLine(["M", a, q, "L", a + (p ? 0 : -f), q + (p ? f : 0)], e);
        },
        renderGridLine: function renderGridLine(a, q, f) {
          var e = this.axis,
              p = e.options,
              r = this.gridLine,
              b = {},
              l = this.pos,
              n = this.type,
              d = u(this.tickmarkOffset, e.tickmarkOffset),
              w = e.chart.renderer,
              g = n ? n + "Grid" : "grid",
              C = p[g + "LineWidth"],
              F = p[g + "LineColor"],
              p = p[g + "LineDashStyle"];
          r || (e.chart.styledMode || (b.stroke = F, b["stroke-width"] = C, p && (b.dashstyle = p)), n || (b.zIndex = 1), a && (q = 0), this.gridLine = r = w.path().attr(b).addClass("highcharts-" + (n ? n + "-" : "") + "grid-line").add(e.gridGroup));
          if (r && (f = e.getPlotLinePath(l + d, r.strokeWidth() * f, a, "pass"))) r[a || this.isNew ? "attr" : "animate"]({
            d: f,
            opacity: q
          });
        },
        renderMark: function renderMark(a, q, f) {
          var e = this.axis,
              p = e.options,
              r = e.chart.renderer,
              b = this.type,
              l = b ? b + "Tick" : "tick",
              n = e.tickSize(l),
              d = this.mark,
              w = !d,
              g = a.x;
          a = a.y;
          var C = u(p[l + "Width"], !b && e.isXAxis ? 1 : 0),
              p = p[l + "Color"];
          n && (e.opposite && (n[0] = -n[0]), w && (this.mark = d = r.path().addClass("highcharts-" + (b ? b + "-" : "") + "tick").add(e.axisGroup), e.chart.styledMode || d.attr({
            stroke: p,
            "stroke-width": C
          })), d[w ? "attr" : "animate"]({
            d: this.getMarkPath(g, a, n[0], d.strokeWidth() * f, e.horiz, r),
            opacity: q
          }));
        },
        renderLabel: function renderLabel(a, q, f, e) {
          var p = this.axis,
              r = p.horiz,
              b = p.options,
              l = this.label,
              n = b.labels,
              d = n.step,
              p = u(this.tickmarkOffset, p.tickmarkOffset),
              w = !0,
              E = a.x;
          a = a.y;
          l && g(E) && (l.xy = a = this.getLabelPosition(E, a, l, r, n, p, e, d), this.isFirst && !this.isLast && !u(b.showFirstLabel, 1) || this.isLast && !this.isFirst && !u(b.showLastLabel, 1) ? w = !1 : !r || n.step || n.rotation || q || 0 === f || this.handleOverflow(a), d && e % d && (w = !1), w && g(a.y) ? (a.opacity = f, l[this.isNewLabel ? "attr" : "animate"](a), this.isNewLabel = !1) : (l.attr("y", -9999), this.isNewLabel = !0));
        },
        render: function render(g, q, f) {
          var e = this.axis,
              p = e.horiz,
              r = this.pos,
              b = u(this.tickmarkOffset, e.tickmarkOffset),
              r = this.getPosition(p, r, b, q),
              b = r.x,
              l = r.y,
              e = p && b === e.pos + e.len || !p && l === e.pos ? -1 : 1;
          f = u(f, 1);
          this.isActive = !0;
          this.renderGridLine(q, f, e);
          this.renderMark(r, f, e);
          this.renderLabel(r, q, f, g);
          this.isNew = !1;
          a.fireEvent(this, "afterRender");
        },
        destroy: function destroy() {
          G(this, this.axis);
        }
      };
    })(H);

    var da = function (a) {
      var B = a.addEvent,
          A = a.animObject,
          G = a.arrayMax,
          m = a.arrayMin,
          g = a.color,
          t = a.correctFloat,
          u = a.defaultOptions,
          v = a.defined,
          y = a.deg2rad,
          q = a.destroyObjectProperties,
          f = a.extend,
          e = a.fireEvent,
          p = a.format,
          r = a.getMagnitude,
          b = a.isArray,
          l = a.isNumber,
          n = a.isString,
          d = a.merge,
          w = a.normalizeTickInterval,
          E = a.objectEach,
          C = a.pick,
          F = a.removeEvent,
          c = a.splat,
          k = a.syncTimeout,
          x = a.Tick,
          D = function D() {
        this.init.apply(this, arguments);
      };

      a.extend(D.prototype, {
        defaultOptions: {
          dateTimeLabelFormats: {
            millisecond: {
              main: "%H:%M:%S.%L",
              range: !1
            },
            second: {
              main: "%H:%M:%S",
              range: !1
            },
            minute: {
              main: "%H:%M",
              range: !1
            },
            hour: {
              main: "%H:%M",
              range: !1
            },
            day: {
              main: "%e. %b"
            },
            week: {
              main: "%e. %b"
            },
            month: {
              main: "%b '%y"
            },
            year: {
              main: "%Y"
            }
          },
          endOnTick: !1,
          labels: {
            enabled: !0,
            indentation: 10,
            x: 0,
            style: {
              color: "#666666",
              cursor: "default",
              fontSize: "11px"
            }
          },
          maxPadding: .01,
          minorTickLength: 2,
          minorTickPosition: "outside",
          minPadding: .01,
          startOfWeek: 1,
          startOnTick: !1,
          tickLength: 10,
          tickPixelInterval: 100,
          tickmarkPlacement: "between",
          tickPosition: "outside",
          title: {
            align: "middle",
            style: {
              color: "#666666"
            }
          },
          type: "linear",
          minorGridLineColor: "#f2f2f2",
          minorGridLineWidth: 1,
          minorTickColor: "#999999",
          lineColor: "#ccd6eb",
          lineWidth: 1,
          gridLineColor: "#e6e6e6",
          tickColor: "#ccd6eb"
        },
        defaultYAxisOptions: {
          endOnTick: !0,
          maxPadding: .05,
          minPadding: .05,
          tickPixelInterval: 72,
          showLastLabel: !0,
          labels: {
            x: -8
          },
          startOnTick: !0,
          title: {
            rotation: 270,
            text: "Values"
          },
          stackLabels: {
            allowOverlap: !1,
            enabled: !1,
            formatter: function formatter() {
              return a.numberFormat(this.total, -1);
            },
            style: {
              color: "#000000",
              fontSize: "11px",
              fontWeight: "bold",
              textOutline: "1px contrast"
            }
          },
          gridLineWidth: 1,
          lineWidth: 0
        },
        defaultLeftAxisOptions: {
          labels: {
            x: -15
          },
          title: {
            rotation: 270
          }
        },
        defaultRightAxisOptions: {
          labels: {
            x: 15
          },
          title: {
            rotation: 90
          }
        },
        defaultBottomAxisOptions: {
          labels: {
            autoRotation: [-45],
            x: 0
          },
          margin: 15,
          title: {
            rotation: 0
          }
        },
        defaultTopAxisOptions: {
          labels: {
            autoRotation: [-45],
            x: 0
          },
          margin: 15,
          title: {
            rotation: 0
          }
        },
        init: function init(a, b) {
          var h = b.isX,
              k = this;
          k.chart = a;
          k.horiz = a.inverted && !k.isZAxis ? !h : h;
          k.isXAxis = h;
          k.coll = k.coll || (h ? "xAxis" : "yAxis");
          e(this, "init", {
            userOptions: b
          });
          k.opposite = b.opposite;
          k.side = b.side || (k.horiz ? k.opposite ? 0 : 2 : k.opposite ? 1 : 3);
          k.setOptions(b);
          var z = this.options,
              l = z.type;
          k.labelFormatter = z.labels.formatter || k.defaultLabelFormatter;
          k.userOptions = b;
          k.minPixelPadding = 0;
          k.reversed = z.reversed;
          k.visible = !1 !== z.visible;
          k.zoomEnabled = !1 !== z.zoomEnabled;
          k.hasNames = "category" === l || !0 === z.categories;
          k.categories = z.categories || k.hasNames;
          k.names || (k.names = [], k.names.keys = {});
          k.plotLinesAndBandsGroups = {};
          k.isLog = "logarithmic" === l;
          k.isDatetimeAxis = "datetime" === l;
          k.positiveValuesOnly = k.isLog && !k.allowNegativeLog;
          k.isLinked = v(z.linkedTo);
          k.ticks = {};
          k.labelEdge = [];
          k.minorTicks = {};
          k.plotLinesAndBands = [];
          k.alternateBands = {};
          k.len = 0;
          k.minRange = k.userMinRange = z.minRange || z.maxZoom;
          k.range = z.range;
          k.offset = z.offset || 0;
          k.stacks = {};
          k.oldStacks = {};
          k.stacksTouched = 0;
          k.max = null;
          k.min = null;
          k.crosshair = C(z.crosshair, c(a.options.tooltip.crosshairs)[h ? 0 : 1], !1);
          b = k.options.events;
          -1 === a.axes.indexOf(k) && (h ? a.axes.splice(a.xAxis.length, 0, k) : a.axes.push(k), a[k.coll].push(k));
          k.series = k.series || [];
          a.inverted && !k.isZAxis && h && void 0 === k.reversed && (k.reversed = !0);
          E(b, function (a, h) {
            B(k, h, a);
          });
          k.lin2log = z.linearToLogConverter || k.lin2log;
          k.isLog && (k.val2lin = k.log2lin, k.lin2val = k.lin2log);
          e(this, "afterInit");
        },
        setOptions: function setOptions(a) {
          this.options = d(this.defaultOptions, "yAxis" === this.coll && this.defaultYAxisOptions, [this.defaultTopAxisOptions, this.defaultRightAxisOptions, this.defaultBottomAxisOptions, this.defaultLeftAxisOptions][this.side], d(u[this.coll], a));
          e(this, "afterSetOptions", {
            userOptions: a
          });
        },
        defaultLabelFormatter: function defaultLabelFormatter() {
          var h = this.axis,
              c = this.value,
              b = h.chart.time,
              k = h.categories,
              l = this.dateTimeLabelFormat,
              d = u.lang,
              x = d.numericSymbols,
              d = d.numericSymbolMagnitude || 1E3,
              n = x && x.length,
              e,
              f = h.options.labels.format,
              h = h.isLog ? Math.abs(c) : h.tickInterval;
          if (f) e = p(f, this, b);else if (k) e = c;else if (l) e = b.dateFormat(l, c);else if (n && 1E3 <= h) for (; n-- && void 0 === e;) {
            b = Math.pow(d, n + 1), h >= b && 0 === 10 * c % b && null !== x[n] && 0 !== c && (e = a.numberFormat(c / b, -1) + x[n]);
          }
          void 0 === e && (e = 1E4 <= Math.abs(c) ? a.numberFormat(c, -1) : a.numberFormat(c, -1, void 0, ""));
          return e;
        },
        getSeriesExtremes: function getSeriesExtremes() {
          var a = this,
              c = a.chart;
          e(this, "getSeriesExtremes", null, function () {
            a.hasVisibleSeries = !1;
            a.dataMin = a.dataMax = a.threshold = null;
            a.softThreshold = !a.isXAxis;
            a.buildStacks && a.buildStacks();
            a.series.forEach(function (h) {
              if (h.visible || !c.options.chart.ignoreHiddenSeries) {
                var b = h.options,
                    k = b.threshold,
                    z;
                a.hasVisibleSeries = !0;
                a.positiveValuesOnly && 0 >= k && (k = null);
                if (a.isXAxis) b = h.xData, b.length && (h = m(b), z = G(b), l(h) || h instanceof Date || (b = b.filter(l), h = m(b), z = G(b)), b.length && (a.dataMin = Math.min(C(a.dataMin, b[0], h), h), a.dataMax = Math.max(C(a.dataMax, b[0], z), z)));else if (h.getExtremes(), z = h.dataMax, h = h.dataMin, v(h) && v(z) && (a.dataMin = Math.min(C(a.dataMin, h), h), a.dataMax = Math.max(C(a.dataMax, z), z)), v(k) && (a.threshold = k), !b.softThreshold || a.positiveValuesOnly) a.softThreshold = !1;
              }
            });
          });
          e(this, "afterGetSeriesExtremes");
        },
        translate: function translate(a, c, b, k, d, x) {
          var h = this.linkedParent || this,
              z = 1,
              n = 0,
              e = k ? h.oldTransA : h.transA;
          k = k ? h.oldMin : h.min;
          var f = h.minPixelPadding;
          d = (h.isOrdinal || h.isBroken || h.isLog && d) && h.lin2val;
          e || (e = h.transA);
          b && (z *= -1, n = h.len);
          h.reversed && (z *= -1, n -= z * (h.sector || h.len));
          c ? (a = (a * z + n - f) / e + k, d && (a = h.lin2val(a))) : (d && (a = h.val2lin(a)), a = l(k) ? z * (a - k) * e + n + z * f + (l(x) ? e * x : 0) : void 0);
          return a;
        },
        toPixels: function toPixels(a, c) {
          return this.translate(a, !1, !this.horiz, null, !0) + (c ? 0 : this.pos);
        },
        toValue: function toValue(a, c) {
          return this.translate(a - (c ? 0 : this.pos), !0, !this.horiz, null, !0);
        },
        getPlotLinePath: function getPlotLinePath(a, c, b, k, d) {
          var h = this,
              z = h.chart,
              x = h.left,
              n = h.top,
              f,
              w,
              r,
              p,
              D = b && z.oldChartHeight || z.chartHeight,
              q = b && z.oldChartWidth || z.chartWidth,
              g,
              L = h.transB,
              E,
              J = function J(a, h, c) {
            if ("pass" !== k && a < h || a > c) k ? a = Math.min(Math.max(h, a), c) : g = !0;
            return a;
          };

          E = {
            value: a,
            lineWidth: c,
            old: b,
            force: k,
            translatedValue: d
          };
          e(this, "getPlotLinePath", E, function (e) {
            d = C(d, h.translate(a, null, null, b));
            d = Math.min(Math.max(-1E5, d), 1E5);
            f = r = Math.round(d + L);
            w = p = Math.round(D - d - L);
            l(d) ? h.horiz ? (w = n, p = D - h.bottom, f = r = J(f, x, x + h.width)) : (f = x, r = q - h.right, w = p = J(w, n, n + h.height)) : (g = !0, k = !1);
            e.path = g && !k ? null : z.renderer.crispLine(["M", f, w, "L", r, p], c || 1);
          });
          return E.path;
        },
        getLinearTickPositions: function getLinearTickPositions(a, c, b) {
          var h,
              k = t(Math.floor(c / a) * a);
          b = t(Math.ceil(b / a) * a);
          var z = [],
              d;
          t(k + a) === k && (d = 20);
          if (this.single) return [c];

          for (c = k; c <= b;) {
            z.push(c);
            c = t(c + a, d);
            if (c === h) break;
            h = c;
          }

          return z;
        },
        getMinorTickInterval: function getMinorTickInterval() {
          var a = this.options;
          return !0 === a.minorTicks ? C(a.minorTickInterval, "auto") : !1 === a.minorTicks ? null : a.minorTickInterval;
        },
        getMinorTickPositions: function getMinorTickPositions() {
          var a = this,
              c = a.options,
              b = a.tickPositions,
              k = a.minorTickInterval,
              d = [],
              l = a.pointRangePadding || 0,
              x = a.min - l,
              l = a.max + l,
              n = l - x;
          if (n && n / k < a.len / 3) if (a.isLog) this.paddedTicks.forEach(function (h, c, b) {
            c && d.push.apply(d, a.getLogTickPositions(k, b[c - 1], b[c], !0));
          });else if (a.isDatetimeAxis && "auto" === this.getMinorTickInterval()) d = d.concat(a.getTimeTicks(a.normalizeTimeTickInterval(k), x, l, c.startOfWeek));else for (c = x + (b[0] - x) % k; c <= l && c !== d[0]; c += k) {
            d.push(c);
          }
          0 !== d.length && a.trimTicks(d);
          return d;
        },
        adjustForMinRange: function adjustForMinRange() {
          var a = this.options,
              c = this.min,
              b = this.max,
              k,
              d,
              l,
              x,
              n,
              e,
              f,
              w;
          this.isXAxis && void 0 === this.minRange && !this.isLog && (v(a.min) || v(a.max) ? this.minRange = null : (this.series.forEach(function (a) {
            e = a.xData;

            for (x = f = a.xIncrement ? 1 : e.length - 1; 0 < x; x--) {
              if (n = e[x] - e[x - 1], void 0 === l || n < l) l = n;
            }
          }), this.minRange = Math.min(5 * l, this.dataMax - this.dataMin)));
          b - c < this.minRange && (d = this.dataMax - this.dataMin >= this.minRange, w = this.minRange, k = (w - b + c) / 2, k = [c - k, C(a.min, c - k)], d && (k[2] = this.isLog ? this.log2lin(this.dataMin) : this.dataMin), c = G(k), b = [c + w, C(a.max, c + w)], d && (b[2] = this.isLog ? this.log2lin(this.dataMax) : this.dataMax), b = m(b), b - c < w && (k[0] = b - w, k[1] = C(a.min, b - w), c = G(k)));
          this.min = c;
          this.max = b;
        },
        getClosest: function getClosest() {
          var a;
          this.categories ? a = 1 : this.series.forEach(function (h) {
            var c = h.closestPointRange,
                b = h.visible || !h.chart.options.chart.ignoreHiddenSeries;
            !h.noSharedTooltip && v(c) && b && (a = v(a) ? Math.min(a, c) : c);
          });
          return a;
        },
        nameToX: function nameToX(a) {
          var h = b(this.categories),
              c = h ? this.categories : this.names,
              k = a.options.x,
              d;
          a.series.requireSorting = !1;
          v(k) || (k = !1 === this.options.uniqueNames ? a.series.autoIncrement() : h ? c.indexOf(a.name) : C(c.keys[a.name], -1));
          -1 === k ? h || (d = c.length) : d = k;
          void 0 !== d && (this.names[d] = a.name, this.names.keys[a.name] = d);
          return d;
        },
        updateNames: function updateNames() {
          var a = this,
              c = this.names;
          0 < c.length && (Object.keys(c.keys).forEach(function (a) {
            delete c.keys[a];
          }), c.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function (h) {
            h.xIncrement = null;
            if (!h.points || h.isDirtyData) a.max = Math.max(a.max, h.xData.length - 1), h.processData(), h.generatePoints();
            h.data.forEach(function (c, b) {
              var k;
              c && c.options && void 0 !== c.name && (k = a.nameToX(c), void 0 !== k && k !== c.x && (c.x = k, h.xData[b] = k));
            });
          }));
        },
        setAxisTranslation: function setAxisTranslation(a) {
          var h = this,
              c = h.max - h.min,
              b = h.axisPointRange || 0,
              k,
              d = 0,
              l = 0,
              x = h.linkedParent,
              f = !!h.categories,
              w = h.transA,
              r = h.isXAxis;
          if (r || f || b) k = h.getClosest(), x ? (d = x.minPointOffset, l = x.pointRangePadding) : h.series.forEach(function (a) {
            var c = f ? 1 : r ? C(a.options.pointRange, k, 0) : h.axisPointRange || 0;
            a = a.options.pointPlacement;
            b = Math.max(b, c);
            h.single || (d = Math.max(d, r && n(a) ? 0 : c / 2), l = Math.max(l, r && "on" === a ? 0 : c));
          }), x = h.ordinalSlope && k ? h.ordinalSlope / k : 1, h.minPointOffset = d *= x, h.pointRangePadding = l *= x, h.pointRange = Math.min(b, c), r && (h.closestPointRange = k);
          a && (h.oldTransA = w);
          h.translationSlope = h.transA = w = h.staticScale || h.len / (c + l || 1);
          h.transB = h.horiz ? h.left : h.bottom;
          h.minPixelPadding = w * d;
          e(this, "afterSetAxisTranslation");
        },
        minFromRange: function minFromRange() {
          return this.max - this.range;
        },
        setTickInterval: function setTickInterval(h) {
          var c = this,
              b = c.chart,
              k = c.options,
              d = c.isLog,
              x = c.isDatetimeAxis,
              n = c.isXAxis,
              f = c.isLinked,
              p = k.maxPadding,
              D = k.minPadding,
              g,
              q = k.tickInterval,
              E = k.tickPixelInterval,
              F = c.categories,
              m = l(c.threshold) ? c.threshold : null,
              y = c.softThreshold,
              u,
              A,
              B;
          x || F || f || this.getTickAmount();
          A = C(c.userMin, k.min);
          B = C(c.userMax, k.max);
          f ? (c.linkedParent = b[c.coll][k.linkedTo], g = c.linkedParent.getExtremes(), c.min = C(g.min, g.dataMin), c.max = C(g.max, g.dataMax), k.type !== c.linkedParent.options.type && a.error(11, 1, b)) : (!y && v(m) && (c.dataMin >= m ? (g = m, D = 0) : c.dataMax <= m && (u = m, p = 0)), c.min = C(A, g, c.dataMin), c.max = C(B, u, c.dataMax));
          d && (c.positiveValuesOnly && !h && 0 >= Math.min(c.min, C(c.dataMin, c.min)) && a.error(10, 1, b), c.min = t(c.log2lin(c.min), 15), c.max = t(c.log2lin(c.max), 15));
          c.range && v(c.max) && (c.userMin = c.min = A = Math.max(c.dataMin, c.minFromRange()), c.userMax = B = c.max, c.range = null);
          e(c, "foundExtremes");
          c.beforePadding && c.beforePadding();
          c.adjustForMinRange();
          !(F || c.axisPointRange || c.usePercentage || f) && v(c.min) && v(c.max) && (b = c.max - c.min) && (!v(A) && D && (c.min -= b * D), !v(B) && p && (c.max += b * p));
          l(k.softMin) && !l(c.userMin) && (c.min = Math.min(c.min, k.softMin));
          l(k.softMax) && !l(c.userMax) && (c.max = Math.max(c.max, k.softMax));
          l(k.floor) && (c.min = Math.min(Math.max(c.min, k.floor), Number.MAX_VALUE));
          l(k.ceiling) && (c.max = Math.max(Math.min(c.max, k.ceiling), C(c.userMax, -Number.MAX_VALUE)));
          y && v(c.dataMin) && (m = m || 0, !v(A) && c.min < m && c.dataMin >= m ? c.min = m : !v(B) && c.max > m && c.dataMax <= m && (c.max = m));
          c.tickInterval = c.min === c.max || void 0 === c.min || void 0 === c.max ? 1 : f && !q && E === c.linkedParent.options.tickPixelInterval ? q = c.linkedParent.tickInterval : C(q, this.tickAmount ? (c.max - c.min) / Math.max(this.tickAmount - 1, 1) : void 0, F ? 1 : (c.max - c.min) * E / Math.max(c.len, E));
          n && !h && c.series.forEach(function (a) {
            a.processData(c.min !== c.oldMin || c.max !== c.oldMax);
          });
          c.setAxisTranslation(!0);
          c.beforeSetTickPositions && c.beforeSetTickPositions();
          c.postProcessTickInterval && (c.tickInterval = c.postProcessTickInterval(c.tickInterval));
          c.pointRange && !q && (c.tickInterval = Math.max(c.pointRange, c.tickInterval));
          h = C(k.minTickInterval, c.isDatetimeAxis && c.closestPointRange);
          !q && c.tickInterval < h && (c.tickInterval = h);
          x || d || q || (c.tickInterval = w(c.tickInterval, null, r(c.tickInterval), C(k.allowDecimals, !(.5 < c.tickInterval && 5 > c.tickInterval && 1E3 < c.max && 9999 > c.max)), !!this.tickAmount));
          this.tickAmount || (c.tickInterval = c.unsquish());
          this.setTickPositions();
        },
        setTickPositions: function setTickPositions() {
          var c = this.options,
              k,
              b = c.tickPositions;
          k = this.getMinorTickInterval();
          var d = c.tickPositioner,
              l = c.startOnTick,
              x = c.endOnTick;
          this.tickmarkOffset = this.categories && "between" === c.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0;
          this.minorTickInterval = "auto" === k && this.tickInterval ? this.tickInterval / 5 : k;
          this.single = this.min === this.max && v(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || !1 !== c.allowDecimals);
          this.tickPositions = k = b && b.slice();
          !k && (!this.ordinalPositions && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200) ? (k = [this.min, this.max], a.error(19, !1, this.chart)) : k = this.isDatetimeAxis ? this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval, c.units), this.min, this.max, c.startOfWeek, this.ordinalPositions, this.closestPointRange, !0) : this.isLog ? this.getLogTickPositions(this.tickInterval, this.min, this.max) : this.getLinearTickPositions(this.tickInterval, this.min, this.max), k.length > this.len && (k = [k[0], k.pop()], k[0] === k[1] && (k.length = 1)), this.tickPositions = k, d && (d = d.apply(this, [this.min, this.max]))) && (this.tickPositions = k = d);
          this.paddedTicks = k.slice(0);
          this.trimTicks(k, l, x);
          this.isLinked || (this.single && 2 > k.length && (this.min -= .5, this.max += .5), b || d || this.adjustTickAmount());
          e(this, "afterSetTickPositions");
        },
        trimTicks: function trimTicks(a, c, k) {
          var h = a[0],
              b = a[a.length - 1],
              d = this.minPointOffset || 0;
          e(this, "trimTicks");

          if (!this.isLinked) {
            if (c && -Infinity !== h) this.min = h;else for (; this.min - d > a[0];) {
              a.shift();
            }
            if (k) this.max = b;else for (; this.max + d < a[a.length - 1];) {
              a.pop();
            }
            0 === a.length && v(h) && !this.options.tickPositions && a.push((b + h) / 2);
          }
        },
        alignToOthers: function alignToOthers() {
          var a = {},
              c,
              k = this.options;
          !1 === this.chart.options.chart.alignTicks || !1 === k.alignTicks || !1 === k.startOnTick || !1 === k.endOnTick || this.isLog || this.chart[this.coll].forEach(function (h) {
            var k = h.options,
                k = [h.horiz ? k.left : k.top, k.width, k.height, k.pane].join();
            h.series.length && (a[k] ? c = !0 : a[k] = 1);
          });
          return c;
        },
        getTickAmount: function getTickAmount() {
          var a = this.options,
              c = a.tickAmount,
              k = a.tickPixelInterval;
          !v(a.tickInterval) && this.len < k && !this.isRadial && !this.isLog && a.startOnTick && a.endOnTick && (c = 2);
          !c && this.alignToOthers() && (c = Math.ceil(this.len / k) + 1);
          4 > c && (this.finalTickAmt = c, c = 5);
          this.tickAmount = c;
        },
        adjustTickAmount: function adjustTickAmount() {
          var a = this.options,
              c = this.tickInterval,
              k = this.tickPositions,
              b = this.tickAmount,
              d = this.finalTickAmt,
              l = k && k.length,
              x = C(this.threshold, this.softThreshold ? 0 : null),
              n;

          if (this.hasData()) {
            if (l < b) {
              for (n = this.min; k.length < b;) {
                k.length % 2 || n === x ? k.push(t(k[k.length - 1] + c)) : k.unshift(t(k[0] - c));
              }

              this.transA *= (l - 1) / (b - 1);
              this.min = a.startOnTick ? k[0] : Math.min(this.min, k[0]);
              this.max = a.endOnTick ? k[k.length - 1] : Math.max(this.max, k[k.length - 1]);
            } else l > b && (this.tickInterval *= 2, this.setTickPositions());

            if (v(d)) {
              for (c = a = k.length; c--;) {
                (3 === d && 1 === c % 2 || 2 >= d && 0 < c && c < a - 1) && k.splice(c, 1);
              }

              this.finalTickAmt = void 0;
            }
          }
        },
        setScale: function setScale() {
          var a = this.series.some(function (a) {
            return a.isDirtyData || a.isDirty || a.xAxis.isDirty;
          }),
              c;
          this.oldMin = this.min;
          this.oldMax = this.max;
          this.oldAxisLength = this.len;
          this.setAxisSize();
          (c = this.len !== this.oldAxisLength) || a || this.isLinked || this.forceRedraw || this.userMin !== this.oldUserMin || this.userMax !== this.oldUserMax || this.alignToOthers() ? (this.resetStacks && this.resetStacks(), this.forceRedraw = !1, this.getSeriesExtremes(), this.setTickInterval(), this.oldUserMin = this.userMin, this.oldUserMax = this.userMax, this.isDirty || (this.isDirty = c || this.min !== this.oldMin || this.max !== this.oldMax)) : this.cleanStacks && this.cleanStacks();
          e(this, "afterSetScale");
        },
        setExtremes: function setExtremes(a, c, k, b, d) {
          var h = this,
              l = h.chart;
          k = C(k, !0);
          h.series.forEach(function (a) {
            delete a.kdTree;
          });
          d = f(d, {
            min: a,
            max: c
          });
          e(h, "setExtremes", d, function () {
            h.userMin = a;
            h.userMax = c;
            h.eventArgs = d;
            k && l.redraw(b);
          });
        },
        zoom: function zoom(a, c) {
          var h = this.dataMin,
              k = this.dataMax,
              b = this.options,
              d = Math.min(h, C(b.min, h)),
              l = Math.max(k, C(b.max, k));
          a = {
            newMin: a,
            newMax: c
          };
          e(this, "zoom", a, function (a) {
            var c = a.newMin,
                b = a.newMax;
            if (c !== this.min || b !== this.max) this.allowZoomOutside || (v(h) && (c < d && (c = d), c > l && (c = l)), v(k) && (b < d && (b = d), b > l && (b = l))), this.displayBtn = void 0 !== c || void 0 !== b, this.setExtremes(c, b, !1, void 0, {
              trigger: "zoom"
            });
            a.zoomed = !0;
          });
          return a.zoomed;
        },
        setAxisSize: function setAxisSize() {
          var c = this.chart,
              k = this.options,
              b = k.offsets || [0, 0, 0, 0],
              d = this.horiz,
              l = this.width = Math.round(a.relativeLength(C(k.width, c.plotWidth - b[3] + b[1]), c.plotWidth)),
              x = this.height = Math.round(a.relativeLength(C(k.height, c.plotHeight - b[0] + b[2]), c.plotHeight)),
              n = this.top = Math.round(a.relativeLength(C(k.top, c.plotTop + b[0]), c.plotHeight, c.plotTop)),
              k = this.left = Math.round(a.relativeLength(C(k.left, c.plotLeft + b[3]), c.plotWidth, c.plotLeft));
          this.bottom = c.chartHeight - x - n;
          this.right = c.chartWidth - l - k;
          this.len = Math.max(d ? l : x, 0);
          this.pos = d ? k : n;
        },
        getExtremes: function getExtremes() {
          var a = this.isLog;
          return {
            min: a ? t(this.lin2log(this.min)) : this.min,
            max: a ? t(this.lin2log(this.max)) : this.max,
            dataMin: this.dataMin,
            dataMax: this.dataMax,
            userMin: this.userMin,
            userMax: this.userMax
          };
        },
        getThreshold: function getThreshold(a) {
          var c = this.isLog,
              h = c ? this.lin2log(this.min) : this.min,
              c = c ? this.lin2log(this.max) : this.max;
          null === a || -Infinity === a ? a = h : Infinity === a ? a = c : h > a ? a = h : c < a && (a = c);
          return this.translate(a, 0, 1, 0, 1);
        },
        autoLabelAlign: function autoLabelAlign(a) {
          var c = (C(a, 0) - 90 * this.side + 720) % 360;
          a = {
            align: "center"
          };
          e(this, "autoLabelAlign", a, function (a) {
            15 < c && 165 > c ? a.align = "right" : 195 < c && 345 > c && (a.align = "left");
          });
          return a.align;
        },
        tickSize: function tickSize(a) {
          var c = this.options,
              h = c[a + "Length"],
              k = C(c[a + "Width"], "tick" === a && this.isXAxis ? 1 : 0),
              b;
          k && h && ("inside" === c[a + "Position"] && (h = -h), b = [h, k]);
          a = {
            tickSize: b
          };
          e(this, "afterTickSize", a);
          return a.tickSize;
        },
        labelMetrics: function labelMetrics() {
          var a = this.tickPositions && this.tickPositions[0] || 0;
          return this.chart.renderer.fontMetrics(this.options.labels.style && this.options.labels.style.fontSize, this.ticks[a] && this.ticks[a].label);
        },
        unsquish: function unsquish() {
          var a = this.options.labels,
              c = this.horiz,
              k = this.tickInterval,
              b = k,
              d = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / k),
              l,
              x = a.rotation,
              n = this.labelMetrics(),
              e,
              f = Number.MAX_VALUE,
              w,
              r = this.max - this.min,
              p = function p(a) {
            var c = a / (d || 1),
                c = 1 < c ? Math.ceil(c) : 1;
            c * k > r && Infinity !== a && Infinity !== d && (c = Math.ceil(r / k));
            return t(c * k);
          };

          c ? (w = !a.staggerLines && !a.step && (v(x) ? [x] : d < C(a.autoRotationLimit, 80) && a.autoRotation)) && w.forEach(function (a) {
            var c;
            if (a === x || a && -90 <= a && 90 >= a) e = p(Math.abs(n.h / Math.sin(y * a))), c = e + Math.abs(a / 360), c < f && (f = c, l = a, b = e);
          }) : a.step || (b = p(n.h));
          this.autoRotation = w;
          this.labelRotation = C(l, x);
          return b;
        },
        getSlotWidth: function getSlotWidth(a) {
          var c = this.chart,
              h = this.horiz,
              k = this.options.labels,
              b = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1),
              d = c.margin[3];
          return a && a.slotWidth || h && 2 > (k.step || 0) && !k.rotation && (this.staggerLines || 1) * this.len / b || !h && (k.style && parseInt(k.style.width, 10) || d && d - c.spacing[3] || .33 * c.chartWidth);
        },
        renderUnsquish: function renderUnsquish() {
          var a = this.chart,
              c = a.renderer,
              k = this.tickPositions,
              b = this.ticks,
              d = this.options.labels,
              l = d && d.style || {},
              x = this.horiz,
              e = this.getSlotWidth(),
              f = Math.max(1, Math.round(e - 2 * (d.padding || 5))),
              w = {},
              r = this.labelMetrics(),
              p = d.style && d.style.textOverflow,
              D,
              g,
              q = 0,
              E;
          n(d.rotation) || (w.rotation = d.rotation || 0);
          k.forEach(function (a) {
            (a = b[a]) && a.label && a.label.textPxLength > q && (q = a.label.textPxLength);
          });
          this.maxLabelLength = q;
          if (this.autoRotation) q > f && q > r.h ? w.rotation = this.labelRotation : this.labelRotation = 0;else if (e && (D = f, !p)) for (g = "clip", f = k.length; !x && f--;) {
            if (E = k[f], E = b[E].label) E.styles && "ellipsis" === E.styles.textOverflow ? E.css({
              textOverflow: "clip"
            }) : E.textPxLength > e && E.css({
              width: e + "px"
            }), E.getBBox().height > this.len / k.length - (r.h - r.f) && (E.specificTextOverflow = "ellipsis");
          }
          w.rotation && (D = q > .5 * a.chartHeight ? .33 * a.chartHeight : q, p || (g = "ellipsis"));
          if (this.labelAlign = d.align || this.autoLabelAlign(this.labelRotation)) w.align = this.labelAlign;
          k.forEach(function (a) {
            var c = (a = b[a]) && a.label,
                h = l.width,
                k = {};
            c && (c.attr(w), a.shortenLabel ? a.shortenLabel() : D && !h && "nowrap" !== l.whiteSpace && (D < c.textPxLength || "SPAN" === c.element.tagName) ? (k.width = D, p || (k.textOverflow = c.specificTextOverflow || g), c.css(k)) : c.styles && c.styles.width && !k.width && !h && c.css({
              width: null
            }), delete c.specificTextOverflow, a.rotation = w.rotation);
          }, this);
          this.tickRotCorr = c.rotCorr(r.b, this.labelRotation || 0, 0 !== this.side);
        },
        hasData: function hasData() {
          return this.hasVisibleSeries || v(this.min) && v(this.max) && this.tickPositions && 0 < this.tickPositions.length;
        },
        addTitle: function addTitle(a) {
          var c = this.chart.renderer,
              h = this.horiz,
              k = this.opposite,
              b = this.options.title,
              l,
              x = this.chart.styledMode;
          this.axisTitle || ((l = b.textAlign) || (l = (h ? {
            low: "left",
            middle: "center",
            high: "right"
          } : {
            low: k ? "right" : "left",
            middle: "center",
            high: k ? "left" : "right"
          })[b.align]), this.axisTitle = c.text(b.text, 0, 0, b.useHTML).attr({
            zIndex: 7,
            rotation: b.rotation || 0,
            align: l
          }).addClass("highcharts-axis-title"), x || this.axisTitle.css(d(b.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0);
          x || b.style.width || this.isRadial || this.axisTitle.css({
            width: this.len
          });
          this.axisTitle[a ? "show" : "hide"](!0);
        },
        generateTick: function generateTick(a) {
          var c = this.ticks;
          c[a] ? c[a].addLabel() : c[a] = new x(this, a);
        },
        getOffset: function getOffset() {
          var a = this,
              c = a.chart,
              k = c.renderer,
              b = a.options,
              d = a.tickPositions,
              l = a.ticks,
              x = a.horiz,
              n = a.side,
              f = c.inverted && !a.isZAxis ? [1, 0, 3, 2][n] : n,
              w,
              r,
              p = 0,
              D,
              q = 0,
              g = b.title,
              F = b.labels,
              m = 0,
              t = c.axisOffset,
              c = c.clipOffset,
              y = [-1, 1, 1, -1][n],
              u = b.className,
              A = a.axisParent;
          w = a.hasData();
          a.showAxis = r = w || C(b.showEmpty, !0);
          a.staggerLines = a.horiz && F.staggerLines;
          a.axisGroup || (a.gridGroup = k.g("grid").attr({
            zIndex: b.gridZIndex || 1
          }).addClass("highcharts-" + this.coll.toLowerCase() + "-grid " + (u || "")).add(A), a.axisGroup = k.g("axis").attr({
            zIndex: b.zIndex || 2
          }).addClass("highcharts-" + this.coll.toLowerCase() + " " + (u || "")).add(A), a.labelGroup = k.g("axis-labels").attr({
            zIndex: F.zIndex || 7
          }).addClass("highcharts-" + a.coll.toLowerCase() + "-labels " + (u || "")).add(A));
          w || a.isLinked ? (d.forEach(function (c, k) {
            a.generateTick(c, k);
          }), a.renderUnsquish(), a.reserveSpaceDefault = 0 === n || 2 === n || {
            1: "left",
            3: "right"
          }[n] === a.labelAlign, C(F.reserveSpace, "center" === a.labelAlign ? !0 : null, a.reserveSpaceDefault) && d.forEach(function (a) {
            m = Math.max(l[a].getLabelSize(), m);
          }), a.staggerLines && (m *= a.staggerLines), a.labelOffset = m * (a.opposite ? -1 : 1)) : E(l, function (a, c) {
            a.destroy();
            delete l[c];
          });
          g && g.text && !1 !== g.enabled && (a.addTitle(r), r && !1 !== g.reserveSpace && (a.titleOffset = p = a.axisTitle.getBBox()[x ? "height" : "width"], D = g.offset, q = v(D) ? 0 : C(g.margin, x ? 5 : 10)));
          a.renderLine();
          a.offset = y * C(b.offset, t[n] ? t[n] + (b.margin || 0) : 0);
          a.tickRotCorr = a.tickRotCorr || {
            x: 0,
            y: 0
          };
          k = 0 === n ? -a.labelMetrics().h : 2 === n ? a.tickRotCorr.y : 0;
          q = Math.abs(m) + q;
          m && (q = q - k + y * (x ? C(F.y, a.tickRotCorr.y + 8 * y) : F.x));
          a.axisTitleMargin = C(D, q);
          a.getMaxLabelDimensions && (a.maxLabelDimensions = a.getMaxLabelDimensions(l, d));
          x = this.tickSize("tick");
          t[n] = Math.max(t[n], a.axisTitleMargin + p + y * a.offset, q, w && d.length && x ? x[0] + y * a.offset : 0);
          b = b.offset ? 0 : 2 * Math.floor(a.axisLine.strokeWidth() / 2);
          c[f] = Math.max(c[f], b);
          e(this, "afterGetOffset");
        },
        getLinePath: function getLinePath(a) {
          var c = this.chart,
              k = this.opposite,
              h = this.offset,
              b = this.horiz,
              d = this.left + (k ? this.width : 0) + h,
              h = c.chartHeight - this.bottom - (k ? this.height : 0) + h;
          k && (a *= -1);
          return c.renderer.crispLine(["M", b ? this.left : d, b ? h : this.top, "L", b ? c.chartWidth - this.right : d, b ? h : c.chartHeight - this.bottom], a);
        },
        renderLine: function renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
            stroke: this.options.lineColor,
            "stroke-width": this.options.lineWidth,
            zIndex: 7
          }));
        },
        getTitlePosition: function getTitlePosition() {
          var a = this.horiz,
              c = this.left,
              k = this.top,
              b = this.len,
              d = this.options.title,
              l = a ? c : k,
              x = this.opposite,
              n = this.offset,
              f = d.x || 0,
              w = d.y || 0,
              r = this.axisTitle,
              p = this.chart.renderer.fontMetrics(d.style && d.style.fontSize, r),
              r = Math.max(r.getBBox(null, 0).height - p.h - 1, 0),
              b = {
            low: l + (a ? 0 : b),
            middle: l + b / 2,
            high: l + (a ? b : 0)
          }[d.align],
              c = (a ? k + this.height : c) + (a ? 1 : -1) * (x ? -1 : 1) * this.axisTitleMargin + [-r, r, p.f, -r][this.side],
              a = {
            x: a ? b + f : c + (x ? this.width : 0) + n + f,
            y: a ? c + w - (x ? this.height : 0) + n : b + w
          };
          e(this, "afterGetTitlePosition", {
            titlePosition: a
          });
          return a;
        },
        renderMinorTick: function renderMinorTick(a) {
          var c = this.chart.hasRendered && l(this.oldMin),
              k = this.minorTicks;
          k[a] || (k[a] = new x(this, a, "minor"));
          c && k[a].isNew && k[a].render(null, !0);
          k[a].render(null, !1, 1);
        },
        renderTick: function renderTick(a, c) {
          var k = this.isLinked,
              b = this.ticks,
              h = this.chart.hasRendered && l(this.oldMin);
          if (!k || a >= this.min && a <= this.max) b[a] || (b[a] = new x(this, a)), h && b[a].isNew && b[a].render(c, !0, -1), b[a].render(c);
        },
        render: function render() {
          var c = this,
              b = c.chart,
              d = c.options,
              n = c.isLog,
              f = c.isLinked,
              w = c.tickPositions,
              r = c.axisTitle,
              p = c.ticks,
              D = c.minorTicks,
              q = c.alternateBands,
              g = d.stackLabels,
              C = d.alternateGridColor,
              F = c.tickmarkOffset,
              m = c.axisLine,
              t = c.showAxis,
              y = A(b.renderer.globalAnimation),
              v,
              u;
          c.labelEdge.length = 0;
          c.overlap = !1;
          [p, D, q].forEach(function (a) {
            E(a, function (a) {
              a.isActive = !1;
            });
          });
          if (c.hasData() || f) c.minorTickInterval && !c.categories && c.getMinorTickPositions().forEach(function (a) {
            c.renderMinorTick(a);
          }), w.length && (w.forEach(function (a, k) {
            c.renderTick(a, k);
          }), F && (0 === c.min || c.single) && (p[-1] || (p[-1] = new x(c, -1, null, !0)), p[-1].render(-1))), C && w.forEach(function (k, h) {
            u = void 0 !== w[h + 1] ? w[h + 1] + F : c.max - F;
            0 === h % 2 && k < c.max && u <= c.max + (b.polar ? -F : F) && (q[k] || (q[k] = new a.PlotLineOrBand(c)), v = k + F, q[k].options = {
              from: n ? c.lin2log(v) : v,
              to: n ? c.lin2log(u) : u,
              color: C
            }, q[k].render(), q[k].isActive = !0);
          }), c._addedPlotLB || ((d.plotLines || []).concat(d.plotBands || []).forEach(function (a) {
            c.addPlotBandOrLine(a);
          }), c._addedPlotLB = !0);
          [p, D, q].forEach(function (a) {
            var c,
                h = [],
                d = y.duration;
            E(a, function (a, c) {
              a.isActive || (a.render(c, !1, 0), a.isActive = !1, h.push(c));
            });
            k(function () {
              for (c = h.length; c--;) {
                a[h[c]] && !a[h[c]].isActive && (a[h[c]].destroy(), delete a[h[c]]);
              }
            }, a !== q && b.hasRendered && d ? d : 0);
          });
          m && (m[m.isPlaced ? "animate" : "attr"]({
            d: this.getLinePath(m.strokeWidth())
          }), m.isPlaced = !0, m[t ? "show" : "hide"](!0));
          r && t && (d = c.getTitlePosition(), l(d.y) ? (r[r.isNew ? "attr" : "animate"](d), r.isNew = !1) : (r.attr("y", -9999), r.isNew = !0));
          g && g.enabled && c.renderStackTotals();
          c.isDirty = !1;
          e(this, "afterRender");
        },
        redraw: function redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function (a) {
            a.render();
          }));
          this.series.forEach(function (a) {
            a.isDirty = !0;
          });
        },
        keepProps: "extKey hcEvents names series userMax userMin".split(" "),
        destroy: function destroy(a) {
          var c = this,
              k = c.stacks,
              b = c.plotLinesAndBands,
              h;
          e(this, "destroy", {
            keepEvents: a
          });
          a || F(c);
          E(k, function (a, c) {
            q(a);
            k[c] = null;
          });
          [c.ticks, c.minorTicks, c.alternateBands].forEach(function (a) {
            q(a);
          });
          if (b) for (a = b.length; a--;) {
            b[a].destroy();
          }
          "stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function (a) {
            c[a] && (c[a] = c[a].destroy());
          });

          for (h in c.plotLinesAndBandsGroups) {
            c.plotLinesAndBandsGroups[h] = c.plotLinesAndBandsGroups[h].destroy();
          }

          E(c, function (a, k) {
            -1 === c.keepProps.indexOf(k) && delete c[k];
          });
        },
        drawCrosshair: function drawCrosshair(a, c) {
          var k,
              b = this.crosshair,
              h = C(b.snap, !0),
              d,
              l = this.cross;
          e(this, "drawCrosshair", {
            e: a,
            point: c
          });
          a || (a = this.cross && this.cross.e);

          if (this.crosshair && !1 !== (v(c) || !h)) {
            h ? v(c) && (d = C(c.crosshairPos, this.isXAxis ? c.plotX : this.len - c.plotY)) : d = a && (this.horiz ? a.chartX - this.pos : this.len - a.chartY + this.pos);
            v(d) && (k = this.getPlotLinePath(c && (this.isXAxis ? c.x : C(c.stackY, c.y)), null, null, null, d) || null);

            if (!v(k)) {
              this.hideCrosshair();
              return;
            }

            h = this.categories && !this.isRadial;
            l || (this.cross = l = this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (h ? "category " : "thin ") + b.className).attr({
              zIndex: C(b.zIndex, 2)
            }).add(), this.chart.styledMode || (l.attr({
              stroke: b.color || (h ? g("#ccd6eb").setOpacity(.25).get() : "#cccccc"),
              "stroke-width": C(b.width, 1)
            }).css({
              "pointer-events": "none"
            }), b.dashStyle && l.attr({
              dashstyle: b.dashStyle
            })));
            l.show().attr({
              d: k
            });
            h && !b.width && l.attr({
              "stroke-width": this.transA
            });
            this.cross.e = a;
          } else this.hideCrosshair();

          e(this, "afterDrawCrosshair", {
            e: a,
            point: c
          });
        },
        hideCrosshair: function hideCrosshair() {
          this.cross && this.cross.hide();
          e(this, "afterHideCrosshair");
        }
      });
      return a.Axis = D;
    }(H);

    (function (a) {
      var B = a.Axis,
          A = a.getMagnitude,
          G = a.normalizeTickInterval,
          m = a.timeUnits;

      B.prototype.getTimeTicks = function () {
        return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
      };

      B.prototype.normalizeTimeTickInterval = function (a, t) {
        var g = t || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]];
        t = g[g.length - 1];
        var v = m[t[0]],
            y = t[1],
            q;

        for (q = 0; q < g.length && !(t = g[q], v = m[t[0]], y = t[1], g[q + 1] && a <= (v * y[y.length - 1] + m[g[q + 1][0]]) / 2); q++) {
          ;
        }

        v === m.year && a < 5 * v && (y = [1, 2, 5]);
        a = G(a / v, y, "year" === t[0] ? Math.max(A(a / v), 1) : 1);
        return {
          unitRange: v,
          count: a,
          unitName: t[0]
        };
      };
    })(H);

    (function (a) {
      var B = a.Axis,
          A = a.getMagnitude,
          G = a.normalizeTickInterval,
          m = a.pick;

      B.prototype.getLogTickPositions = function (a, t, u, v) {
        var g = this.options,
            q = this.len,
            f = [];
        v || (this._minorAutoInterval = null);
        if (.5 <= a) a = Math.round(a), f = this.getLinearTickPositions(a, t, u);else if (.08 <= a) for (var q = Math.floor(t), e, p, r, b, l, g = .3 < a ? [1, 2, 4] : .15 < a ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9]; q < u + 1 && !l; q++) {
          for (p = g.length, e = 0; e < p && !l; e++) {
            r = this.log2lin(this.lin2log(q) * g[e]), r > t && (!v || b <= u) && void 0 !== b && f.push(b), b > u && (l = !0), b = r;
          }
        } else t = this.lin2log(t), u = this.lin2log(u), a = v ? this.getMinorTickInterval() : g.tickInterval, a = m("auto" === a ? null : a, this._minorAutoInterval, g.tickPixelInterval / (v ? 5 : 1) * (u - t) / ((v ? q / this.tickPositions.length : q) || 1)), a = G(a, null, A(a)), f = this.getLinearTickPositions(a, t, u).map(this.log2lin), v || (this._minorAutoInterval = a / 5);
        v || (this.tickInterval = a);
        return f;
      };

      B.prototype.log2lin = function (a) {
        return Math.log(a) / Math.LN10;
      };

      B.prototype.lin2log = function (a) {
        return Math.pow(10, a);
      };
    })(H);

    (function (a, B) {
      var A = a.arrayMax,
          G = a.arrayMin,
          m = a.defined,
          g = a.destroyObjectProperties,
          t = a.erase,
          u = a.merge,
          v = a.pick;

      a.PlotLineOrBand = function (a, q) {
        this.axis = a;
        q && (this.options = q, this.id = q.id);
      };

      a.PlotLineOrBand.prototype = {
        render: function render() {
          a.fireEvent(this, "render");
          var g = this,
              q = g.axis,
              f = q.horiz,
              e = g.options,
              p = e.label,
              r = g.label,
              b = e.to,
              l = e.from,
              n = e.value,
              d = m(l) && m(b),
              w = m(n),
              E = g.svgElem,
              C = !E,
              F = [],
              c = e.color,
              k = v(e.zIndex, 0),
              x = e.events,
              F = {
            "class": "highcharts-plot-" + (d ? "band " : "line ") + (e.className || "")
          },
              D = {},
              h = q.chart.renderer,
              z = d ? "bands" : "lines";
          q.isLog && (l = q.log2lin(l), b = q.log2lin(b), n = q.log2lin(n));
          q.chart.styledMode || (w ? (F.stroke = c, F["stroke-width"] = e.width, e.dashStyle && (F.dashstyle = e.dashStyle)) : d && (c && (F.fill = c), e.borderWidth && (F.stroke = e.borderColor, F["stroke-width"] = e.borderWidth)));
          D.zIndex = k;
          z += "-" + k;
          (c = q.plotLinesAndBandsGroups[z]) || (q.plotLinesAndBandsGroups[z] = c = h.g("plot-" + z).attr(D).add());
          C && (g.svgElem = E = h.path().attr(F).add(c));
          if (w) F = q.getPlotLinePath(n, E.strokeWidth());else if (d) F = q.getPlotBandPath(l, b, e);else return;
          C && F && F.length ? (E.attr({
            d: F
          }), x && a.objectEach(x, function (a, c) {
            E.on(c, function (a) {
              x[c].apply(g, [a]);
            });
          })) : E && (F ? (E.show(), E.animate({
            d: F
          })) : (E.hide(), r && (g.label = r = r.destroy())));
          p && m(p.text) && F && F.length && 0 < q.width && 0 < q.height && !F.isFlat ? (p = u({
            align: f && d && "center",
            x: f ? !d && 4 : 10,
            verticalAlign: !f && d && "middle",
            y: f ? d ? 16 : 10 : d ? 6 : -4,
            rotation: f && !d && 90
          }, p), this.renderLabel(p, F, d, k)) : r && r.hide();
          return g;
        },
        renderLabel: function renderLabel(a, q, f, e) {
          var p = this.label,
              r = this.axis.chart.renderer;
          p || (p = {
            align: a.textAlign || a.align,
            rotation: a.rotation,
            "class": "highcharts-plot-" + (f ? "band" : "line") + "-label " + (a.className || "")
          }, p.zIndex = e, this.label = p = r.text(a.text, 0, 0, a.useHTML).attr(p).add(), this.axis.chart.styledMode || p.css(a.style));
          e = q.xBounds || [q[1], q[4], f ? q[6] : q[1]];
          q = q.yBounds || [q[2], q[5], f ? q[7] : q[2]];
          f = G(e);
          r = G(q);
          p.align(a, !1, {
            x: f,
            y: r,
            width: A(e) - f,
            height: A(q) - r
          });
          p.show();
        },
        destroy: function destroy() {
          t(this.axis.plotLinesAndBands, this);
          delete this.axis;
          g(this);
        }
      };
      a.extend(B.prototype, {
        getPlotBandPath: function getPlotBandPath(a, q) {
          var f = this.getPlotLinePath(q, null, null, !0),
              e = this.getPlotLinePath(a, null, null, !0),
              p = [],
              r = this.horiz,
              b = 1,
              l;
          a = a < this.min && q < this.min || a > this.max && q > this.max;
          if (e && f) for (a && (l = e.toString() === f.toString(), b = 0), a = 0; a < e.length; a += 6) {
            r && f[a + 1] === e[a + 1] ? (f[a + 1] += b, f[a + 4] += b) : r || f[a + 2] !== e[a + 2] || (f[a + 2] += b, f[a + 5] += b), p.push("M", e[a + 1], e[a + 2], "L", e[a + 4], e[a + 5], f[a + 4], f[a + 5], f[a + 1], f[a + 2], "z"), p.isFlat = l;
          }
          return p;
        },
        addPlotBand: function addPlotBand(a) {
          return this.addPlotBandOrLine(a, "plotBands");
        },
        addPlotLine: function addPlotLine(a) {
          return this.addPlotBandOrLine(a, "plotLines");
        },
        addPlotBandOrLine: function addPlotBandOrLine(g, q) {
          var f = new a.PlotLineOrBand(this, g).render(),
              e = this.userOptions;
          f && (q && (e[q] = e[q] || [], e[q].push(g)), this.plotLinesAndBands.push(f));
          return f;
        },
        removePlotBandOrLine: function removePlotBandOrLine(a) {
          for (var q = this.plotLinesAndBands, f = this.options, e = this.userOptions, p = q.length; p--;) {
            q[p].id === a && q[p].destroy();
          }

          [f.plotLines || [], e.plotLines || [], f.plotBands || [], e.plotBands || []].forEach(function (e) {
            for (p = e.length; p--;) {
              e[p].id === a && t(e, e[p]);
            }
          });
        },
        removePlotBand: function removePlotBand(a) {
          this.removePlotBandOrLine(a);
        },
        removePlotLine: function removePlotLine(a) {
          this.removePlotBandOrLine(a);
        }
      });
    })(H, da);

    (function (a) {
      var B = a.doc,
          A = a.extend,
          G = a.format,
          m = a.isNumber,
          g = a.merge,
          t = a.pick,
          u = a.splat,
          v = a.syncTimeout,
          y = a.timeUnits;

      a.Tooltip = function () {
        this.init.apply(this, arguments);
      };

      a.Tooltip.prototype = {
        init: function init(a, f) {
          this.chart = a;
          this.options = f;
          this.crosshairs = [];
          this.now = {
            x: 0,
            y: 0
          };
          this.isHidden = !0;
          this.split = f.split && !a.inverted;
          this.shared = f.shared || this.split;
          this.outside = f.outside && !this.split;
        },
        cleanSplit: function cleanSplit(a) {
          this.chart.series.forEach(function (f) {
            var e = f && f.tt;
            e && (!e.isActive || a ? f.tt = e.destroy() : e.isActive = !1);
          });
        },
        applyFilter: function applyFilter() {
          var a = this.chart;
          a.renderer.definition({
            tagName: "filter",
            id: "drop-shadow-" + a.index,
            opacity: .5,
            children: [{
              tagName: "feGaussianBlur",
              "in": "SourceAlpha",
              stdDeviation: 1
            }, {
              tagName: "feOffset",
              dx: 1,
              dy: 1
            }, {
              tagName: "feComponentTransfer",
              children: [{
                tagName: "feFuncA",
                type: "linear",
                slope: .3
              }]
            }, {
              tagName: "feMerge",
              children: [{
                tagName: "feMergeNode"
              }, {
                tagName: "feMergeNode",
                "in": "SourceGraphic"
              }]
            }]
          });
          a.renderer.definition({
            tagName: "style",
            textContent: ".highcharts-tooltip-" + a.index + "{filter:url(#drop-shadow-" + a.index + ")}"
          });
        },
        getLabel: function getLabel() {
          var q = this,
              f = this.chart.renderer,
              e = this.chart.styledMode,
              p = this.options,
              r,
              b;
          this.label || (this.outside && (this.container = r = a.doc.createElement("div"), r.className = "highcharts-tooltip-container", a.css(r, {
            position: "absolute",
            top: "1px",
            pointerEvents: p.style && p.style.pointerEvents
          }), a.doc.body.appendChild(r), this.renderer = f = new a.Renderer(r, 0, 0)), this.split ? this.label = f.g("tooltip") : (this.label = f.label("", 0, 0, p.shape || "callout", null, null, p.useHTML, null, "tooltip").attr({
            padding: p.padding,
            r: p.borderRadius
          }), e || this.label.attr({
            fill: p.backgroundColor,
            "stroke-width": p.borderWidth
          }).css(p.style).shadow(p.shadow)), e && (this.applyFilter(), this.label.addClass("highcharts-tooltip-" + this.chart.index)), this.outside && (b = {
            x: this.label.xSetter,
            y: this.label.ySetter
          }, this.label.xSetter = function (a, n) {
            b[n].call(this.label, q.distance);
            r.style.left = a + "px";
          }, this.label.ySetter = function (a, n) {
            b[n].call(this.label, q.distance);
            r.style.top = a + "px";
          }), this.label.attr({
            zIndex: 8
          }).add());
          return this.label;
        },
        update: function update(a) {
          this.destroy();
          g(!0, this.chart.options.tooltip.userOptions, a);
          this.init(this.chart, g(!0, this.options, a));
        },
        destroy: function destroy() {
          this.label && (this.label = this.label.destroy());
          this.split && this.tt && (this.cleanSplit(this.chart, !0), this.tt = this.tt.destroy());
          this.renderer && (this.renderer = this.renderer.destroy(), a.discardElement(this.container));
          a.clearTimeout(this.hideTimer);
          a.clearTimeout(this.tooltipTimeout);
        },
        move: function move(g, f, e, p) {
          var r = this,
              b = r.now,
              l = !1 !== r.options.animation && !r.isHidden && (1 < Math.abs(g - b.x) || 1 < Math.abs(f - b.y)),
              n = r.followPointer || 1 < r.len;
          A(b, {
            x: l ? (2 * b.x + g) / 3 : g,
            y: l ? (b.y + f) / 2 : f,
            anchorX: n ? void 0 : l ? (2 * b.anchorX + e) / 3 : e,
            anchorY: n ? void 0 : l ? (b.anchorY + p) / 2 : p
          });
          r.getLabel().attr(b);
          l && (a.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function () {
            r && r.move(g, f, e, p);
          }, 32));
        },
        hide: function hide(g) {
          var f = this;
          a.clearTimeout(this.hideTimer);
          g = t(g, this.options.hideDelay, 500);
          this.isHidden || (this.hideTimer = v(function () {
            f.getLabel()[g ? "fadeOut" : "hide"]();
            f.isHidden = !0;
          }, g));
        },
        getAnchor: function getAnchor(a, f) {
          var e = this.chart,
              p = e.pointer,
              r = e.inverted,
              b = e.plotTop,
              l = e.plotLeft,
              n = 0,
              d = 0,
              w,
              g;
          a = u(a);
          this.followPointer && f ? (void 0 === f.chartX && (f = p.normalize(f)), a = [f.chartX - e.plotLeft, f.chartY - b]) : a[0].tooltipPos ? a = a[0].tooltipPos : (a.forEach(function (a) {
            w = a.series.yAxis;
            g = a.series.xAxis;
            n += a.plotX + (!r && g ? g.left - l : 0);
            d += (a.plotLow ? (a.plotLow + a.plotHigh) / 2 : a.plotY) + (!r && w ? w.top - b : 0);
          }), n /= a.length, d /= a.length, a = [r ? e.plotWidth - d : n, this.shared && !r && 1 < a.length && f ? f.chartY - b : r ? e.plotHeight - n : d]);
          return a.map(Math.round);
        },
        getPosition: function getPosition(a, f, e) {
          var p = this.chart,
              r = this.distance,
              b = {},
              l = p.inverted && e.h || 0,
              n,
              d = this.outside,
              w = d ? B.documentElement.clientWidth - 2 * r : p.chartWidth,
              g = d ? Math.max(B.body.scrollHeight, B.documentElement.scrollHeight, B.body.offsetHeight, B.documentElement.offsetHeight, B.documentElement.clientHeight) : p.chartHeight,
              q = p.pointer.chartPosition,
              F = ["y", g, f, (d ? q.top - r : 0) + e.plotY + p.plotTop, d ? 0 : p.plotTop, d ? g : p.plotTop + p.plotHeight],
              c = ["x", w, a, (d ? q.left - r : 0) + e.plotX + p.plotLeft, d ? 0 : p.plotLeft, d ? w : p.plotLeft + p.plotWidth],
              k = !this.followPointer && t(e.ttBelow, !p.inverted === !!e.negative),
              x = function x(a, c, h, d, _x, n) {
            var e = h < d - r,
                f = d + r + h < c,
                w = d - r - h;
            d += r;
            if (k && f) b[a] = d;else if (!k && e) b[a] = w;else if (e) b[a] = Math.min(n - h, 0 > w - l ? w : w - l);else if (f) b[a] = Math.max(_x, d + l + h > c ? d : d + l);else return !1;
          },
              D = function D(a, c, k, h) {
            var d;
            h < r || h > c - r ? d = !1 : b[a] = h < k / 2 ? 1 : h > c - k / 2 ? c - k - 2 : h - k / 2;
            return d;
          },
              h = function h(a) {
            var k = F;
            F = c;
            c = k;
            n = a;
          },
              z = function z() {
            !1 !== x.apply(0, F) ? !1 !== D.apply(0, c) || n || (h(!0), z()) : n ? b.x = b.y = 0 : (h(!0), z());
          };

          (p.inverted || 1 < this.len) && h();
          z();
          return b;
        },
        defaultFormatter: function defaultFormatter(a) {
          var f = this.points || u(this),
              e;
          e = [a.tooltipFooterHeaderFormatter(f[0])];
          e = e.concat(a.bodyFormatter(f));
          e.push(a.tooltipFooterHeaderFormatter(f[0], !0));
          return e;
        },
        refresh: function refresh(g, f) {
          var e,
              p = this.options,
              r,
              b = g,
              l,
              n = {},
              d = [];
          e = p.formatter || this.defaultFormatter;
          var n = this.shared,
              w,
              q = this.chart.styledMode;
          p.enabled && (a.clearTimeout(this.hideTimer), this.followPointer = u(b)[0].series.tooltipOptions.followPointer, l = this.getAnchor(b, f), f = l[0], r = l[1], !n || b.series && b.series.noSharedTooltip ? n = b.getLabelConfig() : (b.forEach(function (a) {
            a.setState("hover");
            d.push(a.getLabelConfig());
          }), n = {
            x: b[0].category,
            y: b[0].y
          }, n.points = d, b = b[0]), this.len = d.length, n = e.call(n, this), w = b.series, this.distance = t(w.tooltipOptions.distance, 16), !1 === n ? this.hide() : (e = this.getLabel(), this.isHidden && e.attr({
            opacity: 1
          }).show(), this.split ? this.renderSplit(n, u(g)) : (p.style.width && !q || e.css({
            width: this.chart.spacingBox.width
          }), e.attr({
            text: n && n.join ? n.join("") : n
          }), e.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-" + t(b.colorIndex, w.colorIndex)), q || e.attr({
            stroke: p.borderColor || b.color || w.color || "#666666"
          }), this.updatePosition({
            plotX: f,
            plotY: r,
            negative: b.negative,
            ttBelow: b.ttBelow,
            h: l[2] || 0
          })), this.isHidden = !1));
        },
        renderSplit: function renderSplit(g, f) {
          var e = this,
              p = [],
              r = this.chart,
              b = r.renderer,
              l = !0,
              n = this.options,
              d = 0,
              w,
              q = this.getLabel(),
              C = r.plotTop;
          a.isString(g) && (g = [!1, g]);
          g.slice(0, f.length + 1).forEach(function (a, c) {
            if (!1 !== a && "" !== a) {
              c = f[c - 1] || {
                isHeader: !0,
                plotX: f[0].plotX,
                plotY: r.plotHeight
              };
              var k = c.series || e,
                  x = k.tt,
                  g = c.series || {},
                  h = "highcharts-color-" + t(c.colorIndex, g.colorIndex, "none");
              x || (x = {
                padding: n.padding,
                r: n.borderRadius
              }, r.styledMode || (x.fill = n.backgroundColor, x.stroke = n.borderColor || c.color || g.color || "#333333", x["stroke-width"] = n.borderWidth), k.tt = x = b.label(null, null, null, (c.isHeader ? n.headerShape : n.shape) || "callout", null, null, n.useHTML).addClass("highcharts-tooltip-box " + h).attr(x).add(q));
              x.isActive = !0;
              x.attr({
                text: a
              });
              r.styledMode || x.css(n.style).shadow(n.shadow);
              a = x.getBBox();
              g = a.width + x.strokeWidth();
              c.isHeader ? (d = a.height, r.xAxis[0].opposite && (w = !0, C -= d), g = Math.max(0, Math.min(c.plotX + r.plotLeft - g / 2, r.chartWidth + (r.scrollablePixels ? r.scrollablePixels - r.marginRight : 0) - g))) : g = c.plotX + r.plotLeft - t(n.distance, 16) - g;
              0 > g && (l = !1);
              a = (c.series && c.series.yAxis && c.series.yAxis.pos) + (c.plotY || 0);
              a -= C;
              c.isHeader && (a = w ? -d : r.plotHeight + d);
              p.push({
                target: a,
                rank: c.isHeader ? 1 : 0,
                size: k.tt.getBBox().height + 1,
                point: c,
                x: g,
                tt: x
              });
            }
          });
          this.cleanSplit();
          n.positioner && p.forEach(function (a) {
            var c = n.positioner.call(e, a.tt.getBBox().width, a.size, a.point);
            a.x = c.x;
            a.align = 0;
            a.target = c.y;
            a.rank = t(c.rank, a.rank);
          });
          a.distribute(p, r.plotHeight + d);
          p.forEach(function (a) {
            var c = a.point,
                k = c.series;
            a.tt.attr({
              visibility: void 0 === a.pos ? "hidden" : "inherit",
              x: l || c.isHeader || n.positioner ? a.x : c.plotX + r.plotLeft + e.distance,
              y: a.pos + C,
              anchorX: c.isHeader ? c.plotX + r.plotLeft : c.plotX + k.xAxis.pos,
              anchorY: c.isHeader ? r.plotTop + r.plotHeight / 2 : c.plotY + k.yAxis.pos
            });
          });
        },
        updatePosition: function updatePosition(a) {
          var f = this.chart,
              e = this.getLabel(),
              p = (this.options.positioner || this.getPosition).call(this, e.width, e.height, a),
              r = a.plotX + f.plotLeft;
          a = a.plotY + f.plotTop;
          var b;
          this.outside && (b = (this.options.borderWidth || 0) + 2 * this.distance, this.renderer.setSize(e.width + b, e.height + b, !1), r += f.pointer.chartPosition.left - p.x, a += f.pointer.chartPosition.top - p.y);
          this.move(Math.round(p.x), Math.round(p.y || 0), r, a);
        },
        getDateFormat: function getDateFormat(a, f, e, p) {
          var r = this.chart.time,
              b = r.dateFormat("%m-%d %H:%M:%S.%L", f),
              l,
              n,
              d = {
            millisecond: 15,
            second: 12,
            minute: 9,
            hour: 6,
            day: 3
          },
              w = "millisecond";

          for (n in y) {
            if (a === y.week && +r.dateFormat("%w", f) === e && "00:00:00.000" === b.substr(6)) {
              n = "week";
              break;
            }

            if (y[n] > a) {
              n = w;
              break;
            }

            if (d[n] && b.substr(d[n]) !== "01-01 00:00:00.000".substr(d[n])) break;
            "week" !== n && (w = n);
          }

          n && (l = r.resolveDTLFormat(p[n]).main);
          return l;
        },
        getXDateFormat: function getXDateFormat(a, f, e) {
          f = f.dateTimeLabelFormats;
          var p = e && e.closestPointRange;
          return (p ? this.getDateFormat(p, a.x, e.options.startOfWeek, f) : f.day) || f.year;
        },
        tooltipFooterHeaderFormatter: function tooltipFooterHeaderFormatter(g, f) {
          var e = f ? "footer" : "header",
              p = g.series,
              r = p.tooltipOptions,
              b = r.xDateFormat,
              l = p.xAxis,
              n = l && "datetime" === l.options.type && m(g.key),
              d = r[e + "Format"];
          f = {
            isFooter: f,
            labelConfig: g
          };
          a.fireEvent(this, "headerFormatter", f, function (a) {
            n && !b && (b = this.getXDateFormat(g, r, l));
            n && b && (g.point && g.point.tooltipDateKeys || ["key"]).forEach(function (a) {
              d = d.replace("{point." + a + "}", "{point." + a + ":" + b + "}");
            });
            p.chart.styledMode && (d = this.styledModeFormat(d));
            a.text = G(d, {
              point: g,
              series: p
            }, this.chart.time);
          });
          return f.text;
        },
        bodyFormatter: function bodyFormatter(a) {
          return a.map(function (a) {
            var e = a.series.tooltipOptions;
            return (e[(a.point.formatPrefix || "point") + "Formatter"] || a.point.tooltipFormatter).call(a.point, e[(a.point.formatPrefix || "point") + "Format"] || "");
          });
        },
        styledModeFormat: function styledModeFormat(a) {
          return a.replace('style\x3d"font-size: 10px"', 'class\x3d"highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class\x3d"highcharts-color-{$1.colorIndex}"');
        }
      };
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.attr,
          G = a.charts,
          m = a.color,
          g = a.css,
          t = a.defined,
          u = a.extend,
          v = a.find,
          y = a.fireEvent,
          q = a.isNumber,
          f = a.isObject,
          e = a.offset,
          p = a.pick,
          r = a.splat,
          b = a.Tooltip;

      a.Pointer = function (a, b) {
        this.init(a, b);
      };

      a.Pointer.prototype = {
        init: function init(a, n) {
          this.options = n;
          this.chart = a;
          this.runChartClick = n.chart.events && !!n.chart.events.click;
          this.pinchDown = [];
          this.lastValidTouch = {};
          b && (a.tooltip = new b(a, n.tooltip), this.followTouchMove = p(n.tooltip.followTouchMove, !0));
          this.setDOMEvents();
        },
        zoomOption: function zoomOption(a) {
          var b = this.chart,
              d = b.options.chart,
              l = d.zoomType || "",
              b = b.inverted;
          /touch/.test(a.type) && (l = p(d.pinchType, l));
          this.zoomX = a = /x/.test(l);
          this.zoomY = l = /y/.test(l);
          this.zoomHor = a && !b || l && b;
          this.zoomVert = l && !b || a && b;
          this.hasZoom = a || l;
        },
        normalize: function normalize(a, b) {
          var d;
          d = a.touches ? a.touches.length ? a.touches.item(0) : a.changedTouches[0] : a;
          b || (this.chartPosition = b = e(this.chart.container));
          return u(a, {
            chartX: Math.round(d.pageX - b.left),
            chartY: Math.round(d.pageY - b.top)
          });
        },
        getCoordinates: function getCoordinates(a) {
          var b = {
            xAxis: [],
            yAxis: []
          };
          this.chart.axes.forEach(function (d) {
            b[d.isXAxis ? "xAxis" : "yAxis"].push({
              axis: d,
              value: d.toValue(a[d.horiz ? "chartX" : "chartY"])
            });
          });
          return b;
        },
        findNearestKDPoint: function findNearestKDPoint(a, b, d) {
          var l;
          a.forEach(function (a) {
            var n = !(a.noSharedTooltip && b) && 0 > a.options.findNearestPointBy.indexOf("y");
            a = a.searchPoint(d, n);
            if ((n = f(a, !0)) && !(n = !f(l, !0))) var n = l.distX - a.distX,
                e = l.dist - a.dist,
                c = (a.series.group && a.series.group.zIndex) - (l.series.group && l.series.group.zIndex),
                n = 0 < (0 !== n && b ? n : 0 !== e ? e : 0 !== c ? c : l.series.index > a.series.index ? -1 : 1);
            n && (l = a);
          });
          return l;
        },
        getPointFromEvent: function getPointFromEvent(a) {
          a = a.target;

          for (var b; a && !b;) {
            b = a.point, a = a.parentNode;
          }

          return b;
        },
        getChartCoordinatesFromPoint: function getChartCoordinatesFromPoint(a, b) {
          var d = a.series,
              l = d.xAxis,
              d = d.yAxis,
              n = p(a.clientX, a.plotX),
              e = a.shapeArgs;
          if (l && d) return b ? {
            chartX: l.len + l.pos - n,
            chartY: d.len + d.pos - a.plotY
          } : {
            chartX: n + l.pos,
            chartY: a.plotY + d.pos
          };
          if (e && e.x && e.y) return {
            chartX: e.x,
            chartY: e.y
          };
        },
        getHoverData: function getHoverData(a, b, d, e, r, g) {
          var l,
              c = [];
          e = !(!e || !a);
          var k = b && !b.stickyTracking ? [b] : d.filter(function (a) {
            return a.visible && !(!r && a.directTouch) && p(a.options.enableMouseTracking, !0) && a.stickyTracking;
          });
          b = (l = e ? a : this.findNearestKDPoint(k, r, g)) && l.series;
          l && (r && !b.noSharedTooltip ? (k = d.filter(function (a) {
            return a.visible && !(!r && a.directTouch) && p(a.options.enableMouseTracking, !0) && !a.noSharedTooltip;
          }), k.forEach(function (a) {
            var k = v(a.points, function (a) {
              return a.x === l.x && !a.isNull;
            });
            f(k) && (a.chart.isBoosting && (k = a.getPoint(k)), c.push(k));
          })) : c.push(l));
          return {
            hoverPoint: l,
            hoverSeries: b,
            hoverPoints: c
          };
        },
        runPointActions: function runPointActions(b, e) {
          var d = this.chart,
              l = d.tooltip && d.tooltip.options.enabled ? d.tooltip : void 0,
              n = l ? l.shared : !1,
              f = e || d.hoverPoint,
              r = f && f.series || d.hoverSeries,
              r = this.getHoverData(f, r, d.series, "touchmove" !== b.type && (!!e || r && r.directTouch && this.isDirectTouch), n, b),
              c,
              f = r.hoverPoint;
          c = r.hoverPoints;
          e = (r = r.hoverSeries) && r.tooltipOptions.followPointer;
          n = n && r && !r.noSharedTooltip;

          if (f && (f !== d.hoverPoint || l && l.isHidden)) {
            (d.hoverPoints || []).forEach(function (a) {
              -1 === c.indexOf(a) && a.setState();
            });
            (c || []).forEach(function (a) {
              a.setState("hover");
            });
            if (d.hoverSeries !== r) r.onMouseOver();
            d.hoverPoint && d.hoverPoint.firePointEvent("mouseOut");
            if (!f.series) return;
            f.firePointEvent("mouseOver");
            d.hoverPoints = c;
            d.hoverPoint = f;
            l && l.refresh(n ? c : f, b);
          } else e && l && !l.isHidden && (f = l.getAnchor([{}], b), l.updatePosition({
            plotX: f[0],
            plotY: f[1]
          }));

          this.unDocMouseMove || (this.unDocMouseMove = B(d.container.ownerDocument, "mousemove", function (c) {
            var k = G[a.hoverChartIndex];
            if (k) k.pointer.onDocumentMouseMove(c);
          }));
          d.axes.forEach(function (k) {
            var d = p(k.crosshair.snap, !0),
                l = d ? a.find(c, function (a) {
              return a.series[k.coll] === k;
            }) : void 0;
            l || !d ? k.drawCrosshair(b, l) : k.hideCrosshair();
          });
        },
        reset: function reset(a, b) {
          var d = this.chart,
              l = d.hoverSeries,
              e = d.hoverPoint,
              n = d.hoverPoints,
              f = d.tooltip,
              c = f && f.shared ? n : e;
          a && c && r(c).forEach(function (c) {
            c.series.isCartesian && void 0 === c.plotX && (a = !1);
          });
          if (a) f && c && r(c).length && (f.refresh(c), f.shared && n ? n.forEach(function (a) {
            a.setState(a.state, !0);
            a.series.isCartesian && (a.series.xAxis.crosshair && a.series.xAxis.drawCrosshair(null, a), a.series.yAxis.crosshair && a.series.yAxis.drawCrosshair(null, a));
          }) : e && (e.setState(e.state, !0), d.axes.forEach(function (a) {
            a.crosshair && a.drawCrosshair(null, e);
          })));else {
            if (e) e.onMouseOut();
            n && n.forEach(function (a) {
              a.setState();
            });
            if (l) l.onMouseOut();
            f && f.hide(b);
            this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove());
            d.axes.forEach(function (a) {
              a.hideCrosshair();
            });
            this.hoverX = d.hoverPoints = d.hoverPoint = null;
          }
        },
        scaleGroups: function scaleGroups(a, b) {
          var d = this.chart,
              l;
          d.series.forEach(function (e) {
            l = a || e.getPlotBox();
            e.xAxis && e.xAxis.zoomEnabled && e.group && (e.group.attr(l), e.markerGroup && (e.markerGroup.attr(l), e.markerGroup.clip(b ? d.clipRect : null)), e.dataLabelsGroup && e.dataLabelsGroup.attr(l));
          });
          d.clipRect.attr(b || d.clipBox);
        },
        dragStart: function dragStart(a) {
          var b = this.chart;
          b.mouseIsDown = a.type;
          b.cancelClick = !1;
          b.mouseDownX = this.mouseDownX = a.chartX;
          b.mouseDownY = this.mouseDownY = a.chartY;
        },
        drag: function drag(a) {
          var b = this.chart,
              d = b.options.chart,
              l = a.chartX,
              e = a.chartY,
              f = this.zoomHor,
              r = this.zoomVert,
              c = b.plotLeft,
              k = b.plotTop,
              x = b.plotWidth,
              g = b.plotHeight,
              h,
              p = this.selectionMarker,
              q = this.mouseDownX,
              t = this.mouseDownY,
              v = d.panKey && a[d.panKey + "Key"];
          p && p.touch || (l < c ? l = c : l > c + x && (l = c + x), e < k ? e = k : e > k + g && (e = k + g), this.hasDragged = Math.sqrt(Math.pow(q - l, 2) + Math.pow(t - e, 2)), 10 < this.hasDragged && (h = b.isInsidePlot(q - c, t - k), b.hasCartesianSeries && (this.zoomX || this.zoomY) && h && !v && !p && (this.selectionMarker = p = b.renderer.rect(c, k, f ? 1 : x, r ? 1 : g, 0).attr({
            "class": "highcharts-selection-marker",
            zIndex: 7
          }).add(), b.styledMode || p.attr({
            fill: d.selectionMarkerFill || m("#335cad").setOpacity(.25).get()
          })), p && f && (l -= q, p.attr({
            width: Math.abs(l),
            x: (0 < l ? 0 : l) + q
          })), p && r && (l = e - t, p.attr({
            height: Math.abs(l),
            y: (0 < l ? 0 : l) + t
          })), h && !p && d.panning && b.pan(a, d.panning)));
        },
        drop: function drop(a) {
          var b = this,
              d = this.chart,
              l = this.hasPinched;

          if (this.selectionMarker) {
            var e = {
              originalEvent: a,
              xAxis: [],
              yAxis: []
            },
                f = this.selectionMarker,
                r = f.attr ? f.attr("x") : f.x,
                c = f.attr ? f.attr("y") : f.y,
                k = f.attr ? f.attr("width") : f.width,
                x = f.attr ? f.attr("height") : f.height,
                p;
            if (this.hasDragged || l) d.axes.forEach(function (h) {
              if (h.zoomEnabled && t(h.min) && (l || b[{
                xAxis: "zoomX",
                yAxis: "zoomY"
              }[h.coll]])) {
                var d = h.horiz,
                    n = "touchend" === a.type ? h.minPixelPadding : 0,
                    f = h.toValue((d ? r : c) + n),
                    d = h.toValue((d ? r + k : c + x) - n);
                e[h.coll].push({
                  axis: h,
                  min: Math.min(f, d),
                  max: Math.max(f, d)
                });
                p = !0;
              }
            }), p && y(d, "selection", e, function (a) {
              d.zoom(u(a, l ? {
                animation: !1
              } : null));
            });
            q(d.index) && (this.selectionMarker = this.selectionMarker.destroy());
            l && this.scaleGroups();
          }

          d && q(d.index) && (g(d.container, {
            cursor: d._cursor
          }), d.cancelClick = 10 < this.hasDragged, d.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
        },
        onContainerMouseDown: function onContainerMouseDown(a) {
          a = this.normalize(a);
          2 !== a.button && (this.zoomOption(a), a.preventDefault && a.preventDefault(), this.dragStart(a));
        },
        onDocumentMouseUp: function onDocumentMouseUp(b) {
          G[a.hoverChartIndex] && G[a.hoverChartIndex].pointer.drop(b);
        },
        onDocumentMouseMove: function onDocumentMouseMove(a) {
          var b = this.chart,
              d = this.chartPosition;
          a = this.normalize(a, d);
          !d || this.inClass(a.target, "highcharts-tracker") || b.isInsidePlot(a.chartX - b.plotLeft, a.chartY - b.plotTop) || this.reset();
        },
        onContainerMouseLeave: function onContainerMouseLeave(b) {
          var l = G[a.hoverChartIndex];
          l && (b.relatedTarget || b.toElement) && (l.pointer.reset(), l.pointer.chartPosition = null);
        },
        onContainerMouseMove: function onContainerMouseMove(b) {
          var l = this.chart;
          t(a.hoverChartIndex) && G[a.hoverChartIndex] && G[a.hoverChartIndex].mouseIsDown || (a.hoverChartIndex = l.index);
          b = this.normalize(b);
          b.preventDefault || (b.returnValue = !1);
          "mousedown" === l.mouseIsDown && this.drag(b);
          !this.inClass(b.target, "highcharts-tracker") && !l.isInsidePlot(b.chartX - l.plotLeft, b.chartY - l.plotTop) || l.openMenu || this.runPointActions(b);
        },
        inClass: function inClass(a, b) {
          for (var d; a;) {
            if (d = A(a, "class")) {
              if (-1 !== d.indexOf(b)) return !0;
              if (-1 !== d.indexOf("highcharts-container")) return !1;
            }

            a = a.parentNode;
          }
        },
        onTrackerMouseOut: function onTrackerMouseOut(a) {
          var b = this.chart.hoverSeries;
          a = a.relatedTarget || a.toElement;
          this.isDirectTouch = !1;
          if (!(!b || !a || b.stickyTracking || this.inClass(a, "highcharts-tooltip") || this.inClass(a, "highcharts-series-" + b.index) && this.inClass(a, "highcharts-tracker"))) b.onMouseOut();
        },
        onContainerClick: function onContainerClick(a) {
          var b = this.chart,
              d = b.hoverPoint,
              l = b.plotLeft,
              e = b.plotTop;
          a = this.normalize(a);
          b.cancelClick || (d && this.inClass(a.target, "highcharts-tracker") ? (y(d.series, "click", u(a, {
            point: d
          })), b.hoverPoint && d.firePointEvent("click", a)) : (u(a, this.getCoordinates(a)), b.isInsidePlot(a.chartX - l, a.chartY - e) && y(b, "click", a)));
        },
        setDOMEvents: function setDOMEvents() {
          var b = this,
              e = b.chart.container,
              d = e.ownerDocument;

          e.onmousedown = function (a) {
            b.onContainerMouseDown(a);
          };

          e.onmousemove = function (a) {
            b.onContainerMouseMove(a);
          };

          e.onclick = function (a) {
            b.onContainerClick(a);
          };

          this.unbindContainerMouseLeave = B(e, "mouseleave", b.onContainerMouseLeave);
          a.unbindDocumentMouseUp || (a.unbindDocumentMouseUp = B(d, "mouseup", b.onDocumentMouseUp));
          a.hasTouch && (e.ontouchstart = function (a) {
            b.onContainerTouchStart(a);
          }, e.ontouchmove = function (a) {
            b.onContainerTouchMove(a);
          }, a.unbindDocumentTouchEnd || (a.unbindDocumentTouchEnd = B(d, "touchend", b.onDocumentTouchEnd)));
        },
        destroy: function destroy() {
          var b = this;
          b.unDocMouseMove && b.unDocMouseMove();
          this.unbindContainerMouseLeave();
          a.chartCount || (a.unbindDocumentMouseUp && (a.unbindDocumentMouseUp = a.unbindDocumentMouseUp()), a.unbindDocumentTouchEnd && (a.unbindDocumentTouchEnd = a.unbindDocumentTouchEnd()));
          clearInterval(b.tooltipTimeout);
          a.objectEach(b, function (a, d) {
            b[d] = null;
          });
        }
      };
    })(H);

    (function (a) {
      var B = a.charts,
          A = a.extend,
          G = a.noop,
          m = a.pick;
      A(a.Pointer.prototype, {
        pinchTranslate: function pinchTranslate(a, m, u, v, y, q) {
          this.zoomHor && this.pinchTranslateDirection(!0, a, m, u, v, y, q);
          this.zoomVert && this.pinchTranslateDirection(!1, a, m, u, v, y, q);
        },
        pinchTranslateDirection: function pinchTranslateDirection(a, m, u, v, y, q, f, e) {
          var p = this.chart,
              r = a ? "x" : "y",
              b = a ? "X" : "Y",
              l = "chart" + b,
              n = a ? "width" : "height",
              d = p["plot" + (a ? "Left" : "Top")],
              w,
              g,
              C = e || 1,
              F = p.inverted,
              c = p.bounds[a ? "h" : "v"],
              k = 1 === m.length,
              x = m[0][l],
              D = u[0][l],
              h = !k && m[1][l],
              z = !k && u[1][l],
              t;

          u = function u() {
            !k && 20 < Math.abs(x - h) && (C = e || Math.abs(D - z) / Math.abs(x - h));
            g = (d - D) / C + x;
            w = p["plot" + (a ? "Width" : "Height")] / C;
          };

          u();
          m = g;
          m < c.min ? (m = c.min, t = !0) : m + w > c.max && (m = c.max - w, t = !0);
          t ? (D -= .8 * (D - f[r][0]), k || (z -= .8 * (z - f[r][1])), u()) : f[r] = [D, z];
          F || (q[r] = g - d, q[n] = w);
          q = F ? 1 / C : C;
          y[n] = w;
          y[r] = m;
          v[F ? a ? "scaleY" : "scaleX" : "scale" + b] = C;
          v["translate" + b] = q * d + (D - q * x);
        },
        pinch: function pinch(a) {
          var g = this,
              u = g.chart,
              v = g.pinchDown,
              y = a.touches,
              q = y.length,
              f = g.lastValidTouch,
              e = g.hasZoom,
              p = g.selectionMarker,
              r = {},
              b = 1 === q && (g.inClass(a.target, "highcharts-tracker") && u.runTrackerClick || g.runChartClick),
              l = {};
          1 < q && (g.initiated = !0);
          e && g.initiated && !b && a.preventDefault();
          [].map.call(y, function (a) {
            return g.normalize(a);
          });
          "touchstart" === a.type ? ([].forEach.call(y, function (a, b) {
            v[b] = {
              chartX: a.chartX,
              chartY: a.chartY
            };
          }), f.x = [v[0].chartX, v[1] && v[1].chartX], f.y = [v[0].chartY, v[1] && v[1].chartY], u.axes.forEach(function (a) {
            if (a.zoomEnabled) {
              var b = u.bounds[a.horiz ? "h" : "v"],
                  l = a.minPixelPadding,
                  e = a.toPixels(m(a.options.min, a.dataMin)),
                  f = a.toPixels(m(a.options.max, a.dataMax)),
                  n = Math.max(e, f);
              b.min = Math.min(a.pos, Math.min(e, f) - l);
              b.max = Math.max(a.pos + a.len, n + l);
            }
          }), g.res = !0) : g.followTouchMove && 1 === q ? this.runPointActions(g.normalize(a)) : v.length && (p || (g.selectionMarker = p = A({
            destroy: G,
            touch: !0
          }, u.plotBox)), g.pinchTranslate(v, y, r, p, l, f), g.hasPinched = e, g.scaleGroups(r, l), g.res && (g.res = !1, this.reset(!1, 0)));
        },
        touch: function touch(g, t) {
          var u = this.chart,
              v,
              y;
          if (u.index !== a.hoverChartIndex) this.onContainerMouseLeave({
            relatedTarget: !0
          });
          a.hoverChartIndex = u.index;
          1 === g.touches.length ? (g = this.normalize(g), (y = u.isInsidePlot(g.chartX - u.plotLeft, g.chartY - u.plotTop)) && !u.openMenu ? (t && this.runPointActions(g), "touchmove" === g.type && (t = this.pinchDown, v = t[0] ? 4 <= Math.sqrt(Math.pow(t[0].chartX - g.chartX, 2) + Math.pow(t[0].chartY - g.chartY, 2)) : !1), m(v, !0) && this.pinch(g)) : t && this.reset()) : 2 === g.touches.length && this.pinch(g);
        },
        onContainerTouchStart: function onContainerTouchStart(a) {
          this.zoomOption(a);
          this.touch(a, !0);
        },
        onContainerTouchMove: function onContainerTouchMove(a) {
          this.touch(a);
        },
        onDocumentTouchEnd: function onDocumentTouchEnd(g) {
          B[a.hoverChartIndex] && B[a.hoverChartIndex].pointer.drop(g);
        }
      });
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.charts,
          G = a.css,
          m = a.doc,
          g = a.extend,
          t = a.noop,
          u = a.Pointer,
          v = a.removeEvent,
          y = a.win,
          q = a.wrap;

      if (!a.hasTouch && (y.PointerEvent || y.MSPointerEvent)) {
        var f = {},
            e = !!y.PointerEvent,
            p = function p() {
          var b = [];

          b.item = function (a) {
            return this[a];
          };

          a.objectEach(f, function (a) {
            b.push({
              pageX: a.pageX,
              pageY: a.pageY,
              target: a.target
            });
          });
          return b;
        },
            r = function r(b, l, e, d) {
          "touch" !== b.pointerType && b.pointerType !== b.MSPOINTER_TYPE_TOUCH || !A[a.hoverChartIndex] || (d(b), d = A[a.hoverChartIndex].pointer, d[l]({
            type: e,
            target: b.currentTarget,
            preventDefault: t,
            touches: p()
          }));
        };

        g(u.prototype, {
          onContainerPointerDown: function onContainerPointerDown(a) {
            r(a, "onContainerTouchStart", "touchstart", function (a) {
              f[a.pointerId] = {
                pageX: a.pageX,
                pageY: a.pageY,
                target: a.currentTarget
              };
            });
          },
          onContainerPointerMove: function onContainerPointerMove(a) {
            r(a, "onContainerTouchMove", "touchmove", function (a) {
              f[a.pointerId] = {
                pageX: a.pageX,
                pageY: a.pageY
              };
              f[a.pointerId].target || (f[a.pointerId].target = a.currentTarget);
            });
          },
          onDocumentPointerUp: function onDocumentPointerUp(a) {
            r(a, "onDocumentTouchEnd", "touchend", function (a) {
              delete f[a.pointerId];
            });
          },
          batchMSEvents: function batchMSEvents(a) {
            a(this.chart.container, e ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown);
            a(this.chart.container, e ? "pointermove" : "MSPointerMove", this.onContainerPointerMove);
            a(m, e ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
          }
        });
        q(u.prototype, "init", function (a, l, e) {
          a.call(this, l, e);
          this.hasZoom && G(l.container, {
            "-ms-touch-action": "none",
            "touch-action": "none"
          });
        });
        q(u.prototype, "setDOMEvents", function (a) {
          a.apply(this);
          (this.hasZoom || this.followTouchMove) && this.batchMSEvents(B);
        });
        q(u.prototype, "destroy", function (a) {
          this.batchMSEvents(v);
          a.call(this);
        });
      }
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.css,
          G = a.discardElement,
          m = a.defined,
          g = a.fireEvent,
          t = a.isFirefox,
          u = a.marginNames,
          v = a.merge,
          y = a.pick,
          q = a.setAnimation,
          f = a.stableSort,
          e = a.win,
          p = a.wrap;

      a.Legend = function (a, b) {
        this.init(a, b);
      };

      a.Legend.prototype = {
        init: function init(a, b) {
          this.chart = a;
          this.setOptions(b);
          b.enabled && (this.render(), B(this.chart, "endResize", function () {
            this.legend.positionCheckboxes();
          }), this.proximate ? this.unchartrender = B(this.chart, "render", function () {
            this.legend.proximatePositions();
            this.legend.positionItems();
          }) : this.unchartrender && this.unchartrender());
        },
        setOptions: function setOptions(a) {
          var b = y(a.padding, 8);
          this.options = a;
          this.chart.styledMode || (this.itemStyle = a.itemStyle, this.itemHiddenStyle = v(this.itemStyle, a.itemHiddenStyle));
          this.itemMarginTop = a.itemMarginTop || 0;
          this.padding = b;
          this.initialItemY = b - 5;
          this.symbolWidth = y(a.symbolWidth, 16);
          this.pages = [];
          this.proximate = "proximate" === a.layout && !this.chart.inverted;
        },
        update: function update(a, b) {
          var e = this.chart;
          this.setOptions(v(!0, this.options, a));
          this.destroy();
          e.isDirtyLegend = e.isDirtyBox = !0;
          y(b, !0) && e.redraw();
          g(this, "afterUpdate");
        },
        colorizeItem: function colorizeItem(a, b) {
          a.legendGroup[b ? "removeClass" : "addClass"]("highcharts-legend-item-hidden");

          if (!this.chart.styledMode) {
            var e = this.options,
                f = a.legendItem,
                d = a.legendLine,
                r = a.legendSymbol,
                p = this.itemHiddenStyle.color,
                e = b ? e.itemStyle.color : p,
                q = b ? a.color || p : p,
                m = a.options && a.options.marker,
                c = {
              fill: q
            };
            f && f.css({
              fill: e,
              color: e
            });
            d && d.attr({
              stroke: q
            });
            r && (m && r.isMarker && (c = a.pointAttribs(), b || (c.stroke = c.fill = p)), r.attr(c));
          }

          g(this, "afterColorizeItem", {
            item: a,
            visible: b
          });
        },
        positionItems: function positionItems() {
          this.allItems.forEach(this.positionItem, this);
          this.chart.isResizing || this.positionCheckboxes();
        },
        positionItem: function positionItem(a) {
          var b = this.options,
              e = b.symbolPadding,
              b = !b.rtl,
              f = a._legendItemPos,
              d = f[0],
              f = f[1],
              r = a.checkbox;
          if ((a = a.legendGroup) && a.element) a[m(a.translateY) ? "animate" : "attr"]({
            translateX: b ? d : this.legendWidth - d - 2 * e - 4,
            translateY: f
          });
          r && (r.x = d, r.y = f);
        },
        destroyItem: function destroyItem(a) {
          var b = a.checkbox;
          ["legendItem", "legendLine", "legendSymbol", "legendGroup"].forEach(function (b) {
            a[b] && (a[b] = a[b].destroy());
          });
          b && G(a.checkbox);
        },
        destroy: function destroy() {
          function a(a) {
            this[a] && (this[a] = this[a].destroy());
          }

          this.getAllItems().forEach(function (b) {
            ["legendItem", "legendGroup"].forEach(a, b);
          });
          "clipRect up down pager nav box title group".split(" ").forEach(a, this);
          this.display = null;
        },
        positionCheckboxes: function positionCheckboxes() {
          var a = this.group && this.group.alignAttr,
              b,
              e = this.clipHeight || this.legendHeight,
              f = this.titleHeight;
          a && (b = a.translateY, this.allItems.forEach(function (d) {
            var l = d.checkbox,
                n;
            l && (n = b + f + l.y + (this.scrollOffset || 0) + 3, A(l, {
              left: a.translateX + d.checkboxOffset + l.x - 20 + "px",
              top: n + "px",
              display: this.proximate || n > b - 6 && n < b + e - 6 ? "" : "none"
            }));
          }, this));
        },
        renderTitle: function renderTitle() {
          var a = this.options,
              b = this.padding,
              e = a.title,
              f = 0;
          e.text && (this.title || (this.title = this.chart.renderer.label(e.text, b - 3, b - 4, null, null, null, a.useHTML, null, "legend-title").attr({
            zIndex: 1
          }), this.chart.styledMode || this.title.css(e.style), this.title.add(this.group)), e.width || this.title.css({
            width: this.maxLegendWidth + "px"
          }), a = this.title.getBBox(), f = a.height, this.offsetWidth = a.width, this.contentGroup.attr({
            translateY: f
          }));
          this.titleHeight = f;
        },
        setText: function setText(e) {
          var b = this.options;
          e.legendItem.attr({
            text: b.labelFormat ? a.format(b.labelFormat, e, this.chart.time) : b.labelFormatter.call(e)
          });
        },
        renderItem: function renderItem(a) {
          var b = this.chart,
              e = b.renderer,
              f = this.options,
              d = this.symbolWidth,
              p = f.symbolPadding,
              g = this.itemStyle,
              r = this.itemHiddenStyle,
              q = "horizontal" === f.layout ? y(f.itemDistance, 20) : 0,
              c = !f.rtl,
              k = a.legendItem,
              x = !a.series,
              D = !x && a.series.drawLegendSymbol ? a.series : a,
              h = D.options,
              h = this.createCheckboxForItem && h && h.showCheckbox,
              q = d + p + q + (h ? 20 : 0),
              z = f.useHTML,
              m = a.options.className;
          k || (a.legendGroup = e.g("legend-item").addClass("highcharts-" + D.type + "-series highcharts-color-" + a.colorIndex + (m ? " " + m : "") + (x ? " highcharts-series-" + a.index : "")).attr({
            zIndex: 1
          }).add(this.scrollGroup), a.legendItem = k = e.text("", c ? d + p : -p, this.baseline || 0, z), b.styledMode || k.css(v(a.visible ? g : r)), k.attr({
            align: c ? "left" : "right",
            zIndex: 2
          }).add(a.legendGroup), this.baseline || (this.fontMetrics = e.fontMetrics(b.styledMode ? 12 : g.fontSize, k), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, k.attr("y", this.baseline)), this.symbolHeight = f.symbolHeight || this.fontMetrics.f, D.drawLegendSymbol(this, a), this.setItemEvents && this.setItemEvents(a, k, z), h && this.createCheckboxForItem(a));
          this.colorizeItem(a, a.visible);
          !b.styledMode && g.width || k.css({
            width: (f.itemWidth || this.widthOption || b.spacingBox.width) - q
          });
          this.setText(a);
          b = k.getBBox();
          a.itemWidth = a.checkboxOffset = f.itemWidth || a.legendItemWidth || b.width + q;
          this.maxItemWidth = Math.max(this.maxItemWidth, a.itemWidth);
          this.totalItemWidth += a.itemWidth;
          this.itemHeight = a.itemHeight = Math.round(a.legendItemHeight || b.height || this.symbolHeight);
        },
        layoutItem: function layoutItem(a) {
          var b = this.options,
              e = this.padding,
              f = "horizontal" === b.layout,
              d = a.itemHeight,
              p = b.itemMarginBottom || 0,
              g = this.itemMarginTop,
              r = f ? y(b.itemDistance, 20) : 0,
              q = this.maxLegendWidth,
              b = b.alignColumns && this.totalItemWidth > q ? this.maxItemWidth : a.itemWidth;
          f && this.itemX - e + b > q && (this.itemX = e, this.itemY += g + this.lastLineHeight + p, this.lastLineHeight = 0);
          this.lastItemY = g + this.itemY + p;
          this.lastLineHeight = Math.max(d, this.lastLineHeight);
          a._legendItemPos = [this.itemX, this.itemY];
          f ? this.itemX += b : (this.itemY += g + d + p, this.lastLineHeight = d);
          this.offsetWidth = this.widthOption || Math.max((f ? this.itemX - e - (a.checkbox ? 0 : r) : b) + e, this.offsetWidth);
        },
        getAllItems: function getAllItems() {
          var a = [];
          this.chart.series.forEach(function (b) {
            var e = b && b.options;
            b && y(e.showInLegend, m(e.linkedTo) ? !1 : void 0, !0) && (a = a.concat(b.legendItems || ("point" === e.legendType ? b.data : b)));
          });
          g(this, "afterGetAllItems", {
            allItems: a
          });
          return a;
        },
        getAlignment: function getAlignment() {
          var a = this.options;
          return this.proximate ? a.align.charAt(0) + "tv" : a.floating ? "" : a.align.charAt(0) + a.verticalAlign.charAt(0) + a.layout.charAt(0);
        },
        adjustMargins: function adjustMargins(a, b) {
          var e = this.chart,
              f = this.options,
              d = this.getAlignment(),
              p = void 0 !== e.options.title.margin ? e.titleOffset + e.options.title.margin : 0;
          d && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function (l, n) {
            l.test(d) && !m(a[n]) && (e[u[n]] = Math.max(e[u[n]], e.legend[(n + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][n] * f[n % 2 ? "x" : "y"] + y(f.margin, 12) + b[n] + (0 === n && (0 === e.titleOffset ? 0 : p))));
          });
        },
        proximatePositions: function proximatePositions() {
          var e = this.chart,
              b = [],
              l = "left" === this.options.align;
          this.allItems.forEach(function (f) {
            var d, n;
            d = l;
            f.xAxis && f.points && (f.xAxis.options.reversed && (d = !d), d = a.find(d ? f.points : f.points.slice(0).reverse(), function (b) {
              return a.isNumber(b.plotY);
            }), n = f.legendGroup.getBBox().height, b.push({
              target: f.visible ? (d ? d.plotY : f.xAxis.height) - .3 * n : e.plotHeight,
              size: n,
              item: f
            }));
          }, this);
          a.distribute(b, e.plotHeight);
          b.forEach(function (a) {
            a.item._legendItemPos[1] = e.plotTop - e.spacing[0] + a.pos;
          });
        },
        render: function render() {
          var e = this.chart,
              b = e.renderer,
              l = this.group,
              n,
              d,
              p,
              q = this.box,
              m = this.options,
              F = this.padding;
          this.itemX = F;
          this.itemY = this.initialItemY;
          this.lastItemY = this.offsetWidth = 0;
          this.widthOption = a.relativeLength(m.width, e.spacingBox.width - F);
          n = e.spacingBox.width - 2 * F - m.x;
          -1 < ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) && (n /= 2);
          this.maxLegendWidth = this.widthOption || n;
          l || (this.group = l = b.g("legend").attr({
            zIndex: 7
          }).add(), this.contentGroup = b.g().attr({
            zIndex: 1
          }).add(l), this.scrollGroup = b.g().add(this.contentGroup));
          this.renderTitle();
          n = this.getAllItems();
          f(n, function (a, b) {
            return (a.options && a.options.legendIndex || 0) - (b.options && b.options.legendIndex || 0);
          });
          m.reversed && n.reverse();
          this.allItems = n;
          this.display = d = !!n.length;
          this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0;
          n.forEach(this.renderItem, this);
          n.forEach(this.layoutItem, this);
          n = (this.widthOption || this.offsetWidth) + F;
          p = this.lastItemY + this.lastLineHeight + this.titleHeight;
          p = this.handleOverflow(p);
          p += F;
          q || (this.box = q = b.rect().addClass("highcharts-legend-box").attr({
            r: m.borderRadius
          }).add(l), q.isNew = !0);
          e.styledMode || q.attr({
            stroke: m.borderColor,
            "stroke-width": m.borderWidth || 0,
            fill: m.backgroundColor || "none"
          }).shadow(m.shadow);
          0 < n && 0 < p && (q[q.isNew ? "attr" : "animate"](q.crisp.call({}, {
            x: 0,
            y: 0,
            width: n,
            height: p
          }, q.strokeWidth())), q.isNew = !1);
          q[d ? "show" : "hide"]();
          e.styledMode && "none" === l.getStyle("display") && (n = p = 0);
          this.legendWidth = n;
          this.legendHeight = p;
          d && (b = e.spacingBox, /(lth|ct|rth)/.test(this.getAlignment()) && (q = b.y + e.titleOffset, b = v(b, {
            y: 0 < e.titleOffset ? q += e.options.title.margin : q
          })), l.align(v(m, {
            width: n,
            height: p,
            verticalAlign: this.proximate ? "top" : m.verticalAlign
          }), !0, b));
          this.proximate || this.positionItems();
          g(this, "afterRender");
        },
        handleOverflow: function handleOverflow(a) {
          var b = this,
              e = this.chart,
              f = e.renderer,
              d = this.options,
              p = d.y,
              g = this.padding,
              p = e.spacingBox.height + ("top" === d.verticalAlign ? -p : p) - g,
              r = d.maxHeight,
              q,
              c = this.clipRect,
              k = d.navigation,
              x = y(k.animation, !0),
              D = k.arrowSize || 12,
              h = this.nav,
              z = this.pages,
              m,
              t = this.allItems,
              v = function v(a) {
            "number" === typeof a ? c.attr({
              height: a
            }) : c && (b.clipRect = c.destroy(), b.contentGroup.clip());
            b.contentGroup.div && (b.contentGroup.div.style.clip = a ? "rect(" + g + "px,9999px," + (g + a) + "px,0)" : "auto");
          };

          "horizontal" !== d.layout || "middle" === d.verticalAlign || d.floating || (p /= 2);
          r && (p = Math.min(p, r));
          z.length = 0;
          a > p && !1 !== k.enabled ? (this.clipHeight = q = Math.max(p - 20 - this.titleHeight - g, 0), this.currentPage = y(this.currentPage, 1), this.fullHeight = a, t.forEach(function (a, c) {
            var b = a._legendItemPos[1],
                k = Math.round(a.legendItem.getBBox().height),
                h = z.length;
            if (!h || b - z[h - 1] > q && (m || b) !== z[h - 1]) z.push(m || b), h++;
            a.pageIx = h - 1;
            m && (t[c - 1].pageIx = h - 1);
            c === t.length - 1 && b + k - z[h - 1] > q && b !== m && (z.push(b), a.pageIx = h);
            b !== m && (m = b);
          }), c || (c = b.clipRect = f.clipRect(0, g, 9999, 0), b.contentGroup.clip(c)), v(q), h || (this.nav = h = f.g().attr({
            zIndex: 1
          }).add(this.group), this.up = f.symbol("triangle", 0, 0, D, D).on("click", function () {
            b.scroll(-1, x);
          }).add(h), this.pager = f.text("", 15, 10).addClass("highcharts-legend-navigation"), e.styledMode || this.pager.css(k.style), this.pager.add(h), this.down = f.symbol("triangle-down", 0, 0, D, D).on("click", function () {
            b.scroll(1, x);
          }).add(h)), b.scroll(0), a = p) : h && (v(), this.nav = h.destroy(), this.scrollGroup.attr({
            translateY: 1
          }), this.clipHeight = 0);
          return a;
        },
        scroll: function scroll(a, b) {
          var e = this.pages,
              f = e.length;
          a = this.currentPage + a;
          var d = this.clipHeight,
              p = this.options.navigation,
              g = this.pager,
              r = this.padding;
          a > f && (a = f);
          0 < a && (void 0 !== b && q(b, this.chart), this.nav.attr({
            translateX: r,
            translateY: d + this.padding + 7 + this.titleHeight,
            visibility: "visible"
          }), this.up.attr({
            "class": 1 === a ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
          }), g.attr({
            text: a + "/" + f
          }), this.down.attr({
            x: 18 + this.pager.getBBox().width,
            "class": a === f ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
          }), this.chart.styledMode || (this.up.attr({
            fill: 1 === a ? p.inactiveColor : p.activeColor
          }).css({
            cursor: 1 === a ? "default" : "pointer"
          }), this.down.attr({
            fill: a === f ? p.inactiveColor : p.activeColor
          }).css({
            cursor: a === f ? "default" : "pointer"
          })), this.scrollOffset = -e[a - 1] + this.initialItemY, this.scrollGroup.animate({
            translateY: this.scrollOffset
          }), this.currentPage = a, this.positionCheckboxes());
        }
      };
      a.LegendSymbolMixin = {
        drawRectangle: function drawRectangle(a, b) {
          var e = a.symbolHeight,
              f = a.options.squareSymbol;
          b.legendSymbol = this.chart.renderer.rect(f ? (a.symbolWidth - e) / 2 : 0, a.baseline - e + 1, f ? e : a.symbolWidth, e, y(a.options.symbolRadius, e / 2)).addClass("highcharts-point").attr({
            zIndex: 3
          }).add(b.legendGroup);
        },
        drawLineMarker: function drawLineMarker(a) {
          var b = this.options,
              e = b.marker,
              f = a.symbolWidth,
              d = a.symbolHeight,
              p = d / 2,
              g = this.chart.renderer,
              r = this.legendGroup;
          a = a.baseline - Math.round(.3 * a.fontMetrics.b);
          var q = {};
          this.chart.styledMode || (q = {
            "stroke-width": b.lineWidth || 0
          }, b.dashStyle && (q.dashstyle = b.dashStyle));
          this.legendLine = g.path(["M", 0, a, "L", f, a]).addClass("highcharts-graph").attr(q).add(r);
          e && !1 !== e.enabled && f && (b = Math.min(y(e.radius, p), p), 0 === this.symbol.indexOf("url") && (e = v(e, {
            width: d,
            height: d
          }), b = 0), this.legendSymbol = e = g.symbol(this.symbol, f / 2 - b, a - b, 2 * b, 2 * b, e).addClass("highcharts-point").add(r), e.isMarker = !0);
        }
      };
      (/Trident\/7\.0/.test(e.navigator && e.navigator.userAgent) || t) && p(a.Legend.prototype, "positionItem", function (a, b) {
        var e = this,
            f = function f() {
          b._legendItemPos && a.call(e, b);
        };

        f();
        e.bubbleLegend || setTimeout(f);
      });
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.animate,
          G = a.animObject,
          m = a.attr,
          g = a.doc,
          t = a.Axis,
          u = a.createElement,
          v = a.defaultOptions,
          y = a.discardElement,
          q = a.charts,
          f = a.css,
          e = a.defined,
          p = a.extend,
          r = a.find,
          b = a.fireEvent,
          l = a.isNumber,
          n = a.isObject,
          d = a.isString,
          w = a.Legend,
          E = a.marginNames,
          C = a.merge,
          F = a.objectEach,
          c = a.Pointer,
          k = a.pick,
          x = a.pInt,
          D = a.removeEvent,
          h = a.seriesTypes,
          z = a.splat,
          L = a.syncTimeout,
          J = a.win,
          W = a.Chart = function () {
        this.getArgs.apply(this, arguments);
      };

      a.chart = function (a, c, b) {
        return new W(a, c, b);
      };

      p(W.prototype, {
        callbacks: [],
        getArgs: function getArgs() {
          var a = [].slice.call(arguments);
          if (d(a[0]) || a[0].nodeName) this.renderTo = a.shift();
          this.init(a[0], a[1]);
        },
        init: function init(c, k) {
          var h,
              d,
              e = c.series,
              x = c.plotOptions || {};
          b(this, "init", {
            args: arguments
          }, function () {
            c.series = null;
            h = C(v, c);

            for (d in h.plotOptions) {
              h.plotOptions[d].tooltip = x[d] && C(x[d].tooltip) || void 0;
            }

            h.tooltip.userOptions = c.chart && c.chart.forExport && c.tooltip.userOptions || c.tooltip;
            h.series = c.series = e;
            this.userOptions = c;
            var f = h.chart,
                l = f.events;
            this.margin = [];
            this.spacing = [];
            this.bounds = {
              h: {},
              v: {}
            };
            this.labelCollectors = [];
            this.callback = k;
            this.isResizing = 0;
            this.options = h;
            this.axes = [];
            this.series = [];
            this.time = c.time && Object.keys(c.time).length ? new a.Time(c.time) : a.time;
            this.styledMode = f.styledMode;
            this.hasCartesianSeries = f.showAxes;
            var p = this;
            p.index = q.length;
            q.push(p);
            a.chartCount++;
            l && F(l, function (a, c) {
              B(p, c, a);
            });
            p.xAxis = [];
            p.yAxis = [];
            p.pointCount = p.colorCounter = p.symbolCounter = 0;
            b(p, "afterInit");
            p.firstRender();
          });
        },
        initSeries: function initSeries(c) {
          var b = this.options.chart;
          (b = h[c.type || b.type || b.defaultSeriesType]) || a.error(17, !0, this);
          b = new b();
          b.init(this, c);
          return b;
        },
        orderSeries: function orderSeries(a) {
          var c = this.series;

          for (a = a || 0; a < c.length; a++) {
            c[a] && (c[a].index = a, c[a].name = c[a].getName());
          }
        },
        isInsidePlot: function isInsidePlot(a, c, b) {
          var k = b ? c : a;
          a = b ? a : c;
          return 0 <= k && k <= this.plotWidth && 0 <= a && a <= this.plotHeight;
        },
        redraw: function redraw(c) {
          b(this, "beforeRedraw");
          var k = this.axes,
              h = this.series,
              d = this.pointer,
              e = this.legend,
              x = this.userOptions.legend,
              f = this.isDirtyLegend,
              l,
              n,
              g = this.hasCartesianSeries,
              z = this.isDirtyBox,
              r,
              D = this.renderer,
              q = D.isHidden(),
              w = [];
          this.setResponsive && this.setResponsive(!1);
          a.setAnimation(c, this);
          q && this.temporaryDisplay();
          this.layOutTitles();

          for (c = h.length; c--;) {
            if (r = h[c], r.options.stacking && (l = !0, r.isDirty)) {
              n = !0;
              break;
            }
          }

          if (n) for (c = h.length; c--;) {
            r = h[c], r.options.stacking && (r.isDirty = !0);
          }
          h.forEach(function (a) {
            a.isDirty && ("point" === a.options.legendType ? (a.updateTotals && a.updateTotals(), f = !0) : x && (x.labelFormatter || x.labelFormat) && (f = !0));
            a.isDirtyData && b(a, "updatedData");
          });
          f && e && e.options.enabled && (e.render(), this.isDirtyLegend = !1);
          l && this.getStacks();
          g && k.forEach(function (a) {
            a.updateNames();
            a.setScale();
          });
          this.getMargins();
          g && (k.forEach(function (a) {
            a.isDirty && (z = !0);
          }), k.forEach(function (a) {
            var c = a.min + "," + a.max;
            a.extKey !== c && (a.extKey = c, w.push(function () {
              b(a, "afterSetExtremes", p(a.eventArgs, a.getExtremes()));
              delete a.eventArgs;
            }));
            (z || l) && a.redraw();
          }));
          z && this.drawChartBox();
          b(this, "predraw");
          h.forEach(function (a) {
            (z || a.isDirty) && a.visible && a.redraw();
            a.isDirtyData = !1;
          });
          d && d.reset(!0);
          D.draw();
          b(this, "redraw");
          b(this, "render");
          q && this.temporaryDisplay(!0);
          w.forEach(function (a) {
            a.call();
          });
        },
        get: function get(a) {
          function c(c) {
            return c.id === a || c.options && c.options.id === a;
          }

          var b,
              k = this.series,
              h;
          b = r(this.axes, c) || r(this.series, c);

          for (h = 0; !b && h < k.length; h++) {
            b = r(k[h].points || [], c);
          }

          return b;
        },
        getAxes: function getAxes() {
          var a = this,
              c = this.options,
              k = c.xAxis = z(c.xAxis || {}),
              c = c.yAxis = z(c.yAxis || {});
          b(this, "getAxes");
          k.forEach(function (a, c) {
            a.index = c;
            a.isX = !0;
          });
          c.forEach(function (a, c) {
            a.index = c;
          });
          k.concat(c).forEach(function (c) {
            new t(a, c);
          });
          b(this, "afterGetAxes");
        },
        getSelectedPoints: function getSelectedPoints() {
          var a = [];
          this.series.forEach(function (c) {
            a = a.concat((c[c.hasGroupedData ? "points" : "data"] || []).filter(function (a) {
              return a.selected;
            }));
          });
          return a;
        },
        getSelectedSeries: function getSelectedSeries() {
          return this.series.filter(function (a) {
            return a.selected;
          });
        },
        setTitle: function setTitle(a, c, b) {
          var k = this,
              h = k.options,
              d = k.styledMode,
              e;
          e = h.title = C(!d && {
            style: {
              color: "#333333",
              fontSize: h.isStock ? "16px" : "18px"
            }
          }, h.title, a);
          h = h.subtitle = C(!d && {
            style: {
              color: "#666666"
            }
          }, h.subtitle, c);
          [["title", a, e], ["subtitle", c, h]].forEach(function (a, c) {
            var b = a[0],
                h = k[b],
                e = a[1];
            a = a[2];
            h && e && (k[b] = h = h.destroy());
            a && !h && (k[b] = k.renderer.text(a.text, 0, 0, a.useHTML).attr({
              align: a.align,
              "class": "highcharts-" + b,
              zIndex: a.zIndex || 4
            }).add(), k[b].update = function (a) {
              k.setTitle(!c && a, c && a);
            }, d || k[b].css(a.style));
          });
          k.layOutTitles(b);
        },
        layOutTitles: function layOutTitles(a) {
          var c = 0,
              b,
              h = this.renderer,
              d = this.spacingBox;
          ["title", "subtitle"].forEach(function (a) {
            var b = this[a],
                k = this.options[a];
            a = "title" === a ? -3 : k.verticalAlign ? 0 : c + 2;
            var e;
            b && (this.styledMode || (e = k.style.fontSize), e = h.fontMetrics(e, b).b, b.css({
              width: (k.width || d.width + k.widthAdjust) + "px"
            }).align(p({
              y: a + e
            }, k), !1, "spacingBox"), k.floating || k.verticalAlign || (c = Math.ceil(c + b.getBBox(k.useHTML).height)));
          }, this);
          b = this.titleOffset !== c;
          this.titleOffset = c;
          !this.isDirtyBox && b && (this.isDirtyBox = this.isDirtyLegend = b, this.hasRendered && k(a, !0) && this.isDirtyBox && this.redraw());
        },
        getChartSize: function getChartSize() {
          var c = this.options.chart,
              b = c.width,
              c = c.height,
              k = this.renderTo;
          e(b) || (this.containerWidth = a.getStyle(k, "width"));
          e(c) || (this.containerHeight = a.getStyle(k, "height"));
          this.chartWidth = Math.max(0, b || this.containerWidth || 600);
          this.chartHeight = Math.max(0, a.relativeLength(c, this.chartWidth) || (1 < this.containerHeight ? this.containerHeight : 400));
        },
        temporaryDisplay: function temporaryDisplay(c) {
          var b = this.renderTo;
          if (c) for (; b && b.style;) {
            b.hcOrigStyle && (a.css(b, b.hcOrigStyle), delete b.hcOrigStyle), b.hcOrigDetached && (g.body.removeChild(b), b.hcOrigDetached = !1), b = b.parentNode;
          } else for (; b && b.style;) {
            g.body.contains(b) || b.parentNode || (b.hcOrigDetached = !0, g.body.appendChild(b));
            if ("none" === a.getStyle(b, "display", !1) || b.hcOricDetached) b.hcOrigStyle = {
              display: b.style.display,
              height: b.style.height,
              overflow: b.style.overflow
            }, c = {
              display: "block",
              overflow: "hidden"
            }, b !== this.renderTo && (c.height = 0), a.css(b, c), b.offsetWidth || b.style.setProperty("display", "block", "important");
            b = b.parentNode;
            if (b === g.body) break;
          }
        },
        setClassName: function setClassName(a) {
          this.container.className = "highcharts-container " + (a || "");
        },
        getContainer: function getContainer() {
          var c,
              k = this.options,
              h = k.chart,
              e,
              n;
          c = this.renderTo;
          var r = a.uniqueKey(),
              z,
              D;
          c || (this.renderTo = c = h.renderTo);
          d(c) && (this.renderTo = c = g.getElementById(c));
          c || a.error(13, !0, this);
          e = x(m(c, "data-highcharts-chart"));
          l(e) && q[e] && q[e].hasRendered && q[e].destroy();
          m(c, "data-highcharts-chart", this.index);
          c.innerHTML = "";
          h.skipClone || c.offsetWidth || this.temporaryDisplay();
          this.getChartSize();
          e = this.chartWidth;
          n = this.chartHeight;
          f(c, {
            overflow: "hidden"
          });
          this.styledMode || (z = p({
            position: "relative",
            overflow: "hidden",
            width: e + "px",
            height: n + "px",
            textAlign: "left",
            lineHeight: "normal",
            zIndex: 0,
            "-webkit-tap-highlight-color": "rgba(0,0,0,0)"
          }, h.style));
          this.container = c = u("div", {
            id: r
          }, z, c);
          this._cursor = c.style.cursor;
          this.renderer = new (a[h.renderer] || a.Renderer)(c, e, n, null, h.forExport, k.exporting && k.exporting.allowHTML, this.styledMode);
          this.setClassName(h.className);
          if (this.styledMode) for (D in k.defs) {
            this.renderer.definition(k.defs[D]);
          } else this.renderer.setStyle(h.style);
          this.renderer.chartIndex = this.index;
          b(this, "afterGetContainer");
        },
        getMargins: function getMargins(a) {
          var c = this.spacing,
              k = this.margin,
              h = this.titleOffset;
          this.resetMargins();
          h && !e(k[0]) && (this.plotTop = Math.max(this.plotTop, h + this.options.title.margin + c[0]));
          this.legend && this.legend.display && this.legend.adjustMargins(k, c);
          b(this, "getMargins");
          a || this.getAxisMargins();
        },
        getAxisMargins: function getAxisMargins() {
          var a = this,
              c = a.axisOffset = [0, 0, 0, 0],
              b = a.margin;
          a.hasCartesianSeries && a.axes.forEach(function (a) {
            a.visible && a.getOffset();
          });
          E.forEach(function (k, h) {
            e(b[h]) || (a[k] += c[h]);
          });
          a.setChartSize();
        },
        reflow: function reflow(c) {
          var b = this,
              k = b.options.chart,
              h = b.renderTo,
              d = e(k.width) && e(k.height),
              x = k.width || a.getStyle(h, "width"),
              k = k.height || a.getStyle(h, "height"),
              h = c ? c.target : J;

          if (!d && !b.isPrinting && x && k && (h === J || h === g)) {
            if (x !== b.containerWidth || k !== b.containerHeight) a.clearTimeout(b.reflowTimeout), b.reflowTimeout = L(function () {
              b.container && b.setSize(void 0, void 0, !1);
            }, c ? 100 : 0);
            b.containerWidth = x;
            b.containerHeight = k;
          }
        },
        setReflow: function setReflow(a) {
          var c = this;
          !1 === a || this.unbindReflow ? !1 === a && this.unbindReflow && (this.unbindReflow = this.unbindReflow()) : (this.unbindReflow = B(J, "resize", function (a) {
            c.reflow(a);
          }), B(this, "destroy", this.unbindReflow));
        },
        setSize: function setSize(c, k, h) {
          var d = this,
              e = d.renderer,
              x;
          d.isResizing += 1;
          a.setAnimation(h, d);
          d.oldChartHeight = d.chartHeight;
          d.oldChartWidth = d.chartWidth;
          void 0 !== c && (d.options.chart.width = c);
          void 0 !== k && (d.options.chart.height = k);
          d.getChartSize();
          d.styledMode || (x = e.globalAnimation, (x ? A : f)(d.container, {
            width: d.chartWidth + "px",
            height: d.chartHeight + "px"
          }, x));
          d.setChartSize(!0);
          e.setSize(d.chartWidth, d.chartHeight, h);
          d.axes.forEach(function (a) {
            a.isDirty = !0;
            a.setScale();
          });
          d.isDirtyLegend = !0;
          d.isDirtyBox = !0;
          d.layOutTitles();
          d.getMargins();
          d.redraw(h);
          d.oldChartHeight = null;
          b(d, "resize");
          L(function () {
            d && b(d, "endResize", null, function () {
              --d.isResizing;
            });
          }, G(x).duration);
        },
        setChartSize: function setChartSize(a) {
          var c = this.inverted,
              k = this.renderer,
              h = this.chartWidth,
              d = this.chartHeight,
              e = this.options.chart,
              x = this.spacing,
              f = this.clipOffset,
              l,
              p,
              n,
              g;
          this.plotLeft = l = Math.round(this.plotLeft);
          this.plotTop = p = Math.round(this.plotTop);
          this.plotWidth = n = Math.max(0, Math.round(h - l - this.marginRight));
          this.plotHeight = g = Math.max(0, Math.round(d - p - this.marginBottom));
          this.plotSizeX = c ? g : n;
          this.plotSizeY = c ? n : g;
          this.plotBorderWidth = e.plotBorderWidth || 0;
          this.spacingBox = k.spacingBox = {
            x: x[3],
            y: x[0],
            width: h - x[3] - x[1],
            height: d - x[0] - x[2]
          };
          this.plotBox = k.plotBox = {
            x: l,
            y: p,
            width: n,
            height: g
          };
          h = 2 * Math.floor(this.plotBorderWidth / 2);
          c = Math.ceil(Math.max(h, f[3]) / 2);
          k = Math.ceil(Math.max(h, f[0]) / 2);
          this.clipBox = {
            x: c,
            y: k,
            width: Math.floor(this.plotSizeX - Math.max(h, f[1]) / 2 - c),
            height: Math.max(0, Math.floor(this.plotSizeY - Math.max(h, f[2]) / 2 - k))
          };
          a || this.axes.forEach(function (a) {
            a.setAxisSize();
            a.setAxisTranslation();
          });
          b(this, "afterSetChartSize", {
            skipAxes: a
          });
        },
        resetMargins: function resetMargins() {
          b(this, "resetMargins");
          var a = this,
              c = a.options.chart;
          ["margin", "spacing"].forEach(function (b) {
            var h = c[b],
                d = n(h) ? h : [h, h, h, h];
            ["Top", "Right", "Bottom", "Left"].forEach(function (h, e) {
              a[b][e] = k(c[b + h], d[e]);
            });
          });
          E.forEach(function (c, b) {
            a[c] = k(a.margin[b], a.spacing[b]);
          });
          a.axisOffset = [0, 0, 0, 0];
          a.clipOffset = [0, 0, 0, 0];
        },
        drawChartBox: function drawChartBox() {
          var a = this.options.chart,
              c = this.renderer,
              k = this.chartWidth,
              h = this.chartHeight,
              d = this.chartBackground,
              e = this.plotBackground,
              x = this.plotBorder,
              f,
              l = this.styledMode,
              p = this.plotBGImage,
              n = a.backgroundColor,
              g = a.plotBackgroundColor,
              z = a.plotBackgroundImage,
              r,
              D = this.plotLeft,
              q = this.plotTop,
              w = this.plotWidth,
              m = this.plotHeight,
              E = this.plotBox,
              F = this.clipRect,
              C = this.clipBox,
              t = "animate";
          d || (this.chartBackground = d = c.rect().addClass("highcharts-background").add(), t = "attr");
          if (l) f = r = d.strokeWidth();else {
            f = a.borderWidth || 0;
            r = f + (a.shadow ? 8 : 0);
            n = {
              fill: n || "none"
            };
            if (f || d["stroke-width"]) n.stroke = a.borderColor, n["stroke-width"] = f;
            d.attr(n).shadow(a.shadow);
          }
          d[t]({
            x: r / 2,
            y: r / 2,
            width: k - r - f % 2,
            height: h - r - f % 2,
            r: a.borderRadius
          });
          t = "animate";
          e || (t = "attr", this.plotBackground = e = c.rect().addClass("highcharts-plot-background").add());
          e[t](E);
          l || (e.attr({
            fill: g || "none"
          }).shadow(a.plotShadow), z && (p ? p.animate(E) : this.plotBGImage = c.image(z, D, q, w, m).add()));
          F ? F.animate({
            width: C.width,
            height: C.height
          }) : this.clipRect = c.clipRect(C);
          t = "animate";
          x || (t = "attr", this.plotBorder = x = c.rect().addClass("highcharts-plot-border").attr({
            zIndex: 1
          }).add());
          l || x.attr({
            stroke: a.plotBorderColor,
            "stroke-width": a.plotBorderWidth || 0,
            fill: "none"
          });
          x[t](x.crisp({
            x: D,
            y: q,
            width: w,
            height: m
          }, -x.strokeWidth()));
          this.isDirtyBox = !1;
          b(this, "afterDrawChartBox");
        },
        propFromSeries: function propFromSeries() {
          var a = this,
              c = a.options.chart,
              b,
              k = a.options.series,
              d,
              e;
          ["inverted", "angular", "polar"].forEach(function (x) {
            b = h[c.type || c.defaultSeriesType];
            e = c[x] || b && b.prototype[x];

            for (d = k && k.length; !e && d--;) {
              (b = h[k[d].type]) && b.prototype[x] && (e = !0);
            }

            a[x] = e;
          });
        },
        linkSeries: function linkSeries() {
          var a = this,
              c = a.series;
          c.forEach(function (a) {
            a.linkedSeries.length = 0;
          });
          c.forEach(function (c) {
            var b = c.options.linkedTo;
            d(b) && (b = ":previous" === b ? a.series[c.index - 1] : a.get(b)) && b.linkedParent !== c && (b.linkedSeries.push(c), c.linkedParent = b, c.visible = k(c.options.visible, b.options.visible, c.visible));
          });
          b(this, "afterLinkSeries");
        },
        renderSeries: function renderSeries() {
          this.series.forEach(function (a) {
            a.translate();
            a.render();
          });
        },
        renderLabels: function renderLabels() {
          var a = this,
              c = a.options.labels;
          c.items && c.items.forEach(function (b) {
            var k = p(c.style, b.style),
                h = x(k.left) + a.plotLeft,
                d = x(k.top) + a.plotTop + 12;
            delete k.left;
            delete k.top;
            a.renderer.text(b.html, h, d).attr({
              zIndex: 2
            }).css(k).add();
          });
        },
        render: function render() {
          var a = this.axes,
              c = this.renderer,
              b = this.options,
              k = 0,
              h,
              d,
              e;
          this.setTitle();
          this.legend = new w(this, b.legend);
          this.getStacks && this.getStacks();
          this.getMargins(!0);
          this.setChartSize();
          b = this.plotWidth;
          a.some(function (a) {
            if (a.horiz && a.visible && a.options.labels.enabled && a.series.length) return k = 21, !0;
          });
          h = this.plotHeight = Math.max(this.plotHeight - k, 0);
          a.forEach(function (a) {
            a.setScale();
          });
          this.getAxisMargins();
          d = 1.1 < b / this.plotWidth;
          e = 1.05 < h / this.plotHeight;
          if (d || e) a.forEach(function (a) {
            (a.horiz && d || !a.horiz && e) && a.setTickInterval(!0);
          }), this.getMargins();
          this.drawChartBox();
          this.hasCartesianSeries && a.forEach(function (a) {
            a.visible && a.render();
          });
          this.seriesGroup || (this.seriesGroup = c.g("series-group").attr({
            zIndex: 3
          }).add());
          this.renderSeries();
          this.renderLabels();
          this.addCredits();
          this.setResponsive && this.setResponsive();
          this.hasRendered = !0;
        },
        addCredits: function addCredits(a) {
          var c = this;
          a = C(!0, this.options.credits, a);
          a.enabled && !this.credits && (this.credits = this.renderer.text(a.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function () {
            a.href && (J.location.href = a.href);
          }).attr({
            align: a.position.align,
            zIndex: 8
          }), c.styledMode || this.credits.css(a.style), this.credits.add().align(a.position), this.credits.update = function (a) {
            c.credits = c.credits.destroy();
            c.addCredits(a);
          });
        },
        destroy: function destroy() {
          var c = this,
              k = c.axes,
              h = c.series,
              d = c.container,
              e,
              x = d && d.parentNode;
          b(c, "destroy");
          c.renderer.forExport ? a.erase(q, c) : q[c.index] = void 0;
          a.chartCount--;
          c.renderTo.removeAttribute("data-highcharts-chart");
          D(c);

          for (e = k.length; e--;) {
            k[e] = k[e].destroy();
          }

          this.scroller && this.scroller.destroy && this.scroller.destroy();

          for (e = h.length; e--;) {
            h[e] = h[e].destroy();
          }

          "title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function (a) {
            var b = c[a];
            b && b.destroy && (c[a] = b.destroy());
          });
          d && (d.innerHTML = "", D(d), x && y(d));
          F(c, function (a, b) {
            delete c[b];
          });
        },
        firstRender: function firstRender() {
          var k = this,
              h = k.options;

          if (!k.isReadyToRender || k.isReadyToRender()) {
            k.getContainer();
            k.resetMargins();
            k.setChartSize();
            k.propFromSeries();
            k.getAxes();
            (a.isArray(h.series) ? h.series : []).forEach(function (a) {
              k.initSeries(a);
            });
            k.linkSeries();
            b(k, "beforeRender");
            c && (k.pointer = new c(k, h));
            k.render();
            if (!k.renderer.imgCount && k.onload) k.onload();
            k.temporaryDisplay(!0);
          }
        },
        onload: function onload() {
          [this.callback].concat(this.callbacks).forEach(function (a) {
            a && void 0 !== this.index && a.apply(this, [this]);
          }, this);
          b(this, "load");
          b(this, "render");
          e(this.index) && this.setReflow(this.options.chart.reflow);
          this.onload = null;
        }
      });
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.Chart;
      B(A, "afterSetChartSize", function (A) {
        var m = this.options.chart.scrollablePlotArea;
        (m = m && m.minWidth) && !this.renderer.forExport && (this.scrollablePixels = m = Math.max(0, m - this.chartWidth)) && (this.plotWidth += m, this.clipBox.width += m, A.skipAxes || this.axes.forEach(function (g) {
          1 === g.side ? g.getPlotLinePath = function () {
            var m = this.right,
                u;
            this.right = m - g.chart.scrollablePixels;
            u = a.Axis.prototype.getPlotLinePath.apply(this, arguments);
            this.right = m;
            return u;
          } : (g.setAxisSize(), g.setAxisTranslation());
        }));
      });
      B(A, "render", function () {
        this.scrollablePixels ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
      });

      A.prototype.setUpScrolling = function () {
        this.scrollingContainer = a.createElement("div", {
          className: "highcharts-scrolling"
        }, {
          overflowX: "auto",
          WebkitOverflowScrolling: "touch"
        }, this.renderTo);
        this.innerContainer = a.createElement("div", {
          className: "highcharts-inner-container"
        }, null, this.scrollingContainer);
        this.innerContainer.appendChild(this.container);
        this.setUpScrolling = null;
      };

      A.prototype.applyFixed = function () {
        var A = this.container,
            m,
            g,
            t = !this.fixedDiv;
        t && (this.fixedDiv = a.createElement("div", {
          className: "highcharts-fixed"
        }, {
          position: "absolute",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2
        }, null, !0), this.renderTo.insertBefore(this.fixedDiv, this.renderTo.firstChild), this.renderTo.style.overflow = "visible", this.fixedRenderer = m = new a.Renderer(this.fixedDiv, 0, 0), this.scrollableMask = m.path().attr({
          fill: a.color(this.options.chart.backgroundColor || "#fff").setOpacity(.85).get(),
          zIndex: -1
        }).addClass("highcharts-scrollable-mask").add(), [this.inverted ? ".highcharts-xaxis" : ".highcharts-yaxis", this.inverted ? ".highcharts-xaxis-labels" : ".highcharts-yaxis-labels", ".highcharts-contextbutton", ".highcharts-credits", ".highcharts-legend", ".highcharts-subtitle", ".highcharts-title", ".highcharts-legend-checkbox"].forEach(function (a) {
          [].forEach.call(A.querySelectorAll(a), function (a) {
            (a.namespaceURI === m.SVG_NS ? m.box : m.box.parentNode).appendChild(a);
            a.style.pointerEvents = "auto";
          });
        }));
        this.fixedRenderer.setSize(this.chartWidth, this.chartHeight);
        g = this.chartWidth + this.scrollablePixels;
        a.stop(this.container);
        this.container.style.width = g + "px";
        this.renderer.boxWrapper.attr({
          width: g,
          height: this.chartHeight,
          viewBox: [0, 0, g, this.chartHeight].join(" ")
        });
        this.chartBackground.attr({
          width: g
        });
        t && (g = this.options.chart.scrollablePlotArea, g.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixels * g.scrollPositionX));
        t = this.axisOffset;
        g = this.plotTop - t[0] - 1;
        var t = this.plotTop + this.plotHeight + t[2],
            u = this.plotLeft + this.plotWidth - this.scrollablePixels;
        this.scrollableMask.attr({
          d: this.scrollablePixels ? ["M", 0, g, "L", this.plotLeft - 1, g, "L", this.plotLeft - 1, t, "L", 0, t, "Z", "M", u, g, "L", this.chartWidth, g, "L", this.chartWidth, t, "L", u, t, "Z"] : ["M", 0, 0]
        });
      };
    })(H);

    (function (a) {
      var B,
          A = a.extend,
          G = a.erase,
          m = a.fireEvent,
          g = a.format,
          t = a.isArray,
          u = a.isNumber,
          v = a.pick,
          y = a.uniqueKey,
          q = a.defined,
          f = a.removeEvent;

      a.Point = B = function B() {};

      a.Point.prototype = {
        init: function init(a, f, g) {
          var b;
          b = a.chart.options.chart.colorCount;
          var e = a.chart.styledMode;
          this.series = a;
          e || (this.color = a.color);
          this.applyOptions(f, g);
          this.id = q(this.id) ? this.id : y();
          a.options.colorByPoint ? (e || (b = a.options.colors || a.chart.options.colors, this.color = this.color || b[a.colorCounter], b = b.length), f = a.colorCounter, a.colorCounter++, a.colorCounter === b && (a.colorCounter = 0)) : f = a.colorIndex;
          this.colorIndex = v(this.colorIndex, f);
          a.chart.pointCount++;
          m(this, "afterInit");
          return this;
        },
        applyOptions: function applyOptions(a, f) {
          var e = this.series,
              b = e.options.pointValKey || e.pointValKey;
          a = B.prototype.optionsToObject.call(this, a);
          A(this, a);
          this.options = this.options ? A(this.options, a) : a;
          a.group && delete this.group;
          a.dataLabels && delete this.dataLabels;
          b && (this.y = this[b]);
          this.isNull = v(this.isValid && !this.isValid(), null === this.x || !u(this.y, !0));
          this.selected && (this.state = "select");
          "name" in this && void 0 === f && e.xAxis && e.xAxis.hasNames && (this.x = e.xAxis.nameToX(this));
          void 0 === this.x && e && (this.x = void 0 === f ? e.autoIncrement(this) : f);
          return this;
        },
        setNestedProperty: function setNestedProperty(e, f, g) {
          g.split(".").reduce(function (b, e, p, d) {
            b[e] = d.length - 1 === p ? f : a.isObject(b[e], !0) ? b[e] : {};
            return b[e];
          }, e);
          return e;
        },
        optionsToObject: function optionsToObject(e) {
          var f = {},
              g = this.series,
              b = g.options.keys,
              l = b || g.pointArrayMap || ["y"],
              n = l.length,
              d = 0,
              q = 0;
          if (u(e) || null === e) f[l[0]] = e;else if (t(e)) for (!b && e.length > n && (g = typeof e[0], "string" === g ? f.name = e[0] : "number" === g && (f.x = e[0]), d++); q < n;) {
            b && void 0 === e[d] || (0 < l[q].indexOf(".") ? a.Point.prototype.setNestedProperty(f, e[d], l[q]) : f[l[q]] = e[d]), d++, q++;
          } else "object" === typeof e && (f = e, e.dataLabels && (g._hasPointLabels = !0), e.marker && (g._hasPointMarkers = !0));
          return f;
        },
        getClassName: function getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (void 0 !== this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        },
        getZone: function getZone() {
          var a = this.series,
              f = a.zones,
              a = a.zoneAxis || "y",
              g = 0,
              b;

          for (b = f[g]; this[a] >= b.value;) {
            b = f[++g];
          }

          this.nonZonedColor || (this.nonZonedColor = this.color);
          this.color = b && b.color && !this.options.color ? b.color : this.nonZonedColor;
          return b;
        },
        destroy: function destroy() {
          var a = this.series.chart,
              p = a.hoverPoints,
              g;
          a.pointCount--;
          p && (this.setState(), G(p, this), p.length || (a.hoverPoints = null));
          if (this === a.hoverPoint) this.onMouseOut();
          if (this.graphic || this.dataLabel || this.dataLabels) f(this), this.destroyElements();
          this.legendItem && a.legend.destroyItem(this);

          for (g in this) {
            this[g] = null;
          }
        },
        destroyElements: function destroyElements() {
          for (var a = ["graphic", "dataLabel", "dataLabelUpper", "connector", "shadowGroup"], f, g = 6; g--;) {
            f = a[g], this[f] && (this[f] = this[f].destroy());
          }

          this.dataLabels && (this.dataLabels.forEach(function (a) {
            a.element && a.destroy();
          }), delete this.dataLabels);
          this.connectors && (this.connectors.forEach(function (a) {
            a.element && a.destroy();
          }), delete this.connectors);
        },
        getLabelConfig: function getLabelConfig() {
          return {
            x: this.category,
            y: this.y,
            color: this.color,
            colorIndex: this.colorIndex,
            key: this.name || this.category,
            series: this.series,
            point: this,
            percentage: this.percentage,
            total: this.total || this.stackTotal
          };
        },
        tooltipFormatter: function tooltipFormatter(a) {
          var e = this.series,
              f = e.tooltipOptions,
              b = v(f.valueDecimals, ""),
              l = f.valuePrefix || "",
              n = f.valueSuffix || "";
          e.chart.styledMode && (a = e.chart.tooltip.styledModeFormat(a));
          (e.pointArrayMap || ["y"]).forEach(function (d) {
            d = "{point." + d;
            if (l || n) a = a.replace(RegExp(d + "}", "g"), l + d + "}" + n);
            a = a.replace(RegExp(d + "}", "g"), d + ":,." + b + "f}");
          });
          return g(a, {
            point: this,
            series: this.series
          }, e.chart.time);
        },
        firePointEvent: function firePointEvent(a, f, g) {
          var b = this,
              e = this.series.options;
          (e.point.events[a] || b.options && b.options.events && b.options.events[a]) && this.importEvents();
          "click" === a && e.allowPointSelect && (g = function g(a) {
            b.select && b.select(null, a.ctrlKey || a.metaKey || a.shiftKey);
          });
          m(this, a, f, g);
        },
        visible: !0
      };
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.animObject,
          G = a.arrayMax,
          m = a.arrayMin,
          g = a.correctFloat,
          t = a.defaultOptions,
          u = a.defaultPlotOptions,
          v = a.defined,
          y = a.erase,
          q = a.extend,
          f = a.fireEvent,
          e = a.isArray,
          p = a.isNumber,
          r = a.isString,
          b = a.merge,
          l = a.objectEach,
          n = a.pick,
          d = a.removeEvent,
          w = a.splat,
          E = a.SVGElement,
          C = a.syncTimeout,
          F = a.win;
      a.Series = a.seriesType("line", null, {
        lineWidth: 2,
        allowPointSelect: !1,
        showCheckbox: !1,
        animation: {
          duration: 1E3
        },
        events: {},
        marker: {
          lineWidth: 0,
          lineColor: "#ffffff",
          enabledThreshold: 2,
          radius: 4,
          states: {
            normal: {
              animation: !0
            },
            hover: {
              animation: {
                duration: 50
              },
              enabled: !0,
              radiusPlus: 2,
              lineWidthPlus: 1
            },
            select: {
              fillColor: "#cccccc",
              lineColor: "#000000",
              lineWidth: 2
            }
          }
        },
        point: {
          events: {}
        },
        dataLabels: {
          align: "center",
          formatter: function formatter() {
            return null === this.y ? "" : a.numberFormat(this.y, -1);
          },
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0,
          padding: 5
        },
        cropThreshold: 300,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: .25
            }
          },
          select: {
            animation: {
              duration: 0
            }
          }
        },
        stickyTracking: !0,
        turboThreshold: 1E3,
        findNearestPointBy: "x"
      }, {
        isCartesian: !0,
        pointClass: a.Point,
        sorted: !0,
        requireSorting: !0,
        directTouch: !1,
        axisTypes: ["xAxis", "yAxis"],
        colorCounter: 0,
        parallelArrays: ["x", "y"],
        coll: "series",
        cropShoulder: 1,
        init: function init(a, b) {
          f(this, "init", {
            options: b
          });
          var c = this,
              k,
              h = a.series,
              d;
          c.chart = a;
          c.options = b = c.setOptions(b);
          c.linkedSeries = [];
          c.bindAxes();
          q(c, {
            name: b.name,
            state: "",
            visible: !1 !== b.visible,
            selected: !0 === b.selected
          });
          k = b.events;
          l(k, function (a, b) {
            c.hcEvents && c.hcEvents[b] && -1 !== c.hcEvents[b].indexOf(a) || B(c, b, a);
          });
          if (k && k.click || b.point && b.point.events && b.point.events.click || b.allowPointSelect) a.runTrackerClick = !0;
          c.getColor();
          c.getSymbol();
          c.parallelArrays.forEach(function (a) {
            c[a + "Data"] = [];
          });
          c.setData(b.data, !1);
          c.isCartesian && (a.hasCartesianSeries = !0);
          h.length && (d = h[h.length - 1]);
          c._i = n(d && d._i, -1) + 1;
          a.orderSeries(this.insert(h));
          f(this, "afterInit");
        },
        insert: function insert(a) {
          var c = this.options.index,
              b;

          if (p(c)) {
            for (b = a.length; b--;) {
              if (c >= n(a[b].options.index, a[b]._i)) {
                a.splice(b + 1, 0, this);
                break;
              }
            }

            -1 === b && a.unshift(this);
            b += 1;
          } else a.push(this);

          return n(b, a.length - 1);
        },
        bindAxes: function bindAxes() {
          var c = this,
              b = c.options,
              d = c.chart,
              e;
          f(this, "bindAxes", null, function () {
            (c.axisTypes || []).forEach(function (k) {
              d[k].forEach(function (a) {
                e = a.options;
                if (b[k] === e.index || void 0 !== b[k] && b[k] === e.id || void 0 === b[k] && 0 === e.index) c.insert(a.series), c[k] = a, a.isDirty = !0;
              });
              c[k] || c.optionalAxis === k || a.error(18, !0, d);
            });
          });
        },
        updateParallelArrays: function updateParallelArrays(a, b) {
          var c = a.series,
              k = arguments,
              h = p(b) ? function (k) {
            var h = "y" === k && c.toYData ? c.toYData(a) : a[k];
            c[k + "Data"][b] = h;
          } : function (a) {
            Array.prototype[b].apply(c[a + "Data"], Array.prototype.slice.call(k, 2));
          };
          c.parallelArrays.forEach(h);
        },
        autoIncrement: function autoIncrement() {
          var a = this.options,
              b = this.xIncrement,
              d,
              e = a.pointIntervalUnit,
              h = this.chart.time,
              b = n(b, a.pointStart, 0);
          this.pointInterval = d = n(this.pointInterval, a.pointInterval, 1);
          e && (a = new h.Date(b), "day" === e ? h.set("Date", a, h.get("Date", a) + d) : "month" === e ? h.set("Month", a, h.get("Month", a) + d) : "year" === e && h.set("FullYear", a, h.get("FullYear", a) + d), d = a.getTime() - b);
          this.xIncrement = b + d;
          return b;
        },
        setOptions: function setOptions(a) {
          var c = this.chart,
              d = c.options,
              e = d.plotOptions,
              h = (c.userOptions || {}).plotOptions || {},
              l = e[this.type],
              g = b(a);
          a = c.styledMode;
          f(this, "setOptions", {
            userOptions: g
          });
          this.userOptions = g;
          c = b(l, e.series, g);
          this.tooltipOptions = b(t.tooltip, t.plotOptions.series && t.plotOptions.series.tooltip, t.plotOptions[this.type].tooltip, d.tooltip.userOptions, e.series && e.series.tooltip, e[this.type].tooltip, g.tooltip);
          this.stickyTracking = n(g.stickyTracking, h[this.type] && h[this.type].stickyTracking, h.series && h.series.stickyTracking, this.tooltipOptions.shared && !this.noSharedTooltip ? !0 : c.stickyTracking);
          null === l.marker && delete c.marker;
          this.zoneAxis = c.zoneAxis;
          d = this.zones = (c.zones || []).slice();
          !c.negativeColor && !c.negativeFillColor || c.zones || (e = {
            value: c[this.zoneAxis + "Threshold"] || c.threshold || 0,
            className: "highcharts-negative"
          }, a || (e.color = c.negativeColor, e.fillColor = c.negativeFillColor), d.push(e));
          d.length && v(d[d.length - 1].value) && d.push(a ? {} : {
            color: this.color,
            fillColor: this.fillColor
          });
          f(this, "afterSetOptions", {
            options: c
          });
          return c;
        },
        getName: function getName() {
          return n(this.options.name, "Series " + (this.index + 1));
        },
        getCyclic: function getCyclic(a, b, d) {
          var c,
              k = this.chart,
              e = this.userOptions,
              f = a + "Index",
              x = a + "Counter",
              l = d ? d.length : n(k.options.chart[a + "Count"], k[a + "Count"]);
          b || (c = n(e[f], e["_" + f]), v(c) || (k.series.length || (k[x] = 0), e["_" + f] = c = k[x] % l, k[x] += 1), d && (b = d[c]));
          void 0 !== c && (this[f] = c);
          this[a] = b;
        },
        getColor: function getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.options.color = null : this.getCyclic("color", this.options.color || u[this.type].color, this.chart.options.colors);
        },
        getSymbol: function getSymbol() {
          this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
        },
        drawLegendSymbol: a.LegendSymbolMixin.drawLineMarker,
        updateData: function updateData(c) {
          var b = this.options,
              d = this.points,
              e = [],
              h,
              f,
              l,
              g = this.requireSorting;
          this.xIncrement = null;
          c.forEach(function (c) {
            var k, f, x;
            k = a.defined(c) && this.pointClass.prototype.optionsToObject.call({
              series: this
            }, c) || {};
            x = k.x;
            if ((k = k.id) || p(x)) k && (f = (f = this.chart.get(k)) && f.index), void 0 === f && p(x) && (f = this.xData.indexOf(x, l)), -1 !== f && void 0 !== f && this.cropped && (f = f >= this.cropStart ? f - this.cropStart : f), -1 === f || void 0 === f || d[f] && d[f].touched ? e.push(c) : c !== b.data[f] ? (d[f].update(c, !1, null, !1), d[f].touched = !0, g && (l = f + 1)) : d[f] && (d[f].touched = !0), h = !0;
          }, this);
          if (h) for (c = d.length; c--;) {
            f = d[c], f.touched || f.remove(!1), f.touched = !1;
          } else if (c.length === d.length) c.forEach(function (a, c) {
            d[c].update && a !== b.data[c] && d[c].update(a, !1, null, !1);
          });else return !1;
          e.forEach(function (a) {
            this.addPoint(a, !1);
          }, this);
          return !0;
        },
        setData: function setData(c, b, d, f) {
          var k = this,
              l = k.points,
              x = l && l.length || 0,
              g,
              q = k.options,
              w = k.chart,
              D = null,
              m = k.xAxis,
              E = q.turboThreshold,
              F = this.xData,
              C = this.yData,
              t = (g = k.pointArrayMap) && g.length,
              v = q.keys,
              u = 0,
              y = 1,
              A;
          c = c || [];
          g = c.length;
          b = n(b, !0);
          !1 !== f && g && x && !k.cropped && !k.hasGroupedData && k.visible && !k.isSeriesBoosting && (A = this.updateData(c));

          if (!A) {
            k.xIncrement = null;
            k.colorCounter = 0;
            this.parallelArrays.forEach(function (a) {
              k[a + "Data"].length = 0;
            });

            if (E && g > E) {
              for (d = 0; null === D && d < g;) {
                D = c[d], d++;
              }

              if (p(D)) for (d = 0; d < g; d++) {
                F[d] = this.autoIncrement(), C[d] = c[d];
              } else if (e(D)) {
                if (t) for (d = 0; d < g; d++) {
                  D = c[d], F[d] = D[0], C[d] = D.slice(1, t + 1);
                } else for (v && (u = v.indexOf("x"), y = v.indexOf("y"), u = 0 <= u ? u : 0, y = 0 <= y ? y : 1), d = 0; d < g; d++) {
                  D = c[d], F[d] = D[u], C[d] = D[y];
                }
              } else a.error(12, !1, w);
            } else for (d = 0; d < g; d++) {
              void 0 !== c[d] && (D = {
                series: k
              }, k.pointClass.prototype.applyOptions.apply(D, [c[d]]), k.updateParallelArrays(D, d));
            }

            C && r(C[0]) && a.error(14, !0, w);
            k.data = [];
            k.options.data = k.userOptions.data = c;

            for (d = x; d--;) {
              l[d] && l[d].destroy && l[d].destroy();
            }

            m && (m.minRange = m.userMinRange);
            k.isDirty = w.isDirtyBox = !0;
            k.isDirtyData = !!l;
            d = !1;
          }

          "point" === q.legendType && (this.processData(), this.generatePoints());
          b && w.redraw(d);
        },
        processData: function processData(c) {
          var b = this.xData,
              d = this.yData,
              e = b.length,
              h;
          h = 0;
          var f,
              l,
              g = this.xAxis,
              n,
              p = this.options;
          n = p.cropThreshold;
          var q = this.getExtremesFromAll || p.getExtremesFromAll,
              w = this.isCartesian,
              p = g && g.val2lin,
              r = g && g.isLog,
              m = this.requireSorting,
              E,
              F;
          if (w && !this.isDirty && !g.isDirty && !this.yAxis.isDirty && !c) return !1;
          g && (c = g.getExtremes(), E = c.min, F = c.max);
          w && this.sorted && !q && (!n || e > n || this.forceCrop) && (b[e - 1] < E || b[0] > F ? (b = [], d = []) : this.yData && (b[0] < E || b[e - 1] > F) && (h = this.cropData(this.xData, this.yData, E, F), b = h.xData, d = h.yData, h = h.start, f = !0));

          for (n = b.length || 1; --n;) {
            e = r ? p(b[n]) - p(b[n - 1]) : b[n] - b[n - 1], 0 < e && (void 0 === l || e < l) ? l = e : 0 > e && m && (a.error(15, !1, this.chart), m = !1);
          }

          this.cropped = f;
          this.cropStart = h;
          this.processedXData = b;
          this.processedYData = d;
          this.closestPointRange = l;
        },
        cropData: function cropData(a, b, d, e, h) {
          var c = a.length,
              k = 0,
              f = c,
              l;
          h = n(h, this.cropShoulder);

          for (l = 0; l < c; l++) {
            if (a[l] >= d) {
              k = Math.max(0, l - h);
              break;
            }
          }

          for (d = l; d < c; d++) {
            if (a[d] > e) {
              f = d + h;
              break;
            }
          }

          return {
            xData: a.slice(k, f),
            yData: b.slice(k, f),
            start: k,
            end: f
          };
        },
        generatePoints: function generatePoints() {
          var a = this.options,
              b = a.data,
              d = this.data,
              e,
              h = this.processedXData,
              l = this.processedYData,
              g = this.pointClass,
              n = h.length,
              p = this.cropStart || 0,
              r,
              m = this.hasGroupedData,
              a = a.keys,
              E,
              F = [],
              C;
          d || m || (d = [], d.length = b.length, d = this.data = d);
          a && m && (this.options.keys = !1);

          for (C = 0; C < n; C++) {
            r = p + C, m ? (E = new g().init(this, [h[C]].concat(w(l[C]))), E.dataGroup = this.groupMap[C], E.dataGroup.options && (E.options = E.dataGroup.options, q(E, E.dataGroup.options), delete E.dataLabels)) : (E = d[r]) || void 0 === b[r] || (d[r] = E = new g().init(this, b[r], h[C])), E && (E.index = r, F[C] = E);
          }

          this.options.keys = a;
          if (d && (n !== (e = d.length) || m)) for (C = 0; C < e; C++) {
            C !== p || m || (C += n), d[C] && (d[C].destroyElements(), d[C].plotX = void 0);
          }
          this.data = d;
          this.points = F;
          f(this, "afterGeneratePoints");
        },
        getExtremes: function getExtremes(a) {
          var c = this.yAxis,
              b = this.processedXData,
              d,
              h = [],
              l = 0;
          d = this.xAxis.getExtremes();
          var g = d.min,
              n = d.max,
              q,
              w,
              r = this.requireSorting ? this.cropShoulder : 0,
              E,
              F;
          a = a || this.stackedYData || this.processedYData || [];
          d = a.length;

          for (F = 0; F < d; F++) {
            if (w = b[F], E = a[F], q = (p(E, !0) || e(E)) && (!c.positiveValuesOnly || E.length || 0 < E), w = this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || (b[F + r] || w) >= g && (b[F - r] || w) <= n, q && w) if (q = E.length) for (; q--;) {
              "number" === typeof E[q] && (h[l++] = E[q]);
            } else h[l++] = E;
          }

          this.dataMin = m(h);
          this.dataMax = G(h);
          f(this, "afterGetExtremes");
        },
        translate: function translate() {
          this.processedXData || this.processData();
          this.generatePoints();
          var a = this.options,
              b = a.stacking,
              d = this.xAxis,
              e = d.categories,
              h = this.yAxis,
              l = this.points,
              q = l.length,
              w = !!this.modifyValue,
              r,
              m = this.pointPlacementToXValue(),
              E = p(m),
              F = a.threshold,
              C = a.startFromThreshold ? F : 0,
              t,
              u,
              y,
              A,
              B = this.zoneAxis || "y",
              G = Number.MAX_VALUE;

          for (r = 0; r < q; r++) {
            var M = l[r],
                V = M.x,
                N = M.y;
            u = M.low;
            var H = b && h.stacks[(this.negStacks && N < (C ? 0 : F) ? "-" : "") + this.stackKey],
                X;
            h.positiveValuesOnly && null !== N && 0 >= N && (M.isNull = !0);
            M.plotX = t = g(Math.min(Math.max(-1E5, d.translate(V, 0, 0, 0, 1, m, "flags" === this.type)), 1E5));
            b && this.visible && !M.isNull && H && H[V] && (A = this.getStackIndicator(A, V, this.index), X = H[V], N = X.points[A.key], u = N[0], N = N[1], u === C && A.key === H[V].base && (u = n(p(F) && F, h.min)), h.positiveValuesOnly && 0 >= u && (u = null), M.total = M.stackTotal = X.total, M.percentage = X.total && M.y / X.total * 100, M.stackY = N, X.setOffset(this.pointXOffset || 0, this.barW || 0));
            M.yBottom = v(u) ? Math.min(Math.max(-1E5, h.translate(u, 0, 1, 0, 1)), 1E5) : null;
            w && (N = this.modifyValue(N, M));
            M.plotY = u = "number" === typeof N && Infinity !== N ? Math.min(Math.max(-1E5, h.translate(N, 0, 1, 0, 1)), 1E5) : void 0;
            M.isInside = void 0 !== u && 0 <= u && u <= h.len && 0 <= t && t <= d.len;
            M.clientX = E ? g(d.translate(V, 0, 0, 0, 1, m)) : t;
            M.negative = M[B] < (a[B + "Threshold"] || F || 0);
            M.category = e && void 0 !== e[M.x] ? e[M.x] : M.x;
            M.isNull || (void 0 !== y && (G = Math.min(G, Math.abs(t - y))), y = t);
            M.zone = this.zones.length && M.getZone();
          }

          this.closestPointRangePx = G;
          f(this, "afterTranslate");
        },
        getValidPoints: function getValidPoints(a, b, d) {
          var c = this.chart;
          return (a || this.points || []).filter(function (a) {
            return b && !c.isInsidePlot(a.plotX, a.plotY, c.inverted) ? !1 : d || !a.isNull;
          });
        },
        setClip: function setClip(a) {
          var c = this.chart,
              b = this.options,
              d = c.renderer,
              h = c.inverted,
              e = this.clipBox,
              f = e || c.clipBox,
              l = this.sharedClipKey || ["_sharedClip", a && a.duration, a && a.easing, f.height, b.xAxis, b.yAxis].join(),
              g = c[l],
              n = c[l + "m"];
          g || (a && (f.width = 0, h && (f.x = c.plotSizeX), c[l + "m"] = n = d.clipRect(h ? c.plotSizeX + 99 : -99, h ? -c.plotLeft : -c.plotTop, 99, h ? c.chartWidth : c.chartHeight)), c[l] = g = d.clipRect(f), g.count = {
            length: 0
          });
          a && !g.count[this.index] && (g.count[this.index] = !0, g.count.length += 1);
          !1 !== b.clip && (this.group.clip(a || e ? g : c.clipRect), this.markerGroup.clip(n), this.sharedClipKey = l);
          a || (g.count[this.index] && (delete g.count[this.index], --g.count.length), 0 === g.count.length && l && c[l] && (e || (c[l] = c[l].destroy()), c[l + "m"] && (c[l + "m"] = c[l + "m"].destroy())));
        },
        animate: function animate(a) {
          var c = this.chart,
              b = A(this.options.animation),
              d;
          a ? this.setClip(b) : (d = this.sharedClipKey, (a = c[d]) && a.animate({
            width: c.plotSizeX,
            x: 0
          }, b), c[d + "m"] && c[d + "m"].animate({
            width: c.plotSizeX + 99,
            x: 0
          }, b), this.animate = null);
        },
        afterAnimate: function afterAnimate() {
          this.setClip();
          f(this, "afterAnimate");
          this.finishedAnimating = !0;
        },
        drawPoints: function drawPoints() {
          var a = this.points,
              b = this.chart,
              d,
              e,
              h,
              f,
              l = this.options.marker,
              g,
              p,
              q,
              w = this[this.specialGroup] || this.markerGroup;
          d = this.xAxis;
          var r,
              m = n(l.enabled, !d || d.isRadial ? !0 : null, this.closestPointRangePx >= l.enabledThreshold * l.radius);
          if (!1 !== l.enabled || this._hasPointMarkers) for (d = 0; d < a.length; d++) {
            e = a[d], f = e.graphic, g = e.marker || {}, p = !!e.marker, h = m && void 0 === g.enabled || g.enabled, q = !1 !== e.isInside, h && !e.isNull ? (h = n(g.symbol, this.symbol), r = this.markerAttribs(e, e.selected && "select"), f ? f[q ? "show" : "hide"](!0).animate(r) : q && (0 < r.width || e.hasImage) && (e.graphic = f = b.renderer.symbol(h, r.x, r.y, r.width, r.height, p ? g : l).add(w)), f && !b.styledMode && f.attr(this.pointAttribs(e, e.selected && "select")), f && f.addClass(e.getClassName(), !0)) : f && (e.graphic = f.destroy());
          }
        },
        markerAttribs: function markerAttribs(a, b) {
          var c = this.options.marker,
              k = a.marker || {},
              h = k.symbol || c.symbol,
              d = n(k.radius, c.radius);
          b && (c = c.states[b], b = k.states && k.states[b], d = n(b && b.radius, c && c.radius, d + (c && c.radiusPlus || 0)));
          a.hasImage = h && 0 === h.indexOf("url");
          a.hasImage && (d = 0);
          a = {
            x: Math.floor(a.plotX) - d,
            y: a.plotY - d
          };
          d && (a.width = a.height = 2 * d);
          return a;
        },
        pointAttribs: function pointAttribs(a, b) {
          var c = this.options.marker,
              k = a && a.options,
              h = k && k.marker || {},
              d = this.color,
              e = k && k.color,
              f = a && a.color,
              k = n(h.lineWidth, c.lineWidth);
          a = a && a.zone && a.zone.color;
          d = e || a || f || d;
          a = h.fillColor || c.fillColor || d;
          d = h.lineColor || c.lineColor || d;
          b && (c = c.states[b], b = h.states && h.states[b] || {}, k = n(b.lineWidth, c.lineWidth, k + n(b.lineWidthPlus, c.lineWidthPlus, 0)), a = b.fillColor || c.fillColor || a, d = b.lineColor || c.lineColor || d);
          return {
            stroke: d,
            "stroke-width": k,
            fill: a
          };
        },
        destroy: function destroy(c) {
          var b = this,
              e = b.chart,
              g = /AppleWebKit\/533/.test(F.navigator.userAgent),
              h,
              n,
              p = b.data || [],
              q,
              w;
          f(b, "destroy");
          c || d(b);
          (b.axisTypes || []).forEach(function (a) {
            (w = b[a]) && w.series && (y(w.series, b), w.isDirty = w.forceRedraw = !0);
          });
          b.legendItem && b.chart.legend.destroyItem(b);

          for (n = p.length; n--;) {
            (q = p[n]) && q.destroy && q.destroy();
          }

          b.points = null;
          a.clearTimeout(b.animationTimeout);
          l(b, function (a, c) {
            a instanceof E && !a.survive && (h = g && "group" === c ? "hide" : "destroy", a[h]());
          });
          e.hoverSeries === b && (e.hoverSeries = null);
          y(e.series, b);
          e.orderSeries();
          l(b, function (a, k) {
            c && "hcEvents" === k || delete b[k];
          });
        },
        getGraphPath: function getGraphPath(a, b, d) {
          var c = this,
              k = c.options,
              e = k.step,
              f,
              l = [],
              g = [],
              n;
          a = a || c.points;
          (f = a.reversed) && a.reverse();
          (e = {
            right: 1,
            center: 2
          }[e] || e && 3) && f && (e = 4 - e);
          !k.connectNulls || b || d || (a = this.getValidPoints(a));
          a.forEach(function (h, f) {
            var x = h.plotX,
                p = h.plotY,
                q = a[f - 1];
            (h.leftCliff || q && q.rightCliff) && !d && (n = !0);
            h.isNull && !v(b) && 0 < f ? n = !k.connectNulls : h.isNull && !b ? n = !0 : (0 === f || n ? f = ["M", h.plotX, h.plotY] : c.getPointSpline ? f = c.getPointSpline(a, h, f) : e ? (f = 1 === e ? ["L", q.plotX, p] : 2 === e ? ["L", (q.plotX + x) / 2, q.plotY, "L", (q.plotX + x) / 2, p] : ["L", x, q.plotY], f.push("L", x, p)) : f = ["L", x, p], g.push(h.x), e && (g.push(h.x), 2 === e && g.push(h.x)), l.push.apply(l, f), n = !1);
          });
          l.xMap = g;
          return c.graphPath = l;
        },
        drawGraph: function drawGraph() {
          var a = this,
              b = this.options,
              d = (this.gappedPath || this.getGraphPath).call(this),
              e = this.chart.styledMode,
              h = [["graph", "highcharts-graph"]];
          e || h[0].push(b.lineColor || this.color, b.dashStyle);
          h = a.getZonesGraphs(h);
          h.forEach(function (c, k) {
            var h = c[0],
                f = a[h];
            f ? (f.endX = a.preventGraphAnimation ? null : d.xMap, f.animate({
              d: d
            })) : d.length && (a[h] = a.chart.renderer.path(d).addClass(c[1]).attr({
              zIndex: 1
            }).add(a.group), e || (f = {
              stroke: c[2],
              "stroke-width": b.lineWidth,
              fill: a.fillGraph && a.color || "none"
            }, c[3] ? f.dashstyle = c[3] : "square" !== b.linecap && (f["stroke-linecap"] = f["stroke-linejoin"] = "round"), f = a[h].attr(f).shadow(2 > k && b.shadow)));
            f && (f.startX = d.xMap, f.isArea = d.isArea);
          });
        },
        getZonesGraphs: function getZonesGraphs(a) {
          this.zones.forEach(function (c, b) {
            b = ["zone-graph-" + b, "highcharts-graph highcharts-zone-graph-" + b + " " + (c.className || "")];
            this.chart.styledMode || b.push(c.color || this.color, c.dashStyle || this.options.dashStyle);
            a.push(b);
          }, this);
          return a;
        },
        applyZones: function applyZones() {
          var a = this,
              b = this.chart,
              d = b.renderer,
              e = this.zones,
              h,
              f,
              l = this.clips || [],
              g,
              p = this.graph,
              q = this.area,
              w = Math.max(b.chartWidth, b.chartHeight),
              r = this[(this.zoneAxis || "y") + "Axis"],
              m,
              E,
              F = b.inverted,
              C,
              t,
              v,
              u,
              y = !1;
          e.length && (p || q) && r && void 0 !== r.min && (E = r.reversed, C = r.horiz, p && !this.showLine && p.hide(), q && q.hide(), m = r.getExtremes(), e.forEach(function (c, k) {
            h = E ? C ? b.plotWidth : 0 : C ? 0 : r.toPixels(m.min) || 0;
            h = Math.min(Math.max(n(f, h), 0), w);
            f = Math.min(Math.max(Math.round(r.toPixels(n(c.value, m.max), !0) || 0), 0), w);
            y && (h = f = r.toPixels(m.max));
            t = Math.abs(h - f);
            v = Math.min(h, f);
            u = Math.max(h, f);
            r.isXAxis ? (g = {
              x: F ? u : v,
              y: 0,
              width: t,
              height: w
            }, C || (g.x = b.plotHeight - g.x)) : (g = {
              x: 0,
              y: F ? u : v,
              width: w,
              height: t
            }, C && (g.y = b.plotWidth - g.y));
            F && d.isVML && (g = r.isXAxis ? {
              x: 0,
              y: E ? v : u,
              height: g.width,
              width: b.chartWidth
            } : {
              x: g.y - b.plotLeft - b.spacingBox.x,
              y: 0,
              width: g.height,
              height: b.chartHeight
            });
            l[k] ? l[k].animate(g) : (l[k] = d.clipRect(g), p && a["zone-graph-" + k].clip(l[k]), q && a["zone-area-" + k].clip(l[k]));
            y = c.value > m.max;
            a.resetZones && 0 === f && (f = void 0);
          }), this.clips = l);
        },
        invertGroups: function invertGroups(a) {
          function c() {
            ["group", "markerGroup"].forEach(function (c) {
              b[c] && (d.renderer.isVML && b[c].attr({
                width: b.yAxis.len,
                height: b.xAxis.len
              }), b[c].width = b.yAxis.len, b[c].height = b.xAxis.len, b[c].invert(a));
            });
          }

          var b = this,
              d = b.chart,
              h;
          b.xAxis && (h = B(d, "resize", c), B(b, "destroy", h), c(a), b.invertGroups = c);
        },
        plotGroup: function plotGroup(a, b, d, e, h) {
          var c = this[a],
              k = !c;
          k && (this[a] = c = this.chart.renderer.g().attr({
            zIndex: e || .1
          }).add(h));
          c.addClass("highcharts-" + b + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (v(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (c.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0);
          c.attr({
            visibility: d
          })[k ? "attr" : "animate"](this.getPlotBox());
          return c;
        },
        getPlotBox: function getPlotBox() {
          var a = this.chart,
              b = this.xAxis,
              d = this.yAxis;
          a.inverted && (b = d, d = this.xAxis);
          return {
            translateX: b ? b.left : a.plotLeft,
            translateY: d ? d.top : a.plotTop,
            scaleX: 1,
            scaleY: 1
          };
        },
        render: function render() {
          var a = this,
              b = a.chart,
              d,
              e = a.options,
              h = !!a.animate && b.renderer.isSVG && A(e.animation).duration,
              l = a.visible ? "inherit" : "hidden",
              g = e.zIndex,
              n = a.hasRendered,
              p = b.seriesGroup,
              q = b.inverted;
          f(this, "render");
          d = a.plotGroup("group", "series", l, g, p);
          a.markerGroup = a.plotGroup("markerGroup", "markers", l, g, p);
          h && a.animate(!0);
          d.inverted = a.isCartesian ? q : !1;
          a.drawGraph && (a.drawGraph(), a.applyZones());
          a.drawDataLabels && a.drawDataLabels();
          a.visible && a.drawPoints();
          a.drawTracker && !1 !== a.options.enableMouseTracking && a.drawTracker();
          a.invertGroups(q);
          !1 === e.clip || a.sharedClipKey || n || d.clip(b.clipRect);
          h && a.animate();
          n || (a.animationTimeout = C(function () {
            a.afterAnimate();
          }, h));
          a.isDirty = !1;
          a.hasRendered = !0;
          f(a, "afterRender");
        },
        redraw: function redraw() {
          var a = this.chart,
              b = this.isDirty || this.isDirtyData,
              d = this.group,
              e = this.xAxis,
              h = this.yAxis;
          d && (a.inverted && d.attr({
            width: a.plotWidth,
            height: a.plotHeight
          }), d.animate({
            translateX: n(e && e.left, a.plotLeft),
            translateY: n(h && h.top, a.plotTop)
          }));
          this.translate();
          this.render();
          b && delete this.kdTree;
        },
        kdAxisArray: ["clientX", "plotY"],
        searchPoint: function searchPoint(a, b) {
          var c = this.xAxis,
              k = this.yAxis,
              h = this.chart.inverted;
          return this.searchKDTree({
            clientX: h ? c.len - a.chartY + c.pos : a.chartX - c.pos,
            plotY: h ? k.len - a.chartX + k.pos : a.chartY - k.pos
          }, b, a);
        },
        buildKDTree: function buildKDTree(a) {
          function c(a, k, d) {
            var h, e;
            if (e = a && a.length) return h = b.kdAxisArray[k % d], a.sort(function (a, c) {
              return a[h] - c[h];
            }), e = Math.floor(e / 2), {
              point: a[e],
              left: c(a.slice(0, e), k + 1, d),
              right: c(a.slice(e + 1), k + 1, d)
            };
          }

          this.buildingKdTree = !0;
          var b = this,
              d = -1 < b.options.findNearestPointBy.indexOf("y") ? 2 : 1;
          delete b.kdTree;
          C(function () {
            b.kdTree = c(b.getValidPoints(null, !b.directTouch), d, d);
            b.buildingKdTree = !1;
          }, b.options.kdNow || a && "touchstart" === a.type ? 0 : 1);
        },
        searchKDTree: function searchKDTree(a, b, d) {
          function c(a, b, d, h) {
            var g = b.point,
                n = k.kdAxisArray[d % h],
                p,
                x,
                q = g;
            x = v(a[e]) && v(g[e]) ? Math.pow(a[e] - g[e], 2) : null;
            p = v(a[f]) && v(g[f]) ? Math.pow(a[f] - g[f], 2) : null;
            p = (x || 0) + (p || 0);
            g.dist = v(p) ? Math.sqrt(p) : Number.MAX_VALUE;
            g.distX = v(x) ? Math.sqrt(x) : Number.MAX_VALUE;
            n = a[n] - g[n];
            p = 0 > n ? "left" : "right";
            x = 0 > n ? "right" : "left";
            b[p] && (p = c(a, b[p], d + 1, h), q = p[l] < q[l] ? p : g);
            b[x] && Math.sqrt(n * n) < q[l] && (a = c(a, b[x], d + 1, h), q = a[l] < q[l] ? a : q);
            return q;
          }

          var k = this,
              e = this.kdAxisArray[0],
              f = this.kdAxisArray[1],
              l = b ? "distX" : "dist";
          b = -1 < k.options.findNearestPointBy.indexOf("y") ? 2 : 1;
          this.kdTree || this.buildingKdTree || this.buildKDTree(d);
          if (this.kdTree) return c(a, this.kdTree, b, b);
        },
        pointPlacementToXValue: function pointPlacementToXValue() {
          var a = this.options.pointPlacement;
          "between" === a && (a = .5);
          p(a) && (a *= n(this.options.pointRange || this.xAxis.pointRange));
          return a;
        }
      });
    })(H);

    (function (a) {
      var B = a.Axis,
          A = a.Chart,
          G = a.correctFloat,
          m = a.defined,
          g = a.destroyObjectProperties,
          t = a.format,
          u = a.objectEach,
          v = a.pick,
          y = a.Series;

      a.StackItem = function (a, f, e, g, r) {
        var b = a.chart.inverted;
        this.axis = a;
        this.isNegative = e;
        this.options = f;
        this.x = g;
        this.total = null;
        this.points = {};
        this.stack = r;
        this.rightCliff = this.leftCliff = 0;
        this.alignOptions = {
          align: f.align || (b ? e ? "left" : "right" : "center"),
          verticalAlign: f.verticalAlign || (b ? "middle" : e ? "bottom" : "top"),
          y: v(f.y, b ? 4 : e ? 14 : -6),
          x: v(f.x, b ? e ? -6 : 6 : 0)
        };
        this.textAlign = f.textAlign || (b ? e ? "right" : "left" : "center");
      };

      a.StackItem.prototype = {
        destroy: function destroy() {
          g(this, this.axis);
        },
        render: function render(a) {
          var f = this.axis.chart,
              e = this.options,
              g = e.format,
              g = g ? t(g, this, f.time) : e.formatter.call(this);
          this.label ? this.label.attr({
            text: g,
            visibility: "hidden"
          }) : this.label = f.renderer.text(g, null, null, e.useHTML).css(e.style).attr({
            align: this.textAlign,
            rotation: e.rotation,
            visibility: "hidden"
          }).add(a);
          this.label.labelrank = f.plotHeight;
        },
        setOffset: function setOffset(a, f) {
          var e = this.axis,
              g = e.chart,
              q = e.translate(e.usePercentage ? 100 : this.total, 0, 0, 0, 1),
              b = e.translate(0),
              b = m(q) && Math.abs(q - b);
          a = g.xAxis[0].translate(this.x) + a;
          e = m(q) && this.getStackBox(g, this, a, q, f, b, e);
          (f = this.label) && e && (f.align(this.alignOptions, null, e), e = f.alignAttr, f[!1 === this.options.crop || g.isInsidePlot(e.x, e.y) ? "show" : "hide"](!0));
        },
        getStackBox: function getStackBox(a, f, e, g, r, b, l) {
          var n = f.axis.reversed,
              d = a.inverted;
          a = l.height + l.pos - (d ? a.plotLeft : a.plotTop);
          f = f.isNegative && !n || !f.isNegative && n;
          return {
            x: d ? f ? g : g - b : e,
            y: d ? a - e - r : f ? a - g - b : a - g,
            width: d ? b : r,
            height: d ? r : b
          };
        }
      };

      A.prototype.getStacks = function () {
        var a = this;
        a.yAxis.forEach(function (a) {
          a.stacks && a.hasVisibleSeries && (a.oldStacks = a.stacks);
        });
        a.series.forEach(function (f) {
          !f.options.stacking || !0 !== f.visible && !1 !== a.options.chart.ignoreHiddenSeries || (f.stackKey = f.type + v(f.options.stack, ""));
        });
      };

      B.prototype.buildStacks = function () {
        var a = this.series,
            f = v(this.options.reversedStacks, !0),
            e = a.length,
            g;

        if (!this.isXAxis) {
          this.usePercentage = !1;

          for (g = e; g--;) {
            a[f ? g : e - g - 1].setStackedPoints();
          }

          for (g = 0; g < e; g++) {
            a[g].modifyStacks();
          }
        }
      };

      B.prototype.renderStackTotals = function () {
        var a = this.chart,
            f = a.renderer,
            e = this.stacks,
            g = this.stackTotalGroup;
        g || (this.stackTotalGroup = g = f.g("stack-labels").attr({
          visibility: "visible",
          zIndex: 6
        }).add());
        g.translate(a.plotLeft, a.plotTop);
        u(e, function (a) {
          u(a, function (a) {
            a.render(g);
          });
        });
      };

      B.prototype.resetStacks = function () {
        var a = this,
            f = a.stacks;
        a.isXAxis || u(f, function (e) {
          u(e, function (f, g) {
            f.touched < a.stacksTouched ? (f.destroy(), delete e[g]) : (f.total = null, f.cumulative = null);
          });
        });
      };

      B.prototype.cleanStacks = function () {
        var a;
        this.isXAxis || (this.oldStacks && (a = this.stacks = this.oldStacks), u(a, function (a) {
          u(a, function (a) {
            a.cumulative = a.total;
          });
        }));
      };

      y.prototype.setStackedPoints = function () {
        if (this.options.stacking && (!0 === this.visible || !1 === this.chart.options.chart.ignoreHiddenSeries)) {
          var g = this.processedXData,
              f = this.processedYData,
              e = [],
              p = f.length,
              r = this.options,
              b = r.threshold,
              l = v(r.startFromThreshold && b, 0),
              n = r.stack,
              r = r.stacking,
              d = this.stackKey,
              w = "-" + d,
              E = this.negStacks,
              C = this.yAxis,
              F = C.stacks,
              c = C.oldStacks,
              k,
              x,
              D,
              h,
              z,
              t,
              u;
          C.stacksTouched += 1;

          for (z = 0; z < p; z++) {
            t = g[z], u = f[z], k = this.getStackIndicator(k, t, this.index), h = k.key, D = (x = E && u < (l ? 0 : b)) ? w : d, F[D] || (F[D] = {}), F[D][t] || (c[D] && c[D][t] ? (F[D][t] = c[D][t], F[D][t].total = null) : F[D][t] = new a.StackItem(C, C.options.stackLabels, x, t, n)), D = F[D][t], null !== u ? (D.points[h] = D.points[this.index] = [v(D.cumulative, l)], m(D.cumulative) || (D.base = h), D.touched = C.stacksTouched, 0 < k.index && !1 === this.singleStacks && (D.points[h][0] = D.points[this.index + "," + t + ",0"][0])) : D.points[h] = D.points[this.index] = null, "percent" === r ? (x = x ? d : w, E && F[x] && F[x][t] ? (x = F[x][t], D.total = x.total = Math.max(x.total, D.total) + Math.abs(u) || 0) : D.total = G(D.total + (Math.abs(u) || 0))) : D.total = G(D.total + (u || 0)), D.cumulative = v(D.cumulative, l) + (u || 0), null !== u && (D.points[h].push(D.cumulative), e[z] = D.cumulative);
          }

          "percent" === r && (C.usePercentage = !0);
          this.stackedYData = e;
          C.oldStacks = {};
        }
      };

      y.prototype.modifyStacks = function () {
        var a = this,
            f = a.stackKey,
            e = a.yAxis.stacks,
            g = a.processedXData,
            r,
            b = a.options.stacking;
        a[b + "Stacker"] && [f, "-" + f].forEach(function (f) {
          for (var l = g.length, d, p; l--;) {
            if (d = g[l], r = a.getStackIndicator(r, d, a.index, f), p = (d = e[f] && e[f][d]) && d.points[r.key]) a[b + "Stacker"](p, d, l);
          }
        });
      };

      y.prototype.percentStacker = function (a, f, e) {
        f = f.total ? 100 / f.total : 0;
        a[0] = G(a[0] * f);
        a[1] = G(a[1] * f);
        this.stackedYData[e] = a[1];
      };

      y.prototype.getStackIndicator = function (a, f, e, g) {
        !m(a) || a.x !== f || g && a.key !== g ? a = {
          x: f,
          index: 0,
          key: g
        } : a.index++;
        a.key = [e, f, a.index].join();
        return a;
      };
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.animate,
          G = a.Axis,
          m = a.Chart,
          g = a.createElement,
          t = a.css,
          u = a.defined,
          v = a.erase,
          y = a.extend,
          q = a.fireEvent,
          f = a.isNumber,
          e = a.isObject,
          p = a.isArray,
          r = a.merge,
          b = a.objectEach,
          l = a.pick,
          n = a.Point,
          d = a.Series,
          w = a.seriesTypes,
          E = a.setAnimation,
          C = a.splat;

      a.cleanRecursively = function (d, c) {
        var k = {};
        b(d, function (b, f) {
          if (e(d[f], !0) && c[f]) b = a.cleanRecursively(d[f], c[f]), Object.keys(b).length && (k[f] = b);else if (e(d[f]) || d[f] !== c[f]) k[f] = d[f];
        });
        return k;
      };

      y(m.prototype, {
        addSeries: function addSeries(a, c, b) {
          var k,
              d = this;
          a && (c = l(c, !0), q(d, "addSeries", {
            options: a
          }, function () {
            k = d.initSeries(a);
            d.isDirtyLegend = !0;
            d.linkSeries();
            q(d, "afterAddSeries");
            c && d.redraw(b);
          }));
          return k;
        },
        addAxis: function addAxis(a, c, b, d) {
          var k = c ? "xAxis" : "yAxis",
              h = this.options;
          a = r(a, {
            index: this[k].length,
            isX: c
          });
          c = new G(this, a);
          h[k] = C(h[k] || {});
          h[k].push(a);
          l(b, !0) && this.redraw(d);
          return c;
        },
        showLoading: function showLoading(a) {
          var c = this,
              b = c.options,
              d = c.loadingDiv,
              e = b.loading,
              h = function h() {
            d && t(d, {
              left: c.plotLeft + "px",
              top: c.plotTop + "px",
              width: c.plotWidth + "px",
              height: c.plotHeight + "px"
            });
          };

          d || (c.loadingDiv = d = g("div", {
            className: "highcharts-loading highcharts-loading-hidden"
          }, null, c.container), c.loadingSpan = g("span", {
            className: "highcharts-loading-inner"
          }, null, d), B(c, "redraw", h));
          d.className = "highcharts-loading";
          c.loadingSpan.innerHTML = a || b.lang.loading;
          c.styledMode || (t(d, y(e.style, {
            zIndex: 10
          })), t(c.loadingSpan, e.labelStyle), c.loadingShown || (t(d, {
            opacity: 0,
            display: ""
          }), A(d, {
            opacity: e.style.opacity || .5
          }, {
            duration: e.showDuration || 0
          })));
          c.loadingShown = !0;
          h();
        },
        hideLoading: function hideLoading() {
          var a = this.options,
              c = this.loadingDiv;
          c && (c.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || A(c, {
            opacity: 0
          }, {
            duration: a.loading.hideDuration || 100,
            complete: function complete() {
              t(c, {
                display: "none"
              });
            }
          }));
          this.loadingShown = !1;
        },
        propsRequireDirtyBox: "backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
        propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),
        collectionsWithUpdate: "xAxis yAxis zAxis series colorAxis pane".split(" "),
        update: function update(d, c, k, e) {
          var g = this,
              h = {
            credits: "addCredits",
            title: "setTitle",
            subtitle: "setSubtitle"
          },
              n,
              p,
              x,
              w = [];
          q(g, "update", {
            options: d
          });
          d.isResponsiveOptions || g.setResponsive(!1, !0);
          d = a.cleanRecursively(d, g.options);

          if (n = d.chart) {
            r(!0, g.options.chart, n);
            "className" in n && g.setClassName(n.className);
            "reflow" in n && g.setReflow(n.reflow);
            if ("inverted" in n || "polar" in n || "type" in n) g.propFromSeries(), p = !0;
            "alignTicks" in n && (p = !0);
            b(n, function (a, c) {
              -1 !== g.propsRequireUpdateSeries.indexOf("chart." + c) && (x = !0);
              -1 !== g.propsRequireDirtyBox.indexOf(c) && (g.isDirtyBox = !0);
            });
            !g.styledMode && "style" in n && g.renderer.setStyle(n.style);
          }

          !g.styledMode && d.colors && (this.options.colors = d.colors);
          d.plotOptions && r(!0, this.options.plotOptions, d.plotOptions);
          b(d, function (a, c) {
            if (g[c] && "function" === typeof g[c].update) g[c].update(a, !1);else if ("function" === typeof g[h[c]]) g[h[c]](a);
            "chart" !== c && -1 !== g.propsRequireUpdateSeries.indexOf(c) && (x = !0);
          });
          this.collectionsWithUpdate.forEach(function (a) {
            var c;
            d[a] && ("series" === a && (c = [], g[a].forEach(function (a, b) {
              a.options.isInternal || c.push(l(a.options.index, b));
            })), C(d[a]).forEach(function (b, d) {
              (d = u(b.id) && g.get(b.id) || g[a][c ? c[d] : d]) && d.coll === a && (d.update(b, !1), k && (d.touched = !0));
              if (!d && k) if ("series" === a) g.addSeries(b, !1).touched = !0;else if ("xAxis" === a || "yAxis" === a) g.addAxis(b, "xAxis" === a, !1).touched = !0;
            }), k && g[a].forEach(function (a) {
              a.touched || a.options.isInternal ? delete a.touched : w.push(a);
            }));
          });
          w.forEach(function (a) {
            a.remove && a.remove(!1);
          });
          p && g.axes.forEach(function (a) {
            a.update({}, !1);
          });
          x && g.series.forEach(function (a) {
            a.update({}, !1);
          });
          d.loading && r(!0, g.options.loading, d.loading);
          p = n && n.width;
          n = n && n.height;
          f(p) && p !== g.chartWidth || f(n) && n !== g.chartHeight ? g.setSize(p, n, e) : l(c, !0) && g.redraw(e);
          q(g, "afterUpdate", {
            options: d
          });
        },
        setSubtitle: function setSubtitle(a) {
          this.setTitle(void 0, a);
        }
      });
      y(n.prototype, {
        update: function update(a, c, b, d) {
          function k() {
            h.applyOptions(a);
            null === h.y && g && (h.graphic = g.destroy());
            e(a, !0) && (g && g.element && a && a.marker && void 0 !== a.marker.symbol && (h.graphic = g.destroy()), a && a.dataLabels && h.dataLabel && (h.dataLabel = h.dataLabel.destroy()), h.connector && (h.connector = h.connector.destroy()));
            n = h.index;
            f.updateParallelArrays(h, n);
            x.data[n] = e(x.data[n], !0) || e(a, !0) ? h.options : l(a, x.data[n]);
            f.isDirty = f.isDirtyData = !0;
            !f.fixedBox && f.hasCartesianSeries && (p.isDirtyBox = !0);
            "point" === x.legendType && (p.isDirtyLegend = !0);
            c && p.redraw(b);
          }

          var h = this,
              f = h.series,
              g = h.graphic,
              n,
              p = f.chart,
              x = f.options;
          c = l(c, !0);
          !1 === d ? k() : h.firePointEvent("update", {
            options: a
          }, k);
        },
        remove: function remove(a, c) {
          this.series.removePoint(this.series.data.indexOf(this), a, c);
        }
      });
      y(d.prototype, {
        addPoint: function addPoint(a, c, b, d) {
          var k = this.options,
              h = this.data,
              e = this.chart,
              f = this.xAxis,
              f = f && f.hasNames && f.names,
              g = k.data,
              n,
              p,
              x = this.xData,
              w,
              r;
          c = l(c, !0);
          n = {
            series: this
          };
          this.pointClass.prototype.applyOptions.apply(n, [a]);
          r = n.x;
          w = x.length;
          if (this.requireSorting && r < x[w - 1]) for (p = !0; w && x[w - 1] > r;) {
            w--;
          }
          this.updateParallelArrays(n, "splice", w, 0, 0);
          this.updateParallelArrays(n, w);
          f && n.name && (f[r] = n.name);
          g.splice(w, 0, a);
          p && (this.data.splice(w, 0, null), this.processData());
          "point" === k.legendType && this.generatePoints();
          b && (h[0] && h[0].remove ? h[0].remove(!1) : (h.shift(), this.updateParallelArrays(n, "shift"), g.shift()));
          this.isDirtyData = this.isDirty = !0;
          c && e.redraw(d);
        },
        removePoint: function removePoint(a, c, b) {
          var d = this,
              k = d.data,
              h = k[a],
              e = d.points,
              f = d.chart,
              g = function g() {
            e && e.length === k.length && e.splice(a, 1);
            k.splice(a, 1);
            d.options.data.splice(a, 1);
            d.updateParallelArrays(h || {
              series: d
            }, "splice", a, 1);
            h && h.destroy();
            d.isDirty = !0;
            d.isDirtyData = !0;
            c && f.redraw();
          };

          E(b, f);
          c = l(c, !0);
          h ? h.firePointEvent("remove", null, g) : g();
        },
        remove: function remove(a, c, b, d) {
          function k() {
            h.destroy(d);
            h.remove = null;
            e.isDirtyLegend = e.isDirtyBox = !0;
            e.linkSeries();
            l(a, !0) && e.redraw(c);
          }

          var h = this,
              e = h.chart;
          !1 !== b ? q(h, "remove", null, k) : k();
        },
        update: function update(b, c) {
          b = a.cleanRecursively(b, this.userOptions);
          var d = this,
              e = d.chart,
              f = d.userOptions,
              h = d.initialType || d.type,
              g = b.type || f.type || e.options.chart.type,
              n = w[h].prototype,
              p,
              m = ["group", "markerGroup", "dataLabelsGroup"],
              E = ["navigatorSeries", "baseSeries"],
              C = d.finishedAnimating && {
            animation: !1
          },
              t = ["data", "name", "turboThreshold"],
              v = Object.keys(b),
              F = 0 < v.length;
          v.forEach(function (a) {
            -1 === t.indexOf(a) && (F = !1);
          });
          if (F) b.data && this.setData(b.data, !1), b.name && this.setName(b.name, !1);else {
            E = m.concat(E);
            E.forEach(function (a) {
              E[a] = d[a];
              delete d[a];
            });
            b = r(f, C, {
              index: d.index,
              pointStart: l(f.pointStart, d.xData[0])
            }, {
              data: d.options.data
            }, b);
            d.remove(!1, null, !1, !0);

            for (p in n) {
              d[p] = void 0;
            }

            w[g || h] ? y(d, w[g || h].prototype) : a.error(17, !0, e);
            E.forEach(function (a) {
              d[a] = E[a];
            });
            d.init(e, b);
            b.zIndex !== f.zIndex && m.forEach(function (a) {
              d[a] && d[a].attr({
                zIndex: b.zIndex
              });
            });
            d.initialType = h;
            e.linkSeries();
          }
          q(this, "afterUpdate");
          l(c, !0) && e.redraw(F ? void 0 : !1);
        },
        setName: function setName(a) {
          this.name = this.options.name = this.userOptions.name = a;
          this.chart.isDirtyLegend = !0;
        }
      });
      y(G.prototype, {
        update: function update(a, c) {
          var d = this.chart,
              e = a && a.events || {};
          a = r(this.userOptions, a);
          d.options[this.coll].indexOf && (d.options[this.coll][d.options[this.coll].indexOf(this.userOptions)] = a);
          b(d.options[this.coll].events, function (a, c) {
            "undefined" === typeof e[c] && (e[c] = void 0);
          });
          this.destroy(!0);
          this.init(d, y(a, {
            events: e
          }));
          d.isDirtyBox = !0;
          l(c, !0) && d.redraw();
        },
        remove: function remove(a) {
          for (var c = this.chart, b = this.coll, d = this.series, e = d.length; e--;) {
            d[e] && d[e].remove(!1);
          }

          v(c.axes, this);
          v(c[b], this);
          p(c.options[b]) ? c.options[b].splice(this.options.index, 1) : delete c.options[b];
          c[b].forEach(function (a, c) {
            a.options.index = a.userOptions.index = c;
          });
          this.destroy();
          c.isDirtyBox = !0;
          l(a, !0) && c.redraw();
        },
        setTitle: function setTitle(a, c) {
          this.update({
            title: a
          }, c);
        },
        setCategories: function setCategories(a, c) {
          this.update({
            categories: a
          }, c);
        }
      });
    })(H);

    (function (a) {
      var B = a.color,
          A = a.pick,
          G = a.Series,
          m = a.seriesType;
      m("area", "line", {
        softThreshold: !1,
        threshold: 0
      }, {
        singleStacks: !1,
        getStackPoints: function getStackPoints(g) {
          var m = [],
              u = [],
              v = this.xAxis,
              y = this.yAxis,
              q = y.stacks[this.stackKey],
              f = {},
              e = this.index,
              p = y.series,
              r = p.length,
              b,
              l = A(y.options.reversedStacks, !0) ? 1 : -1,
              n;
          g = g || this.points;

          if (this.options.stacking) {
            for (n = 0; n < g.length; n++) {
              g[n].leftNull = g[n].rightNull = null, f[g[n].x] = g[n];
            }

            a.objectEach(q, function (a, b) {
              null !== a.total && u.push(b);
            });
            u.sort(function (a, b) {
              return a - b;
            });
            b = p.map(function (a) {
              return a.visible;
            });
            u.forEach(function (a, g) {
              var d = 0,
                  p,
                  w;
              if (f[a] && !f[a].isNull) m.push(f[a]), [-1, 1].forEach(function (c) {
                var d = 1 === c ? "rightNull" : "leftNull",
                    x = 0,
                    m = q[u[g + c]];
                if (m) for (n = e; 0 <= n && n < r;) {
                  p = m.points[n], p || (n === e ? f[a][d] = !0 : b[n] && (w = q[a].points[n]) && (x -= w[1] - w[0])), n += l;
                }
                f[a][1 === c ? "rightCliff" : "leftCliff"] = x;
              });else {
                for (n = e; 0 <= n && n < r;) {
                  if (p = q[a].points[n]) {
                    d = p[1];
                    break;
                  }

                  n += l;
                }

                d = y.translate(d, 0, 1, 0, 1);
                m.push({
                  isNull: !0,
                  plotX: v.translate(a, 0, 0, 0, 1),
                  x: a,
                  plotY: d,
                  yBottom: d
                });
              }
            });
          }

          return m;
        },
        getGraphPath: function getGraphPath(a) {
          var g = G.prototype.getGraphPath,
              m = this.options,
              v = m.stacking,
              y = this.yAxis,
              q,
              f,
              e = [],
              p = [],
              r = this.index,
              b,
              l = y.stacks[this.stackKey],
              n = m.threshold,
              d = y.getThreshold(m.threshold),
              w,
              m = m.connectNulls || "percent" === v,
              E = function E(f, g, c) {
            var k = a[f];
            f = v && l[k.x].points[r];
            var x = k[c + "Null"] || 0;
            c = k[c + "Cliff"] || 0;
            var w,
                h,
                k = !0;
            c || x ? (w = (x ? f[0] : f[1]) + c, h = f[0] + c, k = !!x) : !v && a[g] && a[g].isNull && (w = h = n);
            void 0 !== w && (p.push({
              plotX: b,
              plotY: null === w ? d : y.getThreshold(w),
              isNull: k,
              isCliff: !0
            }), e.push({
              plotX: b,
              plotY: null === h ? d : y.getThreshold(h),
              doCurve: !1
            }));
          };

          a = a || this.points;
          v && (a = this.getStackPoints(a));

          for (q = 0; q < a.length; q++) {
            if (f = a[q].isNull, b = A(a[q].rectPlotX, a[q].plotX), w = A(a[q].yBottom, d), !f || m) m || E(q, q - 1, "left"), f && !v && m || (p.push(a[q]), e.push({
              x: q,
              plotX: b,
              plotY: w
            })), m || E(q, q + 1, "right");
          }

          q = g.call(this, p, !0, !0);
          e.reversed = !0;
          f = g.call(this, e, !0, !0);
          f.length && (f[0] = "L");
          f = q.concat(f);
          g = g.call(this, p, !1, m);
          f.xMap = q.xMap;
          this.areaPath = f;
          return g;
        },
        drawGraph: function drawGraph() {
          this.areaPath = [];
          G.prototype.drawGraph.apply(this);
          var a = this,
              m = this.areaPath,
              u = this.options,
              v = [["area", "highcharts-area", this.color, u.fillColor]];
          this.zones.forEach(function (g, q) {
            v.push(["zone-area-" + q, "highcharts-area highcharts-zone-area-" + q + " " + g.className, g.color || a.color, g.fillColor || u.fillColor]);
          });
          v.forEach(function (g) {
            var q = g[0],
                f = a[q];
            f ? (f.endX = a.preventGraphAnimation ? null : m.xMap, f.animate({
              d: m
            })) : (f = {
              zIndex: 0
            }, a.chart.styledMode || (f.fill = A(g[3], B(g[2]).setOpacity(A(u.fillOpacity, .75)).get())), f = a[q] = a.chart.renderer.path(m).addClass(g[1]).attr(f).add(a.group), f.isArea = !0);
            f.startX = m.xMap;
            f.shiftUnit = u.step ? 2 : 1;
          });
        },
        drawLegendSymbol: a.LegendSymbolMixin.drawRectangle
      });
    })(H);

    (function (a) {
      var B = a.pick;
      a = a.seriesType;
      a("spline", "line", {}, {
        getPointSpline: function getPointSpline(a, G, m) {
          var g = G.plotX,
              t = G.plotY,
              u = a[m - 1];
          m = a[m + 1];
          var v, y, q, f;

          if (u && !u.isNull && !1 !== u.doCurve && !G.isCliff && m && !m.isNull && !1 !== m.doCurve && !G.isCliff) {
            a = u.plotY;
            q = m.plotX;
            m = m.plotY;
            var e = 0;
            v = (1.5 * g + u.plotX) / 2.5;
            y = (1.5 * t + a) / 2.5;
            q = (1.5 * g + q) / 2.5;
            f = (1.5 * t + m) / 2.5;
            q !== v && (e = (f - y) * (q - g) / (q - v) + t - f);
            y += e;
            f += e;
            y > a && y > t ? (y = Math.max(a, t), f = 2 * t - y) : y < a && y < t && (y = Math.min(a, t), f = 2 * t - y);
            f > m && f > t ? (f = Math.max(m, t), y = 2 * t - f) : f < m && f < t && (f = Math.min(m, t), y = 2 * t - f);
            G.rightContX = q;
            G.rightContY = f;
          }

          G = ["C", B(u.rightContX, u.plotX), B(u.rightContY, u.plotY), B(v, g), B(y, t), g, t];
          u.rightContX = u.rightContY = null;
          return G;
        }
      });
    })(H);

    (function (a) {
      var B = a.seriesTypes.area.prototype,
          A = a.seriesType;
      A("areaspline", "spline", a.defaultPlotOptions.area, {
        getStackPoints: B.getStackPoints,
        getGraphPath: B.getGraphPath,
        drawGraph: B.drawGraph,
        drawLegendSymbol: a.LegendSymbolMixin.drawRectangle
      });
    })(H);

    (function (a) {
      var B = a.animObject,
          A = a.color,
          G = a.extend,
          m = a.defined,
          g = a.isNumber,
          t = a.merge,
          u = a.pick,
          v = a.Series,
          y = a.seriesType,
          q = a.svg;
      y("column", "line", {
        borderRadius: 0,
        crisp: !0,
        groupPadding: .2,
        marker: null,
        pointPadding: .1,
        minPointLength: 0,
        cropThreshold: 50,
        pointRange: null,
        states: {
          hover: {
            halo: !1,
            brightness: .1
          },
          select: {
            color: "#cccccc",
            borderColor: "#000000"
          }
        },
        dataLabels: {
          align: null,
          verticalAlign: null,
          y: null
        },
        softThreshold: !1,
        startFromThreshold: !0,
        stickyTracking: !1,
        tooltip: {
          distance: 6
        },
        threshold: 0,
        borderColor: "#ffffff"
      }, {
        cropShoulder: 0,
        directTouch: !0,
        trackerGroups: ["group", "dataLabelsGroup"],
        negStacks: !0,
        init: function init() {
          v.prototype.init.apply(this, arguments);
          var a = this,
              e = a.chart;
          e.hasRendered && e.series.forEach(function (e) {
            e.type === a.type && (e.isDirty = !0);
          });
        },
        getColumnMetrics: function getColumnMetrics() {
          var a = this,
              e = a.options,
              g = a.xAxis,
              r = a.yAxis,
              b = g.options.reversedStacks,
              b = g.reversed && !b || !g.reversed && b,
              l,
              n = {},
              d = 0;
          !1 === e.grouping ? d = 1 : a.chart.series.forEach(function (b) {
            var c = b.options,
                k = b.yAxis,
                e;
            b.type !== a.type || !b.visible && a.chart.options.chart.ignoreHiddenSeries || r.len !== k.len || r.pos !== k.pos || (c.stacking ? (l = b.stackKey, void 0 === n[l] && (n[l] = d++), e = n[l]) : !1 !== c.grouping && (e = d++), b.columnIndex = e);
          });
          var w = Math.min(Math.abs(g.transA) * (g.ordinalSlope || e.pointRange || g.closestPointRange || g.tickInterval || 1), g.len),
              q = w * e.groupPadding,
              m = (w - 2 * q) / (d || 1),
              e = Math.min(e.maxPointWidth || g.len, u(e.pointWidth, m * (1 - 2 * e.pointPadding)));
          a.columnMetrics = {
            width: e,
            offset: (m - e) / 2 + (q + ((a.columnIndex || 0) + (b ? 1 : 0)) * m - w / 2) * (b ? -1 : 1)
          };
          return a.columnMetrics;
        },
        crispCol: function crispCol(a, e, g, r) {
          var b = this.chart,
              f = this.borderWidth,
              n = -(f % 2 ? .5 : 0),
              f = f % 2 ? .5 : 1;
          b.inverted && b.renderer.isVML && (f += 1);
          this.options.crisp && (g = Math.round(a + g) + n, a = Math.round(a) + n, g -= a);
          r = Math.round(e + r) + f;
          n = .5 >= Math.abs(e) && .5 < r;
          e = Math.round(e) + f;
          r -= e;
          n && r && (--e, r += 1);
          return {
            x: a,
            y: e,
            width: g,
            height: r
          };
        },
        translate: function translate() {
          var a = this,
              e = a.chart,
              g = a.options,
              r = a.dense = 2 > a.closestPointRange * a.xAxis.transA,
              r = a.borderWidth = u(g.borderWidth, r ? 0 : 1),
              b = a.yAxis,
              l = g.threshold,
              n = a.translatedThreshold = b.getThreshold(l),
              d = u(g.minPointLength, 5),
              w = a.getColumnMetrics(),
              q = w.width,
              C = a.barW = Math.max(q, 1 + 2 * r),
              t = a.pointXOffset = w.offset;
          e.inverted && (n -= .5);
          g.pointPadding && (C = Math.ceil(C));
          v.prototype.translate.apply(a);
          a.points.forEach(function (c) {
            var k = u(c.yBottom, n),
                f = 999 + Math.abs(k),
                g = q,
                f = Math.min(Math.max(-f, c.plotY), b.len + f),
                h = c.plotX + t,
                p = C,
                w = Math.min(f, k),
                r,
                E = Math.max(f, k) - w;
            d && Math.abs(E) < d && (E = d, r = !b.reversed && !c.negative || b.reversed && c.negative, c.y === l && a.dataMax <= l && b.min < l && (r = !r), w = Math.abs(w - n) > d ? k - d : n - (r ? d : 0));
            m(c.options.pointWidth) && (g = p = Math.ceil(c.options.pointWidth), h -= Math.round((g - q) / 2));
            c.barX = h;
            c.pointWidth = g;
            c.tooltipPos = e.inverted ? [b.len + b.pos - e.plotLeft - f, a.xAxis.len - h - p / 2, E] : [h + p / 2, f + b.pos - e.plotTop, E];
            c.shapeType = c.shapeType || "rect";
            c.shapeArgs = a.crispCol.apply(a, c.isNull ? [h, n, p, 0] : [h, w, p, E]);
          });
        },
        getSymbol: a.noop,
        drawLegendSymbol: a.LegendSymbolMixin.drawRectangle,
        drawGraph: function drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        },
        pointAttribs: function pointAttribs(a, e) {
          var f = this.options,
              g,
              b = this.pointAttrToOptions || {};
          g = b.stroke || "borderColor";
          var l = b["stroke-width"] || "borderWidth",
              n = a && a.color || this.color,
              d = a && a[g] || f[g] || this.color || n,
              w = a && a[l] || f[l] || this[l] || 0,
              b = f.dashStyle;
          a && this.zones.length && (n = a.getZone(), n = a.options.color || n && n.color || this.color);
          e && (a = t(f.states[e], a.options.states && a.options.states[e] || {}), e = a.brightness, n = a.color || void 0 !== e && A(n).brighten(a.brightness).get() || n, d = a[g] || d, w = a[l] || w, b = a.dashStyle || b);
          g = {
            fill: n,
            stroke: d,
            "stroke-width": w
          };
          b && (g.dashstyle = b);
          return g;
        },
        drawPoints: function drawPoints() {
          var a = this,
              e = this.chart,
              p = a.options,
              r = e.renderer,
              b = p.animationLimit || 250,
              l;
          a.points.forEach(function (f) {
            var d = f.graphic,
                n = d && e.pointCount < b ? "animate" : "attr";

            if (g(f.plotY) && null !== f.y) {
              l = f.shapeArgs;
              if (d) d[n](t(l));else f.graphic = d = r[f.shapeType](l).add(f.group || a.group);
              p.borderRadius && d.attr({
                r: p.borderRadius
              });
              e.styledMode || d[n](a.pointAttribs(f, f.selected && "select")).shadow(p.shadow, null, p.stacking && !p.borderRadius);
              d.addClass(f.getClassName(), !0);
            } else d && (f.graphic = d.destroy());
          });
        },
        animate: function animate(a) {
          var e = this,
              f = this.yAxis,
              g = e.options,
              b = this.chart.inverted,
              l = {},
              n = b ? "translateX" : "translateY",
              d;
          q && (a ? (l.scaleY = .001, a = Math.min(f.pos + f.len, Math.max(f.pos, f.toPixels(g.threshold))), b ? l.translateX = a - f.len : l.translateY = a, e.clipBox && e.setClip(), e.group.attr(l)) : (d = e.group.attr(n), e.group.animate({
            scaleY: 1
          }, G(B(e.options.animation), {
            step: function step(a, b) {
              l[n] = d + b.pos * (f.pos - d);
              e.group.attr(l);
            }
          })), e.animate = null));
        },
        remove: function remove() {
          var a = this,
              e = a.chart;
          e.hasRendered && e.series.forEach(function (e) {
            e.type === a.type && (e.isDirty = !0);
          });
          v.prototype.remove.apply(a, arguments);
        }
      });
    })(H);

    (function (a) {
      a = a.seriesType;
      a("bar", "column", null, {
        inverted: !0
      });
    })(H);

    (function (a) {
      var B = a.Series,
          A = a.seriesType;
      A("scatter", "line", {
        lineWidth: 0,
        findNearestPointBy: "xy",
        jitter: {
          x: 0,
          y: 0
        },
        marker: {
          enabled: !0
        },
        tooltip: {
          headerFormat: "<span style=\"color:{point.color}\">\u25CF</span> <span style=\"font-size: 10px\"> {series.name}</span><br/>",
          pointFormat: "x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"
        }
      }, {
        sorted: !1,
        requireSorting: !1,
        noSharedTooltip: !0,
        trackerGroups: ["group", "markerGroup", "dataLabelsGroup"],
        takeOrdinalPosition: !1,
        drawGraph: function drawGraph() {
          this.options.lineWidth && B.prototype.drawGraph.call(this);
        },
        applyJitter: function applyJitter() {
          var a = this,
              m = this.options.jitter,
              g = this.points.length;
          m && this.points.forEach(function (t, u) {
            ["x", "y"].forEach(function (v, y) {
              var q,
                  f = "plot" + v.toUpperCase(),
                  e,
                  p;
              m[v] && !t.isNull && (q = a[v + "Axis"], p = m[v] * q.transA, q && !q.isLog && (e = Math.max(0, t[f] - p), q = Math.min(q.len, t[f] + p), y = 1E4 * Math.sin(u + y * g), t[f] = e + (q - e) * (y - Math.floor(y)), "x" === v && (t.clientX = t.plotX)));
            });
          });
        }
      });
      a.addEvent(B, "afterTranslate", function () {
        this.applyJitter && this.applyJitter();
      });
    })(H);

    (function (a) {
      var B = a.deg2rad,
          A = a.isNumber,
          G = a.pick,
          m = a.relativeLength;
      a.CenteredSeriesMixin = {
        getCenter: function getCenter() {
          var a = this.options,
              t = this.chart,
              u = 2 * (a.slicedOffset || 0),
              v = t.plotWidth - 2 * u,
              t = t.plotHeight - 2 * u,
              y = a.center,
              y = [G(y[0], "50%"), G(y[1], "50%"), a.size || "100%", a.innerSize || 0],
              q = Math.min(v, t),
              f,
              e;

          for (f = 0; 4 > f; ++f) {
            e = y[f], a = 2 > f || 2 === f && /%$/.test(e), y[f] = m(e, [v, t, q, y[2]][f]) + (a ? u : 0);
          }

          y[3] > y[2] && (y[3] = y[2]);
          return y;
        },
        getStartAndEndRadians: function getStartAndEndRadians(a, m) {
          a = A(a) ? a : 0;
          m = A(m) && m > a && 360 > m - a ? m : a + 360;
          return {
            start: B * (a + -90),
            end: B * (m + -90)
          };
        }
      };
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.CenteredSeriesMixin,
          G = a.defined,
          m = a.extend,
          g = A.getStartAndEndRadians,
          t = a.noop,
          u = a.pick,
          v = a.Point,
          y = a.Series,
          q = a.seriesType,
          f = a.setAnimation;
      q("pie", "line", {
        center: [null, null],
        clip: !1,
        colorByPoint: !0,
        dataLabels: {
          allowOverlap: !0,
          connectorPadding: 5,
          distance: 30,
          enabled: !0,
          formatter: function formatter() {
            return this.point.isNull ? void 0 : this.point.name;
          },
          softConnector: !0,
          x: 0,
          connectorShape: "fixedOffset",
          crookDistance: "70%"
        },
        ignoreHiddenPoint: !0,
        legendType: "point",
        marker: null,
        size: null,
        showInLegend: !1,
        slicedOffset: 10,
        stickyTracking: !1,
        tooltip: {
          followPointer: !0
        },
        borderColor: "#ffffff",
        borderWidth: 1,
        states: {
          hover: {
            brightness: .1
          }
        }
      }, {
        isCartesian: !1,
        requireSorting: !1,
        directTouch: !0,
        noSharedTooltip: !0,
        trackerGroups: ["group", "dataLabelsGroup"],
        axisTypes: [],
        pointAttribs: a.seriesTypes.column.prototype.pointAttribs,
        animate: function animate(a) {
          var e = this,
              f = e.points,
              b = e.startAngleRad;
          a || (f.forEach(function (a) {
            var f = a.graphic,
                d = a.shapeArgs;
            f && (f.attr({
              r: a.startR || e.center[3] / 2,
              start: b,
              end: b
            }), f.animate({
              r: d.r,
              start: d.start,
              end: d.end
            }, e.options.animation));
          }), e.animate = null);
        },
        updateTotals: function updateTotals() {
          var a,
              f = 0,
              g = this.points,
              b = g.length,
              l,
              n = this.options.ignoreHiddenPoint;

          for (a = 0; a < b; a++) {
            l = g[a], f += n && !l.visible ? 0 : l.isNull ? 0 : l.y;
          }

          this.total = f;

          for (a = 0; a < b; a++) {
            l = g[a], l.percentage = 0 < f && (l.visible || !n) ? l.y / f * 100 : 0, l.total = f;
          }
        },
        generatePoints: function generatePoints() {
          y.prototype.generatePoints.call(this);
          this.updateTotals();
        },
        getX: function getX(a, f, g) {
          var b = this.center,
              e = this.radii ? this.radii[g.index] : b[2] / 2;
          return b[0] + (f ? -1 : 1) * Math.cos(Math.asin(Math.max(Math.min((a - b[1]) / (e + g.labelDistance), 1), -1))) * (e + g.labelDistance) + (0 < g.labelDistance ? (f ? -1 : 1) * this.options.dataLabels.padding : 0);
        },
        translate: function translate(a) {
          this.generatePoints();
          var e = 0,
              f = this.options,
              b = f.slicedOffset,
              l = b + (f.borderWidth || 0),
              n,
              d,
              w = g(f.startAngle, f.endAngle),
              q = this.startAngleRad = w.start,
              w = (this.endAngleRad = w.end) - q,
              m = this.points,
              t,
              c,
              k = f.dataLabels.distance,
              f = f.ignoreHiddenPoint,
              x,
              D = m.length,
              h;
          a || (this.center = a = this.getCenter());

          for (x = 0; x < D; x++) {
            h = m[x];
            h.labelDistance = u(h.options.dataLabels && h.options.dataLabels.distance, k);
            this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, h.labelDistance);
            n = q + e * w;
            if (!f || h.visible) e += h.percentage / 100;
            d = q + e * w;
            h.shapeType = "arc";
            h.shapeArgs = {
              x: a[0],
              y: a[1],
              r: a[2] / 2,
              innerR: a[3] / 2,
              start: Math.round(1E3 * n) / 1E3,
              end: Math.round(1E3 * d) / 1E3
            };
            d = (d + n) / 2;
            d > 1.5 * Math.PI ? d -= 2 * Math.PI : d < -Math.PI / 2 && (d += 2 * Math.PI);
            h.slicedTranslation = {
              translateX: Math.round(Math.cos(d) * b),
              translateY: Math.round(Math.sin(d) * b)
            };
            t = Math.cos(d) * a[2] / 2;
            c = Math.sin(d) * a[2] / 2;
            h.tooltipPos = [a[0] + .7 * t, a[1] + .7 * c];
            h.half = d < -Math.PI / 2 || d > Math.PI / 2 ? 1 : 0;
            h.angle = d;
            n = Math.min(l, h.labelDistance / 5);
            h.labelPosition = {
              natural: {
                x: a[0] + t + Math.cos(d) * h.labelDistance,
                y: a[1] + c + Math.sin(d) * h.labelDistance
              },
              "final": {},
              alignment: 0 > h.labelDistance ? "center" : h.half ? "right" : "left",
              connectorPosition: {
                breakAt: {
                  x: a[0] + t + Math.cos(d) * n,
                  y: a[1] + c + Math.sin(d) * n
                },
                touchingSliceAt: {
                  x: a[0] + t,
                  y: a[1] + c
                }
              }
            };
          }
        },
        drawGraph: null,
        drawPoints: function drawPoints() {
          var a = this,
              f = a.chart,
              g = f.renderer,
              b,
              l,
              n,
              d,
              w = a.options.shadow;
          !w || a.shadowGroup || f.styledMode || (a.shadowGroup = g.g("shadow").add(a.group));
          a.points.forEach(function (e) {
            l = e.graphic;
            if (e.isNull) l && (e.graphic = l.destroy());else {
              d = e.shapeArgs;
              b = e.getTranslate();

              if (!f.styledMode) {
                var p = e.shadowGroup;
                w && !p && (p = e.shadowGroup = g.g("shadow").add(a.shadowGroup));
                p && p.attr(b);
                n = a.pointAttribs(e, e.selected && "select");
              }

              l ? (l.setRadialReference(a.center), f.styledMode || l.attr(n), l.animate(m(d, b))) : (e.graphic = l = g[e.shapeType](d).setRadialReference(a.center).attr(b).add(a.group), f.styledMode || l.attr(n).attr({
                "stroke-linejoin": "round"
              }).shadow(w, p));
              l.attr({
                visibility: e.visible ? "inherit" : "hidden"
              });
              l.addClass(e.getClassName());
            }
          });
        },
        searchPoint: t,
        sortByAngle: function sortByAngle(a, f) {
          a.sort(function (a, b) {
            return void 0 !== a.angle && (b.angle - a.angle) * f;
          });
        },
        drawLegendSymbol: a.LegendSymbolMixin.drawRectangle,
        getCenter: A.getCenter,
        getSymbol: t
      }, {
        init: function init() {
          v.prototype.init.apply(this, arguments);
          var a = this,
              f;
          a.name = u(a.name, "Slice");

          f = function f(e) {
            a.slice("select" === e.type);
          };

          B(a, "select", f);
          B(a, "unselect", f);
          return a;
        },
        isValid: function isValid() {
          return a.isNumber(this.y, !0) && 0 <= this.y;
        },
        setVisible: function setVisible(a, f) {
          var e = this,
              b = e.series,
              g = b.chart,
              n = b.options.ignoreHiddenPoint;
          f = u(f, n);
          a !== e.visible && (e.visible = e.options.visible = a = void 0 === a ? !e.visible : a, b.options.data[b.data.indexOf(e)] = e.options, ["graphic", "dataLabel", "connector", "shadowGroup"].forEach(function (b) {
            if (e[b]) e[b][a ? "show" : "hide"](!0);
          }), e.legendItem && g.legend.colorizeItem(e, a), a || "hover" !== e.state || e.setState(""), n && (b.isDirty = !0), f && g.redraw());
        },
        slice: function slice(a, g, q) {
          var b = this.series;
          f(q, b.chart);
          u(g, !0);
          this.sliced = this.options.sliced = G(a) ? a : !this.sliced;
          b.options.data[b.data.indexOf(this)] = this.options;
          this.graphic.animate(this.getTranslate());
          this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
        },
        getTranslate: function getTranslate() {
          return this.sliced ? this.slicedTranslation : {
            translateX: 0,
            translateY: 0
          };
        },
        haloPath: function haloPath(a) {
          var e = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(e.x, e.y, e.r + a, e.r + a, {
            innerR: this.shapeArgs.r - 1,
            start: e.start,
            end: e.end
          });
        },
        connectorShapes: {
          fixedOffset: function fixedOffset(a, f, g) {
            var b = f.breakAt;
            f = f.touchingSliceAt;
            return ["M", a.x, a.y].concat(g.softConnector ? ["C", a.x + ("left" === a.alignment ? -5 : 5), a.y, 2 * b.x - f.x, 2 * b.y - f.y, b.x, b.y] : ["L", b.x, b.y]).concat(["L", f.x, f.y]);
          },
          straight: function straight(a, f) {
            f = f.touchingSliceAt;
            return ["M", a.x, a.y, "L", f.x, f.y];
          },
          crookedLine: function crookedLine(e, f, g) {
            f = f.touchingSliceAt;
            var b = this.series,
                l = b.center[0],
                n = b.chart.plotWidth,
                d = b.chart.plotLeft,
                b = e.alignment,
                w = this.shapeArgs.r;
            g = a.relativeLength(g.crookDistance, 1);
            g = "left" === b ? l + w + (n + d - l - w) * (1 - g) : d + (l - w) * g;
            l = ["L", g, e.y];
            if ("left" === b ? g > e.x || g < f.x : g < e.x || g > f.x) l = [];
            return ["M", e.x, e.y].concat(l).concat(["L", f.x, f.y]);
          }
        },
        getConnectorPath: function getConnectorPath() {
          var a = this.labelPosition,
              f = this.series.options.dataLabels,
              g = f.connectorShape,
              b = this.connectorShapes;
          b[g] && (g = b[g]);
          return g.call(this, {
            x: a.final.x,
            y: a.final.y,
            alignment: a.alignment
          }, a.connectorPosition, f);
        }
      });
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.arrayMax,
          G = a.defined,
          m = a.extend,
          g = a.format,
          t = a.merge,
          u = a.noop,
          v = a.pick,
          y = a.relativeLength,
          q = a.Series,
          f = a.seriesTypes,
          e = a.stableSort,
          p = a.isArray,
          r = a.splat;

      a.distribute = function (b, f, g) {
        function d(a, c) {
          return a.target - c.target;
        }

        var l,
            n = !0,
            p = b,
            q = [],
            c;
        c = 0;
        var k = p.reducedLen || f;

        for (l = b.length; l--;) {
          c += b[l].size;
        }

        if (c > k) {
          e(b, function (a, c) {
            return (c.rank || 0) - (a.rank || 0);
          });

          for (c = l = 0; c <= k;) {
            c += b[l].size, l++;
          }

          q = b.splice(l - 1, b.length);
        }

        e(b, d);

        for (b = b.map(function (a) {
          return {
            size: a.size,
            targets: [a.target],
            align: v(a.align, .5)
          };
        }); n;) {
          for (l = b.length; l--;) {
            n = b[l], c = (Math.min.apply(0, n.targets) + Math.max.apply(0, n.targets)) / 2, n.pos = Math.min(Math.max(0, c - n.size * n.align), f - n.size);
          }

          l = b.length;

          for (n = !1; l--;) {
            0 < l && b[l - 1].pos + b[l - 1].size > b[l].pos && (b[l - 1].size += b[l].size, b[l - 1].targets = b[l - 1].targets.concat(b[l].targets), b[l - 1].align = .5, b[l - 1].pos + b[l - 1].size > f && (b[l - 1].pos = f - b[l - 1].size), b.splice(l, 1), n = !0);
          }
        }

        p.push.apply(p, q);
        l = 0;
        b.some(function (c) {
          var b = 0;
          if (c.targets.some(function () {
            p[l].pos = c.pos + b;
            if (Math.abs(p[l].pos - p[l].target) > g) return p.slice(0, l + 1).forEach(function (a) {
              delete a.pos;
            }), p.reducedLen = (p.reducedLen || f) - .1 * f, p.reducedLen > .1 * f && a.distribute(p, f, g), !0;
            b += p[l].size;
            l++;
          })) return !0;
        });
        e(p, d);
      };

      q.prototype.drawDataLabels = function () {
        function b(a, c) {
          var b = c.filter;
          return b ? (c = b.operator, a = a[b.property], b = b.value, "\x3e" === c && a > b || "\x3c" === c && a < b || "\x3e\x3d" === c && a >= b || "\x3c\x3d" === c && a <= b || "\x3d\x3d" === c && a == b || "\x3d\x3d\x3d" === c && a === b ? !0 : !1) : !0;
        }

        function e(a, c) {
          var b = [],
              d;
          if (p(a) && !p(c)) b = a.map(function (a) {
            return t(a, c);
          });else if (p(c) && !p(a)) b = c.map(function (c) {
            return t(a, c);
          });else if (p(a) || p(c)) for (d = Math.max(a.length, c.length); d--;) {
            b[d] = t(a[d], c[d]);
          } else b = t(a, c);
          return b;
        }

        var f = this,
            d = f.chart,
            q = f.options,
            m = q.dataLabels,
            C = f.points,
            u,
            c = f.hasRendered || 0,
            k,
            x = v(m.defer, !!q.animation),
            D = d.renderer,
            m = e(e(d.options.plotOptions && d.options.plotOptions.series && d.options.plotOptions.series.dataLabels, d.options.plotOptions && d.options.plotOptions[f.type] && d.options.plotOptions[f.type].dataLabels), m);
        a.fireEvent(this, "drawDataLabels");
        if (p(m) || m.enabled || f._hasPointLabels) k = f.plotGroup("dataLabelsGroup", "data-labels", x && !c ? "hidden" : "visible", m.zIndex || 6), x && (k.attr({
          opacity: +c
        }), c || B(f, "afterAnimate", function () {
          f.visible && k.show(!0);
          k[q.animation ? "animate" : "attr"]({
            opacity: 1
          }, {
            duration: 200
          });
        })), C.forEach(function (c) {
          u = r(e(m, c.dlOptions || c.options && c.options.dataLabels));
          u.forEach(function (h, e) {
            var l = h.enabled && !c.isNull && b(c, h),
                n,
                p,
                x,
                w,
                m = c.dataLabels ? c.dataLabels[e] : c.dataLabel,
                r = c.connectors ? c.connectors[e] : c.connector,
                E = !m;
            l && (n = c.getLabelConfig(), p = h[c.formatPrefix + "Format"] || h.format, n = G(p) ? g(p, n, d.time) : (h[c.formatPrefix + "Formatter"] || h.formatter).call(n, h), p = h.style, x = h.rotation, d.styledMode || (p.color = v(h.color, p.color, f.color, "#000000"), "contrast" === p.color && (c.contrastColor = D.getContrast(c.color || f.color), p.color = h.inside || 0 > v(h.distance, c.labelDistance) || q.stacking ? c.contrastColor : "#000000"), q.cursor && (p.cursor = q.cursor)), w = {
              r: h.borderRadius || 0,
              rotation: x,
              padding: h.padding,
              zIndex: 1
            }, d.styledMode || (w.fill = h.backgroundColor, w.stroke = h.borderColor, w["stroke-width"] = h.borderWidth), a.objectEach(w, function (a, c) {
              void 0 === a && delete w[c];
            }));
            !m || l && G(n) ? l && G(n) && (m ? w.text = n : (c.dataLabels = c.dataLabels || [], m = c.dataLabels[e] = x ? D.text(n, 0, -9999).addClass("highcharts-data-label") : D.label(n, 0, -9999, h.shape, null, null, h.useHTML, null, "data-label"), e || (c.dataLabel = m), m.addClass(" highcharts-data-label-color-" + c.colorIndex + " " + (h.className || "") + (h.useHTML ? " highcharts-tracker" : ""))), m.options = h, m.attr(w), d.styledMode || m.css(p).shadow(h.shadow), m.added || m.add(k), f.alignDataLabel(c, m, h, null, E)) : (c.dataLabel = c.dataLabel && c.dataLabel.destroy(), c.dataLabels && (1 === c.dataLabels.length ? delete c.dataLabels : delete c.dataLabels[e]), e || delete c.dataLabel, r && (c.connector = c.connector.destroy(), c.connectors && (1 === c.connectors.length ? delete c.connectors : delete c.connectors[e])));
          });
        });
        a.fireEvent(this, "afterDrawDataLabels");
      };

      q.prototype.alignDataLabel = function (a, e, f, d, g) {
        var b = this.chart,
            l = this.isCartesian && b.inverted,
            n = v(a.dlBox && a.dlBox.centerX, a.plotX, -9999),
            c = v(a.plotY, -9999),
            k = e.getBBox(),
            p,
            q = f.rotation,
            h = f.align,
            w = this.visible && (a.series.forceDL || b.isInsidePlot(n, Math.round(c), l) || d && b.isInsidePlot(n, l ? d.x + 1 : d.y + d.height - 1, l)),
            r = "justify" === v(f.overflow, "justify");
        if (w && (p = b.renderer.fontMetrics(b.styledMode ? void 0 : f.style.fontSize, e).b, d = m({
          x: l ? this.yAxis.len - c : n,
          y: Math.round(l ? this.xAxis.len - n : c),
          width: 0,
          height: 0
        }, d), m(f, {
          width: k.width,
          height: k.height
        }), q ? (r = !1, n = b.renderer.rotCorr(p, q), n = {
          x: d.x + f.x + d.width / 2 + n.x,
          y: d.y + f.y + {
            top: 0,
            middle: .5,
            bottom: 1
          }[f.verticalAlign] * d.height
        }, e[g ? "attr" : "animate"](n).attr({
          align: h
        }), c = (q + 720) % 360, c = 180 < c && 360 > c, "left" === h ? n.y -= c ? k.height : 0 : "center" === h ? (n.x -= k.width / 2, n.y -= k.height / 2) : "right" === h && (n.x -= k.width, n.y -= c ? 0 : k.height), e.placed = !0, e.alignAttr = n) : (e.align(f, null, d), n = e.alignAttr), r && 0 <= d.height ? a.isLabelJustified = this.justifyDataLabel(e, f, n, k, d, g) : v(f.crop, !0) && (w = b.isInsidePlot(n.x, n.y) && b.isInsidePlot(n.x + k.width, n.y + k.height)), f.shape && !q)) e[g ? "attr" : "animate"]({
          anchorX: l ? b.plotWidth - a.plotY : a.plotX,
          anchorY: l ? b.plotHeight - a.plotX : a.plotY
        });
        w || (e.attr({
          y: -9999
        }), e.placed = !1);
      };

      q.prototype.justifyDataLabel = function (a, e, f, d, g, p) {
        var b = this.chart,
            l = e.align,
            c = e.verticalAlign,
            k,
            n,
            q = a.box ? 0 : a.padding || 0;
        k = f.x + q;
        0 > k && ("right" === l ? e.align = "left" : e.x = -k, n = !0);
        k = f.x + d.width - q;
        k > b.plotWidth && ("left" === l ? e.align = "right" : e.x = b.plotWidth - k, n = !0);
        k = f.y + q;
        0 > k && ("bottom" === c ? e.verticalAlign = "top" : e.y = -k, n = !0);
        k = f.y + d.height - q;
        k > b.plotHeight && ("top" === c ? e.verticalAlign = "bottom" : e.y = b.plotHeight - k, n = !0);
        n && (a.placed = !p, a.align(e, null, g));
        return n;
      };

      f.pie && (f.pie.prototype.dataLabelPositioners = {
        radialDistributionY: function radialDistributionY(a) {
          return a.top + a.distributeBox.pos;
        },
        radialDistributionX: function radialDistributionX(a, e, f, d) {
          return a.getX(f < e.top + 2 || f > e.bottom - 2 ? d : f, e.half, e);
        },
        justify: function justify(a, e, f) {
          return f[0] + (a.half ? -1 : 1) * (e + a.labelDistance);
        },
        alignToPlotEdges: function alignToPlotEdges(a, e, f, d) {
          a = a.getBBox().width;
          return e ? a + d : f - a - d;
        },
        alignToConnectors: function alignToConnectors(a, e, f, d) {
          var b = 0,
              g;
          a.forEach(function (a) {
            g = a.dataLabel.getBBox().width;
            g > b && (b = g);
          });
          return e ? b + d : f - b - d;
        }
      }, f.pie.prototype.drawDataLabels = function () {
        var b = this,
            e = b.data,
            f,
            d = b.chart,
            g = b.options.dataLabels,
            p = g.connectorPadding,
            m = v(g.connectorWidth, 1),
            r = d.plotWidth,
            c = d.plotHeight,
            k = d.plotLeft,
            x = Math.round(d.chartWidth / 3),
            t,
            h = b.center,
            z = h[2] / 2,
            u = h[1],
            y,
            B,
            I,
            O,
            R = [[], []],
            K,
            S,
            H,
            T,
            P = [0, 0, 0, 0],
            U = b.dataLabelPositioners;
        b.visible && (g.enabled || b._hasPointLabels) && (e.forEach(function (a) {
          a.dataLabel && a.visible && a.dataLabel.shortened && (a.dataLabel.attr({
            width: "auto"
          }).css({
            width: "auto",
            textOverflow: "clip"
          }), a.dataLabel.shortened = !1);
        }), q.prototype.drawDataLabels.apply(b), e.forEach(function (a) {
          a.dataLabel && (a.visible ? (R[a.half].push(a), a.dataLabel._pos = null, !G(g.style.width) && !G(a.options.dataLabels && a.options.dataLabels.style && a.options.dataLabels.style.width) && a.dataLabel.getBBox().width > x && (a.dataLabel.css({
            width: .7 * x
          }), a.dataLabel.shortened = !0)) : (a.dataLabel = a.dataLabel.destroy(), a.dataLabels && 1 === a.dataLabels.length && delete a.dataLabels));
        }), R.forEach(function (e, l) {
          var n,
              q,
              x = e.length,
              m = [],
              w;
          if (x) for (b.sortByAngle(e, l - .5), 0 < b.maxLabelDistance && (n = Math.max(0, u - z - b.maxLabelDistance), q = Math.min(u + z + b.maxLabelDistance, d.plotHeight), e.forEach(function (a) {
            0 < a.labelDistance && a.dataLabel && (a.top = Math.max(0, u - z - a.labelDistance), a.bottom = Math.min(u + z + a.labelDistance, d.plotHeight), w = a.dataLabel.getBBox().height || 21, a.distributeBox = {
              target: a.labelPosition.natural.y - a.top + w / 2,
              size: w,
              rank: a.y
            }, m.push(a.distributeBox));
          }), n = q + w - n, a.distribute(m, n, n / 5)), T = 0; T < x; T++) {
            f = e[T];
            I = f.labelPosition;
            y = f.dataLabel;
            H = !1 === f.visible ? "hidden" : "inherit";
            S = n = I.natural.y;
            m && G(f.distributeBox) && (void 0 === f.distributeBox.pos ? H = "hidden" : (O = f.distributeBox.size, S = U.radialDistributionY(f)));
            delete f.positionIndex;
            if (g.justify) K = U.justify(f, z, h);else switch (g.alignTo) {
              case "connectors":
                K = U.alignToConnectors(e, l, r, k);
                break;

              case "plotEdges":
                K = U.alignToPlotEdges(y, l, r, k);
                break;

              default:
                K = U.radialDistributionX(b, f, S, n);
            }
            y._attr = {
              visibility: H,
              align: I.alignment
            };
            y._pos = {
              x: K + g.x + ({
                left: p,
                right: -p
              }[I.alignment] || 0),
              y: S + g.y - 10
            };
            I.final.x = K;
            I.final.y = S;
            v(g.crop, !0) && (B = y.getBBox().width, n = null, K - B < p && 1 === l ? (n = Math.round(B - K + p), P[3] = Math.max(n, P[3])) : K + B > r - p && 0 === l && (n = Math.round(K + B - r + p), P[1] = Math.max(n, P[1])), 0 > S - O / 2 ? P[0] = Math.max(Math.round(-S + O / 2), P[0]) : S + O / 2 > c && (P[2] = Math.max(Math.round(S + O / 2 - c), P[2])), y.sideOverflow = n);
          }
        }), 0 === A(P) || this.verifyDataLabelOverflow(P)) && (this.placeDataLabels(), m && this.points.forEach(function (a) {
          var c;
          t = a.connector;

          if ((y = a.dataLabel) && y._pos && a.visible && 0 < a.labelDistance) {
            H = y._attr.visibility;
            if (c = !t) a.connector = t = d.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + a.colorIndex + (a.className ? " " + a.className : "")).add(b.dataLabelsGroup), d.styledMode || t.attr({
              "stroke-width": m,
              stroke: g.connectorColor || a.color || "#666666"
            });
            t[c ? "attr" : "animate"]({
              d: a.getConnectorPath()
            });
            t.attr("visibility", H);
          } else t && (a.connector = t.destroy());
        }));
      }, f.pie.prototype.placeDataLabels = function () {
        this.points.forEach(function (a) {
          var b = a.dataLabel;
          b && a.visible && ((a = b._pos) ? (b.sideOverflow && (b._attr.width = b.getBBox().width - b.sideOverflow, b.css({
            width: b._attr.width + "px",
            textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis"
          }), b.shortened = !0), b.attr(b._attr), b[b.moved ? "animate" : "attr"](a), b.moved = !0) : b && b.attr({
            y: -9999
          }));
        }, this);
      }, f.pie.prototype.alignDataLabel = u, f.pie.prototype.verifyDataLabelOverflow = function (a) {
        var b = this.center,
            e = this.options,
            d = e.center,
            f = e.minSize || 80,
            g,
            p = null !== e.size;
        p || (null !== d[0] ? g = Math.max(b[2] - Math.max(a[1], a[3]), f) : (g = Math.max(b[2] - a[1] - a[3], f), b[0] += (a[3] - a[1]) / 2), null !== d[1] ? g = Math.max(Math.min(g, b[2] - Math.max(a[0], a[2])), f) : (g = Math.max(Math.min(g, b[2] - a[0] - a[2]), f), b[1] += (a[0] - a[2]) / 2), g < b[2] ? (b[2] = g, b[3] = Math.min(y(e.innerSize || 0, g), g), this.translate(b), this.drawDataLabels && this.drawDataLabels()) : p = !0);
        return p;
      });
      f.column && (f.column.prototype.alignDataLabel = function (a, e, f, d, g) {
        var b = this.chart.inverted,
            l = a.series,
            n = a.dlBox || a.shapeArgs,
            c = v(a.below, a.plotY > v(this.translatedThreshold, l.yAxis.len)),
            k = v(f.inside, !!this.options.stacking);
        n && (d = t(n), 0 > d.y && (d.height += d.y, d.y = 0), n = d.y + d.height - l.yAxis.len, 0 < n && (d.height -= n), b && (d = {
          x: l.yAxis.len - d.y - d.height,
          y: l.xAxis.len - d.x - d.width,
          width: d.height,
          height: d.width
        }), k || (b ? (d.x += c ? 0 : d.width, d.width = 0) : (d.y += c ? d.height : 0, d.height = 0)));
        f.align = v(f.align, !b || k ? "center" : c ? "right" : "left");
        f.verticalAlign = v(f.verticalAlign, b || k ? "middle" : c ? "top" : "bottom");
        q.prototype.alignDataLabel.call(this, a, e, f, d, g);
        a.isLabelJustified && a.contrastColor && e.css({
          color: a.contrastColor
        });
      });
    })(H);

    (function (a) {
      var B = a.Chart,
          A = a.isArray,
          G = a.objectEach,
          m = a.pick,
          g = a.addEvent,
          t = a.fireEvent;
      g(B, "render", function () {
        var a = [];
        (this.labelCollectors || []).forEach(function (g) {
          a = a.concat(g());
        });
        (this.yAxis || []).forEach(function (g) {
          g.options.stackLabels && !g.options.stackLabels.allowOverlap && G(g.stacks, function (g) {
            G(g, function (g) {
              a.push(g.label);
            });
          });
        });
        (this.series || []).forEach(function (g) {
          var t = g.options.dataLabels;
          g.visible && (!1 !== t.enabled || g._hasPointLabels) && g.points.forEach(function (g) {
            g.visible && (A(g.dataLabels) ? g.dataLabels : g.dataLabel ? [g.dataLabel] : []).forEach(function (f) {
              var e = f.options;
              f.labelrank = m(e.labelrank, g.labelrank, g.shapeArgs && g.shapeArgs.height);
              e.allowOverlap || a.push(f);
            });
          });
        });
        this.hideOverlappingLabels(a);
      });

      B.prototype.hideOverlappingLabels = function (a) {
        var g = this,
            m = a.length,
            q = g.renderer,
            f,
            e,
            p,
            r,
            b,
            l,
            n = function n(a, b, e, f, g, c, k, l) {
          return !(g > a + e || g + k < a || c > b + f || c + l < b);
        };

        p = function p(a) {
          var b,
              d,
              e,
              f = a.box ? 0 : a.padding || 0;
          e = 0;
          if (a && (!a.alignAttr || a.placed)) return b = a.alignAttr || {
            x: a.attr("x"),
            y: a.attr("y")
          }, d = a.parentGroup, a.width || (e = a.getBBox(), a.width = e.width, a.height = e.height, e = q.fontMetrics(null, a.element).h), {
            x: b.x + (d.translateX || 0) + f,
            y: b.y + (d.translateY || 0) + f - e,
            width: a.width - 2 * f,
            height: a.height - 2 * f
          };
        };

        for (e = 0; e < m; e++) {
          if (f = a[e]) f.oldOpacity = f.opacity, f.newOpacity = 1, f.absoluteBox = p(f);
        }

        a.sort(function (a, b) {
          return (b.labelrank || 0) - (a.labelrank || 0);
        });

        for (e = 0; e < m; e++) {
          for (l = (p = a[e]) && p.absoluteBox, f = e + 1; f < m; ++f) {
            if (b = (r = a[f]) && r.absoluteBox, l && b && p !== r && 0 !== p.newOpacity && 0 !== r.newOpacity && (b = n(l.x, l.y, l.width, l.height, b.x, b.y, b.width, b.height))) (p.labelrank < r.labelrank ? p : r).newOpacity = 0;
          }
        }

        a.forEach(function (a) {
          var b, d;
          a && (d = a.newOpacity, a.oldOpacity !== d && (a.alignAttr && a.placed ? (d ? a.show(!0) : b = function b() {
            a.hide();
          }, a.alignAttr.opacity = d, a[a.isOld ? "animate" : "attr"](a.alignAttr, null, b), t(g, "afterHideOverlappingLabels")) : a.attr({
            opacity: d
          })), a.isOld = !0);
        });
      };
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.Chart,
          G = a.createElement,
          m = a.css,
          g = a.defaultOptions,
          t = a.defaultPlotOptions,
          u = a.extend,
          v = a.fireEvent,
          y = a.hasTouch,
          q = a.isObject,
          f = a.Legend,
          e = a.merge,
          p = a.pick,
          r = a.Point,
          b = a.Series,
          l = a.seriesTypes,
          n = a.svg,
          d;
      d = a.TrackerMixin = {
        drawTrackerPoint: function drawTrackerPoint() {
          var a = this,
              b = a.chart,
              d = b.pointer,
              e = function e(a) {
            var c = d.getPointFromEvent(a);
            void 0 !== c && (d.isDirectTouch = !0, c.onMouseOver(a));
          };

          a.points.forEach(function (a) {
            a.graphic && (a.graphic.element.point = a);
            a.dataLabel && (a.dataLabel.div ? a.dataLabel.div.point = a : a.dataLabel.element.point = a);
          });
          a._hasTracking || (a.trackerGroups.forEach(function (c) {
            if (a[c]) {
              a[c].addClass("highcharts-tracker").on("mouseover", e).on("mouseout", function (a) {
                d.onTrackerMouseOut(a);
              });
              if (y) a[c].on("touchstart", e);
              !b.styledMode && a.options.cursor && a[c].css(m).css({
                cursor: a.options.cursor
              });
            }
          }), a._hasTracking = !0);
          v(this, "afterDrawTracker");
        },
        drawTrackerGraph: function drawTrackerGraph() {
          var a = this,
              b = a.options,
              d = b.trackByArea,
              e = [].concat(d ? a.areaPath : a.graphPath),
              c = e.length,
              k = a.chart,
              f = k.pointer,
              g = k.renderer,
              h = k.options.tooltip.snap,
              l = a.tracker,
              p,
              q = function q() {
            if (k.hoverSeries !== a) a.onMouseOver();
          },
              m = "rgba(192,192,192," + (n ? .0001 : .002) + ")";

          if (c && !d) for (p = c + 1; p--;) {
            "M" === e[p] && e.splice(p + 1, 0, e[p + 1] - h, e[p + 2], "L"), (p && "M" === e[p] || p === c) && e.splice(p, 0, "L", e[p - 2] + h, e[p - 1]);
          }
          l ? l.attr({
            d: e
          }) : a.graph && (a.tracker = g.path(e).attr({
            visibility: a.visible ? "visible" : "hidden",
            zIndex: 2
          }).addClass(d ? "highcharts-tracker-area" : "highcharts-tracker-line").add(a.group), k.styledMode || a.tracker.attr({
            "stroke-linejoin": "round",
            stroke: m,
            fill: d ? m : "none",
            "stroke-width": a.graph.strokeWidth() + (d ? 0 : 2 * h)
          }), [a.tracker, a.markerGroup].forEach(function (a) {
            a.addClass("highcharts-tracker").on("mouseover", q).on("mouseout", function (a) {
              f.onTrackerMouseOut(a);
            });
            b.cursor && !k.styledMode && a.css({
              cursor: b.cursor
            });
            if (y) a.on("touchstart", q);
          }));
          v(this, "afterDrawTracker");
        }
      };
      l.column && (l.column.prototype.drawTracker = d.drawTrackerPoint);
      l.pie && (l.pie.prototype.drawTracker = d.drawTrackerPoint);
      l.scatter && (l.scatter.prototype.drawTracker = d.drawTrackerPoint);
      u(f.prototype, {
        setItemEvents: function setItemEvents(a, b, d) {
          var f = this,
              c = f.chart.renderer.boxWrapper,
              k = "highcharts-legend-" + (a instanceof r ? "point" : "series") + "-active",
              g = f.chart.styledMode;
          (d ? b : a.legendGroup).on("mouseover", function () {
            a.setState("hover");
            c.addClass(k);
            g || b.css(f.options.itemHoverStyle);
          }).on("mouseout", function () {
            f.styledMode || b.css(e(a.visible ? f.itemStyle : f.itemHiddenStyle));
            c.removeClass(k);
            a.setState();
          }).on("click", function (b) {
            var d = function d() {
              a.setVisible && a.setVisible();
            };

            c.removeClass(k);
            b = {
              browserEvent: b
            };
            a.firePointEvent ? a.firePointEvent("legendItemClick", b, d) : v(a, "legendItemClick", b, d);
          });
        },
        createCheckboxForItem: function createCheckboxForItem(a) {
          a.checkbox = G("input", {
            type: "checkbox",
            className: "highcharts-legend-checkbox",
            checked: a.selected,
            defaultChecked: a.selected
          }, this.options.itemCheckboxStyle, this.chart.container);
          B(a.checkbox, "click", function (b) {
            v(a.series || a, "checkboxClick", {
              checked: b.target.checked,
              item: a
            }, function () {
              a.select();
            });
          });
        }
      });
      u(A.prototype, {
        showResetZoom: function showResetZoom() {
          function a() {
            b.zoomOut();
          }

          var b = this,
              d = g.lang,
              e = b.options.chart.resetZoomButton,
              c = e.theme,
              k = c.states,
              f = "chart" === e.relativeTo ? null : "plotBox";
          v(this, "beforeShowResetZoom", null, function () {
            b.resetZoomButton = b.renderer.button(d.resetZoom, null, null, a, c, k && k.hover).attr({
              align: e.position.align,
              title: d.resetZoomTitle
            }).addClass("highcharts-reset-zoom").add().align(e.position, !1, f);
          });
        },
        zoomOut: function zoomOut() {
          v(this, "selection", {
            resetSelection: !0
          }, this.zoom);
        },
        zoom: function zoom(a) {
          var b,
              d = this.pointer,
              e = !1,
              c;
          !a || a.resetSelection ? (this.axes.forEach(function (a) {
            b = a.zoom();
          }), d.initiated = !1) : a.xAxis.concat(a.yAxis).forEach(function (a) {
            var c = a.axis;
            d[c.isXAxis ? "zoomX" : "zoomY"] && (b = c.zoom(a.min, a.max), c.displayBtn && (e = !0));
          });
          c = this.resetZoomButton;
          e && !c ? this.showResetZoom() : !e && q(c) && (this.resetZoomButton = c.destroy());
          b && this.redraw(p(this.options.chart.animation, a && a.animation, 100 > this.pointCount));
        },
        pan: function pan(a, b) {
          var d = this,
              e = d.hoverPoints,
              c;
          v(this, "pan", {
            originalEvent: a
          }, function () {
            e && e.forEach(function (a) {
              a.setState();
            });
            ("xy" === b ? [1, 0] : [1]).forEach(function (b) {
              b = d[b ? "xAxis" : "yAxis"][0];
              var k = b.horiz,
                  e = a[k ? "chartX" : "chartY"],
                  k = k ? "mouseDownX" : "mouseDownY",
                  h = d[k],
                  f = (b.pointRange || 0) / 2,
                  g = b.reversed && !d.inverted || !b.reversed && d.inverted ? -1 : 1,
                  l = b.getExtremes(),
                  n = b.toValue(h - e, !0) + f * g,
                  g = b.toValue(h + b.len - e, !0) - f * g,
                  p = g < n,
                  h = p ? g : n,
                  n = p ? n : g,
                  g = Math.min(l.dataMin, f ? l.min : b.toValue(b.toPixels(l.min) - b.minPixelPadding)),
                  f = Math.max(l.dataMax, f ? l.max : b.toValue(b.toPixels(l.max) + b.minPixelPadding)),
                  p = g - h;
              0 < p && (n += p, h = g);
              p = n - f;
              0 < p && (n = f, h -= p);
              b.series.length && h !== l.min && n !== l.max && (b.setExtremes(h, n, !1, !1, {
                trigger: "pan"
              }), c = !0);
              d[k] = e;
            });
            c && d.redraw(!1);
            m(d.container, {
              cursor: "move"
            });
          });
        }
      });
      u(r.prototype, {
        select: function select(a, b) {
          var d = this,
              e = d.series,
              c = e.chart;
          a = p(a, !d.selected);
          d.firePointEvent(a ? "select" : "unselect", {
            accumulate: b
          }, function () {
            d.selected = d.options.selected = a;
            e.options.data[e.data.indexOf(d)] = d.options;
            d.setState(a && "select");
            b || c.getSelectedPoints().forEach(function (a) {
              a.selected && a !== d && (a.selected = a.options.selected = !1, e.options.data[e.data.indexOf(a)] = a.options, a.setState(""), a.firePointEvent("unselect"));
            });
          });
        },
        onMouseOver: function onMouseOver(a) {
          var b = this.series.chart,
              d = b.pointer;
          a = a ? d.normalize(a) : d.getChartCoordinatesFromPoint(this, b.inverted);
          d.runPointActions(a, this);
        },
        onMouseOut: function onMouseOut() {
          var a = this.series.chart;
          this.firePointEvent("mouseOut");
          (a.hoverPoints || []).forEach(function (a) {
            a.setState();
          });
          a.hoverPoints = a.hoverPoint = null;
        },
        importEvents: function importEvents() {
          if (!this.hasImportedEvents) {
            var b = this,
                d = e(b.series.options.point, b.options).events;
            b.events = d;
            a.objectEach(d, function (a, d) {
              B(b, d, a);
            });
            this.hasImportedEvents = !0;
          }
        },
        setState: function setState(a, b) {
          var d = Math.floor(this.plotX),
              e = this.plotY,
              c = this.series,
              k = c.options.states[a || "normal"] || {},
              f = t[c.type].marker && c.options.marker,
              g = f && !1 === f.enabled,
              h = f && f.states && f.states[a || "normal"] || {},
              l = !1 === h.enabled,
              n = c.stateMarkerGraphic,
              q = this.marker || {},
              m = c.chart,
              r = c.halo,
              w,
              E = f && c.markerAttribs;
          a = a || "";

          if (!(a === this.state && !b || this.selected && "select" !== a || !1 === k.enabled || a && (l || g && !1 === h.enabled) || a && q.states && q.states[a] && !1 === q.states[a].enabled)) {
            E && (w = c.markerAttribs(this, a));
            if (this.graphic) this.state && this.graphic.removeClass("highcharts-point-" + this.state), a && this.graphic.addClass("highcharts-point-" + a), m.styledMode || this.graphic.animate(c.pointAttribs(this, a), p(m.options.chart.animation, k.animation)), w && this.graphic.animate(w, p(m.options.chart.animation, h.animation, f.animation)), n && n.hide();else {
              if (a && h) {
                f = q.symbol || c.symbol;
                n && n.currentSymbol !== f && (n = n.destroy());
                if (n) n[b ? "animate" : "attr"]({
                  x: w.x,
                  y: w.y
                });else f && (c.stateMarkerGraphic = n = m.renderer.symbol(f, w.x, w.y, w.width, w.height).add(c.markerGroup), n.currentSymbol = f);
                !m.styledMode && n && n.attr(c.pointAttribs(this, a));
              }

              n && (n[a && m.isInsidePlot(d, e, m.inverted) ? "show" : "hide"](), n.element.point = this);
            }
            (d = k.halo) && d.size ? (r || (c.halo = r = m.renderer.path().add((this.graphic || n).parentGroup)), r.show()[b ? "animate" : "attr"]({
              d: this.haloPath(d.size)
            }), r.attr({
              "class": "highcharts-halo highcharts-color-" + p(this.colorIndex, c.colorIndex) + (this.className ? " " + this.className : ""),
              zIndex: -1
            }), r.point = this, m.styledMode || r.attr(u({
              fill: this.color || c.color,
              "fill-opacity": d.opacity
            }, d.attributes))) : r && r.point && r.point.haloPath && r.animate({
              d: r.point.haloPath(0)
            }, null, r.hide);
            this.state = a;
            v(this, "afterSetState");
          }
        },
        haloPath: function haloPath(a) {
          return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX) - a, this.plotY - a, 2 * a, 2 * a);
        }
      });
      u(b.prototype, {
        onMouseOver: function onMouseOver() {
          var a = this.chart,
              b = a.hoverSeries;
          if (b && b !== this) b.onMouseOut();
          this.options.events.mouseOver && v(this, "mouseOver");
          this.setState("hover");
          a.hoverSeries = this;
        },
        onMouseOut: function onMouseOut() {
          var a = this.options,
              b = this.chart,
              d = b.tooltip,
              e = b.hoverPoint;
          b.hoverSeries = null;
          if (e) e.onMouseOut();
          this && a.events.mouseOut && v(this, "mouseOut");
          !d || this.stickyTracking || d.shared && !this.noSharedTooltip || d.hide();
          this.setState();
        },
        setState: function setState(a) {
          var b = this,
              d = b.options,
              e = b.graph,
              c = d.states,
              k = d.lineWidth,
              d = 0;
          a = a || "";
          if (b.state !== a && ([b.group, b.markerGroup, b.dataLabelsGroup].forEach(function (c) {
            c && (b.state && c.removeClass("highcharts-series-" + b.state), a && c.addClass("highcharts-series-" + a));
          }), b.state = a, !(b.chart.styledMode || c[a] && !1 === c[a].enabled) && (a && (k = c[a].lineWidth || k + (c[a].lineWidthPlus || 0)), e && !e.dashstyle))) for (k = {
            "stroke-width": k
          }, e.animate(k, p(c[a || "normal"] && c[a || "normal"].animation, b.chart.options.chart.animation)); b["zone-graph-" + d];) {
            b["zone-graph-" + d].attr(k), d += 1;
          }
        },
        setVisible: function setVisible(a, b) {
          var d = this,
              e = d.chart,
              c = d.legendItem,
              k,
              f = e.options.chart.ignoreHiddenSeries,
              g = d.visible;
          k = (d.visible = a = d.options.visible = d.userOptions.visible = void 0 === a ? !g : a) ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach(function (a) {
            if (d[a]) d[a][k]();
          });
          if (e.hoverSeries === d || (e.hoverPoint && e.hoverPoint.series) === d) d.onMouseOut();
          c && e.legend.colorizeItem(d, a);
          d.isDirty = !0;
          d.options.stacking && e.series.forEach(function (a) {
            a.options.stacking && a.visible && (a.isDirty = !0);
          });
          d.linkedSeries.forEach(function (c) {
            c.setVisible(a, !1);
          });
          f && (e.isDirtyBox = !0);
          v(d, k);
          !1 !== b && e.redraw();
        },
        show: function show() {
          this.setVisible(!0);
        },
        hide: function hide() {
          this.setVisible(!1);
        },
        select: function select(a) {
          this.selected = a = this.options.selected = void 0 === a ? !this.selected : a;
          this.checkbox && (this.checkbox.checked = a);
          v(this, a ? "select" : "unselect");
        },
        drawTracker: d.drawTrackerGraph
      });
    })(H);

    (function (a) {
      var B = a.Chart,
          A = a.isArray,
          G = a.isObject,
          m = a.pick,
          g = a.splat;

      B.prototype.setResponsive = function (g, m) {
        var t = this.options.responsive,
            u = [],
            q = this.currentResponsive;
        !m && t && t.rules && t.rules.forEach(function (f) {
          void 0 === f._id && (f._id = a.uniqueKey());
          this.matchResponsiveRule(f, u, g);
        }, this);
        m = a.merge.apply(0, u.map(function (f) {
          return a.find(t.rules, function (a) {
            return a._id === f;
          }).chartOptions;
        }));
        m.isResponsiveOptions = !0;
        u = u.toString() || void 0;
        u !== (q && q.ruleIds) && (q && this.update(q.undoOptions, g), u ? (q = this.currentOptions(m), q.isResponsiveOptions = !0, this.currentResponsive = {
          ruleIds: u,
          mergedOptions: m,
          undoOptions: q
        }, this.update(m, g)) : this.currentResponsive = void 0);
      };

      B.prototype.matchResponsiveRule = function (a, g) {
        var t = a.condition;
        (t.callback || function () {
          return this.chartWidth <= m(t.maxWidth, Number.MAX_VALUE) && this.chartHeight <= m(t.maxHeight, Number.MAX_VALUE) && this.chartWidth >= m(t.minWidth, 0) && this.chartHeight >= m(t.minHeight, 0);
        }).call(this) && g.push(a._id);
      };

      B.prototype.currentOptions = function (m) {
        function t(m, q, f, e) {
          var p;
          a.objectEach(m, function (a, b) {
            if (!e && -1 < ["series", "xAxis", "yAxis"].indexOf(b)) for (a = g(a), f[b] = [], p = 0; p < a.length; p++) {
              q[b][p] && (f[b][p] = {}, t(a[p], q[b][p], f[b][p], e + 1));
            } else G(a) ? (f[b] = A(a) ? [] : {}, t(a, q[b] || {}, f[b], e + 1)) : f[b] = q[b] || null;
          });
        }

        var v = {};
        t(m, this.options, v, 0);
        return v;
      };
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.Axis,
          G = a.Chart,
          m = a.css,
          g = a.defined,
          t = a.extend,
          u = a.noop,
          v = a.pick,
          y = a.timeUnits;
      B(a.Series, "updatedData", function () {
        var a = this.xAxis;
        a && a.options.ordinal && delete a.ordinalIndex;
      });

      A.prototype.getTimeTicks = function (a, f, e, p, m, b, l) {
        var n = 0,
            d,
            q,
            r = {},
            t,
            v,
            c,
            k = [],
            x = -Number.MAX_VALUE,
            D = this.options.tickPixelInterval,
            h = this.chart.time,
            z = [];
        if (!this.options.ordinal && !this.options.breaks || !m || 3 > m.length || void 0 === f) return h.getTimeTicks.apply(h, arguments);
        v = m.length;

        for (d = 0; d < v; d++) {
          c = d && m[d - 1] > e;
          m[d] < f && (n = d);

          if (d === v - 1 || m[d + 1] - m[d] > 5 * b || c) {
            if (m[d] > x) {
              for (q = h.getTimeTicks(a, m[n], m[d], p); q.length && q[0] <= x;) {
                q.shift();
              }

              q.length && (x = q[q.length - 1]);
              z.push(k.length);
              k = k.concat(q);
            }

            n = d + 1;
          }

          if (c) break;
        }

        q = q.info;

        if (l && q.unitRange <= y.hour) {
          d = k.length - 1;

          for (n = 1; n < d; n++) {
            h.dateFormat("%d", k[n]) !== h.dateFormat("%d", k[n - 1]) && (r[k[n]] = "day", t = !0);
          }

          t && (r[k[0]] = "day");
          q.higherRanks = r;
        }

        q.segmentStarts = z;
        k.info = q;

        if (l && g(D)) {
          n = z = k.length;
          t = [];

          for (var u, h = []; n--;) {
            d = this.translate(k[n]), u && (h[n] = u - d), t[n] = u = d;
          }

          h.sort();
          h = h[Math.floor(h.length / 2)];
          h < .6 * D && (h = null);
          n = k[z - 1] > e ? z - 1 : z;

          for (u = void 0; n--;) {
            d = t[n], z = Math.abs(u - d), u && z < .8 * D && (null === h || z < .8 * h) ? (r[k[n]] && !r[k[n + 1]] ? (z = n + 1, u = d) : z = n, k.splice(z, 1)) : u = d;
          }
        }

        return k;
      };

      t(A.prototype, {
        beforeSetTickPositions: function beforeSetTickPositions() {
          var a,
              f = [],
              e,
              g = !1,
              m,
              b = this.getExtremes(),
              l = b.min,
              n = b.max,
              d,
              w = this.isXAxis && !!this.options.breaks,
              b = this.options.ordinal,
              t = Number.MAX_VALUE,
              u = this.chart.options.chart.ignoreHiddenSeries,
              y;

          if (b || w) {
            this.series.forEach(function (c, b) {
              e = [];

              if (!(u && !1 === c.visible || !1 === c.takeOrdinalPosition && !w) && (f = f.concat(c.processedXData), a = f.length, f.sort(function (a, b) {
                return a - b;
              }), t = Math.min(t, v(c.closestPointRange, t)), a)) {
                for (b = 0; b < a - 1;) {
                  f[b] !== f[b + 1] && e.push(f[b + 1]), b++;
                }

                e[0] !== f[0] && e.unshift(f[0]);
                f = e;
              }

              c.isSeriesBoosting && (y = !0);
            });
            y && (f.length = 0);
            a = f.length;

            if (2 < a) {
              m = f[1] - f[0];

              for (d = a - 1; d-- && !g;) {
                f[d + 1] - f[d] !== m && (g = !0);
              }

              !this.options.keepOrdinalPadding && (f[0] - l > m || n - f[f.length - 1] > m) && (g = !0);
            } else this.options.overscroll && (2 === a ? t = f[1] - f[0] : 1 === a ? (t = this.options.overscroll, f = [f[0], f[0] + t]) : t = this.overscrollPointsRange);

            g ? (this.options.overscroll && (this.overscrollPointsRange = t, f = f.concat(this.getOverscrollPositions())), this.ordinalPositions = f, m = this.ordinal2lin(Math.max(l, f[0]), !0), d = Math.max(this.ordinal2lin(Math.min(n, f[f.length - 1]), !0), 1), this.ordinalSlope = n = (n - l) / (d - m), this.ordinalOffset = l - m * n) : (this.overscrollPointsRange = v(this.closestPointRange, this.overscrollPointsRange), this.ordinalPositions = this.ordinalSlope = this.ordinalOffset = void 0);
          }

          this.isOrdinal = b && g;
          this.groupIntervalFactor = null;
        },
        val2lin: function val2lin(a, f) {
          var e = this.ordinalPositions;

          if (e) {
            var g = e.length,
                m,
                b;

            for (m = g; m--;) {
              if (e[m] === a) {
                b = m;
                break;
              }
            }

            for (m = g - 1; m--;) {
              if (a > e[m] || 0 === m) {
                a = (a - e[m]) / (e[m + 1] - e[m]);
                b = m + a;
                break;
              }
            }

            f = f ? b : this.ordinalSlope * (b || 0) + this.ordinalOffset;
          } else f = a;

          return f;
        },
        lin2val: function lin2val(a, f) {
          var e = this.ordinalPositions;

          if (e) {
            var g = this.ordinalSlope,
                m = this.ordinalOffset,
                b = e.length - 1,
                l;
            if (f) 0 > a ? a = e[0] : a > b ? a = e[b] : (b = Math.floor(a), l = a - b);else for (; b--;) {
              if (f = g * b + m, a >= f) {
                g = g * (b + 1) + m;
                l = (a - f) / (g - f);
                break;
              }
            }
            return void 0 !== l && void 0 !== e[b] ? e[b] + (l ? l * (e[b + 1] - e[b]) : 0) : a;
          }

          return a;
        },
        getExtendedPositions: function getExtendedPositions() {
          var a = this,
              f = a.chart,
              e = a.series[0].currentDataGrouping,
              g = a.ordinalIndex,
              m = e ? e.count + e.unitName : "raw",
              b = a.options.overscroll,
              l = a.getExtremes(),
              n,
              d;
          g || (g = a.ordinalIndex = {});
          g[m] || (n = {
            series: [],
            chart: f,
            getExtremes: function getExtremes() {
              return {
                min: l.dataMin,
                max: l.dataMax + b
              };
            },
            options: {
              ordinal: !0
            },
            val2lin: A.prototype.val2lin,
            ordinal2lin: A.prototype.ordinal2lin
          }, a.series.forEach(function (b) {
            d = {
              xAxis: n,
              xData: b.xData.slice(),
              chart: f,
              destroyGroupedData: u
            };
            d.xData = d.xData.concat(a.getOverscrollPositions());
            d.options = {
              dataGrouping: e ? {
                enabled: !0,
                forced: !0,
                approximation: "open",
                units: [[e.unitName, [e.count]]]
              } : {
                enabled: !1
              }
            };
            b.processData.apply(d);
            n.series.push(d);
          }), a.beforeSetTickPositions.apply(n), g[m] = n.ordinalPositions);
          return g[m];
        },
        getOverscrollPositions: function getOverscrollPositions() {
          var g = this.options.overscroll,
              f = this.overscrollPointsRange,
              e = [],
              p = this.dataMax;
          if (a.defined(f)) for (e.push(p); p <= this.dataMax + g;) {
            p += f, e.push(p);
          }
          return e;
        },
        getGroupIntervalFactor: function getGroupIntervalFactor(a, f, e) {
          var g;
          e = e.processedXData;
          var m = e.length,
              b = [];
          g = this.groupIntervalFactor;

          if (!g) {
            for (g = 0; g < m - 1; g++) {
              b[g] = e[g + 1] - e[g];
            }

            b.sort(function (a, b) {
              return a - b;
            });
            b = b[Math.floor(m / 2)];
            a = Math.max(a, e[0]);
            f = Math.min(f, e[m - 1]);
            this.groupIntervalFactor = g = m * b / (f - a);
          }

          return g;
        },
        postProcessTickInterval: function postProcessTickInterval(a) {
          var f = this.ordinalSlope;
          return f ? this.options.breaks ? this.closestPointRange || a : a / (f / this.closestPointRange) : a;
        }
      });
      A.prototype.ordinal2lin = A.prototype.val2lin;
      B(G, "pan", function (a) {
        var f = this.xAxis[0],
            e = f.options.overscroll,
            g = a.originalEvent.chartX,
            q = !1;

        if (f.options.ordinal && f.series.length) {
          var b = this.mouseDownX,
              l = f.getExtremes(),
              n = l.dataMax,
              d = l.min,
              w = l.max,
              t = this.hoverPoints,
              v = f.closestPointRange || f.overscrollPointsRange,
              b = (b - g) / (f.translationSlope * (f.ordinalSlope || v)),
              u = {
            ordinalPositions: f.getExtendedPositions()
          },
              v = f.lin2val,
              c = f.val2lin,
              k;
          u.ordinalPositions ? 1 < Math.abs(b) && (t && t.forEach(function (a) {
            a.setState();
          }), 0 > b ? (t = u, k = f.ordinalPositions ? f : u) : (t = f.ordinalPositions ? f : u, k = u), u = k.ordinalPositions, n > u[u.length - 1] && u.push(n), this.fixedRange = w - d, b = f.toFixedRange(null, null, v.apply(t, [c.apply(t, [d, !0]) + b, !0]), v.apply(k, [c.apply(k, [w, !0]) + b, !0])), b.min >= Math.min(l.dataMin, d) && b.max <= Math.max(n, w) + e && f.setExtremes(b.min, b.max, !0, !1, {
            trigger: "pan"
          }), this.mouseDownX = g, m(this.container, {
            cursor: "move"
          })) : q = !0;
        } else q = !0;

        q ? e && (f.max = f.dataMax + e) : a.preventDefault();
      });
      B(A, "foundExtremes", function () {
        this.isXAxis && g(this.options.overscroll) && this.max === this.dataMax && (!this.chart.mouseIsDown || this.isInternal) && (!this.eventArgs || this.eventArgs && "navigator" !== this.eventArgs.trigger) && (this.max += this.options.overscroll, !this.isInternal && g(this.userMin) && (this.min += this.options.overscroll));
      });
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.pick,
          G = a.extend,
          m = a.isArray,
          g = a.fireEvent,
          t = a.Axis,
          u = a.Series;
      G(t.prototype, {
        isInBreak: function isInBreak(a, g) {
          var m = a.repeat || Infinity,
              f = a.from,
              e = a.to - a.from;
          g = g >= f ? (g - f) % m : m - (f - g) % m;
          return a.inclusive ? g <= e : g < e && 0 !== g;
        },
        isInAnyBreak: function isInAnyBreak(a, g) {
          var m = this.options.breaks,
              f = m && m.length,
              e,
              p,
              r;

          if (f) {
            for (; f--;) {
              this.isInBreak(m[f], a) && (e = !0, p || (p = A(m[f].showPoints, !this.isXAxis)));
            }

            r = e && g ? e && !p : e;
          }

          return r;
        }
      });
      B(t, "afterInit", function () {
        "function" === typeof this.setBreaks && this.setBreaks(this.options.breaks, !1);
      });
      B(t, "afterSetTickPositions", function () {
        if (this.isBroken) {
          var a = this.tickPositions,
              g = this.tickPositions.info,
              m = [],
              f;

          for (f = 0; f < a.length; f++) {
            this.isInAnyBreak(a[f]) || m.push(a[f]);
          }

          this.tickPositions = m;
          this.tickPositions.info = g;
        }
      });
      B(t, "afterSetOptions", function () {
        this.isBroken && (this.options.ordinal = !1);
      });

      t.prototype.setBreaks = function (a, u) {
        function q(a) {
          var b = a,
              f,
              g;

          for (g = 0; g < e.breakArray.length; g++) {
            if (f = e.breakArray[g], f.to <= a) b -= f.len;else if (f.from >= a) break;else if (e.isInBreak(f, a)) {
              b -= a - f.from;
              break;
            }
          }

          return b;
        }

        function f(a) {
          var b, f;

          for (f = 0; f < e.breakArray.length && !(b = e.breakArray[f], b.from >= a); f++) {
            b.to < a ? a += b.len : e.isInBreak(b, a) && (a += b.len);
          }

          return a;
        }

        var e = this,
            p = m(a) && !!a.length;
        e.isDirty = e.isBroken !== p;
        e.isBroken = p;
        e.options.breaks = e.userOptions.breaks = a;
        e.forceRedraw = !0;
        p || e.val2lin !== q || (delete e.val2lin, delete e.lin2val);
        p && (e.userOptions.ordinal = !1, e.val2lin = q, e.lin2val = f, e.setExtremes = function (a, b, e, f, d) {
          if (this.isBroken) {
            for (; this.isInAnyBreak(a);) {
              a -= this.closestPointRange;
            }

            for (; this.isInAnyBreak(b);) {
              b -= this.closestPointRange;
            }
          }

          t.prototype.setExtremes.call(this, a, b, e, f, d);
        }, e.setAxisTranslation = function (a) {
          t.prototype.setAxisTranslation.call(this, a);
          this.unitLength = null;

          if (this.isBroken) {
            a = e.options.breaks;
            var b = [],
                f = [],
                n = 0,
                d,
                m,
                p = e.userMin || e.min,
                q = e.userMax || e.max,
                r = A(e.pointRangePadding, 0),
                c,
                k;
            a.forEach(function (a) {
              m = a.repeat || Infinity;
              e.isInBreak(a, p) && (p += a.to % m - p % m);
              e.isInBreak(a, q) && (q -= q % m - a.from % m);
            });
            a.forEach(function (a) {
              c = a.from;

              for (m = a.repeat || Infinity; c - m > p;) {
                c -= m;
              }

              for (; c < p;) {
                c += m;
              }

              for (k = c; k < q; k += m) {
                b.push({
                  value: k,
                  move: "in"
                }), b.push({
                  value: k + (a.to - a.from),
                  move: "out",
                  size: a.breakSize
                });
              }
            });
            b.sort(function (a, b) {
              return a.value === b.value ? ("in" === a.move ? 0 : 1) - ("in" === b.move ? 0 : 1) : a.value - b.value;
            });
            d = 0;
            c = p;
            b.forEach(function (a) {
              d += "in" === a.move ? 1 : -1;
              1 === d && "in" === a.move && (c = a.value);
              0 === d && (f.push({
                from: c,
                to: a.value,
                len: a.value - c - (a.size || 0)
              }), n += a.value - c - (a.size || 0));
            });
            e.breakArray = f;
            e.unitLength = q - p - n + r;
            g(e, "afterBreaks");
            e.staticScale ? e.transA = e.staticScale : e.unitLength && (e.transA *= (q - e.min + r) / e.unitLength);
            r && (e.minPixelPadding = e.transA * e.minPointOffset);
            e.min = p;
            e.max = q;
          }
        });
        A(u, !0) && this.chart.redraw();
      };

      B(u, "afterGeneratePoints", function () {
        var a = this.xAxis,
            g = this.yAxis,
            m = this.points,
            f,
            e = m.length,
            p = this.options.connectNulls,
            r;
        if (a && g && (a.options.breaks || g.options.breaks)) for (; e--;) {
          f = m[e], r = null === f.y && !1 === p, r || !a.isInAnyBreak(f.x, !0) && !g.isInAnyBreak(f.y, !0) || (m.splice(e, 1), this.data[e] && this.data[e].destroyElements());
        }
      });
      B(u, "afterRender", function () {
        this.drawBreaks(this.xAxis, ["x"]);
        this.drawBreaks(this.yAxis, A(this.pointArrayMap, ["y"]));
      });

      a.Series.prototype.drawBreaks = function (a, m) {
        var q = this,
            f = q.points,
            e,
            p,
            r,
            b;
        a && m.forEach(function (l) {
          e = a.breakArray || [];
          p = a.isXAxis ? a.min : A(q.options.threshold, a.min);
          f.forEach(function (f) {
            b = A(f["stack" + l.toUpperCase()], f[l]);
            e.forEach(function (d) {
              r = !1;
              if (p < d.from && b > d.to || p > d.from && b < d.from) r = "pointBreak";else if (p < d.from && b > d.from && b < d.to || p > d.from && b > d.to && b < d.from) r = "pointInBreak";
              r && g(a, r, {
                point: f,
                brk: d
              });
            });
          });
        });
      };

      a.Series.prototype.gappedPath = function () {
        var g = this.currentDataGrouping,
            m = g && g.gapSize,
            g = this.options.gapSize,
            q = this.points.slice(),
            f = q.length - 1,
            e = this.yAxis;
        if (g && 0 < f) for ("value" !== this.options.gapUnit && (g *= this.closestPointRange), m && m > g && (g = m); f--;) {
          q[f + 1].x - q[f].x > g && (m = (q[f].x + q[f + 1].x) / 2, q.splice(f + 1, 0, {
            isNull: !0,
            x: m
          }), this.options.stacking && (m = e.stacks[this.stackKey][m] = new a.StackItem(e, e.options.stackLabels, !1, m, this.stack), m.total = 0));
        }
        return this.getGraphPath(q);
      };
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.arrayMax,
          G = a.arrayMin,
          m = a.Axis,
          g = a.defaultPlotOptions,
          t = a.defined,
          u = a.extend,
          v = a.format,
          y = a.isNumber,
          q = a.merge,
          f = a.pick,
          e = a.Point,
          p = a.Series,
          r = a.Tooltip,
          b = a.approximations = {
        sum: function sum(a) {
          var b = a.length,
              c;
          if (!b && a.hasNulls) c = null;else if (b) for (c = 0; b--;) {
            c += a[b];
          }
          return c;
        },
        average: function average(a) {
          var c = a.length;
          a = b.sum(a);
          y(a) && c && (a /= c);
          return a;
        },
        averages: function averages() {
          var a = [];
          [].forEach.call(arguments, function (c) {
            a.push(b.average(c));
          });
          return void 0 === a[0] ? void 0 : a;
        },
        open: function open(a) {
          return a.length ? a[0] : a.hasNulls ? null : void 0;
        },
        high: function high(a) {
          return a.length ? A(a) : a.hasNulls ? null : void 0;
        },
        low: function low(a) {
          return a.length ? G(a) : a.hasNulls ? null : void 0;
        },
        close: function close(a) {
          return a.length ? a[a.length - 1] : a.hasNulls ? null : void 0;
        },
        ohlc: function ohlc(a, c, d, e) {
          a = b.open(a);
          c = b.high(c);
          d = b.low(d);
          e = b.close(e);
          if (y(a) || y(c) || y(d) || y(e)) return [a, c, d, e];
        },
        range: function range(a, c) {
          a = b.low(a);
          c = b.high(c);
          if (y(a) || y(c)) return [a, c];
          if (null === a && null === c) return null;
        }
      },
          l = function l(a, c, d, e) {
        var f = this,
            h = f.data,
            k = f.options && f.options.data,
            g = [],
            l = [],
            n = [],
            m = a.length,
            p,
            x,
            r = !!c,
            w = [],
            u = f.pointArrayMap,
            D = u && u.length,
            v = ["x"].concat(u || ["y"]),
            E = 0,
            C = 0,
            F,
            A;
        e = "function" === typeof e ? e : b[e] ? b[e] : b[f.getDGApproximation && f.getDGApproximation() || "average"];
        D ? u.forEach(function () {
          w.push([]);
        }) : w.push([]);
        F = D || 1;

        for (A = 0; A <= m && !(a[A] >= d[0]); A++) {
          ;
        }

        for (A; A <= m; A++) {
          for (; void 0 !== d[E + 1] && a[A] >= d[E + 1] || A === m;) {
            p = d[E];
            f.dataGroupInfo = {
              start: f.cropStart + C,
              length: w[0].length
            };
            x = e.apply(f, w);
            f.pointClass && !t(f.dataGroupInfo.options) && (f.dataGroupInfo.options = q(f.pointClass.prototype.optionsToObject.call({
              series: f
            }, f.options.data[f.cropStart + C])), v.forEach(function (a) {
              delete f.dataGroupInfo.options[a];
            }));
            void 0 !== x && (g.push(p), l.push(x), n.push(f.dataGroupInfo));
            C = A;

            for (p = 0; p < F; p++) {
              w[p].length = 0, w[p].hasNulls = !1;
            }

            E += 1;
            if (A === m) break;
          }

          if (A === m) break;

          if (u) {
            p = f.cropStart + A;
            x = h && h[p] || f.pointClass.prototype.applyOptions.apply({
              series: f
            }, [k[p]]);
            var B;

            for (p = 0; p < D; p++) {
              B = x[u[p]], y(B) ? w[p].push(B) : null === B && (w[p].hasNulls = !0);
            }
          } else p = r ? c[A] : null, y(p) ? w[0].push(p) : null === p && (w[0].hasNulls = !0);
        }

        return {
          groupedXData: g,
          groupedYData: l,
          groupMap: n
        };
      },
          n = {
        approximations: b,
        groupData: l
      },
          d = p.prototype,
          w = d.processData,
          E = d.generatePoints,
          C = {
        groupPixelWidth: 2,
        dateTimeLabelFormats: {
          millisecond: ["%A, %b %e, %H:%M:%S.%L", "%A, %b %e, %H:%M:%S.%L", "-%H:%M:%S.%L"],
          second: ["%A, %b %e, %H:%M:%S", "%A, %b %e, %H:%M:%S", "-%H:%M:%S"],
          minute: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"],
          hour: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"],
          day: ["%A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"],
          week: ["Week from %A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"],
          month: ["%B %Y", "%B", "-%B %Y"],
          year: ["%Y", "%Y", "-%Y"]
        }
      },
          F = {
        line: {},
        spline: {},
        area: {},
        areaspline: {},
        column: {
          groupPixelWidth: 10
        },
        columnrange: {
          groupPixelWidth: 10
        },
        candlestick: {
          groupPixelWidth: 10
        },
        ohlc: {
          groupPixelWidth: 5
        }
      },
          c = a.defaultDataGroupingUnits = [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]];

      d.getDGApproximation = function () {
        return a.seriesTypes.arearange && this instanceof a.seriesTypes.arearange ? "range" : a.seriesTypes.ohlc && this instanceof a.seriesTypes.ohlc ? "ohlc" : a.seriesTypes.column && this instanceof a.seriesTypes.column ? "sum" : "average";
      };

      d.groupData = l;

      d.processData = function () {
        var a = this.chart,
            b = this.options.dataGrouping,
            e = !1 !== this.allowDG && b && f(b.enabled, a.options.isStock),
            h = this.visible || !a.options.chart.ignoreHiddenSeries,
            g,
            l = this.currentDataGrouping,
            n,
            m = !1;
        this.forceCrop = e;
        this.groupPixelWidth = null;
        this.hasProcessed = !0;
        e && !this.requireSorting && (this.requireSorting = m = !0);
        e = !1 === w.apply(this, arguments) || !e;
        m && (this.requireSorting = !1);

        if (!e) {
          this.destroyGroupedData();
          var p,
              e = b.groupAll ? this.xData : this.processedXData,
              q = b.groupAll ? this.yData : this.processedYData,
              r = a.plotSizeX,
              a = this.xAxis,
              u = a.options.ordinal,
              v = this.groupPixelWidth = a.getGroupPixelWidth && a.getGroupPixelWidth();

          if (v) {
            this.isDirty = g = !0;
            this.points = null;
            m = a.getExtremes();
            n = m.min;
            var m = m.max,
                u = u && a.getGroupIntervalFactor(n, m, this) || 1,
                v = v * (m - n) / r * u,
                r = a.getTimeTicks(a.normalizeTimeTickInterval(v, b.units || c), Math.min(n, e[0]), Math.max(m, e[e.length - 1]), a.options.startOfWeek, e, this.closestPointRange),
                q = d.groupData.apply(this, [e, q, r, b.approximation]),
                e = q.groupedXData,
                u = q.groupedYData,
                E = 0;

            if (b.smoothed && e.length) {
              p = e.length - 1;

              for (e[p] = Math.min(e[p], m); p-- && 0 < p;) {
                e[p] += v / 2;
              }

              e[0] = Math.max(e[0], n);
            }

            for (p = 1; p < r.length; p++) {
              r.info.segmentStarts && -1 !== r.info.segmentStarts.indexOf(p) || (E = Math.max(r[p] - r[p - 1], E));
            }

            n = r.info;
            n.gapSize = E;
            this.closestPointRange = r.info.totalRange;
            this.groupMap = q.groupMap;

            if (t(e[0]) && e[0] < a.dataMin && h) {
              if (!t(a.options.min) && a.min <= a.dataMin || a.min === a.dataMin) a.min = e[0];
              a.dataMin = e[0];
            }

            b.groupAll && (b = this.cropData(e, u, a.min, a.max, 1), e = b.xData, u = b.yData);
            this.processedXData = e;
            this.processedYData = u;
          } else this.groupMap = null;

          this.hasGroupedData = g;
          this.currentDataGrouping = n;
          this.preventGraphAnimation = (l && l.totalRange) !== (n && n.totalRange);
        }
      };

      d.destroyGroupedData = function () {
        var a = this.groupedData;
        (a || []).forEach(function (b, c) {
          b && (a[c] = b.destroy ? b.destroy() : null);
        });
        this.groupedData = null;
      };

      d.generatePoints = function () {
        E.apply(this);
        this.destroyGroupedData();
        this.groupedData = this.hasGroupedData ? this.points : null;
      };

      B(e, "update", function () {
        if (this.dataGroup) return a.error(24, !1, this.series.chart), !1;
      });
      B(r, "headerFormatter", function (a) {
        var b = this.chart.time,
            c = a.labelConfig,
            d = c.series,
            e = d.tooltipOptions,
            f = d.options.dataGrouping,
            k = e.xDateFormat,
            g,
            l = d.xAxis,
            n,
            m = e[(a.isFooter ? "footer" : "header") + "Format"];
        l && "datetime" === l.options.type && f && y(c.key) && (n = d.currentDataGrouping, f = f.dateTimeLabelFormats || C.dateTimeLabelFormats, n ? (e = f[n.unitName], 1 === n.count ? k = e[0] : (k = e[1], g = e[2])) : !k && f && (k = this.getXDateFormat(c, e, l)), k = b.dateFormat(k, c.key), g && (k += b.dateFormat(g, c.key + n.totalRange - 1)), d.chart.styledMode && (m = this.styledModeFormat(m)), a.text = v(m, {
          point: u(c.point, {
            key: k
          }),
          series: d
        }, b), a.preventDefault());
      });
      B(p, "destroy", d.destroyGroupedData);
      B(p, "afterSetOptions", function (a) {
        a = a.options;
        var b = this.type,
            c = this.chart.options.plotOptions,
            d = g[b].dataGrouping,
            e = this.useCommonDataGrouping && C;
        if (F[b] || e) d || (d = q(C, F[b])), a.dataGrouping = q(e, d, c.series && c.series.dataGrouping, c[b].dataGrouping, this.userOptions.dataGrouping);
      });
      B(m, "afterSetScale", function () {
        this.series.forEach(function (a) {
          a.hasProcessed = !1;
        });
      });

      m.prototype.getGroupPixelWidth = function () {
        var a = this.series,
            b = a.length,
            c,
            d = 0,
            e = !1,
            g;

        for (c = b; c--;) {
          (g = a[c].options.dataGrouping) && (d = Math.max(d, f(g.groupPixelWidth, C.groupPixelWidth)));
        }

        for (c = b; c--;) {
          (g = a[c].options.dataGrouping) && a[c].hasProcessed && (b = (a[c].processedXData || a[c].data).length, a[c].groupPixelWidth || b > this.chart.plotSizeX / d || b && g.forced) && (e = !0);
        }

        return e ? d : 0;
      };

      m.prototype.setDataGrouping = function (a, b) {
        var c;
        b = f(b, !0);
        a || (a = {
          forced: !1,
          units: null
        });
        if (this instanceof m) for (c = this.series.length; c--;) {
          this.series[c].update({
            dataGrouping: a
          }, !1);
        } else this.chart.options.series.forEach(function (b) {
          b.dataGrouping = a;
        }, !1);
        this.ordinalSlope = null;
        b && this.chart.redraw();
      };

      return a.dataGrouping = n;
    })(H);

    (function (a) {
      var B = a.Point,
          A = a.seriesType,
          G = a.seriesTypes;
      A("ohlc", "column", {
        lineWidth: 1,
        tooltip: {
          pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>"
        },
        threshold: null,
        states: {
          hover: {
            lineWidth: 3
          }
        },
        stickyTracking: !0
      }, {
        directTouch: !1,
        pointArrayMap: ["open", "high", "low", "close"],
        toYData: function toYData(a) {
          return [a.open, a.high, a.low, a.close];
        },
        pointValKey: "close",
        pointAttrToOptions: {
          stroke: "color",
          "stroke-width": "lineWidth"
        },
        init: function init() {
          G.column.prototype.init.apply(this, arguments);
          this.options.stacking = !1;
        },
        pointAttribs: function pointAttribs(a, g) {
          g = G.column.prototype.pointAttribs.call(this, a, g);
          var m = this.options;
          delete g.fill;
          !a.options.color && m.upColor && a.open < a.close && (g.stroke = m.upColor);
          return g;
        },
        translate: function translate() {
          var a = this,
              g = a.yAxis,
              t = !!a.modifyValue,
              u = ["plotOpen", "plotHigh", "plotLow", "plotClose", "yBottom"];
          G.column.prototype.translate.apply(a);
          a.points.forEach(function (m) {
            [m.open, m.high, m.low, m.close, m.low].forEach(function (v, q) {
              null !== v && (t && (v = a.modifyValue(v)), m[u[q]] = g.toPixels(v, !0));
            });
            m.tooltipPos[1] = m.plotHigh + g.pos - a.chart.plotTop;
          });
        },
        drawPoints: function drawPoints() {
          var a = this,
              g = a.chart;
          a.points.forEach(function (m) {
            var t,
                v,
                y,
                q,
                f = m.graphic,
                e,
                p = !f;
            void 0 !== m.plotY && (f || (m.graphic = f = g.renderer.path().add(a.group)), g.styledMode || f.attr(a.pointAttribs(m, m.selected && "select")), v = f.strokeWidth() % 2 / 2, e = Math.round(m.plotX) - v, y = Math.round(m.shapeArgs.width / 2), q = ["M", e, Math.round(m.yBottom), "L", e, Math.round(m.plotHigh)], null !== m.open && (t = Math.round(m.plotOpen) + v, q.push("M", e, t, "L", e - y, t)), null !== m.close && (t = Math.round(m.plotClose) + v, q.push("M", e, t, "L", e + y, t)), f[p ? "attr" : "animate"]({
              d: q
            }).addClass(m.getClassName(), !0));
          });
        },
        animate: null
      }, {
        getClassName: function getClassName() {
          return B.prototype.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }
      });
    })(H);

    (function (a) {
      var B = a.defaultPlotOptions,
          A = a.merge,
          G = a.seriesType,
          m = a.seriesTypes;
      G("candlestick", "ohlc", A(B.column, {
        states: {
          hover: {
            lineWidth: 2
          }
        },
        tooltip: B.ohlc.tooltip,
        threshold: null,
        lineColor: "#000000",
        lineWidth: 1,
        upColor: "#ffffff",
        stickyTracking: !0
      }), {
        pointAttribs: function pointAttribs(a, t) {
          var g = m.column.prototype.pointAttribs.call(this, a, t),
              v = this.options,
              y = a.open < a.close,
              q = v.lineColor || this.color;
          g["stroke-width"] = v.lineWidth;
          g.fill = a.options.color || (y ? v.upColor || this.color : this.color);
          g.stroke = a.lineColor || (y ? v.upLineColor || q : q);
          t && (a = v.states[t], g.fill = a.color || g.fill, g.stroke = a.lineColor || g.stroke, g["stroke-width"] = a.lineWidth || g["stroke-width"]);
          return g;
        },
        drawPoints: function drawPoints() {
          var a = this,
              m = a.chart,
              u = a.yAxis.reversed;
          a.points.forEach(function (g) {
            var t = g.graphic,
                q,
                f,
                e,
                p,
                r,
                b,
                l,
                n = !t;
            void 0 !== g.plotY && (t || (g.graphic = t = m.renderer.path().add(a.group)), a.chart.styledMode || t.attr(a.pointAttribs(g, g.selected && "select")).shadow(a.options.shadow), r = t.strokeWidth() % 2 / 2, b = Math.round(g.plotX) - r, q = g.plotOpen, f = g.plotClose, e = Math.min(q, f), q = Math.max(q, f), l = Math.round(g.shapeArgs.width / 2), f = u ? q !== g.yBottom : Math.round(e) !== Math.round(g.plotHigh), p = u ? Math.round(e) !== Math.round(g.plotHigh) : q !== g.yBottom, e = Math.round(e) + r, q = Math.round(q) + r, r = [], r.push("M", b - l, q, "L", b - l, e, "L", b + l, e, "L", b + l, q, "Z", "M", b, e, "L", b, f ? Math.round(u ? g.yBottom : g.plotHigh) : e, "M", b, q, "L", b, p ? Math.round(u ? g.plotHigh : g.yBottom) : q), t[n ? "attr" : "animate"]({
              d: r
            }).addClass(g.getClassName(), !0));
          });
        }
      });
    })(H);

    da = function (a) {
      var B = a.defined,
          A = a.seriesTypes,
          G = a.stableSort;
      return {
        getPlotBox: function getPlotBox() {
          return a.Series.prototype.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this);
        },
        translate: function translate() {
          A.column.prototype.translate.apply(this);
          var a = this,
              g = a.options,
              t = a.chart,
              u = a.points,
              v = u.length - 1,
              y,
              q = g.onSeries,
              q = q && t.get(q),
              g = g.onKey || "y",
              f = q && q.options.step,
              e = q && q.points,
              p = e && e.length,
              r = t.inverted,
              b = a.xAxis,
              l = a.yAxis,
              n = 0,
              d,
              w,
              E,
              C;
          if (q && q.visible && p) for (n = (q.pointXOffset || 0) + (q.barW || 0) / 2, t = q.currentDataGrouping, w = e[p - 1].x + (t ? t.totalRange : 0), G(u, function (a, b) {
            return a.x - b.x;
          }), g = "plot" + g[0].toUpperCase() + g.substr(1); p-- && u[v] && !(d = e[p], t = u[v], t.y = d.y, d.x <= t.x && void 0 !== d[g] && (t.x <= w && (t.plotY = d[g], d.x < t.x && !f && (E = e[p + 1]) && void 0 !== E[g] && (C = (t.x - d.x) / (E.x - d.x), t.plotY += C * (E[g] - d[g]), t.y += C * (E.y - d.y))), v--, p++, 0 > v));) {
            ;
          }
          u.forEach(function (d, c) {
            var e;
            d.plotX += n;
            if (void 0 === d.plotY || r) 0 <= d.plotX && d.plotX <= b.len ? r ? (d.plotY = b.translate(d.x, 0, 1, 0, 1), d.plotX = B(d.y) ? l.translate(d.y, 0, 0, 0, 1) : 0) : d.plotY = (b.opposite ? 0 : a.yAxis.len) + b.offset : d.shapeArgs = {};
            (y = u[c - 1]) && y.plotX === d.plotX && (void 0 === y.stackIndex && (y.stackIndex = 0), e = y.stackIndex + 1);
            d.stackIndex = e;
          });
          this.onSeries = q;
        }
      };
    }(H);

    (function (a, B) {
      function A(a) {
        e[a + "pin"] = function (f, b, g, n, d) {
          var l = d && d.anchorX;
          d = d && d.anchorY;
          "circle" === a && n > g && (f -= Math.round((n - g) / 2), g = n);
          f = e[a](f, b, g, n);
          l && d && (f.push("M", "circle" === a ? f[1] - f[4] : f[1] + f[4] / 2, b > d ? b : b + n, "L", l, d), f = f.concat(e.circle(l - 1, d - 1, 2, 2)));
          return f;
        };
      }

      var G = a.addEvent,
          m = a.merge,
          g = a.noop,
          t = a.defined,
          u = a.Renderer,
          v = a.Series,
          y = a.seriesType,
          q = a.TrackerMixin,
          f = a.VMLRenderer,
          e = a.SVGRenderer.prototype.symbols;
      y("flags", "column", {
        pointRange: 0,
        allowOverlapX: !1,
        shape: "flag",
        stackDistance: 12,
        textAlign: "center",
        tooltip: {
          pointFormat: "{point.text}\x3cbr/\x3e"
        },
        threshold: null,
        y: -30,
        fillColor: "#ffffff",
        lineWidth: 1,
        states: {
          hover: {
            lineColor: "#000000",
            fillColor: "#ccd6eb"
          }
        },
        style: {
          fontSize: "11px",
          fontWeight: "bold"
        }
      }, {
        sorted: !1,
        noSharedTooltip: !0,
        allowDG: !1,
        takeOrdinalPosition: !1,
        trackerGroups: ["markerGroup"],
        forceCrop: !0,
        init: v.prototype.init,
        pointAttribs: function pointAttribs(a, e) {
          var b = this.options,
              f = a && a.color || this.color,
              g = b.lineColor,
              d = a && a.lineWidth;
          a = a && a.fillColor || b.fillColor;
          e && (a = b.states[e].fillColor, g = b.states[e].lineColor, d = b.states[e].lineWidth);
          return {
            fill: a || f,
            stroke: g || f,
            "stroke-width": d || b.lineWidth || 0
          };
        },
        translate: B.translate,
        getPlotBox: B.getPlotBox,
        drawPoints: function drawPoints() {
          var e = this.points,
              f = this.chart,
              b = f.renderer,
              g,
              n,
              d = f.inverted,
              q = this.options,
              u = q.y,
              v,
              y,
              c,
              k,
              x,
              D,
              h = this.yAxis,
              z = {},
              A = [];

          for (y = e.length; y--;) {
            c = e[y], D = (d ? c.plotY : c.plotX) > this.xAxis.len, g = c.plotX, k = c.stackIndex, v = c.options.shape || q.shape, n = c.plotY, void 0 !== n && (n = c.plotY + u - (void 0 !== k && k * q.stackDistance)), c.anchorX = k ? void 0 : c.plotX, x = k ? void 0 : c.plotY, k = c.graphic, void 0 !== n && 0 <= g && !D ? (k || (k = c.graphic = b.label("", null, null, v, null, null, q.useHTML), f.styledMode || k.attr(this.pointAttribs(c)).css(m(q.style, c.style)), k.attr({
              align: "flag" === v ? "left" : "center",
              width: q.width,
              height: q.height,
              "text-align": q.textAlign
            }).addClass("highcharts-point").add(this.markerGroup), c.graphic.div && (c.graphic.div.point = c), f.styledMode || k.shadow(q.shadow), k.isNew = !0), 0 < g && (g -= k.strokeWidth() % 2), v = {
              y: n,
              anchorY: x
            }, q.allowOverlapX && (v.x = g, v.anchorX = c.anchorX), k.attr({
              text: c.options.title || q.title || "A"
            })[k.isNew ? "attr" : "animate"](v), q.allowOverlapX || (z[c.plotX] ? z[c.plotX].size = Math.max(z[c.plotX].size, k.width) : z[c.plotX] = {
              align: 0,
              size: k.width,
              target: g,
              anchorX: g
            }), c.tooltipPos = [g, n + h.pos - f.plotTop]) : k && (c.graphic = k.destroy());
          }

          q.allowOverlapX || (a.objectEach(z, function (a) {
            a.plotX = a.anchorX;
            A.push(a);
          }), a.distribute(A, d ? h.len : this.xAxis.len, 100), e.forEach(function (a) {
            var b = a.graphic && z[a.plotX];
            b && (a.graphic[a.graphic.isNew ? "attr" : "animate"]({
              x: b.pos,
              anchorX: a.anchorX
            }), t(b.pos) ? a.graphic.isNew = !1 : (a.graphic.attr({
              x: -9999,
              anchorX: -9999
            }), a.graphic.isNew = !0));
          }));
          q.useHTML && a.wrap(this.markerGroup, "on", function (b) {
            return a.SVGElement.prototype.on.apply(b.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        },
        drawTracker: function drawTracker() {
          var a = this.points;
          q.drawTrackerPoint.apply(this);
          a.forEach(function (e) {
            var b = e.graphic;
            b && G(b.element, "mouseover", function () {
              0 < e.stackIndex && !e.raised && (e._y = b.y, b.attr({
                y: e._y - 8
              }), e.raised = !0);
              a.forEach(function (a) {
                a !== e && a.raised && a.graphic && (a.graphic.attr({
                  y: a._y
                }), a.raised = !1);
              });
            });
          });
        },
        animate: function animate(a) {
          a ? this.setClip() : this.animate = null;
        },
        setClip: function setClip() {
          v.prototype.setClip.apply(this, arguments);
          !1 !== this.options.clip && this.sharedClipKey && this.markerGroup.clip(this.chart[this.sharedClipKey]);
        },
        buildKDTree: g,
        invertGroups: g
      });

      e.flag = function (a, f, b, g, n) {
        var d = n && n.anchorX || a;
        n = n && n.anchorY || f;
        return e.circle(d - 1, n - 1, 2, 2).concat(["M", d, n, "L", a, f + g, a, f, a + b, f, a + b, f + g, a, f + g, "Z"]);
      };

      A("circle");
      A("square");
      u === f && ["flag", "circlepin", "squarepin"].forEach(function (a) {
        f.prototype.symbols[a] = e[a];
      });
    })(H, da);

    (function (a) {
      function B(a, e, f) {
        this.init(a, e, f);
      }

      var A = a.addEvent,
          G = a.Axis,
          m = a.correctFloat,
          g = a.defaultOptions,
          t = a.defined,
          u = a.destroyObjectProperties,
          v = a.fireEvent,
          y = a.hasTouch,
          q = a.merge,
          f = a.pick,
          e = a.removeEvent,
          p,
          r = {
        height: a.isTouchDevice ? 20 : 14,
        barBorderRadius: 0,
        buttonBorderRadius: 0,
        liveRedraw: void 0,
        margin: 10,
        minWidth: 6,
        step: .2,
        zIndex: 3,
        barBackgroundColor: "#cccccc",
        barBorderWidth: 1,
        barBorderColor: "#cccccc",
        buttonArrowColor: "#333333",
        buttonBackgroundColor: "#e6e6e6",
        buttonBorderColor: "#cccccc",
        buttonBorderWidth: 1,
        rifleColor: "#333333",
        trackBackgroundColor: "#f2f2f2",
        trackBorderColor: "#f2f2f2",
        trackBorderWidth: 1
      };
      g.scrollbar = q(!0, r, g.scrollbar);

      a.swapXY = p = function p(a, e) {
        var b = a.length,
            d;
        if (e) for (e = 0; e < b; e += 3) {
          d = a[e + 1], a[e + 1] = a[e + 2], a[e + 2] = d;
        }
        return a;
      };

      B.prototype = {
        init: function init(a, e, g) {
          this.scrollbarButtons = [];
          this.renderer = a;
          this.userOptions = e;
          this.options = q(r, e);
          this.chart = g;
          this.size = f(this.options.size, this.options.height);
          e.enabled && (this.render(), this.initEvents(), this.addEvents());
        },
        render: function render() {
          var a = this.renderer,
              e = this.options,
              f = this.size,
              d = this.chart.styledMode,
              g;
          this.group = g = a.g("scrollbar").attr({
            zIndex: e.zIndex,
            translateY: -99999
          }).add();
          this.track = a.rect().addClass("highcharts-scrollbar-track").attr({
            x: 0,
            r: e.trackBorderRadius || 0,
            height: f,
            width: f
          }).add(g);
          d || this.track.attr({
            fill: e.trackBackgroundColor,
            stroke: e.trackBorderColor,
            "stroke-width": e.trackBorderWidth
          });
          this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({
            y: -this.trackBorderWidth % 2 / 2
          });
          this.scrollbarGroup = a.g().add(g);
          this.scrollbar = a.rect().addClass("highcharts-scrollbar-thumb").attr({
            height: f,
            width: f,
            r: e.barBorderRadius || 0
          }).add(this.scrollbarGroup);
          this.scrollbarRifles = a.path(p(["M", -3, f / 4, "L", -3, 2 * f / 3, "M", 0, f / 4, "L", 0, 2 * f / 3, "M", 3, f / 4, "L", 3, 2 * f / 3], e.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);
          d || (this.scrollbar.attr({
            fill: e.barBackgroundColor,
            stroke: e.barBorderColor,
            "stroke-width": e.barBorderWidth
          }), this.scrollbarRifles.attr({
            stroke: e.rifleColor,
            "stroke-width": 1
          }));
          this.scrollbarStrokeWidth = this.scrollbar.strokeWidth();
          this.scrollbarGroup.translate(-this.scrollbarStrokeWidth % 2 / 2, -this.scrollbarStrokeWidth % 2 / 2);
          this.drawScrollbarButton(0);
          this.drawScrollbarButton(1);
        },
        position: function position(a, e, f, d) {
          var b = this.options.vertical,
              g = 0,
              l = this.rendered ? "animate" : "attr";
          this.x = a;
          this.y = e + this.trackBorderWidth;
          this.width = f;
          this.xOffset = this.height = d;
          this.yOffset = g;
          b ? (this.width = this.yOffset = f = g = this.size, this.xOffset = e = 0, this.barWidth = d - 2 * f, this.x = a += this.options.margin) : (this.height = this.xOffset = d = e = this.size, this.barWidth = f - 2 * d, this.y += this.options.margin);
          this.group[l]({
            translateX: a,
            translateY: this.y
          });
          this.track[l]({
            width: f,
            height: d
          });
          this.scrollbarButtons[1][l]({
            translateX: b ? 0 : f - e,
            translateY: b ? d - g : 0
          });
        },
        drawScrollbarButton: function drawScrollbarButton(a) {
          var b = this.renderer,
              e = this.scrollbarButtons,
              d = this.options,
              f = this.size,
              g;
          g = b.g().add(this.group);
          e.push(g);
          g = b.rect().addClass("highcharts-scrollbar-button").add(g);
          this.chart.styledMode || g.attr({
            stroke: d.buttonBorderColor,
            "stroke-width": d.buttonBorderWidth,
            fill: d.buttonBackgroundColor
          });
          g.attr(g.crisp({
            x: -.5,
            y: -.5,
            width: f + 1,
            height: f + 1,
            r: d.buttonBorderRadius
          }, g.strokeWidth()));
          g = b.path(p(["M", f / 2 + (a ? -1 : 1), f / 2 - 3, "L", f / 2 + (a ? -1 : 1), f / 2 + 3, "L", f / 2 + (a ? 2 : -2), f / 2], d.vertical)).addClass("highcharts-scrollbar-arrow").add(e[a]);
          this.chart.styledMode || g.attr({
            fill: d.buttonArrowColor
          });
        },
        setRange: function setRange(a, e) {
          var b = this.options,
              d = b.vertical,
              f = b.minWidth,
              g = this.barWidth,
              l,
              p,
              c = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          t(g) && (a = Math.max(a, 0), l = Math.ceil(g * a), this.calculatedWidth = p = m(g * Math.min(e, 1) - l), p < f && (l = (g - f + p) * a, p = f), f = Math.floor(l + this.xOffset + this.yOffset), g = p / 2 - .5, this.from = a, this.to = e, d ? (this.scrollbarGroup[c]({
            translateY: f
          }), this.scrollbar[c]({
            height: p
          }), this.scrollbarRifles[c]({
            translateY: g
          }), this.scrollbarTop = f, this.scrollbarLeft = 0) : (this.scrollbarGroup[c]({
            translateX: f
          }), this.scrollbar[c]({
            width: p
          }), this.scrollbarRifles[c]({
            translateX: g
          }), this.scrollbarLeft = f, this.scrollbarTop = 0), 12 >= p ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(!0), !1 === b.showFull && (0 >= a && 1 <= e ? this.group.hide() : this.group.show()), this.rendered = !0);
        },
        initEvents: function initEvents() {
          var a = this;

          a.mouseMoveHandler = function (b) {
            var e = a.chart.pointer.normalize(b),
                d = a.options.vertical ? "chartY" : "chartX",
                f = a.initPositions;
            !a.grabbedCenter || b.touches && 0 === b.touches[0][d] || (e = a.cursorToScrollbarPosition(e)[d], d = a[d], d = e - d, a.hasDragged = !0, a.updatePosition(f[0] + d, f[1] + d), a.hasDragged && v(a, "changed", {
              from: a.from,
              to: a.to,
              trigger: "scrollbar",
              DOMType: b.type,
              DOMEvent: b
            }));
          };

          a.mouseUpHandler = function (b) {
            a.hasDragged && v(a, "changed", {
              from: a.from,
              to: a.to,
              trigger: "scrollbar",
              DOMType: b.type,
              DOMEvent: b
            });
            a.grabbedCenter = a.hasDragged = a.chartX = a.chartY = null;
          };

          a.mouseDownHandler = function (b) {
            b = a.chart.pointer.normalize(b);
            b = a.cursorToScrollbarPosition(b);
            a.chartX = b.chartX;
            a.chartY = b.chartY;
            a.initPositions = [a.from, a.to];
            a.grabbedCenter = !0;
          };

          a.buttonToMinClick = function (b) {
            var e = m(a.to - a.from) * a.options.step;
            a.updatePosition(m(a.from - e), m(a.to - e));
            v(a, "changed", {
              from: a.from,
              to: a.to,
              trigger: "scrollbar",
              DOMEvent: b
            });
          };

          a.buttonToMaxClick = function (b) {
            var e = (a.to - a.from) * a.options.step;
            a.updatePosition(a.from + e, a.to + e);
            v(a, "changed", {
              from: a.from,
              to: a.to,
              trigger: "scrollbar",
              DOMEvent: b
            });
          };

          a.trackClick = function (b) {
            var e = a.chart.pointer.normalize(b),
                d = a.to - a.from,
                f = a.y + a.scrollbarTop,
                g = a.x + a.scrollbarLeft;
            a.options.vertical && e.chartY > f || !a.options.vertical && e.chartX > g ? a.updatePosition(a.from + d, a.to + d) : a.updatePosition(a.from - d, a.to - d);
            v(a, "changed", {
              from: a.from,
              to: a.to,
              trigger: "scrollbar",
              DOMEvent: b
            });
          };
        },
        cursorToScrollbarPosition: function cursorToScrollbarPosition(a) {
          var b = this.options,
              b = b.minWidth > this.calculatedWidth ? b.minWidth : 0;
          return {
            chartX: (a.chartX - this.x - this.xOffset) / (this.barWidth - b),
            chartY: (a.chartY - this.y - this.yOffset) / (this.barWidth - b)
          };
        },
        updatePosition: function updatePosition(a, e) {
          1 < e && (a = m(1 - m(e - a)), e = 1);
          0 > a && (e = m(e - a), a = 0);
          this.from = a;
          this.to = e;
        },
        update: function update(a) {
          this.destroy();
          this.init(this.chart.renderer, q(!0, this.options, a), this.chart);
        },
        addEvents: function addEvents() {
          var a = this.options.inverted ? [1, 0] : [0, 1],
              e = this.scrollbarButtons,
              f = this.scrollbarGroup.element,
              d = this.mouseDownHandler,
              g = this.mouseMoveHandler,
              m = this.mouseUpHandler,
              a = [[e[a[0]].element, "click", this.buttonToMinClick], [e[a[1]].element, "click", this.buttonToMaxClick], [this.track.element, "click", this.trackClick], [f, "mousedown", d], [f.ownerDocument, "mousemove", g], [f.ownerDocument, "mouseup", m]];
          y && a.push([f, "touchstart", d], [f.ownerDocument, "touchmove", g], [f.ownerDocument, "touchend", m]);
          a.forEach(function (a) {
            A.apply(null, a);
          });
          this._events = a;
        },
        removeEvents: function removeEvents() {
          this._events.forEach(function (a) {
            e.apply(null, a);
          });

          this._events.length = 0;
        },
        destroy: function destroy() {
          var a = this.chart.scroller;
          this.removeEvents();
          ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function (a) {
            this[a] && this[a].destroy && (this[a] = this[a].destroy());
          }, this);
          a && this === a.scrollbar && (a.scrollbar = null, u(a.scrollbarButtons));
        }
      };
      A(G, "afterInit", function () {
        var b = this;
        b.options && b.options.scrollbar && b.options.scrollbar.enabled && (b.options.scrollbar.vertical = !b.horiz, b.options.startOnTick = b.options.endOnTick = !1, b.scrollbar = new B(b.chart.renderer, b.options.scrollbar, b.chart), A(b.scrollbar, "changed", function (e) {
          var g = Math.min(f(b.options.min, b.min), b.min, b.dataMin),
              d = Math.max(f(b.options.max, b.max), b.max, b.dataMax) - g,
              l;
          b.horiz && !b.reversed || !b.horiz && b.reversed ? (l = g + d * this.to, g += d * this.from) : (l = g + d * (1 - this.from), g += d * (1 - this.to));
          f(this.options.liveRedraw, a.svg && !a.isTouchDevice && !this.chart.isBoosting) || "mouseup" === e.DOMType || !t(e.DOMType) ? b.setExtremes(g, l, !0, "mousemove" !== e.DOMType, e) : this.setRange(this.from, this.to);
        }));
      });
      A(G, "afterRender", function () {
        var a = Math.min(f(this.options.min, this.min), this.min, f(this.dataMin, this.min)),
            e = Math.max(f(this.options.max, this.max), this.max, f(this.dataMax, this.max)),
            g = this.scrollbar,
            d = this.titleOffset || 0;

        if (g) {
          this.horiz ? (g.position(this.left, this.top + this.height + 2 + this.chart.scrollbarsOffsets[1] + (this.opposite ? 0 : d + this.axisTitleMargin + this.offset), this.width, this.height), d = 1) : (g.position(this.left + this.width + 2 + this.chart.scrollbarsOffsets[0] + (this.opposite ? d + this.axisTitleMargin + this.offset : 0), this.top, this.width, this.height), d = 0);
          if (!this.opposite && !this.horiz || this.opposite && this.horiz) this.chart.scrollbarsOffsets[d] += this.scrollbar.size + this.scrollbar.options.margin;
          isNaN(a) || isNaN(e) || !t(this.min) || !t(this.max) ? g.setRange(0, 0) : (d = (this.min - a) / (e - a), a = (this.max - a) / (e - a), this.horiz && !this.reversed || !this.horiz && this.reversed ? g.setRange(d, a) : g.setRange(1 - a, 1 - d));
        }
      });
      A(G, "afterGetOffset", function () {
        var a = this.horiz ? 2 : 1,
            e = this.scrollbar;
        e && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[a] += e.size + e.options.margin);
      });
      a.Scrollbar = B;
    })(H);

    (function (a) {
      function B(a) {
        this.init(a);
      }

      var A = a.addEvent,
          G = a.Axis,
          m = a.Chart,
          g = a.color,
          t = a.defaultOptions,
          u = a.defined,
          v = a.destroyObjectProperties,
          y = a.erase,
          q = a.extend,
          f = a.hasTouch,
          e = a.isArray,
          p = a.isNumber,
          r = a.isTouchDevice,
          b = a.merge,
          l = a.pick,
          n = a.removeEvent,
          d = a.Scrollbar,
          w = a.Series,
          E = a.seriesTypes,
          C = [].concat(a.defaultDataGroupingUnits),
          F = function F(a) {
        var c = [].filter.call(arguments, p);
        if (c.length) return Math[a].apply(0, c);
      };

      C[4] = ["day", [1, 2, 3, 4]];
      C[5] = ["week", [1, 2, 3]];
      E = void 0 === E.areaspline ? "line" : "areaspline";
      q(t, {
        navigator: {
          height: 40,
          margin: 25,
          maskInside: !0,
          handles: {
            width: 7,
            height: 15,
            symbols: ["navigator-handle", "navigator-handle"],
            enabled: !0,
            lineWidth: 1,
            backgroundColor: "#f2f2f2",
            borderColor: "#999999"
          },
          maskFill: g("#6685c2").setOpacity(.3).get(),
          outlineColor: "#cccccc",
          outlineWidth: 1,
          series: {
            type: E,
            fillOpacity: .05,
            lineWidth: 1,
            compare: null,
            dataGrouping: {
              approximation: "average",
              enabled: !0,
              groupPixelWidth: 2,
              smoothed: !0,
              units: C
            },
            dataLabels: {
              enabled: !1,
              zIndex: 2
            },
            id: "highcharts-navigator-series",
            className: "highcharts-navigator-series",
            lineColor: null,
            marker: {
              enabled: !1
            },
            pointRange: 0,
            threshold: null
          },
          xAxis: {
            overscroll: 0,
            className: "highcharts-navigator-xaxis",
            tickLength: 0,
            lineWidth: 0,
            gridLineColor: "#e6e6e6",
            gridLineWidth: 1,
            tickPixelInterval: 200,
            labels: {
              align: "left",
              style: {
                color: "#999999"
              },
              x: 3,
              y: -4
            },
            crosshair: !1
          },
          yAxis: {
            className: "highcharts-navigator-yaxis",
            gridLineWidth: 0,
            startOnTick: !1,
            endOnTick: !1,
            minPadding: .1,
            maxPadding: .1,
            labels: {
              enabled: !1
            },
            crosshair: !1,
            title: {
              text: null
            },
            tickLength: 0,
            tickWidth: 0
          }
        }
      });

      a.Renderer.prototype.symbols["navigator-handle"] = function (a, b, d, e, f) {
        a = f.width / 2;
        b = Math.round(a / 3) + .5;
        f = f.height;
        return ["M", -a - 1, .5, "L", a, .5, "L", a, f + .5, "L", -a - 1, f + .5, "L", -a - 1, .5, "M", -b, 4, "L", -b, f - 3, "M", b - 1, 4, "L", b - 1, f - 3];
      };

      B.prototype = {
        drawHandle: function drawHandle(a, b, d, e) {
          var c = this.navigatorOptions.handles.height;
          this.handles[b][e](d ? {
            translateX: Math.round(this.left + this.height / 2),
            translateY: Math.round(this.top + parseInt(a, 10) + .5 - c)
          } : {
            translateX: Math.round(this.left + parseInt(a, 10)),
            translateY: Math.round(this.top + this.height / 2 - c / 2 - 1)
          });
        },
        drawOutline: function drawOutline(a, b, d, e) {
          var c = this.navigatorOptions.maskInside,
              f = this.outline.strokeWidth(),
              g = f / 2,
              f = f % 2 / 2,
              k = this.outlineHeight,
              l = this.scrollbarHeight,
              n = this.size,
              m = this.left - l,
              p = this.top;
          d ? (m -= g, d = p + b + f, b = p + a + f, a = ["M", m + k, p - l - f, "L", m + k, d, "L", m, d, "L", m, b, "L", m + k, b, "L", m + k, p + n + l].concat(c ? ["M", m + k, d - g, "L", m + k, b + g] : [])) : (a += m + l - f, b += m + l - f, p += g, a = ["M", m, p, "L", a, p, "L", a, p + k, "L", b, p + k, "L", b, p, "L", m + n + 2 * l, p].concat(c ? ["M", a - g, p, "L", b + g, p] : []));
          this.outline[e]({
            d: a
          });
        },
        drawMasks: function drawMasks(a, b, d, e) {
          var c = this.left,
              f = this.top,
              g = this.height,
              k,
              l,
              n,
              m;
          d ? (n = [c, c, c], m = [f, f + a, f + b], l = [g, g, g], k = [a, b - a, this.size - b]) : (n = [c, c + a, c + b], m = [f, f, f], l = [a, b - a, this.size - b], k = [g, g, g]);
          this.shades.forEach(function (a, c) {
            a[e]({
              x: n[c],
              y: m[c],
              width: l[c],
              height: k[c]
            });
          });
        },
        renderElements: function renderElements() {
          var a = this,
              b = a.navigatorOptions,
              d = b.maskInside,
              e = a.chart,
              f = e.renderer,
              g,
              l = {
            cursor: e.inverted ? "ns-resize" : "ew-resize"
          };
          a.navigatorGroup = g = f.g("navigator").attr({
            zIndex: 8,
            visibility: "hidden"
          }).add();
          [!d, d, !d].forEach(function (c, d) {
            a.shades[d] = f.rect().addClass("highcharts-navigator-mask" + (1 === d ? "-inside" : "-outside")).add(g);
            e.styledMode || a.shades[d].attr({
              fill: c ? b.maskFill : "rgba(0,0,0,0)"
            }).css(1 === d && l);
          });
          a.outline = f.path().addClass("highcharts-navigator-outline").add(g);
          e.styledMode || a.outline.attr({
            "stroke-width": b.outlineWidth,
            stroke: b.outlineColor
          });
          b.handles.enabled && [0, 1].forEach(function (c) {
            b.handles.inverted = e.inverted;
            a.handles[c] = f.symbol(b.handles.symbols[c], -b.handles.width / 2 - 1, 0, b.handles.width, b.handles.height, b.handles);
            a.handles[c].attr({
              zIndex: 7 - c
            }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][c]).add(g);

            if (!e.styledMode) {
              var d = b.handles;
              a.handles[c].attr({
                fill: d.backgroundColor,
                stroke: d.borderColor,
                "stroke-width": d.lineWidth
              }).css(l);
            }
          });
        },
        update: function update(a) {
          (this.series || []).forEach(function (a) {
            a.baseSeries && delete a.baseSeries.navigatorSeries;
          });
          this.destroy();
          b(!0, this.chart.options.navigator, this.options, a);
          this.init(this.chart);
        },
        render: function render(c, b, d, e) {
          var f = this.chart,
              g,
              k,
              n = this.scrollbarHeight,
              m,
              q = this.xAxis;
          g = q.fake ? f.xAxis[0] : q;
          var r = this.navigatorEnabled,
              x,
              t = this.rendered;
          k = f.inverted;
          var w,
              v = f.xAxis[0].minRange,
              D = f.xAxis[0].options.maxRange;

          if (!this.hasDragged || u(d)) {
            if (!p(c) || !p(b)) if (t) d = 0, e = l(q.width, g.width);else return;
            this.left = l(q.left, f.plotLeft + n + (k ? f.plotWidth : 0));
            this.size = x = m = l(q.len, (k ? f.plotHeight : f.plotWidth) - 2 * n);
            f = k ? n : m + 2 * n;
            d = l(d, q.toPixels(c, !0));
            e = l(e, q.toPixels(b, !0));
            p(d) && Infinity !== Math.abs(d) || (d = 0, e = f);
            c = q.toValue(d, !0);
            b = q.toValue(e, !0);
            w = Math.abs(a.correctFloat(b - c));
            w < v ? this.grabbedLeft ? d = q.toPixels(b - v, !0) : this.grabbedRight && (e = q.toPixels(c + v, !0)) : u(D) && w > D && (this.grabbedLeft ? d = q.toPixels(b - D, !0) : this.grabbedRight && (e = q.toPixels(c + D, !0)));
            this.zoomedMax = Math.min(Math.max(d, e, 0), x);
            this.zoomedMin = Math.min(Math.max(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(d, e), 0), x);
            this.range = this.zoomedMax - this.zoomedMin;
            x = Math.round(this.zoomedMax);
            d = Math.round(this.zoomedMin);
            r && (this.navigatorGroup.attr({
              visibility: "visible"
            }), t = t && !this.hasDragged ? "animate" : "attr", this.drawMasks(d, x, k, t), this.drawOutline(d, x, k, t), this.navigatorOptions.handles.enabled && (this.drawHandle(d, 0, k, t), this.drawHandle(x, 1, k, t)));
            this.scrollbar && (k ? (k = this.top - n, g = this.left - n + (r || !g.opposite ? 0 : (g.titleOffset || 0) + g.axisTitleMargin), n = m + 2 * n) : (k = this.top + (r ? this.height : -n), g = this.left - n), this.scrollbar.position(g, k, f, n), this.scrollbar.setRange(this.zoomedMin / (m || 1), this.zoomedMax / (m || 1)));
            this.rendered = !0;
          }
        },
        addMouseEvents: function addMouseEvents() {
          var a = this,
              b = a.chart,
              d = b.container,
              e = [],
              g,
              l;

          a.mouseMoveHandler = g = function g(c) {
            a.onMouseMove(c);
          };

          a.mouseUpHandler = l = function l(c) {
            a.onMouseUp(c);
          };

          e = a.getPartsEvents("mousedown");
          e.push(A(d, "mousemove", g), A(d.ownerDocument, "mouseup", l));
          f && (e.push(A(d, "touchmove", g), A(d.ownerDocument, "touchend", l)), e.concat(a.getPartsEvents("touchstart")));
          a.eventsToUnbind = e;
          a.series && a.series[0] && e.push(A(a.series[0].xAxis, "foundExtremes", function () {
            b.navigator.modifyNavigatorAxisExtremes();
          }));
        },
        getPartsEvents: function getPartsEvents(a) {
          var c = this,
              b = [];
          ["shades", "handles"].forEach(function (d) {
            c[d].forEach(function (e, f) {
              b.push(A(e.element, a, function (a) {
                c[d + "Mousedown"](a, f);
              }));
            });
          });
          return b;
        },
        shadesMousedown: function shadesMousedown(a, b) {
          a = this.chart.pointer.normalize(a);
          var c = this.chart,
              d = this.xAxis,
              e = this.zoomedMin,
              f = this.left,
              g = this.size,
              k = this.range,
              l = a.chartX,
              n,
              m;
          c.inverted && (l = a.chartY, f = this.top);
          1 === b ? (this.grabbedCenter = l, this.fixedWidth = k, this.dragOffset = l - e) : (a = l - f - k / 2, 0 === b ? a = Math.max(0, a) : 2 === b && a + k >= g && (a = g - k, this.reversedExtremes ? (a -= k, m = this.getUnionExtremes().dataMin) : n = this.getUnionExtremes().dataMax), a !== e && (this.fixedWidth = k, b = d.toFixedRange(a, a + k, m, n), u(b.min) && c.xAxis[0].setExtremes(Math.min(b.min, b.max), Math.max(b.min, b.max), !0, null, {
            trigger: "navigator"
          })));
        },
        handlesMousedown: function handlesMousedown(a, b) {
          this.chart.pointer.normalize(a);
          a = this.chart;
          var c = a.xAxis[0],
              d = this.reversedExtremes;
          0 === b ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = d ? c.min : c.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = d ? c.max : c.min);
          a.fixedRange = null;
        },
        onMouseMove: function onMouseMove(b) {
          var c = this,
              d = c.chart,
              e = c.left,
              f = c.navigatorSize,
              g = c.range,
              n = c.dragOffset,
              m = d.inverted;
          b.touches && 0 === b.touches[0].pageX || (b = d.pointer.normalize(b), d = b.chartX, m && (e = c.top, d = b.chartY), c.grabbedLeft ? (c.hasDragged = !0, c.render(0, 0, d - e, c.otherHandlePos)) : c.grabbedRight ? (c.hasDragged = !0, c.render(0, 0, c.otherHandlePos, d - e)) : c.grabbedCenter && (c.hasDragged = !0, d < n ? d = n : d > f + n - g && (d = f + n - g), c.render(0, 0, d - n, d - n + g)), c.hasDragged && c.scrollbar && l(c.scrollbar.options.liveRedraw, a.svg && !r && !this.chart.isBoosting) && (b.DOMType = b.type, setTimeout(function () {
            c.onMouseUp(b);
          }, 0)));
        },
        onMouseUp: function onMouseUp(a) {
          var b = this.chart,
              c = this.xAxis,
              d = this.scrollbar,
              e,
              f,
              g = a.DOMEvent || a;
          (!this.hasDragged || d && d.hasDragged) && "scrollbar" !== a.trigger || (d = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? e = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (f = this.fixedExtreme), this.zoomedMax === this.size && (f = this.reversedExtremes ? d.dataMin : d.dataMax), 0 === this.zoomedMin && (e = this.reversedExtremes ? d.dataMax : d.dataMin), c = c.toFixedRange(this.zoomedMin, this.zoomedMax, e, f), u(c.min) && b.xAxis[0].setExtremes(Math.min(c.min, c.max), Math.max(c.min, c.max), !0, this.hasDragged ? !1 : null, {
            trigger: "navigator",
            triggerOp: "navigator-drag",
            DOMEvent: g
          }));
          "mousemove" !== a.DOMType && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null);
        },
        removeEvents: function removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function (a) {
            a();
          }), this.eventsToUnbind = void 0);
          this.removeBaseSeriesEvents();
        },
        removeBaseSeriesEvents: function removeBaseSeriesEvents() {
          var a = this.baseSeries || [];
          this.navigatorEnabled && a[0] && (!1 !== this.navigatorOptions.adaptToUpdatedData && a.forEach(function (a) {
            n(a, "updatedData", this.updatedDataHandler);
          }, this), a[0].xAxis && n(a[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        },
        init: function init(a) {
          var c = a.options,
              e = c.navigator,
              f = e.enabled,
              g = c.scrollbar,
              n = g.enabled,
              c = f ? e.height : 0,
              m = n ? g.height : 0;
          this.handles = [];
          this.shades = [];
          this.chart = a;
          this.setBaseSeries();
          this.height = c;
          this.scrollbarHeight = m;
          this.scrollbarEnabled = n;
          this.navigatorEnabled = f;
          this.navigatorOptions = e;
          this.scrollbarOptions = g;
          this.outlineHeight = c + m;
          this.opposite = l(e.opposite, !f && a.inverted);
          var p = this,
              f = p.baseSeries,
              g = a.xAxis.length,
              n = a.yAxis.length,
              q = f && f[0] && f[0].xAxis || a.xAxis[0] || {
            options: {}
          };
          a.isDirtyBox = !0;
          p.navigatorEnabled ? (p.xAxis = new G(a, b({
            breaks: q.options.breaks,
            ordinal: q.options.ordinal
          }, e.xAxis, {
            id: "navigator-x-axis",
            yAxis: "navigator-y-axis",
            isX: !0,
            type: "datetime",
            index: g,
            isInternal: !0,
            offset: 0,
            keepOrdinalPadding: !0,
            startOnTick: !1,
            endOnTick: !1,
            minPadding: 0,
            maxPadding: 0,
            zoomEnabled: !1
          }, a.inverted ? {
            offsets: [m, 0, -m, 0],
            width: c
          } : {
            offsets: [0, -m, 0, m],
            height: c
          })), p.yAxis = new G(a, b(e.yAxis, {
            id: "navigator-y-axis",
            alignTicks: !1,
            offset: 0,
            index: n,
            isInternal: !0,
            zoomEnabled: !1
          }, a.inverted ? {
            width: c
          } : {
            height: c
          })), f || e.series.data ? p.updateNavigatorSeries(!1) : 0 === a.series.length && (p.unbindRedraw = A(a, "beforeRedraw", function () {
            0 < a.series.length && !p.series && (p.setBaseSeries(), p.unbindRedraw());
          })), p.reversedExtremes = a.inverted && !p.xAxis.reversed || !a.inverted && p.xAxis.reversed, p.renderElements(), p.addMouseEvents()) : p.xAxis = {
            translate: function translate(b, c) {
              var d = a.xAxis[0],
                  e = d.getExtremes(),
                  f = d.len - 2 * m,
                  g = F("min", d.options.min, e.dataMin),
                  d = F("max", d.options.max, e.dataMax) - g;
              return c ? b * d / f + g : f * (b - g) / d;
            },
            toPixels: function toPixels(a) {
              return this.translate(a);
            },
            toValue: function toValue(a) {
              return this.translate(a, !0);
            },
            toFixedRange: G.prototype.toFixedRange,
            fake: !0
          };
          a.options.scrollbar.enabled && (a.scrollbar = p.scrollbar = new d(a.renderer, b(a.options.scrollbar, {
            margin: p.navigatorEnabled ? 0 : 10,
            vertical: a.inverted
          }), a), A(p.scrollbar, "changed", function (b) {
            var c = p.size,
                d = c * this.to,
                c = c * this.from;
            p.hasDragged = p.scrollbar.hasDragged;
            p.render(0, 0, c, d);
            (a.options.scrollbar.liveRedraw || "mousemove" !== b.DOMType && "touchmove" !== b.DOMType) && setTimeout(function () {
              p.onMouseUp(b);
            });
          }));
          p.addBaseSeriesEvents();
          p.addChartEvents();
        },
        getUnionExtremes: function getUnionExtremes(a) {
          var b = this.chart.xAxis[0],
              c = this.xAxis,
              d = c.options,
              e = b.options,
              f;
          a && null === b.dataMin || (f = {
            dataMin: l(d && d.min, F("min", e.min, b.dataMin, c.dataMin, c.min)),
            dataMax: l(d && d.max, F("max", e.max, b.dataMax, c.dataMax, c.max))
          });
          return f;
        },
        setBaseSeries: function setBaseSeries(b, d) {
          var c = this.chart,
              e = this.baseSeries = [];
          b = b || c.options && c.options.navigator.baseSeries || (c.series.length ? a.find(c.series, function (a) {
            return !a.options.isInternal;
          }).index : 0);
          (c.series || []).forEach(function (a, c) {
            a.options.isInternal || !a.options.showInNavigator && (c !== b && a.options.id !== b || !1 === a.options.showInNavigator) || e.push(a);
          });
          this.xAxis && !this.xAxis.fake && this.updateNavigatorSeries(!0, d);
        },
        updateNavigatorSeries: function updateNavigatorSeries(c, d) {
          var f = this,
              g = f.chart,
              h = f.baseSeries,
              k,
              l,
              m = f.navigatorOptions.series,
              p,
              r = {
            enableMouseTracking: !1,
            index: null,
            linkedTo: null,
            group: "nav",
            padXAxis: !1,
            xAxis: "navigator-x-axis",
            yAxis: "navigator-y-axis",
            showInLegend: !1,
            stacking: !1,
            isInternal: !0
          },
              w = f.series = (f.series || []).filter(function (a) {
            var b = a.baseSeries;
            return 0 > h.indexOf(b) ? (b && (n(b, "updatedData", f.updatedDataHandler), delete b.navigatorSeries), a.chart && a.destroy(), !1) : !0;
          });
          h && h.length && h.forEach(function (a) {
            var c = a.navigatorSeries,
                n = q({
              color: a.color,
              visible: a.visible
            }, e(m) ? t.navigator.series : m);
            c && !1 === f.navigatorOptions.adaptToUpdatedData || (r.name = "Navigator " + h.length, k = a.options || {}, p = k.navigatorOptions || {}, l = b(k, r, n, p), n = p.data || n.data, f.hasNavigatorData = f.hasNavigatorData || !!n, l.data = n || k.data && k.data.slice(0), c && c.options ? c.update(l, d) : (a.navigatorSeries = g.initSeries(l), a.navigatorSeries.baseSeries = a, w.push(a.navigatorSeries)));
          });
          if (m.data && (!h || !h.length) || e(m)) f.hasNavigatorData = !1, m = a.splat(m), m.forEach(function (a, c) {
            r.name = "Navigator " + (w.length + 1);
            l = b(t.navigator.series, {
              color: g.series[c] && !g.series[c].options.isInternal && g.series[c].color || g.options.colors[c] || g.options.colors[0]
            }, r, a);
            l.data = a.data;
            l.data && (f.hasNavigatorData = !0, w.push(g.initSeries(l)));
          });
          c && this.addBaseSeriesEvents();
        },
        addBaseSeriesEvents: function addBaseSeriesEvents() {
          var a = this,
              b = a.baseSeries || [];
          b[0] && b[0].xAxis && A(b[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes);
          b.forEach(function (b) {
            A(b, "show", function () {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            });
            A(b, "hide", function () {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            });
            !1 !== this.navigatorOptions.adaptToUpdatedData && b.xAxis && A(b, "updatedData", this.updatedDataHandler);
            A(b, "remove", function () {
              this.navigatorSeries && (y(a.series, this.navigatorSeries), u(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            });
          }, this);
        },
        getBaseSeriesMin: function getBaseSeriesMin(a) {
          return this.baseSeries.reduce(function (a, b) {
            return Math.min(a, b.xData[0]);
          }, a);
        },
        modifyNavigatorAxisExtremes: function modifyNavigatorAxisExtremes() {
          var a = this.xAxis,
              b;
          a.getExtremes && (!(b = this.getUnionExtremes(!0)) || b.dataMin === a.min && b.dataMax === a.max || (a.min = b.dataMin, a.max = b.dataMax));
        },
        modifyBaseAxisExtremes: function modifyBaseAxisExtremes() {
          var a = this.chart.navigator,
              b = this.getExtremes(),
              d = b.dataMin,
              e = b.dataMax,
              b = b.max - b.min,
              f = a.stickToMin,
              g = a.stickToMax,
              n = l(this.options.overscroll, 0),
              m,
              q,
              r = a.series && a.series[0],
              t = !!this.setExtremes;
          this.eventArgs && "rangeSelectorButton" === this.eventArgs.trigger || (f && (q = d, m = q + b), g && (m = e + n, f || (q = Math.max(m - b, a.getBaseSeriesMin(r && r.xData ? r.xData[0] : -Number.MAX_VALUE)))), t && (f || g) && p(q) && (this.min = this.userMin = q, this.max = this.userMax = m));
          a.stickToMin = a.stickToMax = null;
        },
        updatedDataHandler: function updatedDataHandler() {
          var a = this.chart.navigator,
              b = this.navigatorSeries,
              d = a.getBaseSeriesMin(this.xData[0]);
          a.stickToMax = a.reversedExtremes ? 0 === Math.round(a.zoomedMin) : Math.round(a.zoomedMax) >= Math.round(a.size);
          a.stickToMin = p(this.xAxis.min) && this.xAxis.min <= d && (!this.chart.fixedRange || !a.stickToMax);
          b && !a.hasNavigatorData && (b.options.pointStart = this.xData[0], b.setData(this.options.data, !1, null, !1));
        },
        addChartEvents: function addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []);
          this.eventsToUnbind.push(A(this.chart, "redraw", function () {
            var a = this.navigator,
                b = a && (a.baseSeries && a.baseSeries[0] && a.baseSeries[0].xAxis || a.scrollbar && this.xAxis[0]);
            b && a.render(b.min, b.max);
          }), A(this.chart, "getMargins", function () {
            var a = this.navigator,
                b = a.opposite ? "plotTop" : "marginBottom";
            this.inverted && (b = a.opposite ? "marginRight" : "plotLeft");
            this[b] = (this[b] || 0) + (a.navigatorEnabled || !this.inverted ? a.outlineHeight : 0) + a.navigatorOptions.margin;
          }));
        },
        destroy: function destroy() {
          this.removeEvents();
          this.xAxis && (y(this.chart.xAxis, this.xAxis), y(this.chart.axes, this.xAxis));
          this.yAxis && (y(this.chart.yAxis, this.yAxis), y(this.chart.axes, this.yAxis));
          (this.series || []).forEach(function (a) {
            a.destroy && a.destroy();
          });
          "series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" ").forEach(function (a) {
            this[a] && this[a].destroy && this[a].destroy();
            this[a] = null;
          }, this);
          [this.handles].forEach(function (a) {
            v(a);
          }, this);
        }
      };
      a.Navigator = B;
      A(G, "zoom", function (a) {
        var b = this.chart.options,
            c = b.chart.zoomType,
            d = b.chart.pinchType,
            e = b.navigator,
            b = b.rangeSelector;
        this.isXAxis && (e && e.enabled || b && b.enabled) && ("y" === c ? a.zoomed = !1 : (!r && "xy" === c || r && "xy" === d) && this.options.range && (c = this.previousZoom, u(a.newMin) ? this.previousZoom = [this.min, this.max] : c && (a.newMin = c[0], a.newMax = c[1], delete this.previousZoom)));
        void 0 !== a.zoomed && a.preventDefault();
      });
      A(m, "beforeShowResetZoom", function () {
        var a = this.options,
            b = a.navigator,
            d = a.rangeSelector;
        if ((b && b.enabled || d && d.enabled) && (!r && "x" === a.chart.zoomType || r && "x" === a.chart.pinchType)) return !1;
      });
      A(m, "beforeRender", function () {
        var a = this.options;
        if (a.navigator.enabled || a.scrollbar.enabled) this.scroller = this.navigator = new B(this);
      });
      A(m, "afterSetChartSize", function () {
        var a = this.legend,
            b = this.navigator,
            d,
            e,
            f,
            g;
        b && (e = a && a.options, f = b.xAxis, g = b.yAxis, d = b.scrollbarHeight, this.inverted ? (b.left = b.opposite ? this.chartWidth - d - b.height : this.spacing[3] + d, b.top = this.plotTop + d) : (b.left = this.plotLeft + d, b.top = b.navigatorOptions.top || this.chartHeight - b.height - d - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (e && "bottom" === e.verticalAlign && e.enabled && !e.floating ? a.legendHeight + l(e.margin, 10) : 0)), f && g && (this.inverted ? f.options.left = g.options.left = b.left : f.options.top = g.options.top = b.top, f.setAxisSize(), g.setAxisSize()));
      });
      A(m, "update", function (a) {
        var c = a.options.navigator || {},
            d = a.options.scrollbar || {};
        this.navigator || this.scroller || !c.enabled && !d.enabled || (b(!0, this.options.navigator, c), b(!0, this.options.scrollbar, d), delete a.options.navigator, delete a.options.scrollbar);
      });
      A(m, "afterUpdate", function () {
        this.navigator || this.scroller || !this.options.navigator.enabled && !this.options.scrollbar.enabled || (this.scroller = this.navigator = new B(this));
      });
      A(m, "afterAddSeries", function () {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      });
      A(w, "afterUpdate", function () {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      });
      m.prototype.callbacks.push(function (a) {
        var b = a.navigator;
        b && a.xAxis[0] && (a = a.xAxis[0].getExtremes(), b.render(a.min, a.max));
      });
    })(H);

    (function (a) {
      function B(a) {
        this.init(a);
      }

      var A = a.addEvent,
          G = a.Axis,
          m = a.Chart,
          g = a.css,
          t = a.createElement,
          u = a.defaultOptions,
          v = a.defined,
          y = a.destroyObjectProperties,
          q = a.discardElement,
          f = a.extend,
          e = a.fireEvent,
          p = a.isNumber,
          r = a.merge,
          b = a.pick,
          l = a.pInt,
          n = a.splat;
      f(u, {
        rangeSelector: {
          verticalAlign: "top",
          buttonTheme: {
            width: 28,
            height: 18,
            padding: 2,
            zIndex: 7
          },
          floating: !1,
          x: 0,
          y: 0,
          height: void 0,
          inputPosition: {
            align: "right",
            x: 0,
            y: 0
          },
          buttonPosition: {
            align: "left",
            x: 0,
            y: 0
          },
          labelStyle: {
            color: "#666666"
          }
        }
      });
      u.lang = r(u.lang, {
        rangeSelectorZoom: "Zoom",
        rangeSelectorFrom: "From",
        rangeSelectorTo: "To"
      });
      B.prototype = {
        clickButton: function clickButton(a, e) {
          var d = this.chart,
              f = this.buttonOptions[a],
              g = d.xAxis[0],
              c = d.scroller && d.scroller.getUnionExtremes() || g || {},
              k = c.dataMin,
              l = c.dataMax,
              m,
              h = g && Math.round(Math.min(g.max, b(l, g.max))),
              q = f.type,
              r,
              c = f._range,
              t,
              w,
              u,
              v = f.dataGrouping;

          if (null !== k && null !== l) {
            d.fixedRange = c;
            v && (this.forcedDataGrouping = !0, G.prototype.setDataGrouping.call(g || {
              chart: this.chart
            }, v, !1), this.frozenStates = f.preserveDataGrouping);
            if ("month" === q || "year" === q) g ? (q = {
              range: f,
              max: h,
              chart: d,
              dataMin: k,
              dataMax: l
            }, m = g.minFromRange.call(q), p(q.newMax) && (h = q.newMax)) : c = f;else if (c) m = Math.max(h - c, k), h = Math.min(m + c, l);else if ("ytd" === q) {
              if (g) void 0 === l && (k = Number.MAX_VALUE, l = Number.MIN_VALUE, d.series.forEach(function (a) {
                a = a.xData;
                k = Math.min(a[0], k);
                l = Math.max(a[a.length - 1], l);
              }), e = !1), h = this.getYTDExtremes(l, k, d.time.useUTC), m = t = h.min, h = h.max;else {
                this.deferredYTDClick = a;
                return;
              }
            } else "all" === q && g && (m = k, h = l);
            m += f._offsetMin;
            h += f._offsetMax;
            this.setSelected(a);
            g ? g.setExtremes(m, h, b(e, 1), null, {
              trigger: "rangeSelectorButton",
              rangeSelectorButton: f
            }) : (r = n(d.options.xAxis)[0], u = r.range, r.range = c, w = r.min, r.min = t, A(d, "load", function () {
              r.range = u;
              r.min = w;
            }));
          }
        },
        setSelected: function setSelected(a) {
          this.selected = this.options.selected = a;
        },
        defaultButtons: [{
          type: "month",
          count: 1,
          text: "1m"
        }, {
          type: "month",
          count: 3,
          text: "3m"
        }, {
          type: "month",
          count: 6,
          text: "6m"
        }, {
          type: "ytd",
          text: "YTD"
        }, {
          type: "year",
          count: 1,
          text: "1y"
        }, {
          type: "all",
          text: "All"
        }],
        init: function init(a) {
          var b = this,
              d = a.options.rangeSelector,
              f = d.buttons || [].concat(b.defaultButtons),
              g = d.selected,
              c = function c() {
            var a = b.minInput,
                c = b.maxInput;
            a && a.blur && e(a, "blur");
            c && c.blur && e(c, "blur");
          };

          b.chart = a;
          b.options = d;
          b.buttons = [];
          a.extraTopMargin = d.height;
          b.buttonOptions = f;
          this.unMouseDown = A(a.container, "mousedown", c);
          this.unResize = A(a, "resize", c);
          f.forEach(b.computeButtonRange);
          void 0 !== g && f[g] && this.clickButton(g, !1);
          A(a, "load", function () {
            a.xAxis && a.xAxis[0] && A(a.xAxis[0], "setExtremes", function (c) {
              this.max - this.min !== a.fixedRange && "rangeSelectorButton" !== c.trigger && "updatedData" !== c.trigger && b.forcedDataGrouping && !b.frozenStates && this.setDataGrouping(!1, !1);
            });
          });
        },
        updateButtonStates: function updateButtonStates() {
          var a = this,
              b = this.chart,
              e = b.xAxis[0],
              f = Math.round(e.max - e.min),
              g = !e.hasVisibleSeries,
              c = b.scroller && b.scroller.getUnionExtremes() || e,
              k = c.dataMin,
              l = c.dataMax,
              b = a.getYTDExtremes(l, k, b.time.useUTC),
              m = b.min,
              h = b.max,
              n = a.selected,
              q = p(n),
              r = a.options.allButtonsEnabled,
              t = a.buttons;
          a.buttonOptions.forEach(function (b, c) {
            var d = b._range,
                p = b.type,
                w = b.count || 1,
                x = t[c],
                u = 0,
                v = b._offsetMax - b._offsetMin;
            b = c === n;
            var z = d > l - k,
                y = d < e.minRange,
                E = !1,
                C = !1,
                d = d === f;
            ("month" === p || "year" === p) && f + 36E5 >= 864E5 * {
              month: 28,
              year: 365
            }[p] * w - v && f - 36E5 <= 864E5 * {
              month: 31,
              year: 366
            }[p] * w + v ? d = !0 : "ytd" === p ? (d = h - m + v === f, E = !b) : "all" === p && (d = e.max - e.min >= l - k, C = !b && q && d);
            p = !r && (z || y || C || g);
            w = b && d || d && !q && !E || b && a.frozenStates;
            p ? u = 3 : w && (q = !0, u = 2);
            x.state !== u && (x.setState(u), 0 === u && n === c && a.setSelected(null));
          });
        },
        computeButtonRange: function computeButtonRange(a) {
          var d = a.type,
              e = a.count || 1,
              f = {
            millisecond: 1,
            second: 1E3,
            minute: 6E4,
            hour: 36E5,
            day: 864E5,
            week: 6048E5
          };
          if (f[d]) a._range = f[d] * e;else if ("month" === d || "year" === d) a._range = 864E5 * {
            month: 30,
            year: 365
          }[d] * e;
          a._offsetMin = b(a.offsetMin, 0);
          a._offsetMax = b(a.offsetMax, 0);
          a._range += a._offsetMax - a._offsetMin;
        },
        setInputValue: function setInputValue(a, b) {
          var d = this.chart.options.rangeSelector,
              e = this.chart.time,
              f = this[a + "Input"];
          v(b) && (f.previousValue = f.HCTime, f.HCTime = b);
          f.value = e.dateFormat(d.inputEditDateFormat || "%Y-%m-%d", f.HCTime);
          this[a + "DateBox"].attr({
            text: e.dateFormat(d.inputDateFormat || "%b %e, %Y", f.HCTime)
          });
        },
        showInput: function showInput(a) {
          var b = this.inputGroup,
              d = this[a + "DateBox"];
          g(this[a + "Input"], {
            left: b.translateX + d.x + "px",
            top: b.translateY + "px",
            width: d.width - 2 + "px",
            height: d.height - 2 + "px",
            border: "2px solid silver"
          });
        },
        hideInput: function hideInput(a) {
          g(this[a + "Input"], {
            border: 0,
            width: "1px",
            height: "1px"
          });
          this.setInputValue(a);
        },
        drawInput: function drawInput(b) {
          function d() {
            var a = h.value,
                b = (k.inputDateParser || Date.parse)(a),
                c = m.xAxis[0],
                d = m.scroller && m.scroller.xAxis ? m.scroller.xAxis : c,
                f = d.dataMin,
                d = d.dataMax;
            b !== h.previousValue && (h.previousValue = b, p(b) || (b = a.split("-"), b = Date.UTC(l(b[0]), l(b[1]) - 1, l(b[2]))), p(b) && (m.time.useUTC || (b += 6E4 * new Date().getTimezoneOffset()), v ? b > e.maxInput.HCTime ? b = void 0 : b < f && (b = f) : b < e.minInput.HCTime ? b = void 0 : b > d && (b = d), void 0 !== b && c.setExtremes(v ? b : c.min, v ? c.max : b, void 0, void 0, {
              trigger: "rangeSelectorInput"
            })));
          }

          var e = this,
              m = e.chart,
              n = m.renderer.style || {},
              c = m.renderer,
              k = m.options.rangeSelector,
              q = e.div,
              v = "min" === b,
              h,
              z,
              y = this.inputGroup;
          this[b + "Label"] = z = c.label(u.lang[v ? "rangeSelectorFrom" : "rangeSelectorTo"], this.inputGroup.offset).addClass("highcharts-range-label").attr({
            padding: 2
          }).add(y);
          y.offset += z.width + 5;
          this[b + "DateBox"] = c = c.label("", y.offset).addClass("highcharts-range-input").attr({
            padding: 2,
            width: k.inputBoxWidth || 90,
            height: k.inputBoxHeight || 17,
            "text-align": "center"
          }).on("click", function () {
            e.showInput(b);
            e[b + "Input"].focus();
          });
          m.styledMode || c.attr({
            stroke: k.inputBoxBorderColor || "#cccccc",
            "stroke-width": 1
          });
          c.add(y);
          y.offset += c.width + (v ? 10 : 0);
          this[b + "Input"] = h = t("input", {
            name: b,
            className: "highcharts-range-selector",
            type: "text"
          }, {
            top: m.plotTop + "px"
          }, q);
          m.styledMode || (z.css(r(n, k.labelStyle)), c.css(r({
            color: "#333333"
          }, n, k.inputStyle)), g(h, f({
            position: "absolute",
            border: 0,
            width: "1px",
            height: "1px",
            padding: 0,
            textAlign: "center",
            fontSize: n.fontSize,
            fontFamily: n.fontFamily,
            top: "-9999em"
          }, k.inputStyle)));

          h.onfocus = function () {
            e.showInput(b);
          };

          h.onblur = function () {
            h === a.doc.activeElement && (d(), e.hideInput(b));
          };

          h.onchange = d;

          h.onkeypress = function (a) {
            13 === a.keyCode && d();
          };
        },
        getPosition: function getPosition() {
          var a = this.chart,
              b = a.options.rangeSelector,
              a = "top" === b.verticalAlign ? a.plotTop - a.axisOffset[0] : 0;
          return {
            buttonTop: a + b.buttonPosition.y,
            inputTop: a + b.inputPosition.y - 10
          };
        },
        getYTDExtremes: function getYTDExtremes(a, b, e) {
          var d = this.chart.time,
              f = new d.Date(a),
              c = d.get("FullYear", f);
          e = e ? d.Date.UTC(c, 0, 1) : +new d.Date(c, 0, 1);
          b = Math.max(b || 0, e);
          f = f.getTime();
          return {
            max: Math.min(a || f, f),
            min: b
          };
        },
        render: function render(a, e) {
          var d = this,
              f = d.chart,
              g = f.renderer,
              c = f.container,
              k = f.options,
              l = k.exporting && !1 !== k.exporting.enabled && k.navigation && k.navigation.buttonOptions,
              m = u.lang,
              h = d.div,
              n = k.rangeSelector,
              p = b(k.chart.style && k.chart.style.zIndex, 0) + 1,
              k = n.floating,
              q = d.buttons,
              h = d.inputGroup,
              r = n.buttonTheme,
              w = n.buttonPosition,
              v = n.inputPosition,
              y = n.inputEnabled,
              A = r && r.states,
              B = f.plotLeft,
              G,
              H = d.buttonGroup,
              P;
          P = d.rendered;
          var U = d.options.verticalAlign,
              ca = f.legend,
              M = ca && ca.options,
              V = w.y,
              N = v.y,
              Q = P || !1,
              X = Q ? "animate" : "attr",
              ba = 0,
              Z = 0,
              Y;

          if (!1 !== n.enabled) {
            P || (d.group = P = g.g("range-selector-group").attr({
              zIndex: 7
            }).add(), d.buttonGroup = H = g.g("range-selector-buttons").add(P), d.zoomText = g.text(m.rangeSelectorZoom, 0, 15).add(H), f.styledMode || (d.zoomText.css(n.labelStyle), r["stroke-width"] = b(r["stroke-width"], 0)), d.buttonOptions.forEach(function (a, b) {
              q[b] = g.button(a.text, 0, 0, function () {
                var c = a.events && a.events.click,
                    e;
                c && (e = c.call(a));
                !1 !== e && d.clickButton(b);
                d.isActive = !0;
              }, r, A && A.hover, A && A.select, A && A.disabled).attr({
                "text-align": "center"
              }).add(H);
            }), !1 !== y && (d.div = h = t("div", null, {
              position: "relative",
              height: 0,
              zIndex: p
            }), c.parentNode.insertBefore(h, c), d.inputGroup = h = g.g("input-group").add(P), h.offset = 0, d.drawInput("min"), d.drawInput("max")));
            d.zoomText[X]({
              x: b(B + w.x, B)
            });
            G = b(B + w.x, B) + d.zoomText.getBBox().width + 5;
            d.buttonOptions.forEach(function (a, c) {
              q[c][X]({
                x: G
              });
              G += q[c].width + b(n.buttonSpacing, 5);
            });
            B = f.plotLeft - f.spacing[3];
            d.updateButtonStates();
            l && this.titleCollision(f) && "top" === U && "right" === w.align && w.y + H.getBBox().height - 12 < (l.y || 0) + l.height && (ba = -40);
            "left" === w.align ? Y = w.x - f.spacing[3] : "right" === w.align && (Y = w.x + ba - f.spacing[1]);
            H.align({
              y: w.y,
              width: H.getBBox().width,
              align: w.align,
              x: Y
            }, !0, f.spacingBox);
            d.group.placed = Q;
            d.buttonGroup.placed = Q;
            !1 !== y && (ba = l && this.titleCollision(f) && "top" === U && "right" === v.align && v.y - h.getBBox().height - 12 < (l.y || 0) + l.height + f.spacing[0] ? -40 : 0, "left" === v.align ? Y = B : "right" === v.align && (Y = -Math.max(f.axisOffset[1], -ba)), h.align({
              y: v.y,
              width: h.getBBox().width,
              align: v.align,
              x: v.x + Y - 2
            }, !0, f.spacingBox), c = h.alignAttr.translateX + h.alignOptions.x - ba + h.getBBox().x + 2, l = h.alignOptions.width, m = H.alignAttr.translateX + H.getBBox().x, Y = H.getBBox().width + 20, (v.align === w.align || m + Y > c && c + l > m && V < N + h.getBBox().height) && h.attr({
              translateX: h.alignAttr.translateX + (f.axisOffset[1] >= -ba ? 0 : -ba),
              translateY: h.alignAttr.translateY + H.getBBox().height + 10
            }), d.setInputValue("min", a), d.setInputValue("max", e), d.inputGroup.placed = Q);
            d.group.align({
              verticalAlign: U
            }, !0, f.spacingBox);
            a = d.group.getBBox().height + 20;
            e = d.group.alignAttr.translateY;
            "bottom" === U && (ca = M && "bottom" === M.verticalAlign && M.enabled && !M.floating ? ca.legendHeight + b(M.margin, 10) : 0, a = a + ca - 20, Z = e - a - (k ? 0 : n.y) - 10);
            if ("top" === U) k && (Z = 0), f.titleOffset && (Z = f.titleOffset + f.options.title.margin), Z += f.margin[0] - f.spacing[0] || 0;else if ("middle" === U) if (N === V) Z = 0 > N ? e + void 0 : e;else if (N || V) Z = 0 > N || 0 > V ? Z - Math.min(N, V) : e - a + NaN;
            d.group.translate(n.x, n.y + Math.floor(Z));
            !1 !== y && (d.minInput.style.marginTop = d.group.translateY + "px", d.maxInput.style.marginTop = d.group.translateY + "px");
            d.rendered = !0;
          }
        },
        getHeight: function getHeight() {
          var a = this.options,
              b = this.group,
              e = a.y,
              f = a.buttonPosition.y,
              a = a.inputPosition.y,
              b = b ? b.getBBox(!0).height + 13 + e : 0,
              e = Math.min(a, f);
          if (0 > a && 0 > f || 0 < a && 0 < f) b += Math.abs(e);
          return b;
        },
        titleCollision: function titleCollision(a) {
          return !(a.options.title.text || a.options.subtitle.text);
        },
        update: function update(a) {
          var b = this.chart;
          r(!0, b.options.rangeSelector, a);
          this.destroy();
          this.init(b);
          b.rangeSelector.render();
        },
        destroy: function destroy() {
          var b = this,
              e = b.minInput,
              f = b.maxInput;
          b.unMouseDown();
          b.unResize();
          y(b.buttons);
          e && (e.onfocus = e.onblur = e.onchange = null);
          f && (f.onfocus = f.onblur = f.onchange = null);
          a.objectEach(b, function (a, d) {
            a && "chart" !== d && (a.destroy ? a.destroy() : a.nodeType && q(this[d]));
            a !== B.prototype[d] && (b[d] = null);
          }, this);
        }
      };

      G.prototype.toFixedRange = function (a, e, f, g) {
        var d = this.chart && this.chart.fixedRange;
        a = b(f, this.translate(a, !0, !this.horiz));
        e = b(g, this.translate(e, !0, !this.horiz));
        f = d && (e - a) / d;
        .7 < f && 1.3 > f && (g ? a = e - d : e = a + d);
        p(a) && p(e) || (a = e = void 0);
        return {
          min: a,
          max: e
        };
      };

      G.prototype.minFromRange = function () {
        var a = this.range,
            e = {
          month: "Month",
          year: "FullYear"
        }[a.type],
            f,
            g = this.max,
            l,
            c,
            k = function k(a, b) {
          var c = new Date(a),
              d = c["get" + e]();
          c["set" + e](d + b);
          d === c["get" + e]() && c.setDate(0);
          return c.getTime() - a;
        };

        p(a) ? (f = g - a, c = a) : (f = g + k(g, -a.count), this.chart && (this.chart.fixedRange = g - f));
        l = b(this.dataMin, Number.MIN_VALUE);
        p(f) || (f = l);
        f <= l && (f = l, void 0 === c && (c = k(f, a.count)), this.newMax = Math.min(f + c, this.dataMax));
        p(g) || (f = void 0);
        return f;
      };

      A(m, "afterGetContainer", function () {
        this.options.rangeSelector.enabled && (this.rangeSelector = new B(this));
      });
      A(m, "beforeRender", function () {
        var a = this.axes,
            b = this.rangeSelector;
        b && (p(b.deferredYTDClick) && (b.clickButton(b.deferredYTDClick), delete b.deferredYTDClick), a.forEach(function (a) {
          a.updateNames();
          a.setScale();
        }), this.getAxisMargins(), b.render(), a = b.options.verticalAlign, b.options.floating || ("bottom" === a ? this.extraBottomMargin = !0 : "middle" !== a && (this.extraTopMargin = !0)));
      });
      A(m, "update", function (a) {
        var b = a.options.rangeSelector;
        a = this.rangeSelector;
        var d = this.extraBottomMargin,
            e = this.extraTopMargin;
        b && b.enabled && !v(a) && (this.options.rangeSelector.enabled = !0, this.rangeSelector = new B(this));
        this.extraTopMargin = this.extraBottomMargin = !1;
        a && (a.render(), b = b && b.verticalAlign || a.options && a.options.verticalAlign, a.options.floating || ("bottom" === b ? this.extraBottomMargin = !0 : "middle" !== b && (this.extraTopMargin = !0)), this.extraBottomMargin !== d || this.extraTopMargin !== e) && (this.isDirtyBox = !0);
      });
      A(m, "render", function () {
        var a = this.rangeSelector;
        a && !a.options.floating && (a.render(), a = a.options.verticalAlign, "bottom" === a ? this.extraBottomMargin = !0 : "middle" !== a && (this.extraTopMargin = !0));
      });
      A(m, "getMargins", function () {
        var a = this.rangeSelector;
        a && (a = a.getHeight(), this.extraTopMargin && (this.plotTop += a), this.extraBottomMargin && (this.marginBottom += a));
      });
      m.prototype.callbacks.push(function (a) {
        function b() {
          d = a.xAxis[0].getExtremes();
          p(d.min) && e.render(d.min, d.max);
        }

        var d,
            e = a.rangeSelector,
            f,
            c;
        e && (c = A(a.xAxis[0], "afterSetExtremes", function (a) {
          e.render(a.min, a.max);
        }), f = A(a, "redraw", b), b());
        A(a, "destroy", function () {
          e && (f(), c());
        });
      });
      a.RangeSelector = B;
    })(H);

    (function (a) {
      var B = a.addEvent,
          A = a.arrayMax,
          G = a.arrayMin,
          m = a.Axis,
          g = a.Chart,
          t = a.defined,
          u = a.extend,
          v = a.format,
          y = a.isNumber,
          q = a.isString,
          f = a.merge,
          e = a.pick,
          p = a.Point,
          r = a.Renderer,
          b = a.Series,
          l = a.splat,
          n = a.SVGRenderer,
          d = a.VMLRenderer,
          w = b.prototype,
          E = w.init,
          C = w.processData,
          F = p.prototype.tooltipFormatter;

      a.StockChart = a.stockChart = function (b, d, m) {
        var c = q(b) || b.nodeName,
            h = arguments[c ? 1 : 0],
            k = h,
            n = h.series,
            p = a.getOptions(),
            r,
            t = e(h.navigator && h.navigator.enabled, p.navigator.enabled, !0),
            u = t ? {
          startOnTick: !1,
          endOnTick: !1
        } : null,
            x = {
          marker: {
            enabled: !1,
            radius: 2
          }
        },
            v = {
          shadow: !1,
          borderWidth: 0
        };
        h.xAxis = l(h.xAxis || {}).map(function (a, b) {
          return f({
            minPadding: 0,
            maxPadding: 0,
            overscroll: 0,
            ordinal: !0,
            title: {
              text: null
            },
            labels: {
              overflow: "justify"
            },
            showLastLabel: !0
          }, p.xAxis, p.xAxis && p.xAxis[b], a, {
            type: "datetime",
            categories: null
          }, u);
        });
        h.yAxis = l(h.yAxis || {}).map(function (a, b) {
          r = e(a.opposite, !0);
          return f({
            labels: {
              y: -2
            },
            opposite: r,
            showLastLabel: !(!a.categories && "category" !== a.type),
            title: {
              text: null
            }
          }, p.yAxis, p.yAxis && p.yAxis[b], a);
        });
        h.series = null;
        h = f({
          chart: {
            panning: !0,
            pinchType: "x"
          },
          navigator: {
            enabled: t
          },
          scrollbar: {
            enabled: e(p.scrollbar.enabled, !0)
          },
          rangeSelector: {
            enabled: e(p.rangeSelector.enabled, !0)
          },
          title: {
            text: null
          },
          tooltip: {
            split: e(p.tooltip.split, !0),
            crosshairs: !0
          },
          legend: {
            enabled: !1
          },
          plotOptions: {
            line: x,
            spline: x,
            area: x,
            areaspline: x,
            arearange: x,
            areasplinerange: x,
            column: v,
            columnrange: v,
            candlestick: v,
            ohlc: v
          }
        }, h, {
          isStock: !0
        });
        h.series = k.series = n;
        return c ? new g(b, h, m) : new g(h, d);
      };

      B(m, "autoLabelAlign", function (a) {
        var b = this.chart,
            c = this.options,
            b = b._labelPanes = b._labelPanes || {},
            d = this.options.labels;
        this.chart.options.isStock && "yAxis" === this.coll && (c = c.top + "," + c.height, !b[c] && d.enabled && (15 === d.x && (d.x = 0), void 0 === d.align && (d.align = "right"), b[c] = this, a.align = "right", a.preventDefault()));
      });
      B(m, "destroy", function () {
        var a = this.chart,
            b = this.options && this.options.top + "," + this.options.height;
        b && a._labelPanes && a._labelPanes[b] === this && delete a._labelPanes[b];
      });
      B(m, "getPlotLinePath", function (b) {
        function c(a) {
          var b = "xAxis" === a ? "yAxis" : "xAxis";
          a = d.options[b];
          return y(a) ? [g[b][a]] : q(a) ? [g.get(a)] : f.map(function (a) {
            return a[b];
          });
        }

        var d = this,
            f = this.isLinked && !this.series ? this.linkedParent.series : this.series,
            g = d.chart,
            l = g.renderer,
            m = d.left,
            n = d.top,
            p,
            r,
            u,
            v,
            w = [],
            A = [],
            B,
            C,
            E = b.translatedValue,
            G = b.value,
            F = b.force,
            H;
        if ("xAxis" === d.coll || "yAxis" === d.coll) b.preventDefault(), A = c(d.coll), B = d.isXAxis ? g.yAxis : g.xAxis, B.forEach(function (a) {
          if (t(a.options.id) ? -1 === a.options.id.indexOf("navigator") : 1) {
            var b = a.isXAxis ? "yAxis" : "xAxis",
                b = t(a.options[b]) ? g[b][a.options[b]] : g[b][0];
            d === b && A.push(a);
          }
        }), C = A.length ? [] : [d.isXAxis ? g.yAxis[0] : g.xAxis[0]], A.forEach(function (b) {
          -1 !== C.indexOf(b) || a.find(C, function (a) {
            return a.pos === b.pos && a.len === b.len;
          }) || C.push(b);
        }), H = e(E, d.translate(G, null, null, b.old)), y(H) && (d.horiz ? C.forEach(function (a) {
          var b;
          r = a.pos;
          v = r + a.len;
          p = u = Math.round(H + d.transB);
          "pass" !== F && (p < m || p > m + d.width) && (F ? p = u = Math.min(Math.max(m, p), m + d.width) : b = !0);
          b || w.push("M", p, r, "L", u, v);
        }) : C.forEach(function (a) {
          var b;
          p = a.pos;
          u = p + a.len;
          r = v = Math.round(n + d.height - H);
          "pass" !== F && (r < n || r > n + d.height) && (F ? r = v = Math.min(Math.max(n, r), d.top + d.height) : b = !0);
          b || w.push("M", p, r, "L", u, v);
        })), b.path = 0 < w.length ? l.crispPolyLine(w, b.lineWidth || 1) : null;
      });

      n.prototype.crispPolyLine = function (a, b) {
        var c;

        for (c = 0; c < a.length; c += 6) {
          a[c + 1] === a[c + 4] && (a[c + 1] = a[c + 4] = Math.round(a[c + 1]) - b % 2 / 2), a[c + 2] === a[c + 5] && (a[c + 2] = a[c + 5] = Math.round(a[c + 2]) + b % 2 / 2);
        }

        return a;
      };

      r === d && (d.prototype.crispPolyLine = n.prototype.crispPolyLine);
      B(m, "afterHideCrosshair", function () {
        this.crossLabel && (this.crossLabel = this.crossLabel.hide());
      });
      B(m, "afterDrawCrosshair", function (a) {
        var b, c;

        if (t(this.crosshair.label) && this.crosshair.label.enabled && this.cross) {
          var d = this.chart,
              f = this.options.crosshair.label,
              g = this.horiz;
          b = this.opposite;
          c = this.left;
          var l = this.top,
              m = this.crossLabel,
              n = f.format,
              p = "",
              q = "inside" === this.options.tickPosition,
              r = !1 !== this.crosshair.snap,
              w = 0,
              y = a.e || this.cross && this.cross.e,
              A = a.point;
          a = this.lin2log;
          var B, C;
          this.isLog ? (B = a(this.min), C = a(this.max)) : (B = this.min, C = this.max);
          a = g ? "center" : b ? "right" === this.labelAlign ? "right" : "left" : "left" === this.labelAlign ? "left" : "center";
          m || (m = this.crossLabel = d.renderer.label(null, null, null, f.shape || "callout").addClass("highcharts-crosshair-label" + (this.series[0] && " highcharts-color-" + this.series[0].colorIndex)).attr({
            align: f.align || a,
            padding: e(f.padding, 8),
            r: e(f.borderRadius, 3),
            zIndex: 2
          }).add(this.labelGroup), d.styledMode || m.attr({
            fill: f.backgroundColor || this.series[0] && this.series[0].color || "#666666",
            stroke: f.borderColor || "",
            "stroke-width": f.borderWidth || 0
          }).css(u({
            color: "#ffffff",
            fontWeight: "normal",
            fontSize: "11px",
            textAlign: "center"
          }, f.style)));
          g ? (a = r ? A.plotX + c : y.chartX, l += b ? 0 : this.height) : (a = b ? this.width + c : 0, l = r ? A.plotY + l : y.chartY);
          n || f.formatter || (this.isDatetimeAxis && (p = "%b %d, %Y"), n = "{value" + (p ? ":" + p : "") + "}");
          p = r ? A[this.isXAxis ? "x" : "y"] : this.toValue(g ? y.chartX : y.chartY);
          m.attr({
            text: n ? v(n, {
              value: p
            }, d.time) : f.formatter.call(this, p),
            x: a,
            y: l,
            visibility: p < B || p > C ? "hidden" : "visible"
          });
          f = m.getBBox();

          if (g) {
            if (q && !b || !q && b) l = m.y - f.height;
          } else l = m.y - f.height / 2;

          g ? (b = c - f.x, c = c + this.width - f.x) : (b = "left" === this.labelAlign ? c : 0, c = "right" === this.labelAlign ? c + this.width : d.chartWidth);
          m.translateX < b && (w = b - m.translateX);
          m.translateX + f.width >= c && (w = -(m.translateX + f.width - c));
          m.attr({
            x: a + w,
            y: l,
            anchorX: g ? a : this.opposite ? 0 : d.chartWidth,
            anchorY: g ? this.opposite ? d.chartHeight : 0 : l + f.height / 2
          });
        }
      });

      w.init = function () {
        E.apply(this, arguments);
        this.setCompare(this.options.compare);
      };

      w.setCompare = function (a) {
        this.modifyValue = "value" === a || "percent" === a ? function (b, c) {
          var d = this.compareValue;
          if (void 0 !== b && void 0 !== d) return b = "value" === a ? b - d : b / d * 100 - (100 === this.options.compareBase ? 0 : 100), c && (c.change = b), b;
        } : null;
        this.userOptions.compare = a;
        this.chart.hasRendered && (this.isDirty = !0);
      };

      w.processData = function () {
        var a,
            b = -1,
            d,
            e,
            f = !0 === this.options.compareStart ? 0 : 1,
            g,
            l;
        C.apply(this, arguments);
        if (this.xAxis && this.processedYData) for (d = this.processedXData, e = this.processedYData, g = e.length, this.pointArrayMap && (b = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), a = 0; a < g - f; a++) {
          if (l = e[a] && -1 < b ? e[a][b] : e[a], y(l) && d[a + f] >= this.xAxis.min && 0 !== l) {
            this.compareValue = l;
            break;
          }
        }
      };

      B(b, "afterGetExtremes", function () {
        if (this.modifyValue) {
          var a = [this.modifyValue(this.dataMin), this.modifyValue(this.dataMax)];
          this.dataMin = G(a);
          this.dataMax = A(a);
        }
      });

      m.prototype.setCompare = function (a, b) {
        this.isXAxis || (this.series.forEach(function (b) {
          b.setCompare(a);
        }), e(b, !0) && this.chart.redraw());
      };

      p.prototype.tooltipFormatter = function (b) {
        b = b.replace("{point.change}", (0 < this.change ? "+" : "") + a.numberFormat(this.change, e(this.series.tooltipOptions.changeDecimals, 2)));
        return F.apply(this, [b]);
      };

      B(b, "render", function () {
        var a;
        this.chart.is3d && this.chart.is3d() || this.chart.polar || !this.xAxis || this.xAxis.isRadial || (a = this.yAxis.len - (this.xAxis.axisLine ? Math.floor(this.xAxis.axisLine.strokeWidth() / 2) : 0), !this.clipBox && this.animate ? (this.clipBox = f(this.chart.clipBox), this.clipBox.width = this.xAxis.len, this.clipBox.height = a) : this.chart[this.sharedClipKey] && (this.chart[this.sharedClipKey].animate({
          width: this.xAxis.len,
          height: a
        }), this.chart[this.sharedClipKey + "m"] && this.chart[this.sharedClipKey + "m"].animate({
          width: this.xAxis.len
        })));
      });
      B(g, "update", function (a) {
        a = a.options;
        "scrollbar" in a && this.navigator && (f(!0, this.options.scrollbar, a.scrollbar), this.navigator.update({}, !1), delete a.scrollbar);
      });
    })(H);

    return H;
  });
});
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}

var _assocIndexOf = assocIndexOf;
/** Used for built-in method references. */

var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */

function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}

var _stackClear = stackClear;
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;
/** Built-in value references. */

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);

  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;
/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;
/** Used for built-in method references. */

var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);

  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;
/* Built-in method references that are verified to be native. */

var Map = _getNative(_root, 'Map');

var _Map = Map;
/* Built-in method references that are verified to be native. */

var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }

  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;
/** Used for built-in method references. */

var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;
/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}

var _mapCacheClear = mapCacheClear;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

var _isKeyable = isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */

function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

var _getMapData = getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);

  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */

function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof _ListCache) {
    var pairs = data.__data__;

    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new _MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */

function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;

var defineProperty = function () {
  try {
    var func = _getNative(Object, 'defineProperty');

    func({}, '', {});
    return func;
  } catch (e) {}
}();

var _defineProperty = defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq_1(object[key], value) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];

      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }

    return object;
  };
}

var _createBaseFor = createBaseFor;
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */

var baseFor = _createBaseFor();

var _baseFor = baseFor;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
});
/** Built-in value references. */


var Uint8Array = _root.Uint8Array;
var _Uint8Array = Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */

function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}

var _copyArray = copyArray;
/** Built-in value references. */

var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject_1(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var _baseCreate = baseCreate;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;
/** Built-in value references. */

var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$5;
  return value === proto;
}

var _isPrototype = isPrototype;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
}

var _initCloneObject = initCloneObject;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
var isArray_1 = isArray;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */

function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;
var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});
/** `Object#toString` result references. */

var objectTag = '[object Object]';
/** Used for built-in method references. */

var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
    return false;
  }

  var proto = _getPrototype(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && _freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  module.exports = nodeUtil;
});
/* Node.js helper references. */


var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;
/** Used for built-in method references. */

var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */

function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }

  return object;
}

var _copyObject = copyObject;
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}

var _baseTimes = baseTimes;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

var _isIndex = isIndex;
/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    _isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}

var _arrayLikeKeys = arrayLikeKeys;
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}

var _nativeKeysIn = nativeKeysIn;
/** Used for built-in method references. */

var objectProto$a = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }

  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}

var _baseKeysIn = baseKeysIn;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */

function keysIn$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn$1;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */

function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);

    return;
  }

  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);
    newValue = srcValue;

    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;

      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      } else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }

  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }

  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */

function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }

  _baseFor(source, function (srcValue, key) {
    if (isObject_1(srcValue)) {
      stack || (stack = new _Stack());

      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(_safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }

      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity(value) {
  return value;
}

var identity_1 = identity;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

var _apply = apply;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */

function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant(value) {
  return function () {
    return value;
  };
}

var constant_1 = constant;
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var baseSetToString = !_defineProperty ? identity_1 : function (func, string) {
  return _defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};
var _baseSetToString = baseSetToString;
/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */

var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */

function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */

function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }

  var type = typeof index;

  if (type == 'number' ? isArrayLike_1(object) && _isIndex(index, object.length) : type == 'string' && index in object) {
    return eq_1(object[index], value);
  }

  return false;
}

var _isIterateeCall = isIterateeCall;
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */

function createAssigner(assigner) {
  return _baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }

    object = Object(object);

    while (++index < length) {
      var source = sources[index];

      if (source) {
        assigner(object, source, index, customizer);
      }
    }

    return object;
  });
}

var _createAssigner = createAssigner;
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */

var merge = _createAssigner(function (object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;
var isFunction_1$1 = isFunction$1;
var toString = Object.prototype.toString;

function isFunction$1(fn) {
  var string = toString.call(fn);
  return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && ( // IE8 and below
  fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */


var isobject = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

function isObjectObject(o) {
  return isobject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}

var isPlainObject$1 = function isPlainObject(o) {
  var ctor, prot;
  if (isObjectObject(o) === false) return false; // If has modified constructor

  ctor = o.constructor;
  if (typeof ctor !== 'function') return false; // If has modified prototype

  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false; // If constructor does not have an Object-specific method

  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  } // Most likely a plain Object


  return true;
};

var channel = '__THEMING__';

function createBroadcast(initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState() {
    return _state;
  }

  function setState(state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;

    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) {
        listeners[keys[i]](state);
      }
    }
  } // subscribe to changes and return the subscriptionId


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.');
    }

    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId;
  } // remove subscription by removing the listener function


  function unsubscribe(id) {
    listeners[id] = undefined;
  }

  return {
    getState: getState,
    setState: setState,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Provide a theme to an entire react component tree via context
 * and event listeners (have to do both context
 * and event emitter as pure components block context updates)
 */


function createThemeProvider() {
  var _class, _temp2;

  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : channel;
  return _temp2 = _class = function (_React$Component) {
    _inherits(ThemeProvider, _React$Component);

    function ThemeProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ThemeProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.getTheme()), _this.setOuterTheme = function (theme) {
        _this.outerTheme = theme;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ThemeProvider, [{
      key: 'getTheme',
      // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
      value: function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;

        if (isFunction_1$1(theme)) {
          var mergedTheme = theme(this.outerTheme);

          if (!isPlainObject$1(mergedTheme)) {
            throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
          }

          return mergedTheme;
        }

        if (!isPlainObject$1(theme)) {
          throw new Error('[ThemeProvider] Please make your theme prop a plain object');
        }

        if (!this.outerTheme) {
          return theme;
        }

        return _extends({}, this.outerTheme, theme);
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return _defineProperty$1({}, CHANNEL, this.broadcast);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        // create a new subscription for keeping track of outer theme, if present
        if (this.context[CHANNEL]) {
          this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
        }
      } // set broadcast state by merging outer theme with own

    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (this.context[CHANNEL]) {
          this.setOuterTheme(this.context[CHANNEL].getState());
          this.broadcast.setState(this.getTheme());
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) {
          this.broadcast.setState(this.getTheme(nextProps.theme));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.subscriptionId !== undefined) {
          this.context[CHANNEL].unsubscribe(this.subscriptionId);
          delete this.subscriptionId;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        if (!this.props.children) {
          return null;
        }

        return React__default.Children.only(this.props.children);
      }
    }]);

    return ThemeProvider;
  }(React__default.Component), _class.propTypes = {
    children: PropTypes.element,
    theme: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]).isRequired
  }, _class.childContextTypes = _defineProperty$1({}, CHANNEL, PropTypes.object.isRequired), _class.contextTypes = _defineProperty$1({}, CHANNEL, PropTypes.object), _temp2;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createThemeListener() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : channel;

  var contextTypes = _defineProperty$2({}, CHANNEL, PropTypes.object.isRequired);

  function initial(context) {
    if (!context[CHANNEL]) {
      throw new Error('[' + this.displayName + '] Please use ThemeProvider to be able to use WithTheme');
    }

    return context[CHANNEL].getState();
  }

  function subscribe(context, cb) {
    if (context[CHANNEL]) {
      return context[CHANNEL].subscribe(cb);
    }
  }

  function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }

  return {
    contextTypes: contextTypes,
    initial: initial,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
}

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$1(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var getDisplayName = function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
};

function createWithTheme() {
  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : channel;
  var themeListener = createThemeListener(CHANNEL);
  return function (Component$$1) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      _inherits$1(WithTheme, _React$Component);

      function WithTheme(props, context) {
        _classCallCheck$1(this, WithTheme);

        var _this = _possibleConstructorReturn$1(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));

        _this.state = {
          theme: themeListener.initial(context)
        };

        _this.setTheme = function (theme) {
          return _this.setState({
            theme: theme
          });
        };

        return _this;
      }

      _createClass$1(WithTheme, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.unsubscribe = themeListener.subscribe(this.context, this.setTheme);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var theme = this.state.theme;
          return React__default.createElement(Component$$1, _extends$1({
            theme: theme
          }, this.props));
        }
      }]);

      return WithTheme;
    }(React__default.Component), _class.displayName = 'WithTheme(' + getDisplayName(Component$$1) + ')', _class.contextTypes = themeListener.contextTypes, _temp;
  };
}

var withTheme = createWithTheme();
var ThemeProvider = createThemeProvider();
var themeListener = createThemeListener();

function createTheming() {
  var customChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : channel;
  return {
    channel: customChannel,
    withTheme: createWithTheme(customChannel),
    ThemeProvider: createThemeProvider(customChannel),
    themeListener: createThemeListener(customChannel)
  };
}

var _theming = {
  channel: channel,
  withTheme: withTheme,
  ThemeProvider: ThemeProvider,
  themeListener: themeListener,
  createTheming: createTheming
};
var getDynamicStyles_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports['default'] = getDynamicStyles;
  /**
   * Extracts a styles object with only props that contain function values.
   */

  function getDynamicStyles(styles) {
    var to = null;

    for (var key in styles) {
      var value = styles[key];
      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

      if (type === 'function') {
        if (!to) to = {};
        to[key] = value;
      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
        var extracted = getDynamicStyles(value);

        if (extracted) {
          if (!to) to = {};
          to[key] = extracted;
        }
      }
    }

    return to;
  }
});
unwrapExports(getDynamicStyles_1);
var toCssValue_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = toCssValue;

  var join = function join(value, by) {
    var result = '';

    for (var i = 0; i < value.length; i++) {
      // Remove !important from the value, it will be readded later.
      if (value[i] === '!important') break;
      if (result) result += by;
      result += value[i];
    }

    return result;
  };
  /**
   * Converts array values to string.
   *
   * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
   * `border: ['1px', '2px']` > `border: 1px, 2px;`
   * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
   * `color: ['red', !important]` > `color: red !important;`
   */


  function toCssValue(value) {
    var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

    if (Array.isArray(value[0])) {
      for (var i = 0; i < value.length; i++) {
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
      }
    } else cssValue = join(value, ', '); // Add !important, because it was ignored.


    if (!ignoreImportant && value[value.length - 1] === '!important') {
      cssValue += ' !important';
    }

    return cssValue;
  }
});
unwrapExports(toCssValue_1);
var SheetsRegistry_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * Sheets registry to access them all at one place.
   */


  var SheetsRegistry = function () {
    function SheetsRegistry() {
      _classCallCheck(this, SheetsRegistry);

      this.registry = [];
    }

    _createClass(SheetsRegistry, [{
      key: 'add',

      /**
       * Register a Style Sheet.
       */
      value: function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;

        if (registry.length === 0 || index >= this.index) {
          registry.push(sheet);
          return;
        } // Find a position.


        for (var i = 0; i < registry.length; i++) {
          if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
          }
        }
      }
      /**
       * Reset the registry.
       */

    }, {
      key: 'reset',
      value: function reset() {
        this.registry = [];
      }
      /**
       * Remove a Style Sheet.
       */

    }, {
      key: 'remove',
      value: function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
      }
      /**
       * Convert all attached sheets to a CSS string.
       */

    }, {
      key: 'toString',
      value: function toString(options) {
        return this.registry.filter(function (sheet) {
          return sheet.attached;
        }).map(function (sheet) {
          return sheet.toString(options);
        }).join('\n');
      }
    }, {
      key: 'index',

      /**
       * Current highest index number.
       */
      get: function get() {
        return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
      }
    }]);

    return SheetsRegistry;
  }();

  exports['default'] = SheetsRegistry;
});
unwrapExports(SheetsRegistry_1);
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function warning() {};

if (__DEV__) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });

      if (typeof console !== 'undefined') {
        console.error(message);
      }

      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

var warning_1 = warning;
var SheetsManager_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * SheetsManager is like a WeakMap which is designed to count StyleSheet
   * instances and attach/detach automatically.
   */


  var SheetsManager = function () {
    function SheetsManager() {
      _classCallCheck(this, SheetsManager);

      this.sheets = [];
      this.refs = [];
      this.keys = [];
    }

    _createClass(SheetsManager, [{
      key: 'get',
      value: function get(key) {
        var index = this.keys.indexOf(key);
        return this.sheets[index];
      }
    }, {
      key: 'add',
      value: function add(key, sheet) {
        var sheets = this.sheets,
            refs = this.refs,
            keys = this.keys;
        var index = sheets.indexOf(sheet);
        if (index !== -1) return index;
        sheets.push(sheet);
        refs.push(0);
        keys.push(key);
        return sheets.length - 1;
      }
    }, {
      key: 'manage',
      value: function manage(key) {
        var index = this.keys.indexOf(key);
        var sheet = this.sheets[index];
        if (this.refs[index] === 0) sheet.attach();
        this.refs[index]++;
        if (!this.keys[index]) this.keys.splice(index, 0, key);
        return sheet;
      }
    }, {
      key: 'unmanage',
      value: function unmanage(key) {
        var index = this.keys.indexOf(key);

        if (index === -1) {
          // eslint-ignore-next-line no-console
          (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
          return;
        }

        if (this.refs[index] > 0) {
          this.refs[index]--;
          if (this.refs[index] === 0) this.sheets[index].detach();
        }
      }
    }, {
      key: 'size',
      get: function get() {
        return this.keys.length;
      }
    }]);

    return SheetsManager;
  }();

  exports['default'] = SheetsManager;
});
unwrapExports(SheetsManager_1);
var toCss_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = toCss;

  var _toCssValue2 = _interopRequireDefault(toCssValue_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * Indent a string.
   * http://jsperf.com/array-join-vs-for
   */


  function indentStr(str, indent) {
    var result = '';

    for (var index = 0; index < indent; index++) {
      result += '  ';
    }

    return result + str;
  }
  /**
   * Converts a Rule to CSS string.
   */


  function toCss(selector, style) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var result = '';
    if (!style) return result;
    var _options$indent = options.indent,
        indent = _options$indent === undefined ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    indent++; // Apply fallbacks first.

    if (fallbacks) {
      // Array syntax {fallbacks: [{prop: value}]}
      if (Array.isArray(fallbacks)) {
        for (var index = 0; index < fallbacks.length; index++) {
          var fallback = fallbacks[index];

          for (var prop in fallback) {
            var value = fallback[prop];

            if (value != null) {
              result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
            }
          }
        }
      } else {
        // Object syntax {fallbacks: {prop: value}}
        for (var _prop in fallbacks) {
          var _value = fallbacks[_prop];

          if (_value != null) {
            result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
          }
        }
      }
    }

    for (var _prop2 in style) {
      var _value2 = style[_prop2];

      if (_value2 != null && _prop2 !== 'fallbacks') {
        result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
      }
    } // Allow empty style in this case, because properties will be added dynamically.


    if (!result && !options.allowEmpty) return result;
    indent--;
    result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);
    return result;
  }
});
unwrapExports(toCss_1);
var StyleRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _warning2 = _interopRequireDefault(warning_1);

  var _toCss2 = _interopRequireDefault(toCss_1);

  var _toCssValue2 = _interopRequireDefault(toCssValue_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var StyleRule = function () {
    function StyleRule(key, style, options) {
      _classCallCheck(this, StyleRule);

      this.type = 'style';
      this.isProcessed = false;
      var sheet = options.sheet,
          Renderer = options.Renderer,
          selector = options.selector;
      this.key = key;
      this.options = options;
      this.style = style;
      if (selector) this.selectorText = selector;
      this.renderer = sheet ? sheet.renderer : new Renderer();
    }
    /**
     * Set selector string.
     * Attention: use this with caution. Most browsers didn't implement
     * selectorText setter, so this may result in rerendering of entire Style Sheet.
     */


    _createClass(StyleRule, [{
      key: 'prop',

      /**
       * Get or set a style property.
       */
      value: function prop(name, value) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

        if (this.style[name] === value) return this;
        value = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = value == null || value === false;
        var isDefined = (name in this.style); // Value is empty and wasn't defined before.

        if (isEmpty && !isDefined) return this; // We are going to remove this value.

        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];else this.style[name] = value; // Renderable is defined if StyleSheet option `link` is true.

        if (this.renderable) {
          if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
          return this;
        }

        var sheet = this.options.sheet;

        if (sheet && sheet.attached) {
          (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
        }

        return this;
      }
      /**
       * Apply rule to an element inline.
       */

    }, {
      key: 'applyTo',
      value: function applyTo(renderable) {
        var json = this.toJSON();

        for (var prop in json) {
          this.renderer.setProperty(renderable, prop, json[prop]);
        }

        return this;
      }
      /**
       * Returns JSON representation of the rule.
       * Fallbacks are not supported.
       * Useful for inline styles.
       */

    }, {
      key: 'toJSON',
      value: function toJSON() {
        var json = {};

        for (var prop in this.style) {
          var value = this.style[prop];
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
        }

        return json;
      }
      /**
       * Generates a CSS string.
       */

    }, {
      key: 'toString',
      value: function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? _extends({}, options, {
          allowEmpty: true
        }) : options;
        return (0, _toCss2['default'])(this.selector, this.style, opts);
      }
    }, {
      key: 'selector',
      set: function set(selector) {
        if (selector === this.selectorText) return;
        this.selectorText = selector;
        if (!this.renderable) return;
        var hasChanged = this.renderer.setSelector(this.renderable, selector); // If selector setter is not implemented, rerender the rule.

        if (!hasChanged && this.renderable) {
          var renderable = this.renderer.replaceRule(this.renderable, this);
          if (renderable) this.renderable = renderable;
        }
      }
      /**
       * Get selector string.
       */
      ,
      get: function get() {
        return this.selectorText;
      }
    }]);

    return StyleRule;
  }();

  exports['default'] = StyleRule;
});
unwrapExports(StyleRule_1);

function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;

  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      result = Symbol('observable');
      Symbol.observable = result;
    }
  } else {
    result = '@@observable';
  }

  return result;
}
/* global window */


var root$1;

if (typeof self !== 'undefined') {
  root$1 = self;
} else if (typeof window !== 'undefined') {
  root$1 = window;
} else if (typeof global !== 'undefined') {
  root$1 = global;
} else if (typeof module !== 'undefined') {
  root$1 = module;
} else {
  root$1 = Function('return this')();
}

var result = symbolObservablePonyfill(root$1);
var isObservable = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _symbolObservable2 = _interopRequireDefault(result);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  exports['default'] = function (value) {
    return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
  };
});
unwrapExports(isObservable);
var cloneStyle_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports['default'] = cloneStyle;

  var _isObservable2 = _interopRequireDefault(isObservable);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var isArray = Array.isArray;

  function cloneStyle(style) {
    // Support empty values in case user ends up with them by accident.
    if (style == null) return style; // Support string value for SimpleRule.

    var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

    if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
      return style;
    } // Support array for FontFaceRule.


    if (isArray(style)) return style.map(cloneStyle); // Support Observable styles.  Observables are immutable, so we don't need to
    // copy them.

    if ((0, _isObservable2['default'])(style)) return style;
    var newStyle = {};

    for (var name in style) {
      var value = style[name];

      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        newStyle[name] = cloneStyle(value);
        continue;
      }

      newStyle[name] = value;
    }

    return newStyle;
  }
});
unwrapExports(cloneStyle_1);
var createRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = createRule;

  var _warning2 = _interopRequireDefault(warning_1);

  var _StyleRule2 = _interopRequireDefault(StyleRule_1);

  var _cloneStyle2 = _interopRequireDefault(cloneStyle_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * Create a rule instance.
   */


  function createRule() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
    var decl = arguments[1];
    var options = arguments[2];
    var jss = options.jss;
    var declCopy = (0, _cloneStyle2['default'])(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.

    if (name[0] === '@') {
      (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
    }

    return new _StyleRule2['default'](name, declCopy, options);
  }
});
unwrapExports(createRule_1);
var linkRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = linkRule;
  /**
   * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
   */

  function linkRule(rule, cssRule) {
    rule.renderable = cssRule;
    if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
  }
});
unwrapExports(linkRule_1);

var _escape = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CSS = commonjsGlobal.CSS;
  var env = process.env.NODE_ENV;
  var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

  exports['default'] = function (str) {
    // We don't need to escape it in production, because we are not using user's
    // input for selectors, we are generating a valid selector.
    if (env === 'production') return str;

    if (!CSS || !CSS.escape) {
      return str.replace(escapeRegex, '\\$1');
    }

    return CSS.escape(str);
  };
});

unwrapExports(_escape);
var RuleList_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _createRule2 = _interopRequireDefault(createRule_1);

  var _linkRule2 = _interopRequireDefault(linkRule_1);

  var _StyleRule2 = _interopRequireDefault(StyleRule_1);

  var _escape2 = _interopRequireDefault(_escape);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */


  var RuleList = function () {
    // Original styles object.
    function RuleList(options) {
      var _this = this;

      _classCallCheck(this, RuleList);

      this.map = {};
      this.raw = {};
      this.index = [];

      this.update = function (name, data) {
        var _options = _this.options,
            plugins = _options.jss.plugins,
            sheet = _options.sheet;

        if (typeof name === 'string') {
          plugins.onUpdate(data, _this.get(name), sheet);
        } else {
          for (var index = 0; index < _this.index.length; index++) {
            plugins.onUpdate(name, _this.index[index], sheet);
          }
        }
      };

      this.options = options;
      this.classes = options.classes;
    }
    /**
     * Create and register rule.
     *
     * Will not render after Style Sheet was rendered the first time.
     */
    // Used to ensure correct rules order.
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.


    _createClass(RuleList, [{
      key: 'add',
      value: function add(name, decl, options) {
        var _options2 = this.options,
            parent = _options2.parent,
            sheet = _options2.sheet,
            jss = _options2.jss,
            Renderer = _options2.Renderer,
            generateClassName = _options2.generateClassName;
        options = _extends({
          classes: this.classes,
          parent: parent,
          sheet: sheet,
          jss: jss,
          Renderer: Renderer,
          generateClassName: generateClassName
        }, options);

        if (!options.selector && this.classes[name]) {
          options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
        }

        this.raw[name] = decl;
        var rule = (0, _createRule2['default'])(name, decl, options);
        var className = void 0;

        if (!options.selector && rule instanceof _StyleRule2['default']) {
          className = generateClassName(rule, sheet);
          rule.selector = '.' + (0, _escape2['default'])(className);
        }

        this.register(rule, className);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
      }
      /**
       * Get a rule.
       */

    }, {
      key: 'get',
      value: function get(name) {
        return this.map[name];
      }
      /**
       * Delete a rule.
       */

    }, {
      key: 'remove',
      value: function remove(rule) {
        this.unregister(rule);
        this.index.splice(this.indexOf(rule), 1);
      }
      /**
       * Get index of a rule.
       */

    }, {
      key: 'indexOf',
      value: function indexOf(rule) {
        return this.index.indexOf(rule);
      }
      /**
       * Run `onProcessRule()` plugins on every rule.
       */

    }, {
      key: 'process',
      value: function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.

        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
      }
      /**
       * Register a rule in `.map` and `.classes` maps.
       */

    }, {
      key: 'register',
      value: function register(rule, className) {
        this.map[rule.key] = rule;

        if (rule instanceof _StyleRule2['default']) {
          this.map[rule.selector] = rule;
          if (className) this.classes[rule.key] = className;
        }
      }
      /**
       * Unregister a rule.
       */

    }, {
      key: 'unregister',
      value: function unregister(rule) {
        delete this.map[rule.key];

        if (rule instanceof _StyleRule2['default']) {
          delete this.map[rule.selector];
          delete this.classes[rule.key];
        }
      }
      /**
       * Update the function values with a new data.
       */

    }, {
      key: 'link',

      /**
       * Link renderable rules with CSSRuleList.
       */
      value: function link(cssRules) {
        var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

        for (var i = 0; i < cssRules.length; i++) {
          var cssRule = cssRules[i];

          var _key = this.options.sheet.renderer.getKey(cssRule);

          if (map[_key]) _key = map[_key];
          var rule = this.map[_key];
          if (rule) (0, _linkRule2['default'])(rule, cssRule);
        }
      }
      /**
       * Convert rules to a CSS string.
       */

    }, {
      key: 'toString',
      value: function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;

        for (var index = 0; index < this.index.length; index++) {
          var rule = this.index[index];
          var css = rule.toString(options); // No need to render an empty rule.

          if (!css && !link) continue;
          if (str) str += '\n';
          str += css;
        }

        return str;
      }
    }]);

    return RuleList;
  }();

  exports['default'] = RuleList;
});
unwrapExports(RuleList_1);
var sheets = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _SheetsRegistry2 = _interopRequireDefault(SheetsRegistry_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * This is a global sheets registry. Only DomRenderer will add sheets to it.
   * On the server one should use an own SheetsRegistry instance and add the
   * sheets to it, because you need to make sure to create a new registry for
   * each request in order to not leak sheets across requests.
   */


  exports['default'] = new _SheetsRegistry2['default']();
});
unwrapExports(sheets);
var StyleSheet_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _linkRule2 = _interopRequireDefault(linkRule_1);

  var _RuleList2 = _interopRequireDefault(RuleList_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /* eslint-disable-next-line no-use-before-define */


  var StyleSheet = function () {
    function StyleSheet(styles, options) {
      var _this = this;

      _classCallCheck(this, StyleSheet);

      this.update = function (name, data) {
        if (typeof name === 'string') {
          _this.rules.update(name, data);
        } else {
          _this.rules.update(name);
        }

        return _this;
      };

      this.attached = false;
      this.deployed = false;
      this.linked = false;
      this.classes = {};
      this.options = _extends({}, options, {
        sheet: this,
        parent: this,
        classes: this.classes
      });
      this.renderer = new options.Renderer(this);
      this.rules = new _RuleList2['default'](this.options);

      for (var _name in styles) {
        this.rules.add(_name, styles[_name]);
      }

      this.rules.process();
    }
    /**
     * Attach renderable to the render tree.
     */


    _createClass(StyleSheet, [{
      key: 'attach',
      value: function attach() {
        if (this.attached) return this;
        if (!this.deployed) this.deploy();
        this.renderer.attach();
        if (!this.linked && this.options.link) this.link();
        this.attached = true;
        return this;
      }
      /**
       * Remove renderable from render tree.
       */

    }, {
      key: 'detach',
      value: function detach() {
        if (!this.attached) return this;
        this.renderer.detach();
        this.attached = false;
        return this;
      }
      /**
       * Add a rule to the current stylesheet.
       * Will insert a rule also after the stylesheet has been rendered first time.
       */

    }, {
      key: 'addRule',
      value: function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.

        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        this.options.jss.plugins.onProcessRule(rule);

        if (this.attached) {
          if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
          // It will be inserted all together when .attach is called.

          if (queue) queue.push(rule);else {
            this.insertRule(rule);

            if (this.queue) {
              this.queue.forEach(this.insertRule, this);
              this.queue = undefined;
            }
          }
          return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.


        this.deployed = false;
        return rule;
      }
      /**
       * Insert rule into the StyleSheet
       */

    }, {
      key: 'insertRule',
      value: function insertRule(rule) {
        var renderable = this.renderer.insertRule(rule);
        if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
      }
      /**
       * Create and add rules.
       * Will render also after Style Sheet was rendered the first time.
       */

    }, {
      key: 'addRules',
      value: function addRules(styles, options) {
        var added = [];

        for (var _name2 in styles) {
          added.push(this.addRule(_name2, styles[_name2], options));
        }

        return added;
      }
      /**
       * Get a rule by name.
       */

    }, {
      key: 'getRule',
      value: function getRule(name) {
        return this.rules.get(name);
      }
      /**
       * Delete a rule by name.
       * Returns `true`: if rule has been deleted from the DOM.
       */

    }, {
      key: 'deleteRule',
      value: function deleteRule(name) {
        var rule = this.rules.get(name);
        if (!rule) return false;
        this.rules.remove(rule);

        if (this.attached && rule.renderable) {
          return this.renderer.deleteRule(rule.renderable);
        }

        return true;
      }
      /**
       * Get index of a rule.
       */

    }, {
      key: 'indexOf',
      value: function indexOf(rule) {
        return this.rules.indexOf(rule);
      }
      /**
       * Deploy pure CSS string to a renderable.
       */

    }, {
      key: 'deploy',
      value: function deploy() {
        this.renderer.deploy();
        this.deployed = true;
        return this;
      }
      /**
       * Link renderable CSS rules from sheet with their corresponding models.
       */

    }, {
      key: 'link',
      value: function link() {
        var cssRules = this.renderer.getRules(); // Is undefined when VirtualRenderer is used.

        if (cssRules) this.rules.link(cssRules);
        this.linked = true;
        return this;
      }
      /**
       * Update the function values with a new data.
       */

    }, {
      key: 'toString',

      /**
       * Convert rules to a CSS string.
       */
      value: function toString(options) {
        return this.rules.toString(options);
      }
    }]);

    return StyleSheet;
  }();

  exports['default'] = StyleSheet;
});
unwrapExports(StyleSheet_1);
var moduleId = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
  if (commonjsGlobal[ns] == null) commonjsGlobal[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
  // the current version with just one short number and use it for classes generation
  // we use a counter. Also it is more accurate, because user can manually reevaluate
  // the module.

  exports['default'] = commonjsGlobal[ns]++;
});
unwrapExports(moduleId);
var createGenerateClassName = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _warning2 = _interopRequireDefault(warning_1);

  var _StyleSheet2 = _interopRequireDefault(StyleSheet_1);

  var _moduleId2 = _interopRequireDefault(moduleId);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var maxRules = 1e10;
  var env = process.env.NODE_ENV;
  /**
   * Returns a function which generates unique class names based on counters.
   * When new generator function is created, rule counter is reseted.
   * We need to reset the rule counter for SSR for each request.
   */

  exports['default'] = function () {
    var ruleCounter = 0;
    var defaultPrefix = env === 'production' ? 'c' : '';
    return function (rule, sheet) {
      ruleCounter += 1;

      if (ruleCounter > maxRules) {
        (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
      }

      var prefix = defaultPrefix;
      var jssId = '';

      if (sheet) {
        prefix = sheet.options.classNamePrefix || defaultPrefix;
        if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
      }

      if (env === 'production') {
        return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
      }

      return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
    };
  };
});
unwrapExports(createGenerateClassName);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
var PluginsRegistry_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var PluginsRegistry = function () {
    function PluginsRegistry() {
      _classCallCheck(this, PluginsRegistry);

      this.hooks = {
        onCreateRule: [],
        onProcessRule: [],
        onProcessStyle: [],
        onProcessSheet: [],
        onChangeValue: [],
        onUpdate: []
        /**
         * Call `onCreateRule` hooks and return an object if returned by a hook.
         */

      };
    }

    _createClass(PluginsRegistry, [{
      key: 'onCreateRule',
      value: function onCreateRule(name, decl, options) {
        for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
          var rule = this.hooks.onCreateRule[i](name, decl, options);
          if (rule) return rule;
        }

        return null;
      }
      /**
       * Call `onProcessRule` hooks.
       */

    }, {
      key: 'onProcessRule',
      value: function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;

        for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
          this.hooks.onProcessRule[i](rule, sheet);
        } // $FlowFixMe


        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
      }
      /**
       * Call `onProcessStyle` hooks.
       */

    }, {
      key: 'onProcessStyle',
      value: function onProcessStyle(style, rule, sheet) {
        var nextStyle = style;

        for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
          nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet); // $FlowFixMe

          rule.style = nextStyle;
        }
      }
      /**
       * Call `onProcessSheet` hooks.
       */

    }, {
      key: 'onProcessSheet',
      value: function onProcessSheet(sheet) {
        for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
          this.hooks.onProcessSheet[i](sheet);
        }
      }
      /**
       * Call `onUpdate` hooks.
       */

    }, {
      key: 'onUpdate',
      value: function onUpdate(data, rule, sheet) {
        for (var i = 0; i < this.hooks.onUpdate.length; i++) {
          this.hooks.onUpdate[i](data, rule, sheet);
        }
      }
      /**
       * Call `onChangeValue` hooks.
       */

    }, {
      key: 'onChangeValue',
      value: function onChangeValue(value, prop, rule) {
        var processedValue = value;

        for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
          processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
        }

        return processedValue;
      }
      /**
       * Register a plugin.
       * If function is passed, it is a shortcut for `{onProcessRule}`.
       */

    }, {
      key: 'use',
      value: function use(plugin) {
        for (var name in plugin) {
          if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
        }
      }
    }]);

    return PluginsRegistry;
  }();

  exports['default'] = PluginsRegistry;
});
unwrapExports(PluginsRegistry_1);
var SimpleRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var SimpleRule = function () {
    function SimpleRule(key, value, options) {
      _classCallCheck(this, SimpleRule);

      this.type = 'simple';
      this.isProcessed = false;
      this.key = key;
      this.value = value;
      this.options = options;
    }
    /**
     * Generates a CSS string.
     */
    // eslint-disable-next-line no-unused-vars


    _createClass(SimpleRule, [{
      key: 'toString',
      value: function toString(options) {
        if (Array.isArray(this.value)) {
          var str = '';

          for (var index = 0; index < this.value.length; index++) {
            str += this.key + ' ' + this.value[index] + ';';
            if (this.value[index + 1]) str += '\n';
          }

          return str;
        }

        return this.key + ' ' + this.value + ';';
      }
    }]);

    return SimpleRule;
  }();

  exports['default'] = SimpleRule;
});
unwrapExports(SimpleRule_1);
var KeyframesRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _RuleList2 = _interopRequireDefault(RuleList_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * Rule for @keyframes
   */


  var KeyframesRule = function () {
    function KeyframesRule(key, frames, options) {
      _classCallCheck(this, KeyframesRule);

      this.type = 'keyframes';
      this.isProcessed = false;
      this.key = key;
      this.options = options;
      this.rules = new _RuleList2['default'](_extends({}, options, {
        parent: this
      }));

      for (var name in frames) {
        this.rules.add(name, frames[name], _extends({}, this.options, {
          parent: this,
          selector: name
        }));
      }

      this.rules.process();
    }
    /**
     * Generates a CSS string.
     */


    _createClass(KeyframesRule, [{
      key: 'toString',
      value: function toString() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          indent: 1
        };
        var inner = this.rules.toString(options);
        if (inner) inner += '\n';
        return this.key + ' {\n' + inner + '}';
      }
    }]);

    return KeyframesRule;
  }();

  exports['default'] = KeyframesRule;
});
unwrapExports(KeyframesRule_1);
var ConditionalRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _RuleList2 = _interopRequireDefault(RuleList_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * Conditional rule for @media, @supports
   */


  var ConditionalRule = function () {
    function ConditionalRule(key, styles, options) {
      _classCallCheck(this, ConditionalRule);

      this.type = 'conditional';
      this.isProcessed = false;
      this.key = key;
      this.options = options;
      this.rules = new _RuleList2['default'](_extends({}, options, {
        parent: this
      }));

      for (var name in styles) {
        this.rules.add(name, styles[name]);
      }

      this.rules.process();
    }
    /**
     * Get a rule.
     */


    _createClass(ConditionalRule, [{
      key: 'getRule',
      value: function getRule(name) {
        return this.rules.get(name);
      }
      /**
       * Get index of a rule.
       */

    }, {
      key: 'indexOf',
      value: function indexOf(rule) {
        return this.rules.indexOf(rule);
      }
      /**
       * Create and register rule, run plugins.
       */

    }, {
      key: 'addRule',
      value: function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
      }
      /**
       * Generates a CSS string.
       */

    }, {
      key: 'toString',
      value: function toString() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          indent: 1
        };
        var inner = this.rules.toString(options);
        return inner ? this.key + ' {\n' + inner + '\n}' : '';
      }
    }]);

    return ConditionalRule;
  }();

  exports['default'] = ConditionalRule;
});
unwrapExports(ConditionalRule_1);
var FontFaceRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _toCss2 = _interopRequireDefault(toCss_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var FontFaceRule = function () {
    function FontFaceRule(key, style, options) {
      _classCallCheck(this, FontFaceRule);

      this.type = 'font-face';
      this.isProcessed = false;
      this.key = key;
      this.style = style;
      this.options = options;
    }
    /**
     * Generates a CSS string.
     */


    _createClass(FontFaceRule, [{
      key: 'toString',
      value: function toString(options) {
        if (Array.isArray(this.style)) {
          var str = '';

          for (var index = 0; index < this.style.length; index++) {
            str += (0, _toCss2['default'])(this.key, this.style[index]);
            if (this.style[index + 1]) str += '\n';
          }

          return str;
        }

        return (0, _toCss2['default'])(this.key, this.style, options);
      }
    }]);

    return FontFaceRule;
  }();

  exports['default'] = FontFaceRule;
});
unwrapExports(FontFaceRule_1);
var ViewportRule_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _toCss2 = _interopRequireDefault(toCss_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var ViewportRule = function () {
    function ViewportRule(key, style, options) {
      _classCallCheck(this, ViewportRule);

      this.type = 'viewport';
      this.isProcessed = false;
      this.key = key;
      this.style = style;
      this.options = options;
    }
    /**
     * Generates a CSS string.
     */


    _createClass(ViewportRule, [{
      key: 'toString',
      value: function toString(options) {
        return (0, _toCss2['default'])(this.key, this.style, options);
      }
    }]);

    return ViewportRule;
  }();

  exports['default'] = ViewportRule;
});
unwrapExports(ViewportRule_1);
var rules = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _SimpleRule2 = _interopRequireDefault(SimpleRule_1);

  var _KeyframesRule2 = _interopRequireDefault(KeyframesRule_1);

  var _ConditionalRule2 = _interopRequireDefault(ConditionalRule_1);

  var _FontFaceRule2 = _interopRequireDefault(FontFaceRule_1);

  var _ViewportRule2 = _interopRequireDefault(ViewportRule_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var classes = {
    '@charset': _SimpleRule2['default'],
    '@import': _SimpleRule2['default'],
    '@namespace': _SimpleRule2['default'],
    '@keyframes': _KeyframesRule2['default'],
    '@media': _ConditionalRule2['default'],
    '@supports': _ConditionalRule2['default'],
    '@font-face': _FontFaceRule2['default'],
    '@viewport': _ViewportRule2['default'],
    '@-ms-viewport': _ViewportRule2['default']
    /**
     * Generate plugins which will register all rules.
     */

  };
  var plugins = Object.keys(classes).map(function (key) {
    // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
    var re = new RegExp('^' + key);
    var RuleClass = classes[key];

    var onCreateRule = function onCreateRule(name, decl, options) {
      return re.test(name) ? new RuleClass(name, decl, options) : null;
    };

    return {
      onCreateRule: onCreateRule
    };
  });
  exports['default'] = plugins;
});
unwrapExports(rules);
var observables = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _StyleRule2 = _interopRequireDefault(StyleRule_1);

  var _createRule2 = _interopRequireDefault(createRule_1);

  var _isObservable2 = _interopRequireDefault(isObservable);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  exports['default'] = {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (!(0, _isObservable2['default'])(decl)) return null; // Cast `decl` to `Observable`, since it passed the type guard.

      var style$ = decl;
      var rule = (0, _createRule2['default'])(name, {}, options); // TODO
      // Call `stream.subscribe()` returns a subscription, which should be explicitly
      // unsubscribed from when we know this sheet is no longer needed.

      style$.subscribe(function (style) {
        for (var prop in style) {
          rule.prop(prop, style[prop]);
        }
      });
      return rule;
    },
    onProcessRule: function onProcessRule(rule) {
      if (!(rule instanceof _StyleRule2['default'])) return;
      var styleRule = rule;
      var style = styleRule.style;

      var _loop = function _loop(prop) {
        var value = style[prop];
        if (!(0, _isObservable2['default'])(value)) return 'continue';
        delete style[prop];
        value.subscribe({
          next: function next(nextValue) {
            styleRule.prop(prop, nextValue);
          }
        });
      };

      for (var prop in style) {
        var _ret = _loop(prop);

        if (_ret === 'continue') continue;
      }
    }
  };
});
unwrapExports(observables);
var functions = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _RuleList2 = _interopRequireDefault(RuleList_1);

  var _StyleRule2 = _interopRequireDefault(StyleRule_1);

  var _createRule2 = _interopRequireDefault(createRule_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  } // A symbol replacement.


  var now = Date.now();
  var fnValuesNs = 'fnValues' + now;
  var fnStyleNs = 'fnStyle' + ++now;
  exports['default'] = {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = (0, _createRule2['default'])(name, {}, options);
      rule[fnStyleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      var fn = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fn[prop] = value;
      }

      rule = rule;
      rule[fnValuesNs] = fn;
      return style;
    },
    onUpdate: function onUpdate(data, rule) {
      // It is a rules container like for e.g. ConditionalRule.
      if (rule.rules instanceof _RuleList2['default']) {
        rule.rules.update(data);
        return;
      }

      if (!(rule instanceof _StyleRule2['default'])) return;
      rule = rule; // If we have a fn values map, it is a rule with function values.

      if (rule[fnValuesNs]) {
        for (var prop in rule[fnValuesNs]) {
          rule.prop(prop, rule[fnValuesNs][prop](data));
        }
      }

      rule = rule;
      var fnStyle = rule[fnStyleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnStyle) {
        var style = fnStyle(data);

        for (var _prop in style) {
          rule.prop(_prop, style[_prop]);
        }
      }
    }
  };
});
unwrapExports(functions);
var DomRenderer_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _warning2 = _interopRequireDefault(warning_1);

  var _sheets2 = _interopRequireDefault(sheets);

  var _StyleRule2 = _interopRequireDefault(StyleRule_1);

  var _toCssValue2 = _interopRequireDefault(toCssValue_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /**
   * Cache the value from the first time a function is called.
   */


  var memoize = function memoize(fn) {
    var value = void 0;
    return function () {
      if (!value) value = fn();
      return value;
    };
  };
  /**
   * Get a style property value.
   */


  function getPropertyValue(cssRule, prop) {
    try {
      return cssRule.style.getPropertyValue(prop);
    } catch (err) {
      // IE may throw if property is unknown.
      return '';
    }
  }
  /**
   * Set a style property.
   */


  function setProperty(cssRule, prop, value) {
    try {
      var cssValue = value;

      if (Array.isArray(value)) {
        cssValue = (0, _toCssValue2['default'])(value, true);

        if (value[value.length - 1] === '!important') {
          cssRule.style.setProperty(prop, cssValue, 'important');
          return true;
        }
      }

      cssRule.style.setProperty(prop, cssValue);
    } catch (err) {
      // IE may throw if property is unknown.
      return false;
    }

    return true;
  }
  /**
   * Remove a style property.
   */


  function removeProperty(cssRule, prop) {
    try {
      cssRule.style.removeProperty(prop);
    } catch (err) {
      (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
    }
  }

  var CSSRuleTypes = {
    STYLE_RULE: 1,
    KEYFRAMES_RULE: 7
    /**
     * Get the CSS Rule key.
     */

  };

  var getKey = function () {
    var extractKey = function extractKey(cssText) {
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return cssText.substr(from, cssText.indexOf('{') - 1);
    };

    return function (cssRule) {
      if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;

      if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
        var name = cssRule.name;
        if (name) return '@keyframes ' + name; // There is no rule.name in the following browsers:
        // - IE 9
        // - Safari 7.1.8
        // - Mobile Safari 9.0.0

        var cssText = cssRule.cssText;
        return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
      } // Conditionals.


      return extractKey(cssRule.cssText);
    };
  }();
  /**
   * Set the selector.
   */


  function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.

    return cssRule.selectorText === selectorText;
  }
  /**
   * Gets the `head` element upon the first call and caches it.
   */


  var getHead = memoize(function () {
    return document.head || document.getElementsByTagName('head')[0];
  });
  /**
   * Gets a map of rule keys, where the property is an unescaped key and value
   * is a potentially escaped one.
   * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
   * for CSSStyleRule we normally use `selectorText`. Though if original selector text
   * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
   * and so CSS rule's `selectorText` won't match JSS rule selector.
   *
   * https://www.w3.org/International/questions/qa-escapes#cssescapes
   */

  var getUnescapedKeysMap = function () {
    var style = void 0;
    var isAttached = false;
    return function (rules) {
      var map = {}; // https://github.com/facebook/flow/issues/2696

      if (!style) style = document.createElement('style');

      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        if (!(rule instanceof _StyleRule2['default'])) continue;
        var selector = rule.selector; // Only unescape selector over CSSOM if it contains a back slash.

        if (selector && selector.indexOf('\\') !== -1) {
          // Lazilly attach when needed.
          if (!isAttached) {
            getHead().appendChild(style);
            isAttached = true;
          }

          style.textContent = selector + ' {}';
          var _style = style,
              sheet = _style.sheet;

          if (sheet) {
            var cssRules = sheet.cssRules;
            if (cssRules) map[cssRules[0].selectorText] = rule.key;
          }
        }
      }

      if (isAttached) {
        getHead().removeChild(style);
        isAttached = false;
      }

      return map;
    };
  }();
  /**
   * Find attached sheet with an index higher than the passed one.
   */


  function findHigherSheet(registry, options) {
    for (var i = 0; i < registry.length; i++) {
      var sheet = registry[i];

      if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
        return sheet;
      }
    }

    return null;
  }
  /**
   * Find attached sheet with the highest index.
   */


  function findHighestSheet(registry, options) {
    for (var i = registry.length - 1; i >= 0; i--) {
      var sheet = registry[i];

      if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
        return sheet;
      }
    }

    return null;
  }
  /**
   * Find a comment with "jss" inside.
   */


  function findCommentNode(text) {
    var head = getHead();

    for (var i = 0; i < head.childNodes.length; i++) {
      var node = head.childNodes[i];

      if (node.nodeType === 8 && node.nodeValue.trim() === text) {
        return node;
      }
    }

    return null;
  }
  /**
   * Find a node before which we can insert the sheet.
   */


  function findPrevNode(options) {
    var registry = _sheets2['default'].registry;

    if (registry.length > 0) {
      // Try to insert before the next higher sheet.
      var sheet = findHigherSheet(registry, options);
      if (sheet) return sheet.renderer.element; // Otherwise insert after the last attached.

      sheet = findHighestSheet(registry, options);
      if (sheet) return sheet.renderer.element.nextElementSibling;
    } // Try to find a comment placeholder if registry is empty.


    var insertionPoint = options.insertionPoint;

    if (insertionPoint && typeof insertionPoint === 'string') {
      var comment = findCommentNode(insertionPoint);
      if (comment) return comment.nextSibling; // If user specifies an insertion point and it can't be found in the document -
      // bad specificity issues may appear.

      (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
    }

    return null;
  }
  /**
   * Insert style element into the DOM.
   */


  function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var prevNode = findPrevNode(options);

    if (prevNode) {
      var parentNode = prevNode.parentNode;
      if (parentNode) parentNode.insertBefore(style, prevNode);
      return;
    } // Works with iframes and any node types.


    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var insertionPointElement = insertionPoint;
      var _parentNode = insertionPointElement.parentNode;
      if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
      return;
    }

    getHead().insertBefore(style, prevNode);
  }
  /**
   * Read jss nonce setting from the page if the user has set it.
   */


  var getNonce = memoize(function () {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
  });

  var DomRenderer = function () {
    function DomRenderer(sheet) {
      _classCallCheck(this, DomRenderer);

      this.getPropertyValue = getPropertyValue;
      this.setProperty = setProperty;
      this.removeProperty = removeProperty;
      this.setSelector = setSelector;
      this.getKey = getKey;
      this.getUnescapedKeysMap = getUnescapedKeysMap;
      this.hasInsertedRules = false; // There is no sheet when the renderer is used from a standalone StyleRule.

      if (sheet) _sheets2['default'].add(sheet);
      this.sheet = sheet;

      var _ref = this.sheet ? this.sheet.options : {},
          media = _ref.media,
          meta = _ref.meta,
          element = _ref.element;

      this.element = element || document.createElement('style');
      this.element.setAttribute('data-jss', '');
      if (media) this.element.setAttribute('media', media);
      if (meta) this.element.setAttribute('data-meta', meta);
      var nonce = getNonce();
      if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
     * Insert style element into render tree.
     */
    // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


    _createClass(DomRenderer, [{
      key: 'attach',
      value: function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return; // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // browsers remove those rules.
        // TODO figure out if its a bug and if it is known.
        // Workaround is to redeploy the sheet before attaching as a string.

        if (this.hasInsertedRules) {
          this.deploy();
          this.hasInsertedRules = false;
        }

        insertStyle(this.element, this.sheet.options);
      }
      /**
       * Remove style element from render tree.
       */

    }, {
      key: 'detach',
      value: function detach() {
        this.element.parentNode.removeChild(this.element);
      }
      /**
       * Inject CSS string into element.
       */

    }, {
      key: 'deploy',
      value: function deploy() {
        if (!this.sheet) return;
        this.element.textContent = '\n' + this.sheet.toString() + '\n';
      }
      /**
       * Insert a rule into element.
       */

    }, {
      key: 'insertRule',
      value: function insertRule(rule, index) {
        var sheet = this.element.sheet;
        var cssRules = sheet.cssRules;
        var str = rule.toString();
        if (!index) index = cssRules.length;
        if (!str) return false;

        try {
          sheet.insertRule(str, index);
        } catch (err) {
          (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
          return false;
        }

        this.hasInsertedRules = true;
        return cssRules[index];
      }
      /**
       * Delete a rule.
       */

    }, {
      key: 'deleteRule',
      value: function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        return true;
      }
      /**
       * Get index of a CSS Rule.
       */

    }, {
      key: 'indexOf',
      value: function indexOf(cssRule) {
        var cssRules = this.element.sheet.cssRules;

        for (var _index = 0; _index < cssRules.length; _index++) {
          if (cssRule === cssRules[_index]) return _index;
        }

        return -1;
      }
      /**
       * Generate a new CSS rule and replace the existing one.
       */

    }, {
      key: 'replaceRule',
      value: function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        var newCssRule = this.insertRule(rule, index);
        this.element.sheet.deleteRule(index);
        return newCssRule;
      }
      /**
       * Get all rules elements.
       */

    }, {
      key: 'getRules',
      value: function getRules() {
        return this.element.sheet.cssRules;
      }
    }]);

    return DomRenderer;
  }();

  exports['default'] = DomRenderer;
});
unwrapExports(DomRenderer_1);
var VirtualRenderer_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  /* eslint-disable class-methods-use-this */

  /**
   * Rendering backend to do nothing in nodejs.
   */


  var VirtualRenderer = function () {
    function VirtualRenderer() {
      _classCallCheck(this, VirtualRenderer);
    }

    _createClass(VirtualRenderer, [{
      key: 'setProperty',
      value: function setProperty() {
        return true;
      }
    }, {
      key: 'getPropertyValue',
      value: function getPropertyValue() {
        return '';
      }
    }, {
      key: 'removeProperty',
      value: function removeProperty() {}
    }, {
      key: 'setSelector',
      value: function setSelector() {
        return true;
      }
    }, {
      key: 'getKey',
      value: function getKey() {
        return '';
      }
    }, {
      key: 'attach',
      value: function attach() {}
    }, {
      key: 'detach',
      value: function detach() {}
    }, {
      key: 'deploy',
      value: function deploy() {}
    }, {
      key: 'insertRule',
      value: function insertRule() {
        return false;
      }
    }, {
      key: 'deleteRule',
      value: function deleteRule() {
        return true;
      }
    }, {
      key: 'replaceRule',
      value: function replaceRule() {
        return false;
      }
    }, {
      key: 'getRules',
      value: function getRules() {}
    }, {
      key: 'indexOf',
      value: function indexOf() {
        return -1;
      }
    }]);

    return VirtualRenderer;
  }();

  exports['default'] = VirtualRenderer;
});
unwrapExports(VirtualRenderer_1);
var Jss_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _isInBrowser2 = _interopRequireDefault(isBrowser);

  var _StyleSheet2 = _interopRequireDefault(StyleSheet_1);

  var _PluginsRegistry2 = _interopRequireDefault(PluginsRegistry_1);

  var _rules2 = _interopRequireDefault(rules);

  var _observables2 = _interopRequireDefault(observables);

  var _functions2 = _interopRequireDefault(functions);

  var _sheets2 = _interopRequireDefault(sheets);

  var _StyleRule2 = _interopRequireDefault(StyleRule_1);

  var _createGenerateClassName2 = _interopRequireDefault(createGenerateClassName);

  var _createRule3 = _interopRequireDefault(createRule_1);

  var _DomRenderer2 = _interopRequireDefault(DomRenderer_1);

  var _VirtualRenderer2 = _interopRequireDefault(VirtualRenderer_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

  var instanceCounter = 0;

  var Jss = function () {
    function Jss(options) {
      _classCallCheck(this, Jss);

      this.id = instanceCounter++;
      this.version = "9.8.7";
      this.plugins = new _PluginsRegistry2['default']();
      this.options = {
        createGenerateClassName: _createGenerateClassName2['default'],
        Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
        plugins: []
      };
      this.generateClassName = (0, _createGenerateClassName2['default'])(); // eslint-disable-next-line prefer-spread

      this.use.apply(this, defaultPlugins);
      this.setup(options);
    }

    _createClass(Jss, [{
      key: 'setup',
      value: function setup() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (options.createGenerateClassName) {
          this.options.createGenerateClassName = options.createGenerateClassName; // $FlowFixMe

          this.generateClassName = options.createGenerateClassName();
        }

        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

        if (options.virtual || options.Renderer) {
          this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
        } // eslint-disable-next-line prefer-spread


        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
      }
      /**
       * Create a Style Sheet.
       */

    }, {
      key: 'createStyleSheet',
      value: function createStyleSheet(styles) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var index = options.index;

        if (typeof index !== 'number') {
          index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
        }

        var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
          jss: this,
          generateClassName: options.generateClassName || this.generateClassName,
          insertionPoint: this.options.insertionPoint,
          Renderer: this.options.Renderer,
          index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
      }
      /**
       * Detach the Style Sheet and remove it from the registry.
       */

    }, {
      key: 'removeStyleSheet',
      value: function removeStyleSheet(sheet) {
        sheet.detach();

        _sheets2['default'].remove(sheet);

        return this;
      }
      /**
       * Create a rule without a Style Sheet.
       */

    }, {
      key: 'createRule',
      value: function createRule(name) {
        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}; // Enable rule without name for inline styles.

        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
          options = style;
          style = name;
          name = undefined;
        } // Cast from RuleFactoryOptions to RuleOptions
        // https://stackoverflow.com/questions/41328728/force-casting-in-flow


        var ruleOptions = options;
        ruleOptions.jss = this;
        ruleOptions.Renderer = this.options.Renderer;
        if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        var rule = (0, _createRule3['default'])(name, style, ruleOptions);

        if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
          rule.selector = '.' + ruleOptions.generateClassName(rule);
        }

        this.plugins.onProcessRule(rule);
        return rule;
      }
      /**
       * Register plugin. Passed function will be invoked with a rule instance.
       */

    }, {
      key: 'use',
      value: function use() {
        var _this = this;

        for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
          plugins[_key] = arguments[_key];
        }

        plugins.forEach(function (plugin) {
          // Avoids applying same plugin twice, at least based on ref.
          if (_this.options.plugins.indexOf(plugin) === -1) {
            _this.options.plugins.push(plugin);

            _this.plugins.use(plugin);
          }
        });
        return this;
      }
    }]);

    return Jss;
  }();

  exports['default'] = Jss;
});
unwrapExports(Jss_1);
var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;
  Object.defineProperty(exports, 'getDynamicStyles', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(getDynamicStyles_1)['default'];
    }
  });
  Object.defineProperty(exports, 'toCssValue', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(toCssValue_1)['default'];
    }
  });
  Object.defineProperty(exports, 'SheetsRegistry', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SheetsRegistry_1)['default'];
    }
  });
  Object.defineProperty(exports, 'SheetsManager', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(SheetsManager_1)['default'];
    }
  });
  Object.defineProperty(exports, 'RuleList', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(RuleList_1)['default'];
    }
  });
  Object.defineProperty(exports, 'sheets', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(sheets)['default'];
    }
  });
  Object.defineProperty(exports, 'createGenerateClassName', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(createGenerateClassName)['default'];
    }
  });

  var _Jss2 = _interopRequireDefault(Jss_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * Creates a new instance of Jss.
   */


  var create = exports.create = function create(options) {
    return new _Jss2['default'](options);
  };
  /**
   * A global Jss instance.
   */


  exports['default'] = create();
});
unwrapExports(lib);
var lib_1 = lib.create;
var lib_2 = lib.createGenerateClassName;
var lib_3 = lib.sheets;
var lib_4 = lib.RuleList;
var lib_5 = lib.SheetsManager;
var lib_6 = lib.SheetsRegistry;
var lib_7 = lib.toCssValue;
var lib_8 = lib.getDynamicStyles;
var parse = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var semiWithNl = /;\n/;
  /**
   * Naive CSS parser.
   * - Supports only rule body (no selectors)
   * - Requires semicolon and new line after the value (except of last line)
   * - No nested rules support
   */

  exports['default'] = function (cssText) {
    var style = {};
    var split = cssText.split(semiWithNl);

    for (var i = 0; i < split.length; i++) {
      var decl = (split[i] || '').trim();
      if (!decl) continue;
      var colonIndex = decl.indexOf(':');

      if (colonIndex === -1) {
        (0, _warning2['default'])(false, 'Malformed CSS string "%s"', decl);
        continue;
      }

      var prop = decl.substr(0, colonIndex).trim();
      var value = decl.substr(colonIndex + 1).trim();
      style[prop] = value;
    }

    return style;
  };
});
unwrapExports(parse);
var lib$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _parse2 = _interopRequireDefault(parse);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var onProcessRule = function onProcessRule(rule) {
    if (typeof rule.style === 'string') {
      rule.style = (0, _parse2['default'])(rule.style);
    }
  };

  exports['default'] = function () {
    return {
      onProcessRule: onProcessRule
    };
  };
});
unwrapExports(lib$1);
var lib$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  exports['default'] = jssGlobal;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var propKey = '@global';
  var prefixKey = '@global ';

  var GlobalContainerRule = function () {
    function GlobalContainerRule(key, styles, options) {
      _classCallCheck(this, GlobalContainerRule);

      this.type = 'global';
      this.key = key;
      this.options = options;
      this.rules = new lib.RuleList(_extends({}, options, {
        parent: this
      }));

      for (var selector in styles) {
        this.rules.add(selector, styles[selector], {
          selector: selector
        });
      }

      this.rules.process();
    }
    /**
     * Get a rule.
     */


    _createClass(GlobalContainerRule, [{
      key: 'getRule',
      value: function getRule(name) {
        return this.rules.get(name);
      }
      /**
       * Create and register rule, run plugins.
       */

    }, {
      key: 'addRule',
      value: function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
      }
      /**
       * Get index of a rule.
       */

    }, {
      key: 'indexOf',
      value: function indexOf(rule) {
        return this.rules.indexOf(rule);
      }
      /**
       * Generates a CSS string.
       */

    }, {
      key: 'toString',
      value: function toString() {
        return this.rules.toString();
      }
    }]);

    return GlobalContainerRule;
  }();

  var GlobalPrefixedRule = function () {
    function GlobalPrefixedRule(name, style, options) {
      _classCallCheck(this, GlobalPrefixedRule);

      this.name = name;
      this.options = options;
      var selector = name.substr(prefixKey.length);
      this.rule = options.jss.createRule(selector, style, _extends({}, options, {
        parent: this,
        selector: selector
      }));
    }

    _createClass(GlobalPrefixedRule, [{
      key: 'toString',
      value: function toString(options) {
        return this.rule.toString(options);
      }
    }]);

    return GlobalPrefixedRule;
  }();

  var separatorRegExp = /\s*,\s*/g;

  function addScope(selector, scope) {
    var parts = selector.split(separatorRegExp);
    var scoped = '';

    for (var i = 0; i < parts.length; i++) {
      scoped += scope + ' ' + parts[i].trim();
      if (parts[i + 1]) scoped += ', ';
    }

    return scoped;
  }

  function handleNestedGlobalContainerRule(rule) {
    var options = rule.options,
        style = rule.style;
    var rules = style[propKey];
    if (!rules) return;

    for (var name in rules) {
      options.sheet.addRule(name, rules[name], _extends({}, options, {
        selector: addScope(name, rule.selector)
      }));
    }

    delete style[propKey];
  }

  function handlePrefixedGlobalRule(rule) {
    var options = rule.options,
        style = rule.style;

    for (var prop in style) {
      if (prop.substr(0, propKey.length) !== propKey) continue;
      var selector = addScope(prop.substr(propKey.length), rule.selector);
      options.sheet.addRule(selector, style[prop], _extends({}, options, {
        selector: selector
      }));
      delete style[prop];
    }
  }
  /**
   * Convert nested rules to separate, remove them from original styles.
   *
   * @param {Rule} rule
   * @api public
   */


  function jssGlobal() {
    function onCreateRule(name, styles, options) {
      if (name === propKey) {
        return new GlobalContainerRule(name, styles, options);
      }

      if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
        return new GlobalPrefixedRule(name, styles, options);
      }

      var parent = options.parent;

      if (parent) {
        if (parent.type === 'global' || parent.options.parent.type === 'global') {
          options.global = true;
        }
      }

      if (options.global) options.selector = name;
      return null;
    }

    function onProcessRule(rule) {
      if (rule.type !== 'style') return;
      handleNestedGlobalContainerRule(rule);
      handlePrefixedGlobalRule(rule);
    }

    return {
      onCreateRule: onCreateRule,
      onProcessRule: onProcessRule
    };
  }
});
unwrapExports(lib$2);
var lib$3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports['default'] = jssExtend;

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var isObject = function isObject(obj) {
    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
  };

  var valueNs = 'extendCurrValue' + Date.now();

  function mergeExtend(style, rule, sheet, newStyle) {
    var extendType = _typeof(style.extend); // Extend using a rule name.


    if (extendType === 'string') {
      if (!sheet) return;
      var refRule = sheet.getRule(style.extend);
      if (!refRule) return;

      if (refRule === rule) {
        (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);
        return;
      }

      var parent = refRule.options.parent;

      if (parent) {
        var originalStyle = parent.rules.raw[style.extend];
        extend(originalStyle, rule, sheet, newStyle);
      }

      return;
    } // Extend using an array of objects.


    if (Array.isArray(style.extend)) {
      for (var index = 0; index < style.extend.length; index++) {
        extend(style.extend[index], rule, sheet, newStyle);
      }

      return;
    } // Extend is a style object.


    for (var prop in style.extend) {
      if (prop === 'extend') {
        extend(style.extend.extend, rule, sheet, newStyle);
        continue;
      }

      if (isObject(style.extend[prop])) {
        if (!(prop in newStyle)) newStyle[prop] = {};
        extend(style.extend[prop], rule, sheet, newStyle[prop]);
        continue;
      }

      newStyle[prop] = style.extend[prop];
    }
  }

  function mergeRest(style, rule, sheet, newStyle) {
    // Copy base style.
    for (var prop in style) {
      if (prop === 'extend') continue;

      if (isObject(newStyle[prop]) && isObject(style[prop])) {
        extend(style[prop], rule, sheet, newStyle[prop]);
        continue;
      }

      if (isObject(style[prop])) {
        newStyle[prop] = extend(style[prop], rule, sheet);
        continue;
      }

      newStyle[prop] = style[prop];
    }
  }
  /**
   * Recursively extend styles.
   */


  function extend(style, rule, sheet) {
    var newStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    mergeExtend(style, rule, sheet, newStyle);
    mergeRest(style, rule, sheet, newStyle);
    return newStyle;
  }
  /**
   * Handle `extend` property.
   *
   * @param {Rule} rule
   * @api public
   */


  function jssExtend() {
    function onProcessStyle(style, rule, sheet) {
      if ('extend' in style) return extend(style, rule, sheet);
      return style;
    }

    function onChangeValue(value, prop, rule) {
      if (prop !== 'extend') return value; // Value is empty, remove properties set previously.

      if (value == null || value === false) {
        for (var key in rule[valueNs]) {
          rule.prop(key, null);
        }

        rule[valueNs] = null;
        return null;
      }

      for (var _key in value) {
        rule.prop(_key, value[_key]);
      }

      rule[valueNs] = value; // Make sure we don't set the value in the core.

      return null;
    }

    return {
      onProcessStyle: onProcessStyle,
      onChangeValue: onChangeValue
    };
  }
});
unwrapExports(lib$3);
var lib$4 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  exports.default = jssNested;

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var separatorRegExp = /\s*,\s*/g;
  var parentRegExp = /&/g;
  var refRegExp = /\$([\w-]+)/g;
  /**
   * Convert nested rules to separate, remove them from original styles.
   *
   * @param {Rule} rule
   * @api public
   */

  function jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container) {
      return function (match, key) {
        var rule = container.getRule(key);
        if (rule) return rule.selector;
        (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
        return key;
      };
    }

    var hasAnd = function hasAnd(str) {
      return str.indexOf('&') !== -1;
    };

    function replaceParentRefs(nestedProp, parentProp) {
      var parentSelectors = parentProp.split(separatorRegExp);
      var nestedSelectors = nestedProp.split(separatorRegExp);
      var result = '';

      for (var i = 0; i < parentSelectors.length; i++) {
        var parent = parentSelectors[i];

        for (var j = 0; j < nestedSelectors.length; j++) {
          var nested = nestedSelectors[j];
          if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

          result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
        }
      }

      return result;
    }

    function getOptions(rule, container, options) {
      // Options has been already created, now we only increase index.
      if (options) return _extends({}, options, {
        index: options.index + 1
      });
      var nestingLevel = rule.options.nestingLevel;
      nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
      return _extends({}, rule.options, {
        nestingLevel: nestingLevel,
        index: container.indexOf(rule) + 1
      });
    }

    function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var container = rule.options.parent;
      var options = void 0;
      var replaceRef = void 0;

      for (var prop in style) {
        var isNested = hasAnd(prop);
        var isNestedConditional = prop[0] === '@';
        if (!isNested && !isNestedConditional) continue;
        options = getOptions(rule, container, options);

        if (isNested) {
          var selector = replaceParentRefs(prop, rule.selector // Lazily create the ref replacer function just once for
          // all nested rules within the sheet.
          );
          if (!replaceRef) replaceRef = getReplaceRef(container // Replace all $refs.
          );
          selector = selector.replace(refRegExp, replaceRef);
          container.addRule(selector, style[prop], _extends({}, options, {
            selector: selector
          }));
        } else if (isNestedConditional) {
          container // Place conditional right after the parent rule to ensure right ordering.
          .addRule(prop, null, options).addRule(rule.key, style[prop], {
            selector: rule.selector
          });
        }

        delete style[prop];
      }

      return style;
    }

    return {
      onProcessStyle: onProcessStyle
    };
  }
});
unwrapExports(lib$4);
var lib$5 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = jssCompose;

  var _warning2 = _interopRequireDefault(warning_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Set selector.
   *
   * @param {Object} original rule
   * @param {String} className class string
   * @return {Boolean} flag, indicating function was successfull or not
   */


  function registerClass(rule, className) {
    // Skip falsy values
    if (!className) return true; // Support array of class names `{composes: ['foo', 'bar']}`

    if (Array.isArray(className)) {
      for (var index = 0; index < className.length; index++) {
        var isSetted = registerClass(rule, className[index]);
        if (!isSetted) return false;
      }

      return true;
    } // Support space separated class names `{composes: 'foo bar'}`


    if (className.indexOf(' ') > -1) {
      return registerClass(rule, className.split(' '));
    }

    var parent = rule.options.parent; // It is a ref to a local rule.

    if (className[0] === '$') {
      var refRule = parent.getRule(className.substr(1));

      if (!refRule) {
        (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
        return false;
      }

      if (refRule === rule) {
        (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
        return false;
      }

      parent.classes[rule.key] += ' ' + parent.classes[refRule.key];
      return true;
    }

    rule.options.parent.classes[rule.key] += ' ' + className;
    return true;
  }
  /**
   * Convert compose property to additional class, remove property from original styles.
   *
   * @param {Rule} rule
   * @api public
   */


  function jssCompose() {
    function onProcessStyle(style, rule) {
      if (!style.composes) return style;
      registerClass(rule, style.composes); // Remove composes property to prevent infinite loop.

      delete style.composes;
      return style;
    }

    return {
      onProcessStyle: onProcessStyle
    };
  }
});
unwrapExports(lib$5);
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
  return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, '-$&').toLowerCase().replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;
var lib$6 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = camelCase;

  var _hyphenateStyleName2 = _interopRequireDefault(hyphenateStyleName_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * Convert camel cased property names to dash separated.
   *
   * @param {Object} style
   * @return {Object}
   */


  function convertCase(style) {
    var converted = {};

    for (var prop in style) {
      converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
    }

    if (style.fallbacks) {
      if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
    }

    return converted;
  }
  /**
   * Allow camel cased property names by converting them back to dasherized.
   *
   * @param {Rule} rule
   */


  function camelCase() {
    function onProcessStyle(style) {
      if (Array.isArray(style)) {
        // Handle rules like @font-face, which can have multiple styles in an array
        for (var index = 0; index < style.length; index++) {
          style[index] = convertCase(style[index]);
        }

        return style;
      }

      return convertCase(style);
    }

    function onChangeValue(value, prop, rule) {
      var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop); // There was no camel case in place

      if (prop === hyphenatedProp) return value;
      rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

      return null;
    }

    return {
      onProcessStyle: onProcessStyle,
      onChangeValue: onChangeValue
    };
  }
});
unwrapExports(lib$6);
var defaultUnits = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Generated jss-default-unit CSS property units
   *
   * @type object
   */

  exports['default'] = {
    'animation-delay': 'ms',
    'animation-duration': 'ms',
    'background-position': 'px',
    'background-position-x': 'px',
    'background-position-y': 'px',
    'background-size': 'px',
    border: 'px',
    'border-bottom': 'px',
    'border-bottom-left-radius': 'px',
    'border-bottom-right-radius': 'px',
    'border-bottom-width': 'px',
    'border-left': 'px',
    'border-left-width': 'px',
    'border-radius': 'px',
    'border-right': 'px',
    'border-right-width': 'px',
    'border-spacing': 'px',
    'border-top': 'px',
    'border-top-left-radius': 'px',
    'border-top-right-radius': 'px',
    'border-top-width': 'px',
    'border-width': 'px',
    'border-after-width': 'px',
    'border-before-width': 'px',
    'border-end-width': 'px',
    'border-horizontal-spacing': 'px',
    'border-start-width': 'px',
    'border-vertical-spacing': 'px',
    bottom: 'px',
    'box-shadow': 'px',
    'column-gap': 'px',
    'column-rule': 'px',
    'column-rule-width': 'px',
    'column-width': 'px',
    'flex-basis': 'px',
    'font-size': 'px',
    'font-size-delta': 'px',
    height: 'px',
    left: 'px',
    'letter-spacing': 'px',
    'logical-height': 'px',
    'logical-width': 'px',
    margin: 'px',
    'margin-after': 'px',
    'margin-before': 'px',
    'margin-bottom': 'px',
    'margin-left': 'px',
    'margin-right': 'px',
    'margin-top': 'px',
    'max-height': 'px',
    'max-width': 'px',
    'margin-end': 'px',
    'margin-start': 'px',
    'mask-position-x': 'px',
    'mask-position-y': 'px',
    'mask-size': 'px',
    'max-logical-height': 'px',
    'max-logical-width': 'px',
    'min-height': 'px',
    'min-width': 'px',
    'min-logical-height': 'px',
    'min-logical-width': 'px',
    motion: 'px',
    'motion-offset': 'px',
    outline: 'px',
    'outline-offset': 'px',
    'outline-width': 'px',
    padding: 'px',
    'padding-bottom': 'px',
    'padding-left': 'px',
    'padding-right': 'px',
    'padding-top': 'px',
    'padding-after': 'px',
    'padding-before': 'px',
    'padding-end': 'px',
    'padding-start': 'px',
    'perspective-origin-x': '%',
    'perspective-origin-y': '%',
    perspective: 'px',
    right: 'px',
    'shape-margin': 'px',
    size: 'px',
    'text-indent': 'px',
    'text-stroke': 'px',
    'text-stroke-width': 'px',
    top: 'px',
    'transform-origin': '%',
    'transform-origin-x': '%',
    'transform-origin-y': '%',
    'transform-origin-z': '%',
    'transition-delay': 'ms',
    'transition-duration': 'ms',
    'vertical-align': 'px',
    width: 'px',
    'word-spacing': 'px',
    // Not existing properties.
    // Used to avoid issues with jss-expand intergration.
    'box-shadow-x': 'px',
    'box-shadow-y': 'px',
    'box-shadow-blur': 'px',
    'box-shadow-spread': 'px',
    'font-line-height': 'px',
    'text-shadow-x': 'px',
    'text-shadow-y': 'px',
    'text-shadow-blur': 'px'
  };
});
unwrapExports(defaultUnits);
var lib$7 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports['default'] = defaultUnit;

  var _defaultUnits2 = _interopRequireDefault(defaultUnits);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * Clones the object and adds a camel cased property version.
   */


  function addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;

    var replace = function replace(str) {
      return str[1].toUpperCase();
    };

    var newObj = {};

    for (var key in obj) {
      newObj[key] = obj[key];
      newObj[key.replace(regExp, replace)] = obj[key];
    }

    return newObj;
  }

  var units = addCamelCasedVersion(_defaultUnits2['default']);
  /**
   * Recursive deep style passing function
   *
   * @param {String} current property
   * @param {(Object|Array|Number|String)} property value
   * @param {Object} options
   * @return {(Object|Array|Number|String)} resulting value
   */

  function iterate(prop, value, options) {
    if (!value) return value;
    var convertedValue = value;
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    if (type === 'object' && Array.isArray(value)) type = 'array';

    switch (type) {
      case 'object':
        if (prop === 'fallbacks') {
          for (var innerProp in value) {
            value[innerProp] = iterate(innerProp, value[innerProp], options);
          }

          break;
        }

        for (var _innerProp in value) {
          value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
        }

        break;

      case 'array':
        for (var i = 0; i < value.length; i++) {
          value[i] = iterate(prop, value[i], options);
        }

        break;

      case 'number':
        if (value !== 0) {
          convertedValue = value + (options[prop] || units[prop] || '');
        }

        break;

      default:
        break;
    }

    return convertedValue;
  }
  /**
   * Add unit to numeric values.
   */


  function defaultUnit() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var camelCasedOptions = addCamelCasedVersion(options);

    function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;

      for (var prop in style) {
        style[prop] = iterate(prop, style[prop], camelCasedOptions);
      }

      return style;
    }

    function onChangeValue(value, prop) {
      return iterate(prop, value, camelCasedOptions);
    }

    return {
      onProcessStyle: onProcessStyle,
      onChangeValue: onChangeValue
    };
  }
});
unwrapExports(lib$7);
var props = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * A scheme for converting properties from array to regular style.
   * All properties listed below will be transformed to a string separated by space.
   */

  var propArray = exports.propArray = {
    'background-size': true,
    'background-position': true,
    border: true,
    'border-bottom': true,
    'border-left': true,
    'border-top': true,
    'border-right': true,
    'border-radius': true,
    'border-image': true,
    'border-width': true,
    'border-style': true,
    'border-color': true,
    'box-shadow': true,
    flex: true,
    margin: true,
    padding: true,
    outline: true,
    'transform-origin': true,
    transform: true,
    transition: true
    /**
     * A scheme for converting arrays to regular styles inside of objects.
     * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
     */

  };
  var propArrayInObj = exports.propArrayInObj = {
    position: true,
    // background-position
    size: true // background-size

    /**
     * A scheme for parsing and building correct styles from passed objects.
     */

  };
  var propObj = exports.propObj = {
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    margin: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    background: {
      attachment: null,
      color: null,
      image: null,
      position: null,
      repeat: null
    },
    border: {
      width: null,
      style: null,
      color: null
    },
    'border-top': {
      width: null,
      style: null,
      color: null
    },
    'border-right': {
      width: null,
      style: null,
      color: null
    },
    'border-bottom': {
      width: null,
      style: null,
      color: null
    },
    'border-left': {
      width: null,
      style: null,
      color: null
    },
    outline: {
      width: null,
      style: null,
      color: null
    },
    'list-style': {
      type: null,
      position: null,
      image: null
    },
    transition: {
      property: null,
      duration: null,
      'timing-function': null,
      timingFunction: null,
      // Needed for avoiding comilation issues with jss-camel-case
      delay: null
    },
    animation: {
      name: null,
      duration: null,
      'timing-function': null,
      timingFunction: null,
      // Needed to avoid compilation issues with jss-camel-case
      delay: null,
      'iteration-count': null,
      iterationCount: null,
      // Needed to avoid compilation issues with jss-camel-case
      direction: null,
      'fill-mode': null,
      fillMode: null,
      // Needed to avoid compilation issues with jss-camel-case
      'play-state': null,
      playState: null // Needed to avoid compilation issues with jss-camel-case

    },
    'box-shadow': {
      x: 0,
      y: 0,
      blur: 0,
      spread: 0,
      color: null,
      inset: null
    },
    'text-shadow': {
      x: 0,
      y: 0,
      blur: null,
      color: null
    }
    /**
     * A scheme for converting non-standart properties inside object.
     * For e.g.: include 'border-radius' property inside 'border' object.
     */

  };
  var customPropObj = exports.customPropObj = {
    border: {
      radius: 'border-radius',
      image: 'border-image',
      width: 'border-width',
      style: 'border-style',
      color: 'border-color'
    },
    background: {
      size: 'background-size',
      image: 'background-image'
    },
    font: {
      style: 'font-style',
      variant: 'font-variant',
      weight: 'font-weight',
      stretch: 'font-stretch',
      size: 'font-size',
      family: 'font-family',
      lineHeight: 'line-height',
      // Needed to avoid compilation issues with jss-camel-case
      'line-height': 'line-height'
    },
    flex: {
      grow: 'flex-grow',
      basis: 'flex-basis',
      direction: 'flex-direction',
      wrap: 'flex-wrap',
      flow: 'flex-flow',
      shrink: 'flex-shrink'
    },
    align: {
      self: 'align-self',
      items: 'align-items',
      content: 'align-content'
    },
    grid: {
      'template-columns': 'grid-template-columns',
      templateColumns: 'grid-template-columns',
      'template-rows': 'grid-template-rows',
      templateRows: 'grid-template-rows',
      'template-areas': 'grid-template-areas',
      templateAreas: 'grid-template-areas',
      template: 'grid-template',
      'auto-columns': 'grid-auto-columns',
      autoColumns: 'grid-auto-columns',
      'auto-rows': 'grid-auto-rows',
      autoRows: 'grid-auto-rows',
      'auto-flow': 'grid-auto-flow',
      autoFlow: 'grid-auto-flow',
      row: 'grid-row',
      column: 'grid-column',
      'row-start': 'grid-row-start',
      rowStart: 'grid-row-start',
      'row-end': 'grid-row-end',
      rowEnd: 'grid-row-end',
      'column-start': 'grid-column-start',
      columnStart: 'grid-column-start',
      'column-end': 'grid-column-end',
      columnEnd: 'grid-column-end',
      area: 'grid-area',
      gap: 'grid-gap',
      'row-gap': 'grid-row-gap',
      rowGap: 'grid-row-gap',
      'column-gap': 'grid-column-gap',
      columnGap: 'grid-column-gap'
    }
  };
});
unwrapExports(props);
var props_1 = props.propArray;
var props_2 = props.propArrayInObj;
var props_3 = props.propObj;
var props_4 = props.customPropObj;
var lib$8 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports.default = jssExpand;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Map values by given prop.
   *
   * @param {Array} array of values
   * @param {String} original property
   * @param {String} original rule
   * @return {String} mapped values
   */


  function mapValuesByProp(value, prop, rule) {
    return value.map(function (item) {
      return objectToArray(item, prop, rule, false, true);
    });
  }
  /**
   * Convert array to nested array, if needed
   *
   * @param {Array} array of values
   * @param {String} original property
   * @param {Object} sheme, for converting arrays in strings
   * @param {Object} original rule
   * @return {String} converted string
   */


  function processArray(value, prop, scheme, rule) {
    if (scheme[prop] == null) return value;
    if (value.length === 0) return [];
    if (Array.isArray(value[0])) return processArray(value[0], prop, scheme);

    if (_typeof(value[0]) === 'object') {
      return mapValuesByProp(value, prop, rule);
    }

    return [value];
  }
  /**
   * Convert object to array.
   *
   * @param {Object} object of values
   * @param {String} original property
   * @param {Object} original rule
   * @param {Boolean} is fallback prop
   * @param {Boolean} object is inside array
   * @return {String} converted string
   */


  function objectToArray(value, prop, rule, isFallback, isInArray) {
    if (!(props.propObj[prop] || props.customPropObj[prop])) return [];
    var result = []; // Check if exists any non-standart property

    if (props.customPropObj[prop]) {
      value = customPropsToStyle(value, rule, props.customPropObj[prop], isFallback);
    } // Pass throught all standart props


    if (Object.keys(value).length) {
      for (var baseProp in props.propObj[prop]) {
        if (value[baseProp]) {
          if (Array.isArray(value[baseProp])) {
            result.push(props.propArrayInObj[baseProp] === null ? value[baseProp] : value[baseProp].join(' '));
          } else result.push(value[baseProp]);

          continue;
        } // Add default value from props config.


        if (props.propObj[prop][baseProp] != null) {
          result.push(props.propObj[prop][baseProp]);
        }
      }
    }

    if (!result.length || isInArray) return result;
    return [result];
  }
  /**
   * Convert custom properties values to styles adding them to rule directly
   *
   * @param {Object} object of values
   * @param {Object} original rule
   * @param {String} property, that contain partial custom properties
   * @param {Boolean} is fallback prop
   * @return {Object} value without custom properties, that was already added to rule
   */


  function customPropsToStyle(value, rule, customProps, isFallback) {
    for (var prop in customProps) {
      var propName = customProps[prop]; // If current property doesn't exist already in rule - add new one

      if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
        var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName]; // Add style directly in rule

        if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
      } // Delete converted property to avoid double converting


      delete value[prop];
    }

    return value;
  }
  /**
   * Detect if a style needs to be converted.
   *
   * @param {Object} style
   * @param {Object} rule
   * @param {Boolean} is fallback prop
   * @return {Object} convertedStyle
   */


  function styleDetector(style, rule, isFallback) {
    for (var prop in style) {
      var value = style[prop];

      if (Array.isArray(value)) {
        // Check double arrays to avoid recursion.
        if (!Array.isArray(value[0])) {
          if (prop === 'fallbacks') {
            for (var index = 0; index < style.fallbacks.length; index++) {
              style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
            }

            continue;
          }

          style[prop] = processArray(value, prop, props.propArray); // Avoid creating properties with empty values

          if (!style[prop].length) delete style[prop];
        }
      } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        if (prop === 'fallbacks') {
          style.fallbacks = styleDetector(style.fallbacks, rule, true);
          continue;
        }

        style[prop] = objectToArray(value, prop, rule, isFallback); // Avoid creating properties with empty values

        if (!style[prop].length) delete style[prop];
      } // Maybe a computed value resulting in an empty string
      else if (style[prop] === '') delete style[prop];
    }

    return style;
  }
  /**
   * Adds possibility to write expanded styles.
   *
   * @param {Rule} rule
   * @api public
   */


  function jssExpand() {
    function onProcessStyle(style, rule) {
      if (!style || rule.type !== 'style') return style;

      if (Array.isArray(style)) {
        // Pass rules one by one and reformat them
        for (var index = 0; index < style.length; index++) {
          style[index] = styleDetector(style[index], rule);
        }

        return style;
      }

      return styleDetector(style, rule);
    }

    return {
      onProcessStyle: onProcessStyle
    };
  }
});
unwrapExports(lib$8);
var prefix = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _isInBrowser2 = _interopRequireDefault(isBrowser);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var js = '';
  /**
   * Export javascript style and css style vendor prefixes.
   * Based on "transform" support test.
   */

  var css = ''; // We should not do anything if required serverside.

  if (_isInBrowser2['default']) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var jsCssMap = {
      Moz: '-moz-',
      // IE did it wrong again ...
      ms: '-ms-',
      O: '-o-',
      Webkit: '-webkit-'
    };
    var style = document.createElement('p').style;
    var testProp = 'Transform';

    for (var key in jsCssMap) {
      if (key + testProp in style) {
        js = key;
        css = jsCssMap[key];
        break;
      }
    }
  }
  /**
   * Vendor prefix string for the current browser.
   *
   * @type {{js: String, css: String}}
   * @api public
   */


  exports['default'] = {
    js: js,
    css: css
  };
});
unwrapExports(prefix);
var camelize_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = camelize;
  var regExp = /[-\s]+(.)?/g;
  /**
   * Convert dash separated strings to camel cased.
   *
   * @param {String} str
   * @return {String}
   */

  function camelize(str) {
    return str.replace(regExp, toUpper);
  }

  function toUpper(match, c) {
    return c ? c.toUpperCase() : '';
  }
});
unwrapExports(camelize_1);
var supportedProperty_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = supportedProperty;

  var _isInBrowser2 = _interopRequireDefault(isBrowser);

  var _prefix2 = _interopRequireDefault(prefix);

  var _camelize2 = _interopRequireDefault(camelize_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var el = void 0;
  var cache = {};

  if (_isInBrowser2['default']) {
    el = document.createElement('p');
    /**
     * We test every property on vendor prefix requirement.
     * Once tested, result is cached. It gives us up to 70% perf boost.
     * http://jsperf.com/element-style-object-access-vs-plain-object
     *
     * Prefill cache with known css properties to reduce amount of
     * properties we need to feature test at runtime.
     * http://davidwalsh.name/vendor-prefix
     */

    var computed = window.getComputedStyle(document.documentElement, '');

    for (var key in computed) {
      if (!isNaN(key)) cache[computed[key]] = computed[key];
    }
  }
  /**
   * Test if a property is supported, returns supported property with vendor
   * prefix if required. Returns `false` if not supported.
   *
   * @param {String} prop dash separated
   * @return {String|Boolean}
   * @api public
   */


  function supportedProperty(prop) {
    // For server-side rendering.
    if (!el) return prop; // We have not tested this prop yet, lets do the test.

    if (cache[prop] != null) return cache[prop]; // Camelization is required because we can't test using
    // css syntax for e.g. in FF.
    // Test if property is supported as it is.

    if ((0, _camelize2['default'])(prop) in el.style) {
      cache[prop] = prop;
    } // Test if property is supported with vendor prefix.
    else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
        cache[prop] = _prefix2['default'].css + prop;
      } else {
        cache[prop] = false;
      }

    return cache[prop];
  }
});
unwrapExports(supportedProperty_1);
var supportedValue_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = supportedValue;

  var _isInBrowser2 = _interopRequireDefault(isBrowser);

  var _prefix2 = _interopRequireDefault(prefix);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  var cache = {};
  var el = void 0;
  if (_isInBrowser2['default']) el = document.createElement('p');
  /**
   * Returns prefixed value if needed. Returns `false` if value is not supported.
   *
   * @param {String} property
   * @param {String} value
   * @return {String|Boolean}
   * @api public
   */

  function supportedValue(property, value) {
    // For server-side rendering.
    if (!el) return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.

    if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;
    var cacheKey = property + value;
    if (cache[cacheKey] != null) return cache[cacheKey]; // IE can even throw an error in some cases, for e.g. style.content = 'bar'

    try {
      // Test value as it is.
      el.style[property] = value;
    } catch (err) {
      cache[cacheKey] = false;
      return false;
    } // Value is supported as it is.


    if (el.style[property] !== '') {
      cache[cacheKey] = value;
    } else {
      // Test value with vendor prefix.
      value = _prefix2['default'].css + value; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

      if (value === '-ms-flex') value = '-ms-flexbox';
      el.style[property] = value; // Value is supported with vendor prefix.

      if (el.style[property] !== '') cache[cacheKey] = value;
    }

    if (!cache[cacheKey]) cache[cacheKey] = false; // Reset style value.

    el.style[property] = '';
    return cache[cacheKey];
  }
});
unwrapExports(supportedValue_1);
var lib$9 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

  var _prefix2 = _interopRequireDefault(prefix);

  var _supportedProperty2 = _interopRequireDefault(supportedProperty_1);

  var _supportedValue2 = _interopRequireDefault(supportedValue_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  exports['default'] = {
    prefix: _prefix2['default'],
    supportedProperty: _supportedProperty2['default'],
    supportedValue: _supportedValue2['default']
  };
  /**
   * CSS Vendor prefix detection and property feature testing.
   *
   * @copyright Oleg Slobodskoi 2015
   * @website https://github.com/jsstyles/css-vendor
   * @license MIT
   */

  exports.prefix = _prefix2['default'];
  exports.supportedProperty = _supportedProperty2['default'];
  exports.supportedValue = _supportedValue2['default'];
});
unwrapExports(lib$9);
var lib_1$1 = lib$9.supportedValue;
var lib_2$1 = lib$9.supportedProperty;
var lib_3$1 = lib$9.prefix;
var lib$a = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = jssVendorPrefixer;

  var vendor = _interopRequireWildcard(lib$9);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj['default'] = obj;
      return newObj;
    }
  }
  /**
   * Add vendor prefix to a property name when needed.
   *
   * @param {Rule} rule
   * @api public
   */


  function jssVendorPrefixer() {
    function onProcessRule(rule) {
      if (rule.type === 'keyframes') {
        rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
      }
    }

    function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;

      for (var prop in style) {
        var value = style[prop];
        var changeProp = false;
        var supportedProp = vendor.supportedProperty(prop);
        if (supportedProp && supportedProp !== prop) changeProp = true;
        var changeValue = false;
        var supportedValue = vendor.supportedValue(supportedProp, value);
        if (supportedValue && supportedValue !== value) changeValue = true;

        if (changeProp || changeValue) {
          if (changeProp) delete style[prop];
          style[supportedProp || prop] = supportedValue || value;
        }
      }

      return style;
    }

    function onChangeValue(value, prop) {
      return vendor.supportedValue(prop, value);
    }

    return {
      onProcessRule: onProcessRule,
      onProcessStyle: onProcessStyle,
      onChangeValue: onChangeValue
    };
  }
});
unwrapExports(lib$a);
var lib$b = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = jssPropsSort;
  /**
   * Sort props by length.
   */

  function jssPropsSort() {
    function sort(prop0, prop1) {
      return prop0.length - prop1.length;
    }

    function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var prop in props) {
        newStyle[props[prop]] = style[props[prop]];
      }

      return newStyle;
    }

    return {
      onProcessStyle: onProcessStyle
    };
  }
});
unwrapExports(lib$b);
var lib$c = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _jssTemplate2 = _interopRequireDefault(lib$1);

  var _jssGlobal2 = _interopRequireDefault(lib$2);

  var _jssExtend2 = _interopRequireDefault(lib$3);

  var _jssNested2 = _interopRequireDefault(lib$4);

  var _jssCompose2 = _interopRequireDefault(lib$5);

  var _jssCamelCase2 = _interopRequireDefault(lib$6);

  var _jssDefaultUnit2 = _interopRequireDefault(lib$7);

  var _jssExpand2 = _interopRequireDefault(lib$8);

  var _jssVendorPrefixer2 = _interopRequireDefault(lib$a);

  var _jssPropsSort2 = _interopRequireDefault(lib$b);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      plugins: [(0, _jssTemplate2.default)(options.template), (0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
    };
  };
});
unwrapExports(lib$c);
var jss = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createGenerateClassNameDefault = exports.SheetsManager = exports.getDynamicStyles = exports.SheetsRegistry = undefined;
  Object.defineProperty(exports, 'SheetsRegistry', {
    enumerable: true,
    get: function get() {
      return lib.SheetsRegistry;
    }
  });
  Object.defineProperty(exports, 'getDynamicStyles', {
    enumerable: true,
    get: function get() {
      return lib.getDynamicStyles;
    }
  });
  Object.defineProperty(exports, 'SheetsManager', {
    enumerable: true,
    get: function get() {
      return lib.SheetsManager;
    }
  });
  Object.defineProperty(exports, 'createGenerateClassNameDefault', {
    enumerable: true,
    get: function get() {
      return lib.createGenerateClassName;
    }
  });

  var _jssPresetDefault2 = _interopRequireDefault(lib$c);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  exports['default'] = (0, lib.create)((0, _jssPresetDefault2['default'])());
});
unwrapExports(jss);
var jss_1 = jss.createGenerateClassNameDefault;
var jss_2 = jss.SheetsManager;
var jss_3 = jss.getDynamicStyles;
var jss_4 = jss.SheetsRegistry;
var ns = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Namespaces to avoid conflicts on the context.
   */

  var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
  var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
  var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
  var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';
});
unwrapExports(ns);
var ns_1 = ns.jss;
var ns_2 = ns.sheetsRegistry;
var ns_3 = ns.managers;
var ns_4 = ns.sheetOptions;
var propTypes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = {
    jss: (0, PropTypes.shape)({
      options: (0, PropTypes.shape)({
        createGenerateClassName: PropTypes.func.isRequired
      }).isRequired,
      createStyleSheet: PropTypes.func.isRequired,
      removeStyleSheet: PropTypes.func.isRequired
    }),
    registry: (0, PropTypes.shape)({
      add: PropTypes.func.isRequired,
      toString: PropTypes.func.isRequired
    })
  };
});
unwrapExports(propTypes);
var contextTypes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _ns$jss$ns$sheetOptio;

  var ns$$1 = _interopRequireWildcard(ns);

  var _propTypes3 = _interopRequireDefault(propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj['default'] = obj;
      return newObj;
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns$$1.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns$$1.sheetOptions, PropTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns$$1.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns$$1.managers, PropTypes.object), _ns$jss$ns$sheetOptio);
});
unwrapExports(contextTypes);
var JssProvider_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var ns$$1 = _interopRequireWildcard(ns);

  var _contextTypes2 = _interopRequireDefault(contextTypes);

  var _propTypes3 = _interopRequireDefault(propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var JssProvider = function (_Component) {
    _inherits(JssProvider, _Component);

    function JssProvider() {
      _classCallCheck(this, JssProvider);

      return _possibleConstructorReturn(this, (JssProvider.__proto__ || Object.getPrototypeOf(JssProvider)).apply(this, arguments));
    }

    _createClass(JssProvider, [{
      key: 'getChildContext',
      // JssProvider can be nested. We allow to overwrite any context prop at any level.
      // 1. Check if there is a value passed over props.
      // 2. If value was passed, we set it on the child context.
      // 3. If value was not passed, we proxy parent context (default context behaviour).
      value: function getChildContext() {
        var _props = this.props,
            registry = _props.registry,
            classNamePrefix = _props.classNamePrefix,
            localJss = _props.jss,
            generateClassName = _props.generateClassName,
            disableStylesGeneration = _props.disableStylesGeneration;
        var sheetOptions = this.context[ns$$1.sheetOptions] || {};

        var context = _defineProperty({}, ns$$1.sheetOptions, sheetOptions);

        if (registry) {
          context[ns$$1.sheetsRegistry] = registry; // This way we identify a new request on the server, because user will create
          // a new Registry instance for each.

          if (registry !== this.registry) {
            // We reset managers because we have to regenerate all sheets for the new request.
            this.managers = {};
            this.registry = registry;
          }
        } // Make sure we don't loose managers when JssProvider is used inside of a stateful
        // component which decides to rerender.


        context[ns$$1.managers] = this.managers;

        if (generateClassName) {
          sheetOptions.generateClassName = generateClassName;
        } else if (!sheetOptions.generateClassName) {
          if (!this.generateClassName) {
            var createGenerateClassName = jss.createGenerateClassNameDefault;

            if (localJss && localJss.options.createGenerateClassName) {
              createGenerateClassName = localJss.options.createGenerateClassName;
            } // Make sure we don't loose the generator when JssProvider is used inside of a stateful
            // component which decides to rerender.


            this.generateClassName = createGenerateClassName();
          }

          sheetOptions.generateClassName = this.generateClassName;
        }

        if (classNamePrefix) sheetOptions.classNamePrefix = classNamePrefix;
        if (localJss) context[ns$$1.jss] = localJss;

        if (disableStylesGeneration !== undefined) {
          sheetOptions.disableStylesGeneration = disableStylesGeneration;
        }

        return context;
      }
    }, {
      key: 'render',
      value: function render() {
        return React__default.Children.only(this.props.children);
      }
    }]);

    return JssProvider;
  }(React__default.Component);

  JssProvider.propTypes = _extends({}, _propTypes3['default'], {
    generateClassName: PropTypes.func,
    classNamePrefix: PropTypes.string,
    disableStylesGeneration: PropTypes.bool,
    children: PropTypes.node.isRequired
  });
  JssProvider.childContextTypes = _contextTypes2['default'];
  JssProvider.contextTypes = _contextTypes2['default'];
  exports['default'] = JssProvider;
});
unwrapExports(JssProvider_1);
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;
var compose = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  /**
   * Adds `composes` property to each top level rule
   * in order to have a composed class name for dynamic style sheets.
   *
   * It relies on jss-compose and jss-extend plugins.
   *
   * Example:
   * classes:  {left: 'a', button: 'b'}
   * styles:   {button: {height: () => { ... }}}
   * composed: {
   *   button: {
   *     composes: 'b',
   *     height: () => { ... }
   *   },
   *   left: {
   *     composes: 'a'
   *   }
   * }
   *
   * @param {Object} classes static classes map
   * @param {Object} styles dynamic styles object without static properties
   * @return {Object|null}
   */


  exports["default"] = function (staticClasses, dynamicClasses) {
    var combinedClasses = _extends({}, staticClasses);

    for (var name in dynamicClasses) {
      combinedClasses[name] = staticClasses[name] ? staticClasses[name] + " " + dynamicClasses[name] : dynamicClasses[name];
    }

    return combinedClasses;
  };
});
unwrapExports(compose);
var getDisplayName$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports['default'] = function (Component$$1) {
    return Component$$1.displayName || Component$$1.name || 'Component';
  };
});
unwrapExports(getDisplayName$1);
var createHoc = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var _theming2 = _interopRequireDefault(_theming);

  var _jss2 = _interopRequireDefault(jss);

  var _compose2 = _interopRequireDefault(compose);

  var _getDisplayName2 = _interopRequireDefault(getDisplayName$1);

  var ns$$1 = _interopRequireWildcard(ns);

  var _contextTypes2 = _interopRequireDefault(contextTypes);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj['default'] = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var env = process.env.NODE_ENV; // Like a Symbol

  var dynamicStylesNs = Math.random();
  /*
   * # Use cases
   *
   * - Unthemed component accepts styles object
   * - Themed component accepts styles creator function which takes theme as a single argument
   * - Multiple instances will re-use the same static sheet via sheets manager
   * - Sheet manager identifies static sheets by theme as a key
   * - For unthemed components theme is an empty object
   * - The very first instance will add static sheet to sheets manager
   * - Every further instances will get that static sheet from sheet manager
   * - Every mount of every instance will call method `sheetsManager.manage`,
   * thus incrementing reference counter.
   * - Every unmount of every instance will call method `sheetsManager.unmanage`,
   * thus decrementing reference counter.
   * - `sheetsManager.unmanage` under the hood will detach static sheet once reference
   * counter is zero.
   * - Dynamic styles are not shared between instances
   *
   */

  var getStyles = function getStyles(stylesOrCreator, theme) {
    if (typeof stylesOrCreator !== 'function') {
      return stylesOrCreator;
    }

    return stylesOrCreator(theme);
  }; // Returns an object with array property as a key and true as a value.


  var toMap = function toMap(arr) {
    return arr.reduce(function (map, prop) {
      map[prop] = true;
      return map;
    }, {});
  };

  var defaultInjectProps = {
    sheet: false,
    classes: true,
    theme: true
  };
  var managersCounter = 0;
  /**
   * Wrap a Component into a JSS Container Component.
   *
   * @param {Object|Function} stylesOrCreator
   * @param {Component} InnerComponent
   * @param {Object} [options]
   * @return {Component}
   */

  exports['default'] = function (stylesOrCreator, InnerComponent) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var isThemingEnabled = typeof stylesOrCreator === 'function';

    var _options$theming = options.theming,
        theming = _options$theming === undefined ? _theming2['default'] : _options$theming,
        inject = options.inject,
        optionsJss = options.jss,
        sheetOptions = _objectWithoutProperties(options, ['theming', 'inject', 'jss']);

    var injectMap = inject ? toMap(inject) : defaultInjectProps;
    var themeListener = theming.themeListener;
    var displayName = (0, _getDisplayName2['default'])(InnerComponent);
    var defaultClassNamePrefix = env === 'production' ? undefined : displayName + '-';
    var noTheme = {};
    var managerId = managersCounter++;
    var manager = new jss.SheetsManager();

    var defaultProps = _extends({}, InnerComponent.defaultProps);

    delete defaultProps.classes;

    var Jss = function (_Component) {
      _inherits(Jss, _Component);

      function Jss(props, context) {
        _classCallCheck(this, Jss);

        var _this = _possibleConstructorReturn(this, (Jss.__proto__ || Object.getPrototypeOf(Jss)).call(this, props, context));

        _initialiseProps.call(_this);

        var theme = isThemingEnabled ? themeListener.initial(context) : noTheme;
        _this.state = _this.createState({
          theme: theme
        }, props);
        return _this;
      }

      _createClass(Jss, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.manage(this.state);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (isThemingEnabled) {
            this.unsubscribeId = themeListener.subscribe(this.context, this.setTheme);
          }
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
          this.context = nextContext;
          var dynamicSheet = this.state.dynamicSheet;
          if (dynamicSheet) dynamicSheet.update(nextProps);
        }
      }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
          if (isThemingEnabled && this.state.theme !== nextState.theme) {
            var newState = this.createState(nextState, nextProps);
            this.manage(newState);
            this.manager.unmanage(this.state.theme);
            this.setState(newState);
          }
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          // We remove previous dynamicSheet only after new one was created to avoid FOUC.
          if (prevState.dynamicSheet !== this.state.dynamicSheet) {
            this.jss.removeStyleSheet(prevState.dynamicSheet);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.unsubscribeId) {
            themeListener.unsubscribe(this.context, this.unsubscribeId);
          }

          this.manager.unmanage(this.state.theme);

          if (this.state.dynamicSheet) {
            this.state.dynamicSheet.detach();
          }
        }
      }, {
        key: 'createState',
        value: function createState(_ref, _ref2) {
          var theme = _ref.theme,
              dynamicSheet = _ref.dynamicSheet;
          var userClasses = _ref2.classes;
          var contextSheetOptions = this.context[ns$$1.sheetOptions];

          if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
            return {
              theme: theme,
              dynamicSheet: dynamicSheet,
              classes: {}
            };
          }

          var classNamePrefix = defaultClassNamePrefix;
          var staticSheet = this.manager.get(theme);

          if (contextSheetOptions && contextSheetOptions.classNamePrefix) {
            classNamePrefix = contextSheetOptions.classNamePrefix + classNamePrefix;
          }

          if (!staticSheet) {
            var styles = getStyles(stylesOrCreator, theme);
            staticSheet = this.jss.createStyleSheet(styles, _extends({}, sheetOptions, contextSheetOptions, {
              meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Static',
              classNamePrefix: classNamePrefix
            }));
            this.manager.add(theme, staticSheet);
            staticSheet[dynamicStylesNs] = (0, jss.getDynamicStyles)(styles);
          }

          var dynamicStyles = staticSheet[dynamicStylesNs];

          if (dynamicStyles) {
            dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _extends({}, sheetOptions, contextSheetOptions, {
              meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Dynamic',
              classNamePrefix: classNamePrefix,
              link: true
            }));
          }

          var defaultClasses = InnerComponent.defaultProps ? InnerComponent.defaultProps.classes : {};
          var jssClasses = dynamicSheet ? (0, _compose2['default'])(staticSheet.classes, dynamicSheet.classes) : staticSheet.classes;

          var classes = _extends({}, defaultClasses, jssClasses, userClasses);

          return {
            theme: theme,
            dynamicSheet: dynamicSheet,
            classes: classes
          };
        }
      }, {
        key: 'manage',
        value: function manage(_ref3) {
          var theme = _ref3.theme,
              dynamicSheet = _ref3.dynamicSheet;
          var contextSheetOptions = this.context[ns$$1.sheetOptions];

          if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
            return;
          }

          var registry = this.context[ns$$1.sheetsRegistry];
          var staticSheet = this.manager.manage(theme);
          if (registry) registry.add(staticSheet);

          if (dynamicSheet) {
            dynamicSheet.update(this.props).attach();
            if (registry) registry.add(dynamicSheet);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _state = this.state,
              theme = _state.theme,
              dynamicSheet = _state.dynamicSheet,
              classes = _state.classes;

          var _props = this.props,
              innerRef = _props.innerRef,
              props = _objectWithoutProperties(_props, ['innerRef']);

          var sheet = dynamicSheet || this.manager.get(theme);
          if (injectMap.sheet && !props.sheet) props.sheet = sheet;
          if (isThemingEnabled && injectMap.theme && !props.theme) props.theme = theme; // We have merged classes already.

          if (injectMap.classes) props.classes = classes;
          return _react2['default'].createElement(InnerComponent, _extends({
            ref: innerRef
          }, props));
        }
      }, {
        key: 'jss',
        get: function get() {
          return this.context[ns$$1.jss] || optionsJss || _jss2['default'];
        }
      }, {
        key: 'manager',
        get: function get() {
          var managers = this.context[ns$$1.managers]; // If `managers` map is present in the context, we use it in order to
          // let JssProvider reset them when new response has to render server-side.

          if (managers) {
            if (!managers[managerId]) {
              managers[managerId] = new jss.SheetsManager();
            }

            return managers[managerId];
          }

          return manager;
        }
      }]);

      return Jss;
    }(React__default.Component);

    Jss.displayName = 'Jss(' + displayName + ')';
    Jss.InnerComponent = InnerComponent;
    Jss.contextTypes = _extends({}, _contextTypes2['default'], isThemingEnabled && themeListener.contextTypes);
    Jss.propTypes = {
      innerRef: _propTypes2['default'].func
    };
    Jss.defaultProps = defaultProps;

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.setTheme = function (theme) {
        return _this2.setState({
          theme: theme
        });
      };
    };

    return Jss;
  };
});
unwrapExports(createHoc);
var injectSheet_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = injectSheet;

  var _hoistNonReactStatics2 = _interopRequireDefault(hoistNonReactStatics_cjs);

  var _createHoc2 = _interopRequireDefault(createHoc);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  /**
   * Global index counter to preserve source order.
   * As we create the style sheet during componentWillMount lifecycle,
   * children are handled after the parents, so the order of style elements would
   * be parent->child. It is a problem though when a parent passes a className
   * which needs to override any childs styles. StyleSheet of the child has a higher
   * specificity, because of the source order.
   * So our solution is to render sheets them in the reverse order child->sheet, so
   * that parent has a higher specificity.
   *
   * @type {Number}
   */


  var indexCounter = -100000;

  var NoRenderer = function NoRenderer(_ref) {
    var children = _ref.children;
    return children || null;
  };
  /**
   * HOC creator function that wrapps the user component.
   *
   * `injectSheet(styles, [options])(Component)`
   *
   * @api public
   */


  function injectSheet(stylesOrSheet) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (options.index === undefined) {
      options.index = indexCounter++;
    }

    return function () {
      var InnerComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NoRenderer;
      var Jss = (0, _createHoc2['default'])(stylesOrSheet, InnerComponent, options);
      return (0, _hoistNonReactStatics2['default'])(Jss, InnerComponent, {
        inner: true
      });
    };
  }
});
unwrapExports(injectSheet_1);
var lib$d = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, 'ThemeProvider', {
    enumerable: true,
    get: function get() {
      return _theming.ThemeProvider;
    }
  });
  Object.defineProperty(exports, 'withTheme', {
    enumerable: true,
    get: function get() {
      return _theming.withTheme;
    }
  });
  Object.defineProperty(exports, 'createTheming', {
    enumerable: true,
    get: function get() {
      return _theming.createTheming;
    }
  });
  Object.defineProperty(exports, 'JssProvider', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(JssProvider_1)['default'];
    }
  });
  Object.defineProperty(exports, 'jss', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(jss)['default'];
    }
  });
  Object.defineProperty(exports, 'SheetsRegistry', {
    enumerable: true,
    get: function get() {
      return jss.SheetsRegistry;
    }
  });
  Object.defineProperty(exports, 'createGenerateClassName', {
    enumerable: true,
    get: function get() {
      return jss.createGenerateClassNameDefault;
    }
  });
  Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(injectSheet_1)['default'];
    }
  });

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
});
var injectSheet$1 = unwrapExports(lib$d);

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose$1;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty$2 = _defineProperty$3;
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;

for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser$1 && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser$1 && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/

var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */

function isFunction$2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */


function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  } // NOTE: 1 DOM access here


  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */


function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }

  return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */


function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;

    case '#document':
      return element.body;
  } // Firefox want us to check `-x` and `-y` variations as well


  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */

function isIE(version) {
  if (version === 11) {
    return isIE11;
  }

  if (version === 10) {
    return isIE10;
  }

  return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */


function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null; // NOTE: 1 DOM access here

  var offsetParent = element.offsetParent || null; // Skip hidden elements which don't have an offsetParent

  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  } // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...


  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }

  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */


function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */


function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  } // Here we make sure to give as "start" the element that comes first in the DOM


  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1; // Get common ancestor container

  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer; // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  } // one of the nodes is inside shadowDOM, find which one


  var element1root = getRoot(element1);

  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */


function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */


function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */


function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty$3 = function defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */


function getClientRect(offsets) {
  return _extends$3({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */


function getBoundingClientRect(element) {
  var rect = {}; // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11

  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  }; // subtract scrollbar size from sizes

  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height; // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons

  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10); // In cases where the parent is fixed, we must ignore negative scroll in offset calc

  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0; // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.

  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft; // Attach marginTop and marginLeft because in some circumstances we may need them

    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };
  return getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */


function isFixed(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }

  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }

  return isFixed(getParentNode(element));
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */


function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }

  var el = element.parentElement;

  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }

  return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */


function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false; // NOTE: 1 DOM access here

  var boundaries = {
    top: 0,
    left: 0
  };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference); // Handle viewport case

  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;

    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));

      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition); // In case of HTML, we need a different computation

    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  } // Add paddings


  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$3({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split('-')[1];
  return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */


function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */


function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */


function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */


function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0]; // Get popper node sizes

  var popperRect = getOuterSizes(popper); // Add position, width and height to our offsets object

  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  }; // depending by the popper placement we have to compute its offsets slightly differently

  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;

  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  } // use `filter` to obtain the same behavior of `find`


  return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  } // use `find` + `indexOf` if `findIndex` isn't supported


  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */


function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }

    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation

    if (modifier.enabled && isFunction$2(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */


function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  }; // compute reference element offsets

  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding); // store the computed placement inside `originalPlacement`

  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed; // compute the popper offsets

  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute'; // run the modifiers

  data = runModifiers(this.modifiers, data); // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback

  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */


function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */


function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;

    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }

  return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */


function destroy() {
  this.state.isDestroyed = true; // touch DOM only if `applyStyle` modifier is enabled

  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners(); // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it

  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }

  return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */


function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, {
    passive: true
  });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }

  scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, {
    passive: true
  }); // Scroll event listener on scroll parents

  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */


function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound); // Remove scroll event listener on scroll parents

  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  }); // Reset state

  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */


function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */


function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = ''; // add unit if the value is numeric and is one of the following

    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }

    element.style[prop] = styles[prop] + unit;
  });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];

    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */


function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles); // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element

  setAttributes(data.instance.popper, data.attributes); // if arrowElement is defined and arrowStyles has some properties

  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */


function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute('x-placement', placement); // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations

  setStyles(popper, {
    position: options.positionFixed ? 'fixed' : 'absolute'
  });
  return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */


function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthOddness = reference.width % 2 === popper.width % 2;
  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;

  var noRound = function noRound(v) {
    return v;
  };

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
  var verticalToInteger = !shouldRound ? noRound : Math.round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser$1 && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper; // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;

  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }

  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent); // Styles

  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right'; // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed

  var prefixedProperty = getSupportedPropertyName('transform'); // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.

  var left = void 0,
      top = void 0;

  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }

  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }

  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  } // Attributes


  var attributes = {
    'x-placement': data.placement
  }; // Update `data` attributes, styles and arrowStyles

  data.attributes = _extends$3({}, attributes, data.attributes);
  data.styles = _extends$3({}, styles, data.styles);
  data.arrowStyles = _extends$3({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */


function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';

    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }

  return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function arrow(data, options) {
  var _data$offsets$arrow; // arrow depends on keepTogether in order to work


  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element; // if arrowElement is a string, suppose it's a CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement); // if arrowElement is not found, don't run the modifier

    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len]; //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //
  // top/left side

  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  } // bottom/right side


  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }

  data.offsets.popper = getClientRect(data.offsets.popper); // compute center of the popper

  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2; // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available

  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide; // prevent arrowElement from being placed not contiguously to its popper

  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$3(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$3(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
  return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */


function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }

  return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */


var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']; // Get rid of `auto` `auto-start` and `auto-end`

var validPlacements = placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */

function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;

    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;

    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;

    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference; // using floor because the reference offsets may contain decimals we are not going to consider here

    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom; // flip the variation if required

    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : ''); // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future

      data.offsets.popper = _extends$3({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }

  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */


function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2]; // If it's not a number it's an operator, I guess

  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;

    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;

      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;

    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */


function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0]; // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one

  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1; // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)

  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  }); // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space

  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  } // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.


  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments]; // Convert the values with units to absolute pixels to allow our computations

  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, []) // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  }); // Loop trough the offsets arrays and execute the operations

  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */


function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var basePlacement = placement.split('-')[0];
  var offsets = void 0;

  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper); // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken

  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  } // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself


  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification

  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];
  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed); // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed

  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];

      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }

      return defineProperty$3({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];

      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }

      return defineProperty$3({}, mainSide, value);
    }
  };
  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$3({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1]; // if shift shiftvariation is specified, run the modifier

  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;
    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    var shiftOffsets = {
      start: defineProperty$3({}, side, reference[side]),
      end: defineProperty$3({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends$3({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */


var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: offset,

    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: preventOverflow,

    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],

    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: arrow,

    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: flip,

    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',

    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,

    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,

    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: computeStyle,

    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,

    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',

    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: applyStyle,

    /** @prop {Function} */
    onLoad: applyStyleOnLoad,

    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */

var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */
// Utils
// Methods

var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    }; // make update() debounced, so that it only runs at most once-per-tick


    this.update = debounce(this.update.bind(this)); // with {} we create a new object with the options inside it

    this.options = _extends$3({}, Popper.Defaults, options); // init state

    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    }; // get reference and popper elements (allow jQuery wrappers)

    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper; // Deep merge modifiers options

    this.options.modifiers = {};
    Object.keys(_extends$3({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$3({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    }); // Refactoring modifiers' list (Object => Array)

    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$3({
        name: name
      }, _this.options.modifiers[name]);
    }) // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    }); // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!

    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$2(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    }); // fire the first update to position the popper in the right place

    this.update();
    var eventsEnabled = this.options.eventsEnabled;

    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  } // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
var key = '__global_unique_id__';

var gud = function gud() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning$1 = emptyFunction_1;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$1 = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1$1 = warning$1;
var implementation = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _react2 = _interopRequireDefault(React__default);

  var _propTypes2 = _interopRequireDefault(PropTypes);

  var _gud2 = _interopRequireDefault(gud);

  var _warning2 = _interopRequireDefault(warning_1$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MAX_SIGNED_31_BIT_INT = 1073741823; // Inlined Object.is polyfill.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is

  function objectIs(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }

  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function (h) {
          return h !== handler;
        });
      },
      get: function get() {
        return value;
      },
      set: function set(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function (handler) {
          return handler(value, changedBits);
        });
      }
    };
  }

  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }

  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;

    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

    var Provider = function (_Component) {
      _inherits(Provider, _Component);

      function Provider() {
        var _temp, _this, _ret;

        _classCallCheck(this, Provider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
      }

      Provider.prototype.getChildContext = function getChildContext() {
        var _ref;

        return _ref = {}, _ref[contextProp] = this.emitter, _ref;
      };

      Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;

          if (objectIs(oldValue, newValue)) {
            changedBits = 0; // No change
          } else {
            changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

            if (process.env.NODE_ENV !== 'production') {
              (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
            }

            changedBits |= 0;

            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };

      Provider.prototype.render = function render() {
        return this.props.children;
      };

      return Provider;
    }(React__default.Component);

    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

    var Consumer = function (_Component2) {
      _inherits(Consumer, _Component2);

      function Consumer() {
        var _temp2, _this2, _ret2;

        _classCallCheck(this, Consumer);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
          value: _this2.getValue()
        }, _this2.onUpdate = function (newValue, changedBits) {
          var observedBits = _this2.observedBits | 0;

          if ((observedBits & changedBits) !== 0) {
            _this2.setState({
              value: _this2.getValue()
            });
          }
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
      }

      Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };

      Consumer.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }

        var observedBits = this.props.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };

      Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };

      Consumer.prototype.getValue = function getValue() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };

      Consumer.prototype.render = function render() {
        return onlyChild(this.props.children)(this.state.value);
      };

      return Consumer;
    }(React__default.Component);

    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
      Provider: Provider,
      Consumer: Consumer
    };
  }

  exports.default = createReactContext;
  module.exports = exports['default'];
});
unwrapExports(implementation);
var lib$e = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;

  var _react2 = _interopRequireDefault(React__default);

  var _implementation2 = _interopRequireDefault(implementation);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _react2.default.createContext || _implementation2.default;
  module.exports = exports['default'];
});
var createContext = unwrapExports(lib$e);
var ManagerContext = createContext({
  getReferenceRef: undefined,
  referenceNode: undefined
});

var Manager = /*#__PURE__*/function (_React$Component) {
  inheritsLoose(Manager, _React$Component);

  function Manager() {
    var _this;

    _this = _React$Component.call(this) || this;
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "getReferenceRef", function (referenceNode) {
      return _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: _extends_1({}, context, {
            referenceNode: referenceNode
          })
        };
      });
    });
    _this.state = {
      context: {
        getReferenceRef: _this.getReferenceRef,
        referenceNode: undefined
      }
    };
    return _this;
  }

  var _proto = Manager.prototype;

  _proto.render = function render() {
    return createElement(ManagerContext.Provider, {
      value: this.state.context
    }, this.props.children);
  };

  return Manager;
}(Component);
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */


var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */


var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};

var InnerPopper = /*#__PURE__*/function (_React$Component) {
  inheritsLoose(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "state", {
      data: undefined,
      placement: undefined
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "popperInstance", void 0);
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "popperNode", null);
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "arrowNode", null);
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      safeInvoke(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends_1({}, _this.props.modifiers, {
          arrow: _extends_1({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends_1({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = assertThisInitialized(assertThisInitialized(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper(referenceElement, popperNode, _this.getOptions());
    });
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });
    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    safeInvoke(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(Component);

defineProperty$2(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

function Popper$1(_ref) {
  var referenceElement = _ref.referenceElement,
      props = objectWithoutPropertiesLoose(_ref, ["referenceElement"]);
  return createElement(ManagerContext.Consumer, null, function (_ref2) {
    var referenceNode = _ref2.referenceNode;
    return createElement(InnerPopper, _extends_1({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */


var __DEV__$1 = process.env.NODE_ENV !== 'production';

var warning$2 = function warning$2() {};

if (__DEV__$1) {
  var printWarning$1 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$2 = function warning$2(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      printWarning$1.apply(null, [format].concat(args));
    }
  };
}

var warning_1$2 = warning$2;

var InnerReference = /*#__PURE__*/function (_React$Component) {
  inheritsLoose(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    defineProperty$2(assertThisInitialized(assertThisInitialized(_this)), "refHandler", function (node) {
      safeInvoke(_this.props.innerRef, node);
      safeInvoke(_this.props.getReferenceRef, node);
    });
    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.render = function render() {
    warning_1$2(this.props.getReferenceRef, '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(Component);

function Reference(props) {
  return createElement(ManagerContext.Consumer, null, function (_ref) {
    var getReferenceRef = _ref.getReferenceRef;
    return createElement(InnerReference, _extends_1({
      getReferenceRef: getReferenceRef
    }, props));
  });
} // Public components
// Public types


function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var TooltipContext = React__default.createContext({});

var callAll = function callAll() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.forEach(function (fn) {
      return fn && fn.apply(void 0, args);
    });
  };
};

var noop = function noop() {};

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};

var MUTATION_OBSERVER_CONFIG = {
  childList: true,
  subtree: true
};

var Tooltip = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tooltip, _Component);

  function Tooltip() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.observer = void 0;

    _this.handleOutsideClick = function (event) {
      if (!findDOMNode(_assertThisInitialized$1(_assertThisInitialized$1(_this))).contains(event.target)) {
        var _this$props = _this.props,
            hideTooltip = _this$props.hideTooltip,
            clearScheduled = _this$props.clearScheduled,
            parentOutsideClickHandler = _this$props.parentOutsideClickHandler;
        clearScheduled();
        hideTooltip();

        if (parentOutsideClickHandler) {
          parentOutsideClickHandler(event);
        }
      }
    };

    _this.handleOutsideRightClick = function (event) {
      if (!findDOMNode(_assertThisInitialized$1(_assertThisInitialized$1(_this))).contains(event.target)) {
        var _this$props2 = _this.props,
            hideTooltip = _this$props2.hideTooltip,
            clearScheduled = _this$props2.clearScheduled,
            parentOutsideRightClickHandler = _this$props2.parentOutsideRightClickHandler;
        clearScheduled();
        hideTooltip();

        if (parentOutsideRightClickHandler) {
          parentOutsideRightClickHandler(event);
        }
      }
    };

    _this.addOutsideClickHandler = function () {
      if ('ontouchend' in window) {
        document.addEventListener('touchend', _this.handleOutsideClick);
      } else {
        document.addEventListener('click', _this.handleOutsideClick);
      }
    };

    _this.removeOutsideClickHandler = function () {
      document.removeEventListener('touchend', _this.handleOutsideClick);
      document.removeEventListener('click', _this.handleOutsideClick);
    };

    _this.addOutsideRightClickHandler = function () {
      return document.addEventListener('contextmenu', _this.handleOutsideRightClick);
    };

    _this.removeOutsideRightClickHandler = function () {
      return document.removeEventListener('contextmenu', _this.handleOutsideRightClick);
    };

    _this.getArrowProps = function (props) {
      if (props === void 0) {
        props = {};
      }

      return _extends({}, props, {
        style: _extends({}, props.style, _this.props.arrowProps.style)
      });
    };

    _this.getTooltipProps = function (props) {
      if (props === void 0) {
        props = {};
      }

      var isHoverTriggered = _this.props.trigger === 'hover';
      return _extends({}, props, isHoverTriggered && {
        onMouseEnter: callAll(_this.props.clearScheduled, props.onMouseEnter)
      }, isHoverTriggered && {
        onMouseLeave: callAll(_this.props.hideTooltip, props.onMouseLeave)
      }, {
        style: _extends({}, props.style, _this.props.style)
      });
    };

    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var trigger = this.props.trigger;
    var observer = this.observer = new MutationObserver(function () {
      _this2.props.scheduleUpdate();
    });
    observer.observe(findDOMNode(this), MUTATION_OBSERVER_CONFIG);

    if (trigger === 'click' || trigger === 'right-click') {
      var _this$props3 = this.props,
          removeParentOutsideClickHandler = _this$props3.removeParentOutsideClickHandler,
          removeParentOutsideRightClickHandler = _this$props3.removeParentOutsideRightClickHandler;
      this.addOutsideClickHandler();
      this.addOutsideRightClickHandler();

      if (removeParentOutsideClickHandler) {
        removeParentOutsideClickHandler();
      }

      if (removeParentOutsideRightClickHandler) {
        removeParentOutsideRightClickHandler();
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.props.closeOnOutOfBoundaries && this.props.outOfBoundaries) {
      this.props.hideTooltip();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var trigger = this.props.trigger;

    if (this.observer) {
      this.observer.disconnect();
    }

    if (trigger === 'click' || trigger === 'right-click') {
      var _this$props4 = this.props,
          addParentOutsideClickHandler = _this$props4.addParentOutsideClickHandler,
          addParentOutsideRightClickHandler = _this$props4.addParentOutsideRightClickHandler;
      this.removeOutsideClickHandler();
      this.removeOutsideRightClickHandler();
      this.handleOutsideClick = undefined;
      this.handleOutsideRightClick = undefined;

      if (addParentOutsideClickHandler) {
        addParentOutsideClickHandler();
      }

      if (addParentOutsideRightClickHandler) {
        addParentOutsideRightClickHandler();
      }
    }
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        arrowProps = _this$props5.arrowProps,
        placement = _this$props5.placement,
        tooltip = _this$props5.tooltip,
        innerRef = _this$props5.innerRef;
    return React__default.createElement(TooltipContext.Provider, {
      value: {
        addParentOutsideClickHandler: this.addOutsideClickHandler,
        addParentOutsideRightClickHandler: this.addOutsideRightClickHandler,
        parentOutsideClickHandler: this.handleOutsideClick,
        parentOutsideRightClickHandler: this.handleOutsideRightClick,
        removeParentOutsideClickHandler: this.removeOutsideClickHandler,
        removeParentOutsideRightClickHandler: this.removeOutsideRightClickHandler
      }
    }, tooltip({
      arrowRef: arrowProps.ref,
      getArrowProps: this.getArrowProps,
      getTooltipProps: this.getTooltipProps,
      placement: placement,
      tooltipRef: innerRef
    }));
  };

  return Tooltip;
}(Component);

var DEFAULT_MODIFIERS = {
  preventOverflow: {
    boundariesElement: 'viewport'
  }
};

var TooltipTrigger = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TooltipTrigger, _Component);

  function TooltipTrigger() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      tooltipShown: _this.props.defaultTooltipShown
    };
    _this.hideTimeout = void 0;
    _this.showTimeout = void 0;

    _this.setTooltipState = function (state) {
      var cb = function cb() {
        return _this.props.onVisibilityChange(state.tooltipShown);
      };

      _this.isControlled() ? cb() : _this.setState(state, cb);
    };

    _this.clearScheduled = function () {
      clearTimeout(_this.hideTimeout);
      clearTimeout(_this.showTimeout);
    };

    _this.showTooltip = function (_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY;

      _this.clearScheduled();

      var state = {
        tooltipShown: true
      };

      if (_this.props.followCursor) {
        state = _extends({}, state, {
          pageX: pageX,
          pageY: pageY
        });
      }

      _this.showTimeout = window.setTimeout(function () {
        return _this.setTooltipState(state);
      }, _this.props.delayShow);
    };

    _this.hideTooltip = function () {
      _this.clearScheduled();

      _this.hideTimeout = window.setTimeout(function () {
        return _this.setTooltipState({
          tooltipShown: false
        });
      }, _this.props.delayHide);
    };

    _this.toggleTooltip = function (_ref2) {
      var pageX = _ref2.pageX,
          pageY = _ref2.pageY;
      var action = _this.getState() ? 'hideTooltip' : 'showTooltip';

      _this[action]({
        pageX: pageX,
        pageY: pageY
      });
    };

    _this.clickToggle = function (_ref3) {
      var pageX = _ref3.pageX,
          pageY = _ref3.pageY;
      var action = _this.props.followCursor ? 'showTooltip' : 'toggleTooltip';

      _this[action]({
        pageX: pageX,
        pageY: pageY
      });
    };

    _this.contextMenuToggle = function (event) {
      event.preventDefault();
      var pageX = event.pageX,
          pageY = event.pageY;
      var action = _this.props.followCursor ? 'showTooltip' : 'toggleTooltip';

      _this[action]({
        pageX: pageX,
        pageY: pageY
      });
    };

    _this.getTriggerProps = function (props) {
      if (props === void 0) {
        props = {};
      }

      var _this$props = _this.props,
          trigger = _this$props.trigger,
          followCursor = _this$props.followCursor;
      var isClickTriggered = trigger === 'click';
      var isHoverTriggered = trigger === 'hover';
      var isRightClickTriggered = trigger === 'right-click';
      var isTouchEnabled = canUseDOM() && 'ontouchend' in window;
      return _extends({}, props, isClickTriggered && isTouchEnabled && {
        onTouchEnd: callAll(_this.clickToggle, props.onTouchEnd)
      }, isClickTriggered && !isTouchEnabled && {
        onClick: callAll(_this.clickToggle, props.onClick)
      }, isRightClickTriggered && {
        onContextMenu: callAll(_this.contextMenuToggle, props.onContextMenu)
      }, isHoverTriggered && {
        onMouseEnter: callAll(_this.showTooltip, props.onMouseEnter)
      }, isHoverTriggered && {
        onMouseLeave: callAll(_this.hideTooltip, props.onMouseLeave)
      }, isHoverTriggered && followCursor && {
        onMouseMove: callAll(_this.showTooltip, props.onMouseMove)
      });
    };

    return _this;
  }

  var _proto = TooltipTrigger.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearScheduled();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        tooltip = _this$props2.tooltip,
        placement = _this$props2.placement,
        trigger = _this$props2.trigger,
        getTriggerRef = _this$props2.getTriggerRef,
        modifiers = _this$props2.modifiers,
        closeOnOutOfBoundaries = _this$props2.closeOnOutOfBoundaries,
        usePortal = _this$props2.usePortal,
        portalContainer = _this$props2.portalContainer,
        followCursor = _this$props2.followCursor,
        getTooltipRef = _this$props2.getTooltipRef;
    var _this$context = this.context,
        parentOutsideClickHandler = _this$context.parentOutsideClickHandler,
        addParentOutsideClickHandler = _this$context.addParentOutsideClickHandler,
        removeParentOutsideClickHandler = _this$context.removeParentOutsideClickHandler,
        parentOutsideRightClickHandler = _this$context.parentOutsideRightClickHandler,
        addParentOutsideRightClickHandler = _this$context.addParentOutsideRightClickHandler,
        removeParentOutsideRightClickHandler = _this$context.removeParentOutsideRightClickHandler;
    var popper = React__default.createElement(Popper$1, {
      innerRef: getTooltipRef,
      placement: placement,
      modifiers: _extends({}, DEFAULT_MODIFIERS, modifiers)
    }, function (_ref4) {
      var ref = _ref4.ref,
          style = _ref4.style,
          placement = _ref4.placement,
          arrowProps = _ref4.arrowProps,
          outOfBoundaries = _ref4.outOfBoundaries,
          scheduleUpdate = _ref4.scheduleUpdate;

      if (followCursor) {
        var _this2$state = _this2.state,
            pageX = _this2$state.pageX,
            pageY = _this2$state.pageY;
        style.transform = "translate3d(" + pageX + "px, " + pageY + "px, 0";
      }

      return React__default.createElement(Tooltip, _extends({
        addParentOutsideClickHandler: addParentOutsideClickHandler,
        addParentOutsideRightClickHandler: addParentOutsideRightClickHandler,
        arrowProps: arrowProps,
        closeOnOutOfBoundaries: closeOnOutOfBoundaries,
        outOfBoundaries: outOfBoundaries,
        parentOutsideClickHandler: parentOutsideClickHandler,
        parentOutsideRightClickHandler: parentOutsideRightClickHandler,
        placement: placement,
        removeParentOutsideClickHandler: removeParentOutsideClickHandler,
        removeParentOutsideRightClickHandler: removeParentOutsideRightClickHandler,
        scheduleUpdate: scheduleUpdate,
        style: style,
        tooltip: tooltip,
        trigger: trigger
      }, {
        clearScheduled: _this2.clearScheduled,
        hideTooltip: _this2.hideTooltip,
        innerRef: ref
      }));
    });
    return React__default.createElement(Manager, null, React__default.createElement(Reference, {
      innerRef: getTriggerRef
    }, function (_ref5) {
      var ref = _ref5.ref;
      return children({
        getTriggerProps: _this2.getTriggerProps,
        triggerRef: ref
      });
    }), this.getState() && (usePortal ? createPortal(popper, portalContainer) : popper));
  };

  _proto.isControlled = function isControlled() {
    return this.props.tooltipShown !== undefined;
  };

  _proto.getState = function getState() {
    return this.isControlled() ? this.props.tooltipShown : this.state.tooltipShown;
  };

  return TooltipTrigger;
}(Component);

TooltipTrigger.defaultProps = {
  closeOnOutOfBoundaries: true,
  defaultTooltipShown: false,
  delayHide: 0,
  delayShow: 0,
  followCursor: false,
  onVisibilityChange: noop,
  placement: 'right',
  portalContainer: canUseDOM() ? document.body : null,
  trigger: 'hover',
  usePortal: canUseDOM()
};
TooltipTrigger.contextType = TooltipContext;
var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$4(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop$1 = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _PERFORMANCE = {
  mark: noop$1,
  measure: noop$1
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';

var PRODUCTION = function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
}();

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = _objectSpread({
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}, initial);

if (!_default.autoReplaceSvg) _default.observeMutations = false;

var config = _objectSpread({}, _default);

WINDOW.FontAwesomeConfig = config;
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions$2 = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions$2.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};

function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}

var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}

function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}

function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}

function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}

function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function makeIconMasking(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [{
      tag: 'path',
      attributes: _objectSpread({}, mainPath.attributes, trans.path, {
        fill: 'black'
      })
    }]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(nextUniqueId());
  var clipId = "clip-".concat(nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: [maskPath]
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon(_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol(_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var widthClass = "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    transform: transform,
    symbol: symbol,
    styles: extra.styles
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

var noop$1$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1$1,
  measure: noop$1$1
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

var styles = namespace.styles,
    shims = namespace.shims;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};

var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    acc[icon[3]] = iconName;
    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = ('far' in styles);
  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};

build();
var styles$1 = namespace.styles;

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}

MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;
var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

var DOT = {
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
};
var QUESTION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
};
var styles$2 = namespace.styles;
var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

function define(prefix, icons) {
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function') {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    define('fa', icons);
  }
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck$2(this, Library);

    this.definitions = {};
  }

  _createClass$2(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        define(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function prepIcon(icon) {
  var width = icon[0];
  var height = icon[1];
  var vectorData = icon.slice(4);
  return {
    found: true,
    width: width,
    height: height,
    icon: {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData[0]
      }
    }
  };
}

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(params) {
  var _params$prefix = params.prefix,
      prefix = _params$prefix === void 0 ? 'fa' : _params$prefix,
      iconName = params.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var _cssInserted = false;
var parse$2 = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: prepIcon(icon),
        mask: mask ? prepIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof$1(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof$1(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$5(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var commonjsGlobal$1 = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var humps = createCommonjsModule$1(function (module) {
  (function (global) {
    var _processKeys = function _processKeys(convert, obj, options) {
      if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
        return obj;
      }

      var output,
          i = 0,
          l = 0;

      if (_isArray(obj)) {
        output = [];

        for (l = obj.length; i < l; i++) {
          output.push(_processKeys(convert, obj[i], options));
        }
      } else {
        output = {};

        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            output[convert(key, options)] = _processKeys(convert, obj[key], options);
          }
        }
      }

      return output;
    }; // String conversion methods


    var separateWords = function separateWords(string, options) {
      options = options || {};
      var separator = options.separator || '_';
      var split = options.split || /(?=[A-Z])/;
      return string.split(split).join(separator);
    };

    var camelize = function camelize(string) {
      if (_isNumerical(string)) {
        return string;
      }

      string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : '';
      }); // Ensure 1st char is always lowercase

      return string.substr(0, 1).toLowerCase() + string.substr(1);
    };

    var pascalize = function pascalize(string) {
      var camelized = camelize(string); // Ensure 1st char is always uppercase

      return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };

    var decamelize = function decamelize(string, options) {
      return separateWords(string, options).toLowerCase();
    }; // Utilities
    // Taken from Underscore.js


    var toString = Object.prototype.toString;

    var _isFunction = function _isFunction(obj) {
      return typeof obj === 'function';
    };

    var _isObject = function _isObject(obj) {
      return obj === Object(obj);
    };

    var _isArray = function _isArray(obj) {
      return toString.call(obj) == '[object Array]';
    };

    var _isDate = function _isDate(obj) {
      return toString.call(obj) == '[object Date]';
    };

    var _isRegExp = function _isRegExp(obj) {
      return toString.call(obj) == '[object RegExp]';
    };

    var _isBoolean = function _isBoolean(obj) {
      return toString.call(obj) == '[object Boolean]';
    }; // Performant way to determine if obj coerces to a number


    var _isNumerical = function _isNumerical(obj) {
      obj = obj - 0;
      return obj === obj;
    }; // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback


    var _processor = function _processor(convert, options) {
      var callback = options && 'process' in options ? options.process : options;

      if (typeof callback !== 'function') {
        return convert;
      }

      return function (string, options) {
        return callback(string, convert, options);
      };
    };

    var humps = {
      camelize: camelize,
      decamelize: decamelize,
      pascalize: pascalize,
      depascalize: decamelize,
      camelizeKeys: function camelizeKeys(object, options) {
        return _processKeys(_processor(camelize, options), object);
      },
      decamelizeKeys: function decamelizeKeys(object, options) {
        return _processKeys(_processor(decamelize, options), object, options);
      },
      pascalizeKeys: function pascalizeKeys(object, options) {
        return _processKeys(_processor(pascalize, options), object);
      },
      depascalizeKeys: function depascalizeKeys() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };

    if (module.exports) {
      module.exports = humps;
    } else {
      global.humps = humps;
    }
  })(commonjsGlobal$1);
});

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement$$1, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement$$1, child);
  });
  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[humps.camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, ["style"]);

  mixins.attrs['style'] = _objectSpread$1({}, mixins.attrs['style'], existingStyle);
  return createElement$$1.apply(void 0, [element.tag, _objectSpread$1({}, mixins.attrs, remaining)].concat(_toConsumableArray$1(children)));
}

var PRODUCTION$1 = false;

try {
  PRODUCTION$1 = process.env.NODE_ENV === 'production';
} catch (e) {}

function log() {
  if (!PRODUCTION$1 && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$5({}, key, value) : {};
}

function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-pulse': props.pulse,
    'fa-fw': props.fixedWidth,
    'fa-inverse': props.inverse,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, _defineProperty$5(_classes, "fa-".concat(props.size), props.size !== null), _defineProperty$5(_classes, "fa-rotate-".concat(props.rotation), props.rotation !== null), _defineProperty$5(_classes, "fa-pull-".concat(props.pull), props.pull !== null), _classes);
  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

function normalizeIconArgs(icon$$1) {
  if (icon$$1 === null) {
    return null;
  }

  if (_typeof$1(icon$$1) === 'object' && icon$$1.prefix && icon$$1.iconName) {
    return icon$$1;
  }

  if (Array.isArray(icon$$1) && icon$$1.length === 2) {
    return {
      prefix: icon$$1[0],
      iconName: icon$$1[1]
    };
  }

  if (typeof icon$$1 === 'string') {
    return {
      prefix: 'fas',
      iconName: icon$$1
    };
  }
}

function FontAwesomeIcon(props) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray$1(classList(props)), _toConsumableArray$1(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse$2.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread$1({}, classes, transform, mask, {
    symbol: symbol,
    title: title
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {};
  Object.keys(props).forEach(function (key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}

FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  border: PropTypes.bool,
  className: PropTypes.string,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(['right', 'left']),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([90, 180, 270]),
  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  title: '',
  transform: null
};
var convertCurry = convert.bind(null, React__default.createElement);
var faCaretDown = {
  prefix: 'fas',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"]
};
var faCaretUp = {
  prefix: 'fas',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"]
};
var faCircle = {
  prefix: 'fas',
  iconName: 'circle',
  icon: [512, 512, [], "f111", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"]
};
var faInfoCircle = {
  prefix: 'fas',
  iconName: 'info-circle',
  icon: [512, 512, [], "f05a", "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"]
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css$1 = ".tooltip-container {\n  background-color: white;\n  border-radius: 3px;\n  border: 1px solid silver;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);\n  display: flex;\n  flex-direction: column;\n  margin: 0.4rem;\n  padding: 0.4rem;\n  transition: opacity 0.3s;\n  z-index: 2147483647;\n}\n\n.tooltip-arrow {\n  height: 1rem;\n  position: absolute;\n  width: 1rem;\n}\n\n.tooltip-arrow::before {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  margin: auto;\n  width: 0;\n}\n\n.tooltip-arrow::after {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  margin: auto;\n  position: absolute;\n  width: 0;\n}\n\n.tooltip-arrow[data-placement*='bottom'] {\n  height: 1rem;\n  left: 0;\n  margin-top: -0.4rem;\n  top: 0;\n  width: 1rem;\n}\n\n.tooltip-arrow[data-placement*='bottom']::before {\n  border-color: transparent transparent silver transparent;\n  border-width: 0 0.5rem 0.4rem 0.5rem;\n  position: absolute;\n  top: -1px;\n}\n\n.tooltip-arrow[data-placement*='bottom']::after {\n  border-color: transparent transparent white transparent;\n  border-width: 0 0.5rem 0.4rem 0.5rem;\n}\n\n.tooltip-arrow[data-placement*='top'] {\n  bottom: 0;\n  height: 1rem;\n  left: 0;\n  margin-bottom: -1rem;\n  width: 1rem;\n}\n\n.tooltip-arrow[data-placement*='top']::before {\n  border-color: silver transparent transparent transparent;\n  border-width: 0.4rem 0.5rem 0 0.5rem;\n  position: absolute;\n  top: 1px;\n}\n\n.tooltip-arrow[data-placement*='top']::after {\n  border-color: white transparent transparent transparent;\n  border-width: 0.4rem 0.5rem 0 0.5rem;\n}\n\n.tooltip-arrow[data-placement*='right'] {\n  height: 1rem;\n  left: 0;\n  margin-left: -0.7rem;\n  width: 1rem;\n}\n\n.tooltip-arrow[data-placement*='right']::before {\n  border-color: transparent silver transparent transparent;\n  border-width: 0.5rem 0.4rem 0.5rem 0;\n}\n\n.tooltip-arrow[data-placement*='right']::after {\n  border-color: transparent white transparent transparent;\n  border-width: 0.5rem 0.4rem 0.5rem 0;\n  left: 6px;\n  top: 0;\n}\n\n.tooltip-arrow[data-placement*='left'] {\n  height: 1rem;\n  margin-right: -0.7rem;\n  right: 0;\n  width: 1rem;\n}\n\n.tooltip-arrow[data-placement*='left']::before {\n  border-color: transparent transparent transparent silver;\n  border-width: 0.5rem 0 0.5rem 0.4em;\n}\n\n.tooltip-arrow[data-placement*='left']::after {\n  border-color: transparent transparent transparent white;\n  border-width: 0.5rem 0 0.5rem 0.4em;\n  left: 3px;\n  top: 0;\n}\n";
styleInject(css$1);
var classesDef = {
  type: 'Object',
  description: 'CSS in JS classes to be used to style the component. (Passed via <i>injectSheet</i> HOC).'
};
var titleDef = {
  type: 'node | string',
  description: 'Title for the chart.'
};
var languageDef = {
  type: 'string',
  description: 'Sets the main language for the component. Dates and numbers will be configured according to this locale.'
};
var orientationsDef = {
  type: 'enum',
  description: '\n    Defines the direction of the chart.\n    <ul>\n      <li>horizontal</li>\n      <li>vertical</li>\n    </ul>\n  '
};
var allocationGroupsDef = {
  type: 'enum',
  description: '\n  The allocation type to extract from <b>data</b>. Can be one of:\n    <ul>\n      <li>by_class</li>\n      <li>by_component</li>\n      <li>by_currency</li>\n      <li>by_region</li>\n      <li>by_sector</li>\n      <li>by_type</li>\n    </ul>\n  '
};
var arrayColorsDef = {
  type: 'array',
  description: 'Array of colors to be passed to use for the chart. If not passed, will use the colors defined on the theme.'
};
var colorsDef = {
  type: 'Object',
  description: '\n    Object with a defined structure to use for main styling in the component. Following keys are required (as hexadecimal colors):\n    <ul>\n      <li>primary</li>\n      <li>secondary</li>\n      <li>secondaryHover</li>\n    </ul>\n  '
};
var textColorsDef = {
  type: 'Object',
  description: '\n    Object with a defined structure to use for styling texts in the component. Following keys are required (as hexadecimal colors):\n    <ul>\n      <li>dark</li>\n      <li>light</li>\n    </ul>\n  '
};
var statusColorsDef = {
  type: 'Object',
  description: '\n    Object with a defined structure to use for styling status in the component. Following keys are required (as hexadecimal colors):\n    <ul>\n      <li>profit</li>\n      <li>loss</li>\n      <li>warning</li>\n      <li>correct</li>\n    </ul>\n  '
};
var fixedColorsDef = {
  type: 'Object',
  description: '\n    Object with a defined structure to use for styling other properties in the component. Following keys are required (as hexadecimal colors):\n    <ul>\n      <li>background</li>\n      <li>backgroundLight</li>\n      <li>divider</li>\n    </ul>\n  '
};
var chartOptionsDef = {
  type: 'Object',
  description: '\n    Object with custom configuration for Highcarts. <br />\n    The options passed here will have higher priority, and will override default properties for the chart.\n  '
};
var tooltipOptionsDef = {
  type: 'Object',
  description: '\n    Object with custom configuration for the tooltip on top. <br />\n    The following keys are supported:\n      <ul>\n        <li>tooltipColor</li>\n        <li>tooltipTextColor</li>\n      </ul>\n  '
};
var Defs = {
  classesDef: classesDef,
  titleDef: titleDef,
  languageDef: languageDef,
  orientationsDef: orientationsDef,
  allocationGroupsDef: allocationGroupsDef,
  arrayColorsDef: arrayColorsDef,
  colorsDef: colorsDef,
  textColorsDef: textColorsDef,
  statusColorsDef: statusColorsDef,
  fixedColorsDef: fixedColorsDef,
  chartOptionsDef: chartOptionsDef,
  tooltipOptionsDef: tooltipOptionsDef
};

function getColors(propColors, defaultOpts) {
  var dataLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

  if (propColors && Array.isArray(propColors)) {
    return propColors;
  }

  var smallLegend = [defaultOpts.theme.shades.secondary[2], defaultOpts.theme.tints.secondary[0], defaultOpts.theme.tints.secondary[2], defaultOpts.theme.tints.secondary[4], defaultOpts.theme.tints.secondary[6]];
  var largeLegend = [defaultOpts.theme.shades.secondary[2], defaultOpts.theme.tints.secondary[0], defaultOpts.theme.tints.secondary[2], defaultOpts.theme.tints.secondary[4], defaultOpts.theme.tints.tertiary[0], defaultOpts.theme.tints.tertiary[2], defaultOpts.theme.tints.tertiary[4], defaultOpts.theme.tints.primary[0], defaultOpts.theme.tints.primary[2], defaultOpts.theme.tints.primary[4], defaultOpts.theme.shades.secondary[4], defaultOpts.theme.tints.secondary[6], defaultOpts.theme.tints.secondary[8], defaultOpts.theme.shades.tertiary[4], defaultOpts.theme.shades.tertiary[2], defaultOpts.theme.tints.tertiary[6], defaultOpts.theme.tints.tertiary[8], defaultOpts.theme.shades.primary[4], defaultOpts.theme.shades.primary[2], defaultOpts.theme.tints.primary[6], defaultOpts.theme.tints.primary[8]];

  if (dataLength && dataLength > smallLegend.length) {
    return largeLegend;
  }

  return smallLegend;
}

function valueOrDefault(value, defaultValue) {
  return typeof value === 'undefined' || value === null ? defaultValue : value;
}

function valueAtIndexOrDefault(value, index, defaultValue) {
  return valueOrDefault(Array.isArray(value) ? value[index] : null, defaultValue);
}

function setMainLanguage(value, defaultValue) {
  return typeof value === 'undefined' || value === null || value === '' ? defaultValue : value;
}

var helpers = {
  getColors: getColors,
  valueOrDefault: valueOrDefault,
  valueAtIndexOrDefault: valueAtIndexOrDefault,
  setMainLanguage: setMainLanguage
};
var lodash_merge = createCommonjsModule(function (module, exports) {
  /**
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright JS Foundation and other contributors <https://js.foundation/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  /** Used to stand-in for `undefined` hash values. */

  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used to detect hot functions by number of calls within a span of milliseconds. */

  var HOT_COUNT = 800,
      HOT_SPAN = 16;
  /** Used as references for various `Number` constants. */

  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */

  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);

      case 1:
        return func.call(thisArg, args[0]);

      case 2:
        return func.call(thisArg, args[0], args[1]);

      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }

    return func.apply(thisArg, args);
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */


  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function safeGet(object, key) {
    return key == '__proto__' ? undefined : object[key];
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */


  var nativeObjectToString = objectProto.toString;
  /** Used to infer the `Object` constructor. */

  var objectCtorString = funcToString.call(Object);
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();
  /* Built-in method references for those with the same name as other `lodash` methods. */


  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeMax = Math.max,
      nativeNow = Date.now;
  /* Built-in method references that are verified to be native. */

  var Map = getNative(root, 'Map'),
      nativeCreate = getNative(Object, 'create');
  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */

  var baseCreate = function () {
    function object() {}

    return function (proto) {
      if (!isObject(proto)) {
        return {};
      }

      if (objectCreate) {
        return objectCreate(proto);
      }

      object.prototype = proto;
      var result = new object();
      object.prototype = undefined;
      return result;
    };
  }();
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */


  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */


  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */


  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */


  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * This function is like `assignValue` except that it doesn't assign
   * `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */


  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }
  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */


  var baseFor = createBaseFor();
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */


  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */


  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeysIn(object) {
    if (!isObject(object)) {
      return nativeKeysIn(object);
    }

    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */


  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }

    baseFor(source, function (srcValue, key) {
      if (isObject(srcValue)) {
        stack || (stack = new Stack());
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

        if (newValue === undefined) {
          newValue = srcValue;
        }

        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }
  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */


  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);

    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }

    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;

    if (isCommon) {
      var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;

      if (isArr || isBuff || isTyped) {
        if (isArray(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;

        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject(objValue) || srcIndex && isFunction(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }

    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack['delete'](srcValue);
    }

    assignMergeValue(object, key, newValue);
  }
  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */


  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }
  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */


  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };
  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */


  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */


  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */


  function copyArray(source, array) {
    var index = -1,
        length = source.length;
    array || (array = Array(length));

    while (++index < length) {
      array[index] = source[index];
    }

    return array;
  }
  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */


  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

      if (newValue === undefined) {
        newValue = source[key];
      }

      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }

    return object;
  }
  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */


  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;
      customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }

      object = Object(object);

      while (++index < length) {
        var source = sources[index];

        if (source) {
          assigner(object, source, index, customizer);
        }
      }

      return object;
    });
  }
  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */


  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];

        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }

      return object;
    };
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */


  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */


  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */


  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }

    var type = typeof index;

    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }

    return false;
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function nativeKeysIn(object) {
    var result = [];

    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */


  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */


  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }

      index = -1;
      var otherArgs = Array(start + 1);

      while (++index < start) {
        otherArgs[index] = args[index];
      }

      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }
  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */


  var setToString = shortOut(baseSetToString);
  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */

  function shortOut(func) {
    var count = 0,
        lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;

      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }

      return func.apply(undefined, arguments);
    };
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */

  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */


  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */


  var isBuffer = nativeIsBuffer || stubFalse;
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }
  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */


  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }

    var proto = getPrototype(value);

    if (proto === null) {
      return true;
    }

    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */


  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  /**
   * Converts `value` to a plain object flattening inherited enumerable string
   * keyed properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */

  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }
  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */


  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }
  /**
   * This method is like `_.assign` except that it recursively merges own and
   * inherited enumerable string keyed properties of source objects into the
   * destination object. Source properties that resolve to `undefined` are
   * skipped if a destination value exists. Array and plain object properties
   * are merged recursively. Other objects and value types are overridden by
   * assignment. Source objects are applied from left to right. Subsequent
   * sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 0.5.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = {
   *   'a': [{ 'b': 2 }, { 'd': 4 }]
   * };
   *
   * var other = {
   *   'a': [{ 'c': 3 }, { 'e': 5 }]
   * };
   *
   * _.merge(object, other);
   * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
   */


  var merge = createAssigner(function (object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */

  function constant(value) {
    return function () {
      return value;
    };
  }
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */


  function identity(value) {
    return value;
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }

  module.exports = merge;
});
/**
 * Defaults / global configuration for Fincite React Charts Library
 */

var FinciteCharts = {
  global: {
    theme: {
      main: {
        primary: defaultColors.colors.primary,
        secondary: defaultColors.colors.secondary,
        tertiary: defaultColors.colors.tertiary
      },
      tints: {
        primary: defaultColors.tints.primary,
        secondary: defaultColors.tints.secondary,
        tertiary: defaultColors.tints.tertiary
      },
      shades: {
        primary: defaultColors.shades.primary,
        secondary: defaultColors.shades.secondary,
        tertiary: defaultColors.shades.tertiary
      },
      status: {
        warning: statusColors.warning,
        loss: statusColors.loss,
        correct: statusColors.correct,
        profit: statusColors.profit
      },
      text: {
        dark: textColors.dark,
        light: textColors.light
      },
      extra: {
        background: fixedColors.background,
        backgroundLight: fixedColors.backgroundLight,
        mouseoverLightGrey: fixedColors.mouseoverLightGrey,
        lightGrey: fixedColors.lightGrey,
        disabled: fixedColors.disabled
      }
    },
    language: 'de'
  }
};

function setGlobalConfig(newConfig) {
  var primary = FinciteCharts.global.theme.main.primary;
  var secondary = FinciteCharts.global.theme.main.secondary;
  var tertiary = FinciteCharts.global.theme.main.tertiary;

  if (newConfig.theme && newConfig.theme.main) {
    primary = helpers.valueOrDefault(newConfig.theme.main.primary, primary);
    secondary = helpers.valueOrDefault(newConfig.theme.main.secondary, secondary);
    tertiary = helpers.valueOrDefault(newConfig.theme.main.tertiary, tertiary);
  }

  lodash_merge(newConfig, {
    theme: {
      tints: {
        primary: calculateTints(primary),
        secondary: calculateTints(secondary),
        tertiary: calculateTints(tertiary)
      },
      shades: {
        primary: calculateShades(primary),
        secondary: calculateShades(secondary),
        tertiary: calculateShades(tertiary)
      }
    }
  });
  lodash_merge(FinciteCharts.global, newConfig);
}

function getGlobalConfig() {
  return FinciteCharts.global;
}

function getTooltipColor() {
  var tooltipColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return helpers.valueOrDefault(tooltipColor, getGlobalConfig().theme.extra.lightGrey);
}

function getTooltipTextColor() {
  var tooltipTextColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return helpers.valueOrDefault(tooltipTextColor, getGlobalConfig().theme.text.dark);
}

var styles$3 = {
  infoTooltipContainer: {
    backgroundColor: function backgroundColor(_ref) {
      var tooltipColor = _ref.tooltipColor;
      return getTooltipColor(tooltipColor);
    },
    border: 'none',
    borderRadius: 6,
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)'
  },
  infoTooltipIcon: {
    fontSize: 20,
    color: function color(_ref2) {
      var tooltipColor = _ref2.tooltipColor;
      return getTooltipColor(tooltipColor);
    },
    cursor: 'pointer',
    alignSelf: 'flex-start'
  },
  infoTooltipArrow: {
    '&[data-placement*="top"]::before': {
      borderColor: 'transparent transparent transparent transparent'
    },
    '&[data-placement*="top"]::after': {
      borderColor: function borderColor(_ref3) {
        var tooltipColor = _ref3.tooltipColor;
        return getTooltipColor(tooltipColor) + ' transparent transparent transparent';
      }
    },
    '&[data-placement*="bottom"]::before': {
      borderColor: 'transparent transparent transparent transparent'
    },
    '&[data-placement*="bottom"]::after': {
      borderColor: function borderColor(_ref4) {
        var tooltipColor = _ref4.tooltipColor;
        return 'transparent transparent ' + getTooltipColor(tooltipColor) + ' transparent';
      }
    }
  },
  infoTooltipText: {
    position: 'relative',
    fontSize: 12,
    color: function color(_ref5) {
      var tooltipTextColor = _ref5.tooltipTextColor;
      return getTooltipTextColor(tooltipTextColor);
    },
    padding: '0 10px',
    zIndex: 1
  }
};

var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck$1 = function classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

library.add(faInfoCircle);

function Icon(_ref) {
  var getTriggerProps = _ref.getTriggerProps,
      triggerRef = _ref.triggerRef,
      classes = _ref.classes,
      className = _ref.className;
  return React__default.createElement('span', getTriggerProps({
    ref: triggerRef,
    className: '' + classnames(classes.infoTooltipIcon, 'trigger', className)
  }), React__default.createElement(FontAwesomeIcon, {
    icon: 'info-circle'
  }));
}

Icon.propTypes = {
  getTriggerProps: PropTypes.func,
  triggerRef: PropTypes.func,
  classes: PropTypes.any,
  className: PropTypes.string
};
Icon.defaultProps = {
  className: ''
};

function Tooltip$1(_ref2) {
  var getTooltipProps = _ref2.getTooltipProps,
      tooltipRef = _ref2.tooltipRef,
      getArrowProps = _ref2.getArrowProps,
      arrowRef = _ref2.arrowRef,
      placement = _ref2.placement,
      classes = _ref2.classes,
      content = _ref2.content;
  return React__default.createElement('div', getTooltipProps({
    ref: tooltipRef,
    className: '' + classnames(classes.infoTooltipContainer, 'tooltip-container')
  }), React__default.createElement('div', getArrowProps({
    ref: arrowRef,
    className: '' + classnames(classes.infoTooltipArrow, 'tooltip-arrow'),
    'data-placement': placement
  })), React__default.createElement('div', {
    className: classes.infoTooltipText
  }, content));
}

Tooltip$1.propTypes = {
  getTooltipProps: PropTypes.func,
  tooltipRef: PropTypes.func,
  classes: PropTypes.any,
  listItems: PropTypes.array
};

function InfoTooltip(props) {
  var classes = props.classes,
      errorsList = props.errorsList,
      customContent = props.customContent,
      language = props.language,
      others = objectWithoutProperties(props, ['classes', 'errorsList', 'customContent', 'language']);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);

  var tooltipContent = function tooltipContent(errorsList, customContent) {
    if (errorsList) {
      var listItems = errorsList.map(function (index) {
        if (index.isin) {
          return React__default.createElement('li', {
            key: index.isin
          }, index.isin);
        }

        return React__default.createElement('li', {
          key: index.name
        }, index.name);
      });
      return React__default.createElement(React__default.Fragment, null, locale === 'en' || locale === 'EN' ? React__default.createElement('p', null, 'For the following ', React__default.createElement('b', null, 'ISIN(s)'), ' no market data information was found:') : React__default.createElement('p', null, 'F\xFCr die folgenden ', React__default.createElement('b', null, 'ISIN(s)'), ' wurden keine Marktdateninformationen gefunden:'), React__default.createElement('ul', null, listItems));
    }

    if (customContent) {
      return customContent;
    }

    return React__default.createElement('p', null, 'No data provided.');
  };

  var StyledTooltip = function StyledTooltip(props) {
    return React__default.createElement(Tooltip$1, _extends$4({}, props, {
      classes: classes,
      content: tooltipContent(errorsList, customContent)
    }));
  };

  var StyledIcon = function StyledIcon(props) {
    return React__default.createElement(Icon, _extends$4({}, props, {
      classes: classes
    }, others));
  };

  return React__default.createElement(TooltipTrigger, {
    placement: 'bottom',
    trigger: 'hover',
    tooltip: StyledTooltip
  }, StyledIcon);
}

InfoTooltip.propTypes = {
  classes: PropTypes.shape().isRequired,
  errorsList: PropTypes.array,
  customContent: PropTypes.node,
  tooltipColor: PropTypes.string,
  tooltipTextColor: PropTypes.string,
  language: PropTypes.string
};
InfoTooltip.propDefs = {
  classes: Defs.classesDef,
  errorsList: {
    type: 'array',
    description: 'Array of objects with the list of errors to display.'
  },
  customContent: {
    type: 'node',
    description: 'React node with custom content for the tooltip.'
  },
  tooltipColor: {
    type: 'string',
    description: 'Hexadecimal color for the tooltip background and the icon.'
  },
  tooltipTextColor: {
    type: 'string',
    description: 'Hexadecimmal color for the text inside the tooltip.'
  }
};
InfoTooltip.defaultProps = {
  errorsList: null,
  tooltipColor: '#E1E3E9',
  tooltipTextColor: '#4D4F5C',
  customContent: null,
  language: ''
};
var InfoTooltip$1 = injectSheet$1(styles$3)(InfoTooltip);
var styles$4 = {
  titleContainer: {
    position: 'relative'
  },
  title: {
    fontSize: '22px',
    fontFamily: 'inherit',
    color: function color(_ref) {
      var textColors = _ref.textColors;
      return textColors.dark;
    },
    marginTop: 0,
    marginBottom: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  infoIcon: {
    position: 'absolute',
    top: -7,
    right: -12,
    display: 'inline-block',
    float: 'right'
  }
};

var ChartTitleWrapper = function ChartTitleWrapper(props) {
  var globalTheme = getGlobalConfig().theme;
  var textColors = helpers.valueOrDefault(globalTheme.text);
  return React__default.createElement(StyledChartTitle, _extends$4({
    textColors: textColors
  }, props));
};

var ChartTitle = function ChartTitle(props) {
  var classes = props.classes,
      errorsInData = props.errorsInData,
      tooltipOptions = props.tooltipOptions,
      title = props.title;
  return React__default.createElement('div', {
    className: classes.titleContainer
  }, title !== '' && React__default.createElement('p', {
    className: classes.title
  }, title), errorsInData && errorsInData.length > 0 && React__default.createElement(InfoTooltip$1, _extends$4({
    errorsList: errorsInData
  }, tooltipOptions, {
    className: classes.infoIcon
  })));
};

ChartTitle.propTypes = {
  classes: PropTypes.shape().isRequired,
  tooltipOptions: PropTypes.shape(),
  textColors: PropTypes.shape().isRequired,
  errorsInData: PropTypes.array,
  title: PropTypes.string
};
ChartTitle.defaultProps = {
  errorsInData: [],
  title: '',
  tooltipOptions: {}
};
var StyledChartTitle = injectSheet$1(styles$4)(ChartTitle);
var map = createCommonjsModule(function (module) {
  /*
   Highmaps JS v7.0.3 (2019-02-06)
   Highmaps as a plugin for Highcharts or Highstock.
  
   (c) 2011-2019 Torstein Honsi
  
   License: www.highcharts.com/license
  */
  (function (z) {
    module.exports ? (z["default"] = z, module.exports = z) : z("undefined" !== typeof Highcharts ? Highcharts : void 0);
  })(function (z) {
    (function (a) {
      var p = a.addEvent,
          h = a.Axis,
          n = a.pick;
      p(h, "getSeriesExtremes", function () {
        var a = [];
        this.isXAxis && (this.series.forEach(function (e, r) {
          e.useMapGeometry && (a[r] = e.xData, e.xData = []);
        }), this.seriesXData = a);
      });
      p(h, "afterGetSeriesExtremes", function () {
        var a = this.seriesXData,
            e,
            t,
            h;
        this.isXAxis && (e = n(this.dataMin, Number.MAX_VALUE), t = n(this.dataMax, -Number.MAX_VALUE), this.series.forEach(function (d, b) {
          d.useMapGeometry && (e = Math.min(e, n(d.minX, e)), t = Math.max(t, n(d.maxX, t)), d.xData = a[b], h = !0);
        }), h && (this.dataMin = e, this.dataMax = t), delete this.seriesXData);
      });
      p(h, "afterSetAxisTranslation", function () {
        var a = this.chart,
            e;
        e = a.plotWidth / a.plotHeight;
        var a = a.xAxis[0],
            h;
        "yAxis" === this.coll && void 0 !== a.transA && this.series.forEach(function (a) {
          a.preserveAspectRatio && (h = !0);
        });

        if (h && (this.transA = a.transA = Math.min(this.transA, a.transA), e /= (a.max - a.min) / (this.max - this.min), e = 1 > e ? this : a, a = (e.max - e.min) * e.transA, e.pixelPadding = e.len - a, e.minPixelPadding = e.pixelPadding / 2, a = e.fixTo)) {
          a = a[1] - e.toValue(a[0], !0);
          a *= e.transA;
          if (Math.abs(a) > e.minPixelPadding || e.min === e.dataMin && e.max === e.dataMax) a = 0;
          e.minPixelPadding -= a;
        }
      });
      p(h, "render", function () {
        this.fixTo = null;
      });
    })(z);

    (function (a) {
      var p = a.addEvent,
          h = a.Axis,
          n = a.Chart,
          r = a.color,
          e,
          t = a.extend,
          y = a.isNumber,
          d = a.Legend,
          b = a.LegendSymbolMixin,
          f = a.noop,
          w = a.merge,
          q = a.pick;
      a.ColorAxis || (e = a.ColorAxis = function () {
        this.init.apply(this, arguments);
      }, t(e.prototype, h.prototype), t(e.prototype, {
        defaultColorAxisOptions: {
          lineWidth: 0,
          minPadding: 0,
          maxPadding: 0,
          gridLineWidth: 1,
          tickPixelInterval: 72,
          startOnTick: !0,
          endOnTick: !0,
          offset: 0,
          marker: {
            animation: {
              duration: 50
            },
            width: .01,
            color: "#999999"
          },
          labels: {
            overflow: "justify",
            rotation: 0
          },
          minColor: "#e6ebf5",
          maxColor: "#003399",
          tickLength: 5,
          showInLegend: !0
        },
        keepProps: ["legendGroup", "legendItemHeight", "legendItemWidth", "legendItem", "legendSymbol"].concat(h.prototype.keepProps),
        init: function init(c, l) {
          var g = "vertical" !== c.options.legend.layout,
              a;
          this.coll = "colorAxis";
          a = w(this.defaultColorAxisOptions, {
            side: g ? 2 : 1,
            reversed: !g
          }, l, {
            opposite: !g,
            showEmpty: !1,
            title: null,
            visible: c.options.legend.enabled
          });
          h.prototype.init.call(this, c, a);
          l.dataClasses && this.initDataClasses(l);
          this.initStops();
          this.horiz = g;
          this.zoomEnabled = !1;
          this.defaultLegendLength = 200;
        },
        initDataClasses: function initDataClasses(c) {
          var l = this.chart,
              g,
              a = 0,
              k = l.options.chart.colorCount,
              m = this.options,
              b = c.dataClasses.length;
          this.dataClasses = g = [];
          this.legendItems = [];
          c.dataClasses.forEach(function (c, x) {
            c = w(c);
            g.push(c);
            if (l.styledMode || !c.color) "category" === m.dataClassColor ? (l.styledMode || (x = l.options.colors, k = x.length, c.color = x[a]), c.colorIndex = a, a++, a === k && (a = 0)) : c.color = r(m.minColor).tweenTo(r(m.maxColor), 2 > b ? .5 : x / (b - 1));
          });
        },
        setTickPositions: function setTickPositions() {
          if (!this.dataClasses) return h.prototype.setTickPositions.call(this);
        },
        initStops: function initStops() {
          this.stops = this.options.stops || [[0, this.options.minColor], [1, this.options.maxColor]];
          this.stops.forEach(function (c) {
            c.color = r(c[1]);
          });
        },
        setOptions: function setOptions(c) {
          h.prototype.setOptions.call(this, c);
          this.options.crosshair = this.options.marker;
        },
        setAxisSize: function setAxisSize() {
          var c = this.legendSymbol,
              l = this.chart,
              g = l.options.legend || {},
              a,
              k;
          c ? (this.left = g = c.attr("x"), this.top = a = c.attr("y"), this.width = k = c.attr("width"), this.height = c = c.attr("height"), this.right = l.chartWidth - g - k, this.bottom = l.chartHeight - a - c, this.len = this.horiz ? k : c, this.pos = this.horiz ? g : a) : this.len = (this.horiz ? g.symbolWidth : g.symbolHeight) || this.defaultLegendLength;
        },
        normalizedValue: function normalizedValue(c) {
          this.isLog && (c = this.val2lin(c));
          return 1 - (this.max - c) / (this.max - this.min || 1);
        },
        toColor: function toColor(c, l) {
          var a = this.stops,
              b,
              k,
              m = this.dataClasses,
              x,
              v;
          if (m) for (v = m.length; v--;) {
            if (x = m[v], b = x.from, a = x.to, (void 0 === b || c >= b) && (void 0 === a || c <= a)) {
              k = x.color;
              l && (l.dataClass = v, l.colorIndex = x.colorIndex);
              break;
            }
          } else {
            c = this.normalizedValue(c);

            for (v = a.length; v-- && !(c > a[v][0]);) {
              ;
            }

            b = a[v] || a[v + 1];
            a = a[v + 1] || b;
            c = 1 - (a[0] - c) / (a[0] - b[0] || 1);
            k = b.color.tweenTo(a.color, c);
          }
          return k;
        },
        getOffset: function getOffset() {
          var c = this.legendGroup,
              a = this.chart.axisOffset[this.side];
          c && (this.axisParent = c, h.prototype.getOffset.call(this), this.added || (this.added = !0, this.labelLeft = 0, this.labelRight = this.width), this.chart.axisOffset[this.side] = a);
        },
        setLegendColor: function setLegendColor() {
          var c,
              a = this.reversed;
          c = a ? 1 : 0;
          a = a ? 0 : 1;
          c = this.horiz ? [c, 0, a, 0] : [0, a, 0, c];
          this.legendColor = {
            linearGradient: {
              x1: c[0],
              y1: c[1],
              x2: c[2],
              y2: c[3]
            },
            stops: this.stops
          };
        },
        drawLegendSymbol: function drawLegendSymbol(c, a) {
          var l = c.padding,
              b = c.options,
              k = this.horiz,
              m = q(b.symbolWidth, k ? this.defaultLegendLength : 12),
              x = q(b.symbolHeight, k ? 12 : this.defaultLegendLength),
              v = q(b.labelPadding, k ? 16 : 30),
              b = q(b.itemDistance, 10);
          this.setLegendColor();
          a.legendSymbol = this.chart.renderer.rect(0, c.baseline - 11, m, x).attr({
            zIndex: 1
          }).add(a.legendGroup);
          this.legendItemWidth = m + l + (k ? b : v);
          this.legendItemHeight = x + l + (k ? v : 0);
        },
        setState: function setState(c) {
          this.series.forEach(function (a) {
            a.setState(c);
          });
        },
        visible: !0,
        setVisible: f,
        getSeriesExtremes: function getSeriesExtremes() {
          var c = this.series,
              a = c.length;
          this.dataMin = Infinity;

          for (this.dataMax = -Infinity; a--;) {
            c[a].getExtremes(), void 0 !== c[a].valueMin && (this.dataMin = Math.min(this.dataMin, c[a].valueMin), this.dataMax = Math.max(this.dataMax, c[a].valueMax));
          }
        },
        drawCrosshair: function drawCrosshair(c, a) {
          var b = a && a.plotX,
              l = a && a.plotY,
              k,
              m = this.pos,
              x = this.len;
          a && (k = this.toPixels(a[a.series.colorKey]), k < m ? k = m - 2 : k > m + x && (k = m + x + 2), a.plotX = k, a.plotY = this.len - k, h.prototype.drawCrosshair.call(this, c, a), a.plotX = b, a.plotY = l, this.cross && !this.cross.addedToColorAxis && this.legendGroup && (this.cross.addClass("highcharts-coloraxis-marker").add(this.legendGroup), this.cross.addedToColorAxis = !0, this.chart.styledMode || this.cross.attr({
            fill: this.crosshair.color
          })));
        },
        getPlotLinePath: function getPlotLinePath(c, a, b, f, k) {
          return y(k) ? this.horiz ? ["M", k - 4, this.top - 6, "L", k + 4, this.top - 6, k, this.top, "Z"] : ["M", this.left, k, "L", this.left - 6, k + 6, this.left - 6, k - 6, "Z"] : h.prototype.getPlotLinePath.call(this, c, a, b, f);
        },
        update: function update(c, a) {
          var b = this.chart,
              l = b.legend;
          this.series.forEach(function (c) {
            c.isDirtyData = !0;
          });
          c.dataClasses && l.allItems && (l.allItems.forEach(function (c) {
            c.isDataClass && c.legendGroup && c.legendGroup.destroy();
          }), b.isDirtyLegend = !0);
          b.options[this.coll] = w(this.userOptions, c);
          h.prototype.update.call(this, c, a);
          this.legendItem && (this.setLegendColor(), l.colorizeItem(this, !0));
        },
        remove: function remove() {
          this.legendItem && this.chart.legend.destroyItem(this);
          h.prototype.remove.call(this);
        },
        getDataClassLegendSymbols: function getDataClassLegendSymbols() {
          var c = this,
              l = this.chart,
              g = this.legendItems,
              d = l.options.legend,
              k = d.valueDecimals,
              m = d.valueSuffix || "",
              x;
          g.length || this.dataClasses.forEach(function (v, d) {
            var A = !0,
                e = v.from,
                u = v.to;
            x = "";
            void 0 === e ? x = "\x3c " : void 0 === u && (x = "\x3e ");
            void 0 !== e && (x += a.numberFormat(e, k) + m);
            void 0 !== e && void 0 !== u && (x += " - ");
            void 0 !== u && (x += a.numberFormat(u, k) + m);
            g.push(t({
              chart: l,
              name: x,
              options: {},
              drawLegendSymbol: b.drawRectangle,
              visible: !0,
              setState: f,
              isDataClass: !0,
              setVisible: function setVisible() {
                A = this.visible = !A;
                c.series.forEach(function (c) {
                  c.points.forEach(function (c) {
                    c.dataClass === d && c.setVisible(A);
                  });
                });
                l.legend.colorizeItem(this, A);
              }
            }, v));
          });
          return g;
        },
        name: ""
      }), ["fill", "stroke"].forEach(function (c) {
        a.Fx.prototype[c + "Setter"] = function () {
          this.elem.attr(c, r(this.start).tweenTo(r(this.end), this.pos), null, !0);
        };
      }), p(n, "afterGetAxes", function () {
        var c = this.options.colorAxis;
        this.colorAxis = [];
        c && new e(this, c);
      }), p(d, "afterGetAllItems", function (c) {
        var b = [],
            g = this.chart.colorAxis[0];
        g && g.options && g.options.showInLegend && (g.options.dataClasses ? b = g.getDataClassLegendSymbols() : b.push(g), g.series.forEach(function (b) {
          a.erase(c.allItems, b);
        }));

        for (g = b.length; g--;) {
          c.allItems.unshift(b[g]);
        }
      }), p(d, "afterColorizeItem", function (c) {
        c.visible && c.item.legendColor && c.item.legendSymbol.attr({
          fill: c.item.legendColor
        });
      }), p(d, "afterUpdate", function (c, a, b) {
        this.chart.colorAxis[0] && this.chart.colorAxis[0].update({}, b);
      }));
    })(z);

    (function (a) {
      var p = a.defined,
          h = a.noop,
          n = a.seriesTypes;
      a.colorPointMixin = {
        isValid: function isValid() {
          return null !== this.value && Infinity !== this.value && -Infinity !== this.value;
        },
        setVisible: function setVisible(a) {
          var e = this,
              r = a ? "show" : "hide";
          e.visible = !!a;
          ["graphic", "dataLabel"].forEach(function (a) {
            if (e[a]) e[a][r]();
          });
        },
        setState: function setState(r) {
          a.Point.prototype.setState.call(this, r);
          this.graphic && this.graphic.attr({
            zIndex: "hover" === r ? 1 : 0
          });
        }
      };
      a.colorSeriesMixin = {
        pointArrayMap: ["value"],
        axisTypes: ["xAxis", "yAxis", "colorAxis"],
        optionalAxis: "colorAxis",
        trackerGroups: ["group", "markerGroup", "dataLabelsGroup"],
        getSymbol: h,
        parallelArrays: ["x", "y", "value"],
        colorKey: "value",
        pointAttribs: n.column.prototype.pointAttribs,
        translateColors: function translateColors() {
          var a = this,
              e = this.options.nullColor,
              h = this.colorAxis,
              n = this.colorKey;
          this.data.forEach(function (d) {
            var b = d[n];
            if (b = d.options.color || (d.isNull ? e : h && void 0 !== b ? h.toColor(b, d) : d.color || a.color)) d.color = b;
          });
        },
        colorAttribs: function colorAttribs(a) {
          var e = {};
          p(a.color) && (e[this.colorProp || "fill"] = a.color);
          return e;
        }
      };
    })(z);

    (function (a) {
      function p(a) {
        a && (a.preventDefault && a.preventDefault(), a.stopPropagation && a.stopPropagation(), a.cancelBubble = !0);
      }

      function h(a) {
        this.init(a);
      }

      var n = a.addEvent,
          r = a.Chart,
          e = a.doc,
          t = a.extend,
          y = a.merge,
          d = a.pick;

      h.prototype.init = function (a) {
        this.chart = a;
        a.mapNavButtons = [];
      };

      h.prototype.update = function (b) {
        var f = this.chart,
            e = f.options.mapNavigation,
            q,
            c,
            l,
            g,
            u,
            k = function k(c) {
          this.handler.call(f, c);
          p(c);
        },
            m = f.mapNavButtons;

        b && (e = f.options.mapNavigation = y(f.options.mapNavigation, b));

        for (; m.length;) {
          m.pop().destroy();
        }

        d(e.enableButtons, e.enabled) && !f.renderer.forExport && a.objectEach(e.buttons, function (a, b) {
          q = y(e.buttonOptions, a);
          f.styledMode || (c = q.theme, c.style = y(q.theme.style, q.style), g = (l = c.states) && l.hover, u = l && l.select);
          a = f.renderer.button(q.text, 0, 0, k, c, g, u, 0, "zoomIn" === b ? "topbutton" : "bottombutton").addClass("highcharts-map-navigation highcharts-" + {
            zoomIn: "zoom-in",
            zoomOut: "zoom-out"
          }[b]).attr({
            width: q.width,
            height: q.height,
            title: f.options.lang[b],
            padding: q.padding,
            zIndex: 5
          }).add();
          a.handler = q.onclick;
          a.align(t(q, {
            width: a.width,
            height: 2 * a.height
          }), null, q.alignTo);
          n(a.element, "dblclick", p);
          m.push(a);
        });
        this.updateEvents(e);
      };

      h.prototype.updateEvents = function (a) {
        var b = this.chart;
        d(a.enableDoubleClickZoom, a.enabled) || a.enableDoubleClickZoomTo ? this.unbindDblClick = this.unbindDblClick || n(b.container, "dblclick", function (a) {
          b.pointer.onContainerDblClick(a);
        }) : this.unbindDblClick && (this.unbindDblClick = this.unbindDblClick());
        d(a.enableMouseWheelZoom, a.enabled) ? this.unbindMouseWheel = this.unbindMouseWheel || n(b.container, void 0 === e.onmousewheel ? "DOMMouseScroll" : "mousewheel", function (a) {
          b.pointer.onContainerMouseWheel(a);
          p(a);
          return !1;
        }) : this.unbindMouseWheel && (this.unbindMouseWheel = this.unbindMouseWheel());
      };

      t(r.prototype, {
        fitToBox: function fitToBox(a, f) {
          [["x", "width"], ["y", "height"]].forEach(function (b) {
            var d = b[0];
            b = b[1];
            a[d] + a[b] > f[d] + f[b] && (a[b] > f[b] ? (a[b] = f[b], a[d] = f[d]) : a[d] = f[d] + f[b] - a[b]);
            a[b] > f[b] && (a[b] = f[b]);
            a[d] < f[d] && (a[d] = f[d]);
          });
          return a;
        },
        mapZoom: function mapZoom(a, f, e, r, c) {
          var b = this.xAxis[0],
              g = b.max - b.min,
              u = d(f, b.min + g / 2),
              k = g * a,
              g = this.yAxis[0],
              m = g.max - g.min,
              x = d(e, g.min + m / 2),
              m = m * a,
              u = this.fitToBox({
            x: u - k * (r ? (r - b.pos) / b.len : .5),
            y: x - m * (c ? (c - g.pos) / g.len : .5),
            width: k,
            height: m
          }, {
            x: b.dataMin,
            y: g.dataMin,
            width: b.dataMax - b.dataMin,
            height: g.dataMax - g.dataMin
          }),
              k = u.x <= b.dataMin && u.width >= b.dataMax - b.dataMin && u.y <= g.dataMin && u.height >= g.dataMax - g.dataMin;
          r && (b.fixTo = [r - b.pos, f]);
          c && (g.fixTo = [c - g.pos, e]);
          void 0 === a || k ? (b.setExtremes(void 0, void 0, !1), g.setExtremes(void 0, void 0, !1)) : (b.setExtremes(u.x, u.x + u.width, !1), g.setExtremes(u.y, u.y + u.height, !1));
          this.redraw();
        }
      });
      n(r, "beforeRender", function () {
        this.mapNavigation = new h(this);
        this.mapNavigation.update();
      });
      a.MapNavigation = h;
    })(z);

    (function (a) {
      var p = a.extend,
          h = a.pick,
          n = a.Pointer;
      a = a.wrap;
      p(n.prototype, {
        onContainerDblClick: function onContainerDblClick(a) {
          var e = this.chart;
          a = this.normalize(a);
          e.options.mapNavigation.enableDoubleClickZoomTo ? e.pointer.inClass(a.target, "highcharts-tracker") && e.hoverPoint && e.hoverPoint.zoomTo() : e.isInsidePlot(a.chartX - e.plotLeft, a.chartY - e.plotTop) && e.mapZoom(.5, e.xAxis[0].toValue(a.chartX), e.yAxis[0].toValue(a.chartY), a.chartX, a.chartY);
        },
        onContainerMouseWheel: function onContainerMouseWheel(a) {
          var e = this.chart,
              h;
          a = this.normalize(a);
          h = a.detail || -(a.wheelDelta / 120);
          e.isInsidePlot(a.chartX - e.plotLeft, a.chartY - e.plotTop) && e.mapZoom(Math.pow(e.options.mapNavigation.mouseWheelSensitivity, h), e.xAxis[0].toValue(a.chartX), e.yAxis[0].toValue(a.chartY), a.chartX, a.chartY);
        }
      });
      a(n.prototype, "zoomOption", function (a) {
        var e = this.chart.options.mapNavigation;
        h(e.enableTouchZoom, e.enabled) && (this.chart.options.chart.pinchType = "xy");
        a.apply(this, [].slice.call(arguments, 1));
      });
      a(n.prototype, "pinchTranslate", function (a, e, h, n, d, b, f) {
        a.call(this, e, h, n, d, b, f);
        "map" === this.chart.options.chart.type && this.hasZoom && (a = n.scaleX > n.scaleY, this.pinchTranslateDirection(!a, e, h, n, d, b, f, a ? n.scaleX : n.scaleY));
      });
    })(z);

    (function (a) {
      var p = a.colorPointMixin,
          h = a.extend,
          n = a.isNumber,
          r = a.merge,
          e = a.noop,
          t = a.pick,
          y = a.isArray,
          d = a.Point,
          b = a.Series,
          f = a.seriesType,
          w = a.seriesTypes,
          q = a.splat;
      f("map", "scatter", {
        animation: !1,
        dataLabels: {
          crop: !1,
          formatter: function formatter() {
            return this.point.value;
          },
          inside: !0,
          overflow: !1,
          padding: 0,
          verticalAlign: "middle"
        },
        marker: null,
        nullColor: "#f7f7f7",
        stickyTracking: !1,
        tooltip: {
          followPointer: !0,
          pointFormat: "{point.name}: {point.value}\x3cbr/\x3e"
        },
        turboThreshold: 0,
        allAreas: !0,
        borderColor: "#cccccc",
        borderWidth: 1,
        joinBy: "hc-key",
        states: {
          hover: {
            halo: null,
            brightness: .2
          },
          normal: {
            animation: !0
          },
          select: {
            color: "#cccccc"
          }
        }
      }, r(a.colorSeriesMixin, {
        type: "map",
        getExtremesFromAll: !0,
        useMapGeometry: !0,
        forceDL: !0,
        searchPoint: e,
        directTouch: !0,
        preserveAspectRatio: !0,
        pointArrayMap: ["value"],
        getBox: function getBox(c) {
          var b = Number.MAX_VALUE,
              g = -b,
              d = b,
              k = -b,
              m = b,
              x = b,
              v = this.xAxis,
              f = this.yAxis,
              e;
          (c || []).forEach(function (c) {
            if (c.path) {
              "string" === typeof c.path && (c.path = a.splitPath(c.path));
              var l = c.path || [],
                  f = l.length,
                  v = !1,
                  A = -b,
                  u = b,
                  h = -b,
                  q = b,
                  w = c.properties;

              if (!c._foundBox) {
                for (; f--;) {
                  n(l[f]) && (v ? (A = Math.max(A, l[f]), u = Math.min(u, l[f])) : (h = Math.max(h, l[f]), q = Math.min(q, l[f])), v = !v);
                }

                c._midX = u + (A - u) * t(c.middleX, w && w["hc-middle-x"], .5);
                c._midY = q + (h - q) * t(c.middleY, w && w["hc-middle-y"], .5);
                c._maxX = A;
                c._minX = u;
                c._maxY = h;
                c._minY = q;
                c.labelrank = t(c.labelrank, (A - u) * (h - q));
                c._foundBox = !0;
              }

              g = Math.max(g, c._maxX);
              d = Math.min(d, c._minX);
              k = Math.max(k, c._maxY);
              m = Math.min(m, c._minY);
              x = Math.min(c._maxX - c._minX, c._maxY - c._minY, x);
              e = !0;
            }
          });
          e && (this.minY = Math.min(m, t(this.minY, b)), this.maxY = Math.max(k, t(this.maxY, -b)), this.minX = Math.min(d, t(this.minX, b)), this.maxX = Math.max(g, t(this.maxX, -b)), v && void 0 === v.options.minRange && (v.minRange = Math.min(5 * x, (this.maxX - this.minX) / 5, v.minRange || b)), f && void 0 === f.options.minRange && (f.minRange = Math.min(5 * x, (this.maxY - this.minY) / 5, f.minRange || b)));
        },
        getExtremes: function getExtremes() {
          b.prototype.getExtremes.call(this, this.valueData);
          this.chart.hasRendered && this.isDirtyData && this.getBox(this.options.data);
          this.valueMin = this.dataMin;
          this.valueMax = this.dataMax;
          this.dataMin = this.minY;
          this.dataMax = this.maxY;
        },
        translatePath: function translatePath(a) {
          var c = !1,
              b = this.xAxis,
              f = this.yAxis,
              k = b.min,
              m = b.transA,
              b = b.minPixelPadding,
              x = f.min,
              v = f.transA,
              f = f.minPixelPadding,
              d,
              e = [];
          if (a) for (d = a.length; d--;) {
            n(a[d]) ? (e[d] = c ? (a[d] - k) * m + b : (a[d] - x) * v + f, c = !c) : e[d] = a[d];
          }
          return e;
        },
        setData: function setData(c, l, g, f) {
          var k = this.options,
              m = this.chart.options.chart,
              d = m && m.map,
              v = k.mapData,
              e = k.joinBy,
              u = null === e,
              h = k.keys || this.pointArrayMap,
              w = [],
              t = {},
              p = this.chart.mapTransforms;
          !v && d && (v = "string" === typeof d ? a.maps[d] : d);
          u && (e = "_i");
          e = this.joinBy = q(e);
          e[1] || (e[1] = e[0]);
          c && c.forEach(function (b, m) {
            var g = 0;
            if (n(b)) c[m] = {
              value: b
            };else if (y(b)) {
              c[m] = {};
              !k.keys && b.length > h.length && "string" === typeof b[0] && (c[m]["hc-key"] = b[0], ++g);

              for (var d = 0; d < h.length; ++d, ++g) {
                h[d] && void 0 !== b[g] && (0 < h[d].indexOf(".") ? a.Point.prototype.setNestedProperty(c[m], b[g], h[d]) : c[m][h[d]] = b[g]);
              }
            }
            u && (c[m]._i = m);
          });
          this.getBox(c);
          (this.chart.mapTransforms = p = m && m.mapTransforms || v && v["hc-transform"] || p) && a.objectEach(p, function (a) {
            a.rotation && (a.cosAngle = Math.cos(a.rotation), a.sinAngle = Math.sin(a.rotation));
          });

          if (v) {
            "FeatureCollection" === v.type && (this.mapTitle = v.title, v = a.geojson(v, this.type, this));
            this.mapData = v;
            this.mapMap = {};

            for (p = 0; p < v.length; p++) {
              m = v[p], d = m.properties, m._i = p, e[0] && d && d[e[0]] && (m[e[0]] = d[e[0]]), t[m[e[0]]] = m;
            }

            this.mapMap = t;
            c && e[1] && c.forEach(function (a) {
              t[a[e[1]]] && w.push(t[a[e[1]]]);
            });
            k.allAreas ? (this.getBox(v), c = c || [], e[1] && c.forEach(function (a) {
              w.push(a[e[1]]);
            }), w = "|" + w.map(function (a) {
              return a && a[e[0]];
            }).join("|") + "|", v.forEach(function (a) {
              e[0] && -1 !== w.indexOf("|" + a[e[0]] + "|") || (c.push(r(a, {
                value: null
              })), f = !1);
            })) : this.getBox(w);
          }

          b.prototype.setData.call(this, c, l, g, f);
        },
        drawGraph: e,
        drawDataLabels: e,
        doFullTranslate: function doFullTranslate() {
          return this.isDirtyData || this.chart.isResizing || this.chart.renderer.isVML || !this.baseTrans;
        },
        translate: function translate() {
          var a = this,
              b = a.xAxis,
              g = a.yAxis,
              d = a.doFullTranslate();
          a.generatePoints();
          a.data.forEach(function (c) {
            c.plotX = b.toPixels(c._midX, !0);
            c.plotY = g.toPixels(c._midY, !0);
            d && (c.shapeType = "path", c.shapeArgs = {
              d: a.translatePath(c.path)
            });
          });
          a.translateColors();
        },
        pointAttribs: function pointAttribs(a, b) {
          b = a.series.chart.styledMode ? this.colorAttribs(a) : w.column.prototype.pointAttribs.call(this, a, b);
          b["stroke-width"] = t(a.options[this.pointAttrToOptions && this.pointAttrToOptions["stroke-width"] || "borderWidth"], "inherit");
          return b;
        },
        drawPoints: function drawPoints() {
          var a = this,
              b = a.xAxis,
              g = a.yAxis,
              d = a.group,
              k = a.chart,
              m = k.renderer,
              f,
              e,
              h,
              q,
              n = this.baseTrans,
              p,
              r,
              t,
              y,
              G;
          a.transformGroup || (a.transformGroup = m.g().attr({
            scaleX: 1,
            scaleY: 1
          }).add(d), a.transformGroup.survive = !0);
          a.doFullTranslate() ? (k.hasRendered && !k.styledMode && a.points.forEach(function (c) {
            c.shapeArgs && (c.shapeArgs.fill = a.pointAttribs(c, c.state).fill);
          }), a.group = a.transformGroup, w.column.prototype.drawPoints.apply(a), a.group = d, a.points.forEach(function (c) {
            c.graphic && (c.name && c.graphic.addClass("highcharts-name-" + c.name.replace(/ /g, "-").toLowerCase()), c.properties && c.properties["hc-key"] && c.graphic.addClass("highcharts-key-" + c.properties["hc-key"].toLowerCase()), k.styledMode && c.graphic.css(a.pointAttribs(c, c.selected && "select")));
          }), this.baseTrans = {
            originX: b.min - b.minPixelPadding / b.transA,
            originY: g.min - g.minPixelPadding / g.transA + (g.reversed ? 0 : g.len / g.transA),
            transAX: b.transA,
            transAY: g.transA
          }, this.transformGroup.animate({
            translateX: 0,
            translateY: 0,
            scaleX: 1,
            scaleY: 1
          })) : (f = b.transA / n.transAX, e = g.transA / n.transAY, h = b.toPixels(n.originX, !0), q = g.toPixels(n.originY, !0), .99 < f && 1.01 > f && .99 < e && 1.01 > e && (e = f = 1, h = Math.round(h), q = Math.round(q)), p = this.transformGroup, k.renderer.globalAnimation ? (r = p.attr("translateX"), t = p.attr("translateY"), y = p.attr("scaleX"), G = p.attr("scaleY"), p.attr({
            animator: 0
          }).animate({
            animator: 1
          }, {
            step: function step(a, c) {
              p.attr({
                translateX: r + (h - r) * c.pos,
                translateY: t + (q - t) * c.pos,
                scaleX: y + (f - y) * c.pos,
                scaleY: G + (e - G) * c.pos
              });
            }
          })) : p.attr({
            translateX: h,
            translateY: q,
            scaleX: f,
            scaleY: e
          }));
          k.styledMode || d.element.setAttribute("stroke-width", (a.options[a.pointAttrToOptions && a.pointAttrToOptions["stroke-width"] || "borderWidth"] || 1) / (f || 1));
          this.drawMapDataLabels();
        },
        drawMapDataLabels: function drawMapDataLabels() {
          b.prototype.drawDataLabels.call(this);
          this.dataLabelsGroup && this.dataLabelsGroup.clip(this.chart.clipRect);
        },
        render: function render() {
          var a = this,
              d = b.prototype.render;
          a.chart.renderer.isVML && 3E3 < a.data.length ? setTimeout(function () {
            d.call(a);
          }) : d.call(a);
        },
        animate: function animate(a) {
          var c = this.options.animation,
              b = this.group,
              d = this.xAxis,
              k = this.yAxis,
              m = d.pos,
              f = k.pos;
          this.chart.renderer.isSVG && (!0 === c && (c = {
            duration: 1E3
          }), a ? b.attr({
            translateX: m + d.len / 2,
            translateY: f + k.len / 2,
            scaleX: .001,
            scaleY: .001
          }) : (b.animate({
            translateX: m,
            translateY: f,
            scaleX: 1,
            scaleY: 1
          }, c), this.animate = null));
        },
        animateDrilldown: function animateDrilldown(a) {
          var c = this.chart.plotBox,
              b = this.chart.drilldownLevels[this.chart.drilldownLevels.length - 1],
              d = b.bBox,
              k = this.chart.options.drilldown.animation;
          a || (a = Math.min(d.width / c.width, d.height / c.height), b.shapeArgs = {
            scaleX: a,
            scaleY: a,
            translateX: d.x,
            translateY: d.y
          }, this.points.forEach(function (a) {
            a.graphic && a.graphic.attr(b.shapeArgs).animate({
              scaleX: 1,
              scaleY: 1,
              translateX: 0,
              translateY: 0
            }, k);
          }), this.animate = null);
        },
        drawLegendSymbol: a.LegendSymbolMixin.drawRectangle,
        animateDrillupFrom: function animateDrillupFrom(a) {
          w.column.prototype.animateDrillupFrom.call(this, a);
        },
        animateDrillupTo: function animateDrillupTo(a) {
          w.column.prototype.animateDrillupTo.call(this, a);
        }
      }), h({
        applyOptions: function applyOptions(a, b) {
          a = d.prototype.applyOptions.call(this, a, b);
          b = this.series;
          var c = b.joinBy;
          b.mapData && ((c = void 0 !== a[c[1]] && b.mapMap[a[c[1]]]) ? (b.xyFromShape && (a.x = c._midX, a.y = c._midY), h(a, c)) : a.value = a.value || null);
          return a;
        },
        onMouseOver: function onMouseOver(c) {
          a.clearTimeout(this.colorInterval);
          if (null !== this.value || this.series.options.nullInteraction) d.prototype.onMouseOver.call(this, c);else this.series.onMouseOut(c);
        },
        zoomTo: function zoomTo() {
          var a = this.series;
          a.xAxis.setExtremes(this._minX, this._maxX, !1);
          a.yAxis.setExtremes(this._minY, this._maxY, !1);
          a.chart.redraw();
        }
      }, p));
    })(z);

    (function (a) {
      var p = a.seriesType,
          h = a.seriesTypes;
      p("mapline", "map", {
        lineWidth: 1,
        fillColor: "none"
      }, {
        type: "mapline",
        colorProp: "stroke",
        pointAttrToOptions: {
          stroke: "color",
          "stroke-width": "lineWidth"
        },
        pointAttribs: function pointAttribs(a, p) {
          a = h.map.prototype.pointAttribs.call(this, a, p);
          a.fill = this.options.fillColor;
          return a;
        },
        drawLegendSymbol: h.line.prototype.drawLegendSymbol
      });
    })(z);

    (function (a) {
      var p = a.merge,
          h = a.Point;
      a = a.seriesType;
      a("mappoint", "scatter", {
        dataLabels: {
          enabled: !0,
          formatter: function formatter() {
            return this.point.name;
          },
          crop: !1,
          defer: !1,
          overflow: !1,
          style: {
            color: "#000000"
          }
        }
      }, {
        type: "mappoint",
        forceDL: !0
      }, {
        applyOptions: function applyOptions(a, r) {
          a = void 0 !== a.lat && void 0 !== a.lon ? p(a, this.series.chart.fromLatLonToPoint(a)) : a;
          return h.prototype.applyOptions.call(this, a, r);
        }
      });
    })(z);

    (function (a) {
      var p = a.Series,
          h = a.Legend,
          n = a.Chart,
          r = a.addEvent,
          e = a.wrap,
          t = a.color,
          y = a.isNumber,
          d = a.numberFormat,
          b = a.objectEach,
          f = a.merge,
          w = a.noop,
          q = a.pick,
          c = a.stableSort,
          l = a.setOptions,
          g = a.arrayMin,
          u = a.arrayMax;
      l({
        legend: {
          bubbleLegend: {
            borderColor: void 0,
            borderWidth: 2,
            className: void 0,
            color: void 0,
            connectorClassName: void 0,
            connectorColor: void 0,
            connectorDistance: 60,
            connectorWidth: 1,
            enabled: !1,
            labels: {
              className: void 0,
              allowOverlap: !1,
              format: "",
              formatter: void 0,
              align: "right",
              style: {
                fontSize: 10,
                color: void 0
              },
              x: 0,
              y: 0
            },
            maxSize: 60,
            minSize: 10,
            legendIndex: 0,
            ranges: {
              value: void 0,
              borderColor: void 0,
              color: void 0,
              connectorColor: void 0
            },
            sizeBy: "area",
            sizeByAbsoluteValue: !1,
            zIndex: 1,
            zThreshold: 0
          }
        }
      });

      a.BubbleLegend = function (a, c) {
        this.init(a, c);
      };

      a.BubbleLegend.prototype = {
        init: function init(a, c) {
          this.options = a;
          this.visible = !0;
          this.chart = c.chart;
          this.legend = c;
        },
        setState: w,
        addToLegend: function addToLegend(a) {
          a.splice(this.options.legendIndex, 0, this);
        },
        drawLegendSymbol: function drawLegendSymbol(a) {
          var b = this.chart,
              k = this.options,
              d = q(a.options.itemDistance, 20),
              f,
              g = k.ranges;
          f = k.connectorDistance;
          this.fontMetrics = b.renderer.fontMetrics(k.labels.style.fontSize.toString() + "px");
          g && g.length && y(g[0].value) ? (c(g, function (a, c) {
            return c.value - a.value;
          }), this.ranges = g, this.setOptions(), this.render(), b = this.getMaxLabelSize(), g = this.ranges[0].radius, a = 2 * g, f = f - g + b.width, f = 0 < f ? f : 0, this.maxLabel = b, this.movementX = "left" === k.labels.align ? f : 0, this.legendItemWidth = a + f + d, this.legendItemHeight = a + this.fontMetrics.h / 2) : a.options.bubbleLegend.autoRanges = !0;
        },
        setOptions: function setOptions() {
          var a = this,
              c = a.ranges,
              b = a.options,
              d = a.chart.series[b.seriesIndex],
              g = a.legend.baseline,
              e = {
            "z-index": b.zIndex,
            "stroke-width": b.borderWidth
          },
              l = {
            "z-index": b.zIndex,
            "stroke-width": b.connectorWidth
          },
              h = a.getLabelStyles(),
              u = d.options.marker.fillOpacity,
              w = a.chart.styledMode;
          c.forEach(function (k, m) {
            w || (e.stroke = q(k.borderColor, b.borderColor, d.color), e.fill = q(k.color, b.color, 1 !== u ? t(d.color).setOpacity(u).get("rgba") : d.color), l.stroke = q(k.connectorColor, b.connectorColor, d.color));
            c[m].radius = a.getRangeRadius(k.value);
            c[m] = f(c[m], {
              center: c[0].radius - c[m].radius + g
            });
            w || f(!0, c[m], {
              bubbleStyle: f(!1, e),
              connectorStyle: f(!1, l),
              labelStyle: h
            });
          });
        },
        getLabelStyles: function getLabelStyles() {
          var a = this.options,
              c = {},
              d = "left" === a.labels.align,
              g = this.legend.options.rtl;
          b(a.labels.style, function (a, b) {
            "color" !== b && "fontSize" !== b && "z-index" !== b && (c[b] = a);
          });
          return f(!1, c, {
            "font-size": a.labels.style.fontSize,
            fill: q(a.labels.style.color, "#000000"),
            "z-index": a.zIndex,
            align: g || d ? "right" : "left"
          });
        },
        getRangeRadius: function getRangeRadius(a) {
          var c = this.options;
          return this.chart.series[this.options.seriesIndex].getRadius.call(this, c.ranges[c.ranges.length - 1].value, c.ranges[0].value, c.minSize, c.maxSize, a);
        },
        render: function render() {
          var a = this,
              c = a.chart.renderer,
              b = a.options.zThreshold;
          a.symbols || (a.symbols = {
            connectors: [],
            bubbleItems: [],
            labels: []
          });
          a.legendSymbol = c.g("bubble-legend");
          a.legendItem = c.g("bubble-legend-item");
          a.legendSymbol.translateX = 0;
          a.legendSymbol.translateY = 0;
          a.ranges.forEach(function (c) {
            c.value >= b && a.renderRange(c);
          });
          a.legendSymbol.add(a.legendItem);
          a.legendItem.add(a.legendGroup);
          a.hideOverlappingLabels();
        },
        renderRange: function renderRange(a) {
          var c = this.options,
              b = c.labels,
              d = this.chart.renderer,
              k = this.symbols,
              g = k.labels,
              f = a.center,
              e = Math.abs(a.radius),
              l = c.connectorDistance,
              h = b.align,
              u = b.style.fontSize,
              l = this.legend.options.rtl || "left" === h ? -l : l,
              b = c.connectorWidth,
              w = this.ranges[0].radius,
              q = f - e - c.borderWidth / 2 + b / 2,
              p,
              u = u / 2 - (this.fontMetrics.h - u) / 2,
              n = d.styledMode;
          "center" === h && (l = 0, c.connectorDistance = 0, a.labelStyle.align = "center");
          h = q + c.labels.y;
          p = w + l + c.labels.x;
          k.bubbleItems.push(d.circle(w, f + ((q % 1 ? 1 : .5) - (b % 2 ? 0 : .5)), e).attr(n ? {} : a.bubbleStyle).addClass((n ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-symbol " + (c.className || "")).add(this.legendSymbol));
          k.connectors.push(d.path(d.crispLine(["M", w, q, "L", w + l, q], c.connectorWidth)).attr(n ? {} : a.connectorStyle).addClass((n ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (c.connectorClassName || "")).add(this.legendSymbol));
          a = d.text(this.formatLabel(a), p, h + u).attr(n ? {} : a.labelStyle).addClass("highcharts-bubble-legend-labels " + (c.labels.className || "")).add(this.legendSymbol);
          g.push(a);
          a.placed = !0;
          a.alignAttr = {
            x: p,
            y: h + u
          };
        },
        getMaxLabelSize: function getMaxLabelSize() {
          var a, c;
          this.symbols.labels.forEach(function (b) {
            c = b.getBBox(!0);
            a = a ? c.width > a.width ? c : a : c;
          });
          return a || {};
        },
        formatLabel: function formatLabel(c) {
          var b = this.options,
              g = b.labels.formatter;
          return (b = b.labels.format) ? a.format(b, c) : g ? g.call(c) : d(c.value, 1);
        },
        hideOverlappingLabels: function hideOverlappingLabels() {
          var a = this.chart,
              c = this.symbols;
          !this.options.labels.allowOverlap && c && (a.hideOverlappingLabels(c.labels), c.labels.forEach(function (a, b) {
            a.newOpacity ? a.newOpacity !== a.oldOpacity && c.connectors[b].show() : c.connectors[b].hide();
          }));
        },
        getRanges: function getRanges() {
          var a = this.legend.bubbleLegend,
              c,
              b = a.options.ranges,
              d,
              e = Number.MAX_VALUE,
              l = -Number.MAX_VALUE;
          a.chart.series.forEach(function (a) {
            a.isBubble && !a.ignoreSeries && (d = a.zData.filter(y), d.length && (e = q(a.options.zMin, Math.min(e, Math.max(g(d), !1 === a.options.displayNegative ? a.options.zThreshold : -Number.MAX_VALUE))), l = q(a.options.zMax, Math.max(l, u(d)))));
          });
          c = e === l ? [{
            value: l
          }] : [{
            value: e
          }, {
            value: (e + l) / 2
          }, {
            value: l,
            autoRanges: !0
          }];
          b.length && b[0].radius && c.reverse();
          c.forEach(function (a, d) {
            b && b[d] && (c[d] = f(!1, b[d], a));
          });
          return c;
        },
        predictBubbleSizes: function predictBubbleSizes() {
          var a = this.chart,
              c = this.fontMetrics,
              b = a.legend.options,
              d = "horizontal" === b.layout,
              g = d ? a.legend.lastLineHeight : 0,
              f = a.plotSizeX,
              e = a.plotSizeY,
              l = a.series[this.options.seriesIndex],
              a = Math.ceil(l.minPxSize),
              h = Math.ceil(l.maxPxSize),
              l = l.options.maxSize,
              u = Math.min(e, f);
          if (b.floating || !/%$/.test(l)) c = h;else if (l = parseFloat(l), c = (u + g - c.h / 2) * l / 100 / (l / 100 + 1), d && e - c >= f || !d && f - c >= e) c = h;
          return [a, Math.ceil(c)];
        },
        updateRanges: function updateRanges(a, c) {
          var b = this.legend.options.bubbleLegend;
          b.minSize = a;
          b.maxSize = c;
          b.ranges = this.getRanges();
        },
        correctSizes: function correctSizes() {
          var a = this.legend,
              c = this.chart.series[this.options.seriesIndex];
          1 < Math.abs(Math.ceil(c.maxPxSize) - this.options.maxSize) && (this.updateRanges(this.options.minSize, c.maxPxSize), a.render());
        }
      };
      r(a.Legend, "afterGetAllItems", function (c) {
        var b = this.bubbleLegend,
            d = this.options,
            g = d.bubbleLegend,
            f = this.chart.getVisibleBubbleSeriesIndex();
        b && b.ranges && b.ranges.length && (g.ranges.length && (g.autoRanges = !!g.ranges[0].autoRanges), this.destroyItem(b));
        0 <= f && d.enabled && g.enabled && (g.seriesIndex = f, this.bubbleLegend = new a.BubbleLegend(g, this), this.bubbleLegend.addToLegend(c.allItems));
      });

      n.prototype.getVisibleBubbleSeriesIndex = function () {
        for (var a = this.series, c = 0; c < a.length;) {
          if (a[c] && a[c].isBubble && a[c].visible && a[c].zData.length) return c;
          c++;
        }

        return -1;
      };

      h.prototype.getLinesHeights = function () {
        var a = this.allItems,
            c = [],
            b,
            d = a.length,
            g,
            f = 0;

        for (g = 0; g < d; g++) {
          if (a[g].legendItemHeight && (a[g].itemHeight = a[g].legendItemHeight), a[g] === a[d - 1] || a[g + 1] && a[g]._legendItemPos[1] !== a[g + 1]._legendItemPos[1]) {
            c.push({
              height: 0
            });
            b = c[c.length - 1];

            for (f; f <= g; f++) {
              a[f].itemHeight > b.height && (b.height = a[f].itemHeight);
            }

            b.step = g;
          }
        }

        return c;
      };

      h.prototype.retranslateItems = function (a) {
        var c,
            b,
            d,
            g = this.options.rtl,
            f = 0;
        this.allItems.forEach(function (e, l) {
          c = e.legendGroup.translateX;
          b = e._legendItemPos[1];
          if ((d = e.movementX) || g && e.ranges) d = g ? c - e.options.maxSize / 2 : c + d, e.legendGroup.attr({
            translateX: d
          });
          l > a[f].step && f++;
          e.legendGroup.attr({
            translateY: Math.round(b + a[f].height / 2)
          });
          e._legendItemPos[1] = b + a[f].height / 2;
        });
      };

      r(p, "legendItemClick", function () {
        var a = this.chart,
            c = this.visible,
            b = this.chart.legend;
        b && b.bubbleLegend && (this.visible = !c, this.ignoreSeries = c, a = 0 <= a.getVisibleBubbleSeriesIndex(), b.bubbleLegend.visible !== a && (b.update({
          bubbleLegend: {
            enabled: a
          }
        }), b.bubbleLegend.visible = a), this.visible = c);
      });
      e(n.prototype, "drawChartBox", function (a, c, d) {
        var g = this.legend,
            f = 0 <= this.getVisibleBubbleSeriesIndex(),
            e;
        g && g.options.enabled && g.bubbleLegend && g.options.bubbleLegend.autoRanges && f ? (e = g.bubbleLegend.options, f = g.bubbleLegend.predictBubbleSizes(), g.bubbleLegend.updateRanges(f[0], f[1]), e.placed || (g.group.placed = !1, g.allItems.forEach(function (a) {
          a.legendGroup.translateY = null;
        })), g.render(), this.getMargins(), this.axes.forEach(function (a) {
          a.render();
          e.placed || (a.setScale(), a.updateNames(), b(a.ticks, function (a) {
            a.isNew = !0;
            a.isNewLabel = !0;
          }));
        }), e.placed = !0, this.getMargins(), a.call(this, c, d), g.bubbleLegend.correctSizes(), g.retranslateItems(g.getLinesHeights())) : (a.call(this, c, d), g && g.options.enabled && g.bubbleLegend && (g.render(), g.retranslateItems(g.getLinesHeights())));
      });
    })(z);

    (function (a) {
      var p = a.arrayMax,
          h = a.arrayMin,
          n = a.Axis,
          r = a.color,
          e = a.isNumber,
          t = a.noop,
          y = a.pick,
          d = a.pInt,
          b = a.Point,
          f = a.Series,
          w = a.seriesType,
          q = a.seriesTypes;
      w("bubble", "scatter", {
        dataLabels: {
          formatter: function formatter() {
            return this.point.z;
          },
          inside: !0,
          verticalAlign: "middle"
        },
        animationLimit: 250,
        marker: {
          lineColor: null,
          lineWidth: 1,
          fillOpacity: .5,
          radius: null,
          states: {
            hover: {
              radiusPlus: 0
            }
          },
          symbol: "circle"
        },
        minSize: 8,
        maxSize: "20%",
        softThreshold: !1,
        states: {
          hover: {
            halo: {
              size: 5
            }
          }
        },
        tooltip: {
          pointFormat: "({point.x}, {point.y}), Size: {point.z}"
        },
        turboThreshold: 0,
        zThreshold: 0,
        zoneAxis: "z"
      }, {
        pointArrayMap: ["y", "z"],
        parallelArrays: ["x", "y", "z"],
        trackerGroups: ["group", "dataLabelsGroup"],
        specialGroup: "group",
        bubblePadding: !0,
        zoneAxis: "z",
        directTouch: !0,
        isBubble: !0,
        pointAttribs: function pointAttribs(a, b) {
          var c = this.options.marker.fillOpacity;
          a = f.prototype.pointAttribs.call(this, a, b);
          1 !== c && (a.fill = r(a.fill).setOpacity(c).get("rgba"));
          return a;
        },
        getRadii: function getRadii(a, b, g) {
          var c,
              d = this.zData,
              f = g.minPxSize,
              e = g.maxPxSize,
              l = [],
              h;
          c = 0;

          for (g = d.length; c < g; c++) {
            h = d[c], l.push(this.getRadius(a, b, f, e, h));
          }

          this.radii = l;
        },
        getRadius: function getRadius(a, b, d, f, k) {
          var c = this.options,
              g = "width" !== c.sizeBy,
              l = c.zThreshold,
              h = b - a;
          c.sizeByAbsoluteValue && null !== k && (k = Math.abs(k - l), h = Math.max(b - l, Math.abs(a - l)), a = 0);
          e(k) ? k < a ? d = d / 2 - 1 : (a = 0 < h ? (k - a) / h : .5, g && 0 <= a && (a = Math.sqrt(a)), d = Math.ceil(d + a * (f - d)) / 2) : d = null;
          return d;
        },
        animate: function animate(a) {
          !a && this.points.length < this.options.animationLimit && (this.points.forEach(function (a) {
            var c = a.graphic,
                b;
            c && c.width && (b = {
              x: c.x,
              y: c.y,
              width: c.width,
              height: c.height
            }, c.attr({
              x: a.plotX,
              y: a.plotY,
              width: 1,
              height: 1
            }), c.animate(b, this.options.animation));
          }, this), this.animate = null);
        },
        translate: function translate() {
          var c,
              b = this.data,
              d,
              f,
              k = this.radii;
          q.scatter.prototype.translate.call(this);

          for (c = b.length; c--;) {
            d = b[c], f = k ? k[c] : 0, e(f) && f >= this.minPxSize / 2 ? (d.marker = a.extend(d.marker, {
              radius: f,
              width: 2 * f,
              height: 2 * f
            }), d.dlBox = {
              x: d.plotX - f,
              y: d.plotY - f,
              width: 2 * f,
              height: 2 * f
            }) : d.shapeArgs = d.plotY = d.dlBox = void 0;
          }
        },
        alignDataLabel: q.column.prototype.alignDataLabel,
        buildKDTree: t,
        applyZones: t
      }, {
        haloPath: function haloPath(a) {
          return b.prototype.haloPath.call(this, 0 === a ? 0 : (this.marker ? this.marker.radius || 0 : 0) + a);
        },
        ttBelow: !1
      });

      n.prototype.beforePadding = function () {
        var c = this,
            b = this.len,
            f = this.chart,
            w = 0,
            k = b,
            q = this.isXAxis,
            n = q ? "xData" : "yData",
            r = this.min,
            t = {},
            z = Math.min(f.plotWidth, f.plotHeight),
            C = Number.MAX_VALUE,
            D = -Number.MAX_VALUE,
            E = this.max - r,
            B = b / E,
            F = [];
        this.series.forEach(function (b) {
          var g = b.options;
          !b.bubblePadding || !b.visible && f.options.chart.ignoreHiddenSeries || (c.allowZoomOutside = !0, F.push(b), q && (["minSize", "maxSize"].forEach(function (a) {
            var c = g[a],
                b = /%$/.test(c),
                c = d(c);
            t[a] = b ? z * c / 100 : c;
          }), b.minPxSize = t.minSize, b.maxPxSize = Math.max(t.maxSize, t.minSize), b = b.zData.filter(a.isNumber), b.length && (C = y(g.zMin, Math.min(C, Math.max(h(b), !1 === g.displayNegative ? g.zThreshold : -Number.MAX_VALUE))), D = y(g.zMax, Math.max(D, p(b))))));
        });
        F.forEach(function (a) {
          var b = a[n],
              d = b.length,
              f;
          q && a.getRadii(C, D, a);
          if (0 < E) for (; d--;) {
            e(b[d]) && c.dataMin <= b[d] && b[d] <= c.dataMax && (f = a.radii[d], w = Math.min((b[d] - r) * B - f, w), k = Math.max((b[d] - r) * B + f, k));
          }
        });
        F.length && 0 < E && !this.isLog && (k -= b, B *= (b + Math.max(0, w) - Math.min(k, b)) / b, [["min", "userMin", w], ["max", "userMax", k]].forEach(function (a) {
          void 0 === y(c.options[a[0]], c[a[1]]) && (c[a[0]] += a[2] / B);
        }));
      };
    })(z);

    (function (a) {
      var p = a.merge,
          h = a.Point,
          n = a.seriesType,
          r = a.seriesTypes;
      r.bubble && n("mapbubble", "bubble", {
        animationLimit: 500,
        tooltip: {
          pointFormat: "{point.name}: {point.z}"
        }
      }, {
        xyFromShape: !0,
        type: "mapbubble",
        pointArrayMap: ["z"],
        getMapData: r.map.prototype.getMapData,
        getBox: r.map.prototype.getBox,
        setData: r.map.prototype.setData
      }, {
        applyOptions: function applyOptions(a, n) {
          return a && void 0 !== a.lat && void 0 !== a.lon ? h.prototype.applyOptions.call(this, p(a, this.series.chart.fromLatLonToPoint(a)), n) : r.map.prototype.pointClass.prototype.applyOptions.call(this, a, n);
        },
        isValid: function isValid() {
          return "number" === typeof this.z;
        },
        ttBelow: !1
      });
    })(z);

    (function (a) {
      var p = a.colorPointMixin,
          h = a.merge,
          n = a.noop,
          r = a.pick,
          e = a.Series,
          t = a.seriesType,
          y = a.seriesTypes;
      t("heatmap", "scatter", {
        animation: !1,
        borderWidth: 0,
        nullColor: "#f7f7f7",
        dataLabels: {
          formatter: function formatter() {
            return this.point.value;
          },
          inside: !0,
          verticalAlign: "middle",
          crop: !1,
          overflow: !1,
          padding: 0
        },
        marker: null,
        pointRange: null,
        tooltip: {
          pointFormat: "{point.x}, {point.y}: {point.value}\x3cbr/\x3e"
        },
        states: {
          hover: {
            halo: !1,
            brightness: .2
          }
        }
      }, h(a.colorSeriesMixin, {
        pointArrayMap: ["y", "value"],
        hasPointSpecificOptions: !0,
        getExtremesFromAll: !0,
        directTouch: !0,
        init: function init() {
          var a;
          y.scatter.prototype.init.apply(this, arguments);
          a = this.options;
          a.pointRange = r(a.pointRange, a.colsize || 1);
          this.yAxis.axisPointRange = a.rowsize || 1;
        },
        translate: function translate() {
          var a = this.options,
              b = this.xAxis,
              f = this.yAxis,
              e = a.pointPadding || 0,
              h = function h(a, c, b) {
            return Math.min(Math.max(c, a), b);
          },
              c = this.pointPlacementToXValue();

          this.generatePoints();
          this.points.forEach(function (d) {
            var g = (a.colsize || 1) / 2,
                l = (a.rowsize || 1) / 2,
                k = h(Math.round(b.len - b.translate(d.x - g, 0, 1, 0, 1, -c)), -b.len, 2 * b.len),
                g = h(Math.round(b.len - b.translate(d.x + g, 0, 1, 0, 1, -c)), -b.len, 2 * b.len),
                w = h(Math.round(f.translate(d.y - l, 0, 1, 0, 1)), -f.len, 2 * f.len),
                l = h(Math.round(f.translate(d.y + l, 0, 1, 0, 1)), -f.len, 2 * f.len),
                q = r(d.pointPadding, e);
            d.plotX = d.clientX = (k + g) / 2;
            d.plotY = (w + l) / 2;
            d.shapeType = "rect";
            d.shapeArgs = {
              x: Math.min(k, g) + q,
              y: Math.min(w, l) + q,
              width: Math.abs(g - k) - 2 * q,
              height: Math.abs(l - w) - 2 * q
            };
          });
          this.translateColors();
        },
        drawPoints: function drawPoints() {
          var a = this.chart.styledMode ? "css" : "attr";
          y.column.prototype.drawPoints.call(this);
          this.points.forEach(function (b) {
            b.graphic[a](this.colorAttribs(b));
          }, this);
        },
        getValidPoints: function getValidPoints(a, b) {
          return e.prototype.getValidPoints.call(this, a, b, !0);
        },
        animate: n,
        getBox: n,
        drawLegendSymbol: a.LegendSymbolMixin.drawRectangle,
        alignDataLabel: y.column.prototype.alignDataLabel,
        getExtremes: function getExtremes() {
          e.prototype.getExtremes.call(this, this.valueData);
          this.valueMin = this.dataMin;
          this.valueMax = this.dataMax;
          e.prototype.getExtremes.call(this);
        }
      }), a.extend({
        haloPath: function haloPath(a) {
          if (!a) return [];
          var b = this.shapeArgs;
          return ["M", b.x - a, b.y - a, "L", b.x - a, b.y + b.height + a, b.x + b.width + a, b.y + b.height + a, b.x + b.width + a, b.y - a, "Z"];
        }
      }, p));
    })(z);

    (function (a) {
      function p(a, b) {
        var d,
            e,
            h,
            c = !1,
            l = a.x,
            g = a.y;
        a = 0;

        for (d = b.length - 1; a < b.length; d = a++) {
          e = b[a][1] > g, h = b[d][1] > g, e !== h && l < (b[d][0] - b[a][0]) * (g - b[a][1]) / (b[d][1] - b[a][1]) + b[a][0] && (c = !c);
        }

        return c;
      }

      var h = a.Chart,
          n = a.extend,
          r = a.format,
          e = a.merge,
          t = a.win,
          y = a.wrap;

      h.prototype.transformFromLatLon = function (d, b) {
        if (void 0 === t.proj4) return a.error(21, !1, this), {
          x: 0,
          y: null
        };
        d = t.proj4(b.crs, [d.lon, d.lat]);
        var f = b.cosAngle || b.rotation && Math.cos(b.rotation),
            e = b.sinAngle || b.rotation && Math.sin(b.rotation);
        d = b.rotation ? [d[0] * f + d[1] * e, -d[0] * e + d[1] * f] : d;
        return {
          x: ((d[0] - (b.xoffset || 0)) * (b.scale || 1) + (b.xpan || 0)) * (b.jsonres || 1) + (b.jsonmarginX || 0),
          y: (((b.yoffset || 0) - d[1]) * (b.scale || 1) + (b.ypan || 0)) * (b.jsonres || 1) - (b.jsonmarginY || 0)
        };
      };

      h.prototype.transformToLatLon = function (d, b) {
        if (void 0 === t.proj4) a.error(21, !1, this);else {
          d = {
            x: ((d.x - (b.jsonmarginX || 0)) / (b.jsonres || 1) - (b.xpan || 0)) / (b.scale || 1) + (b.xoffset || 0),
            y: ((-d.y - (b.jsonmarginY || 0)) / (b.jsonres || 1) + (b.ypan || 0)) / (b.scale || 1) + (b.yoffset || 0)
          };
          var f = b.cosAngle || b.rotation && Math.cos(b.rotation),
              e = b.sinAngle || b.rotation && Math.sin(b.rotation);
          b = t.proj4(b.crs, "WGS84", b.rotation ? {
            x: d.x * f + d.y * -e,
            y: d.x * e + d.y * f
          } : d);
          return {
            lat: b.y,
            lon: b.x
          };
        }
      };

      h.prototype.fromPointToLatLon = function (d) {
        var b = this.mapTransforms,
            f;

        if (b) {
          for (f in b) {
            if (b.hasOwnProperty(f) && b[f].hitZone && p({
              x: d.x,
              y: -d.y
            }, b[f].hitZone.coordinates[0])) return this.transformToLatLon(d, b[f]);
          }

          return this.transformToLatLon(d, b["default"]);
        }

        a.error(22, !1, this);
      };

      h.prototype.fromLatLonToPoint = function (d) {
        var b = this.mapTransforms,
            f,
            e;
        if (!b) return a.error(22, !1, this), {
          x: 0,
          y: null
        };

        for (f in b) {
          if (b.hasOwnProperty(f) && b[f].hitZone && (e = this.transformFromLatLon(d, b[f]), p({
            x: e.x,
            y: -e.y
          }, b[f].hitZone.coordinates[0]))) return e;
        }

        return this.transformFromLatLon(d, b["default"]);
      };

      a.geojson = function (a, b, f) {
        var d = [],
            e = [],
            c = function c(a) {
          var c,
              b = a.length;
          e.push("M");

          for (c = 0; c < b; c++) {
            1 === c && e.push("L"), e.push(a[c][0], -a[c][1]);
          }
        };

        b = b || "map";
        a.features.forEach(function (a) {
          var f = a.geometry,
              h = f.type,
              f = f.coordinates;
          a = a.properties;
          var k;
          e = [];
          "map" === b || "mapbubble" === b ? ("Polygon" === h ? (f.forEach(c), e.push("Z")) : "MultiPolygon" === h && (f.forEach(function (a) {
            a.forEach(c);
          }), e.push("Z")), e.length && (k = {
            path: e
          })) : "mapline" === b ? ("LineString" === h ? c(f) : "MultiLineString" === h && f.forEach(c), e.length && (k = {
            path: e
          })) : "mappoint" === b && "Point" === h && (k = {
            x: f[0],
            y: -f[1]
          });
          k && d.push(n(k, {
            name: a.name || a.NAME,
            properties: a
          }));
        });
        f && a.copyrightShort && (f.chart.mapCredits = r(f.chart.options.credits.mapText, {
          geojson: a
        }), f.chart.mapCreditsFull = r(f.chart.options.credits.mapTextFull, {
          geojson: a
        }));
        return d;
      };

      y(h.prototype, "addCredits", function (a, b) {
        b = e(!0, this.options.credits, b);
        this.mapCredits && (b.href = null);
        a.call(this, b);
        this.credits && this.mapCreditsFull && this.credits.attr({
          title: this.mapCreditsFull
        });
      });
    })(z);

    (function (a) {
      function p(a, b, d, c, e, g, h, k) {
        return ["M", a + e, b, "L", a + d - g, b, "C", a + d - g / 2, b, a + d, b + g / 2, a + d, b + g, "L", a + d, b + c - h, "C", a + d, b + c - h / 2, a + d - h / 2, b + c, a + d - h, b + c, "L", a + k, b + c, "C", a + k / 2, b + c, a, b + c - k / 2, a, b + c - k, "L", a, b + e, "C", a, b + e / 2, a + e / 2, b, a + e, b, "Z"];
      }

      var h = a.Chart,
          n = a.defaultOptions,
          r = a.extend,
          e = a.merge,
          t = a.pick,
          y = a.Renderer,
          d = a.SVGRenderer,
          b = a.VMLRenderer;
      r(n.lang, {
        zoomIn: "Zoom in",
        zoomOut: "Zoom out"
      });
      n.mapNavigation = {
        buttonOptions: {
          alignTo: "plotBox",
          align: "left",
          verticalAlign: "top",
          x: 0,
          width: 18,
          height: 18,
          padding: 5,
          style: {
            fontSize: "15px",
            fontWeight: "bold"
          },
          theme: {
            "stroke-width": 1,
            "text-align": "center"
          }
        },
        buttons: {
          zoomIn: {
            onclick: function onclick() {
              this.mapZoom(.5);
            },
            text: "+",
            y: 0
          },
          zoomOut: {
            onclick: function onclick() {
              this.mapZoom(2);
            },
            text: "-",
            y: 28
          }
        },
        mouseWheelSensitivity: 1.1
      };

      a.splitPath = function (a) {
        var b;
        a = a.replace(/([A-Za-z])/g, " $1 ");
        a = a.replace(/^\s*/, "").replace(/\s*$/, "");
        a = a.split(/[ ,]+/);

        for (b = 0; b < a.length; b++) {
          /[a-zA-Z]/.test(a[b]) || (a[b] = parseFloat(a[b]));
        }

        return a;
      };

      a.maps = {};

      d.prototype.symbols.topbutton = function (a, b, d, c, e) {
        return p(a - 1, b - 1, d, c, e.r, e.r, 0, 0);
      };

      d.prototype.symbols.bottombutton = function (a, b, d, c, e) {
        return p(a - 1, b - 1, d, c, 0, 0, e.r, e.r);
      };

      y === b && ["topbutton", "bottombutton"].forEach(function (a) {
        b.prototype.symbols[a] = d.prototype.symbols[a];
      });

      a.Map = a.mapChart = function (b, d, p) {
        var c = "string" === typeof b || b.nodeName,
            f = arguments[c ? 1 : 0],
            g = f,
            n = {
          endOnTick: !1,
          visible: !1,
          minPadding: 0,
          maxPadding: 0,
          startOnTick: !1
        },
            k,
            m = a.getOptions().credits;
        k = f.series;
        f.series = null;
        f = e({
          chart: {
            panning: "xy",
            type: "map"
          },
          credits: {
            mapText: t(m.mapText, " \xA9 <a href=\"{geojson.copyrightUrl}\">{geojson.copyrightShort}</a>"),
            mapTextFull: t(m.mapTextFull, "{geojson.copyright}")
          },
          tooltip: {
            followTouchMove: !1
          },
          xAxis: n,
          yAxis: e(n, {
            reversed: !0
          })
        }, f, {
          chart: {
            inverted: !1,
            alignTicks: !1
          }
        });
        f.series = g.series = k;
        return c ? new h(b, f, p) : new h(f, d);
      };
    })(z);
  });
});
var annotations = createCommonjsModule(function (module) {
  /*
   Highcharts JS v7.0.3 (2019-02-06)
   Annotations module
  
   (c) 2009-2019 Torstein Honsi
  
   License: www.highcharts.com/license
  */
  (function (m) {
    module.exports ? (m["default"] = m, module.exports = m) : m("undefined" !== typeof Highcharts ? Highcharts : void 0);
  })(function (m) {
    var y = function (a) {
      return {
        addEvents: function addEvents() {
          var e = this;
          a.addEvent(e.graphic.element, "mousedown", function (d) {
            e.onMouseDown(d);
          });
          a.objectEach(e.options.events, function (d, b) {
            var c = function c(_c) {
              "click" === b && e.cancelClick || d.call(e, e.chart.pointer.normalize(_c), e.target);
            };

            if ("drag" !== b) e.graphic.on(b, c);else a.addEvent(e, "drag", c);
          });
          e.options.draggable && (a.addEvent(e, "drag", e.onDrag), e.graphic.renderer.styledMode || e.graphic.css({
            cursor: {
              x: "ew-resize",
              y: "ns-resize",
              xy: "move"
            }[e.options.draggable]
          }));
        },
        removeDocEvents: function removeDocEvents() {
          this.removeDrag && (this.removeDrag = this.removeDrag());
          this.removeMouseUp && (this.removeMouseUp = this.removeMouseUp());
        },
        onMouseDown: function onMouseDown(e) {
          var d = this,
              b = d.chart.pointer,
              c,
              f;
          2 !== e.button && (e.stopPropagation(), e = b.normalize(e), c = e.chartX, f = e.chartY, d.cancelClick = !1, d.removeDrag = a.addEvent(a.doc, "mousemove", function (l) {
            d.hasDragged = !0;
            l = b.normalize(l);
            l.prevChartX = c;
            l.prevChartY = f;
            a.fireEvent(d, "drag", l);
            c = l.chartX;
            f = l.chartY;
          }), d.removeMouseUp = a.addEvent(a.doc, "mouseup", function (c) {
            d.cancelClick = d.hasDragged;
            d.hasDragged = !1;
            d.onMouseUp(c);
          }));
        },
        onMouseUp: function onMouseUp() {
          var a = this.chart,
              d = this.target || this,
              b = a.options.annotations,
              a = a.annotations.indexOf(d);
          this.removeDocEvents();
          b[a] = d.options;
        },
        onDrag: function onDrag(a) {
          if (this.chart.isInsidePlot(a.chartX - this.chart.plotLeft, a.chartY - this.chart.plotTop)) {
            var d = this.mouseMoveToTranslation(a);
            "x" === this.options.draggable && (d.y = 0);
            "y" === this.options.draggable && (d.x = 0);
            this.points.length ? this.translate(d.x, d.y) : (this.shapes.forEach(function (b) {
              b.translate(d.x, d.y);
            }), this.labels.forEach(function (b) {
              b.translate(d.x, d.y);
            }));
            this.redraw(!1);
          }
        },
        mouseMoveToRadians: function mouseMoveToRadians(a, d, b) {
          var c = a.prevChartY - b,
              f = a.prevChartX - d;
          b = a.chartY - b;
          a = a.chartX - d;
          this.chart.inverted && (d = f, f = c, c = d, d = a, a = b, b = d);
          return Math.atan2(b, a) - Math.atan2(c, f);
        },
        mouseMoveToTranslation: function mouseMoveToTranslation(a) {
          var d = a.chartX - a.prevChartX;
          a = a.chartY - a.prevChartY;
          var b;
          this.chart.inverted && (b = a, a = d, d = b);
          return {
            x: d,
            y: a
          };
        },
        mouseMoveToScale: function mouseMoveToScale(a, d, b) {
          d = (a.chartX - d || 1) / (a.prevChartX - d || 1);
          a = (a.chartY - b || 1) / (a.prevChartY - b || 1);
          this.chart.inverted && (b = a, a = d, d = b);
          return {
            x: d,
            y: a
          };
        },
        destroy: function destroy() {
          this.removeDocEvents();
          a.removeEvent(this);
          this.hcEvents = null;
        }
      };
    }(m),
        A = function (a, e) {
      function d(b, c, f, d) {
        this.chart = b;
        this.target = c;
        this.options = f;
        this.index = a.pick(f.index, d);
      }

      a.extend(d.prototype, e);

      d.prototype.setVisibility = function (b) {
        this.graphic.attr("visibility", b ? "visible" : "hidden");
        this.options.visible = b;
      };

      d.prototype.render = function () {
        var b = this.chart,
            c = this.options;
        this.graphic = b.renderer.symbol(c.symbol, 0, 0, c.width, c.height).add(b.controlPointsGroup).css(c.style);
        this.setVisibility(c.visible);
        this.addEvents();
      };

      d.prototype.redraw = function (b) {
        this.graphic[b ? "animate" : "attr"](this.options.positioner.call(this, this.target));
      };

      d.prototype.destroy = function () {
        e.destroy.call(this);
        this.graphic && (this.graphic = this.graphic.destroy());
        this.options = this.target = this.chart = null;
      };

      d.prototype.update = function (b) {
        var c = this.chart,
            f = this.target,
            d = this.index;
        b = a.merge(!0, this.options, b);
        this.destroy();
        this.constructor(c, f, b, d);
        this.render(c.controlPointsGroup);
        this.redraw();
      };

      return d;
    }(m, y),
        z = function (a) {
      function e(d, b, c) {
        this.series = {
          visible: !0,
          chart: d,
          getPlotBox: a.Series.prototype.getPlotBox
        };
        this.target = b || null;
        this.options = c;
        this.applyOptions(this.getOptions());
      }

      e.fromPoint = function (a) {
        return new e(a.series.chart, null, {
          x: a.x,
          y: a.y,
          xAxis: a.series.xAxis,
          yAxis: a.series.yAxis
        });
      };

      e.pointToPixels = function (a, b) {
        var c = a.series,
            f = c.chart,
            d = a.plotX,
            h = a.plotY;
        f.inverted && (a.mock ? (d = a.plotY, h = a.plotX) : (d = f.plotWidth - a.plotY, h = f.plotHeight - a.plotX));
        c && !b && (a = c.getPlotBox(), d += a.translateX, h += a.translateY);
        return {
          x: d,
          y: h
        };
      };

      e.pointToOptions = function (a) {
        return {
          x: a.x,
          y: a.y,
          xAxis: a.series.xAxis,
          yAxis: a.series.yAxis
        };
      };

      a.extend(e.prototype, {
        mock: !0,
        hasDynamicOptions: function hasDynamicOptions() {
          return "function" === typeof this.options;
        },
        getOptions: function getOptions() {
          return this.hasDynamicOptions() ? this.options(this.target) : this.options;
        },
        applyOptions: function applyOptions(a) {
          this.command = a.command;
          this.setAxis(a, "x");
          this.setAxis(a, "y");
          this.refresh();
        },
        setAxis: function setAxis(d, b) {
          b += "Axis";
          d = d[b];
          var c = this.series.chart;
          this.series[b] = d instanceof a.Axis ? d : a.defined(d) ? c[b][d] || c.get(d) : null;
        },
        toAnchor: function toAnchor() {
          var a = [this.plotX, this.plotY, 0, 0];
          this.series.chart.inverted && (a[0] = this.plotY, a[1] = this.plotX);
          return a;
        },
        getLabelConfig: function getLabelConfig() {
          return {
            x: this.x,
            y: this.y,
            point: this
          };
        },
        isInsidePane: function isInsidePane() {
          var d = this.plotX,
              b = this.plotY,
              c = this.series.xAxis,
              f = this.series.yAxis,
              l = !0;
          c && (l = a.defined(d) && 0 <= d && d <= c.len);
          f && (l = l && a.defined(b) && 0 <= b && b <= f.len);
          return l;
        },
        refresh: function refresh() {
          var a = this.series,
              b = a.xAxis,
              a = a.yAxis,
              c = this.getOptions();
          b ? (this.x = c.x, this.plotX = b.toPixels(c.x, !0)) : (this.x = null, this.plotX = c.x);
          a ? (this.y = c.y, this.plotY = a.toPixels(c.y, !0)) : (this.y = null, this.plotY = c.y);
          this.isInside = this.isInsidePane();
        },
        translate: function translate(a, b, c, f) {
          this.hasDynamicOptions() || (this.plotX += c, this.plotY += f, this.refreshOptions());
        },
        scale: function scale(a, b, c, f) {
          if (!this.hasDynamicOptions()) {
            var d = this.plotY * f;
            this.plotX = (1 - c) * a + this.plotX * c;
            this.plotY = (1 - f) * b + d;
            this.refreshOptions();
          }
        },
        rotate: function rotate(a, b, c) {
          if (!this.hasDynamicOptions()) {
            var f = Math.cos(c);
            c = Math.sin(c);
            var d = this.plotX,
                h = this.plotY,
                d = d - a,
                h = h - b;
            this.plotX = d * f - h * c + a;
            this.plotY = d * c + h * f + b;
            this.refreshOptions();
          }
        },
        refreshOptions: function refreshOptions() {
          var a = this.series,
              b = a.xAxis,
              a = a.yAxis;
          this.x = this.options.x = b ? this.options.x = b.toValue(this.plotX, !0) : this.plotX;
          this.y = this.options.y = a ? a.toValue(this.plotY, !0) : this.plotY;
        }
      });
      return e;
    }(m),
        t = function (a, e, d) {
      return {
        init: function init(a, c, f) {
          this.annotation = a;
          this.chart = a.chart;
          this.options = c;
          this.points = [];
          this.controlPoints = [];
          this.index = f;
          this.linkPoints();
          this.addControlPoints();
        },
        attr: function attr() {
          this.graphic.attr.apply(this.graphic, arguments);
        },
        getPointsOptions: function getPointsOptions() {
          var b = this.options;
          return b.points || b.point && a.splat(b.point);
        },
        attrsFromOptions: function attrsFromOptions(a) {
          var c = this.constructor.attrsMap,
              f = {},
              b,
              d,
              e = this.chart.styledMode;

          for (b in a) {
            d = c[b], !d || e && -1 !== ["fill", "stroke", "stroke-width"].indexOf(d) || (f[d] = a[b]);
          }

          return f;
        },
        anchor: function anchor(b) {
          var c = b.series.getPlotBox();
          b = b.mock ? b.toAnchor() : a.Tooltip.prototype.getAnchor.call({
            chart: b.series.chart
          }, b);
          b = {
            x: b[0] + (this.options.x || 0),
            y: b[1] + (this.options.y || 0),
            height: b[2] || 0,
            width: b[3] || 0
          };
          return {
            relativePosition: b,
            absolutePosition: a.merge(b, {
              x: b.x + c.translateX,
              y: b.y + c.translateY
            })
          };
        },
        point: function point(b, c) {
          if (b && b.series) return b;
          c && null !== c.series || (a.isObject(b) ? c = new d(this.chart, this, b) : a.isString(b) ? c = this.chart.get(b) || null : "function" === typeof b && (c = b.call(c, this), c = c.series ? c : new d(this.chart, this, b)));
          return c;
        },
        linkPoints: function linkPoints() {
          var a = this.getPointsOptions(),
              c = this.points,
              f = a && a.length || 0,
              d,
              h;

          for (d = 0; d < f; d++) {
            h = this.point(a[d], c[d]);

            if (!h) {
              c.length = 0;
              return;
            }

            h.mock && h.refresh();
            c[d] = h;
          }

          return c;
        },
        addControlPoints: function addControlPoints() {
          var b = this.options.controlPoints;
          (b || []).forEach(function (c, f) {
            c = a.merge(this.options.controlPointOptions, c);
            c.index || (c.index = f);
            b[f] = c;
            this.controlPoints.push(new e(this.chart, this, c));
          }, this);
        },
        shouldBeDrawn: function shouldBeDrawn() {
          return !!this.points.length;
        },
        render: function render() {
          this.controlPoints.forEach(function (a) {
            a.render();
          });
        },
        redraw: function redraw(a) {
          this.controlPoints.forEach(function (c) {
            c.redraw(a);
          });
        },
        transform: function transform(a, c, f, d, h) {
          if (this.chart.inverted) {
            var b = c;
            c = f;
            f = b;
          }

          this.points.forEach(function (b, g) {
            this.transformPoint(a, c, f, d, h, g);
          }, this);
        },
        transformPoint: function transformPoint(a, c, f, l, h, e) {
          var b = this.points[e];
          b.mock || (b = this.points[e] = d.fromPoint(b));
          b[a](c, f, l, h);
        },
        translate: function translate(a, c) {
          this.transform("translate", null, null, a, c);
        },
        translatePoint: function translatePoint(a, c, f) {
          this.transformPoint("translate", null, null, a, c, f);
        },
        rotate: function rotate(a, c, f) {
          this.transform("rotate", a, c, f);
        },
        scale: function scale(a, c, f, d) {
          this.transform("scale", a, c, f, d);
        },
        setControlPointsVisibility: function setControlPointsVisibility(a) {
          this.controlPoints.forEach(function (c) {
            c.setVisibility(a);
          });
        },
        destroy: function destroy() {
          this.graphic && (this.graphic = this.graphic.destroy());
          this.tracker && (this.tracker = this.tracker.destroy());
          this.controlPoints.forEach(function (a) {
            a.destroy();
          });
          this.options = this.controlPoints = this.points = this.chart = null;
          this.annotation && (this.annotation = null);
        },
        update: function update(b) {
          var c = this.annotation;
          b = a.merge(!0, this.options, b);
          var f = this.graphic.parentGroup;
          this.destroy();
          this.constructor(c, b);
          this.render(f);
          this.redraw();
        }
      };
    }(m, A, z),
        w = function (a) {
      var e = {
        arrow: {
          tagName: "marker",
          render: !1,
          id: "arrow",
          refY: 5,
          refX: 9,
          markerWidth: 10,
          markerHeight: 10,
          children: [{
            tagName: "path",
            d: "M 0 0 L 10 5 L 0 10 Z",
            strokeWidth: 0
          }]
        },
        "reverse-arrow": {
          tagName: "marker",
          render: !1,
          id: "reverse-arrow",
          refY: 5,
          refX: 1,
          markerWidth: 10,
          markerHeight: 10,
          children: [{
            tagName: "path",
            d: "M 0 5 L 10 0 L 10 10 Z",
            strokeWidth: 0
          }]
        }
      };

      a.SVGRenderer.prototype.addMarker = function (b, c) {
        var f = {
          id: b
        },
            d = {
          stroke: c.color || "none",
          fill: c.color || "rgba(0, 0, 0, 0.75)"
        };
        f.children = c.children.map(function (c) {
          return a.merge(d, c);
        });
        c = this.definition(a.merge(!0, {
          markerWidth: 20,
          markerHeight: 20,
          refX: 0,
          refY: 0,
          orient: "auto"
        }, c, f));
        c.id = b;
        return c;
      };

      var d = function d(a) {
        return function (c) {
          this.attr(a, "url(#" + c + ")");
        };
      },
          d = {
        markerEndSetter: d("marker-end"),
        markerStartSetter: d("marker-start"),
        setItemMarkers: function setItemMarkers(b) {
          var c = b.options,
              f = b.chart,
              d = f.options.defs,
              h = c.fill,
              e = a.defined(h) && "none" !== h ? h : c.stroke;
          ["markerStart", "markerEnd"].forEach(function (l) {
            var g = c[l],
                k,
                p,
                q;

            if (g) {
              for (q in d) {
                if (k = d[q], g === k.id && "marker" === k.tagName) {
                  p = k;
                  break;
                }
              }

              p && (g = b[l] = f.renderer.addMarker((c.id || a.uniqueKey()) + "-" + p.id, a.merge(p, {
                color: e
              })), b.attr(l, g.attr("id")));
            }
          });
        }
      };

      a.SVGRenderer.prototype.definition = function (b) {
        function c(b, d) {
          var l;
          a.splat(b).forEach(function (b) {
            var g = f.createElement(b.tagName),
                k = {};
            a.objectEach(b, function (a, c) {
              "tagName" !== c && "children" !== c && "textContent" !== c && (k[c] = a);
            });
            g.attr(k);
            g.add(d || f.defs);
            b.textContent && g.element.appendChild(a.doc.createTextNode(b.textContent));
            c(b.children || [], g);
            l = g;
          });
          return l;
        }

        var f = this;
        return c(b);
      };

      a.addEvent(a.Chart, "afterGetContainer", function () {
        this.options.defs = a.merge(e, this.options.defs || {});
        a.objectEach(this.options.defs, function (a) {
          "marker" === a.tagName && !1 !== a.render && this.renderer.addMarker(a.id, a);
        }, this);
      });
      return d;
    }(m),
        w = function (a, e, d) {
      function b(a, c, b) {
        this.init(a, c, b);
        this.collection = "shapes";
      }

      var c = "rgba(192,192,192," + (a.svg ? .0001 : .002) + ")";
      b.attrsMap = {
        dashStyle: "dashstyle",
        strokeWidth: "stroke-width",
        stroke: "stroke",
        fill: "fill",
        zIndex: "zIndex"
      };
      a.merge(!0, b.prototype, e, {
        type: "path",
        setMarkers: d.setItemMarkers,
        toD: function toD() {
          var a = this.options.d;
          if (a) return "function" === typeof a ? a.call(this) : a;

          for (var c = this.points, b = c.length, d = b, e = c[0], g = d && this.anchor(e).absolutePosition, k = 0, p = 2, a = g && ["M", g.x, g.y]; ++k < b && d;) {
            e = c[k], d = e.command || "L", g = this.anchor(e).absolutePosition, "Z" === d ? a[++p] = d : (d !== c[k - 1].command && (a[++p] = d), a[++p] = g.x, a[++p] = g.y), d = e.series.visible;
          }

          return d ? this.chart.renderer.crispLine(a, this.graphic.strokeWidth()) : null;
        },
        shouldBeDrawn: function shouldBeDrawn() {
          return e.shouldBeDrawn.call(this) || !!this.options.d;
        },
        render: function render(b) {
          var f = this.options,
              h = this.attrsFromOptions(f);
          this.graphic = this.annotation.chart.renderer.path(["M", 0, 0]).attr(h).add(b);
          f.className && this.graphic.addClass(f.className);
          this.tracker = this.annotation.chart.renderer.path(["M", 0, 0]).addClass("highcharts-tracker-line").attr({
            zIndex: 2
          }).add(b);
          this.annotation.chart.styledMode || this.tracker.attr({
            "stroke-linejoin": "round",
            stroke: c,
            fill: c,
            "stroke-width": this.graphic.strokeWidth() + 2 * f.snap
          });
          e.render.call(this);
          a.extend(this.graphic, {
            markerStartSetter: d.markerStartSetter,
            markerEndSetter: d.markerEndSetter
          });
          this.setMarkers(this);
        },
        redraw: function redraw(a) {
          var c = this.toD(),
              b = a ? "animate" : "attr";
          c ? (this.graphic[b]({
            d: c
          }), this.tracker[b]({
            d: c
          })) : (this.graphic.attr({
            d: "M 0 -9000000000"
          }), this.tracker.attr({
            d: "M 0 -9000000000"
          }));
          this.graphic.placed = this.tracker.placed = !!c;
          e.redraw.call(this, a);
        }
      });
      return b;
    }(m, t, w),
        D = function (a, e, d) {
      function b(a, b, d) {
        this.init(a, b, d);
        this.collection = "shapes";
      }

      b.attrsMap = a.merge(d.attrsMap, {
        width: "width",
        height: "height"
      });
      a.merge(!0, b.prototype, e, {
        type: "rect",
        render: function render(a) {
          var c = this.attrsFromOptions(this.options);
          this.graphic = this.annotation.chart.renderer.rect(0, -9E9, 0, 0).attr(c).add(a);
          e.render.call(this);
        },
        redraw: function redraw(a) {
          var c = this.anchor(this.points[0]).absolutePosition;
          if (c) this.graphic[a ? "animate" : "attr"]({
            x: c.x,
            y: c.y,
            width: this.options.width,
            height: this.options.height
          });else this.attr({
            x: 0,
            y: -9E9
          });
          this.graphic.placed = !!c;
          e.redraw.call(this, a);
        },
        translate: function translate(a, b) {
          var c = this.annotation.userOptions[this.collection][this.index];
          this.translatePoint(a, b, 0);
          c.point = this.options.point;
        }
      });
      return b;
    }(m, t, w),
        E = function (a, e, d) {
      function b(a, b, d) {
        this.init(a, b, d);
        this.collection = "shapes";
      }

      b.attrsMap = a.merge(d.attrsMap, {
        r: "r"
      });
      a.merge(!0, b.prototype, e, {
        type: "circle",
        render: function render(a) {
          var c = this.attrsFromOptions(this.options);
          this.graphic = this.annotation.chart.renderer.circle(0, -9E9, 0).attr(c).add(a);
          e.render.call(this);
        },
        redraw: function redraw(a) {
          var c = this.anchor(this.points[0]).absolutePosition;
          if (c) this.graphic[a ? "animate" : "attr"]({
            x: c.x,
            y: c.y,
            r: this.options.r
          });else this.graphic.attr({
            x: 0,
            y: -9E9
          });
          this.graphic.placed = !!c;
          e.redraw.call(this, a);
        },
        translate: function translate(a, b) {
          var c = this.annotation.userOptions[this.collection][this.index];
          this.translatePoint(a, b, 0);
          c.point = this.options.point;
        },
        setRadius: function setRadius(a) {
          this.options.r = a;
        }
      });
      return b;
    }(m, t, w),
        C = function (a, e, d) {
      function b(a, b, d) {
        this.init(a, b, d);
        this.collection = "labels";
      }

      b.shapesWithoutBackground = ["connector"];

      b.alignedPosition = function (a, b) {
        var c = a.align,
            d = a.verticalAlign,
            f = (b.x || 0) + (a.x || 0),
            e = (b.y || 0) + (a.y || 0),
            g,
            k;
        "right" === c ? g = 1 : "center" === c && (g = 2);
        g && (f += (b.width - (a.width || 0)) / g);
        "bottom" === d ? k = 1 : "middle" === d && (k = 2);
        k && (e += (b.height - (a.height || 0)) / k);
        return {
          x: Math.round(f),
          y: Math.round(e)
        };
      };

      b.justifiedOptions = function (a, b, d, e) {
        var c = d.align,
            f = d.verticalAlign,
            g = b.box ? 0 : b.padding || 0,
            k = b.getBBox();
        b = {
          align: c,
          verticalAlign: f,
          x: d.x,
          y: d.y,
          width: b.width,
          height: b.height
        };
        d = e.x - a.plotLeft;
        var p = e.y - a.plotTop;
        e = d + g;
        0 > e && ("right" === c ? b.align = "left" : b.x = -e);
        e = d + k.width - g;
        e > a.plotWidth && ("left" === c ? b.align = "right" : b.x = a.plotWidth - e);
        e = p + g;
        0 > e && ("bottom" === f ? b.verticalAlign = "top" : b.y = -e);
        e = p + k.height - g;
        e > a.plotHeight && ("top" === f ? b.verticalAlign = "bottom" : b.y = a.plotHeight - e);
        return b;
      };

      b.attrsMap = {
        backgroundColor: "fill",
        borderColor: "stroke",
        borderWidth: "stroke-width",
        zIndex: "zIndex",
        borderRadius: "r",
        padding: "padding"
      };
      a.merge(!0, b.prototype, e, {
        translatePoint: function translatePoint(a, b) {
          e.translatePoint.call(this, a, b, 0);
        },
        translate: function translate(a, b) {
          var c = this.annotation.userOptions[this.collection][this.index];
          this.options.x += a;
          this.options.y += b;
          c.x = this.options.x;
          c.y = this.options.y;
        },
        render: function render(a) {
          var c = this.options,
              d = this.attrsFromOptions(c),
              h = c.style;
          this.graphic = this.annotation.chart.renderer.label("", 0, -9E9, c.shape, null, null, c.useHTML, null, "annotation-label").attr(d).add(a);
          this.annotation.chart.styledMode || ("contrast" === h.color && (h.color = this.annotation.chart.renderer.getContrast(-1 < b.shapesWithoutBackground.indexOf(c.shape) ? "#FFFFFF" : c.backgroundColor)), this.graphic.css(c.style).shadow(c.shadow));
          c.className && this.graphic.addClass(c.className);
          this.graphic.labelrank = c.labelrank;
          e.render.call(this);
        },
        redraw: function redraw(c) {
          var b = this.options,
              d = this.text || b.format || b.text,
              h = this.graphic,
              n = this.points[0];
          h.attr({
            text: d ? a.format(d, n.getLabelConfig(), this.annotation.chart.time) : b.formatter.call(n, this)
          });
          b = this.anchor(n);
          (d = this.position(b)) ? (h.alignAttr = d, d.anchorX = b.absolutePosition.x, d.anchorY = b.absolutePosition.y, h[c ? "animate" : "attr"](d)) : h.attr({
            x: 0,
            y: -9E9
          });
          h.placed = !!d;
          e.redraw.call(this, c);
        },
        anchor: function anchor() {
          var a = e.anchor.apply(this, arguments),
              b = this.options.x || 0,
              d = this.options.y || 0;
          a.absolutePosition.x -= b;
          a.absolutePosition.y -= d;
          a.relativePosition.x -= b;
          a.relativePosition.y -= d;
          return a;
        },
        position: function position(c) {
          var e = this.graphic,
              l = this.annotation.chart,
              h = this.points[0],
              n = this.options,
              B = c.absolutePosition,
              g = c.relativePosition,
              k;
          if (c = h.series.visible && d.prototype.isInsidePane.call(h)) n.distance ? k = a.Tooltip.prototype.getPosition.call({
            chart: l,
            distance: a.pick(n.distance, 16)
          }, e.width, e.height, {
            plotX: g.x,
            plotY: g.y,
            negative: h.negative,
            ttBelow: h.ttBelow,
            h: g.height || g.width
          }) : n.positioner ? k = n.positioner.call(this) : (h = {
            x: B.x,
            y: B.y,
            width: 0,
            height: 0
          }, k = b.alignedPosition(a.extend(n, {
            width: e.width,
            height: e.height
          }), h), "justify" === this.options.overflow && (k = b.alignedPosition(b.justifiedOptions(l, e, n, k), h))), n.crop && (n = k.x - l.plotLeft, h = k.y - l.plotTop, c = l.isInsidePlot(n, h) && l.isInsidePlot(n + e.width, h + e.height));
          return c ? k : null;
        }
      });

      a.SVGRenderer.prototype.symbols.connector = function (b, d, e, h, n) {
        var c = n && n.anchorX;
        n = n && n.anchorY;
        var g,
            k,
            f = e / 2;
        a.isNumber(c) && a.isNumber(n) && (g = ["M", c, n], k = d - n, 0 > k && (k = -h - k), k < e && (f = c < b + e / 2 ? k : e - k), n > d + h ? g.push("L", b + f, d + h) : n < d ? g.push("L", b + f, d) : c < b ? g.push("L", b, d + h / 2) : c > b + e && g.push("L", b + e, d + h / 2));
        return g || [];
      };

      return b;
    }(m, t, z),
        F = function (a, e, d) {
      function b(a, b, d) {
        this.init(a, b, d);
        this.collection = "shapes";
      }

      b.attrsMap = {
        width: "width",
        height: "height",
        zIndex: "zIndex"
      };
      a.merge(!0, b.prototype, e, {
        type: "image",
        render: function render(a) {
          var b = this.attrsFromOptions(this.options),
              c = this.options;
          this.graphic = this.annotation.chart.renderer.image(c.src, 0, -9E9, c.width, c.height).attr(b).add(a);
          this.graphic.width = c.width;
          this.graphic.height = c.height;
          e.render.call(this);
        },
        redraw: function redraw(a) {
          var b = this.anchor(this.points[0]);
          if (b = d.prototype.position.call(this, b)) this.graphic[a ? "animate" : "attr"]({
            x: b.x,
            y: b.y
          });else this.graphic.attr({
            x: 0,
            y: -9E9
          });
          this.graphic.placed = !!b;
          e.redraw.call(this, a);
        },
        translate: function translate(a, b) {
          var c = this.annotation.userOptions[this.collection][this.index];
          this.translatePoint(a, b, 0);
          c.point = this.options.point;
        }
      });
      return b;
    }(m, t, C);

    (function (a, e, d, b, c, f, l, h, n, m) {
      var g = a.merge,
          k = a.addEvent,
          p = a.defined,
          q = a.erase,
          x = a.find,
          u = a.isString,
          v = a.pick,
          G = a.reduce,
          H = a.splat,
          I = a.destroyObjectProperties,
          r = a.Annotation = function (a, b) {
        var c;
        this.chart = a;
        this.points = [];
        this.controlPoints = [];
        this.coll = "annotations";
        this.labels = [];
        this.shapes = [];
        this.options = b;
        this.userOptions = g(!0, {}, b);
        c = this.getLabelsAndShapesOptions(this.userOptions, b);
        this.userOptions.labels = c.labels;
        this.userOptions.shapes = c.shapes;
        this.init(a, b);
      };

      g(!0, r.prototype, e, h, {
        defaultOptions: {
          visible: !0,
          draggable: "xy",
          labelOptions: {
            align: "center",
            allowOverlap: !1,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            borderColor: "black",
            borderRadius: 3,
            borderWidth: 1,
            className: "",
            crop: !1,
            formatter: function formatter() {
              return p(this.y) ? this.y : "Annotation label";
            },
            overflow: "justify",
            padding: 5,
            shadow: !1,
            shape: "callout",
            style: {
              fontSize: "11px",
              fontWeight: "normal",
              color: "contrast"
            },
            useHTML: !1,
            verticalAlign: "bottom",
            x: 0,
            y: -16
          },
          shapeOptions: {
            stroke: "rgba(0, 0, 0, 0.75)",
            strokeWidth: 1,
            fill: "rgba(0, 0, 0, 0.75)",
            r: 0,
            snap: 2
          },
          controlPointOptions: {
            symbol: "circle",
            width: 10,
            height: 10,
            style: {
              stroke: "black",
              "stroke-width": 2,
              fill: "white"
            },
            visible: !1,
            events: {}
          },
          events: {},
          zIndex: 6
        },
        init: function init() {
          this.linkPoints();
          this.addControlPoints();
          this.addShapes();
          this.addLabels();
          this.addClipPaths();
          this.setLabelCollector();
        },
        getLabelsAndShapesOptions: function getLabelsAndShapesOptions(a, b) {
          var c = {};
          ["labels", "shapes"].forEach(function (d) {
            a[d] && (c[d] = H(b[d]).map(function (b, c) {
              return g(a[d][c], b);
            }));
          });
          return c;
        },
        addShapes: function addShapes() {
          (this.options.shapes || []).forEach(function (a, b) {
            a = this.initShape(a, b);
            this.options.shapes[b] = a.options;
          }, this);
        },
        addLabels: function addLabels() {
          (this.options.labels || []).forEach(function (a, b) {
            a = this.initLabel(a, b);
            this.options.labels[b] = a.options;
          }, this);
        },
        addClipPaths: function addClipPaths() {
          this.setClipAxes();
          this.clipXAxis && this.clipYAxis && (this.clipRect = this.chart.renderer.clipRect(this.getClipBox()));
        },
        setClipAxes: function setClipAxes() {
          var a = this.chart.xAxis,
              b = this.chart.yAxis,
              c = G((this.options.labels || []).concat(this.options.shapes || []), function (c, d) {
            return [a[d && d.point && d.point.xAxis] || c[0], b[d && d.point && d.point.yAxis] || c[1]];
          }, []);
          this.clipXAxis = c[0];
          this.clipYAxis = c[1];
        },
        getClipBox: function getClipBox() {
          return {
            x: this.clipXAxis.left,
            y: this.clipYAxis.top,
            width: this.clipXAxis.width,
            height: this.clipYAxis.height
          };
        },
        setLabelCollector: function setLabelCollector() {
          var a = this;

          a.labelCollector = function () {
            return a.labels.reduce(function (a, b) {
              b.options.allowOverlap || a.push(b.graphic);
              return a;
            }, []);
          };

          a.chart.labelCollectors.push(a.labelCollector);
        },
        setOptions: function setOptions(a) {
          this.options = g(this.defaultOptions, a);
        },
        redraw: function redraw(a) {
          this.linkPoints();
          this.graphic || this.render();
          this.clipRect && this.clipRect.animate(this.getClipBox());
          this.redrawItems(this.shapes, a);
          this.redrawItems(this.labels, a);
          e.redraw.call(this, a);
        },
        redrawItems: function redrawItems(a, b) {
          for (var c = a.length; c--;) {
            this.redrawItem(a[c], b);
          }
        },
        render: function render() {
          var a = this.chart.renderer;
          this.graphic = a.g("annotation").attr({
            zIndex: this.options.zIndex,
            visibility: this.options.visible ? "visible" : "hidden"
          }).add();
          this.shapesGroup = a.g("annotation-shapes").add(this.graphic).clip(this.chart.plotBoxClip);
          this.labelsGroup = a.g("annotation-labels").attr({
            translateX: 0,
            translateY: 0
          }).add(this.graphic);
          this.clipRect && this.graphic.clip(this.clipRect);
          this.addEvents();
          e.render.call(this);
        },
        setVisibility: function setVisibility(a) {
          var b = this.options;
          a = v(a, !b.visible);
          this.graphic.attr("visibility", a ? "visible" : "hidden");
          a || this.setControlPointsVisibility(!1);
          b.visible = a;
        },
        setControlPointsVisibility: function setControlPointsVisibility(a) {
          var b = function b(_b) {
            _b.setControlPointsVisibility(a);
          };

          e.setControlPointsVisibility.call(this, a);
          this.shapes.forEach(b);
          this.labels.forEach(b);
        },
        destroy: function destroy() {
          var a = this.chart,
              b = function b(a) {
            a.destroy();
          };

          this.labels.forEach(b);
          this.shapes.forEach(b);
          this.clipYAxis = this.clipXAxis = null;
          q(a.labelCollectors, this.labelCollector);
          h.destroy.call(this);
          e.destroy.call(this);
          I(this, a);
        },
        remove: function remove() {
          return this.destroy();
        },
        update: function update(b) {
          var c = this.chart,
              d = this.getLabelsAndShapesOptions(this.userOptions, b),
              g = c.annotations.indexOf(this);
          b = a.merge(!0, this.userOptions, b);
          b.labels = d.labels;
          b.shapes = d.shapes;
          this.destroy();
          this.constructor(c, b);
          c.options.annotations[g] = b;
          this.redraw();
        },
        initShape: function initShape(a, b) {
          a = g(this.options.shapeOptions, {
            controlPointOptions: this.options.controlPointOptions
          }, a);
          b = new r.shapesMap[a.type](this, a, b);
          b.itemType = "shape";
          this.shapes.push(b);
          return b;
        },
        initLabel: function initLabel(a, b) {
          a = g(this.options.labelOptions, {
            controlPointOptions: this.options.controlPointOptions
          }, a);
          b = new l(this, a, b);
          b.itemType = "label";
          this.labels.push(b);
          return b;
        },
        redrawItem: function redrawItem(b, c) {
          b.linkPoints();
          b.shouldBeDrawn() ? (b.graphic || this.renderItem(b), b.redraw(a.pick(c, !0) && b.graphic.placed), b.points.length && this.adjustVisibility(b)) : this.destroyItem(b);
        },
        adjustVisibility: function adjustVisibility(a) {
          var b = !1,
              c = a.graphic;
          a.points.forEach(function (a) {
            !1 !== a.series.visible && !1 !== a.visible && (b = !0);
          });
          b ? "hidden" === c.visibility && c.show() : c.hide();
        },
        destroyItem: function destroyItem(a) {
          q(this[a.itemType + "s"], a);
          a.destroy();
        },
        renderItem: function renderItem(a) {
          a.render("label" === a.itemType ? this.labelsGroup : this.shapesGroup);
        }
      });
      r.shapesMap = {
        rect: d,
        circle: b,
        path: c,
        image: f
      };
      r.types = {};
      r.MockPoint = n;
      r.ControlPoint = m;

      a.extendAnnotation = function (a, b, c, d) {
        b = b || r;
        g(!0, a.prototype, b.prototype, c);
        a.prototype.defaultOptions = g(a.prototype.defaultOptions, d || {});
      };

      a.Chart.prototype.collectionsWithUpdate.push("annotations");
      a.extend(a.Chart.prototype, {
        initAnnotation: function initAnnotation(b) {
          var c = r.types[b.type] || r;
          b = a.merge(c.prototype.defaultOptions, b);
          c = new c(this, b);
          this.annotations.push(c);
          return c;
        },
        addAnnotation: function addAnnotation(a, b) {
          a = this.initAnnotation(a);
          this.options.annotations.push(a.options);
          v(b, !0) && a.redraw();
          return a;
        },
        removeAnnotation: function removeAnnotation(a) {
          var b = this.annotations,
              c = u(a) ? x(b, function (b) {
            return b.options.id === a;
          }) : a;
          c && (q(this.options.annotations, c.options), q(b, c), c.destroy());
        },
        drawAnnotations: function drawAnnotations() {
          this.plotBoxClip.attr(this.plotBox);
          this.annotations.forEach(function (a) {
            a.redraw();
          });
        }
      });
      a.Chart.prototype.callbacks.push(function (a) {
        a.annotations = [];
        a.options.annotations || (a.options.annotations = []);
        a.plotBoxClip = this.renderer.clipRect(this.plotBox);
        a.controlPointsGroup = a.renderer.g("control-points").attr({
          zIndex: 99
        }).clip(a.plotBoxClip).add();
        a.options.annotations.forEach(function (b, c) {
          b = a.initAnnotation(b);
          a.options.annotations[c] = b.options;
        });
        a.drawAnnotations();
        k(a, "redraw", a.drawAnnotations);
        k(a, "destroy", function () {
          a.plotBoxClip.destroy();
          a.controlPointsGroup.destroy();
        });
      });
    })(m, t, D, E, w, F, C, y, z, A);

    y = function () {
      return {
        initUpdate: function initUpdate(a) {
          a.navigation || (a.navigation = {
            updates: [],
            update: function update(a, d) {
              this.updates.forEach(function (b) {
                b.update.call(b.context, a, d);
              });
            }
          });
        },
        addUpdate: function addUpdate(a, e) {
          e.navigation || this.initUpdate(e);
          e.navigation.updates.push({
            update: a,
            context: e
          });
        }
      };
    }();

    (function (a, e) {
      function d(b) {
        var c = b.prototype.defaultOptions.events && b.prototype.defaultOptions.events.click;
        a.merge(!0, b.prototype.defaultOptions.events, {
          click: function click(a) {
            var b = this,
                d = b.chart.navigationBindings,
                g = d.activeAnnotation;
            c && c.click.call(b, a);
            g !== b ? (d.deselectAnnotation(), d.activeAnnotation = b, b.setControlPointsVisibility(!0), m(d, "showPopup", {
              annotation: b,
              formType: "annotation-toolbar",
              options: d.annotationToFields(b),
              onSubmit: function onSubmit(a) {
                var c = {};
                "remove" === a.actionType ? (d.activeAnnotation = !1, d.chart.removeAnnotation(b)) : (d.fieldsToOptions(a.fields, c), d.deselectAnnotation(), a = c.typeOptions, "measure" === b.options.type && (a.crosshairY.enabled = 0 !== a.crosshairY.strokeWidth, a.crosshairX.enabled = 0 !== a.crosshairX.strokeWidth), b.update(c));
              }
            })) : (d.deselectAnnotation(), m(d, "closePopup"));
            a.activeAnnotation = !0;
          }
        });
      }

      var b = a.doc,
          c = a.addEvent,
          f = a.pick,
          l = a.merge,
          h = a.extend,
          n = a.isNumber,
          m = a.fireEvent,
          g = a.isArray,
          k = a.isObject,
          p = a.objectEach;

      a.NavigationBindings = function (a, c) {
        this.chart = a;
        this.options = c;
        this.eventsToUnbind = [];
        this.container = b.getElementsByClassName(this.options.bindingsClassName);
      };

      a.NavigationBindings.annotationsEditable = {
        nestedOptions: {
          labelOptions: ["style", "format", "backgroundColor"],
          labels: ["style"],
          label: ["style"],
          style: ["fontSize", "color"],
          background: ["fill", "strokeWidth", "stroke"],
          innerBackground: ["fill", "strokeWidth", "stroke"],
          outerBackground: ["fill", "strokeWidth", "stroke"],
          shapeOptions: ["fill", "strokeWidth", "stroke"],
          shapes: ["fill", "strokeWidth", "stroke"],
          line: ["strokeWidth", "stroke"],
          backgroundColors: [!0],
          connector: ["fill", "strokeWidth", "stroke"],
          crosshairX: ["strokeWidth", "stroke"],
          crosshairY: ["strokeWidth", "stroke"]
        },
        circle: ["shapes"],
        verticalLine: [],
        label: ["labelOptions"],
        measure: ["background", "crosshairY", "crosshairX"],
        fibonacci: [],
        tunnel: ["background", "line", "height"],
        pitchfork: ["innerBackground", "outerBackground"],
        rect: ["shapes"],
        crookedLine: []
      };
      a.NavigationBindings.annotationsNonEditable = {
        rectangle: ["crosshairX", "crosshairY", "label"]
      };
      h(a.NavigationBindings.prototype, {
        initEvents: function initEvents() {
          var a = this,
              b = a.chart,
              d = a.container,
              g = a.options;
          a.boundClassNames = {};
          p(g.bindings, function (b) {
            a.boundClassNames[b.className] = b;
          });
          [].forEach.call(d, function (b) {
            a.eventsToUnbind.push(c(b, "click", function (b) {
              var c = a.getButtonEvents(d, b);
              c && a.bindingsButtonClick(c.button, c.events, b);
            }));
          });
          p(g.events || {}, function (b, d) {
            a.eventsToUnbind.push(c(a, d, b));
          });
          a.eventsToUnbind.push(c(b.container, "click", function (c) {
            !b.cancelClick && b.isInsidePlot(c.chartX - b.plotLeft, c.chartY - b.plotTop) && a.bindingsChartClick(this, c);
          }));
          a.eventsToUnbind.push(c(b.container, "mousemove", function (b) {
            a.bindingsContainerMouseMove(this, b);
          }));
        },
        initUpdate: function initUpdate() {
          var a = this;
          e.addUpdate(function (b) {
            a.update(b);
          }, this.chart);
        },
        bindingsButtonClick: function bindingsButtonClick(a, b, c) {
          var d = this.chart;
          this.selectedButtonElement && (m(this, "deselectButton", {
            button: this.selectedButtonElement
          }), this.nextEvent && (this.currentUserDetails && "annotations" === this.currentUserDetails.coll && d.removeAnnotation(this.currentUserDetails), this.mouseMoveEvent = this.nextEvent = !1));
          this.selectedButton = b;
          this.selectedButtonElement = a;
          m(this, "selectButton", {
            button: a
          });
          b.init && b.init.call(this, a, c);
          (b.start || b.steps) && d.renderer.boxWrapper.addClass("highcharts-draw-mode");
        },
        bindingsChartClick: function bindingsChartClick(a, b) {
          a = this.selectedButton;
          var c = this.chart.renderer.boxWrapper;
          this.activeAnnotation && !b.activeAnnotation && b.target.parentNode && !b.target.closest(".highcharts-popup") && (m(this, "closePopup"), this.deselectAnnotation());
          a && a.start && (this.nextEvent ? (this.nextEvent(b, this.currentUserDetails), this.steps && (this.stepIndex++, a.steps[this.stepIndex] ? this.mouseMoveEvent = this.nextEvent = a.steps[this.stepIndex] : (m(this, "deselectButton", {
            button: this.selectedButtonElement
          }), c.removeClass("highcharts-draw-mode"), a.end && a.end.call(this, b, this.currentUserDetails), this.mouseMoveEvent = this.nextEvent = !1, this.selectedButton = null))) : (this.currentUserDetails = a.start.call(this, b), a.steps ? (this.stepIndex = 0, this.steps = !0, this.mouseMoveEvent = this.nextEvent = a.steps[this.stepIndex]) : (m(this, "deselectButton", {
            button: this.selectedButtonElement
          }), c.removeClass("highcharts-draw-mode"), this.steps = !1, this.selectedButton = null, a.end && a.end.call(this, b, this.currentUserDetails))));
        },
        bindingsContainerMouseMove: function bindingsContainerMouseMove(a, b) {
          this.mouseMoveEvent && this.mouseMoveEvent(b, this.currentUserDetails);
        },
        fieldsToOptions: function fieldsToOptions(a, b) {
          p(a, function (a, c) {
            var d = parseFloat(a),
                g = c.split("."),
                k = b,
                e = g.length - 1;
            !n(d) || a.match(/px/g) || c.match(/format/g) || (a = d);
            "" !== a && "undefined" !== a && g.forEach(function (b, c) {
              var d = f(g[c + 1], "");
              e === c ? k[b] = a : (k[b] || (k[b] = d.match(/\d/g) ? [] : {}), k = k[b]);
            });
          });
          return b;
        },
        deselectAnnotation: function deselectAnnotation() {
          this.activeAnnotation && (this.activeAnnotation.setControlPointsVisibility(!1), this.activeAnnotation = !1);
        },
        annotationToFields: function annotationToFields(b) {
          function c(d, e, u, f) {
            var v;
            u && -1 === n.indexOf(e) && (0 <= (u.indexOf && u.indexOf(e)) || u[e] || !0 === u) && (g(d) ? (f[e] = [], d.forEach(function (a, b) {
              k(a) ? (f[e][b] = {}, p(a, function (a, d) {
                c(a, d, q[e], f[e][b]);
              })) : c(a, 0, q[e], f[e]);
            })) : k(d) ? (v = {}, g(f) ? (f.push(v), v[e] = {}, v = v[e]) : f[e] = v, p(d, function (a, b) {
              c(a, b, 0 === e ? u : q[e], v);
            })) : "format" === e ? f[e] = [a.format(d, b.labels[0].points[0]).toString(), "text"] : g(f) ? f.push([d, h(d)]) : f[e] = [d, h(d)]);
          }

          var d = b.options,
              e = a.NavigationBindings.annotationsEditable,
              q = e.nestedOptions,
              h = this.utils.getFieldType,
              l = f(d.type, d.shapes && d.shapes[0] && d.shapes[0].type, d.labels && d.labels[0] && d.labels[0].itemType, "label"),
              n = a.NavigationBindings.annotationsNonEditable[d.langKey] || [],
              m = {
            langKey: d.langKey,
            type: l
          };
          p(d, function (a, b) {
            "typeOptions" === b ? (m[b] = {}, p(d[b], function (a, d) {
              c(a, d, q, m[b], !0);
            })) : c(a, b, e[l], m);
          });
          return m;
        },
        getClickedClassNames: function getClickedClassNames(b, c) {
          var d = c.target;
          c = [];

          for (var g; d && ((g = a.attr(d, "class")) && (c = c.concat(g.split(" ").map(function (a) {
            return [a, d];
          }))), d = d.parentNode, d !== b);) {
            ;
          }

          return c;
        },
        getButtonEvents: function getButtonEvents(a, b) {
          var c = this,
              d;
          this.getClickedClassNames(a, b).forEach(function (a) {
            c.boundClassNames[a[0]] && !d && (d = {
              events: c.boundClassNames[a[0]],
              button: a[1]
            });
          });
          return d;
        },
        update: function update(a) {
          this.options = l(!0, this.options, a);
          this.removeEvents();
          this.initEvents();
        },
        removeEvents: function removeEvents() {
          this.eventsToUnbind.forEach(function (a) {
            a();
          });
        },
        destroy: function destroy() {
          this.removeEvents();
        },
        utils: {
          updateRectSize: function updateRectSize(a, b) {
            var c = b.options.typeOptions,
                d = this.chart.xAxis[0].toValue(a.chartX);
            a = this.chart.yAxis[0].toValue(a.chartY);
            b.update({
              typeOptions: {
                background: {
                  width: d - c.point.x,
                  height: c.point.y - a
                }
              }
            });
          },
          getFieldType: function getFieldType(a) {
            return {
              string: "text",
              number: "number",
              "boolean": "checkbox"
            }[typeof a];
          }
        }
      });

      a.Chart.prototype.initNavigationBindings = function () {
        var b = this.options;
        b && b.navigation && b.navigation.bindings && (this.navigationBindings = new a.NavigationBindings(this, b.navigation), this.navigationBindings.initEvents(), this.navigationBindings.initUpdate());
      };

      c(a.Chart, "load", function () {
        this.initNavigationBindings();
      });
      c(a.Chart, "destroy", function () {
        this.navigationBindings && this.navigationBindings.destroy();
      });
      c(a.NavigationBindings, "deselectButton", function () {
        this.selectedButtonElement = null;
      });
      a.Annotation && (d(a.Annotation), a.objectEach(a.Annotation.types, function (a) {
        d(a);
      }));
      a.setOptions({
        lang: {
          navigation: {
            popup: {
              simpleShapes: "Simple shapes",
              lines: "Lines",
              circle: "Circle",
              rectangle: "Rectangle",
              label: "Label",
              shapeOptions: "Shape options",
              typeOptions: "Details",
              fill: "Fill",
              format: "Text",
              strokeWidth: "Line width",
              stroke: "Line color",
              title: "Title",
              name: "Name",
              labelOptions: "Label options",
              labels: "Labels",
              backgroundColor: "Background color",
              backgroundColors: "Background colors",
              borderColor: "Border color",
              borderRadius: "Border radius",
              borderWidth: "Border width",
              style: "Style",
              padding: "Padding",
              fontSize: "Font size",
              color: "Color",
              height: "Height",
              shapes: "Shape options"
            }
          }
        },
        navigation: {
          bindingsClassName: "highcharts-bindings-wrapper",
          bindings: {
            circleAnnotation: {
              className: "highcharts-circle-annotation",
              start: function start(b) {
                var c = this.chart.xAxis[0].toValue(b.chartX);
                b = this.chart.yAxis[0].toValue(b.chartY);
                return this.chart.addAnnotation({
                  langKey: "circle",
                  shapes: [{
                    type: "circle",
                    point: {
                      xAxis: 0,
                      yAxis: 0,
                      x: c,
                      y: b
                    },
                    r: 5,
                    controlPoints: [{
                      positioner: function positioner(b) {
                        var c = a.Annotation.MockPoint.pointToPixels(b.points[0]);
                        b = b.options.r;
                        return {
                          x: c.x + b * Math.cos(Math.PI / 4) - this.graphic.width / 2,
                          y: c.y + b * Math.sin(Math.PI / 4) - this.graphic.height / 2
                        };
                      },
                      events: {
                        drag: function drag(a, b) {
                          var c = b.annotation;
                          a = this.mouseMoveToTranslation(a);
                          b.setRadius(Math.max(b.options.r + a.y / Math.sin(Math.PI / 4), 5));
                          c.options.shapes[0] = c.userOptions.shapes[0] = b.options;
                          b.redraw(!1);
                        }
                      }
                    }]
                  }]
                });
              },
              steps: [function (a, b) {
                var c = b.options.shapes[0].point,
                    d = this.chart.xAxis[0].toPixels(c.x),
                    c = this.chart.yAxis[0].toPixels(c.y);
                b.update({
                  shapes: [{
                    r: Math.max(Math.sqrt(Math.pow(d - a.chartX, 2) + Math.pow(c - a.chartY, 2)), 5)
                  }]
                });
              }]
            },
            rectangleAnnotation: {
              className: "highcharts-rectangle-annotation",
              start: function start(b) {
                var c = this.chart.xAxis[0].toValue(b.chartX);
                b = this.chart.yAxis[0].toValue(b.chartY);
                return this.chart.addAnnotation({
                  langKey: "rectangle",
                  shapes: [{
                    type: "rect",
                    point: {
                      x: c,
                      y: b,
                      xAxis: 0,
                      yAxis: 0
                    },
                    width: 5,
                    height: 5,
                    controlPoints: [{
                      positioner: function positioner(b) {
                        var c = a.Annotation.MockPoint.pointToPixels(b.points[0]);
                        return {
                          x: c.x + b.options.width - 4,
                          y: c.y + b.options.height - 4
                        };
                      },
                      events: {
                        drag: function drag(a, b) {
                          var c = b.annotation;
                          a = this.mouseMoveToTranslation(a);
                          b.options.width = Math.max(b.options.width + a.x, 5);
                          b.options.height = Math.max(b.options.height + a.y, 5);
                          c.options.shapes[0] = b.options;
                          c.userOptions.shapes[0] = b.options;
                          b.redraw(!1);
                        }
                      }
                    }]
                  }]
                });
              },
              steps: [function (a, b) {
                var c = this.chart.yAxis[0],
                    d = b.options.shapes[0].point,
                    g = this.chart.xAxis[0].toPixels(d.x),
                    c = c.toPixels(d.y);
                b.update({
                  shapes: [{
                    width: Math.max(a.chartX - g, 5),
                    height: Math.max(a.chartY - c, 5),
                    point: {
                      x: d.x,
                      y: d.y
                    }
                  }]
                });
              }]
            },
            labelAnnotation: {
              className: "highcharts-label-annotation",
              start: function start(b) {
                var c = this.chart.xAxis[0].toValue(b.chartX);
                b = this.chart.yAxis[0].toValue(b.chartY);
                this.chart.addAnnotation({
                  langKey: "label",
                  labelOptions: {
                    format: "{y:.2f}"
                  },
                  labels: [{
                    point: {
                      x: c,
                      y: b,
                      xAxis: 0,
                      yAxis: 0
                    },
                    controlPoints: [{
                      symbol: "triangle-down",
                      positioner: function positioner(b) {
                        if (!b.graphic.placed) return {
                          x: 0,
                          y: -9E7
                        };
                        b = a.Annotation.MockPoint.pointToPixels(b.points[0]);
                        return {
                          x: b.x - this.graphic.width / 2,
                          y: b.y - this.graphic.height / 2
                        };
                      },
                      events: {
                        drag: function drag(a, b) {
                          a = this.mouseMoveToTranslation(a);
                          b.translatePoint(a.x, a.y);
                          b.annotation.labels[0].options = b.options;
                          b.redraw(!1);
                        }
                      }
                    }, {
                      symbol: "square",
                      positioner: function positioner(a) {
                        return a.graphic.placed ? {
                          x: a.graphic.alignAttr.x - this.graphic.width / 2,
                          y: a.graphic.alignAttr.y - this.graphic.height / 2
                        } : {
                          x: 0,
                          y: -9E7
                        };
                      },
                      events: {
                        drag: function drag(a, b) {
                          a = this.mouseMoveToTranslation(a);
                          b.translate(a.x, a.y);
                          b.annotation.labels[0].options = b.options;
                          b.redraw(!1);
                        }
                      }
                    }],
                    overflow: "none",
                    crop: !0
                  }]
                });
              }
            }
          },
          events: {}
        }
      });
    })(m, y);

    (function (a) {
      var e = a.addEvent,
          d = a.createElement,
          b = a.objectEach,
          c = a.pick,
          f = a.wrap,
          l = a.isString,
          h = a.isObject,
          m = a.isArray,
          t = /\d/g;
      f(a.Pointer.prototype, "onContainerMouseDown", function (a, b) {
        var c = b.target && b.target.className;
        l(c) && 0 <= c.indexOf("highcharts-popup-field") || a.apply(this, Array.prototype.slice.call(arguments, 1));
      });

      a.Popup = function (a) {
        this.init(a);
      };

      a.Popup.prototype = {
        init: function init(a) {
          this.container = d("div", {
            className: "highcharts-popup"
          }, null, a);
          this.lang = this.getLangpack();
          this.addCloseBtn();
        },
        addCloseBtn: function addCloseBtn() {
          var a = this,
              b;
          b = d("div", {
            className: "highcharts-popup-close"
          }, null, this.container);
          ["click", "touchstart"].forEach(function (c) {
            e(b, c, function () {
              a.closePopup();
            });
          });
        },
        addColsContainer: function addColsContainer(a) {
          var b;
          b = d("div", {
            className: "highcharts-popup-lhs-col"
          }, null, a);
          a = d("div", {
            className: "highcharts-popup-rhs-col"
          }, null, a);
          d("div", {
            className: "highcharts-popup-rhs-col-wrapper"
          }, null, a);
          return {
            lhsCol: b,
            rhsCol: a
          };
        },
        addInput: function addInput(a, b, c, e) {
          var g = a.split("."),
              g = g[g.length - 1],
              k = this.lang;
          b = "highcharts-" + b + "-" + g;
          b.match(t) || d("label", {
            innerHTML: k[g] || g,
            htmlFor: b
          }, null, c);
          d("input", {
            name: b,
            value: e[0],
            type: e[1],
            className: "highcharts-popup-field"
          }, null, c).setAttribute("highcharts-data-name", a);
        },
        addButton: function addButton(a, b, c, f, h) {
          var g = this,
              k = this.closePopup,
              p = this.getFields,
              q;
          q = d("button", {
            innerHTML: b
          }, null, a);
          ["click", "touchstart"].forEach(function (a) {
            e(q, a, function () {
              k.call(g);
              return f(p(h, c));
            });
          });
          return q;
        },
        getFields: function getFields(a, b) {
          var c = a.querySelectorAll("input"),
              d = a.querySelectorAll("#highcharts-select-series \x3e option:checked")[0];
          a = a.querySelectorAll("#highcharts-select-volume \x3e option:checked")[0];
          var e, g, k;
          k = {
            actionType: b,
            linkedTo: d && d.getAttribute("value"),
            fields: {}
          };
          c.forEach(function (a) {
            g = a.getAttribute("highcharts-data-name");
            (e = a.getAttribute("highcharts-data-series-id")) ? k.seriesId = a.value : g ? k.fields[g] = a.value : k.type = a.value;
          });
          a && (k.fields["params.volumeSeriesID"] = a.getAttribute("value"));
          return k;
        },
        showPopup: function showPopup() {
          var a = this.container,
              b = a.querySelectorAll(".highcharts-popup-close")[0];
          a.innerHTML = "";
          0 <= a.className.indexOf("highcharts-annotation-toolbar") && (a.classList.remove("highcharts-annotation-toolbar"), a.removeAttribute("style"));
          a.appendChild(b);
          a.style.display = "block";
        },
        closePopup: function closePopup() {
          this.popup.container.style.display = "none";
        },
        showForm: function showForm(a, b, c, d) {
          this.popup = b.navigationBindings.popup;
          this.showPopup();
          "indicators" === a && this.indicators.addForm.call(this, b, c, d);
          "annotation-toolbar" === a && this.annotations.addToolbar.call(this, b, c, d);
          "annotation-edit" === a && this.annotations.addForm.call(this, b, c, d);
          "flag" === a && this.annotations.addForm.call(this, b, c, d, !0);
        },
        getLangpack: function getLangpack() {
          return a.getOptions().lang.navigation.popup;
        },
        annotations: {
          addToolbar: function addToolbar(a, b, e) {
            var g = this,
                k = this.lang,
                f = this.popup.container,
                p = this.showForm,
                h;
            -1 === f.className.indexOf("highcharts-annotation-toolbar") && (f.className += " highcharts-annotation-toolbar");
            f.style.top = a.plotTop + 10 + "px";
            d("span", {
              innerHTML: c(k[b.langKey] || b.langKey, b.shapes && b.shapes[0].type)
            }, null, f);
            h = this.addButton(f, k.removeButton || "remove", "remove", e, f);
            h.className += " highcharts-annotation-remove-button";
            h = this.addButton(f, k.editButton || "edit", "edit", function () {
              p.call(g, "annotation-edit", a, b, e);
            }, f);
            h.className += " highcharts-annotation-edit-button";
          },
          addForm: function addForm(a, b, c, e) {
            var g = this.popup.container,
                k = this.lang,
                f,
                h;
            d("h2", {
              innerHTML: k[b.langKey] || b.langKey,
              className: "highcharts-popup-main-title"
            }, null, g);
            h = d("div", {
              className: "highcharts-popup-lhs-col highcharts-popup-lhs-full"
            }, null, g);
            f = d("div", {
              className: "highcharts-popup-bottom-row"
            }, null, g);
            this.annotations.addFormFields.call(this, h, a, "", b, [], !0);
            this.addButton(f, e ? k.addButton || "add" : k.saveButton || "save", e ? "add" : "save", c, g);
          },
          addFormFields: function addFormFields(a, c, e, f, l, u) {
            var g = this,
                k = this.annotations.addFormFields,
                p = this.addInput,
                q = this.lang,
                n,
                x;
            b(f, function (b, d) {
              n = "" !== e ? e + "." + d : d;
              h(b) && (!m(b) || m(b) && h(b[0]) ? (x = q[d] || d, x.match(t) || l.push([!0, x, a]), k.call(g, a, c, n, b, l, !1)) : l.push([g, n, "annotation", a, b]));
            });
            u && (l = l.sort(function (a) {
              return a[1].match(/format/g) ? -1 : 1;
            }), l.forEach(function (a) {
              !0 === a[0] ? d("span", {
                className: "highcharts-annotation-title",
                innerHTML: a[1]
              }, null, a[2]) : p.apply(a[0], a.splice(1));
            }));
          }
        },
        indicators: {
          addForm: function addForm(a, b, c) {
            var d = this.indicators,
                e = this.lang,
                g;
            this.tabs.init.call(this, a);
            b = this.popup.container.querySelectorAll(".highcharts-tab-item-content");
            this.addColsContainer(b[0]);
            d.addIndicatorList.call(this, a, b[0], "add");
            g = b[0].querySelectorAll(".highcharts-popup-rhs-col")[0];
            this.addButton(g, e.addButton || "add", "add", c, g);
            this.addColsContainer(b[1]);
            d.addIndicatorList.call(this, a, b[1], "edit");
            g = b[1].querySelectorAll(".highcharts-popup-rhs-col")[0];
            this.addButton(g, e.saveButton || "save", "edit", c, g);
            this.addButton(g, e.removeButton || "remove", "remove", c, g);
          },
          addIndicatorList: function addIndicatorList(c, k, f) {
            var g = this,
                h = k.querySelectorAll(".highcharts-popup-lhs-col")[0];
            k = k.querySelectorAll(".highcharts-popup-rhs-col")[0];
            var p = a.getOptions(),
                l = "edit" === f,
                m = l ? c.series : p.plotOptions,
                n = this.indicators.addFormFields,
                t,
                r,
                w;
            r = d("ul", {
              className: "highcharts-indicator-list"
            }, null, h);
            t = k.querySelectorAll(".highcharts-popup-rhs-col-wrapper")[0];
            b(m, function (a, b) {
              var k = a.options;

              if (a.params || k && k.params) {
                var f = g.indicators.getNameType(a, b),
                    h = f.type;
                w = d("li", {
                  className: "highcharts-indicator-list",
                  innerHTML: f.name
                }, null, r);
                ["click", "touchstart"].forEach(function (b) {
                  e(w, b, function () {
                    n.call(g, c, l ? a : m[h], f.type, t);
                    l && a.options && d("input", {
                      type: "hidden",
                      name: "highcharts-id-" + h,
                      value: a.options.id
                    }, null, t).setAttribute("highcharts-data-series-id", a.options.id);
                  });
                });
              }
            });
            0 < r.childNodes.length && r.childNodes[0].click();
          },
          getNameType: function getNameType(b, c) {
            var d = b.options,
                e = a.seriesTypes,
                e = e[c] && e[c].prototype.nameBase || c.toUpperCase();
            d && d.type && (c = b.options.type, e = b.name);
            return {
              name: e,
              type: c
            };
          },
          listAllSeries: function listAllSeries(a, b, c, e) {
            a = "highcharts-" + b + "-type-" + a;
            var g, f;
            d("label", {
              innerHTML: this.lang[b] || b,
              htmlFor: a
            }, null, e);
            g = d("select", {
              name: a,
              className: "highcharts-popup-field"
            }, null, e);
            g.setAttribute("id", "highcharts-select-" + b);
            c.series.forEach(function (a) {
              f = a.options;
              !f.params && f.id && "highcharts-navigator-series" !== f.id && d("option", {
                innerHTML: f.name || f.id,
                value: f.id
              }, null, g);
            });
          },
          addFormFields: function addFormFields(a, b, c, e) {
            var g = b.params || b.options.params,
                f = this.indicators.getNameType;
            e.innerHTML = "";
            d("h3", {
              className: "highcharts-indicator-title",
              innerHTML: f(b, c).name
            }, null, e);
            d("input", {
              type: "hidden",
              name: "highcharts-type-" + c,
              value: c
            }, null, e);
            this.indicators.listAllSeries.call(this, c, "series", a, e);
            g.volumeSeriesID && this.indicators.listAllSeries.call(this, c, "volume", a, e);
            this.indicators.addParamInputs.call(this, a, "params", g, c, e);
          },
          addParamInputs: function addParamInputs(a, c, d, e, f) {
            var g = this,
                k = this.indicators.addParamInputs,
                p = this.addInput,
                l;
            b(d, function (b, d) {
              l = c + "." + d;
              h(b) ? k.call(g, a, l, b, e, f) : "params.volumeSeriesID" !== l && p.call(g, l, e, f, [b, "text"]);
            });
          },
          getAmount: function getAmount() {
            var a = 0;
            b(this.series, function (b) {
              var c = b.options;
              (b.params || c && c.params) && a++;
            });
            return a;
          }
        },
        tabs: {
          init: function init(a) {
            var b = this.tabs;
            a = this.indicators.getAmount.call(a);
            var c;
            c = b.addMenuItem.call(this, "add");
            b.addMenuItem.call(this, "edit", a);
            b.addContentItem.call(this, "add");
            b.addContentItem.call(this, "edit");
            b.switchTabs.call(this, a);
            b.selectTab.call(this, c, 0);
          },
          addMenuItem: function addMenuItem(a, b) {
            var c = this.popup.container,
                e = "highcharts-tab-item",
                f = this.lang;
            0 === b && (e += " highcharts-tab-disabled");
            b = d("span", {
              innerHTML: f[a + "Button"] || a,
              className: e
            }, null, c);
            b.setAttribute("highcharts-data-tab-type", a);
            return b;
          },
          addContentItem: function addContentItem() {
            return d("div", {
              className: "highcharts-tab-item-content"
            }, null, this.popup.container);
          },
          switchTabs: function switchTabs(a) {
            var b = this,
                c;
            this.popup.container.querySelectorAll(".highcharts-tab-item").forEach(function (d, f) {
              c = d.getAttribute("highcharts-data-tab-type");
              "edit" === c && 0 === a || ["click", "touchstart"].forEach(function (a) {
                e(d, a, function () {
                  b.tabs.deselectAll.call(b);
                  b.tabs.selectTab.call(b, this, f);
                });
              });
            });
          },
          selectTab: function selectTab(a, b) {
            var c = this.popup.container.querySelectorAll(".highcharts-tab-item-content");
            a.className += " highcharts-tab-item-active";
            c[b].className += " highcharts-tab-item-show";
          },
          deselectAll: function deselectAll() {
            var a = this.popup.container,
                b = a.querySelectorAll(".highcharts-tab-item"),
                a = a.querySelectorAll(".highcharts-tab-item-content"),
                c;

            for (c = 0; c < b.length; c++) {
              b[c].classList.remove("highcharts-tab-item-active"), a[c].classList.remove("highcharts-tab-item-show");
            }
          }
        }
      };
      e(a.NavigationBindings, "showPopup", function (b) {
        this.popup || (this.popup = new a.Popup(this.chart.container));
        this.popup.showForm(b.formType, this.chart, b.options, b.onSubmit);
      });
      e(a.NavigationBindings, "closePopup", function () {
        this.popup && this.popup.closePopup();
      });
    })(m);
  });
});
var bullet = createCommonjsModule(function (module) {
  /*
    Highcharts JS v7.0.3 (2019-02-06)
  
   Bullet graph series type for Highcharts
  
   (c) 2010-2019 Kacper Madej
  
   License: www.highcharts.com/license
  */
  (function (a) {
    module.exports ? (a["default"] = a, module.exports = a) : a("undefined" !== typeof Highcharts ? Highcharts : void 0);
  })(function (a) {
    (function (a) {
      var r = a.pick,
          n = a.isNumber,
          v = a.relativeLength,
          p = a.seriesType,
          f = a.seriesTypes.column.prototype;
      p("bullet", "column", {
        targetOptions: {
          width: "140%",
          height: 3,
          borderWidth: 0
        },
        tooltip: {
          pointFormat: "<span style=\"color:{series.color}\">\u25CF</span> {series.name}: <b>{point.y}</b>. Target: <b>{point.target}</b><br/>"
        }
      }, {
        pointArrayMap: ["y", "target"],
        parallelArrays: ["x", "y", "target"],
        drawPoints: function drawPoints() {
          var b = this,
              k = b.chart,
              h = b.options,
              p = h.animationLimit || 250;
          f.drawPoints.apply(this);
          b.points.forEach(function (c) {
            var f = c.options,
                g,
                d = c.targetGraphic,
                l = c.target,
                m = c.y,
                q,
                t,
                e,
                u;
            n(l) && null !== l ? (e = a.merge(h.targetOptions, f.targetOptions), t = e.height, g = c.shapeArgs, q = v(e.width, g.width), u = b.yAxis.translate(l, !1, !0, !1, !0) - e.height / 2 - .5, g = b.crispCol.apply({
              chart: k,
              borderWidth: e.borderWidth,
              options: {
                crisp: h.crisp
              }
            }, [g.x + g.width / 2 - q / 2, u, q, t]), d ? (d[k.pointCount < p ? "animate" : "attr"](g), n(m) && null !== m ? d.element.point = c : d.element.point = void 0) : c.targetGraphic = d = k.renderer.rect().attr(g).add(b.group), k.styledMode || d.attr({
              fill: r(e.color, f.color, b.zones.length && (c.getZone.call({
                series: b,
                x: c.x,
                y: l,
                options: {}
              }).color || b.color) || void 0, c.color, b.color),
              stroke: r(e.borderColor, c.borderColor, b.options.borderColor),
              "stroke-width": e.borderWidth
            }), n(m) && null !== m && (d.element.point = c), d.addClass(c.getClassName() + " highcharts-bullet-target", !0)) : d && (c.targetGraphic = d.destroy());
          });
        },
        getExtremes: function getExtremes(b) {
          var a = this.targetData,
              h;
          f.getExtremes.call(this, b);
          a && a.length && (b = this.dataMax, h = this.dataMin, f.getExtremes.call(this, a), this.dataMax = Math.max(this.dataMax, b), this.dataMin = Math.min(this.dataMin, h));
        }
      }, {
        destroy: function destroy() {
          this.targetGraphic && (this.targetGraphic = this.targetGraphic.destroy());
          f.pointClass.prototype.destroy.apply(this, arguments);
        }
      });
    })(a);
  });
});
var heatmap = createCommonjsModule(function (module) {
  /*
   Highcharts JS v7.0.3 (2019-02-06)
  
   (c) 2009-2019 Torstein Honsi
  
   License: www.highcharts.com/license
  */
  (function (h) {
    module.exports ? (h["default"] = h, module.exports = h) : h("undefined" !== typeof Highcharts ? Highcharts : void 0);
  })(function (h) {
    (function (b) {
      var h = b.addEvent,
          k = b.Axis,
          q = b.Chart,
          l = b.color,
          n,
          r = b.extend,
          p = b.isNumber,
          e = b.Legend,
          c = b.LegendSymbolMixin,
          v = b.noop,
          u = b.merge,
          t = b.pick;
      b.ColorAxis || (n = b.ColorAxis = function () {
        this.init.apply(this, arguments);
      }, r(n.prototype, k.prototype), r(n.prototype, {
        defaultColorAxisOptions: {
          lineWidth: 0,
          minPadding: 0,
          maxPadding: 0,
          gridLineWidth: 1,
          tickPixelInterval: 72,
          startOnTick: !0,
          endOnTick: !0,
          offset: 0,
          marker: {
            animation: {
              duration: 50
            },
            width: .01,
            color: "#999999"
          },
          labels: {
            overflow: "justify",
            rotation: 0
          },
          minColor: "#e6ebf5",
          maxColor: "#003399",
          tickLength: 5,
          showInLegend: !0
        },
        keepProps: ["legendGroup", "legendItemHeight", "legendItemWidth", "legendItem", "legendSymbol"].concat(k.prototype.keepProps),
        init: function init(a, d) {
          var f = "vertical" !== a.options.legend.layout,
              g;
          this.coll = "colorAxis";
          g = u(this.defaultColorAxisOptions, {
            side: f ? 2 : 1,
            reversed: !f
          }, d, {
            opposite: !f,
            showEmpty: !1,
            title: null,
            visible: a.options.legend.enabled
          });
          k.prototype.init.call(this, a, g);
          d.dataClasses && this.initDataClasses(d);
          this.initStops();
          this.horiz = f;
          this.zoomEnabled = !1;
          this.defaultLegendLength = 200;
        },
        initDataClasses: function initDataClasses(a) {
          var d = this.chart,
              f,
              g = 0,
              m = d.options.chart.colorCount,
              b = this.options,
              e = a.dataClasses.length;
          this.dataClasses = f = [];
          this.legendItems = [];
          a.dataClasses.forEach(function (a, c) {
            a = u(a);
            f.push(a);
            if (d.styledMode || !a.color) "category" === b.dataClassColor ? (d.styledMode || (c = d.options.colors, m = c.length, a.color = c[g]), a.colorIndex = g, g++, g === m && (g = 0)) : a.color = l(b.minColor).tweenTo(l(b.maxColor), 2 > e ? .5 : c / (e - 1));
          });
        },
        setTickPositions: function setTickPositions() {
          if (!this.dataClasses) return k.prototype.setTickPositions.call(this);
        },
        initStops: function initStops() {
          this.stops = this.options.stops || [[0, this.options.minColor], [1, this.options.maxColor]];
          this.stops.forEach(function (a) {
            a.color = l(a[1]);
          });
        },
        setOptions: function setOptions(a) {
          k.prototype.setOptions.call(this, a);
          this.options.crosshair = this.options.marker;
        },
        setAxisSize: function setAxisSize() {
          var a = this.legendSymbol,
              d = this.chart,
              f = d.options.legend || {},
              g,
              m;
          a ? (this.left = f = a.attr("x"), this.top = g = a.attr("y"), this.width = m = a.attr("width"), this.height = a = a.attr("height"), this.right = d.chartWidth - f - m, this.bottom = d.chartHeight - g - a, this.len = this.horiz ? m : a, this.pos = this.horiz ? f : g) : this.len = (this.horiz ? f.symbolWidth : f.symbolHeight) || this.defaultLegendLength;
        },
        normalizedValue: function normalizedValue(a) {
          this.isLog && (a = this.val2lin(a));
          return 1 - (this.max - a) / (this.max - this.min || 1);
        },
        toColor: function toColor(a, d) {
          var f = this.stops,
              g,
              m,
              b = this.dataClasses,
              c,
              e;
          if (b) for (e = b.length; e--;) {
            if (c = b[e], g = c.from, f = c.to, (void 0 === g || a >= g) && (void 0 === f || a <= f)) {
              m = c.color;
              d && (d.dataClass = e, d.colorIndex = c.colorIndex);
              break;
            }
          } else {
            a = this.normalizedValue(a);

            for (e = f.length; e-- && !(a > f[e][0]);) {
              ;
            }

            g = f[e] || f[e + 1];
            f = f[e + 1] || g;
            a = 1 - (f[0] - a) / (f[0] - g[0] || 1);
            m = g.color.tweenTo(f.color, a);
          }
          return m;
        },
        getOffset: function getOffset() {
          var a = this.legendGroup,
              d = this.chart.axisOffset[this.side];
          a && (this.axisParent = a, k.prototype.getOffset.call(this), this.added || (this.added = !0, this.labelLeft = 0, this.labelRight = this.width), this.chart.axisOffset[this.side] = d);
        },
        setLegendColor: function setLegendColor() {
          var a,
              d = this.reversed;
          a = d ? 1 : 0;
          d = d ? 0 : 1;
          a = this.horiz ? [a, 0, d, 0] : [0, d, 0, a];
          this.legendColor = {
            linearGradient: {
              x1: a[0],
              y1: a[1],
              x2: a[2],
              y2: a[3]
            },
            stops: this.stops
          };
        },
        drawLegendSymbol: function drawLegendSymbol(a, d) {
          var f = a.padding,
              g = a.options,
              e = this.horiz,
              c = t(g.symbolWidth, e ? this.defaultLegendLength : 12),
              b = t(g.symbolHeight, e ? 12 : this.defaultLegendLength),
              l = t(g.labelPadding, e ? 16 : 30),
              g = t(g.itemDistance, 10);
          this.setLegendColor();
          d.legendSymbol = this.chart.renderer.rect(0, a.baseline - 11, c, b).attr({
            zIndex: 1
          }).add(d.legendGroup);
          this.legendItemWidth = c + f + (e ? g : l);
          this.legendItemHeight = b + f + (e ? l : 0);
        },
        setState: function setState(a) {
          this.series.forEach(function (d) {
            d.setState(a);
          });
        },
        visible: !0,
        setVisible: v,
        getSeriesExtremes: function getSeriesExtremes() {
          var a = this.series,
              d = a.length;
          this.dataMin = Infinity;

          for (this.dataMax = -Infinity; d--;) {
            a[d].getExtremes(), void 0 !== a[d].valueMin && (this.dataMin = Math.min(this.dataMin, a[d].valueMin), this.dataMax = Math.max(this.dataMax, a[d].valueMax));
          }
        },
        drawCrosshair: function drawCrosshair(a, d) {
          var f = d && d.plotX,
              e = d && d.plotY,
              c,
              b = this.pos,
              l = this.len;
          d && (c = this.toPixels(d[d.series.colorKey]), c < b ? c = b - 2 : c > b + l && (c = b + l + 2), d.plotX = c, d.plotY = this.len - c, k.prototype.drawCrosshair.call(this, a, d), d.plotX = f, d.plotY = e, this.cross && !this.cross.addedToColorAxis && this.legendGroup && (this.cross.addClass("highcharts-coloraxis-marker").add(this.legendGroup), this.cross.addedToColorAxis = !0, this.chart.styledMode || this.cross.attr({
            fill: this.crosshair.color
          })));
        },
        getPlotLinePath: function getPlotLinePath(a, d, f, e, c) {
          return p(c) ? this.horiz ? ["M", c - 4, this.top - 6, "L", c + 4, this.top - 6, c, this.top, "Z"] : ["M", this.left, c, "L", this.left - 6, c + 6, this.left - 6, c - 6, "Z"] : k.prototype.getPlotLinePath.call(this, a, d, f, e);
        },
        update: function update(a, d) {
          var c = this.chart,
              e = c.legend;
          this.series.forEach(function (a) {
            a.isDirtyData = !0;
          });
          a.dataClasses && e.allItems && (e.allItems.forEach(function (a) {
            a.isDataClass && a.legendGroup && a.legendGroup.destroy();
          }), c.isDirtyLegend = !0);
          c.options[this.coll] = u(this.userOptions, a);
          k.prototype.update.call(this, a, d);
          this.legendItem && (this.setLegendColor(), e.colorizeItem(this, !0));
        },
        remove: function remove() {
          this.legendItem && this.chart.legend.destroyItem(this);
          k.prototype.remove.call(this);
        },
        getDataClassLegendSymbols: function getDataClassLegendSymbols() {
          var a = this,
              d = this.chart,
              e = this.legendItems,
              g = d.options.legend,
              l = g.valueDecimals,
              n = g.valueSuffix || "",
              h;
          e.length || this.dataClasses.forEach(function (f, g) {
            var k = !0,
                m = f.from,
                p = f.to;
            h = "";
            void 0 === m ? h = "\x3c " : void 0 === p && (h = "\x3e ");
            void 0 !== m && (h += b.numberFormat(m, l) + n);
            void 0 !== m && void 0 !== p && (h += " - ");
            void 0 !== p && (h += b.numberFormat(p, l) + n);
            e.push(r({
              chart: d,
              name: h,
              options: {},
              drawLegendSymbol: c.drawRectangle,
              visible: !0,
              setState: v,
              isDataClass: !0,
              setVisible: function setVisible() {
                k = this.visible = !k;
                a.series.forEach(function (a) {
                  a.points.forEach(function (a) {
                    a.dataClass === g && a.setVisible(k);
                  });
                });
                d.legend.colorizeItem(this, k);
              }
            }, f));
          });
          return e;
        },
        name: ""
      }), ["fill", "stroke"].forEach(function (a) {
        b.Fx.prototype[a + "Setter"] = function () {
          this.elem.attr(a, l(this.start).tweenTo(l(this.end), this.pos), null, !0);
        };
      }), h(q, "afterGetAxes", function () {
        var a = this.options.colorAxis;
        this.colorAxis = [];
        a && new n(this, a);
      }), h(e, "afterGetAllItems", function (a) {
        var d = [],
            c = this.chart.colorAxis[0];
        c && c.options && c.options.showInLegend && (c.options.dataClasses ? d = c.getDataClassLegendSymbols() : d.push(c), c.series.forEach(function (c) {
          b.erase(a.allItems, c);
        }));

        for (c = d.length; c--;) {
          a.allItems.unshift(d[c]);
        }
      }), h(e, "afterColorizeItem", function (a) {
        a.visible && a.item.legendColor && a.item.legendSymbol.attr({
          fill: a.item.legendColor
        });
      }), h(e, "afterUpdate", function (a, c, e) {
        this.chart.colorAxis[0] && this.chart.colorAxis[0].update({}, e);
      }));
    })(h);

    (function (b) {
      var h = b.defined,
          k = b.noop,
          q = b.seriesTypes;
      b.colorPointMixin = {
        isValid: function isValid() {
          return null !== this.value && Infinity !== this.value && -Infinity !== this.value;
        },
        setVisible: function setVisible(b) {
          var l = this,
              h = b ? "show" : "hide";
          l.visible = !!b;
          ["graphic", "dataLabel"].forEach(function (b) {
            if (l[b]) l[b][h]();
          });
        },
        setState: function setState(l) {
          b.Point.prototype.setState.call(this, l);
          this.graphic && this.graphic.attr({
            zIndex: "hover" === l ? 1 : 0
          });
        }
      };
      b.colorSeriesMixin = {
        pointArrayMap: ["value"],
        axisTypes: ["xAxis", "yAxis", "colorAxis"],
        optionalAxis: "colorAxis",
        trackerGroups: ["group", "markerGroup", "dataLabelsGroup"],
        getSymbol: k,
        parallelArrays: ["x", "y", "value"],
        colorKey: "value",
        pointAttribs: q.column.prototype.pointAttribs,
        translateColors: function translateColors() {
          var b = this,
              h = this.options.nullColor,
              k = this.colorAxis,
              p = this.colorKey;
          this.data.forEach(function (e) {
            var c = e[p];
            if (c = e.options.color || (e.isNull ? h : k && void 0 !== c ? k.toColor(c, e) : e.color || b.color)) e.color = c;
          });
        },
        colorAttribs: function colorAttribs(b) {
          var l = {};
          h(b.color) && (l[this.colorProp || "fill"] = b.color);
          return l;
        }
      };
    })(h);

    (function (b) {
      var h = b.colorPointMixin,
          k = b.merge,
          q = b.noop,
          l = b.pick,
          n = b.Series,
          r = b.seriesType,
          p = b.seriesTypes;
      r("heatmap", "scatter", {
        animation: !1,
        borderWidth: 0,
        nullColor: "#f7f7f7",
        dataLabels: {
          formatter: function formatter() {
            return this.point.value;
          },
          inside: !0,
          verticalAlign: "middle",
          crop: !1,
          overflow: !1,
          padding: 0
        },
        marker: null,
        pointRange: null,
        tooltip: {
          pointFormat: "{point.x}, {point.y}: {point.value}\x3cbr/\x3e"
        },
        states: {
          hover: {
            halo: !1,
            brightness: .2
          }
        }
      }, k(b.colorSeriesMixin, {
        pointArrayMap: ["y", "value"],
        hasPointSpecificOptions: !0,
        getExtremesFromAll: !0,
        directTouch: !0,
        init: function init() {
          var e;
          p.scatter.prototype.init.apply(this, arguments);
          e = this.options;
          e.pointRange = l(e.pointRange, e.colsize || 1);
          this.yAxis.axisPointRange = e.rowsize || 1;
        },
        translate: function translate() {
          var e = this.options,
              c = this.xAxis,
              b = this.yAxis,
              h = e.pointPadding || 0,
              k = function k(a, c, b) {
            return Math.min(Math.max(c, a), b);
          },
              a = this.pointPlacementToXValue();

          this.generatePoints();
          this.points.forEach(function (d) {
            var f = (e.colsize || 1) / 2,
                g = (e.rowsize || 1) / 2,
                m = k(Math.round(c.len - c.translate(d.x - f, 0, 1, 0, 1, -a)), -c.len, 2 * c.len),
                f = k(Math.round(c.len - c.translate(d.x + f, 0, 1, 0, 1, -a)), -c.len, 2 * c.len),
                p = k(Math.round(b.translate(d.y - g, 0, 1, 0, 1)), -b.len, 2 * b.len),
                g = k(Math.round(b.translate(d.y + g, 0, 1, 0, 1)), -b.len, 2 * b.len),
                n = l(d.pointPadding, h);
            d.plotX = d.clientX = (m + f) / 2;
            d.plotY = (p + g) / 2;
            d.shapeType = "rect";
            d.shapeArgs = {
              x: Math.min(m, f) + n,
              y: Math.min(p, g) + n,
              width: Math.abs(f - m) - 2 * n,
              height: Math.abs(g - p) - 2 * n
            };
          });
          this.translateColors();
        },
        drawPoints: function drawPoints() {
          var b = this.chart.styledMode ? "css" : "attr";
          p.column.prototype.drawPoints.call(this);
          this.points.forEach(function (c) {
            c.graphic[b](this.colorAttribs(c));
          }, this);
        },
        getValidPoints: function getValidPoints(b, c) {
          return n.prototype.getValidPoints.call(this, b, c, !0);
        },
        animate: q,
        getBox: q,
        drawLegendSymbol: b.LegendSymbolMixin.drawRectangle,
        alignDataLabel: p.column.prototype.alignDataLabel,
        getExtremes: function getExtremes() {
          n.prototype.getExtremes.call(this, this.valueData);
          this.valueMin = this.dataMin;
          this.valueMax = this.dataMax;
          n.prototype.getExtremes.call(this);
        }
      }), b.extend({
        haloPath: function haloPath(b) {
          if (!b) return [];
          var c = this.shapeArgs;
          return ["M", c.x - b, c.y - b, "L", c.x - b, c.y + c.height + b, c.x + c.width + b, c.y + c.height + b, c.x + c.width + b, c.y - b, "Z"];
        }
      }, h));
    })(h);
  });
});
var treemap = createCommonjsModule(function (module) {
  /*
   Highcharts JS v7.0.3 (2019-02-06)
  
   (c) 2014-2019 Highsoft AS
   Authors: Jon Arild Nygard / Oystein Moseng
  
   License: www.highcharts.com/license
  */
  (function (m) {
    module.exports ? (m["default"] = m, module.exports = m) : m("undefined" !== typeof Highcharts ? Highcharts : void 0);
  })(function (m) {
    var F = function (c) {
      var w = c.extend,
          m = c.isArray,
          l = c.isObject,
          C = c.isNumber,
          r = c.merge,
          A = c.pick;
      return {
        getColor: function getColor(p, e) {
          var u = e.index,
              g = e.mapOptionsToLevel,
              l = e.parentColor,
              y = e.parentColorIndex,
              B = e.series,
              v = e.colors,
              m = e.siblings,
              h = B.points,
              q = B.chart.options.chart,
              z,
              w,
              x,
              r;

          if (p) {
            h = h[p.i];
            p = g[p.level] || {};
            if (g = h && p.colorByPoint) w = h.index % (v ? v.length : q.colorCount), z = v && v[w];

            if (!B.chart.styledMode) {
              v = h && h.options.color;
              q = p && p.color;
              if (x = l) x = (x = p && p.colorVariation) && "brightness" === x.key ? c.color(l).brighten(u / m * x.to).get() : l;
              x = A(v, q, z, x, B.color);
            }

            r = A(h && h.options.colorIndex, p && p.colorIndex, w, y, e.colorIndex);
          }

          return {
            color: x,
            colorIndex: r
          };
        },
        getLevelOptions: function getLevelOptions(c) {
          var e = null,
              u,
              g,
              p,
              y;
          if (l(c)) for (e = {}, p = C(c.from) ? c.from : 1, y = c.levels, g = {}, u = l(c.defaults) ? c.defaults : {}, m(y) && (g = y.reduce(function (c, e) {
            var g, h;
            l(e) && C(e.level) && (h = r({}, e), g = "boolean" === typeof h.levelIsConstant ? h.levelIsConstant : u.levelIsConstant, delete h.levelIsConstant, delete h.level, e = e.level + (g ? 0 : p - 1), l(c[e]) ? w(c[e], h) : c[e] = h);
            return c;
          }, {})), y = C(c.to) ? c.to : 1, c = 0; c <= y; c++) {
            e[c] = r({}, u, l(g[c]) ? g[c] : {});
          }
          return e;
        },
        setTreeValues: function e(c, g) {
          var l = g.before,
              u = g.idRoot,
              m = g.mapIdToNode[u],
              v = g.points[c.i],
              r = v && v.options || {},
              h = 0,
              q = [];
          w(c, {
            levelDynamic: c.level - (("boolean" === typeof g.levelIsConstant ? g.levelIsConstant : 1) ? 0 : m.level),
            name: A(v && v.name, ""),
            visible: u === c.id || ("boolean" === typeof g.visible ? g.visible : !1)
          });
          "function" === typeof l && (c = l(c, g));
          c.children.forEach(function (l, u) {
            var m = w({}, g);
            w(m, {
              index: u,
              siblings: c.children.length,
              visible: c.visible
            });
            l = e(l, m);
            q.push(l);
            l.visible && (h += l.val);
          });
          c.visible = 0 < h || c.visible;
          l = A(r.value, h);
          w(c, {
            children: q,
            childrenTotal: h,
            isLeaf: c.visible && !h,
            val: l
          });
          return c;
        },
        updateRootId: function updateRootId(c) {
          var e;
          l(c) && (e = l(c.options) ? c.options : {}, e = A(c.rootNode, e.rootId, ""), l(c.userOptions) && (c.userOptions.rootId = e), c.rootNode = e);
          return e;
        }
      };
    }(m);

    (function (c, m) {
      var w = c.seriesType,
          l = c.seriesTypes,
          C = c.addEvent,
          r = c.merge,
          A = c.extend,
          p = c.error,
          e = c.defined,
          u = c.noop,
          g = c.fireEvent,
          F = m.getColor,
          y = m.getLevelOptions,
          B = c.isArray,
          v = c.isNumber,
          H = c.isObject,
          h = c.isString,
          q = c.pick,
          z = c.Series,
          I = c.stableSort,
          x = c.Color,
          J = function J(a, b, d) {
        d = d || this;
        c.objectEach(a, function (n, f) {
          b.call(d, n, f, a);
        });
      },
          E = function E(a, b, d) {
        d = d || this;
        a = b.call(d, a);
        !1 !== a && E(a, b, d);
      },
          K = m.updateRootId;

      w("treemap", "scatter", {
        allowTraversingTree: !1,
        showInLegend: !1,
        marker: !1,
        colorByPoint: !1,
        dataLabels: {
          enabled: !0,
          defer: !1,
          verticalAlign: "middle",
          formatter: function formatter() {
            var a = this && this.point ? this.point : {};
            return h(a.name) ? a.name : "";
          },
          inside: !0
        },
        tooltip: {
          headerFormat: "",
          pointFormat: "\x3cb\x3e{point.name}\x3c/b\x3e: {point.value}\x3cbr/\x3e"
        },
        ignoreHiddenPoint: !0,
        layoutAlgorithm: "sliceAndDice",
        layoutStartingDirection: "vertical",
        alternateStartingDirection: !1,
        levelIsConstant: !0,
        drillUpButton: {
          position: {
            align: "right",
            x: -10,
            y: 10
          }
        },
        traverseUpButton: {
          position: {
            align: "right",
            x: -10,
            y: 10
          }
        },
        borderColor: "#e6e6e6",
        borderWidth: 1,
        opacity: .15,
        states: {
          hover: {
            borderColor: "#999999",
            brightness: l.heatmap ? 0 : .1,
            halo: !1,
            opacity: .75,
            shadow: !1
          }
        }
      }, {
        pointArrayMap: ["value"],
        directTouch: !0,
        optionalAxis: "colorAxis",
        getSymbol: u,
        parallelArrays: ["x", "y", "value", "colorValue"],
        colorKey: "colorValue",
        trackerGroups: ["group", "dataLabelsGroup"],
        getListOfParents: function getListOfParents(a, b) {
          a = B(a) ? a : [];
          var d = B(b) ? b : [];
          b = a.reduce(function (a, b, d) {
            b = q(b.parent, "");
            void 0 === a[b] && (a[b] = []);
            a[b].push(d);
            return a;
          }, {
            "": []
          });
          J(b, function (a, b, c) {
            "" !== b && -1 === d.indexOf(b) && (a.forEach(function (a) {
              c[""].push(a);
            }), delete c[b]);
          });
          return b;
        },
        getTree: function getTree() {
          var a = this.data.map(function (a) {
            return a.id;
          }),
              a = this.getListOfParents(this.data, a);
          this.nodeMap = [];
          return this.buildNode("", -1, 0, a, null);
        },
        init: function init(a, b) {
          var d = c.colorSeriesMixin;
          c.colorSeriesMixin && (this.translateColors = d.translateColors, this.colorAttribs = d.colorAttribs, this.axisTypes = d.axisTypes);
          C(this, "setOptions", function (a) {
            a = a.userOptions;
            e(a.allowDrillToNode) && !e(a.allowTraversingTree) && (a.allowTraversingTree = a.allowDrillToNode, delete a.allowDrillToNode);
            e(a.drillUpButton) && !e(a.traverseUpButton) && (a.traverseUpButton = a.drillUpButton, delete a.drillUpButton);
          });
          z.prototype.init.call(this, a, b);
          this.options.allowTraversingTree && C(this, "click", this.onClickDrillToNode);
        },
        buildNode: function buildNode(a, b, d, c, f) {
          var n = this,
              t = [],
              k = n.points[b],
              G = 0,
              e;
          (c[a] || []).forEach(function (b) {
            e = n.buildNode(n.points[b].id, b, d + 1, c, a);
            G = Math.max(e.height + 1, G);
            t.push(e);
          });
          b = {
            id: a,
            i: b,
            children: t,
            height: G,
            level: d,
            parent: f,
            visible: !1
          };
          n.nodeMap[b.id] = b;
          k && (k.node = b);
          return b;
        },
        setTreeValues: function setTreeValues(a) {
          var b = this,
              d = b.options,
              c = b.nodeMap[b.rootNode],
              d = "boolean" === typeof d.levelIsConstant ? d.levelIsConstant : !0,
              f = 0,
              D = [],
              t,
              k = b.points[a.i];
          a.children.forEach(function (a) {
            a = b.setTreeValues(a);
            D.push(a);
            a.ignore || (f += a.val);
          });
          I(D, function (a, b) {
            return a.sortIndex - b.sortIndex;
          });
          t = q(k && k.options.value, f);
          k && (k.value = t);
          A(a, {
            children: D,
            childrenTotal: f,
            ignore: !(q(k && k.visible, !0) && 0 < t),
            isLeaf: a.visible && !f,
            levelDynamic: a.level - (d ? 0 : c.level),
            name: q(k && k.name, ""),
            sortIndex: q(k && k.sortIndex, -t),
            val: t
          });
          return a;
        },
        calculateChildrenAreas: function calculateChildrenAreas(a, b) {
          var d = this,
              c = d.options,
              f = d.mapOptionsToLevel[a.level + 1],
              D = q(d[f && f.layoutAlgorithm] && f.layoutAlgorithm, c.layoutAlgorithm),
              t = c.alternateStartingDirection,
              k = [];
          a = a.children.filter(function (a) {
            return !a.ignore;
          });
          f && f.layoutStartingDirection && (b.direction = "vertical" === f.layoutStartingDirection ? 0 : 1);
          k = d[D](b, a);
          a.forEach(function (a, c) {
            c = k[c];
            a.values = r(c, {
              val: a.childrenTotal,
              direction: t ? 1 - b.direction : b.direction
            });
            a.pointValues = r(c, {
              x: c.x / d.axisRatio,
              width: c.width / d.axisRatio
            });
            a.children.length && d.calculateChildrenAreas(a, a.values);
          });
        },
        setPointValues: function setPointValues() {
          var a = this,
              b = a.xAxis,
              d = a.yAxis;
          a.points.forEach(function (c) {
            var f = c.node,
                n = f.pointValues,
                t,
                k,
                e = 0;
            a.chart.styledMode || (e = (a.pointAttribs(c)["stroke-width"] || 0) % 2 / 2);
            n && f.visible ? (f = Math.round(b.translate(n.x, 0, 0, 0, 1)) - e, t = Math.round(b.translate(n.x + n.width, 0, 0, 0, 1)) - e, k = Math.round(d.translate(n.y, 0, 0, 0, 1)) - e, n = Math.round(d.translate(n.y + n.height, 0, 0, 0, 1)) - e, c.shapeType = "rect", c.shapeArgs = {
              x: Math.min(f, t),
              y: Math.min(k, n),
              width: Math.abs(t - f),
              height: Math.abs(n - k)
            }, c.plotX = c.shapeArgs.x + c.shapeArgs.width / 2, c.plotY = c.shapeArgs.y + c.shapeArgs.height / 2) : (delete c.plotX, delete c.plotY);
          });
        },
        setColorRecursive: function setColorRecursive(a, b, d, c, f) {
          var n = this,
              e = n && n.chart,
              e = e && e.options && e.options.colors,
              k;

          if (a) {
            k = F(a, {
              colors: e,
              index: c,
              mapOptionsToLevel: n.mapOptionsToLevel,
              parentColor: b,
              parentColorIndex: d,
              series: n,
              siblings: f
            });
            if (b = n.points[a.i]) b.color = k.color, b.colorIndex = k.colorIndex;
            (a.children || []).forEach(function (b, d) {
              n.setColorRecursive(b, k.color, k.colorIndex, d, a.children.length);
            });
          }
        },
        algorithmGroup: function algorithmGroup(a, b, d, c) {
          this.height = a;
          this.width = b;
          this.plot = c;
          this.startDirection = this.direction = d;
          this.lH = this.nH = this.lW = this.nW = this.total = 0;
          this.elArr = [];
          this.lP = {
            total: 0,
            lH: 0,
            nH: 0,
            lW: 0,
            nW: 0,
            nR: 0,
            lR: 0,
            aspectRatio: function aspectRatio(a, b) {
              return Math.max(a / b, b / a);
            }
          };

          this.addElement = function (a) {
            this.lP.total = this.elArr[this.elArr.length - 1];
            this.total += a;
            0 === this.direction ? (this.lW = this.nW, this.lP.lH = this.lP.total / this.lW, this.lP.lR = this.lP.aspectRatio(this.lW, this.lP.lH), this.nW = this.total / this.height, this.lP.nH = this.lP.total / this.nW, this.lP.nR = this.lP.aspectRatio(this.nW, this.lP.nH)) : (this.lH = this.nH, this.lP.lW = this.lP.total / this.lH, this.lP.lR = this.lP.aspectRatio(this.lP.lW, this.lH), this.nH = this.total / this.width, this.lP.nW = this.lP.total / this.nH, this.lP.nR = this.lP.aspectRatio(this.lP.nW, this.nH));
            this.elArr.push(a);
          };

          this.reset = function () {
            this.lW = this.nW = 0;
            this.elArr = [];
            this.total = 0;
          };
        },
        algorithmCalcPoints: function algorithmCalcPoints(a, b, d, n) {
          var f,
              e,
              t,
              k,
              l = d.lW,
              h = d.lH,
              g = d.plot,
              m,
              q = 0,
              p = d.elArr.length - 1;
          b ? (l = d.nW, h = d.nH) : m = d.elArr[d.elArr.length - 1];
          d.elArr.forEach(function (a) {
            if (b || q < p) 0 === d.direction ? (f = g.x, e = g.y, t = l, k = a / t) : (f = g.x, e = g.y, k = h, t = a / k), n.push({
              x: f,
              y: e,
              width: t,
              height: c.correctFloat(k)
            }), 0 === d.direction ? g.y += k : g.x += t;
            q += 1;
          });
          d.reset();
          0 === d.direction ? d.width -= l : d.height -= h;
          g.y = g.parent.y + (g.parent.height - d.height);
          g.x = g.parent.x + (g.parent.width - d.width);
          a && (d.direction = 1 - d.direction);
          b || d.addElement(m);
        },
        algorithmLowAspectRatio: function algorithmLowAspectRatio(a, b, d) {
          var c = [],
              f = this,
              e,
              g = {
            x: b.x,
            y: b.y,
            parent: b
          },
              k = 0,
              l = d.length - 1,
              h = new this.algorithmGroup(b.height, b.width, b.direction, g);
          d.forEach(function (d) {
            e = d.val / b.val * b.height * b.width;
            h.addElement(e);
            h.lP.nR > h.lP.lR && f.algorithmCalcPoints(a, !1, h, c, g);
            k === l && f.algorithmCalcPoints(a, !0, h, c, g);
            k += 1;
          });
          return c;
        },
        algorithmFill: function algorithmFill(a, b, d) {
          var c = [],
              f,
              e = b.direction,
              g = b.x,
              k = b.y,
              h = b.width,
              l = b.height,
              m,
              q,
              p,
              r;
          d.forEach(function (d) {
            f = d.val / b.val * b.height * b.width;
            m = g;
            q = k;
            0 === e ? (r = l, p = f / r, h -= p, g += p) : (p = h, r = f / p, l -= r, k += r);
            c.push({
              x: m,
              y: q,
              width: p,
              height: r
            });
            a && (e = 1 - e);
          });
          return c;
        },
        strip: function strip(a, b) {
          return this.algorithmLowAspectRatio(!1, a, b);
        },
        squarified: function squarified(a, b) {
          return this.algorithmLowAspectRatio(!0, a, b);
        },
        sliceAndDice: function sliceAndDice(a, b) {
          return this.algorithmFill(!0, a, b);
        },
        stripes: function stripes(a, b) {
          return this.algorithmFill(!1, a, b);
        },
        translate: function translate() {
          var a = this,
              b = a.options,
              d = K(a),
              c,
              f;
          z.prototype.translate.call(a);
          f = a.tree = a.getTree();
          c = a.nodeMap[d];
          a.renderTraverseUpButton(d);
          a.mapOptionsToLevel = y({
            from: c.level + 1,
            levels: b.levels,
            to: f.height,
            defaults: {
              levelIsConstant: a.options.levelIsConstant,
              colorByPoint: b.colorByPoint
            }
          });
          "" === d || c && c.children.length || (a.setRootNode("", !1), d = a.rootNode, c = a.nodeMap[d]);
          E(a.nodeMap[a.rootNode], function (b) {
            var c = !1,
                d = b.parent;
            b.visible = !0;
            if (d || "" === d) c = a.nodeMap[d];
            return c;
          });
          E(a.nodeMap[a.rootNode].children, function (a) {
            var b = !1;
            a.forEach(function (a) {
              a.visible = !0;
              a.children.length && (b = (b || []).concat(a.children));
            });
            return b;
          });
          a.setTreeValues(f);
          a.axisRatio = a.xAxis.len / a.yAxis.len;
          a.nodeMap[""].pointValues = d = {
            x: 0,
            y: 0,
            width: 100,
            height: 100
          };
          a.nodeMap[""].values = d = r(d, {
            width: d.width * a.axisRatio,
            direction: "vertical" === b.layoutStartingDirection ? 0 : 1,
            val: f.val
          });
          a.calculateChildrenAreas(f, d);
          a.colorAxis ? a.translateColors() : b.colorByPoint || a.setColorRecursive(a.tree);
          b.allowTraversingTree && (b = c.pointValues, a.xAxis.setExtremes(b.x, b.x + b.width, !1), a.yAxis.setExtremes(b.y, b.y + b.height, !1), a.xAxis.setScale(), a.yAxis.setScale());
          a.setPointValues();
        },
        drawDataLabels: function drawDataLabels() {
          var a = this,
              b = a.mapOptionsToLevel,
              d,
              c;
          a.points.filter(function (a) {
            return a.node.visible;
          }).forEach(function (f) {
            c = b[f.node.level];
            d = {
              style: {}
            };
            f.node.isLeaf || (d.enabled = !1);
            c && c.dataLabels && (d = r(d, c.dataLabels), a._hasPointLabels = !0);
            f.shapeArgs && (d.style.width = f.shapeArgs.width, f.dataLabel && f.dataLabel.css({
              width: f.shapeArgs.width + "px"
            }));
            f.dlOptions = r(d, f.options.dataLabels);
          });
          z.prototype.drawDataLabels.call(this);
        },
        alignDataLabel: function alignDataLabel(a, b, d) {
          var e = d.style;
          !c.defined(e.textOverflow) && b.text && b.getBBox().width > b.text.textWidth && b.css({
            textOverflow: "ellipsis",
            width: e.width += "px"
          });
          l.column.prototype.alignDataLabel.apply(this, arguments);
          a.dataLabel && a.dataLabel.attr({
            zIndex: (a.node.zIndex || 0) + 1
          });
        },
        pointAttribs: function pointAttribs(a, b) {
          var c = H(this.mapOptionsToLevel) ? this.mapOptionsToLevel : {},
              e = a && c[a.node.level] || {},
              c = this.options,
              f = b && c.states[b] || {},
              g = a && a.getClassName() || "";
          a = {
            stroke: a && a.borderColor || e.borderColor || f.borderColor || c.borderColor,
            "stroke-width": q(a && a.borderWidth, e.borderWidth, f.borderWidth, c.borderWidth),
            dashstyle: a && a.borderDashStyle || e.borderDashStyle || f.borderDashStyle || c.borderDashStyle,
            fill: a && a.color || this.color
          };
          -1 !== g.indexOf("highcharts-above-level") ? (a.fill = "none", a["stroke-width"] = 0) : -1 !== g.indexOf("highcharts-internal-node-interactive") ? (b = q(f.opacity, c.opacity), a.fill = x(a.fill).setOpacity(b).get(), a.cursor = "pointer") : -1 !== g.indexOf("highcharts-internal-node") ? a.fill = "none" : b && (a.fill = x(a.fill).brighten(f.brightness).get());
          return a;
        },
        drawPoints: function drawPoints() {
          var a = this,
              b = a.points.filter(function (a) {
            return a.node.visible;
          });
          b.forEach(function (b) {
            var c = "level-group-" + b.node.levelDynamic;
            a[c] || (a[c] = a.chart.renderer.g(c).attr({
              zIndex: 1E3 - b.node.levelDynamic
            }).add(a.group));
            b.group = a[c];
          });
          l.column.prototype.drawPoints.call(this);
          this.colorAttribs && a.chart.styledMode && this.points.forEach(function (a) {
            a.graphic && a.graphic.css(this.colorAttribs(a));
          }, this);
          a.options.allowTraversingTree && b.forEach(function (b) {
            b.graphic && (b.drillId = a.options.interactByLeaf ? a.drillToByLeaf(b) : a.drillToByGroup(b));
          });
        },
        onClickDrillToNode: function onClickDrillToNode(a) {
          var b = (a = a.point) && a.drillId;
          h(b) && (a.setState(""), this.setRootNode(b, !0, {
            trigger: "click"
          }));
        },
        drillToByGroup: function drillToByGroup(a) {
          var b = !1;
          1 !== a.node.level - this.nodeMap[this.rootNode].level || a.node.isLeaf || (b = a.id);
          return b;
        },
        drillToByLeaf: function drillToByLeaf(a) {
          var b = !1;
          if (a.node.parent !== this.rootNode && a.node.isLeaf) for (a = a.node; !b;) {
            a = this.nodeMap[a.parent], a.parent === this.rootNode && (b = a.id);
          }
          return b;
        },
        drillUp: function drillUp() {
          var a = this.nodeMap[this.rootNode];
          a && h(a.parent) && this.setRootNode(a.parent, !0, {
            trigger: "traverseUpButton"
          });
        },
        drillToNode: function drillToNode(a, b) {
          p("WARNING: treemap.drillToNode has been renamed to treemap.setRootNode, and will be removed in the next major version.");
          this.setRootNode(a, b);
        },
        setRootNode: function setRootNode(a, b, c) {
          a = A({
            newRootId: a,
            previousRootId: this.rootNode,
            redraw: q(b, !0),
            series: this
          }, c);
          g(this, "setRootNode", a, function (a) {
            var b = a.series;
            b.idPreviousRoot = a.previousRootId;
            b.rootNode = a.newRootId;
            b.isDirty = !0;
            a.redraw && b.chart.redraw();
          });
        },
        renderTraverseUpButton: function renderTraverseUpButton(a) {
          var b = this,
              c = b.options.traverseUpButton,
              e = q(c.text, b.nodeMap[a].name, "\x3c Back"),
              f;
          "" === a ? b.drillUpButton && (b.drillUpButton = b.drillUpButton.destroy()) : this.drillUpButton ? (this.drillUpButton.placed = !1, this.drillUpButton.attr({
            text: e
          }).align()) : (f = (a = c.theme) && a.states, this.drillUpButton = this.chart.renderer.button(e, null, null, function () {
            b.drillUp();
          }, a, f && f.hover, f && f.select).addClass("highcharts-drillup-button").attr({
            align: c.position.align,
            zIndex: 7
          }).add().align(c.position, !1, c.relativeTo || "plotBox"));
        },
        buildKDTree: u,
        drawLegendSymbol: c.LegendSymbolMixin.drawRectangle,
        getExtremes: function getExtremes() {
          z.prototype.getExtremes.call(this, this.colorValueData);
          this.valueMin = this.dataMin;
          this.valueMax = this.dataMax;
          z.prototype.getExtremes.call(this);
        },
        getExtremesFromAll: !0,
        bindAxes: function bindAxes() {
          var a = {
            endOnTick: !1,
            gridLineWidth: 0,
            lineWidth: 0,
            min: 0,
            dataMin: 0,
            minPadding: 0,
            max: 100,
            dataMax: 100,
            maxPadding: 0,
            startOnTick: !1,
            title: null,
            tickPositions: []
          };
          z.prototype.bindAxes.call(this);
          c.extend(this.yAxis.options, a);
          c.extend(this.xAxis.options, a);
        },
        utils: {
          recursive: E
        }
      }, {
        getClassName: function getClassName() {
          var a = c.Point.prototype.getClassName.call(this),
              b = this.series,
              d = b.options;
          this.node.level <= b.nodeMap[b.rootNode].level ? a += " highcharts-above-level" : this.node.isLeaf || q(d.interactByLeaf, !d.allowTraversingTree) ? this.node.isLeaf || (a += " highcharts-internal-node") : a += " highcharts-internal-node-interactive";
          return a;
        },
        isValid: function isValid() {
          return this.id || v(this.value);
        },
        setState: function setState(a) {
          c.Point.prototype.setState.call(this, a);
          this.graphic && this.graphic.attr({
            zIndex: "hover" === a ? 1 : 0
          });
        },
        setVisible: l.pie.prototype.pointClass.prototype.setVisible
      });
    })(m, F);
  });
});
var highchartsReact_min = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e(React__default);
  }("undefined" != typeof self ? self : commonjsGlobal, function (t) {
    return function (t) {
      function e(n) {
        if (r[n]) return r[n].exports;
        var o = r[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
      }

      var r = {};
      return e.m = t, e.c = r, e.d = function (t, r, n) {
        e.o(t, r) || Object.defineProperty(t, r, {
          configurable: !1,
          enumerable: !0,
          get: n
        });
      }, e.n = function (t) {
        var r = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(r, "a", r), r;
      }, e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, e.p = "", e(e.s = 0);
    }([function (t, e, r) {
      function n(t) {
        if (Array.isArray(t)) {
          for (var e = 0, r = Array(t.length); e < t.length; e++) {
            r[e] = t[e];
          }

          return r;
        }

        return Array.from(t);
      }

      function o(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function i(t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }

      function c(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
      }

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      },
          u = function () {
        function t(t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }

        return function (e, r, n) {
          return r && t(e.prototype, r), n && t(e, n), e;
        };
      }(),
          f = r(1),
          p = function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }(f),
          s = function (t) {
        function e(t) {
          o(this, e);
          var r = i(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
          return r.container = p.default.createRef(), r;
        }

        return c(e, t), u(e, [{
          key: "componentDidMount",
          value: function value() {
            var t = this.props,
                e = t.highcharts || window.Highcharts;
            this.chart = e[t.constructorType || "chart"](this.container.current, t.options, t.callback ? t.callback : void 0);
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            if (!1 !== this.props.allowChartUpdate) {
              var t;
              (t = this.chart).update.apply(t, [this.props.options].concat(n(this.props.updateArgs || [!0, !0])));
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.chart && (this.chart.destroy(), this.chart = null);
          }
        }, {
          key: "render",
          value: function value() {
            return p.default.createElement("div", a({}, this.props.containerProps, {
              ref: this.container
            }));
          }
        }]), e;
      }(p.default.PureComponent);

      e.default = s;
    }, function (e, r) {
      e.exports = t;
    }]);
  });
});
var HighchartsReact = unwrapExports(highchartsReact_min);
var highchartsReact_min_1 = highchartsReact_min.HighchartsReact;
map(highstock);
annotations(highstock);
bullet(highstock);
heatmap(highstock);
treemap(highstock);

(function (H) {
  // internal functions
  function stopEvent(e) {
    if (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (e.stopPropagation) {
        e.stopPropagation();
      }

      e.cancelBubble = true;
    }
  } // the wrap


  H.wrap(H.Chart.prototype, 'render', function (proceed) {
    var chart = this;
    var isScrollable = chart.options.customMouseScroll;
    proceed.call(chart);

    if (isScrollable) {
      // Add the mousewheel event
      H.addEvent(chart.container, document.onmousewheel === undefined ? 'DOMMouseScroll' : 'wheel', function (event) {
        var delta = void 0;
        var extr = void 0;
        var step = void 0;
        var axis = chart.xAxis[0];
        var dataMax = chart.xAxis[0].dataMax;
        var dataMin = chart.xAxis[0].dataMin;
        var newExtrMin = void 0;
        var newExtrMax = void 0;
        var e = chart.pointer.normalize(event); // Firefox uses e.detail, WebKit and IE uses wheelDelta

        delta = e.detail || -(e.deltaY / 120);
        delta = delta < 0 ? 1 : -1;

        if (chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) {
          extr = axis.getExtremes();
          step = (extr.max - extr.min) / 15 * delta;

          if (extr.min + step <= dataMin) {
            newExtrMin = dataMin;
            newExtrMax = dataMin + (extr.max - extr.min);
          } else if (extr.max + step >= dataMax) {
            newExtrMin = dataMax - (extr.max - extr.min);
            newExtrMax = dataMax;
          } else {
            newExtrMin = extr.min + step;
            newExtrMax = extr.max + step;
          }

          axis.setExtremes(newExtrMin, newExtrMax, true, false);
        }

        stopEvent(event);
        return false;
      });
    }
  });
})(highstock);

function HighchartsBase(props) {
  var language = props.language,
      options = props.options,
      other = objectWithoutProperties(props, ['language', 'options']);
  setHighchartsOptions(language);
  return React__default.createElement(HighchartsReact, _extends$4({
    highcharts: highstock,
    options: options,
    containerProps: {
      style: {
        height: '100%',
        width: '100%'
      }
    }
  }, other));
}

HighchartsBase.propTypes = {
  options: PropTypes.shape().isRequired,
  language: PropTypes.string.isRequired
};

function setHighchartsOptions(language) {
  var locale = language.toUpperCase();

  switch (locale) {
    case 'DE':
      highstock.setOptions({
        lang: {
          decimalPoint: ',',
          thousandsSep: '.',
          loading: 'Daten werden geladen...',
          months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
          weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
          shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
          exportButtonTitle: 'Exportieren',
          printButtonTitle: 'Drucken',
          rangeSelectorFrom: 'Von',
          rangeSelectorTo: 'Bis',
          rangeSelectorZoom: 'Zeitraum',
          downloadPNG: 'Download als PNG-Bild',
          downloadJPEG: 'Download als JPEG-Bild',
          downloadPDF: 'Download als PDF-Dokument',
          downloadSVG: 'Download als SVG-Bild',
          resetZoom: 'Zoom zurücksetzen',
          resetZoomTitle: 'Zoom zurücksetzen'
        }
      });
      break;

    case 'EN':
    default:
      highstock.setOptions({
        lang: {
          decimalPoint: '.',
          thousandsSep: ' ',
          loading: 'Loading...',
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          exportButtonTitle: 'Export',
          printButtonTitle: 'Print',
          rangeSelectorFrom: 'From',
          rangeSelectorTo: 'To',
          rangeSelectorZoom: 'Zoom',
          downloadPNG: 'Download PNG image',
          downloadJPEG: 'Download JPEG image',
          downloadPDF: 'Download PDF document',
          downloadSVG: 'Download SVG vector image',
          resetZoom: 'Reset zoom',
          resetZoomTitle: 'Reset zoom level 1:1'
        }
      });
      break;
  }
}

var ORIENTATION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
var AXIS = {
  X: 'x',
  Y: 'y'
};
var ALLOCATION_GROUP = {
  BY_CLASS: 'by_class',
  BY_COMPONENT: 'by_component',
  BY_CURRENCY: 'by_currency',
  BY_REGION: 'by_region',
  BY_SECTOR: 'by_sector',
  BY_TYPE: 'by_type'
};
var HISTORY_TYPE = {
  CUSTOM: 'CUSTOM',
  WTD: 'WTD',
  MTD: 'MTD',
  QTD: 'QTD',
  YTD: 'YTD',
  '30D': '30D',
  '3M': '3M',
  '1Y': '1Y'
};
var INDICATOR = {
  BETA: 'beta',
  ALPHA: 'alpha',
  ALPHA_JENSEN: 'alpha_jensen',
  CORRELATION: 'correlation',
  R_SQUARED: 'r_squared',
  SHARPE_RATIO_A: 'sharpe_ratio_a',
  SORTINO_RATIO_A: 'sortino_ratio_a',
  TREYNOR_RATIO_A: 'treynor_ratio_a',
  FS_TREYNOR_G: 'fs_treynor_g',
  SKEW: 'skew',
  TRACKING_ERROR: 'tracking_error',
  LOSS_DEVIATION: 'loss_deviation',
  CALMAR_RATIO: 'calmar_ratio'
};
var HISTORICAL_CHART_TYPE = {
  LINE: 'line',
  AREASPLINE: 'areaspline'
};
var AllocationGroupPropType = PropTypes.oneOf([ALLOCATION_GROUP.BY_CLASS, ALLOCATION_GROUP.BY_COMPONENT, ALLOCATION_GROUP.BY_CURRENCY, ALLOCATION_GROUP.BY_REGION, ALLOCATION_GROUP.BY_SECTOR, ALLOCATION_GROUP.BY_TYPE]);
var TooltipOptionsPropType = PropTypes.shape({
  tooltipColor: PropTypes.string,
  tooltipTextColor: PropTypes.string
});
var ColorsPropType = PropTypes.arrayOf(PropTypes.string);
var OrientationPropType = PropTypes.oneOf([ORIENTATION.HORIZONTAL, ORIENTATION.VERTICAL]);
var HistoryTypePropType = PropTypes.oneOf([HISTORY_TYPE['1Y'], HISTORY_TYPE['30D'], HISTORY_TYPE['3M'], HISTORY_TYPE.MTD, HISTORY_TYPE.QTD, HISTORY_TYPE.WTD, HISTORY_TYPE.YTD, HISTORY_TYPE.CUSTOM]);
var IndicatorPropType = PropTypes.oneOf([INDICATOR.BETA, INDICATOR.ALPHA, INDICATOR.ALPHA_JENSEN, INDICATOR.CORRELATION, INDICATOR.R_SQUARED, INDICATOR.SHARPE_RATIO_A, INDICATOR.SORTINO_RATIO_A, INDICATOR.TREYNOR_RATIO_A, INDICATOR.FS_TREYNOR_G, INDICATOR.SKEW, INDICATOR.TRACKING_ERROR, INDICATOR.LOSS_DEVIATION, INDICATOR.CALMAR_RATIO]);

function HistoricalValueChart(props) {
  var data = props.data,
      title = props.title,
      stockName = props.stockName,
      colors = props.colors,
      subHeaderComponent = props.subHeaderComponent,
      language = props.language,
      chartOptions = props.chartOptions;
  var preparedData = prepareData(data);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var seriesType = preparedData.length > 1 ? HISTORICAL_CHART_TYPE.LINE : HISTORICAL_CHART_TYPE.AREASPLINE;
  var preparedColors = getChartColors(colors, preparedData.length + 1, seriesType);
  var options = {
    chart: {
      height: 450,
      spacingBottom: 0,
      style: {
        fontFamily: 'inherit'
      }
    },
    rangeSelector: {
      selected: 1
    },
    title: null,
    colors: preparedColors,
    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        events: {
          legendItemClick: function legendItemClick() {
            return false;
          }
        }
      }
    },
    series: prepareSeries(preparedData, stockName, preparedColors, seriesType)
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title
  }), subHeaderComponent(), React__default.createElement(HighchartsBase, {
    language: locale,
    options: merge_1(options, chartOptions),
    constructorType: 'stockChart'
  }));
}

HistoricalValueChart.propTypes = {
  data: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]).isRequired,
  title: PropTypes.node.isRequired,
  stockName: PropTypes.node,
  colors: ColorsPropType,
  language: PropTypes.string,
  chartOptions: PropTypes.shape(),
  subHeaderComponent: PropTypes.func
};
HistoricalValueChart.propDefs = {
  data: {
    type: 'Object | Array',
    description: 'Historical dataset to be dßisplayed in the chart.'
  },
  title: Defs.titleDef,
  stockName: {
    type: 'string',
    description: 'Name to use for the series in Highchart.'
  },
  colors: Defs.arrayColorsDef,
  language: Defs.languageDef,
  chartOptions: Defs.chartOptionsDef,
  subHeaderComponent: {
    type: 'function',
    description: 'In case some content is required below title, pass this function that should return the desired component.'
  }
};
HistoricalValueChart.defaultProps = {
  colors: null,
  language: '',
  subHeaderComponent: function subHeaderComponent() {
    return null;
  },
  stockName: null
};

function dataFormatter(data) {
  var formattedData = data.portfolio.map(function (portfolio) {
    return [Date.parse(portfolio.date), portfolio.value];
  });
  return formattedData;
}
/** Prepare series from data 
 * 
 * @param {Array<Object>} data Data, that should be displayed on chart
 * @param {Array<String>} colors Chart's colors
 * @param {String} stockName Stock name, that should be used, if series does not have name
 * @param {String} [seriesType] Type of the chart
 * 
 * @returns {Array<Object>}
*/


function prepareSeries(data, stockName, colors) {
  var seriesType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : HISTORICAL_CHART_TYPE.AREASPLINE;
  return data.map(function (values, index) {
    return _extends$4({
      name: values.name ? values.name : stockName ? stockName : 'Series ' + index,
      data: dataFormatter(values),
      type: seriesType,
      threshold: null,
      tooltip: {
        valueDecimals: 2
      },
      showInNavigator: true
    }, getSeriesOptions(colors, seriesType));
  });
}
/** Get chart's colors, that depends of series type 
 * 
 * @param {Array<String>} colors Array with colors
 * @param {Number} length Number of colors, that should be generated
 * @param {String} [seriesType] Type of the series
 * 
 * @returns {Array<String>}
*/


function getChartColors(colors, length) {
  var seriesType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : HISTORICAL_CHART_TYPE.AREASPLINE;

  switch (seriesType) {
    case HISTORICAL_CHART_TYPE.AREASPLINE:
      return [helpers.valueAtIndexOrDefault(colors, 0, getGlobalConfig().theme.main.primary), helpers.valueAtIndexOrDefault(colors, 1, getGlobalConfig().theme.tints.primary[4])];

    default:
      return helpers.getColors(colors, getGlobalConfig(), length);
  }
}
/** Convert data to array if it is not
 * 
 * @param {Array<Object>|Object} data Data, that should be converted
 * 
 * @returns {Array<Object>}
*/


function prepareData(data) {
  if (!Array.isArray(data)) {
    return [data];
  }

  return data;
}
/** Get series options, that depends on series type
 * 
 * @param {Array<String>} colors Chart's colors
 * @param {String} [seriesType] Type of the series
 * 
 * @returns {Object}
 */


function getSeriesOptions(colors) {
  var seriesType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HISTORICAL_CHART_TYPE.AREASPLINE;

  switch (seriesType) {
    case HISTORICAL_CHART_TYPE.AREASPLINE:
      return {
        lineColor: colors[0],
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          },
          stops: [[0, colors[1]], [1, highstock.Color(colors[1]).setOpacity(0).get('rgba')]]
        }
      };

    default:
      return {};
  }
}

function attributionErrors(data) {
  if (!data || !data['components']) {
    return null;
  }

  return data['components'].filter(function (item) {
    if (item.error) {
      return item;
    }
  });
}

function extractAssetInfo(assetsInfo, isin) {
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!assetsInfo) {
    return defaultValue;
  }

  if (isin in assetsInfo) {
    if (field) {
      return assetsInfo[isin][field] || defaultValue;
    }

    return assetsInfo[isin];
  }

  return defaultValue;
}

function numberDecimalFormat(value, lang, extraOptions) {
  var defaultOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };

  var options = function options(defaultOptions, extraOptions) {
    if (extraOptions) {
      return _extends$4({}, defaultOptions, extraOptions);
    }

    return defaultOptions;
  };

  var locale = lang.toUpperCase();

  switch (locale) {
    case 'DE':
      return value.toLocaleString('de-DE', options(defaultOptions, extraOptions));

    case 'EN':
    default:
      return value.toLocaleString('en-US', options(defaultOptions, extraOptions));
  }
}

var styles$5 = {
  '@global': {
    '.highcharts-tooltip span': {
      backgroundColor: 'white',
      borderRadius: 3,
      padding: 6
    }
  }
};

function PerformanceAttributionChart(props) {
  var title = props.title,
      data = props.data,
      colors = props.colors,
      fixedColorsProp = props.fixedColors,
      textColorsProp = props.textColors,
      assetsInfo = props.assetsInfo,
      labelField = props.labelField,
      language = props.language,
      tooltipOptions = props.tooltipOptions;
  var globalConfig = getGlobalConfig();

  var _normalizeColors = normalizeColors({
    fixedColors: fixedColorsProp,
    textColors: textColorsProp
  }),
      textColors = _normalizeColors.textColors,
      fixedColors = _normalizeColors.fixedColors;

  var cleanedData = data.components.filter(function (index) {
    if (!index.error) {
      return index;
    }
  });
  var errorsInData = attributionErrors(data);
  var locale = helpers.setMainLanguage(language, globalConfig.language);
  var sortedData = cleanedData.sort(function (val1, val2) {
    return val2.performance - val1.performance;
  });
  var options = {
    chart: {
      type: 'bar',
      pointWidth: 20,
      style: {
        fontFamily: 'inherit'
      }
    },
    customMouseScroll: cleanedData.length > 20,
    scrollbar: {
      enabled: cleanedData.length > 20,
      barBackgroundColor: fixedColors.lightGrey,
      barBorderWidth: 0,
      barBorderRadius: 3,
      buttonArrowColor: 'transparent',
      buttonBackgroundColor: 'transparent',
      buttonBorderWidth: 0,
      rifleColor: fixedColors.lightGrey,
      trackBorderWidth: 0,
      trackBackgroundColor: fixedColors.background,
      height: 5
    },
    title: null,
    colors: helpers.getColors(colors, globalConfig, 2),
    credits: {
      enabled: false
    },
    xAxis: {
      categories: dataNamesFormatter(sortedData, assetsInfo, labelField),
      min: 0,
      max: cleanedData.length > 20 ? 19 : null,
      reversed: true,
      labels: {
        align: 'left',
        reserveSpace: true,
        step: 1,
        style: {
          fontWeight: 'bold'
        },
        useHTML: true,
        formatter: function formatter() {
          if (typeof this.value !== 'number') {
            return '<div\n                style="\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                "\n              >\n                ' + this.value + '\n              </div>\n              ';
          }
        }
      },
      events: {
        afterSetExtremes: function afterSetExtremes() {
          var xAxis = this;
          var numberOfPoints = xAxis.series[0].points.length - 1;
          var minRangeValue = xAxis.getExtremes().min;
          var maxRangeValue = xAxis.getExtremes().max;

          if (minRangeValue < 0) {
            xAxis.setExtremes(null, xAxis.options.max);
          } else if (maxRangeValue > numberOfPoints) {
            xAxis.setExtremes(numberOfPoints - xAxis.options.max, numberOfPoints);
          }
        }
      }
    },
    yAxis: [{
      title: {
        text: null
      },
      labels: {
        formatter: function formatter() {
          return numberDecimalFormat(this.value, locale) + '%';
        },
        style: {
          color: textColors.light
        }
      }
    }, {
      title: {
        text: null
      },
      linkedTo: 0,
      labels: {
        formatter: function formatter() {
          return numberDecimalFormat(this.value, locale) + '%';
        },
        style: {
          color: textColors.light
        }
      },
      opposite: true
    }],
    plotOptions: {
      bar: {
        pointWidth: 20
      },
      series: {
        stacking: 'normal'
      }
    },
    tooltip: {
      backgroundColor: 'white',
      padding: 1,
      shadow: false,
      formatter: function formatter() {
        return '\n            ' + this.series.xAxis.categories[this.point.x] + '\n            <br/>\n            <b style="color:' + (this.point.y >= 0 ? globalConfig.theme.status.profit : globalConfig.theme.status.loss) + '">\n              ' + (this.point.y >= 0 ? '+' : '-') + ' ' + numberDecimalFormat(Math.abs(this.point.y), locale) + '%\n            </b>\n          ';
      },
      useHTML: true
    },
    legend: {
      enabled: false
    },
    series: [{
      name: 'negative',
      data: dataNegativeFormatter(sortedData),
      color: globalConfig.theme.main.tertiary
    }, {
      name: 'positive',
      data: dataPositiveFormatter(sortedData),
      color: globalConfig.theme.main.secondary
    }]
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement(HighchartsBase, {
    options: options,
    language: locale,
    containerProps: {
      style: {
        minHeight: 600
      }
    }
  }));
}

PerformanceAttributionChart.propTypes = {
  data: PropTypes.shape().isRequired,
  title: PropTypes.node.isRequired,
  colors: ColorsPropType,
  fixedColors: ColorsPropType,
  textColors: ColorsPropType,
  assetsInfo: PropTypes.shape(),
  labelField: PropTypes.string,
  language: PropTypes.string,
  tooltipOptions: TooltipOptionsPropType
};
PerformanceAttributionChart.propDefs = {
  data: {
    type: 'Object',
    description: 'Object with the structure of the Performance Attribution response from Core.Analyse.'
  },
  title: Defs.titleDef,
  colors: Defs.arrayColorsDef,
  assetsInfo: {
    type: 'array',
    description: 'Additional asset information to extract labels from.'
  },
  labelField: {
    type: 'string',
    description: 'Field name in assetsInfo to use for extracting the label value.'
  },
  language: Defs.languageDef
};
PerformanceAttributionChart.defaultProps = {
  colors: null,
  fixedColors: null,
  textColors: null,
  assetsInfo: null,
  labelField: 'name',
  language: '',
  tooltipOptions: {}
};

function dataPositiveFormatter(data) {
  var dataPositive = data.map(function (components) {
    return components.performance >= 0 ? components.performance * 100 : null;
  });
  return dataPositive;
}

function dataNegativeFormatter(data) {
  var dataNegative = data.map(function (components) {
    return components.performance < 0 ? components.performance * 100 : null;
  });
  return dataNegative;
}

function dataNamesFormatter(data, assetsInfo, field) {
  var dataNames = data.map(function (component) {
    return extractAssetInfo(assetsInfo, component.isin, field, component.isin);
  });
  return dataNames;
}

function normalizeColors(_ref) {
  var fixedColors = _ref.fixedColors,
      textColors = _ref.textColors;
  var globalTheme = getGlobalConfig().theme;
  var finalTextColors = helpers.valueOrDefault(textColors, globalTheme.text);
  var finalFixedColors = helpers.valueOrDefault(fixedColors, {
    background: globalTheme.extra.background,
    backgroundLight: globalTheme.extra.backgroundLight,
    lightGrey: globalTheme.extra.lightGrey
  });

  if (Array.isArray(finalFixedColors)) {
    finalFixedColors = {
      background: helpers.valueAtIndexOrDefault(finalFixedColors, 0, globalTheme.extra.background),
      backgroundLight: helpers.valueAtIndexOrDefault(finalFixedColors, 1, globalTheme.extra.backgroundLight),
      lightGrey: helpers.valueAtIndexOrDefault(finalFixedColors, 2, globalTheme.extra.lightGrey)
    };
  }

  if (Array.isArray(finalTextColors)) {
    finalTextColors = {
      dark: helpers.valueAtIndexOrDefault(finalTextColors, 0, globalTheme.text.dark),
      light: helpers.valueAtIndexOrDefault(finalTextColors, 1, globalTheme.text.light)
    };
  }

  return {
    fixedColors: finalFixedColors,
    textColors: finalTextColors
  };
}

var PerformanceAttributionChart$1 = injectSheet$1(styles$5)(PerformanceAttributionChart);
var countUp_min = createCommonjsModule(function (module, exports) {
  !function (a, n) {
    module.exports = n(commonjsRequire, exports, module);
  }(commonjsGlobal, function (a, n, t) {
    var e = function e(a, n, t, _e2, i, r) {
      function o(a) {
        var n,
            t,
            e,
            i,
            r,
            o,
            s = a < 0;

        if (a = Math.abs(a).toFixed(l.decimals), a += "", n = a.split("."), t = n[0], e = n.length > 1 ? l.options.decimal + n[1] : "", l.options.useGrouping) {
          for (i = "", r = 0, o = t.length; r < o; ++r) {
            0 !== r && r % 3 === 0 && (i = l.options.separator + i), i = t[o - r - 1] + i;
          }

          t = i;
        }

        return l.options.numerals.length && (t = t.replace(/[0-9]/g, function (a) {
          return l.options.numerals[+a];
        }), e = e.replace(/[0-9]/g, function (a) {
          return l.options.numerals[+a];
        })), (s ? "-" : "") + l.options.prefix + t + e + l.options.suffix;
      }

      function s(a, n, t, e) {
        return t * (-Math.pow(2, -10 * a / e) + 1) * 1024 / 1023 + n;
      }

      function u(a) {
        return "number" == typeof a && !isNaN(a);
      }

      var l = this;
      if (l.version = function () {
        return "1.9.3";
      }, l.options = {
        useEasing: !0,
        useGrouping: !0,
        separator: ",",
        decimal: ".",
        easingFn: s,
        formattingFn: o,
        prefix: "",
        suffix: "",
        numerals: []
      }, r && "object" == typeof r) for (var m in l.options) {
        r.hasOwnProperty(m) && null !== r[m] && (l.options[m] = r[m]);
      }
      "" === l.options.separator ? l.options.useGrouping = !1 : l.options.separator = "" + l.options.separator;

      for (var d = 0, c = ["webkit", "moz", "ms", "o"], f = 0; f < c.length && !window.requestAnimationFrame; ++f) {
        window.requestAnimationFrame = window[c[f] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[c[f] + "CancelAnimationFrame"] || window[c[f] + "CancelRequestAnimationFrame"];
      }

      window.requestAnimationFrame || (window.requestAnimationFrame = function (a, n) {
        var t = new Date().getTime(),
            e = Math.max(0, 16 - (t - d)),
            i = window.setTimeout(function () {
          a(t + e);
        }, e);
        return d = t + e, i;
      }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (a) {
        clearTimeout(a);
      }), l.initialize = function () {
        return !!l.initialized || (l.error = "", l.d = "string" == typeof a ? document.getElementById(a) : a, l.d ? (l.startVal = Number(n), l.endVal = Number(t), u(l.startVal) && u(l.endVal) ? (l.decimals = Math.max(0, _e2 || 0), l.dec = Math.pow(10, l.decimals), l.duration = 1e3 * Number(i) || 2e3, l.countDown = l.startVal > l.endVal, l.frameVal = l.startVal, l.initialized = !0, !0) : (l.error = "[CountUp] startVal (" + n + ") or endVal (" + t + ") is not a number", !1)) : (l.error = "[CountUp] target is null or undefined", !1));
      }, l.printValue = function (a) {
        var n = l.options.formattingFn(a);
        "INPUT" === l.d.tagName ? this.d.value = n : "text" === l.d.tagName || "tspan" === l.d.tagName ? this.d.textContent = n : this.d.innerHTML = n;
      }, l.count = function (a) {
        l.startTime || (l.startTime = a), l.timestamp = a;
        var n = a - l.startTime;
        l.remaining = l.duration - n, l.options.useEasing ? l.countDown ? l.frameVal = l.startVal - l.options.easingFn(n, 0, l.startVal - l.endVal, l.duration) : l.frameVal = l.options.easingFn(n, l.startVal, l.endVal - l.startVal, l.duration) : l.countDown ? l.frameVal = l.startVal - (l.startVal - l.endVal) * (n / l.duration) : l.frameVal = l.startVal + (l.endVal - l.startVal) * (n / l.duration), l.countDown ? l.frameVal = l.frameVal < l.endVal ? l.endVal : l.frameVal : l.frameVal = l.frameVal > l.endVal ? l.endVal : l.frameVal, l.frameVal = Math.round(l.frameVal * l.dec) / l.dec, l.printValue(l.frameVal), n < l.duration ? l.rAF = requestAnimationFrame(l.count) : l.callback && l.callback();
      }, l.start = function (a) {
        l.initialize() && (l.callback = a, l.rAF = requestAnimationFrame(l.count));
      }, l.pauseResume = function () {
        l.paused ? (l.paused = !1, delete l.startTime, l.duration = l.remaining, l.startVal = l.frameVal, requestAnimationFrame(l.count)) : (l.paused = !0, cancelAnimationFrame(l.rAF));
      }, l.reset = function () {
        l.paused = !1, delete l.startTime, l.initialized = !1, l.initialize() && (cancelAnimationFrame(l.rAF), l.printValue(l.startVal));
      }, l.update = function (a) {
        if (l.initialize()) {
          if (a = Number(a), !u(a)) return void (l.error = "[CountUp] update() - new endVal is not a number: " + a);
          l.error = "", a !== l.frameVal && (cancelAnimationFrame(l.rAF), l.paused = !1, delete l.startTime, l.startVal = l.frameVal, l.endVal = a, l.countDown = l.startVal > l.endVal, l.rAF = requestAnimationFrame(l.count));
        }
      }, l.initialize() && l.printValue(l.startVal);
    };

    return e;
  });
});
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__$2 = process.env.NODE_ENV !== 'production';

var warning$3 = function warning$3() {};

if (__DEV__$2) {
  var printWarning$2 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$3 = function warning$3(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);

    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (!condition) {
      printWarning$2.apply(null, [format].concat(args));
    }
  };
}

var warning_1$3 = warning$3;

function _interopDefault$1(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var Count = _interopDefault$1(countUp_min);

var PropTypes$1 = _interopDefault$1(PropTypes);

var React__default$1 = _interopDefault$1(React__default);

var warning$4 = _interopDefault$1(warning_1$3);

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$2(self);
}

var CountUp = /*#__PURE__*/function (_Component) {
  _inherits$2(CountUp, _Component);

  function CountUp() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$3(this, CountUp);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$2(this, (_getPrototypeOf2 = _getPrototypeOf(CountUp)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty$6(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "createInstance", function () {
      if (typeof _this.props.children === 'function') {
        // Warn when user didn't use containerRef at all
        warning$4(_this.containerRef.current && _this.containerRef.current instanceof HTMLElement, "Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an HTMLElement, eg. <span ref={containerRef} />.");
      }

      var _this$props = _this.props,
          decimal = _this$props.decimal,
          decimals = _this$props.decimals,
          duration = _this$props.duration,
          easingFn = _this$props.easingFn,
          end = _this$props.end,
          formattingFn = _this$props.formattingFn,
          prefix = _this$props.prefix,
          separator = _this$props.separator,
          start = _this$props.start,
          suffix = _this$props.suffix,
          useEasing = _this$props.useEasing;
      return new Count(_this.containerRef.current, start, end, decimals, duration, {
        decimal: decimal,
        easingFn: easingFn,
        formattingFn: formattingFn,
        separator: separator,
        prefix: prefix,
        suffix: suffix,
        useEasing: useEasing,
        useGrouping: !!separator
      });
    });

    _defineProperty$6(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "pauseResume", function () {
      var _assertThisInitialize = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
          reset = _assertThisInitialize.reset,
          start = _assertThisInitialize.restart,
          update = _assertThisInitialize.update;

      var onPauseResume = _this.props.onPauseResume;

      _this.instance.pauseResume();

      onPauseResume({
        reset: reset,
        start: start,
        update: update
      });
    });

    _defineProperty$6(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "reset", function () {
      var _assertThisInitialize2 = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
          pauseResume = _assertThisInitialize2.pauseResume,
          start = _assertThisInitialize2.restart,
          update = _assertThisInitialize2.update;

      var onReset = _this.props.onReset;

      _this.instance.reset();

      onReset({
        pauseResume: pauseResume,
        start: start,
        update: update
      });
    });

    _defineProperty$6(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "restart", function () {
      _this.reset();

      _this.start();
    });

    _defineProperty$6(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "start", function () {
      var _assertThisInitialize3 = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
          pauseResume = _assertThisInitialize3.pauseResume,
          reset = _assertThisInitialize3.reset,
          start = _assertThisInitialize3.restart,
          update = _assertThisInitialize3.update;

      var _this$props2 = _this.props,
          delay = _this$props2.delay,
          onEnd = _this$props2.onEnd,
          onStart = _this$props2.onStart;

      var run = function run() {
        return _this.instance.start(function () {
          return onEnd({
            pauseResume: pauseResume,
            reset: reset,
            start: start,
            update: update
          });
        });
      }; // Delay start if delay prop is properly set


      if (delay > 0) {
        setTimeout(run, delay * 1000);
      } else {
        run();
      }

      onStart({
        pauseResume: pauseResume,
        reset: reset,
        update: update
      });
    });

    _defineProperty$6(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "update", function (newEnd) {
      var _assertThisInitialize4 = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
          pauseResume = _assertThisInitialize4.pauseResume,
          reset = _assertThisInitialize4.reset,
          start = _assertThisInitialize4.restart;

      var onUpdate = _this.props.onUpdate;

      _this.instance.update(newEnd);

      onUpdate({
        pauseResume: pauseResume,
        reset: reset,
        start: start
      });
    });

    _defineProperty$6(_assertThisInitialized$2(_assertThisInitialized$2(_this)), "containerRef", React__default$1.createRef());

    return _this;
  }

  _createClass$3(CountUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          delay = _this$props3.delay;
      this.instance = this.createInstance(); // Don't invoke start if component is used as a render prop

      if (typeof children === 'function' && delay !== 0) return; // Otherwise just start immediately

      this.start();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var hasCertainPropsChanged = this.props.duration !== nextProps.duration || this.props.end !== nextProps.end || this.props.start !== nextProps.start;
      return hasCertainPropsChanged || this.props.redraw;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If duration or start has changed, there's no way to update the duration
      // or start value. So we need to re-create the CountUp instance in order to
      // restart it.
      if (this.props.duration !== prevProps.duration || this.props.start !== prevProps.start) {
        this.instance = this.createInstance();
        this.start();
      } // Only end value has changed, so reset and and re-animate with the updated
      // end value.


      if (this.props.end !== prevProps.end) {
        this.instance.reset();
        this.instance.update(this.props.end);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          style = _this$props4.style;
      var containerRef = this.containerRef,
          pauseResume = this.pauseResume,
          reset = this.reset,
          restart = this.restart,
          update = this.update;

      if (typeof children === 'function') {
        return children({
          countUpRef: containerRef,
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      }

      return React__default$1.createElement("span", {
        className: className,
        ref: containerRef,
        style: style
      });
    }
  }]);

  return CountUp;
}(React__default.Component);

_defineProperty$6(CountUp, "propTypes", {
  decimal: PropTypes$1.string,
  decimals: PropTypes$1.number,
  delay: PropTypes$1.number,
  easingFn: PropTypes$1.func,
  end: PropTypes$1.number.isRequired,
  formattingFn: PropTypes$1.func,
  onEnd: PropTypes$1.func,
  onStart: PropTypes$1.func,
  prefix: PropTypes$1.string,
  redraw: PropTypes$1.bool,
  separator: PropTypes$1.string,
  start: PropTypes$1.number,
  suffix: PropTypes$1.string,
  style: PropTypes$1.object,
  useEasing: PropTypes$1.bool
});

_defineProperty$6(CountUp, "defaultProps", {
  decimal: '.',
  decimals: 0,
  delay: null,
  duration: null,
  easingFn: null,
  formattingFn: null,
  onEnd: function onEnd() {},
  onPauseResume: function onPauseResume() {},
  onReset: function onReset() {},
  onStart: function onStart() {},
  onUpdate: function onUpdate() {},
  prefix: '',
  redraw: false,
  separator: '',
  start: 0,
  suffix: '',
  style: undefined,
  useEasing: true
});

var build$1 = CountUp;
var styles$6 = {
  cardCounter: {
    fontSize: 36,
    alignSelf: 'center',
    fontWeight: 'bold',
    color: function color(_ref) {
      var colors = _ref.colors;
      return colors.secondary;
    }
  },
  cardTitle: {
    fontSize: 14,
    color: function color(_ref2) {
      var textColors = _ref2.textColors;
      return textColors.dark;
    }
  },
  cardNote: {
    alignSelf: 'flex-end',
    fontSize: 12,
    color: function color(_ref3) {
      var textColors = _ref3.textColors;
      return textColors.light;
    }
  },
  cardNoNote: {
    height: 14
  }
};

function decimalSeparator(language) {
  var locale = language.toUpperCase();

  switch (locale) {
    case 'DE':
      return ',';

    case 'EN':
    default:
      return '.';
  }
}

function thousandsSeparator(language) {
  var locale = language.toUpperCase();

  switch (locale) {
    case 'DE':
      return '.';

    case 'EN':
    default:
      return ',';
  }
}

var IndicatorCardInner = function IndicatorCardInner(props) {
  var title = props.title,
      value = props.value,
      language = props.language,
      note = props.note,
      classes = props.classes;
  var extraProps = {
    decimals: Number.isInteger(value) ? 0 : 2,
    decimal: decimalSeparator(language),
    separator: thousandsSeparator(language)
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement('span', {
    className: classes.cardTitle
  }, title), React__default.createElement(build$1, _extends$4({
    start: 0,
    end: value,
    duration: 2.5,
    useEasing: true,
    className: classes.cardCounter
  }, extraProps)), note ? React__default.createElement('div', {
    className: classes.cardNote
  }, note) : React__default.createElement('div', {
    className: classes.cardNoNote
  }));
};

IndicatorCardInner.propTypes = {
  value: PropTypes.number.isRequired,
  language: PropTypes.string,
  colors: PropTypes.shape(),
  textColors: PropTypes.shape(),
  note: PropTypes.string,
  title: PropTypes.node,
  classes: PropTypes.shape().isRequired
};
var IndicatorCardInner$1 = injectSheet$1(styles$6)(IndicatorCardInner);
var styles$7 = {
  cardContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    minHeight: 100,
    minWidth: 100,
    height: '100%',
    width: '100%',
    fontFamily: 'inherit'
  }
};

var IndicatorCard = function IndicatorCard(props) {
  var title = props.title,
      name = props.name,
      data = props.data,
      colorsProp = props.colors,
      textColorsProp = props.textColors,
      note = props.note,
      classes = props.classes,
      language = props.language;
  var value = data.indicators[name];
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);

  var _normalizeColors = normalizeColors$1({
    colors: colorsProp,
    textColors: textColorsProp
  }),
      colors = _normalizeColors.colors,
      textColors = _normalizeColors.textColors;

  return React__default.createElement('div', {
    className: classes.cardContainer
  }, React__default.createElement(IndicatorCardInner$1, {
    title: title,
    value: value,
    language: locale,
    colors: colors,
    textColors: textColors,
    note: note
  }));
};

IndicatorCard.propTypes = {
  classes: PropTypes.shape().isRequired,
  data: PropTypes.shape().isRequired,
  colors: ColorsPropType,
  textColors: ColorsPropType,
  note: PropTypes.string,
  language: PropTypes.string,
  title: PropTypes.node,
  name: IndicatorPropType.isRequired
};
IndicatorCard.propDefs = {
  classes: Defs.classesDef,
  data: {
    type: 'Object',
    description: 'Data to be displayed. Shaped as Core.Analyse Risk Indicators endpoint.'
  },
  colors: Defs.colorsDef,
  textColors: Defs.textColorsDef,
  title: Defs.titleDef,
  note: {
    type: 'string',
    description: 'Small note to be added at the bottom of the indicator card.'
  },
  name: {
    type: 'enum',
    description: '\n      Name of the indicator to be shown. Options are:\n      <ul>\n        <li>beta</li>\n        <li>alpha</li>\n        <li>alpha_jensen</li>\n        <li>correlation</li>\n        <li>r_squared</li>\n        <li>sharpe_ratio_a</li>\n        <li>sortino_ratio_a</li>\n        <li>treynor_ratio_a</li>\n        <li>fs_treynor_g</li>\n        <li>skew</li>\n        <li>tracking_error</li>\n        <li>loss_deviation</li>\n        <li>calmar_ratio</li>\n      </ul>\n    '
  },
  language: Defs.languageDef
};
IndicatorCard.defaultProps = {
  note: '',
  title: null,
  colors: null,
  textColors: null,
  language: ''
};

function normalizeColors$1(_ref) {
  var colors = _ref.colors,
      textColors = _ref.textColors;
  var globalTheme = getGlobalConfig().theme;
  var finalColors = helpers.valueOrDefault(colors, {
    primary: globalTheme.main.primary,
    secondary: globalTheme.main.secondary,
    secondaryHover: globalTheme.tints.secondary[1]
  });
  var finalTextColors = helpers.valueOrDefault(textColors, globalTheme.text);

  if (Array.isArray(finalColors)) {
    finalColors = {
      primary: helpers.valueAtIndexOrDefault(finalColors, 0, globalTheme.main.primary),
      secondary: helpers.valueAtIndexOrDefault(finalColors, 1, globalTheme.main.secondary),
      secondaryHover: helpers.valueAtIndexOrDefault(finalColors, 2, globalTheme.tints.secondary[1])
    };
  }

  if (Array.isArray(finalTextColors)) {
    finalTextColors = {
      dark: helpers.valueAtIndexOrDefault(finalTextColors, 0, globalTheme.text.dark),
      light: helpers.valueAtIndexOrDefault(finalTextColors, 1, globalTheme.text.light)
    };
  }

  return {
    colors: finalColors,
    textColors: finalTextColors
  };
}

var IndicatorCard$1 = injectSheet$1(styles$7)(IndicatorCard);
var scrollArea = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t(React__default);
  }(commonjsGlobal, function (e) {
    return function (e) {
      function t(o) {
        if (n[o]) return n[o].exports;
        var r = n[o] = {
          exports: {},
          id: o,
          loaded: !1
        };
        return e[o].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
      }

      var n = {};
      return t.m = e, t.c = n, t.p = "", t(0);
    }([function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), n(31);
      var r = n(13),
          i = o(r);
      t.default = i.default;
    }, function (t, n) {
      t.exports = e;
    }, function (e, t, n) {
      e.exports = n(19)();
    }, function (e, t) {
      function n(e) {
        var t = {};

        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = "number" == typeof e[n] ? e[n] : e[n].val);
        }

        return t;
      }

      t.__esModule = !0, t.default = n, e.exports = t.default;
    }, function (e, t, n) {
      (function (t) {
        (function () {
          var n, o, r;
          "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
            return performance.now();
          } : "undefined" != typeof t && null !== t && t.hrtime ? (e.exports = function () {
            return (n() - r) / 1e6;
          }, o = t.hrtime, n = function n() {
            var e;
            return e = o(), 1e9 * e[0] + e[1];
          }, r = n()) : Date.now ? (e.exports = function () {
            return Date.now() - r;
          }, r = Date.now()) : (e.exports = function () {
            return new Date().getTime() - r;
          }, r = new Date().getTime());
        }).call(this);
      }).call(t, n(10));
    }, function (e, t, n) {
      (function (t) {
        for (var o = n(23), r = "undefined" == typeof window ? t : window, i = ["moz", "webkit"], a = "AnimationFrame", l = r["request" + a], s = r["cancel" + a] || r["cancelRequest" + a], u = 0; !l && u < i.length; u++) {
          l = r[i[u] + "Request" + a], s = r[i[u] + "Cancel" + a] || r[i[u] + "CancelRequest" + a];
        }

        if (!l || !s) {
          var c = 0,
              f = 0,
              p = [],
              d = 1e3 / 60;
          l = function l(e) {
            if (0 === p.length) {
              var t = o(),
                  n = Math.max(0, d - (t - c));
              c = n + t, setTimeout(function () {
                var e = p.slice(0);
                p.length = 0;

                for (var t = 0; t < e.length; t++) {
                  if (!e[t].cancelled) try {
                    e[t].callback(c);
                  } catch (e) {
                    setTimeout(function () {
                      throw e;
                    }, 0);
                  }
                }
              }, Math.round(n));
            }

            return p.push({
              handle: ++f,
              callback: e,
              cancelled: !1
            }), f;
          }, s = function s(e) {
            for (var t = 0; t < p.length; t++) {
              p[t].handle === e && (p[t].cancelled = !0);
            }
          };
        }

        e.exports = function (e) {
          return l.call(r, e);
        }, e.exports.cancel = function () {
          s.apply(r, arguments);
        }, e.exports.polyfill = function (e) {
          e || (e = r), e.requestAnimationFrame = l, e.cancelAnimationFrame = s;
        };
      }).call(t, function () {
        return this;
      }());
    }, function (e, t) {
      function n(e) {
        var t = {};

        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = 0);
        }

        return t;
      }

      t.__esModule = !0, t.default = n, e.exports = t.default;
    }, function (e, t) {
      function n(e, t, n) {
        for (var o in t) {
          if (Object.prototype.hasOwnProperty.call(t, o)) {
            if (0 !== n[o]) return !1;
            var r = "number" == typeof t[o] ? t[o] : t[o].val;
            if (e[o] !== r) return !1;
          }
        }

        return !0;
      }

      t.__esModule = !0, t.default = n, e.exports = t.default;
    }, function (e, t) {
      function n(e, t, n, r, i, a, l) {
        var s = -i * (t - r),
            u = -a * n,
            c = s + u,
            f = n + c * e,
            p = t + f * e;
        return Math.abs(f) < l && Math.abs(p - r) < l ? (o[0] = r, o[1] = 0, o) : (o[0] = p, o[1] = f, o);
      }

      t.__esModule = !0, t.default = n;
      var o = [0, 0];
      e.exports = t.default;
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function r(e) {
        return p ? f.default.findDOMNode(e) : e;
      }

      function i() {
        d || p || (d = !0, console.error("With React 0.14 and later versions, you no longer need to wrap <ScrollArea> child into a function."));
      }

      function a() {
        !d && p && (d = !0, console.error("With React 0.13, you need to wrap <ScrollArea> child into a function."));
      }

      function l(e) {
        return e < 0 ? 0 : e;
      }

      function s(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (e) {
          return e;
        },
            n = {};

        for (var o in e) {
          e.hasOwnProperty(o) && (n[o] = t(e[o]));
        }

        return n;
      }

      function u(e) {
        var t = e.version;
        if ("string" != typeof t) return !0;
        var n = t.split("."),
            o = parseInt(n[0], 10),
            r = parseInt(n[1], 10);
        return 0 === o && 13 === r;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.findDOMNode = r, t.warnAboutFunctionChild = i, t.warnAboutElementChild = a, t.positiveOrZero = l, t.modifyObjValues = s, t.isReact13 = u;
      var c = n(1),
          f = o(c),
          p = u(f.default),
          d = !1;
    }, function (e, t) {
      function n() {
        throw new Error("setTimeout has not been defined");
      }

      function o() {
        throw new Error("clearTimeout has not been defined");
      }

      function r(e) {
        if (c === setTimeout) return setTimeout(e, 0);
        if ((c === n || !c) && setTimeout) return c = setTimeout, setTimeout(e, 0);

        try {
          return c(e, 0);
        } catch (t) {
          try {
            return c.call(null, e, 0);
          } catch (t) {
            return c.call(this, e, 0);
          }
        }
      }

      function i(e) {
        if (f === clearTimeout) return clearTimeout(e);
        if ((f === o || !f) && clearTimeout) return f = clearTimeout, clearTimeout(e);

        try {
          return f(e);
        } catch (t) {
          try {
            return f.call(null, e);
          } catch (t) {
            return f.call(this, e);
          }
        }
      }

      function a() {
        y && d && (y = !1, d.length ? h = d.concat(h) : v = -1, h.length && l());
      }

      function l() {
        if (!y) {
          var e = r(a);
          y = !0;

          for (var t = h.length; t;) {
            for (d = h, h = []; ++v < t;) {
              d && d[v].run();
            }

            v = -1, t = h.length;
          }

          d = null, y = !1, i(e);
        }
      }

      function s(e, t) {
        this.fun = e, this.array = t;
      }

      function u() {}

      var c,
          f,
          p = e.exports = {};
      !function () {
        try {
          c = "function" == typeof setTimeout ? setTimeout : n;
        } catch (e) {
          c = n;
        }

        try {
          f = "function" == typeof clearTimeout ? clearTimeout : o;
        } catch (e) {
          f = o;
        }
      }();
      var d,
          h = [],
          y = !1,
          v = -1;
      p.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }
        h.push(new s(e, t)), 1 !== h.length || y || r(l);
      }, s.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = u, p.addListener = u, p.once = u, p.off = u, p.removeListener = u, p.removeAllListeners = u, p.emit = u, p.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, p.cwd = function () {
        return "/";
      }, p.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, p.umask = function () {
        return 0;
      };
    }, function (e, t) {
      t.__esModule = !0, t.default = {
        noWobble: {
          stiffness: 170,
          damping: 26
        },
        gentle: {
          stiffness: 120,
          damping: 14
        },
        wobbly: {
          stiffness: 180,
          damping: 12
        },
        stiff: {
          stiffness: 210,
          damping: 20
        }
      }, e.exports = t.default;
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e.default : e;
      }

      t.__esModule = !0;
      var r = n(24);
      t.Motion = o(r);
      var i = n(25);
      t.StaggeredMotion = o(i);
      var a = n(26);
      t.TransitionMotion = o(a);
      var l = n(29);
      t.spring = o(l);
      var s = n(11);
      t.presets = o(s);
      var u = n(3);
      t.stripStyle = o(u);
      var c = n(28);
      t.reorderKeys = o(c);
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function r(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function i(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function a(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      },
          u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }

        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
          c = n(1),
          f = o(c),
          p = n(2),
          d = o(p),
          h = n(18),
          y = o(h),
          v = n(12),
          m = n(9),
          b = n(14),
          S = o(b),
          g = {
        wheel: "wheel",
        api: "api",
        touch: "touch",
        touchEnd: "touchEnd",
        mousemove: "mousemove",
        keyPress: "keypress"
      },
          w = function (e) {
        function t(e) {
          r(this, t);
          var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return n.state = {
            topPosition: 0,
            leftPosition: 0,
            realHeight: 0,
            containerHeight: 0,
            realWidth: 0,
            containerWidth: 0
          }, n.scrollArea = {
            refresh: function refresh() {
              n.setSizesToState();
            },
            scrollTop: function scrollTop() {
              n.scrollTop();
            },
            scrollBottom: function scrollBottom() {
              n.scrollBottom();
            },
            scrollYTo: function scrollYTo(e) {
              n.scrollYTo(e);
            },
            scrollLeft: function scrollLeft() {
              n.scrollLeft();
            },
            scrollRight: function scrollRight() {
              n.scrollRight();
            },
            scrollXTo: function scrollXTo(e) {
              n.scrollXTo(e);
            }
          }, n.evntsPreviousValues = {
            clientX: 0,
            clientY: 0,
            deltaX: 0,
            deltaY: 0
          }, n.bindedHandleWindowResize = n.handleWindowResize.bind(n), n.bindedHandleWheel = n.handleWheel.bind(n), n;
        }

        return a(t, e), u(t, [{
          key: "getChildContext",
          value: function value() {
            return {
              scrollArea: this.scrollArea
            };
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            this.props.contentWindow && this.props.contentWindow.addEventListener("resize", this.bindedHandleWindowResize), this.lineHeightPx = (0, y.default)((0, m.findDOMNode)(this.content)), this.setSizesToState(), this.wrapper.addEventListener("wheel", this.bindedHandleWheel, {
              passive: !1
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.props.contentWindow && this.props.contentWindow.removeEventListener("resize", this.bindedHandleWindowResize), this.wrapper.removeEventListener("wheel", this.bindedHandleWheel);
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.setSizesToState();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
                t = this.props,
                n = t.children,
                o = t.className,
                r = t.contentClassName,
                i = t.ownerDocument,
                a = this.props.smoothScrolling && (this.state.eventType === g.wheel || this.state.eventType === g.api || this.state.eventType === g.touchEnd || this.state.eventType === g.keyPress),
                l = this.canScrollY() ? f.default.createElement(S.default, {
              ownerDocument: i,
              realSize: this.state.realHeight,
              containerSize: this.state.containerHeight,
              position: this.state.topPosition,
              onMove: this.handleScrollbarMove.bind(this),
              onPositionChange: this.handleScrollbarYPositionChange.bind(this),
              containerStyle: this.props.verticalContainerStyle,
              scrollbarStyle: this.props.verticalScrollbarStyle,
              smoothScrolling: a,
              minScrollSize: this.props.minScrollSize,
              onFocus: this.focusContent.bind(this),
              type: "vertical"
            }) : null,
                u = this.canScrollX() ? f.default.createElement(S.default, {
              ownerDocument: i,
              realSize: this.state.realWidth,
              containerSize: this.state.containerWidth,
              position: this.state.leftPosition,
              onMove: this.handleScrollbarMove.bind(this),
              onPositionChange: this.handleScrollbarXPositionChange.bind(this),
              containerStyle: this.props.horizontalContainerStyle,
              scrollbarStyle: this.props.horizontalScrollbarStyle,
              smoothScrolling: a,
              minScrollSize: this.props.minScrollSize,
              onFocus: this.focusContent.bind(this),
              type: "horizontal"
            }) : null;
            "function" == typeof n ? ((0, m.warnAboutFunctionChild)(), n = n()) : (0, m.warnAboutElementChild)();
            var c = "scrollarea " + (o || ""),
                p = "scrollarea-content " + (r || ""),
                d = {
              marginTop: -this.state.topPosition,
              marginLeft: -this.state.leftPosition
            },
                h = a ? (0, m.modifyObjValues)(d, function (e) {
              return (0, v.spring)(e);
            }) : d;
            return f.default.createElement(v.Motion, {
              style: h
            }, function (t) {
              return f.default.createElement("div", {
                ref: function ref(t) {
                  return e.wrapper = t;
                },
                className: c,
                style: e.props.style
              }, f.default.createElement("div", {
                ref: function ref(t) {
                  return e.content = t;
                },
                style: s({}, e.props.contentStyle, t),
                className: p,
                onTouchStart: e.handleTouchStart.bind(e),
                onTouchMove: e.handleTouchMove.bind(e),
                onTouchEnd: e.handleTouchEnd.bind(e),
                onKeyDown: e.handleKeyDown.bind(e),
                tabIndex: e.props.focusableTabIndex
              }, n), l, u);
            });
          }
        }, {
          key: "setStateFromEvent",
          value: function value(e, t) {
            this.props.onScroll && this.props.onScroll(e), this.setState(s({}, e, {
              eventType: t
            }));
          }
        }, {
          key: "handleTouchStart",
          value: function value(e) {
            var t = e.touches;

            if (1 === t.length) {
              var n = t[0],
                  o = n.clientX,
                  r = n.clientY;
              this.eventPreviousValues = s({}, this.eventPreviousValues, {
                clientY: r,
                clientX: o,
                timestamp: Date.now()
              });
            }
          }
        }, {
          key: "handleTouchMove",
          value: function value(e) {
            this.canScroll() && (e.preventDefault(), e.stopPropagation());
            var t = e.touches;

            if (1 === t.length) {
              var n = t[0],
                  o = n.clientX,
                  r = n.clientY,
                  i = this.eventPreviousValues.clientY - r,
                  a = this.eventPreviousValues.clientX - o;
              this.eventPreviousValues = s({}, this.eventPreviousValues, {
                deltaY: i,
                deltaX: a,
                clientY: r,
                clientX: o,
                timestamp: Date.now()
              }), this.setStateFromEvent(this.composeNewState(-a, -i));
            }
          }
        }, {
          key: "handleTouchEnd",
          value: function value(e) {
            var t = this.eventPreviousValues,
                n = t.deltaX,
                o = t.deltaY,
                r = t.timestamp;
            "undefined" == typeof n && (n = 0), "undefined" == typeof o && (o = 0), Date.now() - r < 200 && this.setStateFromEvent(this.composeNewState(10 * -n, 10 * -o), g.touchEnd), this.eventPreviousValues = s({}, this.eventPreviousValues, {
              deltaY: 0,
              deltaX: 0
            });
          }
        }, {
          key: "handleScrollbarMove",
          value: function value(e, t) {
            this.setStateFromEvent(this.composeNewState(t, e));
          }
        }, {
          key: "handleScrollbarXPositionChange",
          value: function value(e) {
            this.scrollXTo(e);
          }
        }, {
          key: "handleScrollbarYPositionChange",
          value: function value(e) {
            this.scrollYTo(e);
          }
        }, {
          key: "handleWheel",
          value: function value(e) {
            var t = e.deltaY,
                n = e.deltaX;

            if (this.props.swapWheelAxes) {
              var o = [n, t];
              t = o[0], n = o[1];
            }

            1 === e.deltaMode && (t *= this.lineHeightPx, n *= this.lineHeightPx), t *= this.props.speed, n *= this.props.speed;
            var r = this.composeNewState(-n, -t);
            (r.topPosition && this.state.topPosition !== r.topPosition || r.leftPosition && this.state.leftPosition !== r.leftPosition || this.props.stopScrollPropagation) && (e.preventDefault(), e.stopPropagation()), this.setStateFromEvent(r, g.wheel), this.focusContent();
          }
        }, {
          key: "handleKeyDown",
          value: function value(e) {
            if ("input" !== e.target.tagName.toLowerCase() && "textarea" !== e.target.tagName.toLowerCase() && !e.target.isContentEditable) {
              var t = 0,
                  n = 0,
                  o = this.lineHeightPx ? this.lineHeightPx : 10;

              switch (e.keyCode) {
                case 33:
                  t = this.state.containerHeight - o;
                  break;

                case 34:
                  t = -this.state.containerHeight + o;
                  break;

                case 37:
                  n = o;
                  break;

                case 38:
                  t = o;
                  break;

                case 39:
                  n = -o;
                  break;

                case 40:
                  t = -o;
              }

              if (0 !== t || 0 !== n) {
                var r = this.composeNewState(n, t);
                e.preventDefault(), e.stopPropagation(), this.setStateFromEvent(r, g.keyPress);
              }
            }
          }
        }, {
          key: "handleWindowResize",
          value: function value() {
            var e = this.computeSizes();
            e = this.getModifiedPositionsIfNeeded(e), this.setStateFromEvent(e);
          }
        }, {
          key: "composeNewState",
          value: function value(e, t) {
            var n = this.computeSizes();
            return this.canScrollY(n) ? n.topPosition = this.computeTopPosition(t, n) : n.topPosition = 0, this.canScrollX(n) && (n.leftPosition = this.computeLeftPosition(e, n)), n;
          }
        }, {
          key: "computeTopPosition",
          value: function value(e, t) {
            var n = this.state.topPosition - e;
            return this.normalizeTopPosition(n, t);
          }
        }, {
          key: "computeLeftPosition",
          value: function value(e, t) {
            var n = this.state.leftPosition - e;
            return this.normalizeLeftPosition(n, t);
          }
        }, {
          key: "normalizeTopPosition",
          value: function value(e, t) {
            return e > t.realHeight - t.containerHeight && (e = t.realHeight - t.containerHeight), e < 0 && (e = 0), e;
          }
        }, {
          key: "normalizeLeftPosition",
          value: function value(e, t) {
            return e > t.realWidth - t.containerWidth ? e = t.realWidth - t.containerWidth : e < 0 && (e = 0), e;
          }
        }, {
          key: "computeSizes",
          value: function value() {
            var e = this.content.offsetHeight,
                t = this.wrapper.offsetHeight,
                n = this.content.offsetWidth,
                o = this.wrapper.offsetWidth;
            return {
              realHeight: e,
              containerHeight: t,
              realWidth: n,
              containerWidth: o
            };
          }
        }, {
          key: "setSizesToState",
          value: function value() {
            var e = this.computeSizes();
            e.realHeight === this.state.realHeight && e.realWidth === this.state.realWidth || this.setStateFromEvent(this.getModifiedPositionsIfNeeded(e));
          }
        }, {
          key: "scrollTop",
          value: function value() {
            this.scrollYTo(0);
          }
        }, {
          key: "scrollBottom",
          value: function value() {
            this.scrollYTo(this.state.realHeight - this.state.containerHeight);
          }
        }, {
          key: "scrollLeft",
          value: function value() {
            this.scrollXTo(0);
          }
        }, {
          key: "scrollRight",
          value: function value() {
            this.scrollXTo(this.state.realWidth - this.state.containerWidth);
          }
        }, {
          key: "scrollYTo",
          value: function value(e) {
            if (this.canScrollY()) {
              var t = this.normalizeTopPosition(e, this.computeSizes());
              this.setStateFromEvent({
                topPosition: t
              }, g.api);
            }
          }
        }, {
          key: "scrollXTo",
          value: function value(e) {
            if (this.canScrollX()) {
              var t = this.normalizeLeftPosition(e, this.computeSizes());
              this.setStateFromEvent({
                leftPosition: t
              }, g.api);
            }
          }
        }, {
          key: "canScrollY",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state,
                t = e.realHeight > e.containerHeight;
            return t && this.props.vertical;
          }
        }, {
          key: "canScrollX",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state,
                t = e.realWidth > e.containerWidth;
            return t && this.props.horizontal;
          }
        }, {
          key: "canScroll",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state;
            return this.canScrollY(e) || this.canScrollX(e);
          }
        }, {
          key: "getModifiedPositionsIfNeeded",
          value: function value(e) {
            var t = e.realHeight - e.containerHeight;
            this.state.topPosition >= t && (e.topPosition = this.canScrollY(e) ? (0, m.positiveOrZero)(t) : 0);
            var n = e.realWidth - e.containerWidth;
            return this.state.leftPosition >= n && (e.leftPosition = this.canScrollX(e) ? (0, m.positiveOrZero)(n) : 0), e;
          }
        }, {
          key: "focusContent",
          value: function value() {
            this.content && (0, m.findDOMNode)(this.content).focus();
          }
        }]), t;
      }(f.default.Component);

      t.default = w, w.childContextTypes = {
        scrollArea: d.default.object
      }, w.propTypes = {
        className: d.default.string,
        style: d.default.object,
        speed: d.default.number,
        contentClassName: d.default.string,
        contentStyle: d.default.object,
        vertical: d.default.bool,
        verticalContainerStyle: d.default.object,
        verticalScrollbarStyle: d.default.object,
        horizontal: d.default.bool,
        horizontalContainerStyle: d.default.object,
        horizontalScrollbarStyle: d.default.object,
        onScroll: d.default.func,
        contentWindow: d.default.any,
        ownerDocument: d.default.any,
        smoothScrolling: d.default.bool,
        minScrollSize: d.default.number,
        swapWheelAxes: d.default.bool,
        stopScrollPropagation: d.default.bool,
        focusableTabIndex: d.default.number
      }, w.defaultProps = {
        speed: 1,
        vertical: !0,
        horizontal: !0,
        smoothScrolling: !1,
        swapWheelAxes: !1,
        contentWindow: "object" === ("undefined" == typeof window ? "undefined" : l(window)) ? window : void 0,
        ownerDocument: "object" === ("undefined" == typeof document ? "undefined" : l(document)) ? document : void 0,
        focusableTabIndex: 1
      };
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function r(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function i(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function a(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      },
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }

        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
          u = n(1),
          c = o(u),
          f = n(2),
          p = o(f),
          d = n(12),
          h = n(9),
          y = function (e) {
        function t(e) {
          r(this, t);
          var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
              o = n.calculateState(e);
          return n.state = {
            position: o.position,
            scrollSize: o.scrollSize,
            isDragging: !1,
            lastClientPosition: 0
          }, "vertical" === e.type ? n.bindedHandleMouseMove = n.handleMouseMoveForVertical.bind(n) : n.bindedHandleMouseMove = n.handleMouseMoveForHorizontal.bind(n), n.bindedHandleMouseUp = n.handleMouseUp.bind(n), n;
        }

        return a(t, e), s(t, [{
          key: "componentDidMount",
          value: function value() {
            this.props.ownerDocument && (this.props.ownerDocument.addEventListener("mousemove", this.bindedHandleMouseMove), this.props.ownerDocument.addEventListener("mouseup", this.bindedHandleMouseUp));
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            this.setState(this.calculateState(e));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.props.ownerDocument && (this.props.ownerDocument.removeEventListener("mousemove", this.bindedHandleMouseMove), this.props.ownerDocument.removeEventListener("mouseup", this.bindedHandleMouseUp));
          }
        }, {
          key: "calculateFractionalPosition",
          value: function value(e, t, n) {
            var o = e - t;
            return 1 - (o - n) / o;
          }
        }, {
          key: "calculateState",
          value: function value(e) {
            var t = this.calculateFractionalPosition(e.realSize, e.containerSize, e.position),
                n = e.containerSize * e.containerSize / e.realSize,
                o = n < e.minScrollSize ? e.minScrollSize : n,
                r = (e.containerSize - o) * t;
            return {
              scrollSize: o,
              position: Math.round(r)
            };
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
                t = this.props,
                n = t.smoothScrolling,
                o = t.isDragging,
                r = t.type,
                i = t.scrollbarStyle,
                a = t.containerStyle,
                s = "horizontal" === r,
                u = "vertical" === r,
                f = this.createScrollStyles(),
                p = n ? (0, h.modifyObjValues)(f, function (e) {
              return (0, d.spring)(e);
            }) : f,
                y = "scrollbar-container " + (o ? "active" : "") + " " + (s ? "horizontal" : "") + " " + (u ? "vertical" : "");
            return c.default.createElement(d.Motion, {
              style: p
            }, function (t) {
              return c.default.createElement("div", {
                className: y,
                style: a,
                onMouseDown: e.handleScrollBarContainerClick.bind(e),
                ref: function ref(t) {
                  return e.scrollbarContainer = t;
                }
              }, c.default.createElement("div", {
                className: "scrollbar",
                style: l({}, i, t),
                onMouseDown: e.handleMouseDown.bind(e)
              }));
            });
          }
        }, {
          key: "handleScrollBarContainerClick",
          value: function value(e) {
            e.preventDefault();
            var t = this.computeMultiplier(),
                n = this.isVertical() ? e.clientY : e.clientX,
                o = this.scrollbarContainer.getBoundingClientRect(),
                r = o.top,
                i = o.left,
                a = this.isVertical() ? r : i,
                l = n - a,
                s = this.props.containerSize * this.props.containerSize / this.props.realSize;
            this.setState({
              isDragging: !0,
              lastClientPosition: n
            }), this.props.onPositionChange((l - s / 2) / t);
          }
        }, {
          key: "handleMouseMoveForHorizontal",
          value: function value(e) {
            var t = this.computeMultiplier();

            if (this.state.isDragging) {
              e.preventDefault();
              var n = this.state.lastClientPosition - e.clientX;
              this.setState({
                lastClientPosition: e.clientX
              }), this.props.onMove(0, n / t);
            }
          }
        }, {
          key: "handleMouseMoveForVertical",
          value: function value(e) {
            var t = this.computeMultiplier();

            if (this.state.isDragging) {
              e.preventDefault();
              var n = this.state.lastClientPosition - e.clientY;
              this.setState({
                lastClientPosition: e.clientY
              }), this.props.onMove(n / t, 0);
            }
          }
        }, {
          key: "handleMouseDown",
          value: function value(e) {
            e.preventDefault(), e.stopPropagation();
            var t = this.isVertical() ? e.clientY : e.clientX;
            this.setState({
              isDragging: !0,
              lastClientPosition: t
            }), this.props.onFocus();
          }
        }, {
          key: "handleMouseUp",
          value: function value(e) {
            this.state.isDragging && (e.preventDefault(), this.setState({
              isDragging: !1
            }));
          }
        }, {
          key: "createScrollStyles",
          value: function value() {
            return "vertical" === this.props.type ? {
              height: this.state.scrollSize,
              marginTop: this.state.position
            } : {
              width: this.state.scrollSize,
              marginLeft: this.state.position
            };
          }
        }, {
          key: "computeMultiplier",
          value: function value() {
            return this.props.containerSize / this.props.realSize;
          }
        }, {
          key: "isVertical",
          value: function value() {
            return "vertical" === this.props.type;
          }
        }]), t;
      }(c.default.Component);

      y.propTypes = {
        onMove: p.default.func,
        onPositionChange: p.default.func,
        onFocus: p.default.func,
        realSize: p.default.number,
        containerSize: p.default.number,
        position: p.default.number,
        containerStyle: p.default.object,
        scrollbarStyle: p.default.object,
        type: p.default.oneOf(["vertical", "horizontal"]),
        ownerDocument: p.default.any,
        smoothScrolling: p.default.bool,
        minScrollSize: p.default.number
      }, y.defaultProps = {
        type: "vertical",
        smoothScrolling: !1
      }, t.default = y;
    }, function (e, t) {
      var n = function n(e, t, _n2) {
        return _n2 = window.getComputedStyle, (_n2 ? _n2(e) : e.currentStyle)[t.replace(/-(\w)/gi, function (e, t) {
          return t.toUpperCase();
        })];
      };

      e.exports = n;
    }, function (e, t, n) {
      t = e.exports = n(17)(), t.push([e.id, ".scrollarea-content{margin:0;padding:0;overflow:hidden;position:relative;touch-action:none}.scrollarea-content:focus{outline:0}.scrollarea{position:relative;overflow:hidden}.scrollarea .scrollbar-container{position:absolute;background:none;opacity:.1;z-index:99;-webkit-transition:all .4s;transition:all .4s}.scrollarea .scrollbar-container.horizontal{width:100%;height:10px;left:0;bottom:0}.scrollarea .scrollbar-container.horizontal .scrollbar{width:20px;height:8px;background:#000;margin-top:1px}.scrollarea .scrollbar-container.vertical{width:10px;height:100%;right:0;top:0}.scrollarea .scrollbar-container.vertical .scrollbar{width:8px;height:20px;background:#000;margin-left:1px}.scrollarea .scrollbar-container.active,.scrollarea .scrollbar-container:hover{background:gray;opacity:.6!important}.scrollarea:hover .scrollbar-container{opacity:.3}", ""]);
    }, function (e, t) {
      e.exports = function () {
        var e = [];
        return e.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var n = this[t];
            n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
          }

          return e.join("");
        }, e.i = function (t, n) {
          "string" == typeof t && (t = [[null, t, ""]]);

          for (var o = {}, r = 0; r < this.length; r++) {
            var i = this[r][0];
            "number" == typeof i && (o[i] = !0);
          }

          for (r = 0; r < t.length; r++) {
            var a = t[r];
            "number" == typeof a[0] && o[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
          }
        }, e;
      };
    }, function (e, t, n) {
      function o(e) {
        var t = r(e, "line-height"),
            n = parseFloat(t, 10);

        if (t === n + "") {
          var o = e.style.lineHeight;
          e.style.lineHeight = t + "em", t = r(e, "line-height"), n = parseFloat(t, 10), o ? e.style.lineHeight = o : delete e.style.lineHeight;
        }

        if (t.indexOf("pt") !== -1 ? (n *= 4, n /= 3) : t.indexOf("mm") !== -1 ? (n *= 96, n /= 25.4) : t.indexOf("cm") !== -1 ? (n *= 96, n /= 2.54) : t.indexOf("in") !== -1 ? n *= 96 : t.indexOf("pc") !== -1 && (n *= 16), n = Math.round(n), "normal" === t) {
          var i = e.nodeName,
              a = document.createElement(i);
          a.innerHTML = "&nbsp;";
          var l = r(e, "font-size");
          a.style.fontSize = l;
          var s = document.body;
          s.appendChild(a);
          var u = a.offsetHeight;
          n = u, s.removeChild(a);
        }

        return n;
      }

      var r = n(15);
      e.exports = o;
    }, function (e, t, n) {
      var o = n(21),
          r = n(22),
          i = n(20);

      e.exports = function () {
        function e(e, t, n, o, a, l) {
          l !== i && r(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        }

        function t() {
          return e;
        }

        e.isRequired = e;
        var n = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t
        };
        return n.checkPropTypes = o, n.PropTypes = n, n;
      };
    }, function (e, t) {
      var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      e.exports = n;
    }, function (e, t) {
      function n(e) {
        return function () {
          return e;
        };
      }

      var o = function o() {};

      o.thatReturns = n, o.thatReturnsFalse = n(!1), o.thatReturnsTrue = n(!0), o.thatReturnsNull = n(null), o.thatReturnsThis = function () {
        return this;
      }, o.thatReturnsArgument = function (e) {
        return e;
      }, e.exports = o;
    }, function (e, t, n) {
      function o(e, t, n, o, i, a, l, s) {
        if (!e) {
          var u;
          if (void 0 === t) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var c = [n, o, i, a, l, s],
                f = 0;
            u = new Error(t.replace(/%s/g, function () {
              return c[f++];
            })), u.name = "Invariant Violation";
          }
          throw u.framesToPop = 1, u;
        }
      }

      e.exports = o;
    }, function (e, t, n) {
      (function (t) {
        (function () {
          var n, o, r, i, a, l;
          "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
            return performance.now();
          } : "undefined" != typeof t && null !== t && t.hrtime ? (e.exports = function () {
            return (n() - a) / 1e6;
          }, o = t.hrtime, n = function n() {
            var e;
            return e = o(), 1e9 * e[0] + e[1];
          }, i = n(), l = 1e9 * t.uptime(), a = i - l) : Date.now ? (e.exports = function () {
            return Date.now() - r;
          }, r = Date.now()) : (e.exports = function () {
            return new Date().getTime() - r;
          }, r = new Date().getTime());
        }).call(this);
      }).call(t, n(10));
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function r(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function i(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      t.__esModule = !0;

      var a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      },
          l = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }

        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
          s = n(6),
          u = o(s),
          c = n(3),
          f = o(c),
          p = n(8),
          d = o(p),
          h = n(4),
          y = o(h),
          v = n(5),
          m = o(v),
          b = n(7),
          S = o(b),
          g = n(1),
          w = o(g),
          P = n(2),
          T = o(P),
          k = 1e3 / 60,
          O = function (e) {
        function t(n) {
          var o = this;
          r(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
            var t = !1,
                n = o.state,
                r = n.currentStyle,
                i = n.currentVelocity,
                l = n.lastIdealStyle,
                s = n.lastIdealVelocity;

            for (var u in e) {
              if (Object.prototype.hasOwnProperty.call(e, u)) {
                var c = e[u];
                "number" == typeof c && (t || (t = !0, r = a({}, r), i = a({}, i), l = a({}, l), s = a({}, s)), r[u] = c, i[u] = 0, l[u] = c, s[u] = 0);
              }
            }

            t && o.setState({
              currentStyle: r,
              currentVelocity: i,
              lastIdealStyle: l,
              lastIdealVelocity: s
            });
          }, this.startAnimationIfNecessary = function () {
            o.animationID = m.default(function (e) {
              var t = o.props.style;
              if (S.default(o.state.currentStyle, t, o.state.currentVelocity)) return o.wasAnimating && o.props.onRest && o.props.onRest(), o.animationID = null, o.wasAnimating = !1, void (o.accumulatedTime = 0);
              o.wasAnimating = !0;
              var n = e || y.default(),
                  r = n - o.prevTime;
              if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 10 * k && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();
              var i = (o.accumulatedTime - Math.floor(o.accumulatedTime / k) * k) / k,
                  a = Math.floor(o.accumulatedTime / k),
                  l = {},
                  s = {},
                  u = {},
                  c = {};

              for (var f in t) {
                if (Object.prototype.hasOwnProperty.call(t, f)) {
                  var p = t[f];
                  if ("number" == typeof p) u[f] = p, c[f] = 0, l[f] = p, s[f] = 0;else {
                    for (var h = o.state.lastIdealStyle[f], v = o.state.lastIdealVelocity[f], m = 0; m < a; m++) {
                      var b = d.default(k / 1e3, h, v, p.val, p.stiffness, p.damping, p.precision);
                      h = b[0], v = b[1];
                    }

                    var g = d.default(k / 1e3, h, v, p.val, p.stiffness, p.damping, p.precision),
                        w = g[0],
                        P = g[1];
                    u[f] = h + (w - h) * i, c[f] = v + (P - v) * i, l[f] = h, s[f] = v;
                  }
                }
              }

              o.animationID = null, o.accumulatedTime -= a * k, o.setState({
                currentStyle: u,
                currentVelocity: c,
                lastIdealStyle: l,
                lastIdealVelocity: s
              }), o.unreadPropStyle = null, o.startAnimationIfNecessary();
            });
          }, this.state = this.defaultState();
        }

        return i(t, e), l(t, null, [{
          key: "propTypes",
          value: {
            defaultStyle: T.default.objectOf(T.default.number),
            style: T.default.objectOf(T.default.oneOfType([T.default.number, T.default.object])).isRequired,
            children: T.default.func.isRequired,
            onRest: T.default.func
          },
          enumerable: !0
        }]), t.prototype.defaultState = function () {
          var e = this.props,
              t = e.defaultStyle,
              n = e.style,
              o = t || f.default(n),
              r = u.default(o);
          return {
            currentStyle: o,
            currentVelocity: r,
            lastIdealStyle: o,
            lastIdealVelocity: r
          };
        }, t.prototype.componentDidMount = function () {
          this.prevTime = y.default(), this.startAnimationIfNecessary();
        }, t.prototype.componentWillReceiveProps = function (e) {
          null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = y.default(), this.startAnimationIfNecessary());
        }, t.prototype.componentWillUnmount = function () {
          null != this.animationID && (m.default.cancel(this.animationID), this.animationID = null);
        }, t.prototype.render = function () {
          var e = this.props.children(this.state.currentStyle);
          return e && w.default.Children.only(e);
        }, t;
      }(w.default.Component);

      t.default = O, e.exports = t.default;
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function r(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function i(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      function a(e, t, n) {
        for (var o = 0; o < e.length; o++) {
          if (!g.default(e[o], t[o], n[o])) return !1;
        }

        return !0;
      }

      t.__esModule = !0;

      var l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      },
          s = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }

        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
          u = n(6),
          c = o(u),
          f = n(3),
          p = o(f),
          d = n(8),
          h = o(d),
          y = n(4),
          v = o(y),
          m = n(5),
          b = o(m),
          S = n(7),
          g = o(S),
          w = n(1),
          P = o(w),
          T = n(2),
          k = o(T),
          O = 1e3 / 60,
          M = function (e) {
        function t(n) {
          var o = this;
          r(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
            for (var t = o.state, n = t.currentStyles, r = t.currentVelocities, i = t.lastIdealStyles, a = t.lastIdealVelocities, s = !1, u = 0; u < e.length; u++) {
              var c = e[u],
                  f = !1;

              for (var p in c) {
                if (Object.prototype.hasOwnProperty.call(c, p)) {
                  var d = c[p];
                  "number" == typeof d && (f || (f = !0, s = !0, n[u] = l({}, n[u]), r[u] = l({}, r[u]), i[u] = l({}, i[u]), a[u] = l({}, a[u])), n[u][p] = d, r[u][p] = 0, i[u][p] = d, a[u][p] = 0);
                }
              }
            }

            s && o.setState({
              currentStyles: n,
              currentVelocities: r,
              lastIdealStyles: i,
              lastIdealVelocities: a
            });
          }, this.startAnimationIfNecessary = function () {
            o.animationID = b.default(function (e) {
              var t = o.props.styles(o.state.lastIdealStyles);
              if (a(o.state.currentStyles, t, o.state.currentVelocities)) return o.animationID = null, void (o.accumulatedTime = 0);
              var n = e || v.default(),
                  r = n - o.prevTime;
              if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 10 * O && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();

              for (var i = (o.accumulatedTime - Math.floor(o.accumulatedTime / O) * O) / O, l = Math.floor(o.accumulatedTime / O), s = [], u = [], c = [], f = [], p = 0; p < t.length; p++) {
                var d = t[p],
                    y = {},
                    m = {},
                    b = {},
                    S = {};

                for (var g in d) {
                  if (Object.prototype.hasOwnProperty.call(d, g)) {
                    var w = d[g];
                    if ("number" == typeof w) y[g] = w, m[g] = 0, b[g] = w, S[g] = 0;else {
                      for (var P = o.state.lastIdealStyles[p][g], T = o.state.lastIdealVelocities[p][g], k = 0; k < l; k++) {
                        var M = h.default(O / 1e3, P, T, w.val, w.stiffness, w.damping, w.precision);
                        P = M[0], T = M[1];
                      }

                      var x = h.default(O / 1e3, P, T, w.val, w.stiffness, w.damping, w.precision),
                          I = x[0],
                          D = x[1];
                      y[g] = P + (I - P) * i, m[g] = T + (D - T) * i, b[g] = P, S[g] = T;
                    }
                  }
                }

                c[p] = y, f[p] = m, s[p] = b, u[p] = S;
              }

              o.animationID = null, o.accumulatedTime -= l * O, o.setState({
                currentStyles: c,
                currentVelocities: f,
                lastIdealStyles: s,
                lastIdealVelocities: u
              }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
            });
          }, this.state = this.defaultState();
        }

        return i(t, e), s(t, null, [{
          key: "propTypes",
          value: {
            defaultStyles: k.default.arrayOf(k.default.objectOf(k.default.number)),
            styles: k.default.func.isRequired,
            children: k.default.func.isRequired
          },
          enumerable: !0
        }]), t.prototype.defaultState = function () {
          var e = this.props,
              t = e.defaultStyles,
              n = e.styles,
              o = t || n().map(p.default),
              r = o.map(function (e) {
            return c.default(e);
          });
          return {
            currentStyles: o,
            currentVelocities: r,
            lastIdealStyles: o,
            lastIdealVelocities: r
          };
        }, t.prototype.componentDidMount = function () {
          this.prevTime = v.default(), this.startAnimationIfNecessary();
        }, t.prototype.componentWillReceiveProps = function (e) {
          null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = v.default(), this.startAnimationIfNecessary());
        }, t.prototype.componentWillUnmount = function () {
          null != this.animationID && (b.default.cancel(this.animationID), this.animationID = null);
        }, t.prototype.render = function () {
          var e = this.props.children(this.state.currentStyles);
          return e && P.default.Children.only(e);
        }, t;
      }(P.default.Component);

      t.default = M, e.exports = t.default;
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function r(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function i(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      function a(e, t, n) {
        var o = t;
        return null == o ? e.map(function (e, t) {
          return {
            key: e.key,
            data: e.data,
            style: n[t]
          };
        }) : e.map(function (e, t) {
          for (var r = 0; r < o.length; r++) {
            if (o[r].key === e.key) return {
              key: o[r].key,
              data: o[r].data,
              style: n[t]
            };
          }

          return {
            key: e.key,
            data: e.data,
            style: n[t]
          };
        });
      }

      function l(e, t, n, o) {
        if (o.length !== t.length) return !1;

        for (var r = 0; r < o.length; r++) {
          if (o[r].key !== t[r].key) return !1;
        }

        for (var r = 0; r < o.length; r++) {
          if (!k.default(e[r], t[r].style, n[r])) return !1;
        }

        return !0;
      }

      function s(e, t, n, o, r, i, a, l, s) {
        for (var u = b.default(o, r, function (e, o) {
          var r = t(o);
          return null == r ? (n({
            key: o.key,
            data: o.data
          }), null) : k.default(i[e], r, a[e]) ? (n({
            key: o.key,
            data: o.data
          }), null) : {
            key: o.key,
            data: o.data,
            style: r
          };
        }), c = [], f = [], d = [], h = [], y = 0; y < u.length; y++) {
          for (var v = u[y], m = null, S = 0; S < o.length; S++) {
            if (o[S].key === v.key) {
              m = S;
              break;
            }
          }

          if (null == m) {
            var g = e(v);
            c[y] = g, d[y] = g;
            var w = p.default(v.style);
            f[y] = w, h[y] = w;
          } else c[y] = i[m], d[y] = l[m], f[y] = a[m], h[y] = s[m];
        }

        return [u, c, f, d, h];
      }

      t.__esModule = !0;

      var u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      },
          c = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
          }
        }

        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      }(),
          f = n(6),
          p = o(f),
          d = n(3),
          h = o(d),
          y = n(8),
          v = o(y),
          m = n(27),
          b = o(m),
          S = n(4),
          g = o(S),
          w = n(5),
          P = o(w),
          T = n(7),
          k = o(T),
          O = n(1),
          M = o(O),
          x = n(2),
          I = o(x),
          D = 1e3 / 60,
          _ = function (e) {
        function t(n) {
          var o = this;
          r(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
            for (var t = s(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, e, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), n = t[0], r = t[1], i = t[2], a = t[3], l = t[4], c = 0; c < e.length; c++) {
              var f = e[c].style,
                  p = !1;

              for (var d in f) {
                if (Object.prototype.hasOwnProperty.call(f, d)) {
                  var h = f[d];
                  "number" == typeof h && (p || (p = !0, r[c] = u({}, r[c]), i[c] = u({}, i[c]), a[c] = u({}, a[c]), l[c] = u({}, l[c]), n[c] = {
                    key: n[c].key,
                    data: n[c].data,
                    style: u({}, n[c].style)
                  }), r[c][d] = h, i[c][d] = 0, a[c][d] = h, l[c][d] = 0, n[c].style[d] = h);
                }
              }
            }

            o.setState({
              currentStyles: r,
              currentVelocities: i,
              mergedPropsStyles: n,
              lastIdealStyles: a,
              lastIdealVelocities: l
            });
          }, this.startAnimationIfNecessary = function () {
            o.unmounting || (o.animationID = P.default(function (e) {
              if (!o.unmounting) {
                var t = o.props.styles,
                    n = "function" == typeof t ? t(a(o.state.mergedPropsStyles, o.unreadPropStyles, o.state.lastIdealStyles)) : t;
                if (l(o.state.currentStyles, n, o.state.currentVelocities, o.state.mergedPropsStyles)) return o.animationID = null, void (o.accumulatedTime = 0);
                var r = e || g.default(),
                    i = r - o.prevTime;
                if (o.prevTime = r, o.accumulatedTime = o.accumulatedTime + i, o.accumulatedTime > 10 * D && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();

                for (var u = (o.accumulatedTime - Math.floor(o.accumulatedTime / D) * D) / D, c = Math.floor(o.accumulatedTime / D), f = s(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, n, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), p = f[0], d = f[1], h = f[2], y = f[3], m = f[4], b = 0; b < p.length; b++) {
                  var S = p[b].style,
                      w = {},
                      P = {},
                      T = {},
                      k = {};

                  for (var O in S) {
                    if (Object.prototype.hasOwnProperty.call(S, O)) {
                      var M = S[O];
                      if ("number" == typeof M) w[O] = M, P[O] = 0, T[O] = M, k[O] = 0;else {
                        for (var x = y[b][O], I = m[b][O], _ = 0; _ < c; _++) {
                          var j = v.default(D / 1e3, x, I, M.val, M.stiffness, M.damping, M.precision);
                          x = j[0], I = j[1];
                        }

                        var C = v.default(D / 1e3, x, I, M.val, M.stiffness, M.damping, M.precision),
                            z = C[0],
                            E = C[1];
                        w[O] = x + (z - x) * u, P[O] = I + (E - I) * u, T[O] = x, k[O] = I;
                      }
                    }
                  }

                  y[b] = T, m[b] = k, d[b] = w, h[b] = P;
                }

                o.animationID = null, o.accumulatedTime -= c * D, o.setState({
                  currentStyles: d,
                  currentVelocities: h,
                  lastIdealStyles: y,
                  lastIdealVelocities: m,
                  mergedPropsStyles: p
                }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
              }
            }));
          }, this.state = this.defaultState();
        }

        return i(t, e), c(t, null, [{
          key: "propTypes",
          value: {
            defaultStyles: I.default.arrayOf(I.default.shape({
              key: I.default.string.isRequired,
              data: I.default.any,
              style: I.default.objectOf(I.default.number).isRequired
            })),
            styles: I.default.oneOfType([I.default.func, I.default.arrayOf(I.default.shape({
              key: I.default.string.isRequired,
              data: I.default.any,
              style: I.default.objectOf(I.default.oneOfType([I.default.number, I.default.object])).isRequired
            }))]).isRequired,
            children: I.default.func.isRequired,
            willEnter: I.default.func,
            willLeave: I.default.func,
            didLeave: I.default.func
          },
          enumerable: !0
        }, {
          key: "defaultProps",
          value: {
            willEnter: function willEnter(e) {
              return h.default(e.style);
            },
            willLeave: function willLeave() {
              return null;
            },
            didLeave: function didLeave() {}
          },
          enumerable: !0
        }]), t.prototype.defaultState = function () {
          var e = this.props,
              t = e.defaultStyles,
              n = e.styles,
              o = e.willEnter,
              r = e.willLeave,
              i = e.didLeave,
              a = "function" == typeof n ? n(t) : n,
              l = void 0;
          l = null == t ? a : t.map(function (e) {
            for (var t = 0; t < a.length; t++) {
              if (a[t].key === e.key) return a[t];
            }

            return e;
          });
          var u = null == t ? a.map(function (e) {
            return h.default(e.style);
          }) : t.map(function (e) {
            return h.default(e.style);
          }),
              c = null == t ? a.map(function (e) {
            return p.default(e.style);
          }) : t.map(function (e) {
            return p.default(e.style);
          }),
              f = s(o, r, i, l, a, u, c, u, c),
              d = f[0],
              y = f[1],
              v = f[2],
              m = f[3],
              b = f[4];
          return {
            currentStyles: y,
            currentVelocities: v,
            lastIdealStyles: m,
            lastIdealVelocities: b,
            mergedPropsStyles: d
          };
        }, t.prototype.componentDidMount = function () {
          this.prevTime = g.default(), this.startAnimationIfNecessary();
        }, t.prototype.componentWillReceiveProps = function (e) {
          this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
          var t = e.styles;
          "function" == typeof t ? this.unreadPropStyles = t(a(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : this.unreadPropStyles = t, null == this.animationID && (this.prevTime = g.default(), this.startAnimationIfNecessary());
        }, t.prototype.componentWillUnmount = function () {
          this.unmounting = !0, null != this.animationID && (P.default.cancel(this.animationID), this.animationID = null);
        }, t.prototype.render = function () {
          var e = a(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
              t = this.props.children(e);
          return t && M.default.Children.only(t);
        }, t;
      }(M.default.Component);

      t.default = _, e.exports = t.default;
    }, function (e, t) {
      function n(e, t, n) {
        for (var o = {}, r = 0; r < e.length; r++) {
          o[e[r].key] = r;
        }

        for (var i = {}, r = 0; r < t.length; r++) {
          i[t[r].key] = r;
        }

        for (var a = [], r = 0; r < t.length; r++) {
          a[r] = t[r];
        }

        for (var r = 0; r < e.length; r++) {
          if (!Object.prototype.hasOwnProperty.call(i, e[r].key)) {
            var l = n(r, e[r]);
            null != l && a.push(l);
          }
        }

        return a.sort(function (e, n) {
          var r = i[e.key],
              a = i[n.key],
              l = o[e.key],
              s = o[n.key];
          if (null != r && null != a) return i[e.key] - i[n.key];
          if (null != l && null != s) return o[e.key] - o[n.key];

          if (null != r) {
            for (var u = 0; u < t.length; u++) {
              var c = t[u].key;

              if (Object.prototype.hasOwnProperty.call(o, c)) {
                if (r < i[c] && s > o[c]) return -1;
                if (r > i[c] && s < o[c]) return 1;
              }
            }

            return 1;
          }

          for (var u = 0; u < t.length; u++) {
            var c = t[u].key;

            if (Object.prototype.hasOwnProperty.call(o, c)) {
              if (a < i[c] && l > o[c]) return 1;
              if (a > i[c] && l < o[c]) return -1;
            }
          }

          return -1;
        });
      }

      t.__esModule = !0, t.default = n, e.exports = t.default;
    }, function (e, t, n) {
      function o() {}

      t.__esModule = !0, t.default = o;
      e.exports = t.default;
    }, function (e, t, n) {
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function r(e, t) {
        return i({}, s, t, {
          val: e
        });
      }

      t.__esModule = !0;

      var i = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      };

      t.default = r;
      var a = n(11),
          l = o(a),
          s = i({}, l.default.noWobble, {
        precision: .01
      });
      e.exports = t.default;
    }, function (e, t, n) {
      function o(e, t) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n],
              r = d[o.id];

          if (r) {
            r.refs++;

            for (var i = 0; i < r.parts.length; i++) {
              r.parts[i](o.parts[i]);
            }

            for (; i < o.parts.length; i++) {
              r.parts.push(u(o.parts[i], t));
            }
          } else {
            for (var a = [], i = 0; i < o.parts.length; i++) {
              a.push(u(o.parts[i], t));
            }

            d[o.id] = {
              id: o.id,
              refs: 1,
              parts: a
            };
          }
        }
      }

      function r(e) {
        for (var t = [], n = {}, o = 0; o < e.length; o++) {
          var r = e[o],
              i = r[0],
              a = r[1],
              l = r[2],
              s = r[3],
              u = {
            css: a,
            media: l,
            sourceMap: s
          };
          n[i] ? n[i].parts.push(u) : t.push(n[i] = {
            id: i,
            parts: [u]
          });
        }

        return t;
      }

      function i(e, t) {
        var n = v(),
            o = S[S.length - 1];
        if ("top" === e.insertAt) o ? o.nextSibling ? n.insertBefore(t, o.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), S.push(t);else {
          if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
          n.appendChild(t);
        }
      }

      function a(e) {
        e.parentNode.removeChild(e);
        var t = S.indexOf(e);
        t >= 0 && S.splice(t, 1);
      }

      function l(e) {
        var t = document.createElement("style");
        return t.type = "text/css", i(e, t), t;
      }

      function s(e) {
        var t = document.createElement("link");
        return t.rel = "stylesheet", i(e, t), t;
      }

      function u(e, t) {
        var n, o, r;

        if (t.singleton) {
          var i = b++;
          n = m || (m = l(t)), o = c.bind(null, n, i, !1), r = c.bind(null, n, i, !0);
        } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = s(t), o = p.bind(null, n), r = function r() {
          a(n), n.href && URL.revokeObjectURL(n.href);
        }) : (n = l(t), o = f.bind(null, n), r = function r() {
          a(n);
        });

        return o(e), function (t) {
          if (t) {
            if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
            o(e = t);
          } else r();
        };
      }

      function c(e, t, n, o) {
        var r = n ? "" : o.css;
        if (e.styleSheet) e.styleSheet.cssText = g(t, r);else {
          var i = document.createTextNode(r),
              a = e.childNodes;
          a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
        }
      }

      function f(e, t) {
        var n = t.css,
            o = t.media;
        if (o && e.setAttribute("media", o), e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }

      function p(e, t) {
        var n = t.css,
            o = t.sourceMap;
        o && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var r = new Blob([n], {
          type: "text/css"
        }),
            i = e.href;
        e.href = URL.createObjectURL(r), i && URL.revokeObjectURL(i);
      }

      var d = {},
          h = function h(e) {
        var t;
        return function () {
          return "undefined" == typeof t && (t = e.apply(this, arguments)), t;
        };
      },
          y = h(function () {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
      }),
          v = h(function () {
        return document.head || document.getElementsByTagName("head")[0];
      }),
          m = null,
          b = 0,
          S = [];

      e.exports = function (e, t) {
        t = t || {}, "undefined" == typeof t.singleton && (t.singleton = y()), "undefined" == typeof t.insertAt && (t.insertAt = "bottom");
        var n = r(e);
        return o(n, t), function (e) {
          for (var i = [], a = 0; a < n.length; a++) {
            var l = n[a],
                s = d[l.id];
            s.refs--, i.push(s);
          }

          if (e) {
            var u = r(e);
            o(u, t);
          }

          for (var a = 0; a < i.length; a++) {
            var s = i[a];

            if (0 === s.refs) {
              for (var c = 0; c < s.parts.length; c++) {
                s.parts[c]();
              }

              delete d[s.id];
            }
          }
        };
      };

      var g = function () {
        var e = [];
        return function (t, n) {
          return e[t] = n, e.filter(Boolean).join("\n");
        };
      }();
    }, function (e, t, n) {
      var o = n(16);
      "string" == typeof o && (o = [[e.id, o, ""]]);
      n(30)(o, {});
      o.locals && (e.exports = o.locals);
    }]);
  });
});
var ScrollArea = unwrapExports(scrollArea);
var scrollArea_1 = scrollArea.ScrollArea;

function getTooltipColor$1() {
  var tooltipColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return helpers.valueOrDefault(tooltipColor, getGlobalConfig().theme.extra.lightGrey);
}

function getTooltipTextColor$1() {
  var tooltipTextColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return helpers.valueOrDefault(tooltipTextColor, getGlobalConfig().theme.text.dark);
}

var styles$8 = {
  tooltipContainer: {
    backgroundColor: function backgroundColor(_ref) {
      var tooltipColor = _ref.tooltipColor;
      return getTooltipColor$1(tooltipColor);
    },
    border: 'none',
    borderRadius: 6,
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
    color: function color(_ref2) {
      var tooltipTextColor = _ref2.tooltipTextColor;
      return getTooltipTextColor$1(tooltipTextColor);
    },
    fontSize: 12,
    padding: '5px 15px'
  },
  tooltipArrow: {
    '&[data-placement*="top"]::before': {
      borderColor: 'transparent transparent transparent transparent'
    },
    '&[data-placement*="top"]::after': {
      borderColor: function borderColor(_ref3) {
        var tooltipColor = _ref3.tooltipColor;
        return getTooltipColor$1(tooltipColor) + ' transparent transparent transparent';
      }
    },
    '&[data-placement*="bottom"]::before': {
      borderColor: 'transparent transparent transparent transparent'
    },
    '&[data-placement*="bottom"]::after': {
      borderColor: function borderColor(_ref4) {
        var tooltipColor = _ref4.tooltipColor;
        return 'transparent transparent ' + getTooltipColor$1(tooltipColor) + ' transparent';
      }
    }
  }
};

var Tooltip$2 = function Tooltip(_ref) {
  var children = _ref.children,
      _tooltip = _ref.tooltip,
      hideArrow = _ref.hideArrow,
      classes = _ref.classes,
      props = objectWithoutProperties(_ref, ['children', 'tooltip', 'hideArrow', 'classes']);
  return React__default.createElement(TooltipTrigger, _extends$4({}, props, {
    tooltip: function tooltip(_ref2) {
      var arrowRef = _ref2.arrowRef,
          tooltipRef = _ref2.tooltipRef,
          getArrowProps = _ref2.getArrowProps,
          getTooltipProps = _ref2.getTooltipProps,
          placement = _ref2.placement;
      return React__default.createElement('div', getTooltipProps({
        ref: tooltipRef,
        className: '' + classnames(classes.tooltipContainer, 'tooltip-container')
      }), !hideArrow && React__default.createElement('div', getArrowProps({
        ref: arrowRef,
        className: '' + classnames(classes.tooltipArrow, 'tooltip-arrow'),
        'data-placement': placement
      })), _tooltip);
    }
  }), function (_ref3) {
    var getTriggerProps = _ref3.getTriggerProps,
        triggerRef = _ref3.triggerRef;
    return React__default.createElement('span', getTriggerProps({
      ref: triggerRef
    }), children);
  });
};

Tooltip$2.propTypes = {
  classes: PropTypes.shape().isRequired,
  tooltip: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  hideArrow: PropTypes.bool,
  placement: PropTypes.string,
  trigger: PropTypes.string
};
Tooltip$2.propDefs = {
  classes: {
    type: 'object',
    description: 'JSS classes passed by injectSheet HOC.'
  },
  tooltip: {
    type: 'string',
    description: 'The content to be shown in the tooltip.'
  },
  children: {
    type: 'node',
    description: 'The place where the tooltip is triggered.'
  },
  hideArrow: {
    type: 'bool',
    description: 'Show/Hide the tooltip arrow.'
  },
  placement: {
    type: 'string',
    description: 'The tooltip placement. Valid placements are: auto, top, right, bottom, left.'
  },
  trigger: {
    type: 'string',
    description: 'The event that triggers the tooltip. One of click, hover, right-click, none.'
  }
};
Tooltip$2.defaultProps = {
  hideArrow: false,
  placement: 'top',
  trigger: 'hover'
};
var Tooltip$3 = injectSheet$1(styles$8)(Tooltip$2);
var listStyles = {
  tableContainer: {
    '@media (min-width: 900px)': {
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  listContainer: {
    '@media (min-width: 900px)': {
      width: 'calc(50% - 9px)'
    }
  },
  listHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '7px 31px 8px 10px',
    fontWeight: 'bold',
    fontFamily: 'inherit',
    fontSize: 12,
    textTransform: 'uppercase'
  },
  secondaryColumn: {
    textAlign: 'right'
  },
  listItemWrapper: {
    maxHeight: 345
  }
};
var itemStyles = {
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: function borderBottom(_ref) {
      var fixedColors = _ref.fixedColors;
      return '1px solid ' + fixedColors.lightGrey;
    },
    color: function color(_ref2) {
      var textColors = _ref2.textColors;
      return '' + textColors.dark;
    },
    padding: 10,
    marginRight: 21
  },
  listItemName: {
    fontFamily: 'inherit',
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: function color(_ref3) {
      var textColors = _ref3.textColors;
      return '' + textColors.dark;
    }
  },
  listItemTopProps: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  listItemIsin: {
    fontSize: 12,
    lineHeight: '16px'
  },
  primaryColumn: {
    flex: 0.7,
    overflow: 'hidden',
    '@media (min-width: 1920px)': {
      flex: 0.8
    }
  },
  secondaryColumn: {
    textAlign: 'right',
    fontSize: 14,
    flex: 0.3,
    fontFamily: 'inherit',
    color: function color(_ref4) {
      var textColors = _ref4.textColors;
      return '' + textColors.dark;
    },
    '@media (min-width: 1920px)': {
      flex: 0.2
    }
  }
};

function ItemValue(_ref) {
  var value = _ref.value,
      language = _ref.language,
      className = _ref.className,
      statusColors = _ref.statusColors;
  var style = {
    color: value < 0 ? statusColors.loss : statusColors.profit,
    fontSize: 14
  };
  return React__default.createElement('span', {
    className: className
  }, numberDecimalFormat(value, language), '\xA0', value < 0 ? React__default.createElement(FontAwesomeIcon, {
    style: style,
    icon: faCaretDown
  }) : React__default.createElement(FontAwesomeIcon, {
    style: style,
    icon: faCaretUp
  }));
}

function ProfitLossesListItem(props) {
  var classes = props.classes,
      name = props.name,
      value = props.value,
      language = props.language,
      textColors = props.textColors,
      statusColors = props.statusColors,
      detailCell = props.detailCell;
  return React__default.createElement('div', {
    className: classes.listItem
  }, React__default.createElement('div', {
    className: classes.primaryColumn
  }, React__default.createElement('div', {
    className: classes.listItemName
  }, React__default.createElement(Tooltip$3, {
    tooltip: name
  }, name)), detailCell(props)), React__default.createElement(ItemValue, {
    className: classes.secondaryColumn,
    value: value,
    language: language,
    textColors: textColors,
    statusColors: statusColors
  }));
}

ProfitLossesListItem.propTypes = {
  name: PropTypes.node,
  value: PropTypes.node.isRequired,
  isin: PropTypes.node.isRequired,
  classes: PropTypes.shape().isRequired,
  textColors: PropTypes.shape().isRequired,
  statusColors: PropTypes.shape().isRequired,
  detailCell: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired
};
var ProfitLossesListItem$1 = injectSheet$1(itemStyles)(ProfitLossesListItem);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var _arrayEach = arrayEach;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;
/** Used for built-in method references. */

var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$9.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */

function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */

function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}

var _arrayFilter = arrayFilter;
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray() {
  return [];
}

var stubArray_1 = stubArray;
/** Used for built-in method references. */

var objectProto$c = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}

var _arrayPush = arrayPush;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
  var result = [];

  while (object) {
    _arrayPush(result, _getSymbols(object));

    object = _getPrototype(object);
  }

  return result;
};
var _getSymbolsIn = getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */

function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;
/* Built-in method references that are verified to be native. */

var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;
/* Built-in method references that are verified to be native. */

var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;
/* Built-in method references that are verified to be native. */

var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;
/* Built-in method references that are verified to be native. */

var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;
/** `Object#toString` result references. */

var mapTag$1 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */


var getTag = _baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1 || _Map && getTag(new _Map()) != mapTag$1 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$1 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;

        case mapCtorString:
          return mapTag$1;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$1;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var _getTag = getTag;
/** Used for built-in method references. */

var objectProto$d = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$d.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty$a.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}

var _initCloneArray = initCloneArray;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */

function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;
/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;
/** Used to convert symbols to primitives and strings. */

var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;
/** `Object#toString` result references. */

var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;
/** `Object#toString` result references. */

var mapTag$3 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;
/* Node.js helper references. */

var nodeIsMap = _nodeUtil && _nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;
var isMap_1 = isMap;
/** `Object#toString` result references. */

var setTag$3 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;
/* Node.js helper references. */

var nodeIsSet = _nodeUtil && _nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;
var isSet_1 = isSet;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */

var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] = cloneableTags[numberTag$2] = cloneableTags[objectTag$3] = cloneableTags[regexpTag$2] = cloneableTags[setTag$4] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject_1(value)) {
    return value;
  }

  var isArr = isArray_1(value);

  if (isArr) {
    result = _initCloneArray(value);

    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }

    if (tag == objectTag$3 || tag == argsTag$2 || isFunc && !object) {
      result = isFlat || isFunc ? {} : _initCloneObject(value);

      if (!isDeep) {
        return isFlat ? _copySymbolsIn(value, _baseAssignIn(result, value)) : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = _initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new _Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    return result;
  }

  if (isMap_1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
  }

  var keysFunc = isFull ? isFlat ? _getAllKeysIn : _getAllKeys : isFlat ? keysIn : keys_1;
  var props = isArr ? undefined : keysFunc(value);

  _arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });

  return result;
}

var _baseClone = baseClone;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */

function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;

function parseData(data) {
  var newData = cloneDeep_1(data);
  var cleanedData = newData.reduce(function (acc, value) {
    var type = value.history_type;
    value.errorComponents = value.components.filter(function (component) {
      return component.error;
    }).map(function (component) {
      return {
        error: component.error,
        name: component.name || component.isin
      };
    });
    value.components = value.components.filter(function (component) {
      return !component.error;
    });
    value.components = value.components.map(function (component) {
      component.performance *= 100;
      return component;
    });
    value.components = value.components.sort(function (val1, val2) {
      return val2.performance - val1.performance;
    });
    value.positiveComponents = value.components.filter(function (component) {
      return component.performance >= 0;
    });
    value.negativeComponents = value.components.filter(function (component) {
      return component.performance < 0;
    });
    delete value.history_type;
    delete value.components;
    acc[type] = value;
    return acc;
  }, {});
  return cleanedData;
}

function ProfitLossesList(props) {
  var title = props.title,
      classes = props.classes,
      data = props.data,
      assetsInfo = props.assetsInfo,
      historyType = props.historyType,
      tooltipOptions = props.tooltipOptions,
      detailCell = props.detailCell,
      language = props.language,
      textColorsProps = props.textColors,
      statusColorsProps = props.statusColors,
      fixedColorsProps = props.fixedColors;
  var globalTheme = getGlobalConfig().theme;
  var textColors = helpers.valueOrDefault(textColorsProps, globalTheme.text);
  var statusColors = helpers.valueOrDefault(statusColorsProps, globalTheme.status);
  var fixedColors = helpers.valueOrDefault(fixedColorsProps, globalTheme.extra);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  /**
   * Build an structure like:
   * {
   *   history_type_1: {
   *     start: Date,
   *     end: Date,
   *     performance: number,
   *     components: []
   *   }
   * }
   *
   * This way, indexing via the history type can be done faster.
   */

  var cleanedData = parseData(data);
  var errorsInData = cleanedData[historyType].errorComponents;
  var profitData = cleanedData[historyType].positiveComponents.map(function (component) {
    component.name = extractAssetInfo(assetsInfo, component.isin, 'name', component.isin);
    return component;
  });
  var lossData = cleanedData[historyType].negativeComponents.map(function (component) {
    component.name = extractAssetInfo(assetsInfo, component.isin, 'name', component.isin);
    return component;
  });
  var headerStyles = {
    backgroundColor: fixedColors.backgroundLight,
    color: textColors.light
  };
  var scrollContainerStyle = {
    width: 5,
    opacity: 1,
    zIndex: 100
  };
  var scrollBarStyle = {
    width: 5,
    height: 100,
    background: fixedColors.lightGrey,
    borderRadius: 3,
    marginLeft: 0
  };

  var renderTable = function renderTable(typeStr, data) {
    return React__default.createElement('div', {
      className: classes.listContainer
    }, React__default.createElement('div', {
      className: classes.listHeader,
      style: headerStyles
    }, React__default.createElement('div', null, 'INSTRUMENT NAME'), React__default.createElement('div', {
      className: classes.secondaryColumn
    }, typeStr, React__default.createElement('br', null), '(%)')), React__default.createElement(ScrollArea, {
      className: classes.listItemWrapper,
      speed: 0.8,
      horizontal: false,
      verticalContainerStyle: scrollContainerStyle,
      verticalScrollbarStyle: scrollBarStyle,
      stopScrollPropagation: true,
      smoothScrolling: true
    }, data.map(function (component) {
      return React__default.createElement(ProfitLossesListItem$1, {
        key: component.isin,
        name: extractAssetInfo(assetsInfo, component.isin, 'name', component.isin),
        value: component.performance,
        isin: component.isin,
        textColors: textColors,
        statusColors: statusColors,
        fixedColors: fixedColors,
        detailCell: detailCell,
        language: locale
      });
    })));
  };

  return React__default.createElement('div', null, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement('div', {
    className: classes.tableContainer
  }, renderTable('PROFITS', profitData), renderTable('LOSSES', lossData)));
}

ProfitLossesList.propTypes = {
  classes: PropTypes.shape().isRequired,
  data: PropTypes.array.isRequired,
  title: PropTypes.node,
  historyType: HistoryTypePropType,
  assetsInfo: PropTypes.shape(),
  textColors: PropTypes.shape(),
  statusColors: PropTypes.shape(),
  fixedColors: PropTypes.shape(),
  tooltipOptions: PropTypes.shape(),
  detailCell: PropTypes.func,
  language: PropTypes.string
};
ProfitLossesList.propDefs = {
  classes: Defs.classesDef,
  data: {
    type: 'Object',
    description: 'Data to be displayed in the table. Expected in the shape of Core.Analyses performance endpoint.'
  },
  title: Defs.titleDef,
  historyType: {
    type: 'enum',
    description: '\n      Period of historic performance to be shown. Options are:\n      <ul>\n        <li>WTD</li>\n        <li>MTD</li>\n        <li>QTD</li>\n        <li>YTD</li>\n        <li>30D</li>\n        <li>3M</li>\n        <li>1Y</li>\n      </ul>\n    '
  },
  assetsInfo: {
    type: 'Object',
    description: 'Additional asset information used to show some field as the name of the instrument.'
  },
  fixedColors: Defs.fixedColorsDef,
  textColors: Defs.textColorsDef,
  statusColors: Defs.statusColorsDef,
  tooltipOptions: Defs.tooltipOptionsDef,
  language: Defs.languageDef,
  detailCell: {
    type: 'func',
    description: 'Function to dynamically render the details for each row in the profit losses table. Should return a valid React node.'
  }
};
ProfitLossesList.defaultProps = {
  title: null,
  historyType: HISTORY_TYPE['30D'],
  assetsInfo: null,
  textColors: null,
  statusColors: null,
  fixedColors: null,
  language: '',
  tooltipOptions: {},
  detailCell: function detailCell(_ref) {
    var classes = _ref.classes,
        isin = _ref.isin;
    return React__default.createElement('div', {
      className: classes.listItemIsin
    }, isin);
  }
};
var ProfitLossesList$1 = injectSheet$1(listStyles)(ProfitLossesList);

function allocationErrors(data) {
  if (!data || !data.by_component) {
    return [];
  }

  return data['by_component'].filter(function (item) {
    if (item.error) {
      return item;
    }
  });
}

function lessThanZero(value, lang) {
  if (value > 0.01) {
    return numberDecimalFormat(value, lang);
  }

  return '<0' + decimalSeparator(lang) + '01';
}

function AllocationPieChart(props) {
  var data = props.data,
      title = props.title,
      group = props.group,
      colors = props.colors,
      pie = props.pie,
      orientation = props.orientation,
      language = props.language,
      legendInteraction = props.legendInteraction,
      chartOptions = props.chartOptions,
      tooltipOptions = props.tooltipOptions;
  var values = data[group];
  var errorsInData = allocationErrors(data);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var verticalLegendOptions = {
    layout: ORIENTATION.VERTICAL,
    align: 'right',
    verticalAlign: 'middle'
  };
  var horizontalLegendOptions = {
    layout: ORIENTATION.HORIZONTAL,
    alignColumns: false,
    align: 'center',
    verticalAlign: 'bottom'
  };
  var options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      marginTop: 0,
      style: {
        fontFamily: 'inherit'
      }
    },
    title: null,
    colors: helpers.getColors(colors, getGlobalConfig(), values.length),
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function formatter() {
        return this.point.name + ' : ' + numberDecimalFormat(this.percentage, locale) + '%';
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        innerSize: pie ? '0%' : '50%',
        showInLegend: true,
        point: {
          events: {
            legendItemClick: function legendItemClick() {
              return legendInteraction;
            }
          }
        }
      }
    },
    legend: {
      enabled: true,
      itemStyle: {
        'fontWeight': 'normal'
      },
      itemMarginBottom: 7,
      useHTML: true,
      labelFormatter: function labelFormatter() {
        return '<b>' + this.name + '</b><br/>' + lessThanZero(this.percentage, locale) + '%';
      }
    },
    series: [{
      colorByPoint: true,
      data: dataFormatter$1(values)
    }]
  };
  options.legend = Object.assign({}, options.legend, orientation === ORIENTATION.VERTICAL ? verticalLegendOptions : horizontalLegendOptions);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement(HighchartsBase, {
    language: language,
    options: merge_1(options, chartOptions),
    callback: function callback(chart) {
      // max height should be the container size minus the Title + InfoTooltip height.
      chart.container.parentElement.style.maxHeight = 'calc(100% - 55px)';
      var _chart$options$legend = chart.options.legend,
          layout = _chart$options$legend.layout,
          verticalAlign = _chart$options$legend.verticalAlign;

      if (layout === ORIENTATION.VERTICAL && ['top', 'bottom'].includes(verticalAlign)) {
        // set min height for the chart, so legend do not overlap with the chart
        // and spacing is not too big.
        var pieMinHeight = 300;
        var minHeight = pieMinHeight + 35 * values.length; //chart.container.parentElement.style.minHeight = `${minHeight}px`
      }

      chart.reflow();
    }
  }));
}

AllocationPieChart.propTypes = {
  data: PropTypes.shape().isRequired,
  title: PropTypes.node.isRequired,
  group: AllocationGroupPropType.isRequired,
  language: PropTypes.string,
  colors: ColorsPropType,
  pie: PropTypes.bool,
  orientation: OrientationPropType,
  legendInteraction: PropTypes.bool,
  chartOptions: PropTypes.shape(),
  tooltipOptions: TooltipOptionsPropType
};
AllocationPieChart.propDefs = {
  data: {
    type: 'Object',
    description: 'Data to be displayed. Expects the shape of the response from Core.Analyse Allocation Endpoint.'
  },
  title: Defs.titleDef,
  group: Defs.allocationGroupsDef,
  colors: Defs.arrayColorsDef,
  pie: {
    type: 'bool',
    description: 'Whether to show the chart as a full pie or dount chart.'
  },
  orientation: Defs.orientationsDef,
  language: Defs.languageDef,
  legendInteraction: {
    type: 'bool',
    description: 'Whether the chart should support user interaction on legend (clicks on legend to show/hide entries)'
  },
  chartOptions: Defs.chartOptionsDef,
  tooltipOptions: Defs.tooltipOptionsDef
};
AllocationPieChart.defaultProps = {
  colors: null,
  pie: true,
  orientation: ORIENTATION.VERTICAL,
  language: '',
  legendInteraction: true,
  chartOptions: {},
  tooltipOptions: {}
};

function dataFormatter$1(data) {
  var formattedData = data.map(function (item) {
    return {
      name: item.name,
      y: item.weight * 100
    };
  });
  return formattedData;
}

function sortByKey(values, key) {
  return values.concat().sort(function (el1, el2) {
    if (el1[key] < el2[key]) {
      return 1;
    }

    if (el1[key] > el2[key]) {
      return -1;
    }

    return 0;
  });
}
/**
 * General component description.
 */


function AllocationBarChart(props) {
  var data = props.data,
      title = props.title,
      group = props.group,
      colors = props.colors,
      orientation = props.orientation,
      gridLinesOrientation = props.gridLinesOrientation,
      showValueLabels = props.showValueLabels,
      sorted = props.sorted,
      limit = props.limit,
      language = props.language,
      chartOptions = props.chartOptions,
      tooltipOptions = props.tooltipOptions;
  var errorsInData = allocationErrors(data);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var values = data[group];
  var showTop10 = false;

  if (sorted) {
    values = sortByKey(values, 'weight');
    showTop10 = values.length > limit;
    values = values.slice(0, limit);
  }

  var options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: orientation === ORIENTATION.HORIZONTAL ? 'bar' : 'column',
      style: {
        fontFamily: 'inherit'
      }
    },
    title: null,
    colors: helpers.getColors(colors, getGlobalConfig(), values.length),
    xAxis: {
      categories: categoriesFormatter(values),
      gridLineWidth: isGridLineVisible(orientation, gridLinesOrientation, AXIS.X) ? 1 : 0,
      labels: {
        align: orientation === ORIENTATION.HORIZONTAL ? 'left' : undefined,
        reserveSpace: orientation === ORIENTATION.HORIZONTAL
      }
    },
    yAxis: {
      gridLineWidth: isGridLineVisible(orientation, gridLinesOrientation, AXIS.Y) ? 1 : 0,
      labels: {
        enabled: showValueLabels
      },
      title: {
        text: null
      }
    },
    tooltip: {
      followPointer: true,
      formatter: function formatter() {
        return this.point.name + ': ' + lessThanZero(this.point.y, locale) + '%';
      }
    },
    plotOptions: {
      bar: {
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          style: {
            'fontWeight': 'normal'
          },
          formatter: function formatter() {
            return lessThanZero(this.point.y, locale) + '%';
          }
        }
      },
      column: {
        colorByPoint: true,
        dataLabels: {
          enabled: true,
          style: {
            'fontWeight': 'normal'
          },
          formatter: function formatter() {
            return lessThanZero(this.point.y, locale) + '%';
          }
        }
      }
    },
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    series: dataFormatter$2(values)
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title + (showTop10 ? ' (Top ' + limit + ')' : ''),
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement(HighchartsBase, {
    options: merge_1(options, chartOptions),
    language: locale,
    callback: function callback(chart) {
      // max height should be the container size minus the Title + InfoTooltip height.
      chart.container.parentElement.style.maxHeight = 'calc(100% - 55px)';
      chart.reflow(); // reflows chart to fit the containers size
    }
  }));
}

AllocationBarChart.propTypes = {
  data: PropTypes.shape().isRequired,
  title: PropTypes.node.isRequired,
  group: AllocationGroupPropType.isRequired,
  language: PropTypes.string,
  orientation: OrientationPropType,
  gridLinesOrientation: OrientationPropType,
  showValueLabels: PropTypes.bool,
  sorted: PropTypes.bool,
  limit: PropTypes.number,
  colors: ColorsPropType,
  chartOptions: PropTypes.shape(),
  tooltipOptions: TooltipOptionsPropType
};
AllocationBarChart.propDefs = {
  data: {
    type: 'Object',
    description: 'Object with the structure of the Allocation response from Core.Analyse.'
  },
  title: Defs.titleDef,
  language: Defs.languageDef,
  orientation: Defs.orientationsDef,
  gridLinesOrientation: {
    type: 'enum',
    description: '\n      Defines the direction of the grid lines.\n      <ul>\n        <li>horizontal</li>\n        <li>vertical</li>\n      </ul>\n    '
  },
  showValueLabels: {
    type: 'bool',
    description: 'Whether to show numeric labels in the bar chart.'
  },
  group: Defs.allocationGroupsDef,
  sorted: {
    type: 'bool',
    description: 'Whether to sort the data in the chart.'
  },
  limit: {
    type: 'number',
    description: 'If sorted is enabled, picks top `limit` elements and shows only those. Adds `Top <limit>` to title.'
  },
  colors: Defs.arrayColorsDef,
  chartOptions: Defs.chartOptionsDef,
  tooltipOptions: Defs.tooltipOptionsDef
};
AllocationBarChart.defaultProps = {
  colors: null,
  orientation: ORIENTATION.VERTICAL,
  gridLinesOrientation: ORIENTATION.HORIZONTAL,
  showValueLabels: false,
  sorted: false,
  limit: Infinity,
  language: '',
  chartOptions: {},
  tooltipOptions: {}
};

function dataFormatter$2(data) {
  var formattedData = data.map(function (item) {
    return [item.name, item.weight * 100];
  });
  return [{
    name: 'Currency allocation',
    data: formattedData
  }];
}

function categoriesFormatter(data) {
  var formattedData = data.map(function (item) {
    return item.name;
  });
  return formattedData;
}

function isGridLineVisible(orientation, gridLinesOrientation, axis) {
  if (axis === AXIS.X) {
    if (orientation === ORIENTATION.HORIZONTAL) {
      return gridLinesOrientation === ORIENTATION.HORIZONTAL;
    } else {
      return gridLinesOrientation === ORIENTATION.VERTICAL;
    }
  } else {
    if (orientation === ORIENTATION.HORIZONTAL) {
      return gridLinesOrientation === ORIENTATION.VERTICAL;
    } else {
      return gridLinesOrientation === ORIENTATION.HORIZONTAL;
    }
  }
}

var title = "World, Miller projection, medium resolution";
var version = "1.1.2";
var type = "FeatureCollection";
var copyright = "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth";
var copyrightShort = "Natural Earth";
var copyrightUrl = "http://www.naturalearthdata.com";
var crs = {
  type: "name",
  properties: {
    name: "urn:ogc:def:crs:EPSG:54003"
  }
};
var features = [{
  type: "Feature",
  id: "FO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.54,
    "hc-key": "fo",
    "hc-a2": "FO",
    name: "Faroe Islands",
    labelrank: "6",
    "country-abbrev": "Faeroe Is.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "FRO",
    "iso-a2": "FO",
    "woe-id": "23424816",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3991, 8611], [4005, 8598], [4004, 8594], [3989, 8605], [3991, 8611]]]
  }
}, {
  type: "Feature",
  id: "UM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.57,
    "hc-middle-y": 0.58,
    "hc-key": "um",
    "hc-a2": "UM",
    name: "United States Minor Outlying Islands",
    labelrank: "5",
    "country-abbrev": "U.S. MOI",
    subregion: "Seven seas (open ocean)",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "UMI",
    "iso-a2": "UM",
    "woe-id": "28289407",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[-605, 6652], [-606, 6652], [-606, 6652], [-606, 6652], [-605, 6652]]]
  }
}, {
  type: "Feature",
  id: "US",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.68,
    "hc-middle-y": 0.68,
    "hc-key": "us",
    "hc-a2": "US",
    name: "United States of America",
    labelrank: "2",
    "country-abbrev": "U.S.A.",
    subregion: "Northern America",
    "region-wb": "North America",
    "iso-a3": "USA",
    "iso-a2": "US",
    "woe-id": "23424977",
    continent: "North America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[556, 8034], [559, 8032], [549, 8036], [550, 8040], [556, 8034]]], [[[558, 8043], [561, 8042], [558, 8039], [553, 8040], [558, 8043]]], [[[265, 8289], [268, 8289], [267, 8283], [263, 8288], [265, 8289]]], [[[263, 8300], [267, 8295], [264, 8292], [261, 8294], [263, 8300]]], [[[255, 8300], [267, 8279], [253, 8290], [251, 8302], [255, 8300]]], [[[306, 8298], [305, 8293], [298, 8293], [300, 8304], [306, 8298]]], [[[249, 8306], [250, 8302], [245, 8301], [244, 8305], [249, 8306]]], [[[292, 8310], [298, 8305], [294, 8298], [291, 8308], [292, 8310]]], [[[238, 8311], [244, 8313], [244, 8308], [238, 8304], [238, 8311]]], [[[249, 8311], [248, 8310], [244, 8314], [249, 8314], [249, 8311]]], [[[232, 8330], [237, 8337], [249, 8340], [245, 8335], [232, 8330]]], [[[272, 8342], [284, 8338], [278, 8330], [268, 8336], [272, 8342]]], [[[268, 8353], [268, 8346], [255, 8348], [259, 8353], [268, 8353]]], [[[282, 8349], [285, 8339], [276, 8346], [276, 8355], [282, 8349]]], [[[261, 8368], [271, 8358], [264, 8355], [259, 8356], [261, 8368]]], [[[234, 8379], [258, 8373], [253, 8353], [237, 8353], [234, 8379]]], [[[181, 8386], [179, 8377], [173, 8376], [177, 8383], [181, 8386]]], [[[158, 8420], [155, 8412], [152, 8416], [154, 8423], [158, 8420]]], [[[1578, 8023], [1574, 8018], [1559, 8010], [1556, 8013], [1578, 8023]]], [[[1623, 7918], [1621, 7909], [1614, 7899], [1610, 7903], [1623, 7918]]], [[[1667, 7934], [1667, 7928], [1663, 7927], [1665, 7933], [1667, 7934]]], [[[1724, 7944], [1726, 7939], [1717, 7939], [1721, 7943], [1724, 7944]]], [[[224, 8331], [215, 8369], [227, 8371], [236, 8359], [224, 8331]]], [[[-726, 8256], [-740, 8233], [-777, 8227], [-811, 8206], [-792, 8230], [-757, 8230], [-757, 8246], [-726, 8256]]], [[[193, 8378], [186, 8400], [202, 8387], [208, 8341], [193, 8378]]], [[[183, 8412], [177, 8392], [156, 8412], [174, 8431], [183, 8412]]], [[[199, 8431], [221, 8424], [229, 8389], [214, 8393], [199, 8431]]], [[[-826, 8660], [-803, 8657], [-834, 8641], [-862, 8661], [-896, 8667], [-850, 8675], [-826, 8660]]], [[[553, 8054], [551, 8053], [551, 8054], [553, 8054]]], [[[1261, 7281], [1260, 7293], [1252, 7296], [1228, 7335], [1206, 7373], [1202, 7375], [1200, 7378], [1167, 7387], [1143, 7358], [1102, 7380], [1091, 7409], [1043, 7449], [993, 7449], [993, 7434], [908, 7434], [797, 7472], [799, 7479], [728, 7473], [722, 7492], [686, 7523], [648, 7524], [624, 7541], [571, 7629], [568, 7651], [532, 7689], [528, 7720], [512, 7742], [522, 7777], [507, 7826], [520, 7864], [527, 7925], [507, 8030], [563, 8020], [563, 8024], [573, 8014], [562, 8025], [562, 8026], [566, 8031], [562, 8027], [561, 8054], [1379, 8054], [1455, 8037], [1491, 8018], [1546, 8016], [1503, 7997], [1471, 7971], [1510, 7975], [1520, 7963], [1574, 7988], [1575, 7986], [1575, 7988], [1591, 7997], [1601, 7995], [1583, 7981], [1612, 7961], [1683, 7971], [1697, 7959], [1708, 7961], [1708, 7954], [1689, 7936], [1622, 7938], [1592, 7889], [1612, 7898], [1595, 7842], [1598, 7806], [1614, 7783], [1632, 7792], [1645, 7831], [1636, 7855], [1644, 7893], [1694, 7935], [1726, 7918], [1730, 7880], [1715, 7868], [1750, 7865], [1758, 7833], [1755, 7820], [1751, 7816], [1746, 7820], [1739, 7807], [1727, 7787], [1756, 7775], [1780, 7780], [1855, 7817], [1862, 7830], [1858, 7836], [1858, 7842], [1927, 7844], [1955, 7886], [1970, 7900], [1987, 7905], [1987, 7905], [2082, 7905], [2118, 7937], [2126, 7968], [2149, 7996], [2192, 7982], [2192, 7933], [2196, 7927], [2203, 7927], [2202, 7914], [2210, 7911], [2216, 7898], [2179, 7882], [2181, 7881], [2174, 7874], [2173, 7879], [2173, 7879], [2164, 7875], [2168, 7876], [2168, 7870], [2163, 7871], [2161, 7874], [2155, 7872], [2110, 7843], [2108, 7787], [2041, 7770], [2006, 7747], [2005, 7718], [1959, 7656], [1937, 7700], [1941, 7654], [1934, 7620], [1948, 7620], [1956, 7577], [1933, 7542], [1915, 7545], [1890, 7517], [1854, 7495], [1795, 7447], [1786, 7414], [1814, 7342], [1829, 7289], [1819, 7237], [1797, 7235], [1766, 7277], [1746, 7323], [1752, 7355], [1710, 7394], [1682, 7378], [1650, 7401], [1567, 7404], [1544, 7395], [1558, 7358], [1533, 7373], [1514, 7361], [1485, 7382], [1464, 7376], [1411, 7380], [1340, 7337], [1309, 7290], [1321, 7262], [1289, 7265], [1261, 7281]]], [[[247, 8324], [243, 8322], [239, 8327], [247, 8327], [248, 8327], [252, 8348], [288, 8301], [287, 8280], [261, 8307], [246, 8319], [247, 8324]]], [[[-425, 7092], [-433, 7100], [-433, 7100], [-426, 7097], [-425, 7092], [-425, 7092], [-425, 7092]]], [[[-425, 7092], [-390, 7060], [-422, 7047], [-425, 7092], [-425, 7092], [-425, 7092]]], [[[308, 8292], [307, 8287], [302, 8290], [308, 8292], [308, 8292], [308, 8292]]], [[[217, 8430], [220, 8427], [210, 8429], [210, 8433], [205, 8435], [148, 8429], [100, 8466], [54, 8486], [-34, 8511], [-77, 8513], [-132, 8528], [-131, 8544], [-185, 8544], [-179, 8506], [-229, 8506], [-240, 8492], [-304, 8469], [-282, 8489], [-303, 8495], [-289, 8538], [-261, 8553], [-264, 8566], [-317, 8528], [-328, 8503], [-369, 8479], [-346, 8459], [-377, 8422], [-432, 8396], [-465, 8356], [-478, 8363], [-510, 8328], [-540, 8328], [-589, 8308], [-615, 8286], [-687, 8268], [-679, 8288], [-643, 8297], [-585, 8332], [-551, 8327], [-555, 8346], [-513, 8369], [-478, 8400], [-458, 8457], [-516, 8437], [-555, 8465], [-597, 8443], [-595, 8484], [-613, 8511], [-651, 8497], [-693, 8522], [-709, 8506], [-741, 8500], [-765, 8515], [-713, 8520], [-680, 8544], [-726, 8574], [-715, 8598], [-667, 8655], [-644, 8644], [-615, 8663], [-568, 8678], [-587, 8710], [-579, 8735], [-637, 8709], [-728, 8718], [-784, 8772], [-702, 8808], [-655, 8816], [-653, 8790], [-599, 8787], [-594, 8837], [-655, 8842], [-667, 8867], [-741, 8904], [-729, 8932], [-673, 8934], [-637, 8959], [-638, 8973], [-601, 9009], [-570, 9009], [-534, 9034], [-486, 9036], [-450, 9061], [-399, 9052], [-370, 9033], [-317, 9037], [-306, 9015], [-225, 9020], [-162, 9000], [-87, 8990], [-49, 8997], [19, 8972], [20, 8520], [74, 8510], [120, 8473], [126, 8458], [158, 8488], [183, 8497], [199, 8475], [245, 8436], [292, 8359], [346, 8330], [346, 8304], [346, 8304], [319, 8284], [320, 8322], [316, 8323], [310, 8332], [305, 8326], [295, 8329], [287, 8349], [254, 8380], [220, 8428], [217, 8430]]], [[[-373, 8372], [-390, 8391], [-344, 8421], [-318, 8446], [-311, 8403], [-356, 8377], [-413, 8325], [-373, 8372]]], [[[-433, 7100], [-479, 7115], [-446, 7112], [-433, 7100], [-433, 7100]]], [[[308, 8292], [309, 8295], [309, 8292], [308, 8292], [308, 8292], [308, 8292]]]]
  }
}, {
  type: "Feature",
  id: "JP",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.66,
    "hc-key": "jp",
    "hc-a2": "JP",
    name: "Japan",
    labelrank: "2",
    "country-abbrev": "Japan",
    subregion: "Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "JPN",
    "iso-a2": "JP",
    "woe-id": "23424856",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[8389, 7914], [8390, 7917], [8398, 7911], [8394, 7909], [8389, 7914]]], [[[8149, 7526], [8129, 7515], [8097, 7520], [8140, 7570], [8197, 7578], [8232, 7572], [8278, 7641], [8269, 7618], [8307, 7629], [8314, 7654], [8342, 7662], [8359, 7703], [8352, 7721], [8369, 7771], [8380, 7756], [8400, 7767], [8419, 7706], [8391, 7670], [8390, 7636], [8375, 7598], [8384, 7580], [8357, 7553], [8353, 7573], [8306, 7546], [8256, 7542], [8267, 7531], [8239, 7508], [8212, 7518], [8222, 7544], [8172, 7539], [8149, 7527], [8166, 7521], [8186, 7539], [8200, 7532], [8186, 7497], [8173, 7507], [8138, 7480], [8130, 7504], [8149, 7526]]], [[[8044, 7495], [8037, 7525], [8057, 7499], [8076, 7517], [8113, 7508], [8122, 7487], [8101, 7435], [8068, 7431], [8067, 7482], [8044, 7495]]], [[[8380, 7790], [8365, 7775], [8355, 7820], [8373, 7846], [8401, 7845], [8416, 7924], [8472, 7874], [8509, 7860], [8522, 7839], [8483, 7831], [8455, 7794], [8413, 7818], [8367, 7806], [8380, 7790]]]]
  }
}, {
  type: "Feature",
  id: "SC",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.58,
    "hc-middle-y": 0.41,
    "hc-key": "sc",
    "hc-a2": "SC",
    name: "Seychelles",
    labelrank: "6",
    "country-abbrev": "Syc.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "SYC",
    "iso-a2": "SC",
    "woe-id": "23424941",
    continent: "Seven seas (open ocean)"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5849, 6344], [5852, 6341], [5851, 6337], [5843, 6348], [5849, 6344]]]
  }
}, {
  type: "Feature",
  id: "IN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.34,
    "hc-middle-y": 0.43,
    "hc-key": "in",
    "hc-a2": "IN",
    name: "India",
    labelrank: "2",
    "country-abbrev": "India",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "IND",
    "iso-a2": "IN",
    "woe-id": "23424848",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[6818, 7133], [6820, 7134], [6820, 7126], [6817, 7128], [6818, 7133]]], [[[6819, 7322], [6840, 7326], [6842, 7305], [6869, 7285], [6937, 7293], [6923, 7319], [6953, 7324], [7012, 7369], [7032, 7360], [7057, 7370], [7092, 7333], [7074, 7306], [7024, 7278], [7023, 7255], [6996, 7195], [6973, 7200], [6969, 7150], [6951, 7137], [6939, 7192], [6922, 7167], [6909, 7188], [6949, 7229], [6935, 7237], [6886, 7236], [6870, 7262], [6829, 7277], [6818, 7260], [6843, 7237], [6816, 7220], [6837, 7209], [6832, 7189], [6847, 7142], [6823, 7124], [6820, 7141], [6792, 7124], [6767, 7075], [6740, 7073], [6699, 7023], [6646, 6986], [6647, 6972], [6586, 6945], [6580, 6925], [6588, 6875], [6574, 6835], [6574, 6783], [6504, 6717], [6476, 6742], [6454, 6807], [6424, 6859], [6410, 6911], [6384, 6956], [6360, 7072], [6367, 7093], [6351, 7149], [6344, 7113], [6310, 7098], [6291, 7105], [6258, 7137], [6287, 7155], [6241, 7174], [6227, 7195], [6247, 7208], [6280, 7205], [6313, 7222], [6265, 7289], [6295, 7328], [6337, 7325], [6368, 7360], [6381, 7388], [6416, 7427], [6415, 7446], [6438, 7461], [6400, 7495], [6393, 7534], [6410, 7548], [6453, 7539], [6490, 7559], [6513, 7572], [6527, 7544], [6546, 7534], [6542, 7507], [6563, 7480], [6530, 7473], [6541, 7434], [6608, 7397], [6589, 7383], [6579, 7353], [6660, 7310], [6714, 7305], [6751, 7281], [6795, 7274], [6820, 7286], [6819, 7322]]]]
  }
}, {
  type: "Feature",
  id: "FR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.28,
    "hc-middle-y": 0.04,
    "hc-key": "fr",
    "hc-a2": "FR",
    name: "France",
    labelrank: "2",
    "country-abbrev": "Fr.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "FRA",
    "iso-a2": "FR",
    "woe-id": "-90",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[2537, 7972], [2531, 7971], [2530, 7983], [2533, 7975], [2537, 7972]]], [[[4485, 7820], [4477, 7774], [4465, 7781], [4462, 7817], [4485, 7820]]], [[[9164, 5848], [9155, 5806], [9109, 5833], [9082, 5858], [9076, 5879], [9141, 5830], [9164, 5848]]], [[[6256, 4904], [6297, 4899], [6285, 4876], [6245, 4876], [6256, 4904]]], [[[2331, 7017], [2334, 7019], [2334, 7016], [2331, 7017]]], [[[4427, 7861], [4426, 7860], [4425, 7859], [4424, 7860], [4423, 7858], [4385, 7835], [4321, 7852], [4294, 7830], [4298, 7812], [4279, 7808], [4263, 7812], [4262, 7812], [4262, 7812], [4255, 7814], [4255, 7818], [4246, 7818], [4203, 7821], [4151, 7846], [4160, 7853], [4173, 7943], [4145, 7980], [4120, 7997], [4065, 8019], [4064, 8038], [4112, 8049], [4124, 8036], [4163, 8041], [4147, 8082], [4197, 8065], [4210, 8081], [4250, 8101], [4251, 8127], [4279, 8135], [4327, 8092], [4376, 8075], [4381, 8071], [4392, 8072], [4447, 8053], [4429, 8001], [4386, 7963], [4389, 7952], [4391, 7955], [4393, 7956], [4405, 7957], [4405, 7947], [4412, 7939], [4400, 7909], [4427, 7861]]], [[[2596, 6636], [2603, 6648], [2632, 6639], [2670, 6598], [2632, 6543], [2583, 6547], [2601, 6581], [2587, 6623], [2596, 6636]]]]
  }
}, {
  type: "Feature",
  id: "FM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.52,
    "hc-key": "fm",
    "hc-a2": "FM",
    name: "Federated States of Micronesia",
    labelrank: "6",
    "country-abbrev": "F.S.M.",
    subregion: "Micronesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "FSM",
    "iso-a2": "FM",
    "woe-id": "23424815",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[8899, 6684], [8902, 6683], [8902, 6679], [8899, 6679], [8899, 6684]]]
  }
}, {
  type: "Feature",
  id: "CN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.41,
    "hc-middle-y": 0.56,
    "hc-key": "cn",
    "hc-a2": "CN",
    name: "China",
    labelrank: "2",
    "country-abbrev": "China",
    subregion: "Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "CHN",
    "iso-a2": "CN",
    "woe-id": "23424781",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[7429, 7050], [7456, 7076], [7488, 7081], [7498, 7067], [7481, 7036], [7459, 7021], [7429, 7031], [7429, 7050]]], [[[6842, 7305], [6840, 7326], [6819, 7322], [6773, 7330], [6756, 7323], [6729, 7336], [6699, 7367], [6683, 7364], [6640, 7401], [6608, 7397], [6541, 7434], [6530, 7473], [6563, 7480], [6542, 7507], [6546, 7534], [6527, 7544], [6513, 7572], [6500, 7571], [6482, 7577], [6459, 7605], [6416, 7624], [6411, 7627], [6426, 7631], [6423, 7675], [6395, 7677], [6389, 7707], [6399, 7728], [6446, 7748], [6450, 7736], [6482, 7759], [6521, 7763], [6529, 7774], [6584, 7803], [6602, 7838], [6581, 7906], [6646, 7924], [6668, 7986], [6719, 7972], [6741, 7981], [6750, 8032], [6795, 8058], [6801, 8059], [6810, 8061], [6814, 8039], [6847, 8016], [6885, 8003], [6906, 7963], [6901, 7912], [6979, 7903], [7034, 7879], [7064, 7822], [7220, 7815], [7232, 7803], [7282, 7788], [7326, 7787], [7372, 7807], [7453, 7813], [7526, 7857], [7511, 7885], [7528, 7908], [7575, 7895], [7603, 7919], [7637, 7921], [7664, 7953], [7714, 7968], [7756, 7963], [7762, 7975], [7722, 8015], [7698, 8015], [7696, 8015], [7691, 8008], [7642, 8005], [7632, 8021], [7667, 8086], [7699, 8074], [7742, 8093], [7740, 8107], [7768, 8158], [7788, 8176], [7766, 8201], [7790, 8222], [7862, 8234], [7935, 8210], [8005, 8075], [8043, 8071], [8086, 8027], [8093, 8004], [8135, 8005], [8192, 8031], [8204, 8005], [8185, 7988], [8178, 7951], [8146, 7907], [8138, 7916], [8121, 7913], [8090, 7899], [8099, 7870], [8091, 7827], [8078, 7815], [8057, 7831], [8053, 7812], [8004, 7796], [8007, 7774], [7962, 7785], [7943, 7758], [7895, 7730], [7838, 7706], [7799, 7682], [7804, 7705], [7833, 7744], [7800, 7758], [7778, 7733], [7751, 7722], [7736, 7698], [7699, 7695], [7708, 7662], [7731, 7662], [7749, 7627], [7787, 7651], [7812, 7637], [7845, 7637], [7787, 7604], [7742, 7557], [7773, 7532], [7791, 7478], [7819, 7454], [7824, 7420], [7794, 7408], [7836, 7385], [7812, 7368], [7814, 7337], [7794, 7326], [7749, 7262], [7758, 7244], [7731, 7235], [7661, 7167], [7610, 7163], [7593, 7144], [7576, 7170], [7574, 7142], [7489, 7118], [7466, 7084], [7461, 7122], [7422, 7134], [7409, 7122], [7366, 7149], [7372, 7161], [7329, 7180], [7289, 7154], [7245, 7162], [7234, 7150], [7217, 7146], [7222, 7111], [7206, 7124], [7177, 7120], [7170, 7139], [7146, 7143], [7157, 7171], [7138, 7175], [7130, 7203], [7101, 7195], [7103, 7234], [7133, 7260], [7132, 7313], [7098, 7343], [7092, 7333], [7057, 7370], [7032, 7360], [7012, 7369], [6953, 7324], [6923, 7319], [6882, 7338], [6842, 7305]]]]
  }
}, {
  type: "Feature",
  id: "PT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.46,
    "hc-middle-y": 0.5,
    "hc-key": "pt",
    "hc-a2": "PT",
    name: "Portugal",
    labelrank: "2",
    "country-abbrev": "Port.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "PRT",
    "iso-a2": "PT",
    "woe-id": "23424925",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3984, 7629], [3937, 7624], [3944, 7663], [3922, 7681], [3946, 7754], [3944, 7795], [4009, 7795], [4020, 7781], [3998, 7762], [3997, 7692], [3984, 7629]]]
  }
}, {
  type: "Feature",
  id: "SW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.86,
    "hc-middle-y": 0.57,
    "hc-key": "sw",
    "hc-a2": "SW",
    name: "Serranilla Bank",
    labelrank: "5",
    "country-abbrev": "S.B.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "-99",
    "iso-a2": "SW",
    "woe-id": "-99",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1870, 6950], [1870, 6950], [1870, 6950], [1870, 6950]]]
  }
}, {
  type: "Feature",
  id: "SH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.54,
    "hc-middle-y": 0.51,
    "hc-key": "sh",
    "hc-a2": "SH",
    name: "Scarborough Reef",
    labelrank: "6",
    "country-abbrev": "S.R.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "-99",
    "iso-a2": "SH",
    "woe-id": "-99",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7699, 6929], [7698, 6929], [7698, 6929], [7698, 6929], [7699, 6929]]]
  }
}, {
  type: "Feature",
  id: "BR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.54,
    "hc-middle-y": 0.34,
    "hc-key": "br",
    "hc-a2": "BR",
    name: "Brazil",
    labelrank: "2",
    "country-abbrev": "Brazil",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "BRA",
    "iso-a2": "BR",
    "woe-id": "23424768",
    continent: "South America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[2729, 6474], [2767, 6471], [2755, 6436], [2702, 6426], [2696, 6461], [2729, 6474]]], [[[2615, 5450], [2627, 5475], [2626, 5480], [2554, 5539], [2542, 5531], [2517, 5563], [2494, 5561], [2549, 5623], [2606, 5658], [2604, 5706], [2584, 5708], [2584, 5709], [2583, 5712], [2594, 5736], [2594, 5755], [2559, 5759], [2553, 5800], [2530, 5817], [2483, 5817], [2488, 5852], [2478, 5876], [2496, 5937], [2471, 5965], [2469, 5993], [2419, 5995], [2409, 6069], [2369, 6077], [2332, 6104], [2293, 6110], [2263, 6149], [2262, 6192], [2226, 6186], [2177, 6154], [2139, 6155], [2108, 6153], [2111, 6200], [2091, 6185], [2061, 6183], [2007, 6256], [2034, 6290], [2040, 6327], [2103, 6356], [2128, 6354], [2143, 6437], [2125, 6474], [2131, 6529], [2181, 6529], [2206, 6540], [2219, 6515], [2258, 6498], [2301, 6525], [2324, 6550], [2303, 6552], [2286, 6596], [2377, 6604], [2401, 6632], [2424, 6629], [2437, 6595], [2423, 6558], [2431, 6534], [2459, 6514], [2509, 6538], [2528, 6536], [2543, 6553], [2583, 6547], [2632, 6543], [2670, 6598], [2688, 6593], [2700, 6543], [2723, 6528], [2725, 6479], [2679, 6465], [2701, 6426], [2743, 6421], [2788, 6463], [2869, 6439], [2879, 6399], [2908, 6412], [2969, 6393], [3017, 6395], [3062, 6370], [3101, 6334], [3149, 6327], [3171, 6267], [3156, 6207], [3109, 6160], [3075, 6104], [3048, 6086], [3051, 6007], [3043, 5952], [3028, 5936], [3026, 5900], [2985, 5834], [2988, 5821], [2956, 5790], [2888, 5790], [2811, 5749], [2785, 5728], [2761, 5693], [2767, 5650], [2757, 5614], [2726, 5585], [2711, 5552], [2684, 5560], [2677, 5531], [2654, 5510], [2642, 5465], [2620, 5444], [2615, 5447], [2615, 5450]]]]
  }
}, {
  type: "Feature",
  id: "KI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.28,
    "hc-middle-y": 0.65,
    "hc-key": "ki",
    "hc-a2": "KI",
    name: "Kiribati",
    labelrank: "6",
    "country-abbrev": "Kir.",
    subregion: "Micronesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "KIR",
    "iso-a2": "KI",
    "woe-id": "23424867",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[-468, 6538], [-465, 6533], [-460, 6529], [-467, 6531], [-468, 6538]]]
  }
}, {
  type: "Feature",
  id: "PH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.4,
    "hc-middle-y": 0.19,
    "hc-key": "ph",
    "hc-a2": "PH",
    name: "Philippines",
    labelrank: "2",
    "country-abbrev": "Phil.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "PHL",
    "iso-a2": "PH",
    "woe-id": "23424934",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[7894, 6825], [7915, 6827], [7892, 6850], [7919, 6851], [7934, 6808], [7915, 6812], [7907, 6784], [7894, 6825]]], [[[7758, 6817], [7762, 6844], [7775, 6837], [7758, 6817], [7758, 6817]]], [[[7753, 6809], [7752, 6810], [7758, 6817], [7758, 6817], [7758, 6816], [7753, 6809], [7753, 6809]]], [[[7823, 6787], [7825, 6841], [7859, 6818], [7853, 6800], [7886, 6812], [7884, 6786], [7855, 6746], [7836, 6770], [7842, 6795], [7823, 6787]]], [[[7891, 6697], [7867, 6709], [7840, 6706], [7823, 6668], [7827, 6707], [7866, 6736], [7880, 6720], [7907, 6747], [7929, 6745], [7929, 6776], [7953, 6740], [7962, 6694], [7951, 6678], [7937, 6696], [7925, 6676], [7925, 6643], [7891, 6661], [7891, 6697]]], [[[7896, 6884], [7885, 6826], [7867, 6840], [7859, 6878], [7840, 6893], [7842, 6869], [7816, 6893], [7801, 6877], [7817, 6862], [7802, 6841], [7776, 6880], [7796, 6881], [7767, 6918], [7760, 6966], [7777, 6959], [7775, 7002], [7801, 7048], [7798, 7035], [7834, 7023], [7840, 6987], [7831, 6962], [7812, 6952], [7817, 6900], [7839, 6905], [7896, 6884]]], [[[7753, 6809], [7757, 6790], [7686, 6729], [7752, 6809], [7753, 6809]]]]
  }
}, {
  type: "Feature",
  id: "MX",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.51,
    "hc-middle-y": 0.49,
    "hc-key": "mx",
    "hc-a2": "MX",
    name: "Mexico",
    labelrank: "2",
    "country-abbrev": "Mex.",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "MEX",
    "iso-a2": "MX",
    "woe-id": "23424900",
    continent: "North America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[1630, 7094], [1622, 7084], [1622, 7088], [1624, 7093], [1630, 7094]]], [[[1038, 7129], [1042, 7127], [1052, 7116], [1044, 7121], [1038, 7129]]], [[[881, 7216], [885, 7216], [889, 7212], [889, 7210], [881, 7216]]], [[[875, 7231], [874, 7226], [871, 7225], [874, 7232], [875, 7231]]], [[[786, 7330], [784, 7328], [781, 7330], [786, 7338], [786, 7330]]], [[[696, 7356], [694, 7355], [692, 7363], [695, 7361], [696, 7356]]], [[[864, 7349], [866, 7364], [874, 7359], [871, 7350], [864, 7349]]], [[[836, 7376], [845, 7368], [847, 7358], [833, 7372], [836, 7376]]], [[[1200, 7378], [1199, 7374], [1206, 7373], [1228, 7335], [1252, 7296], [1259, 7288], [1261, 7281], [1289, 7265], [1321, 7262], [1306, 7216], [1300, 7155], [1321, 7096], [1361, 7038], [1401, 7020], [1478, 7034], [1505, 7051], [1523, 7108], [1589, 7126], [1630, 7115], [1609, 7083], [1597, 7023], [1583, 7030], [1567, 7012], [1558, 7009], [1504, 7009], [1491, 6992], [1522, 6966], [1482, 6956], [1466, 6911], [1417, 6957], [1389, 6967], [1339, 6944], [1273, 6971], [1205, 6993], [1183, 7012], [1133, 7025], [1088, 7056], [1067, 7089], [1083, 7121], [1064, 7158], [989, 7239], [956, 7256], [956, 7286], [923, 7307], [876, 7358], [847, 7417], [849, 7428], [804, 7448], [801, 7397], [832, 7368], [924, 7228], [922, 7208], [946, 7205], [956, 7176], [943, 7165], [930, 7186], [876, 7228], [873, 7264], [834, 7285], [790, 7321], [816, 7325], [820, 7341], [771, 7383], [760, 7417], [728, 7473], [799, 7479], [797, 7472], [908, 7434], [993, 7434], [993, 7449], [1043, 7449], [1091, 7409], [1102, 7380], [1143, 7358], [1167, 7387], [1200, 7378]], [[1309, 7246], [1303, 7231], [1306, 7218], [1313, 7245], [1309, 7246]]]]
  }
}, {
  type: "Feature",
  id: "ES",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.76,
    "hc-middle-y": 0.27,
    "hc-key": "es",
    "hc-a2": "ES",
    name: "Spain",
    labelrank: "2",
    "country-abbrev": "Sp.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "ESP",
    "iso-a2": "ES",
    "woe-id": "23424950",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[3748, 7322], [3716, 7331], [3697, 7330], [3726, 7345], [3748, 7322]]], [[[4117, 7566], [4118, 7565], [4117, 7564], [4116, 7566], [4117, 7566]]], [[[4044, 7586], [4046, 7586], [4045, 7584], [4044, 7585], [4044, 7586]]], [[[4045, 7594], [4021, 7599], [4011, 7621], [3984, 7629], [3997, 7692], [3998, 7762], [4020, 7781], [4009, 7795], [3944, 7795], [3930, 7838], [3969, 7860], [3988, 7852], [4098, 7851], [4151, 7846], [4203, 7821], [4246, 7818], [4249, 7812], [4255, 7814], [4262, 7812], [4262, 7813], [4262, 7814], [4263, 7812], [4263, 7812], [4279, 7808], [4298, 7812], [4300, 7795], [4265, 7771], [4233, 7763], [4194, 7709], [4211, 7683], [4189, 7669], [4183, 7644], [4154, 7635], [4143, 7615], [4072, 7613], [4046, 7594], [4045, 7594]]]]
  }
}, {
  type: "Feature",
  id: "BU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.73,
    "hc-key": "bu",
    "hc-a2": "BU",
    name: "Bajo Nuevo Bank (Petrel Is.)",
    labelrank: "8",
    "country-abbrev": null,
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "-99",
    "iso-a2": "BU",
    "woe-id": "-99",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1830, 6948], [1830, 6948], [1830, 6948], [1830, 6948], [1830, 6948]]]
  }
}, {
  type: "Feature",
  id: "MV",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.57,
    "hc-middle-y": 0.53,
    "hc-key": "mv",
    "hc-a2": "MV",
    name: "Maldives",
    labelrank: "5",
    "country-abbrev": "Mald.",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "MDV",
    "iso-a2": "MV",
    "woe-id": "23424899",
    continent: "Seven seas (open ocean)"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6382, 6647], [6390, 6636], [6380, 6637], [6384, 6642], [6382, 6647]]]
  }
}, {
  type: "Feature",
  id: "SP",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.5,
    "hc-key": "sp",
    "hc-a2": "SP",
    name: "Spratly Islands",
    labelrank: "6",
    "country-abbrev": "Spratly Is.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "SPI",
    "iso-a2": "SP",
    "woe-id": "23424921",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7642, 6799], [7641, 6799], [7641, 6799], [7642, 6799], [7642, 6799]]]
  }
}, {
  type: "Feature",
  id: "GB",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.69,
    "hc-middle-y": 0.09,
    "hc-key": "gb",
    "hc-a2": "GB",
    name: "United Kingdom",
    labelrank: "2",
    "country-abbrev": "U.K.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "GBR",
    "iso-a2": "GB",
    "woe-id": "-90",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4108, 8458], [4110, 8454], [4106, 8453], [4102, 8457], [4108, 8458]]], [[[4112, 8469], [4111, 8462], [4116, 8461], [4104, 8463], [4112, 8469]]], [[[4118, 8472], [4113, 8477], [4125, 8471], [4121, 8468], [4118, 8472]]], [[[4173, 8521], [4166, 8500], [4165, 8515], [4155, 8520], [4173, 8521]]], [[[4176, 8534], [4182, 8533], [4169, 8530], [4171, 8539], [4176, 8534]]], [[[4181, 8542], [4179, 8536], [4175, 8537], [4176, 8542], [4181, 8542]]], [[[1789, 7055], [1792, 7057], [1798, 7055], [1792, 7054], [1789, 7055]]], [[[2080, 7131], [2072, 7131], [2072, 7133], [2077, 7133], [2080, 7131]]], [[[2065, 7134], [2063, 7131], [2058, 7131], [2062, 7132], [2065, 7134]]], [[[3994, 8404], [3993, 8427], [4018, 8441], [4015, 8421], [3994, 8404]]], [[[2433, 4774], [2454, 4816], [2486, 4811], [2491, 4798], [2433, 4774]]], [[[5210, 7554], [5209, 7553], [5207, 7555], [5206, 7555], [5206, 7555], [5206, 7554], [5204, 7554], [5204, 7555], [5205, 7555], [5203, 7556], [5206, 7556], [5210, 7558], [5210, 7557], [5207, 7557], [5210, 7554]], [[5205, 7555], [5206, 7556], [5205, 7556], [5205, 7555]]], [[[4046, 7594], [4045, 7593], [4045, 7594], [4046, 7594]]], [[[5184, 7543], [5181, 7544], [5176, 7544], [5178, 7545], [5184, 7543]]], [[[3989, 8295], [4018, 8305], [4040, 8278], [4018, 8256], [3987, 8256], [3961, 8270], [3989, 8295]]], [[[4024, 8390], [4056, 8446], [4114, 8447], [4083, 8416], [4100, 8407], [4147, 8405], [4152, 8396], [4110, 8337], [4156, 8317], [4168, 8277], [4202, 8256], [4214, 8215], [4204, 8207], [4254, 8201], [4251, 8174], [4225, 8151], [4244, 8137], [4212, 8122], [4102, 8117], [4043, 8100], [4081, 8140], [4113, 8140], [4074, 8163], [4046, 8166], [4079, 8182], [4080, 8220], [4109, 8227], [4119, 8259], [4096, 8272], [4103, 8288], [4073, 8289], [4075, 8268], [4052, 8286], [4067, 8313], [4036, 8351], [4008, 8361], [4032, 8367], [4003, 8396], [4024, 8390]]]]
  }
}, {
  type: "Feature",
  id: "GR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.3,
    "hc-middle-y": 0.43,
    "hc-key": "gr",
    "hc-a2": "GR",
    name: "Greece",
    labelrank: "3",
    "country-abbrev": "Greece",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "GRC",
    "iso-a2": "GR",
    "woe-id": "23424833",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4984, 7560], [4938, 7553], [4902, 7565], [4922, 7573], [4984, 7560]]], [[[5023, 7596], [5041, 7604], [5037, 7593], [5028, 7585], [5023, 7596]]], [[[5011, 7610], [5003, 7612], [5010, 7619], [5009, 7615], [5011, 7610]]], [[[5002, 7626], [5006, 7623], [5003, 7621], [5004, 7624], [5002, 7626]]], [[[4952, 7622], [4962, 7630], [4963, 7623], [4957, 7611], [4952, 7622]]], [[[4985, 7644], [4977, 7640], [4975, 7641], [4978, 7645], [4985, 7644]]], [[[5004, 7649], [5007, 7647], [4999, 7645], [4993, 7649], [5004, 7649]]], [[[4978, 7677], [4980, 7667], [4975, 7669], [4971, 7677], [4978, 7677]]], [[[4959, 7727], [4953, 7726], [4959, 7743], [4966, 7743], [4959, 7727]]], [[[4828, 7750], [4831, 7753], [4828, 7750], [4826, 7753], [4826, 7754], [4828, 7756], [4831, 7756], [4854, 7765], [4884, 7773], [4931, 7781], [4953, 7770], [4985, 7786], [4994, 7775], [4977, 7752], [4947, 7761], [4907, 7750], [4928, 7732], [4876, 7743], [4874, 7728], [4958, 7637], [4915, 7667], [4918, 7646], [4893, 7656], [4878, 7642], [4892, 7604], [4853, 7613], [4838, 7665], [4798, 7715], [4809, 7720], [4828, 7750]]], [[[4989, 7700], [4994, 7693], [4988, 7690], [4971, 7698], [4986, 7702], [4988, 7702], [4989, 7700]]]]
  }
}, {
  type: "Feature",
  id: "AS",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.56,
    "hc-middle-y": 0.57,
    "hc-key": "as",
    "hc-a2": "AS",
    name: "American Samoa",
    labelrank: "4",
    "country-abbrev": "Am. Samoa",
    subregion: "Polynesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "ASM",
    "iso-a2": "AS",
    "woe-id": "23424746",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[-859, 6056], [-861, 6055], [-863, 6052], [-866, 6054], [-859, 6056]]]
  }
}, {
  type: "Feature",
  id: "DK",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.35,
    "hc-middle-y": 0.49,
    "hc-key": "dk",
    "hc-a2": "DK",
    name: "Denmark",
    labelrank: "4",
    "country-abbrev": "Den.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "DNK",
    "iso-a2": "DK",
    "woe-id": "23424796",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4538, 8291], [4553, 8278], [4544, 8277], [4531, 8283], [4538, 8291]]], [[[4511, 8288], [4516, 8286], [4512, 8286], [4506, 8292], [4511, 8288]]], [[[4576, 8293], [4566, 8288], [4565, 8292], [4570, 8294], [4576, 8293]]], [[[4495, 8296], [4502, 8291], [4500, 8287], [4494, 8289], [4495, 8296]]], [[[4526, 8290], [4523, 8282], [4520, 8286], [4529, 8299], [4526, 8290]]], [[[4578, 8322], [4559, 8280], [4533, 8320], [4567, 8339], [4578, 8322]]], [[[4484, 8285], [4466, 8289], [4461, 8288], [4445, 8357], [4495, 8381], [4519, 8408], [4509, 8372], [4529, 8353], [4516, 8338], [4525, 8302], [4488, 8310], [4484, 8285]]]]
  }
}, {
  type: "Feature",
  id: "GL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.55,
    "hc-middle-y": 0.43,
    "hc-key": "gl",
    "hc-a2": "GL",
    name: "Greenland",
    labelrank: "3",
    "country-abbrev": "Grlnd.",
    subregion: "Northern America",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "GRL",
    "iso-a2": "GL",
    "woe-id": "23424828",
    continent: "North America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[2633, 8910], [2635, 8908], [2628, 8905], [2624, 8909], [2633, 8910]]], [[[2656, 8923], [2628, 8916], [2630, 8920], [2642, 8923], [2656, 8923]]], [[[2582, 9011], [2574, 9011], [2571, 9017], [2578, 9015], [2582, 9011]]], [[[2616, 9047], [2602, 9051], [2613, 9062], [2620, 9051], [2616, 9047]]], [[[2570, 9117], [2557, 9108], [2553, 9113], [2571, 9121], [2570, 9117]]], [[[2552, 9143], [2545, 9137], [2535, 9139], [2543, 9143], [2552, 9143]]], [[[2572, 9145], [2556, 9131], [2554, 9142], [2564, 9145], [2572, 9145]]], [[[2544, 9188], [2558, 9180], [2554, 9179], [2539, 9188], [2544, 9188]]], [[[2534, 9206], [2543, 9205], [2524, 9203], [2524, 9209], [2534, 9206]]], [[[2528, 9242], [2510, 9242], [2496, 9242], [2521, 9246], [2528, 9242]]], [[[2139, 9366], [2126, 9367], [2127, 9369], [2140, 9370], [2139, 9366]]], [[[2061, 9422], [2086, 9417], [2076, 9414], [2052, 9419], [2061, 9422]]], [[[2100, 9424], [2119, 9418], [2095, 9418], [2088, 9423], [2100, 9424]]], [[[3690, 9588], [3655, 9569], [3628, 9580], [3678, 9596], [3690, 9588]]], [[[2218, 9636], [2228, 9632], [2222, 9631], [2218, 9632], [2218, 9636]]], [[[2683, 9729], [2658, 9730], [2626, 9738], [2637, 9753], [2683, 9729]]], [[[2610, 8952], [2619, 8961], [2572, 8975], [2577, 9002], [2623, 9002], [2661, 8980], [2657, 8963], [2610, 8952]]], [[[2631, 8765], [2626, 8765], [2626, 8768], [2627, 8768], [2624, 8771], [2612, 8811], [2652, 8832], [2603, 8840], [2627, 8897], [2686, 8916], [2696, 8975], [2677, 8989], [2606, 9011], [2584, 9029], [2647, 9028], [2701, 9008], [2677, 9040], [2647, 9058], [2641, 9054], [2628, 9056], [2632, 9066], [2636, 9065], [2631, 9068], [2667, 9078], [2637, 9080], [2624, 9074], [2617, 9080], [2629, 9081], [2633, 9081], [2599, 9084], [2603, 9068], [2563, 9065], [2545, 9082], [2553, 9091], [2548, 9094], [2555, 9096], [2557, 9095], [2575, 9114], [2584, 9146], [2568, 9153], [2570, 9153], [2556, 9159], [2555, 9158], [2552, 9159], [2564, 9178], [2541, 9192], [2552, 9207], [2530, 9217], [2538, 9235], [2510, 9267], [2478, 9276], [2463, 9295], [2469, 9316], [2398, 9342], [2320, 9355], [2304, 9341], [2239, 9349], [2231, 9329], [2173, 9337], [2137, 9356], [2186, 9374], [2115, 9382], [2087, 9394], [2100, 9406], [2175, 9418], [2222, 9417], [2237, 9433], [2150, 9423], [2141, 9438], [2088, 9443], [2041, 9468], [2050, 9491], [2146, 9510], [2185, 9528], [2246, 9530], [2279, 9557], [2274, 9591], [2214, 9594], [2202, 9613], [2271, 9643], [2281, 9658], [2335, 9675], [2378, 9663], [2400, 9695], [2380, 9712], [2465, 9738], [2588, 9757], [2615, 9738], [2608, 9698], [2633, 9733], [2679, 9723], [2736, 9726], [2703, 9741], [2687, 9767], [2750, 9763], [2839, 9733], [2864, 9715], [2891, 9719], [2870, 9733], [2876, 9737], [2813, 9756], [2770, 9788], [2788, 9777], [2829, 9779], [2885, 9759], [2877, 9738], [2906, 9760], [2846, 9787], [2988, 9787], [2850, 9794], [2814, 9801], [2838, 9810], [2865, 9802], [2879, 9816], [2954, 9821], [3022, 9818], [3052, 9816], [3056, 9835], [3114, 9844], [3240, 9851], [3294, 9849], [3443, 9826], [3430, 9819], [3292, 9814], [3167, 9796], [3259, 9803], [3311, 9813], [3391, 9808], [3456, 9816], [3478, 9796], [3532, 9789], [3571, 9776], [3538, 9755], [3318, 9740], [3231, 9719], [3264, 9718], [3380, 9734], [3473, 9729], [3471, 9714], [3423, 9702], [3421, 9689], [3499, 9712], [3516, 9732], [3569, 9736], [3573, 9695], [3518, 9653], [3552, 9660], [3651, 9717], [3698, 9699], [3735, 9718], [3791, 9716], [3847, 9704], [3866, 9691], [3808, 9660], [3772, 9658], [3780, 9644], [3746, 9634], [3698, 9635], [3735, 9618], [3716, 9605], [3647, 9598], [3600, 9582], [3634, 9570], [3623, 9548], [3641, 9533], [3613, 9524], [3628, 9503], [3597, 9514], [3572, 9475], [3569, 9450], [3634, 9453], [3630, 9441], [3674, 9435], [3630, 9427], [3586, 9435], [3597, 9418], [3660, 9407], [3648, 9365], [3653, 9329], [3637, 9361], [3647, 9379], [3595, 9391], [3559, 9373], [3560, 9348], [3612, 9348], [3630, 9296], [3689, 9274], [3657, 9271], [3629, 9229], [3573, 9218], [3594, 9181], [3565, 9184], [3542, 9170], [3492, 9190], [3428, 9169], [3444, 9165], [3441, 9166], [3478, 9180], [3514, 9160], [3554, 9151], [3554, 9138], [3524, 9143], [3553, 9127], [3532, 9126], [3545, 9106], [3481, 9133], [3477, 9146], [3501, 9146], [3476, 9150], [3457, 9159], [3441, 9150], [3476, 9123], [3536, 9094], [3520, 9084], [3557, 9059], [3567, 9020], [3511, 9014], [3484, 9049], [3437, 9076], [3445, 9055], [3375, 9038], [3366, 9011], [3394, 9014], [3371, 9014], [3383, 9030], [3452, 9049], [3453, 9026], [3427, 9015], [3407, 9015], [3376, 8996], [3394, 8990], [3453, 9013], [3505, 8997], [3540, 8997], [3514, 8972], [3489, 8966], [3424, 8922], [3372, 8915], [3332, 8897], [3254, 8889], [3215, 8864], [3216, 8851], [3176, 8805], [3124, 8778], [3080, 8766], [3076, 8798], [3061, 8771], [3013, 8760], [3032, 8753], [3009, 8738], [2992, 8708], [3002, 8677], [2953, 8623], [2939, 8546], [2915, 8528], [2921, 8504], [2888, 8501], [2857, 8515], [2855, 8534], [2781, 8544], [2749, 8569], [2741, 8603], [2711, 8619], [2716, 8640], [2679, 8665], [2683, 8709], [2658, 8696], [2660, 8737], [2631, 8765]]]]
  }
}, {
  type: "Feature",
  id: "GU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.44,
    "hc-key": "gu",
    "hc-a2": "GU",
    name: "Guam",
    labelrank: "6",
    "country-abbrev": "Guam",
    subregion: "Micronesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "GUM",
    "iso-a2": "GU",
    "woe-id": "23424832",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[8501, 6877], [8498, 6871], [8496, 6877], [8503, 6884], [8501, 6877]]]
  }
}, {
  type: "Feature",
  id: "MP",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.49,
    "hc-key": "mp",
    "hc-a2": "MP",
    name: "Northern Mariana Islands",
    labelrank: "6",
    "country-abbrev": "N.M.I.",
    subregion: "Micronesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "MNP",
    "iso-a2": "MP",
    "woe-id": "23424788",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[8526, 6925], [8528, 6930], [8531, 6932], [8529, 6927], [8526, 6925]]]
  }
}, {
  type: "Feature",
  id: "PR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.65,
    "hc-key": "pr",
    "hc-a2": "PR",
    name: "Puerto Rico",
    labelrank: "5",
    "country-abbrev": "P.R.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "PRI",
    "iso-a2": "PR",
    "woe-id": "23424935",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2267, 7024], [2239, 7013], [2212, 7014], [2213, 7031], [2267, 7024]]]
  }
}, {
  type: "Feature",
  id: "VI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.19,
    "hc-key": "vi",
    "hc-a2": "VI",
    name: "United States Virgin Islands",
    labelrank: "6",
    "country-abbrev": "V.I. (U.S.)",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "VIR",
    "iso-a2": "VI",
    "woe-id": "23424985",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2283, 7008], [2288, 7008], [2278, 7005], [2279, 7008], [2283, 7008]]]
  }
}, {
  type: "Feature",
  id: "CA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.29,
    "hc-middle-y": 0.64,
    "hc-key": "ca",
    "hc-a2": "CA",
    name: "Canada",
    labelrank: "2",
    "country-abbrev": "Can.",
    subregion: "Northern America",
    "region-wb": "North America",
    "iso-a3": "CAN",
    "iso-a2": "CA",
    "woe-id": "23424775",
    continent: "North America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[1713, 9425], [1665, 9428], [1680, 9462], [1643, 9470], [1608, 9466], [1608, 9487], [1634, 9510], [1674, 9517], [1735, 9510], [1777, 9514], [1703, 9520], [1681, 9564], [1638, 9573], [1639, 9612], [1717, 9607], [1765, 9581], [1781, 9562], [1787, 9587], [1735, 9612], [1889, 9631], [1831, 9632], [1931, 9652], [1841, 9647], [1743, 9627], [1715, 9642], [1699, 9625], [1630, 9631], [1649, 9658], [1614, 9633], [1551, 9650], [1631, 9659], [1637, 9668], [1538, 9660], [1523, 9671], [1581, 9700], [1519, 9685], [1545, 9704], [1475, 9704], [1503, 9719], [1590, 9738], [1689, 9729], [1630, 9740], [1671, 9751], [1659, 9764], [1742, 9752], [1829, 9728], [1749, 9758], [1768, 9779], [1812, 9771], [1783, 9788], [1833, 9786], [1825, 9799], [1915, 9793], [1945, 9807], [2002, 9803], [2013, 9793], [2038, 9809], [2136, 9812], [2138, 9803], [2235, 9795], [2168, 9776], [2203, 9778], [2284, 9797], [2337, 9767], [2377, 9766], [2384, 9744], [2294, 9710], [2264, 9713], [2226, 9694], [2125, 9670], [2289, 9698], [2178, 9642], [2107, 9600], [2083, 9572], [2026, 9575], [2032, 9559], [1951, 9546], [1907, 9553], [1909, 9541], [1994, 9538], [1993, 9525], [1945, 9531], [1892, 9527], [1955, 9522], [1989, 9509], [1984, 9496], [1934, 9493], [1975, 9482], [1961, 9465], [1901, 9446], [1881, 9418], [1807, 9415], [1859, 9401], [1848, 9390], [1892, 9392], [1896, 9373], [1852, 9352], [1863, 9324], [1837, 9325], [1849, 9351], [1798, 9340], [1807, 9358], [1714, 9361], [1699, 9351], [1610, 9360], [1531, 9362], [1516, 9376], [1584, 9403], [1602, 9416], [1587, 9445], [1616, 9451], [1653, 9439], [1658, 9421], [1713, 9425]], [[1713, 9425], [1714, 9425], [1714, 9425], [1714, 9425], [1714, 9425], [1714, 9425], [1729, 9427], [1747, 9459], [1714, 9425], [1714, 9425], [1714, 9425], [1714, 9425], [1713, 9425]]], [[[1858, 7836], [1858, 7833], [1862, 7830], [1790, 7820], [1752, 7798], [1739, 7807], [1758, 7809], [1751, 7816], [1755, 7820], [1758, 7833], [1778, 7845], [1791, 7914], [1827, 7886], [1838, 7897], [1808, 7939], [1708, 7954], [1708, 7961], [1697, 7959], [1686, 8013], [1656, 8016], [1639, 8046], [1591, 8054], [1546, 8016], [1491, 8018], [1455, 8037], [1379, 8054], [561, 8054], [555, 8058], [553, 8054], [551, 8054], [545, 8069], [502, 8091], [506, 8102], [499, 8104], [501, 8103], [504, 8100], [499, 8097], [497, 8104], [488, 8106], [489, 8108], [486, 8110], [485, 8107], [476, 8108], [474, 8109], [464, 8111], [472, 8108], [471, 8108], [468, 8109], [472, 8107], [474, 8108], [480, 8106], [485, 8099], [485, 8098], [490, 8093], [490, 8093], [508, 8069], [539, 8044], [537, 8052], [544, 8047], [553, 8046], [540, 8044], [545, 8040], [537, 8028], [504, 8038], [448, 8070], [445, 8079], [446, 8079], [443, 8087], [443, 8087], [442, 8091], [411, 8096], [393, 8123], [409, 8127], [448, 8116], [450, 8117], [447, 8118], [456, 8118], [459, 8122], [456, 8125], [447, 8118], [412, 8138], [406, 8174], [401, 8161], [398, 8166], [401, 8173], [406, 8174], [406, 8175], [407, 8175], [409, 8178], [406, 8178], [405, 8179], [408, 8179], [407, 8183], [405, 8181], [402, 8201], [387, 8216], [379, 8197], [370, 8211], [371, 8215], [366, 8216], [366, 8220], [371, 8223], [371, 8217], [373, 8223], [384, 8218], [380, 8222], [387, 8253], [374, 8237], [381, 8240], [379, 8235], [373, 8232], [372, 8234], [366, 8227], [332, 8264], [346, 8293], [346, 8304], [346, 8330], [292, 8359], [245, 8436], [199, 8475], [183, 8497], [158, 8488], [126, 8458], [120, 8473], [74, 8510], [20, 8520], [19, 8972], [75, 8965], [132, 8936], [172, 8933], [173, 8954], [234, 8964], [250, 8959], [335, 9000], [361, 8992], [287, 8966], [261, 8941], [310, 8969], [318, 8952], [336, 8974], [431, 9004], [446, 8976], [481, 8955], [509, 8996], [512, 8957], [549, 8964], [555, 8982], [600, 8978], [635, 8959], [701, 8939], [762, 8928], [763, 8938], [815, 8916], [820, 8899], [792, 8901], [776, 8883], [825, 8871], [894, 8872], [929, 8885], [965, 8875], [975, 8854], [999, 8850], [1012, 8813], [1023, 8842], [999, 8872], [1069, 8919], [1010, 8895], [975, 8901], [991, 8919], [1064, 8932], [1078, 8905], [1103, 8888], [1137, 8887], [1191, 8870], [1215, 8879], [1285, 8876], [1309, 8866], [1275, 8905], [1318, 8911], [1331, 8888], [1358, 8902], [1341, 8860], [1375, 8831], [1371, 8890], [1389, 8888], [1427, 8930], [1396, 8925], [1405, 8962], [1349, 8984], [1339, 9009], [1342, 9061], [1378, 9097], [1396, 9099], [1380, 9098], [1381, 9125], [1363, 9145], [1363, 9192], [1377, 9214], [1424, 9223], [1466, 9213], [1527, 9207], [1478, 9147], [1462, 9139], [1410, 9143], [1430, 9125], [1411, 9101], [1398, 9100], [1438, 9070], [1443, 9037], [1487, 8999], [1448, 8975], [1480, 8964], [1520, 8932], [1525, 8899], [1543, 8940], [1565, 8950], [1594, 8924], [1580, 8901], [1607, 8842], [1655, 8889], [1662, 8924], [1690, 8940], [1667, 8953], [1666, 8979], [1701, 8983], [1715, 8980], [1715, 8982], [1725, 8979], [1723, 8978], [1752, 8972], [1790, 8948], [1776, 8934], [1792, 8919], [1751, 8910], [1793, 8859], [1785, 8836], [1730, 8804], [1700, 8835], [1720, 8796], [1674, 8800], [1668, 8815], [1628, 8808], [1656, 8794], [1611, 8754], [1595, 8754], [1542, 8784], [1562, 8753], [1621, 8749], [1593, 8699], [1561, 8687], [1534, 8698], [1528, 8674], [1504, 8670], [1505, 8669], [1514, 8666], [1512, 8664], [1511, 8666], [1505, 8669], [1514, 8645], [1453, 8618], [1404, 8545], [1390, 8504], [1401, 8450], [1439, 8451], [1460, 8395], [1454, 8374], [1503, 8387], [1566, 8370], [1605, 8336], [1693, 8303], [1761, 8295], [1767, 8244], [1762, 8210], [1837, 8137], [1874, 8185], [1860, 8212], [1855, 8257], [1837, 8278], [1896, 8304], [1928, 8336], [1934, 8367], [1917, 8417], [1872, 8446], [1910, 8497], [1884, 8545], [1903, 8573], [1885, 8610], [1905, 8624], [1985, 8603], [2018, 8619], [2077, 8581], [2073, 8567], [2145, 8542], [2132, 8530], [2143, 8458], [2163, 8459], [2196, 8424], [2251, 8456], [2259, 8494], [2279, 8522], [2293, 8517], [2299, 8495], [2302, 8500], [2305, 8496], [2301, 8493], [2299, 8495], [2303, 8480], [2323, 8475], [2336, 8445], [2383, 8381], [2366, 8360], [2429, 8297], [2504, 8272], [2482, 8261], [2509, 8241], [2548, 8229], [2554, 8180], [2513, 8148], [2465, 8139], [2429, 8106], [2372, 8097], [2354, 8104], [2232, 8103], [2205, 8067], [2155, 8046], [2129, 8008], [2086, 7969], [2038, 7949], [1987, 7905], [1970, 7900], [1955, 7886], [1860, 7863], [1837, 7844], [1858, 7842], [1858, 7838], [1858, 7836]], [[456, 8113], [455, 8114], [454, 8114], [456, 8113]], [[544, 8070], [543, 8075], [540, 8074], [540, 8071], [544, 8070]], [[424, 8181], [428, 8188], [413, 8181], [409, 8169], [424, 8181]], [[1315, 8873], [1309, 8871], [1310, 8867], [1315, 8870], [1315, 8873]], [[466, 8061], [471, 8060], [471, 8063], [469, 8063], [466, 8061]], [[463, 8065], [462, 8069], [458, 8069], [458, 8065], [463, 8065]]], [[[2286, 8678], [2286, 8639], [2268, 8632], [2229, 8643], [2201, 8663], [2198, 8647], [2247, 8606], [2237, 8590], [2170, 8608], [2139, 8627], [2076, 8651], [2080, 8670], [2048, 8683], [2024, 8719], [1988, 8708], [1954, 8719], [1928, 8699], [1894, 8707], [1885, 8735], [1906, 8760], [1956, 8748], [2002, 8763], [2024, 8760], [1994, 8794], [2039, 8823], [2062, 8850], [2038, 8899], [2013, 8904], [1964, 8939], [1930, 8922], [1930, 8939], [1961, 8950], [1899, 8982], [1899, 9001], [1861, 9008], [1866, 8984], [1778, 8998], [1766, 8979], [1644, 8997], [1572, 9016], [1546, 9050], [1612, 9042], [1590, 9056], [1539, 9063], [1530, 9095], [1546, 9144], [1564, 9172], [1599, 9197], [1631, 9204], [1678, 9202], [1631, 9145], [1640, 9100], [1686, 9060], [1667, 9114], [1696, 9106], [1661, 9135], [1676, 9169], [1746, 9198], [1785, 9197], [1822, 9141], [1805, 9098], [1835, 9128], [1862, 9100], [1876, 9132], [1901, 9142], [1972, 9127], [1970, 9106], [2001, 9104], [2000, 9085], [2036, 9059], [2053, 9080], [2094, 9059], [2066, 9049], [2064, 9043], [2072, 9048], [2082, 9041], [2103, 9051], [2091, 9022], [2129, 9038], [2175, 9022], [2212, 8976], [2191, 8974], [2194, 8971], [2188, 8967], [2194, 8966], [2201, 8970], [2207, 8967], [2198, 8965], [2209, 8962], [2222, 8945], [2194, 8940], [2183, 8927], [2180, 8928], [2174, 8928], [2182, 8926], [2175, 8917], [2219, 8908], [2228, 8897], [2231, 8899], [2238, 8899], [2237, 8895], [2228, 8896], [2237, 8885], [2276, 8889], [2307, 8851], [2310, 8851], [2317, 8853], [2324, 8851], [2323, 8851], [2334, 8850], [2324, 8830], [2364, 8838], [2380, 8805], [2348, 8798], [2346, 8770], [2315, 8760], [2319, 8733], [2288, 8742], [2220, 8813], [2190, 8809], [2212, 8787], [2187, 8765], [2258, 8726], [2254, 8713], [2286, 8689], [2286, 8685], [2286, 8685], [2287, 8680], [2292, 8674], [2286, 8678]], [[2063, 9038], [2061, 9032], [2070, 9036], [2065, 9034], [2063, 9038]], [[2187, 8974], [2164, 8972], [2177, 8969], [2187, 8974]]], [[[2096, 7974], [2093, 7974], [2100, 7980], [2101, 7977], [2096, 7974]]], [[[533, 8059], [538, 8053], [544, 8051], [538, 8052], [533, 8059]]], [[[2301, 8091], [2368, 8068], [2357, 8057], [2317, 8069], [2301, 8091]]], [[[495, 8094], [493, 8097], [495, 8100], [498, 8096], [495, 8094]]], [[[409, 8150], [403, 8151], [401, 8156], [405, 8160], [409, 8150]]], [[[1857, 8175], [1850, 8170], [1841, 8168], [1841, 8172], [1857, 8175]]], [[[316, 8175], [314, 8174], [313, 8171], [313, 8177], [316, 8175]]], [[[399, 8172], [397, 8175], [398, 8179], [401, 8179], [399, 8172]]], [[[397, 8181], [396, 8177], [390, 8177], [392, 8181], [397, 8181]]], [[[385, 8190], [387, 8184], [385, 8182], [383, 8189], [385, 8190]]], [[[390, 8195], [391, 8191], [390, 8189], [384, 8195], [390, 8195]]], [[[297, 8200], [302, 8200], [303, 8197], [299, 8195], [297, 8200]]], [[[394, 8186], [392, 8196], [394, 8203], [397, 8191], [394, 8186]]], [[[366, 8203], [377, 8196], [378, 8191], [372, 8194], [366, 8203]]], [[[398, 8196], [397, 8198], [396, 8202], [400, 8203], [398, 8196]]], [[[359, 8213], [360, 8209], [357, 8209], [354, 8216], [359, 8213]]], [[[363, 8217], [367, 8211], [364, 8211], [361, 8219], [363, 8217]]], [[[1788, 8220], [1797, 8219], [1809, 8199], [1769, 8212], [1788, 8220]]], [[[1834, 8218], [1836, 8216], [1832, 8215], [1833, 8218], [1834, 8218]]], [[[378, 8225], [372, 8224], [371, 8226], [376, 8233], [378, 8225]]], [[[329, 8230], [331, 8237], [350, 8227], [348, 8218], [329, 8230]]], [[[343, 8235], [336, 8236], [334, 8239], [340, 8242], [343, 8235]]], [[[353, 8238], [366, 8226], [359, 8220], [337, 8245], [353, 8238]]], [[[327, 8256], [336, 8254], [339, 8250], [328, 8243], [327, 8256]]], [[[314, 8276], [324, 8276], [326, 8266], [318, 8270], [314, 8276]]], [[[1852, 8288], [1842, 8285], [1840, 8286], [1859, 8290], [1852, 8288]]], [[[333, 8283], [332, 8285], [341, 8294], [338, 8286], [333, 8283]]], [[[1861, 8337], [1867, 8352], [1869, 8353], [1869, 8342], [1861, 8337]]], [[[1843, 8360], [1842, 8352], [1831, 8342], [1841, 8352], [1843, 8360]]], [[[1834, 8370], [1832, 8369], [1834, 8374], [1838, 8369], [1834, 8370]]], [[[2200, 8432], [2196, 8433], [2197, 8436], [2199, 8437], [2200, 8432]]], [[[2155, 8463], [2146, 8461], [2146, 8468], [2153, 8468], [2155, 8463]]], [[[1818, 8492], [1823, 8494], [1825, 8492], [1822, 8490], [1818, 8492]]], [[[1830, 8501], [1833, 8500], [1829, 8496], [1825, 8495], [1830, 8501]]], [[[2284, 8532], [2292, 8519], [2283, 8523], [2280, 8528], [2284, 8532]]], [[[2184, 8533], [2191, 8527], [2187, 8519], [2174, 8520], [2184, 8533]]], [[[1883, 8544], [1879, 8541], [1869, 8538], [1871, 8541], [1883, 8544]]], [[[2281, 8579], [2279, 8566], [2261, 8578], [2274, 8583], [2281, 8579]]], [[[2252, 8589], [2255, 8585], [2247, 8587], [2252, 8591], [2252, 8589]]], [[[1449, 8594], [1442, 8589], [1438, 8593], [1443, 8593], [1449, 8594]]], [[[2273, 8593], [2280, 8586], [2271, 8587], [2267, 8591], [2273, 8593]]], [[[1847, 8614], [1850, 8596], [1837, 8578], [1824, 8603], [1847, 8614]]], [[[1463, 8614], [1464, 8616], [1470, 8615], [1467, 8613], [1463, 8614]]], [[[2284, 8621], [2293, 8621], [2287, 8613], [2277, 8616], [2284, 8621]]], [[[1894, 8622], [1887, 8624], [1901, 8624], [1897, 8621], [1894, 8622]]], [[[2278, 8622], [2272, 8621], [2274, 8624], [2278, 8624], [2278, 8622]]], [[[1995, 8630], [2007, 8628], [2009, 8625], [1997, 8626], [1995, 8630]]], [[[2103, 8635], [2121, 8624], [2105, 8622], [2090, 8637], [2103, 8635]]], [[[1767, 8641], [1772, 8629], [1737, 8605], [1714, 8619], [1732, 8640], [1767, 8641]]], [[[2222, 8640], [2222, 8639], [2213, 8647], [2218, 8646], [2222, 8640]]], [[[1877, 8666], [1899, 8663], [1902, 8651], [1891, 8647], [1877, 8666]]], [[[2300, 8671], [2296, 8665], [2297, 8658], [2290, 8672], [2300, 8671]]], [[[1914, 8674], [1932, 8665], [1919, 8662], [1906, 8671], [1914, 8674]]], [[[2297, 8678], [2295, 8679], [2295, 8682], [2300, 8681], [2297, 8678]]], [[[1903, 8691], [1897, 8687], [1890, 8688], [1891, 8690], [1903, 8691]]], [[[2277, 8700], [2275, 8699], [2274, 8705], [2278, 8702], [2277, 8700]]], [[[2022, 8713], [2021, 8705], [2018, 8705], [2017, 8715], [2022, 8713]]], [[[2266, 8724], [2269, 8720], [2255, 8714], [2261, 8722], [2266, 8724]]], [[[2351, 8774], [2357, 8774], [2360, 8769], [2350, 8770], [2351, 8774]]], [[[1732, 8779], [1726, 8777], [1725, 8780], [1730, 8780], [1732, 8779]]], [[[1679, 8789], [1689, 8780], [1691, 8765], [1678, 8775], [1679, 8789]]], [[[1701, 8792], [1719, 8784], [1729, 8768], [1707, 8775], [1701, 8792]]], [[[1737, 8802], [1744, 8800], [1741, 8796], [1732, 8800], [1737, 8802]]], [[[2352, 8845], [2353, 8844], [2340, 8837], [2345, 8845], [2352, 8845]]], [[[1017, 8840], [1013, 8840], [1010, 8844], [1011, 8846], [1017, 8840]]], [[[1002, 8856], [1000, 8852], [995, 8857], [1002, 8860], [1002, 8856]]], [[[987, 8864], [990, 8864], [988, 8859], [984, 8863], [987, 8864]]], [[[2311, 8862], [2304, 8863], [2306, 8869], [2311, 8864], [2311, 8862]]], [[[1001, 8864], [995, 8864], [996, 8870], [999, 8869], [1001, 8864]]], [[[843, 8882], [837, 8883], [852, 8884], [852, 8882], [843, 8882]]], [[[997, 8881], [992, 8881], [993, 8884], [996, 8885], [997, 8881]]], [[[964, 8886], [973, 8884], [971, 8880], [965, 8883], [964, 8886]]], [[[959, 8889], [960, 8886], [955, 8889], [955, 8892], [959, 8889]]], [[[944, 8895], [952, 8898], [942, 8891], [932, 8889], [944, 8895]]], [[[2000, 8891], [2025, 8885], [2025, 8875], [1996, 8875], [2000, 8891]]], [[[1641, 8883], [1634, 8873], [1624, 8883], [1631, 8902], [1641, 8883]]], [[[890, 8898], [887, 8898], [889, 8902], [894, 8903], [890, 8898]]], [[[1961, 8903], [1974, 8899], [1976, 8864], [1952, 8849], [1919, 8848], [1909, 8872], [1928, 8900], [1961, 8903]]], [[[1859, 8896], [1854, 8898], [1855, 8904], [1865, 8901], [1859, 8896]]], [[[1767, 8905], [1771, 8904], [1768, 8902], [1763, 8905], [1767, 8905]]], [[[2003, 8899], [1996, 8909], [2001, 8909], [2005, 8904], [2003, 8899]]], [[[917, 8916], [917, 8914], [919, 8912], [907, 8911], [917, 8916]]], [[[1102, 8907], [1086, 8915], [1097, 8916], [1104, 8913], [1102, 8907]]], [[[1872, 8919], [1870, 8911], [1860, 8911], [1869, 8917], [1872, 8919]]], [[[1993, 8916], [1985, 8915], [1981, 8919], [1984, 8921], [1993, 8916]]], [[[1981, 8915], [1984, 8904], [1966, 8913], [1971, 8924], [1981, 8915]]], [[[1184, 8927], [1182, 8916], [1167, 8922], [1176, 8929], [1184, 8927]]], [[[1232, 8934], [1224, 8924], [1218, 8926], [1218, 8938], [1232, 8934]]], [[[1236, 8935], [1230, 8938], [1232, 8946], [1235, 8943], [1236, 8935]]], [[[166, 8945], [168, 8943], [161, 8944], [162, 8948], [166, 8945]]], [[[1187, 8943], [1188, 8950], [1191, 8949], [1190, 8944], [1187, 8943]]], [[[1516, 8957], [1520, 8950], [1516, 8949], [1513, 8957], [1516, 8957]]], [[[1876, 8959], [1876, 8950], [1864, 8933], [1847, 8934], [1876, 8959]]], [[[181, 8968], [186, 8972], [180, 8962], [173, 8964], [181, 8968]]], [[[1779, 8961], [1785, 8959], [1786, 8956], [1774, 8960], [1779, 8961]]], [[[1528, 8959], [1523, 8951], [1518, 8955], [1523, 8961], [1528, 8959]]], [[[1918, 8960], [1929, 8958], [1914, 8944], [1907, 8952], [1918, 8960]]], [[[1199, 8967], [1208, 8963], [1201, 8958], [1198, 8962], [1199, 8967]]], [[[1336, 8968], [1351, 8968], [1351, 8957], [1339, 8963], [1336, 8968]]], [[[1365, 8970], [1373, 8966], [1364, 8955], [1363, 8967], [1365, 8970]]], [[[83, 8969], [76, 8966], [71, 8969], [76, 8972], [83, 8969]]], [[[1890, 8974], [1874, 8964], [1864, 8965], [1881, 8977], [1890, 8974]]], [[[1840, 8981], [1844, 8971], [1807, 8973], [1823, 8980], [1840, 8981]]], [[[1756, 8978], [1754, 8977], [1746, 8979], [1751, 8982], [1756, 8978]]], [[[1479, 8982], [1481, 8985], [1489, 8981], [1487, 8976], [1479, 8982]]], [[[1315, 8986], [1312, 8986], [1311, 8988], [1315, 8988], [1315, 8986]]], [[[1622, 8997], [1634, 8997], [1629, 8989], [1611, 8996], [1622, 8997]]], [[[890, 9007], [877, 9007], [872, 9011], [884, 9008], [890, 9007]]], [[[748, 9020], [758, 9020], [744, 9016], [738, 9020], [748, 9020]]], [[[735, 9020], [725, 9020], [723, 9021], [725, 9023], [735, 9020]]], [[[403, 9024], [398, 9023], [395, 9020], [398, 9026], [403, 9024]]], [[[1216, 9028], [1222, 9027], [1230, 9016], [1217, 9020], [1216, 9028]]], [[[2033, 9068], [2043, 9069], [2038, 9062], [2030, 9064], [2033, 9068]]], [[[2046, 9075], [2038, 9075], [2040, 9080], [2045, 9081], [2046, 9075]]], [[[1100, 9174], [1080, 9147], [1043, 9179], [1041, 9196], [1083, 9199], [1100, 9174]]], [[[1106, 9352], [1117, 9374], [1155, 9352], [1166, 9333], [1127, 9326], [1106, 9352]]], [[[1524, 9434], [1544, 9415], [1530, 9407], [1498, 9420], [1524, 9434]]], [[[1088, 9420], [1104, 9404], [1081, 9404], [1056, 9441], [1088, 9420]]], [[[1664, 8007], [1660, 8006], [1654, 8006], [1656, 8009], [1664, 8007]]], [[[1600, 8048], [1604, 8045], [1593, 8045], [1594, 8049], [1600, 8048]]], [[[1763, 7943], [1772, 7941], [1776, 7924], [1734, 7937], [1763, 7943]]], [[[1732, 7940], [1731, 7937], [1726, 7938], [1728, 7941], [1732, 7940]]], [[[1710, 7953], [1718, 7950], [1713, 7944], [1709, 7949], [1710, 7953]]], [[[1938, 7875], [1934, 7873], [1936, 7876], [1943, 7877], [1938, 7875]]], [[[1366, 9443], [1437, 9441], [1429, 9423], [1355, 9424], [1366, 9443]]], [[[2430, 7942], [2394, 7922], [2378, 7943], [2406, 7980], [2411, 7952], [2430, 7942]]], [[[2364, 7988], [2365, 7958], [2348, 7940], [2327, 7957], [2361, 7959], [2364, 7988]]], [[[277, 8210], [270, 8217], [293, 8221], [295, 8199], [277, 8210]]], [[[257, 8259], [297, 8258], [287, 8221], [261, 8230], [257, 8259]]], [[[1844, 8337], [1829, 8330], [1851, 8362], [1858, 8352], [1844, 8337]]], [[[1395, 9317], [1429, 9288], [1426, 9252], [1382, 9254], [1337, 9272], [1349, 9299], [1395, 9317]]], [[[957, 9478], [905, 9483], [849, 9475], [844, 9483], [927, 9507], [955, 9496], [957, 9478]]], [[[1358, 9489], [1390, 9481], [1388, 9465], [1330, 9444], [1302, 9460], [1284, 9490], [1291, 9511], [1350, 9498], [1358, 9489]]], [[[2210, 7911], [2202, 7914], [2203, 7927], [2195, 7929], [2192, 7933], [2192, 7982], [2149, 7996], [2126, 7968], [2118, 7937], [2082, 7905], [1987, 7905], [2022, 7920], [2033, 7943], [2111, 7979], [2155, 8025], [2239, 8062], [2276, 8063], [2298, 8050], [2295, 8032], [2262, 8016], [2230, 8020], [2256, 8004], [2290, 8010], [2271, 7986], [2302, 7943], [2350, 7927], [2367, 7937], [2394, 7917], [2333, 7893], [2308, 7894], [2257, 7848], [2239, 7871], [2245, 7889], [2279, 7910], [2289, 7938], [2249, 7913], [2210, 7911]]], [[[2018, 7927], [2024, 7931], [2021, 7924], [2020, 7921], [2009, 7921], [2015, 7925], [2012, 7925], [2016, 7930], [2021, 7930], [2018, 7927]]], [[[518, 8075], [504, 8083], [514, 8081], [518, 8075], [518, 8075], [518, 8075]]], [[[629, 9322], [617, 9345], [604, 9327], [571, 9328], [559, 9347], [597, 9359], [678, 9417], [749, 9430], [780, 9414], [754, 9406], [765, 9375], [730, 9364], [718, 9338], [684, 9302], [660, 9308], [712, 9340], [710, 9380], [687, 9377], [670, 9338], [629, 9322]]], [[[2606, 8006], [2634, 8020], [2643, 7998], [2633, 7971], [2596, 7976], [2607, 7995], [2574, 7990], [2550, 7973], [2552, 8004], [2449, 8000], [2441, 8012], [2462, 8038], [2521, 8144], [2553, 8130], [2521, 8094], [2558, 8090], [2552, 8069], [2599, 8083], [2618, 8064], [2604, 8038], [2629, 8033], [2606, 8006]]], [[[1663, 8674], [1617, 8670], [1645, 8694], [1639, 8718], [1654, 8775], [1667, 8783], [1687, 8748], [1694, 8761], [1761, 8726], [1784, 8700], [1824, 8681], [1800, 8664], [1725, 8695], [1722, 8679], [1673, 8648], [1663, 8674]]], [[[1295, 8985], [1330, 8964], [1360, 8932], [1379, 8931], [1340, 8910], [1312, 8914], [1248, 8940], [1284, 8957], [1295, 8985]]], [[[1118, 9032], [1191, 8997], [1210, 8979], [1165, 8981], [1152, 8958], [1175, 8964], [1181, 8940], [1135, 8927], [1046, 8948], [1043, 8964], [1019, 8939], [971, 8925], [843, 8910], [830, 8948], [762, 8954], [719, 8990], [733, 8998], [815, 9008], [894, 9005], [875, 9018], [821, 9029], [760, 9020], [715, 9023], [691, 9046], [758, 9065], [767, 9075], [697, 9065], [700, 9081], [671, 9079], [670, 9095], [698, 9112], [685, 9123], [721, 9151], [804, 9178], [822, 9164], [829, 9134], [850, 9157], [903, 9140], [890, 9116], [922, 9133], [946, 9128], [919, 9156], [937, 9155], [980, 9131], [1007, 9079], [1021, 9094], [1006, 9107], [996, 9142], [999, 9187], [1024, 9167], [1044, 9168], [1077, 9144], [1079, 9125], [1107, 9076], [1100, 9049], [1118, 9032]]], [[[1885, 9194], [1941, 9161], [1939, 9145], [1830, 9148], [1807, 9172], [1804, 9199], [1885, 9194]]], [[[1340, 9095], [1291, 9080], [1274, 9059], [1217, 9110], [1182, 9118], [1155, 9145], [1179, 9161], [1198, 9140], [1223, 9141], [1230, 9163], [1188, 9184], [1204, 9198], [1291, 9219], [1302, 9241], [1296, 9210], [1318, 9205], [1321, 9178], [1285, 9158], [1318, 9154], [1331, 9167], [1346, 9123], [1340, 9095]]], [[[596, 9246], [638, 9229], [700, 9230], [736, 9218], [782, 9183], [668, 9135], [638, 9108], [624, 9071], [551, 9049], [522, 9083], [467, 9098], [499, 9159], [531, 9200], [502, 9234], [596, 9246]]], [[[1227, 9273], [1215, 9298], [1242, 9311], [1158, 9302], [1138, 9317], [1171, 9332], [1183, 9360], [1242, 9329], [1202, 9368], [1208, 9378], [1306, 9362], [1313, 9300], [1295, 9274], [1227, 9273]]], [[[938, 9326], [960, 9339], [928, 9351], [976, 9386], [984, 9335], [1027, 9326], [1040, 9336], [1073, 9326], [1073, 9306], [1130, 9283], [1100, 9275], [1068, 9293], [1058, 9276], [987, 9267], [975, 9276], [890, 9242], [830, 9239], [808, 9254], [857, 9271], [887, 9271], [912, 9287], [822, 9276], [820, 9294], [792, 9270], [717, 9284], [764, 9354], [794, 9364], [795, 9380], [808, 9377], [822, 9344], [851, 9349], [896, 9323], [902, 9303], [972, 9302], [974, 9314], [938, 9326]]], [[[1848, 9265], [1825, 9250], [1777, 9240], [1726, 9247], [1603, 9240], [1567, 9252], [1535, 9244], [1473, 9259], [1459, 9285], [1470, 9325], [1440, 9355], [1412, 9348], [1360, 9357], [1331, 9393], [1362, 9399], [1423, 9389], [1442, 9371], [1490, 9375], [1552, 9344], [1528, 9336], [1587, 9303], [1652, 9304], [1719, 9322], [1797, 9319], [1840, 9300], [1841, 9283], [1817, 9274], [1848, 9265]]], [[[933, 9426], [877, 9415], [845, 9427], [833, 9446], [816, 9439], [788, 9455], [811, 9463], [843, 9452], [918, 9464], [949, 9456], [933, 9426]]], [[[1126, 9547], [1165, 9524], [1187, 9528], [1249, 9496], [1240, 9486], [1266, 9450], [1200, 9447], [1205, 9471], [1154, 9471], [1155, 9482], [1104, 9475], [1087, 9490], [1131, 9490], [1115, 9522], [1071, 9525], [1076, 9545], [1126, 9547]]], [[[1511, 9629], [1553, 9627], [1562, 9603], [1579, 9620], [1601, 9618], [1623, 9584], [1617, 9561], [1665, 9561], [1684, 9542], [1637, 9527], [1563, 9469], [1474, 9471], [1406, 9521], [1437, 9534], [1477, 9534], [1456, 9553], [1417, 9540], [1362, 9550], [1334, 9600], [1389, 9593], [1338, 9609], [1354, 9630], [1379, 9632], [1370, 9645], [1389, 9663], [1439, 9666], [1403, 9677], [1436, 9685], [1480, 9670], [1511, 9629]]], [[[518, 8075], [519, 8073], [519, 8072], [518, 8075], [518, 8075], [518, 8075]]]]
  }
}, {
  type: "Feature",
  id: "ST",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.55,
    "hc-middle-y": 0.5,
    "hc-key": "st",
    "hc-a2": "ST",
    name: "Sao Tome and Principe",
    labelrank: "6",
    "country-abbrev": "S.T.P.",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "STP",
    "iso-a2": "ST",
    "woe-id": "23424966",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4400, 6481], [4396, 6485], [4401, 6491], [4405, 6487], [4400, 6481]]]
  }
}, {
  type: "Feature",
  id: "CV",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.56,
    "hc-middle-y": 0.5,
    "hc-key": "cv",
    "hc-a2": "CV",
    name: "Cape Verde",
    labelrank: "4",
    "country-abbrev": "C.Vd.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "CPV",
    "iso-a2": "CV",
    "woe-id": "23424794",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3499, 6934], [3506, 6928], [3507, 6922], [3499, 6925], [3499, 6934]]]
  }
}, {
  type: "Feature",
  id: "DM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.54,
    "hc-middle-y": 0.47,
    "hc-key": "dm",
    "hc-a2": "DM",
    name: "Dominica",
    labelrank: "6",
    "country-abbrev": "D'inca",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "DMA",
    "iso-a2": "DM",
    "woe-id": "23424798",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2382, 6942], [2386, 6936], [2383, 6930], [2380, 6939], [2382, 6942]]]
  }
}, {
  type: "Feature",
  id: "NL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.99,
    "hc-middle-y": 0.01,
    "hc-key": "nl",
    "hc-a2": "NL",
    name: "Netherlands",
    labelrank: "5",
    "country-abbrev": "Neth.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "NLD",
    "iso-a2": "NL",
    "woe-id": "-90",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4369, 8229], [4359, 8225], [4360, 8227], [4372, 8230], [4369, 8229]]], [[[2334, 7016], [2331, 7016], [2331, 7017], [2334, 7016]]], [[[4303, 8146], [4315, 8146], [4329, 8146], [4317, 8140], [4303, 8146]]], [[[4417, 8221], [4412, 8180], [4393, 8164], [4382, 8122], [4353, 8150], [4330, 8146], [4318, 8156], [4355, 8209], [4396, 8234], [4417, 8221]]]]
  }
}, {
  type: "Feature",
  id: "JM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.52,
    "hc-key": "jm",
    "hc-a2": "JM",
    name: "Jamaica",
    labelrank: "4",
    "country-abbrev": "Jam.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "JAM",
    "iso-a2": "JM",
    "woe-id": "23424858",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1906, 7029], [1943, 7013], [1913, 7006], [1878, 7023], [1906, 7029]]]
  }
}, {
  type: "Feature",
  id: "WS",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.54,
    "hc-key": "ws",
    "hc-a2": "WS",
    name: "Samoa",
    labelrank: "4",
    "country-abbrev": "Samoa",
    subregion: "Polynesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "WSM",
    "iso-a2": "WS",
    "woe-id": "23424992",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[-909, 6078], [-907, 6069], [-916, 6069], [-924, 6078], [-909, 6078]]]
  }
}, {
  type: "Feature",
  id: "OM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.88,
    "hc-middle-y": 0.44,
    "hc-key": "om",
    "hc-a2": "OM",
    name: "Oman",
    labelrank: "4",
    "country-abbrev": "Oman",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "OMN",
    "iso-a2": "OM",
    "woe-id": "23424898",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5874, 7239], [5873, 7238], [5873, 7241], [5876, 7241], [5874, 7239]]], [[[5868, 7265], [5877, 7275], [5874, 7251], [5870, 7253], [5868, 7265]]], [[[5747, 7045], [5836, 7076], [5855, 7137], [5842, 7160], [5860, 7228], [5877, 7231], [5900, 7199], [5948, 7186], [5979, 7145], [5916, 7068], [5920, 7047], [5885, 7033], [5876, 7013], [5849, 7010], [5837, 6985], [5780, 6974], [5769, 6994], [5747, 7045]]]]
  }
}, {
  type: "Feature",
  id: "VC",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.5,
    "hc-key": "vc",
    "hc-a2": "VC",
    name: "Saint Vincent and the Grenadines",
    labelrank: "6",
    "country-abbrev": "St.V.G.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "VCT",
    "iso-a2": "VC",
    "woe-id": "23424981",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2388, 6865], [2385, 6871], [2389, 6875], [2390, 6870], [2388, 6865]]]
  }
}, {
  type: "Feature",
  id: "TR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.34,
    "hc-middle-y": 0.49,
    "hc-key": "tr",
    "hc-a2": "TR",
    name: "Turkey",
    labelrank: "2",
    "country-abbrev": "Tur.",
    subregion: "Western Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "TUR",
    "iso-a2": "TR",
    "woe-id": "23424969",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4974, 7732], [4969, 7730], [4966, 7731], [4973, 7735], [4974, 7732]]], [[[5035, 7796], [5068, 7769], [5021, 7761], [5011, 7748], [4977, 7752], [4994, 7775], [4985, 7786], [5007, 7799], [5035, 7796]]], [[[5534, 7714], [5510, 7704], [5516, 7656], [5532, 7628], [5472, 7635], [5461, 7627], [5457, 7634], [5384, 7614], [5338, 7620], [5291, 7617], [5270, 7586], [5272, 7620], [5252, 7608], [5229, 7615], [5177, 7590], [5154, 7607], [5115, 7619], [5106, 7597], [5085, 7593], [5044, 7625], [5011, 7635], [5012, 7657], [4983, 7666], [5007, 7687], [4989, 7700], [4986, 7702], [4979, 7707], [4997, 7740], [5069, 7741], [5071, 7770], [5131, 7764], [5193, 7797], [5271, 7787], [5318, 7762], [5374, 7765], [5395, 7758], [5436, 7779], [5474, 7782], [5493, 7765], [5500, 7730], [5533, 7716], [5534, 7714]]]]
  }
}, {
  type: "Feature",
  id: "BD",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.85,
    "hc-middle-y": 0.61,
    "hc-key": "bd",
    "hc-a2": "BD",
    name: "Bangladesh",
    labelrank: "3",
    "country-abbrev": "Bang.",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "BGD",
    "iso-a2": "BD",
    "woe-id": "23424759",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6942, 7109], [6918, 7163], [6880, 7132], [6847, 7142], [6832, 7189], [6837, 7209], [6816, 7220], [6843, 7237], [6818, 7260], [6829, 7277], [6870, 7262], [6886, 7236], [6935, 7237], [6949, 7229], [6909, 7188], [6922, 7167], [6939, 7192], [6951, 7137], [6953, 7116], [6942, 7109]]]
  }
}, {
  type: "Feature",
  id: "LC",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.47,
    "hc-key": "lc",
    "hc-a2": "LC",
    name: "Saint Lucia",
    labelrank: "6",
    "country-abbrev": "S.L.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "LCA",
    "iso-a2": "LC",
    "woe-id": "23424951",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2395, 6886], [2391, 6890], [2396, 6897], [2397, 6893], [2395, 6886]]]
  }
}, {
  type: "Feature",
  id: "NR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.53,
    "hc-middle-y": 0.5,
    "hc-key": "nr",
    "hc-a2": "NR",
    name: "Nauru",
    labelrank: "6",
    "country-abbrev": "Nauru",
    subregion: "Micronesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "NRU",
    "iso-a2": "NR",
    "woe-id": "23424912",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[9158, 6463], [9157, 6463], [9157, 6464], [9159, 6464], [9158, 6463]]]
  }
}, {
  type: "Feature",
  id: "NO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.1,
    "hc-middle-y": 0.93,
    "hc-key": "no",
    "hc-a2": "NO",
    name: "Norway",
    labelrank: "3",
    "country-abbrev": "Nor.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "NOR",
    "iso-a2": "NO",
    "woe-id": "-90",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4821, 8997], [4815, 8993], [4809, 8996], [4815, 9003], [4821, 8997]]], [[[4797, 8992], [4790, 8995], [4784, 9004], [4802, 8997], [4797, 8992]]], [[[4877, 9011], [4887, 9004], [4870, 9006], [4871, 9011], [4877, 9011]]], [[[4901, 9024], [4906, 9016], [4890, 9006], [4882, 9013], [4901, 9024]]], [[[4911, 9029], [4920, 9024], [4909, 9019], [4905, 9028], [4911, 9029]]], [[[4898, 9036], [4889, 9022], [4861, 9017], [4873, 9029], [4898, 9036]]], [[[4918, 9045], [4919, 9040], [4914, 9042], [4915, 9046], [4918, 9045]]], [[[4966, 9053], [4974, 9045], [4962, 9041], [4955, 9047], [4966, 9053]]], [[[4841, 9496], [4865, 9475], [4829, 9471], [4803, 9490], [4841, 9496]]], [[[4998, 9499], [4989, 9504], [4994, 9510], [5000, 9504], [4998, 9499]]], [[[5066, 9517], [5038, 9511], [5030, 9512], [5047, 9521], [5066, 9517]]], [[[4804, 9531], [4822, 9526], [4810, 9523], [4799, 9526], [4804, 9531]]], [[[4802, 9547], [4789, 9545], [4786, 9549], [4789, 9550], [4802, 9547]]], [[[5202, 9605], [5178, 9599], [5142, 9595], [5139, 9598], [5202, 9605]]], [[[4928, 9617], [4921, 9616], [4921, 9620], [4923, 9621], [4928, 9617]]], [[[4921, 9625], [4925, 9623], [4923, 9622], [4917, 9623], [4921, 9625]]], [[[4797, 9623], [4793, 9624], [4796, 9627], [4801, 9625], [4797, 9623]]], [[[4837, 9638], [4831, 9635], [4828, 9638], [4834, 9639], [4837, 9638]]], [[[4821, 9634], [4821, 9638], [4813, 9643], [4826, 9639], [4821, 9634]]], [[[4748, 8967], [4767, 8968], [4802, 8988], [4813, 8979], [4815, 8980], [4817, 8980], [4818, 8983], [4823, 8988], [4820, 8990], [4826, 8992], [4827, 8992], [4845, 9007], [4847, 9007], [4847, 9006], [4849, 9005], [4850, 9007], [4886, 9002], [4934, 9033], [4973, 9037], [4948, 9018], [4950, 8995], [4996, 9042], [4991, 9010], [5022, 9050], [5094, 9029], [5126, 9006], [5099, 8995], [5057, 9000], [5119, 8981], [5093, 8957], [5063, 8940], [5075, 8962], [5032, 8995], [4976, 8974], [4965, 8932], [4942, 8915], [4914, 8929], [4869, 8923], [4847, 8952], [4816, 8940], [4797, 8905], [4743, 8914], [4735, 8885], [4718, 8892], [4683, 8857], [4691, 8839], [4635, 8792], [4635, 8753], [4609, 8718], [4618, 8690], [4580, 8688], [4560, 8656], [4569, 8610], [4565, 8584], [4586, 8568], [4568, 8551], [4575, 8512], [4556, 8501], [4543, 8462], [4515, 8473], [4456, 8430], [4429, 8420], [4398, 8424], [4359, 8468], [4372, 8509], [4342, 8554], [4363, 8576], [4347, 8589], [4369, 8612], [4411, 8630], [4409, 8639], [4464, 8659], [4435, 8662], [4465, 8681], [4504, 8658], [4544, 8680], [4498, 8667], [4487, 8679], [4537, 8729], [4562, 8742], [4566, 8761], [4607, 8833], [4667, 8874], [4643, 8878], [4692, 8898], [4682, 8907], [4716, 8924], [4703, 8941], [4719, 8966], [4748, 8967], [4769, 8982], [4768, 8999], [4781, 8983], [4748, 8967]], [[5095, 8982], [5091, 8986], [5086, 8978], [5097, 8981], [5095, 8982]]], [[[4948, 9363], [4949, 9366], [4963, 9376], [4948, 9363], [4948, 9363], [4948, 9363]]], [[[4630, 8922], [4662, 8932], [4682, 8955], [4696, 8923], [4668, 8902], [4602, 8890], [4605, 8899], [4657, 8910], [4630, 8922]]], [[[4893, 9411], [4874, 9424], [4825, 9422], [4847, 9452], [4824, 9463], [4886, 9474], [4905, 9449], [4929, 9446], [4893, 9411]]], [[[4669, 9570], [4695, 9593], [4764, 9552], [4766, 9533], [4843, 9513], [4768, 9488], [4744, 9425], [4730, 9424], [4703, 9367], [4631, 9407], [4617, 9428], [4702, 9450], [4611, 9443], [4607, 9461], [4650, 9465], [4673, 9480], [4644, 9505], [4641, 9483], [4590, 9471], [4561, 9497], [4565, 9471], [4533, 9487], [4515, 9516], [4540, 9521], [4522, 9560], [4531, 9569], [4564, 9568], [4613, 9582], [4616, 9559], [4636, 9577], [4658, 9563], [4689, 9517], [4669, 9570]]], [[[4909, 9611], [5000, 9602], [5010, 9580], [4975, 9557], [4918, 9535], [4884, 9538], [4883, 9551], [4822, 9548], [4787, 9564], [4852, 9570], [4854, 9578], [4761, 9571], [4763, 9592], [4732, 9599], [4742, 9610], [4778, 9596], [4809, 9619], [4824, 9604], [4852, 9608], [4868, 9590], [4879, 9624], [4887, 9601], [4909, 9611]]], [[[4948, 9363], [4946, 9359], [4947, 9363], [4948, 9363], [4948, 9363], [4948, 9363]]]]
  }
}, {
  type: "Feature",
  id: "KN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.57,
    "hc-middle-y": 0.49,
    "hc-key": "kn",
    "hc-a2": "KN",
    name: "Saint Kitts and Nevis",
    labelrank: "6",
    "country-abbrev": "St.K.N.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "KNA",
    "iso-a2": "KN",
    "woe-id": "23424940",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2346, 6991], [2339, 6996], [2340, 6997], [2343, 6995], [2346, 6991]]]
  }
}, {
  type: "Feature",
  id: "BH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.5,
    "hc-key": "bh",
    "hc-a2": "BH",
    name: "Bahrain",
    labelrank: "4",
    "country-abbrev": "Bahr.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "BHR",
    "iso-a2": "BH",
    "woe-id": "23424753",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5702, 7271], [5706, 7269], [5705, 7256], [5701, 7263], [5702, 7271]]]
  }
}, {
  type: "Feature",
  id: "TO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.54,
    "hc-middle-y": 0.34,
    "hc-key": "to",
    "hc-a2": "TO",
    name: "Tonga",
    labelrank: "4",
    "country-abbrev": "Tongo",
    subregion: "Polynesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "TON",
    "iso-a2": "TO",
    "woe-id": "23424964",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[-987, 5842], [-988, 5840], [-999, 5845], [-992, 5847], [-987, 5842]]]
  }
}, {
  type: "Feature",
  id: "FI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.63,
    "hc-middle-y": 0.54,
    "hc-key": "fi",
    "hc-a2": "FI",
    name: "Finland",
    labelrank: "3",
    "country-abbrev": "Fin.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "FIN",
    "iso-a2": "FI",
    "woe-id": "23424812",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4816, 8512], [4815, 8507], [4806, 8505], [4810, 8509], [4816, 8512]]], [[[4803, 8510], [4806, 8512], [4803, 8505], [4798, 8508], [4803, 8510]]], [[[4808, 8518], [4799, 8510], [4785, 8518], [4800, 8522], [4808, 8518]]], [[[4844, 8516], [4844, 8514], [4855, 8514], [4842, 8511], [4844, 8516]]], [[[4870, 8506], [4870, 8515], [4882, 8511], [4872, 8501], [4870, 8506]]], [[[4836, 8532], [4837, 8528], [4836, 8523], [4835, 8528], [4836, 8532]]], [[[4835, 8657], [4838, 8652], [4834, 8650], [4830, 8654], [4835, 8657]]], [[[4942, 8741], [4935, 8736], [4933, 8739], [4936, 8741], [4942, 8741]]], [[[4851, 8526], [4845, 8528], [4834, 8596], [4842, 8652], [4868, 8658], [4939, 8731], [4954, 8729], [4955, 8762], [4921, 8778], [4906, 8808], [4916, 8826], [4899, 8860], [4906, 8885], [4816, 8940], [4847, 8952], [4869, 8923], [4914, 8929], [4942, 8915], [4965, 8932], [4976, 8974], [5032, 8995], [5075, 8962], [5063, 8940], [5048, 8914], [5055, 8897], [5095, 8871], [5067, 8828], [5091, 8792], [5082, 8737], [5111, 8691], [5094, 8678], [5141, 8638], [5131, 8620], [5071, 8562], [5029, 8531], [4909, 8505], [4869, 8520], [4871, 8521], [4866, 8521], [4866, 8521], [4854, 8525], [4857, 8523], [4856, 8520], [4851, 8524], [4851, 8526]]]]
  }
}, {
  type: "Feature",
  id: "ID",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.38,
    "hc-middle-y": 0.41,
    "hc-key": "id",
    "hc-a2": "ID",
    name: "Indonesia",
    labelrank: "2",
    "country-abbrev": "Indo.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "IDN",
    "iso-a2": "ID",
    "woe-id": "23424846",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[8188, 6311], [8203, 6311], [8186, 6274], [8184, 6299], [8156, 6320], [8188, 6311]]], [[[7394, 6396], [7365, 6387], [7343, 6415], [7351, 6432], [7368, 6393], [7394, 6396]]], [[[7693, 6231], [7736, 6235], [7737, 6224], [7676, 6209], [7642, 6218], [7658, 6236], [7693, 6231]]], [[[8007, 6546], [8003, 6517], [8028, 6486], [8001, 6493], [7995, 6439], [7976, 6470], [7993, 6473], [7985, 6514], [8007, 6546]]], [[[7885, 6203], [7891, 6198], [7897, 6207], [7902, 6208], [7911, 6214], [7912, 6206], [7915, 6198], [7897, 6179], [7868, 6172], [7885, 6203]]], [[[7703, 6601], [7696, 6596], [7697, 6601], [7703, 6601]]], [[[8388, 6402], [8388, 6275], [8388, 6210], [8360, 6240], [8289, 6230], [8299, 6253], [8325, 6262], [8294, 6324], [8238, 6346], [8216, 6347], [8170, 6376], [8148, 6358], [8127, 6400], [8181, 6408], [8142, 6411], [8087, 6439], [8070, 6476], [8099, 6455], [8142, 6468], [8180, 6457], [8185, 6415], [8210, 6380], [8248, 6403], [8246, 6430], [8295, 6435], [8355, 6409], [8388, 6402]]], [[[7779, 6174], [7734, 6196], [7755, 6202], [7771, 6234], [7833, 6224], [7852, 6236], [7936, 6242], [7886, 6226], [7878, 6234], [7818, 6216], [7763, 6218], [7789, 6183], [7779, 6174]]], [[[7419, 6248], [7365, 6260], [7335, 6278], [7351, 6305], [7419, 6294], [7427, 6279], [7483, 6274], [7496, 6290], [7530, 6275], [7624, 6277], [7624, 6218], [7565, 6234], [7548, 6229], [7490, 6237], [7450, 6251], [7419, 6248]]], [[[8007, 6388], [7965, 6365], [7943, 6380], [7942, 6408], [7946, 6387], [7976, 6380], [8002, 6393], [8048, 6397], [8079, 6386], [8086, 6365], [8007, 6388]]], [[[7849, 6311], [7824, 6317], [7851, 6347], [7809, 6341], [7813, 6358], [7778, 6383], [7775, 6316], [7746, 6321], [7754, 6351], [7730, 6401], [7746, 6421], [7766, 6500], [7792, 6519], [7814, 6510], [7882, 6503], [7917, 6531], [7898, 6492], [7774, 6491], [7765, 6473], [7785, 6438], [7815, 6465], [7866, 6460], [7862, 6427], [7846, 6446], [7811, 6422], [7839, 6386], [7855, 6349], [7849, 6311]]], [[[7693, 6601], [7687, 6576], [7709, 6546], [7702, 6535], [7736, 6509], [7698, 6501], [7689, 6463], [7663, 6436], [7664, 6414], [7646, 6373], [7606, 6356], [7594, 6380], [7558, 6385], [7522, 6375], [7519, 6397], [7476, 6390], [7466, 6446], [7452, 6441], [7434, 6503], [7458, 6540], [7485, 6504], [7557, 6525], [7602, 6521], [7631, 6568], [7642, 6608], [7693, 6601]]], [[[7120, 6602], [7164, 6572], [7200, 6534], [7221, 6541], [7283, 6486], [7272, 6457], [7301, 6448], [7311, 6409], [7338, 6408], [7352, 6382], [7345, 6312], [7312, 6304], [7219, 6384], [7196, 6415], [7181, 6455], [7152, 6486], [7124, 6478], [7149, 6426], [7139, 6429], [7121, 6478], [7145, 6496], [7128, 6536], [7092, 6539], [7110, 6508], [7103, 6496], [7087, 6540], [7065, 6548], [7092, 6543], [7100, 6563], [7036, 6621], [7032, 6650], [7065, 6633], [7097, 6634], [7120, 6602]]]]
  }
}, {
  type: "Feature",
  id: "MU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.63,
    "hc-middle-y": 0.58,
    "hc-key": "mu",
    "hc-a2": "MU",
    name: "Mauritius",
    labelrank: "5",
    "country-abbrev": "Mus.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "MUS",
    "iso-a2": "MU",
    "woe-id": "23424894",
    continent: "Seven seas (open ocean)"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5917, 5878], [5916, 5867], [5907, 5866], [5911, 5880], [5917, 5878]]]
  }
}, {
  type: "Feature",
  id: "SE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.4,
    "hc-middle-y": 0.48,
    "hc-key": "se",
    "hc-a2": "SE",
    name: "Sweden",
    labelrank: "3",
    "country-abbrev": "Swe.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "SWE",
    "iso-a2": "SE",
    "woe-id": "23424954",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4749, 8461], [4749, 8461], [4749, 8466], [4753, 8466], [4749, 8461]]], [[[4864, 8758], [4864, 8764], [4868, 8762], [4868, 8758], [4864, 8758]]], [[[4921, 8778], [4853, 8764], [4831, 8722], [4845, 8711], [4821, 8684], [4769, 8651], [4733, 8619], [4712, 8569], [4718, 8540], [4736, 8533], [4770, 8495], [4751, 8469], [4701, 8445], [4691, 8414], [4700, 8372], [4711, 8391], [4741, 8387], [4760, 8415], [4759, 8386], [4710, 8386], [4693, 8344], [4640, 8340], [4625, 8309], [4589, 8309], [4571, 8373], [4546, 8417], [4550, 8417], [4552, 8421], [4545, 8421], [4546, 8418], [4537, 8434], [4543, 8462], [4556, 8501], [4575, 8512], [4568, 8551], [4586, 8568], [4565, 8584], [4569, 8610], [4560, 8656], [4580, 8688], [4618, 8690], [4609, 8718], [4635, 8753], [4635, 8792], [4691, 8839], [4683, 8857], [4718, 8892], [4735, 8885], [4743, 8914], [4797, 8905], [4816, 8940], [4906, 8885], [4899, 8860], [4916, 8826], [4906, 8808], [4921, 8778]], [[4554, 8430], [4543, 8426], [4546, 8423], [4554, 8424], [4554, 8430]]]]
  }
}, {
  type: "Feature",
  id: "TT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.46,
    "hc-middle-y": 0.44,
    "hc-key": "tt",
    "hc-a2": "TT",
    name: "Trinidad and Tobago",
    labelrank: "5",
    "country-abbrev": "Tr.T.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "TTO",
    "iso-a2": "TT",
    "woe-id": "23424958",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2396, 6799], [2394, 6779], [2380, 6783], [2374, 6796], [2396, 6799]]]
  }
}, {
  type: "Feature",
  id: "MY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.9,
    "hc-middle-y": 0.26,
    "hc-key": "my",
    "hc-a2": "MY",
    name: "Malaysia",
    labelrank: "3",
    "country-abbrev": "Malay.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "MYS",
    "iso-a2": "MY",
    "woe-id": "23424901",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[7181, 6640], [7180, 6634], [7177, 6634], [7177, 6640], [7181, 6640]]], [[[7703, 6601], [7697, 6601], [7698, 6602], [7693, 6601], [7642, 6608], [7631, 6568], [7602, 6521], [7557, 6525], [7485, 6504], [7458, 6540], [7498, 6525], [7508, 6550], [7510, 6549], [7510, 6554], [7511, 6558], [7558, 6572], [7587, 6614], [7606, 6597], [7616, 6623], [7617, 6624], [7618, 6621], [7627, 6606], [7621, 6623], [7650, 6660], [7685, 6675], [7743, 6632], [7710, 6623], [7722, 6607], [7701, 6603], [7703, 6601]]], [[[7175, 6669], [7204, 6663], [7205, 6645], [7233, 6663], [7274, 6620], [7274, 6565], [7299, 6519], [7272, 6524], [7210, 6563], [7193, 6593], [7175, 6669]]]]
  }
}, {
  type: "Feature",
  id: "PA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.22,
    "hc-middle-y": 0.5,
    "hc-key": "pa",
    "hc-a2": "PA",
    name: "Panama",
    labelrank: "4",
    "country-abbrev": "Pan.",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "PAN",
    "iso-a2": "PA",
    "woe-id": "23424924",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1892, 6692], [1873, 6732], [1843, 6744], [1816, 6717], [1829, 6699], [1776, 6692], [1778, 6721], [1744, 6716], [1739, 6725], [1740, 6725], [1740, 6725], [1740, 6726], [1740, 6726], [1754, 6762], [1768, 6743], [1798, 6739], [1841, 6763], [1876, 6757], [1908, 6735], [1914, 6713], [1892, 6692]]]
  }
}, {
  type: "Feature",
  id: "PW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.38,
    "hc-middle-y": 0.44,
    "hc-key": "pw",
    "hc-a2": "PW",
    name: "Palau",
    labelrank: "6",
    "country-abbrev": "Palau",
    subregion: "Micronesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "PLW",
    "iso-a2": "PW",
    "woe-id": "23424927",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[8196, 6695], [8195, 6699], [8197, 6703], [8200, 6703], [8196, 6695]]]
  }
}, {
  type: "Feature",
  id: "TV",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.25,
    "hc-middle-y": 0.5,
    "hc-key": "tv",
    "hc-a2": "TV",
    name: "Tuvalu",
    labelrank: "6",
    "country-abbrev": "Tuv.",
    subregion: "Polynesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "TUV",
    "iso-a2": "TV",
    "woe-id": "23424970",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[9522, 6227], [9522, 6227], [9522, 6229], [9522, 6227], [9522, 6227]]]
  }
}, {
  type: "Feature",
  id: "MH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.6,
    "hc-key": "mh",
    "hc-a2": "MH",
    name: "Marshall Islands",
    labelrank: "6",
    "country-abbrev": "M. Is.",
    subregion: "Micronesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "MHL",
    "iso-a2": "MH",
    "woe-id": "23424932",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[9280, 6690], [9285, 6688], [9286, 6687], [9285, 6688], [9280, 6690]]]
  }
}, {
  type: "Feature",
  id: "CL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.51,
    "hc-middle-y": 0.9,
    "hc-key": "cl",
    "hc-a2": "CL",
    name: "Chile",
    labelrank: "2",
    "country-abbrev": "Chile",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "CHL",
    "iso-a2": "CL",
    "woe-id": "23424782",
    continent: "South America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[2028, 4732], [2063, 4714], [2042, 4700], [2014, 4729], [2028, 4732]]], [[[1977, 4948], [1993, 4916], [1994, 4867], [1960, 4879], [1981, 4893], [1959, 4908], [1961, 4938], [1977, 4948]]], [[[2022, 5147], [2016, 5111], [1985, 5101], [2001, 5124], [2006, 5163], [2022, 5147]]], [[[2167, 4761], [2167, 4674], [2165, 4674], [2167, 4673], [2167, 4670], [2128, 4674], [2110, 4657], [2088, 4695], [2113, 4723], [2117, 4693], [2157, 4688], [2125, 4702], [2114, 4746], [2144, 4768], [2167, 4761]]], [[[2115, 5932], [2128, 5935], [2141, 5957], [2157, 5913], [2173, 5898], [2163, 5868], [2180, 5842], [2189, 5794], [2210, 5794], [2206, 5757], [2169, 5733], [2177, 5666], [2162, 5659], [2137, 5618], [2109, 5516], [2133, 5456], [2115, 5397], [2115, 5366], [2096, 5352], [2091, 5311], [2101, 5277], [2085, 5269], [2069, 5206], [2075, 5158], [2063, 5125], [2077, 5092], [2066, 5062], [2088, 5042], [2070, 4970], [2051, 4944], [2059, 4928], [2020, 4882], [2032, 4835], [2058, 4839], [2054, 4804], [2070, 4787], [2128, 4786], [2173, 4772], [2152, 4778], [2105, 4757], [2096, 4714], [2032, 4737], [2038, 4753], [2004, 4758], [1996, 4781], [2017, 4777], [2012, 4815], [1976, 4834], [2000, 4847], [1996, 4918], [1986, 4952], [2000, 4987], [1966, 4992], [1995, 5037], [2008, 5015], [2031, 5042], [2026, 5058], [1996, 5060], [2012, 5097], [2020, 5062], [2053, 5159], [2039, 5179], [2015, 5170], [2010, 5197], [2030, 5249], [2018, 5310], [2031, 5329], [2048, 5383], [2060, 5398], [2085, 5489], [2078, 5559], [2088, 5569], [2081, 5601], [2100, 5643], [2113, 5714], [2109, 5785], [2125, 5837], [2115, 5932]]], [[[2209, 4666], [2230, 4654], [2168, 4659], [2214, 4627], [2192, 4628], [2162, 4657], [2133, 4648], [2129, 4663], [2202, 4668], [2207, 4668], [2209, 4666]]]]
  }
}, {
  type: "Feature",
  id: "TH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.25,
    "hc-middle-y": 0.49,
    "hc-key": "th",
    "hc-a2": "TH",
    name: "Thailand",
    labelrank: "3",
    "country-abbrev": "Thai.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "THA",
    "iso-a2": "TH",
    "woe-id": "23424960",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[7239, 6839], [7241, 6837], [7244, 6834], [7240, 6833], [7239, 6839]]], [[[7233, 6663], [7205, 6645], [7204, 6663], [7175, 6669], [7151, 6704], [7118, 6732], [7134, 6785], [7161, 6829], [7146, 6886], [7119, 6918], [7137, 6959], [7095, 7030], [7113, 7070], [7128, 7066], [7175, 7086], [7186, 7062], [7209, 7061], [7205, 6999], [7233, 7022], [7249, 7010], [7272, 7029], [7290, 7025], [7315, 6996], [7313, 6970], [7338, 6946], [7325, 6904], [7280, 6907], [7241, 6881], [7258, 6824], [7226, 6854], [7201, 6852], [7200, 6878], [7173, 6876], [7172, 6840], [7151, 6793], [7149, 6752], [7167, 6753], [7185, 6690], [7218, 6681], [7233, 6663]]]]
  }
}, {
  type: "Feature",
  id: "GD",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.5,
    "hc-key": "gd",
    "hc-a2": "GD",
    name: "Grenada",
    labelrank: "6",
    "country-abbrev": "Gren.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "GRD",
    "iso-a2": "GD",
    "woe-id": "23424826",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2375, 6835], [2372, 6835], [2372, 6839], [2376, 6841], [2375, 6835]]]
  }
}, {
  type: "Feature",
  id: "EE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.35,
    "hc-middle-y": 0.41,
    "hc-key": "ee",
    "hc-a2": "EE",
    name: "Estonia",
    labelrank: "6",
    "country-abbrev": "Est.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "EST",
    "iso-a2": "EE",
    "woe-id": "23424805",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4876, 8444], [4887, 8435], [4863, 8425], [4852, 8441], [4876, 8444]]], [[[4897, 8446], [4893, 8442], [4888, 8445], [4892, 8448], [4897, 8446]]], [[[4893, 8464], [4897, 8464], [4898, 8461], [4891, 8461], [4893, 8464]]], [[[4878, 8463], [4888, 8455], [4872, 8449], [4858, 8459], [4878, 8463]]], [[[5026, 8462], [5004, 8453], [5024, 8419], [5021, 8411], [5016, 8399], [4990, 8398], [4954, 8422], [4925, 8413], [4902, 8443], [4901, 8472], [4975, 8490], [5035, 8483], [5038, 8482], [5040, 8478], [5038, 8477], [5035, 8477], [5035, 8477], [5037, 8476], [5037, 8476], [5038, 8476], [5037, 8476], [5034, 8476], [5030, 8469], [5026, 8462]]]]
  }
}, {
  type: "Feature",
  id: "AG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.48,
    "hc-key": "ag",
    "hc-a2": "AG",
    name: "Antigua and Barbuda",
    labelrank: "6",
    "country-abbrev": "Ant.B.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "ATG",
    "iso-a2": "AG",
    "woe-id": "23424737",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2371, 6989], [2373, 6986], [2369, 6985], [2367, 6988], [2371, 6989]]]
  }
}, {
  type: "Feature",
  id: "TW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.41,
    "hc-key": "tw",
    "hc-a2": "TW",
    name: "Taiwan",
    labelrank: "3",
    "country-abbrev": "Taiwan",
    subregion: "Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "TWN",
    "iso-a2": "TW",
    "woe-id": "23424971",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7752, 7185], [7768, 7185], [7797, 7233], [7821, 7235], [7807, 7173], [7790, 7136], [7752, 7185]]]
  }
}, {
  type: "Feature",
  id: "BB",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.31,
    "hc-middle-y": 0.56,
    "hc-key": "bb",
    "hc-a2": "BB",
    name: "Barbados",
    labelrank: "5",
    "country-abbrev": "Barb.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "BRB",
    "iso-a2": "BB",
    "woe-id": "23424754",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2438, 6866], [2434, 6868], [2435, 6874], [2440, 6869], [2438, 6866]]]
  }
}, {
  type: "Feature",
  id: "IT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.79,
    "hc-middle-y": 0.71,
    "hc-key": "it",
    "hc-a2": "IT",
    name: "Italy",
    labelrank: "2",
    "country-abbrev": "Italy",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "ITA",
    "iso-a2": "IT",
    "woe-id": "23424853",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4571, 7654], [4668, 7666], [4655, 7649], [4652, 7611], [4634, 7616], [4571, 7654]]], [[[4484, 7768], [4496, 7744], [4488, 7697], [4454, 7690], [4456, 7736], [4448, 7757], [4484, 7768]]], [[[4427, 7861], [4400, 7909], [4412, 7939], [4444, 7951], [4466, 7944], [4500, 7955], [4514, 7974], [4566, 7982], [4572, 7967], [4611, 7961], [4601, 7952], [4611, 7927], [4596, 7933], [4565, 7916], [4572, 7876], [4608, 7851], [4622, 7818], [4654, 7794], [4680, 7795], [4677, 7778], [4738, 7749], [4753, 7731], [4710, 7744], [4694, 7715], [4713, 7705], [4681, 7655], [4685, 7684], [4668, 7729], [4611, 7770], [4591, 7769], [4536, 7815], [4504, 7869], [4464, 7884], [4427, 7861]], [[4574, 7793], [4574, 7793], [4574, 7793], [4574, 7793], [4574, 7793]], [[4574, 7865], [4574, 7868], [4573, 7867], [4572, 7866], [4574, 7865]]]]
  }
}, {
  type: "Feature",
  id: "MT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.53,
    "hc-key": "mt",
    "hc-a2": "MT",
    name: "Malta",
    labelrank: "5",
    "country-abbrev": "Malta",
    subregion: "Southern Europe",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "MLT",
    "iso-a2": "MT",
    "woe-id": "23424897",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4628, 7589], [4635, 7586], [4635, 7582], [4631, 7584], [4628, 7589]]]
  }
}, {
  type: "Feature",
  id: "VU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.6,
    "hc-middle-y": 0.53,
    "hc-key": "vu",
    "hc-a2": "VU",
    name: "Vanuatu",
    labelrank: "4",
    "country-abbrev": "Van.",
    subregion: "Melanesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "VUT",
    "iso-a2": "VU",
    "woe-id": "23424907",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[9172, 6054], [9194, 6034], [9205, 5976], [9178, 5988], [9154, 6029], [9172, 6054]]]
  }
}, {
  type: "Feature",
  id: "SG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.57,
    "hc-key": "sg",
    "hc-a2": "SG",
    name: "Singapore",
    labelrank: "6",
    "country-abbrev": "Sing.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "SGP",
    "iso-a2": "SG",
    "woe-id": "23424948",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7286, 6521], [7290, 6519], [7286, 6516], [7280, 6517], [7286, 6521]]]
  }
}, {
  type: "Feature",
  id: "CY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.39,
    "hc-middle-y": 0.51,
    "hc-key": "cy",
    "hc-a2": "CY",
    name: "Cyprus",
    labelrank: "5",
    "country-abbrev": "Cyp.",
    subregion: "Western Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "CYP",
    "iso-a2": "CY",
    "woe-id": "-90",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5205, 7555], [5205, 7556], [5206, 7556], [5205, 7555]]], [[[5214, 7557], [5216, 7554], [5210, 7554], [5207, 7557], [5210, 7557], [5213, 7557], [5214, 7557]]], [[[5206, 7555], [5206, 7555], [5207, 7555], [5207, 7554], [5206, 7555]]], [[[5204, 7554], [5201, 7549], [5184, 7543], [5178, 7545], [5176, 7544], [5162, 7557], [5171, 7561], [5172, 7560], [5173, 7562], [5174, 7561], [5175, 7561], [5175, 7561], [5175, 7561], [5175, 7561], [5175, 7561], [5196, 7561], [5204, 7555], [5204, 7554]]]]
  }
}, {
  type: "Feature",
  id: "LK",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.62,
    "hc-middle-y": 0.91,
    "hc-key": "lk",
    "hc-a2": "LK",
    name: "Sri Lanka",
    labelrank: "3",
    "country-abbrev": "Sri L.",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "LKA",
    "iso-a2": "LK",
    "woe-id": "23424778",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6576, 6765], [6600, 6755], [6632, 6703], [6631, 6674], [6596, 6654], [6581, 6660], [6572, 6717], [6584, 6759], [6576, 6765]]]
  }
}, {
  type: "Feature",
  id: "KM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.41,
    "hc-middle-y": 0.51,
    "hc-key": "km",
    "hc-a2": "KM",
    name: "Comoros",
    labelrank: "6",
    "country-abbrev": "Com.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "COM",
    "iso-a2": "KM",
    "woe-id": "23424786",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5494, 6125], [5487, 6131], [5488, 6142], [5492, 6141], [5494, 6125]]]
  }
}, {
  type: "Feature",
  id: "FJ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.44,
    "hc-middle-y": 0.33,
    "hc-key": "fj",
    "hc-a2": "FJ",
    name: "Fiji",
    labelrank: "6",
    "country-abbrev": "Fiji",
    subregion: "Melanesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "FJI",
    "iso-a2": "FJ",
    "woe-id": "23424813",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[9460, 5963], [9494, 5962], [9495, 5978], [9543, 5996], [9494, 5959], [9507, 5951], [9500, 5915], [9490, 5934], [9467, 5939], [9460, 5963]]]
  }
}, {
  type: "Feature",
  id: "RU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.57,
    "hc-middle-y": 0.56,
    "hc-key": "ru",
    "hc-a2": "RU",
    name: "Russia",
    labelrank: "2",
    "country-abbrev": "Rus.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "RUS",
    "iso-a2": "RU",
    "woe-id": "23424936",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[8620, 7917], [8587, 7905], [8565, 7884], [8519, 7862], [8540, 7887], [8614, 7923], [8620, 7917]]], [[[5691, 8936], [5646, 8924], [5637, 8953], [5666, 8965], [5693, 8952], [5691, 8936]]], [[[5965, 9010], [5999, 8987], [5972, 8976], [5942, 8995], [5965, 9010]]], [[[6315, 9176], [6331, 9169], [6278, 9157], [6280, 9178], [6315, 9176]]], [[[7568, 9234], [7551, 9218], [7512, 9233], [7528, 9245], [7568, 9234]]], [[[5900, 9603], [5857, 9597], [5866, 9613], [5939, 9622], [5950, 9582], [5900, 9603]]], [[[5825, 9623], [5819, 9605], [5766, 9602], [5774, 9618], [5819, 9609], [5825, 9623]]], [[[5870, 9665], [5945, 9662], [5893, 9635], [5861, 9633], [5807, 9645], [5870, 9665]]], [[[6124, 9673], [6147, 9654], [6077, 9637], [6060, 9648], [6104, 9658], [6124, 9673]]], [[[5922, 9709], [5937, 9692], [5916, 9668], [5861, 9672], [5922, 9709]]], [[[5391, 7846], [5361, 7874], [5289, 7912], [5317, 7918], [5327, 7959], [5370, 7979], [5338, 7983], [5356, 8011], [5384, 8010], [5382, 8045], [5395, 8064], [5367, 8087], [5315, 8109], [5262, 8106], [5245, 8140], [5218, 8142], [5225, 8161], [5207, 8185], [5147, 8175], [5131, 8212], [5175, 8229], [5146, 8243], [5121, 8317], [5039, 8340], [5024, 8370], [5016, 8399], [5021, 8411], [5024, 8419], [5030, 8439], [5026, 8462], [5030, 8469], [5033, 8474], [5037, 8476], [5037, 8476], [5035, 8477], [5035, 8477], [5035, 8477], [5037, 8476], [5040, 8478], [5038, 8482], [5035, 8483], [5037, 8497], [5090, 8514], [5029, 8531], [5071, 8562], [5131, 8620], [5141, 8638], [5094, 8678], [5111, 8691], [5082, 8737], [5091, 8792], [5067, 8828], [5095, 8871], [5055, 8897], [5048, 8914], [5063, 8940], [5093, 8957], [5119, 8981], [5155, 8989], [5187, 8976], [5154, 8968], [5271, 8947], [5422, 8870], [5431, 8846], [5404, 8806], [5372, 8793], [5330, 8791], [5199, 8822], [5161, 8842], [5242, 8773], [5227, 8755], [5241, 8731], [5264, 8746], [5302, 8746], [5378, 8716], [5404, 8728], [5386, 8767], [5431, 8789], [5468, 8824], [5515, 8780], [5524, 8820], [5504, 8845], [5517, 8900], [5490, 8918], [5567, 8909], [5591, 8879], [5550, 8873], [5538, 8852], [5564, 8831], [5620, 8836], [5629, 8869], [5652, 8873], [5723, 8912], [5790, 8934], [5806, 8904], [5827, 8896], [5866, 8921], [5905, 8916], [5951, 8938], [5975, 8904], [6011, 8945], [5989, 8968], [6007, 8983], [6107, 8967], [6153, 8943], [6199, 8929], [6230, 8904], [6255, 8935], [6236, 8937], [6223, 8964], [6186, 8969], [6202, 9029], [6176, 9027], [6190, 9061], [6236, 9090], [6251, 9138], [6269, 9149], [6328, 9151], [6366, 9139], [6367, 9115], [6336, 9074], [6361, 9051], [6354, 9006], [6358, 8935], [6389, 8913], [6375, 8873], [6358, 8867], [6328, 8819], [6292, 8803], [6343, 8798], [6385, 8827], [6422, 8871], [6414, 8922], [6471, 8938], [6499, 8913], [6493, 8875], [6522, 8899], [6509, 8932], [6445, 8952], [6393, 8949], [6386, 8977], [6409, 9019], [6371, 9068], [6386, 9090], [6428, 9105], [6421, 9150], [6448, 9187], [6481, 9183], [6445, 9141], [6451, 9113], [6436, 9067], [6512, 9052], [6527, 9059], [6469, 9075], [6459, 9094], [6487, 9102], [6506, 9090], [6515, 9116], [6553, 9161], [6560, 9121], [6630, 9083], [6675, 9084], [6646, 9060], [6663, 9044], [6673, 9007], [6690, 9016], [6671, 9058], [6685, 9079], [6643, 9115], [6599, 9130], [6588, 9167], [6594, 9189], [6788, 9206], [6780, 9224], [6737, 9257], [6785, 9249], [6777, 9269], [6809, 9274], [6873, 9307], [6980, 9323], [6962, 9336], [7011, 9336], [7047, 9351], [7033, 9373], [7059, 9393], [7066, 9353], [7049, 9341], [7067, 9325], [7108, 9332], [7138, 9364], [7197, 9366], [7207, 9400], [7268, 9436], [7313, 9439], [7346, 9430], [7326, 9407], [7393, 9388], [7362, 9364], [7404, 9365], [7407, 9378], [7502, 9378], [7543, 9370], [7546, 9346], [7568, 9345], [7578, 9308], [7544, 9323], [7575, 9289], [7467, 9233], [7411, 9192], [7384, 9191], [7360, 9167], [7401, 9165], [7495, 9195], [7457, 9196], [7469, 9214], [7539, 9196], [7561, 9206], [7571, 9185], [7629, 9196], [7719, 9189], [7716, 9172], [7772, 9155], [7853, 9150], [7870, 9168], [7862, 9188], [7901, 9208], [7905, 9196], [7955, 9179], [7974, 9187], [8045, 9157], [8030, 9104], [7998, 9123], [8055, 9053], [8088, 9032], [8108, 9038], [8137, 9093], [8170, 9068], [8195, 9065], [8239, 9079], [8270, 9074], [8322, 9080], [8360, 9070], [8335, 9109], [8345, 9127], [8405, 9143], [8519, 9131], [8564, 9117], [8534, 9111], [8541, 9090], [8572, 9118], [8644, 9108], [8657, 9095], [8626, 9083], [8700, 9063], [8721, 9038], [8764, 9037], [8832, 9050], [8908, 9043], [8943, 9027], [8955, 9004], [8943, 8985], [8984, 8961], [9072, 8979], [9096, 8968], [9158, 8964], [9197, 8992], [9232, 8984], [9225, 8968], [9192, 8975], [9201, 8950], [9238, 8927], [9278, 8941], [9267, 8997], [9413, 8983], [9467, 8971], [9580, 8925], [9584, 8914], [9685, 8870], [9711, 8813], [9723, 8834], [9791, 8834], [9851, 8793], [9826, 8768], [9778, 8763], [9764, 8722], [9776, 8709], [9742, 8703], [9702, 8728], [9668, 8738], [9667, 8757], [9635, 8767], [9589, 8762], [9555, 8796], [9567, 8768], [9556, 8744], [9493, 8721], [9439, 8731], [9486, 8700], [9495, 8707], [9534, 8629], [9519, 8610], [9488, 8621], [9448, 8619], [9352, 8576], [9308, 8545], [9266, 8526], [9261, 8505], [9227, 8532], [9158, 8520], [9133, 8499], [9142, 8528], [9095, 8497], [9060, 8508], [9046, 8484], [9064, 8458], [9090, 8456], [9056, 8438], [9043, 8461], [9011, 8423], [9051, 8406], [9035, 8366], [9052, 8342], [9016, 8339], [9005, 8318], [9016, 8287], [8954, 8259], [8941, 8221], [8912, 8207], [8886, 8153], [8827, 8100], [8811, 8101], [8856, 8131], [8837, 8208], [8820, 8304], [8835, 8366], [8877, 8410], [8923, 8437], [8948, 8468], [9008, 8515], [9010, 8525], [9072, 8567], [9075, 8609], [9107, 8615], [9089, 8628], [9049, 8621], [9040, 8587], [8957, 8532], [8946, 8548], [8962, 8594], [8877, 8587], [8802, 8523], [8776, 8485], [8810, 8470], [8755, 8473], [8696, 8456], [8678, 8483], [8643, 8496], [8619, 8473], [8474, 8481], [8435, 8472], [8385, 8435], [8373, 8412], [8319, 8375], [8287, 8339], [8217, 8288], [8256, 8276], [8261, 8291], [8303, 8293], [8279, 8254], [8297, 8235], [8321, 8264], [8353, 8263], [8401, 8217], [8372, 8113], [8375, 8076], [8364, 8034], [8337, 8008], [8302, 7950], [8237, 7883], [8214, 7850], [8156, 7821], [8116, 7844], [8083, 7807], [8081, 7811], [8078, 7815], [8091, 7827], [8099, 7870], [8090, 7899], [8121, 7913], [8132, 7887], [8146, 7907], [8178, 7951], [8185, 7988], [8204, 8005], [8192, 8031], [8135, 8005], [8093, 8004], [8086, 8027], [8043, 8071], [8005, 8075], [7935, 8210], [7862, 8234], [7790, 8222], [7766, 8201], [7788, 8176], [7768, 8158], [7740, 8107], [7742, 8093], [7699, 8074], [7667, 8086], [7628, 8089], [7596, 8104], [7559, 8077], [7490, 8060], [7425, 8067], [7407, 8090], [7330, 8111], [7280, 8098], [7239, 8117], [7237, 8144], [7139, 8176], [7106, 8132], [7121, 8113], [7093, 8083], [7011, 8094], [7001, 8115], [6945, 8127], [6810, 8061], [6801, 8059], [6795, 8058], [6774, 8077], [6734, 8077], [6680, 8131], [6621, 8121], [6598, 8144], [6577, 8124], [6515, 8222], [6475, 8250], [6479, 8269], [6407, 8235], [6385, 8249], [6316, 8256], [6306, 8305], [6230, 8300], [6227, 8291], [6139, 8266], [6014, 8247], [6020, 8222], [6045, 8216], [6005, 8198], [6015, 8184], [5989, 8167], [6028, 8148], [6025, 8123], [5983, 8125], [5978, 8114], [5943, 8133], [5881, 8134], [5856, 8113], [5821, 8126], [5787, 8152], [5705, 8157], [5648, 8115], [5641, 8085], [5615, 8110], [5596, 8086], [5600, 8062], [5583, 8032], [5602, 8009], [5630, 8008], [5665, 7954], [5617, 7931], [5591, 7892], [5617, 7860], [5612, 7833], [5646, 7791], [5621, 7768], [5582, 7793], [5534, 7823], [5508, 7816], [5475, 7838], [5391, 7846]]], [[[9599, 9071], [9621, 9058], [9607, 9047], [9546, 9044], [9510, 9034], [9513, 9057], [9553, 9077], [9599, 9071]]], [[[8377, 9210], [8419, 9208], [8460, 9187], [8453, 9166], [8373, 9183], [8377, 9210]]], [[[6937, 9577], [6908, 9593], [6985, 9585], [6953, 9568], [6937, 9577]]], [[[5596, 9641], [5637, 9647], [5572, 9620], [5542, 9634], [5596, 9641]]], [[[5995, 9655], [6034, 9667], [6052, 9644], [6016, 9618], [5975, 9619], [5961, 9635], [5995, 9655]]], [[[4790, 8269], [4810, 8280], [4786, 8270], [4786, 8270], [4795, 8288], [4825, 8304], [4827, 8304], [4814, 8290], [4835, 8303], [4881, 8288], [4880, 8266], [4878, 8266], [4790, 8269]]], [[[7022, 9596], [7001, 9593], [6984, 9590], [6920, 9610], [6957, 9625], [6965, 9659], [7046, 9679], [7111, 9638], [7088, 9634], [7088, 9606], [7033, 9597], [7100, 9602], [7123, 9582], [7148, 9593], [7170, 9569], [7154, 9511], [7105, 9510], [7077, 9522], [7024, 9525], [6986, 9559], [7022, 9596]]], [[[8455, 8069], [8434, 8017], [8459, 7961], [8432, 7965], [8421, 7938], [8413, 7964], [8424, 8015], [8417, 8049], [8426, 8138], [8409, 8161], [8411, 8226], [8442, 8239], [8434, 8264], [8456, 8217], [8461, 8152], [8486, 8064], [8455, 8069]]], [[[5879, 9169], [5847, 9116], [5869, 9059], [5914, 9030], [5900, 9017], [5849, 9031], [5841, 9020], [5786, 9037], [5794, 9055], [5774, 9065], [5778, 9046], [5733, 9076], [5731, 9096], [5759, 9104], [5780, 9161], [5834, 9180], [5879, 9169]]], [[[8571, 9292], [8608, 9297], [8629, 9288], [8681, 9280], [8673, 9266], [8601, 9260], [8539, 9286], [8548, 9307], [8571, 9292]]], [[[8399, 9343], [8434, 9324], [8476, 9322], [8518, 9303], [8477, 9274], [8433, 9294], [8437, 9278], [8468, 9268], [8429, 9262], [8413, 9272], [8329, 9252], [8296, 9263], [8266, 9294], [8241, 9299], [8224, 9294], [8230, 9324], [8269, 9309], [8282, 9329], [8326, 9346], [8388, 9309], [8399, 9343]]], [[[6210, 9395], [6246, 9386], [6250, 9367], [6197, 9339], [6025, 9292], [5959, 9239], [5931, 9247], [5933, 9224], [5888, 9170], [5837, 9181], [5814, 9174], [5796, 9199], [5830, 9212], [5852, 9252], [5897, 9296], [5931, 9307], [5947, 9326], [6017, 9337], [6017, 9349], [6055, 9344], [6104, 9352], [6210, 9395]]], [[[7197, 9509], [7203, 9532], [7240, 9552], [7265, 9544], [7257, 9526], [7285, 9533], [7322, 9512], [7352, 9475], [7326, 9488], [7282, 9474], [7207, 9470], [7173, 9455], [7150, 9460], [7197, 9509]]], [[[5588, 9611], [5677, 9634], [5658, 9643], [5699, 9660], [5738, 9636], [5680, 9624], [5695, 9590], [5674, 9601], [5588, 9611]]]]
  }
}, {
  type: "Feature",
  id: "VA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.61,
    "hc-middle-y": 0.44,
    "hc-key": "va",
    "hc-a2": "VA",
    name: "Vatican",
    labelrank: "6",
    "country-abbrev": "Vat.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "VAT",
    "iso-a2": "VA",
    "woe-id": "23424986",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4574, 7793], [4574, 7793], [4574, 7793], [4574, 7793], [4574, 7793]]]
  }
}, {
  type: "Feature",
  id: "SM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.42,
    "hc-key": "sm",
    "hc-a2": "SM",
    name: "San Marino",
    labelrank: "6",
    "country-abbrev": "S.M.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "SMR",
    "iso-a2": "SM",
    "woe-id": "23424947",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4574, 7865], [4572, 7866], [4573, 7867], [4574, 7868], [4574, 7865]]]
  }
}, {
  type: "Feature",
  id: "KZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.57,
    "hc-middle-y": 0.46,
    "hc-key": "kz",
    "hc-a2": "KZ",
    name: "Kazakhstan",
    labelrank: "3",
    "country-abbrev": "Kaz.",
    subregion: "Central Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "KAZ",
    "iso-a2": "KZ",
    "woe-id": "-90",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5991, 7941], [5960, 7930], [5968, 7910], [5947, 7922], [5952, 7928], [5943, 7925], [5865, 7905], [5865, 7773], [5851, 7770], [5812, 7808], [5792, 7800], [5792, 7800], [5792, 7800], [5792, 7800], [5780, 7795], [5780, 7795], [5780, 7795], [5780, 7795], [5760, 7788], [5768, 7823], [5745, 7826], [5697, 7892], [5729, 7917], [5763, 7920], [5779, 7942], [5779, 7975], [5750, 7972], [5724, 7983], [5665, 7954], [5630, 8008], [5602, 8009], [5583, 8032], [5600, 8062], [5596, 8086], [5615, 8110], [5641, 8085], [5648, 8115], [5705, 8157], [5787, 8152], [5821, 8126], [5856, 8113], [5881, 8134], [5943, 8133], [5978, 8114], [5983, 8125], [6025, 8123], [6028, 8148], [5989, 8167], [6015, 8184], [6005, 8198], [6045, 8216], [6020, 8222], [6014, 8247], [6139, 8266], [6227, 8291], [6230, 8300], [6306, 8305], [6316, 8256], [6385, 8249], [6407, 8235], [6479, 8269], [6475, 8250], [6515, 8222], [6577, 8124], [6598, 8144], [6621, 8121], [6680, 8131], [6734, 8077], [6774, 8077], [6795, 8058], [6750, 8032], [6741, 7981], [6719, 7972], [6668, 7986], [6646, 7924], [6581, 7906], [6602, 7838], [6584, 7803], [6531, 7828], [6435, 7827], [6405, 7842], [6385, 7812], [6336, 7826], [6309, 7805], [6253, 7774], [6240, 7747], [6220, 7768], [6183, 7768], [6178, 7796], [6163, 7797], [6157, 7828], [6131, 7858], [6045, 7850], [6015, 7882], [5986, 7899], [5977, 7930], [5996, 7939], [5991, 7941]], [[5995, 7942], [5997, 7942], [5997, 7940], [6021, 7950], [5995, 7942]]], [[[5693, 7900], [5687, 7903], [5689, 7907], [5698, 7908], [5693, 7900]]]]
  }
}, {
  type: "Feature",
  id: "AZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.83,
    "hc-middle-y": 0.51,
    "hc-key": "az",
    "hc-a2": "AZ",
    name: "Azerbaijan",
    labelrank: "5",
    "country-abbrev": "Aze.",
    subregion: "Western Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "AZE",
    "iso-a2": "AZ",
    "woe-id": "23424741",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5540, 7763], [5539, 7762], [5538, 7764], [5540, 7764], [5540, 7763]]], [[[5546, 7760], [5545, 7760], [5545, 7761], [5545, 7761], [5546, 7760]]], [[[5554, 7747], [5554, 7749], [5556, 7749], [5555, 7747], [5554, 7747]]], [[[5534, 7714], [5533, 7716], [5563, 7710], [5573, 7687], [5552, 7692], [5534, 7714]]], [[[5582, 7793], [5621, 7768], [5646, 7791], [5676, 7748], [5654, 7672], [5629, 7685], [5627, 7716], [5584, 7687], [5558, 7727], [5568, 7734], [5539, 7771], [5584, 7763], [5582, 7793]]]]
  }
}, {
  type: "Feature",
  id: "TJ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.28,
    "hc-middle-y": 0.56,
    "hc-key": "tj",
    "hc-a2": "TJ",
    name: "Tajikistan",
    labelrank: "4",
    "country-abbrev": "Tjk.",
    subregion: "Central Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "TJK",
    "iso-a2": "TJ",
    "woe-id": "23424961",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[6300, 7759], [6300, 7759], [6298, 7762], [6299, 7761], [6300, 7759]]], [[[6300, 7721], [6302, 7720], [6299, 7718], [6296, 7722], [6300, 7721]]], [[[6389, 7707], [6395, 7677], [6423, 7675], [6426, 7631], [6379, 7639], [6329, 7613], [6329, 7653], [6299, 7669], [6285, 7641], [6259, 7626], [6215, 7629], [6232, 7665], [6225, 7691], [6203, 7699], [6235, 7710], [6264, 7754], [6295, 7762], [6310, 7734], [6280, 7734], [6261, 7709], [6325, 7713], [6348, 7698], [6389, 7707]]]]
  }
}, {
  type: "Feature",
  id: "LS",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.45,
    "hc-key": "ls",
    "hc-a2": "LS",
    name: "Lesotho",
    labelrank: "6",
    "country-abbrev": "Les.",
    subregion: "Southern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "LSO",
    "iso-a2": "LS",
    "woe-id": "23424880",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5040, 5608], [5054, 5613], [5078, 5588], [5037, 5545], [5006, 5579], [5040, 5608]]]
  }
}, {
  type: "Feature",
  id: "UZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.46,
    "hc-middle-y": 0.53,
    "hc-key": "uz",
    "hc-a2": "UZ",
    name: "Uzbekistan",
    labelrank: "3",
    "country-abbrev": "Uzb.",
    subregion: "Central Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "UZB",
    "iso-a2": "UZ",
    "woe-id": "23424980",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[6333, 7723], [6332, 7723], [6331, 7724], [6334, 7726], [6333, 7723]]], [[[6316, 7728], [6317, 7722], [6312, 7722], [6310, 7729], [6316, 7728]]], [[[5968, 7910], [5961, 7895], [5982, 7876], [5986, 7899], [6015, 7882], [6045, 7850], [6131, 7858], [6157, 7828], [6163, 7797], [6178, 7796], [6183, 7768], [6220, 7768], [6240, 7747], [6253, 7774], [6309, 7805], [6286, 7782], [6323, 7766], [6333, 7777], [6374, 7754], [6331, 7731], [6310, 7734], [6295, 7762], [6264, 7754], [6235, 7710], [6203, 7699], [6225, 7691], [6232, 7665], [6215, 7629], [6200, 7629], [6178, 7635], [6179, 7658], [6151, 7665], [6057, 7726], [6043, 7761], [5987, 7775], [5981, 7807], [5943, 7825], [5915, 7802], [5908, 7809], [5898, 7794], [5896, 7770], [5865, 7773], [5865, 7905], [5943, 7925], [5934, 7884], [5947, 7922], [5968, 7910]], [[6300, 7759], [6299, 7761], [6298, 7762], [6300, 7759], [6300, 7759]]]]
  }
}, {
  type: "Feature",
  id: "MA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.6,
    "hc-middle-y": 0.21,
    "hc-key": "ma",
    "hc-a2": "MA",
    name: "Morocco",
    labelrank: "3",
    "country-abbrev": "Mor.",
    subregion: "Northern Africa",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "MAR",
    "iso-a2": "MA",
    "woe-id": "23424893",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4117, 7564], [4118, 7565], [4119, 7560], [4138, 7558], [4151, 7547], [4154, 7497], [4173, 7473], [4167, 7459], [4129, 7460], [4095, 7444], [4096, 7414], [4033, 7378], [3977, 7371], [3946, 7348], [3946, 7316], [3943, 7298], [3915, 7290], [3866, 7291], [3847, 7264], [3835, 7226], [3788, 7182], [3782, 7148], [3764, 7121], [3699, 7120], [3740, 7201], [3762, 7222], [3774, 7267], [3800, 7285], [3820, 7324], [3863, 7337], [3890, 7358], [3919, 7404], [3912, 7436], [3929, 7475], [3951, 7498], [4002, 7523], [4028, 7582], [4044, 7586], [4044, 7585], [4045, 7584], [4074, 7560], [4116, 7566], [4117, 7566], [4117, 7564]]]
  }
}, {
  type: "Feature",
  id: "CO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.54,
    "hc-key": "co",
    "hc-a2": "CO",
    name: "Colombia",
    labelrank: "2",
    "country-abbrev": "Col.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "COL",
    "iso-a2": "CO",
    "woe-id": "23424787",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1865, 6521], [1868, 6543], [1894, 6559], [1916, 6592], [1909, 6611], [1909, 6673], [1892, 6692], [1914, 6713], [1908, 6735], [1920, 6731], [1960, 6758], [1963, 6791], [2005, 6815], [2029, 6813], [2082, 6847], [2087, 6830], [2068, 6824], [2040, 6787], [2037, 6753], [2056, 6726], [2064, 6688], [2123, 6685], [2143, 6659], [2201, 6662], [2190, 6612], [2207, 6580], [2191, 6564], [2210, 6549], [2219, 6515], [2206, 6540], [2181, 6529], [2131, 6529], [2125, 6474], [2143, 6437], [2128, 6354], [2105, 6367], [2125, 6399], [2096, 6414], [2056, 6406], [2032, 6413], [2019, 6442], [1970, 6476], [1940, 6492], [1905, 6498], [1865, 6521]]]
  }
}, {
  type: "Feature",
  id: "TL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.65,
    "hc-middle-y": 0.36,
    "hc-key": "tl",
    "hc-a2": "TL",
    name: "East Timor",
    labelrank: "5",
    "country-abbrev": "T.L.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "TLS",
    "iso-a2": "TL",
    "woe-id": "23424968",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[7885, 6203], [7890, 6206], [7897, 6207], [7891, 6198], [7885, 6203]]], [[[7911, 6214], [7918, 6224], [7972, 6233], [7957, 6214], [7915, 6198], [7912, 6206], [7911, 6214]]]]
  }
}, {
  type: "Feature",
  id: "TZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.5,
    "hc-key": "tz",
    "hc-a2": "TZ",
    name: "United Republic of Tanzania",
    labelrank: "3",
    "country-abbrev": "Tanz.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "TZA",
    "iso-a2": "TZ",
    "woe-id": "23424973",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5242, 6136], [5241, 6138], [5240, 6141], [5240, 6141], [5236, 6143], [5235, 6145], [5235, 6145], [5234, 6146], [5227, 6185], [5222, 6192], [5219, 6195], [5219, 6195], [5216, 6197], [5215, 6197], [5215, 6198], [5211, 6196], [5210, 6191], [5195, 6195], [5181, 6201], [5153, 6211], [5129, 6225], [5093, 6304], [5084, 6347], [5118, 6383], [5111, 6408], [5119, 6432], [5108, 6447], [5119, 6449], [5147, 6449], [5147, 6448], [5148, 6449], [5149, 6449], [5151, 6407], [5189, 6405], [5215, 6448], [5321, 6389], [5325, 6371], [5367, 6341], [5387, 6324], [5371, 6310], [5378, 6289], [5372, 6221], [5404, 6169], [5316, 6132], [5242, 6136]]]
  }
}, {
  type: "Feature",
  id: "AR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.46,
    "hc-middle-y": 0.27,
    "hc-key": "ar",
    "hc-a2": "AR",
    name: "Argentina",
    labelrank: "2",
    "country-abbrev": "Arg.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "ARG",
    "iso-a2": "AR",
    "woe-id": "23424747",
    continent: "South America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[2167, 4673], [2169, 4670], [2167, 4670], [2167, 4673]]], [[[2584, 5708], [2604, 5706], [2606, 5658], [2549, 5623], [2494, 5561], [2477, 5505], [2477, 5487], [2466, 5426], [2509, 5387], [2501, 5373], [2522, 5338], [2495, 5295], [2451, 5277], [2398, 5267], [2362, 5269], [2354, 5201], [2310, 5191], [2278, 5207], [2273, 5163], [2287, 5146], [2312, 5158], [2316, 5134], [2292, 5143], [2292, 5126], [2265, 5101], [2257, 5052], [2239, 5053], [2206, 5030], [2197, 5010], [2222, 4978], [2246, 4976], [2246, 4939], [2199, 4902], [2189, 4865], [2160, 4852], [2151, 4826], [2173, 4772], [2128, 4786], [2070, 4787], [2054, 4804], [2058, 4839], [2032, 4835], [2020, 4882], [2059, 4928], [2051, 4944], [2070, 4970], [2088, 5042], [2066, 5062], [2077, 5092], [2063, 5125], [2075, 5158], [2069, 5206], [2085, 5269], [2101, 5277], [2091, 5311], [2096, 5352], [2115, 5366], [2115, 5397], [2133, 5456], [2109, 5516], [2137, 5618], [2162, 5659], [2177, 5666], [2169, 5733], [2206, 5757], [2210, 5794], [2238, 5826], [2287, 5813], [2295, 5792], [2307, 5819], [2345, 5812], [2394, 5763], [2422, 5757], [2496, 5712], [2465, 5653], [2549, 5649], [2578, 5674], [2584, 5708]]], [[[2167, 4674], [2167, 4761], [2173, 4734], [2207, 4704], [2250, 4679], [2287, 4669], [2229, 4663], [2209, 4666], [2202, 4668], [2167, 4674]]]]
  }
}, {
  type: "Feature",
  id: "SA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.53,
    "hc-key": "sa",
    "hc-a2": "SA",
    name: "Saudi Arabia",
    labelrank: "2",
    "country-abbrev": "Saud.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "SAU",
    "iso-a2": "SA",
    "woe-id": "23424938",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5641, 7344], [5655, 7313], [5692, 7284], [5692, 7255], [5712, 7224], [5717, 7218], [5724, 7220], [5726, 7210], [5734, 7208], [5764, 7167], [5842, 7160], [5855, 7137], [5836, 7076], [5747, 7045], [5662, 7034], [5633, 7020], [5611, 6987], [5544, 6998], [5485, 6995], [5474, 6966], [5427, 7036], [5419, 7061], [5381, 7090], [5364, 7117], [5364, 7155], [5345, 7193], [5318, 7209], [5309, 7237], [5249, 7328], [5230, 7330], [5241, 7370], [5274, 7365], [5331, 7407], [5301, 7439], [5366, 7460], [5404, 7453], [5453, 7426], [5530, 7365], [5585, 7362], [5612, 7358], [5641, 7344]]]
  }
}, {
  type: "Feature",
  id: "PK",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.34,
    "hc-middle-y": 0.64,
    "hc-key": "pk",
    "hc-a2": "PK",
    name: "Pakistan",
    labelrank: "2",
    "country-abbrev": "Pak.",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "PAK",
    "iso-a2": "PK",
    "woe-id": "23424922",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6416, 7624], [6459, 7605], [6482, 7577], [6490, 7559], [6453, 7539], [6410, 7548], [6393, 7534], [6400, 7495], [6438, 7461], [6415, 7446], [6416, 7427], [6381, 7388], [6368, 7360], [6337, 7325], [6295, 7328], [6265, 7289], [6313, 7222], [6280, 7205], [6247, 7208], [6227, 7195], [6203, 7202], [6173, 7246], [6088, 7238], [6032, 7238], [6039, 7270], [6076, 7283], [6067, 7334], [6041, 7344], [6010, 7386], [6058, 7372], [6106, 7371], [6168, 7385], [6173, 7421], [6226, 7450], [6261, 7454], [6268, 7491], [6290, 7499], [6281, 7523], [6313, 7524], [6330, 7562], [6316, 7590], [6357, 7617], [6416, 7624]]]
  }
}, {
  type: "Feature",
  id: "YE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.39,
    "hc-middle-y": 0.75,
    "hc-key": "ye",
    "hc-a2": "YE",
    name: "Yemen",
    labelrank: "3",
    "country-abbrev": "Yem.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "YEM",
    "iso-a2": "YE",
    "woe-id": "23425002",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5747, 7045], [5769, 6994], [5780, 6974], [5754, 6943], [5675, 6916], [5649, 6895], [5629, 6896], [5590, 6877], [5564, 6875], [5508, 6852], [5494, 6859], [5472, 6941], [5474, 6966], [5485, 6995], [5544, 6998], [5611, 6987], [5633, 7020], [5662, 7034], [5747, 7045]]]
  }
}, {
  type: "Feature",
  id: "AE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.59,
    "hc-middle-y": 0.65,
    "hc-key": "ae",
    "hc-a2": "AE",
    name: "United Arab Emirates",
    labelrank: "4",
    "country-abbrev": "U.A.E.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "ARE",
    "iso-a2": "AE",
    "woe-id": "23424738",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5874, 7251], [5877, 7248], [5877, 7231], [5860, 7228], [5842, 7160], [5764, 7167], [5734, 7208], [5810, 7205], [5868, 7265], [5870, 7253], [5874, 7251]], [[5874, 7239], [5876, 7241], [5873, 7241], [5873, 7238], [5874, 7239]]]
  }
}, {
  type: "Feature",
  id: "KE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.87,
    "hc-middle-y": 0.7,
    "hc-key": "ke",
    "hc-a2": "KE",
    name: "Kenya",
    labelrank: "2",
    "country-abbrev": "Ken.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "KEN",
    "iso-a2": "KE",
    "woe-id": "23424863",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5367, 6341], [5325, 6371], [5321, 6389], [5215, 6448], [5220, 6471], [5213, 6486], [5242, 6527], [5240, 6552], [5212, 6603], [5255, 6627], [5270, 6615], [5297, 6609], [5335, 6585], [5377, 6579], [5414, 6605], [5447, 6596], [5420, 6562], [5420, 6453], [5437, 6429], [5396, 6397], [5367, 6341]]]
  }
}, {
  type: "Feature",
  id: "PE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.69,
    "hc-middle-y": 0.71,
    "hc-key": "pe",
    "hc-a2": "PE",
    name: "Peru",
    labelrank: "2",
    "country-abbrev": "Peru",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "PER",
    "iso-a2": "PE",
    "woe-id": "23424919",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1970, 6476], [2019, 6442], [2032, 6413], [2056, 6406], [2096, 6414], [2125, 6399], [2105, 6367], [2128, 6354], [2103, 6356], [2040, 6327], [2034, 6290], [2007, 6256], [2061, 6183], [2091, 6185], [2111, 6200], [2108, 6153], [2139, 6155], [2166, 6108], [2153, 6073], [2160, 6058], [2145, 6017], [2126, 6008], [2153, 5996], [2155, 5997], [2157, 5996], [2153, 5988], [2155, 5986], [2137, 5964], [2141, 5957], [2128, 5935], [2115, 5932], [2082, 5964], [1973, 6022], [1940, 6061], [1942, 6083], [1900, 6144], [1860, 6236], [1831, 6278], [1797, 6299], [1793, 6354], [1820, 6379], [1815, 6358], [1858, 6331], [1879, 6379], [1928, 6403], [1961, 6433], [1970, 6476]]]
  }
}, {
  type: "Feature",
  id: "DO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.46,
    "hc-middle-y": 0.38,
    "hc-key": "do",
    "hc-a2": "DO",
    name: "Dominican Republic",
    labelrank: "5",
    "country-abbrev": "Dom. Rep.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "DOM",
    "iso-a2": "DO",
    "woe-id": "23424800",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2070, 7030], [2070, 7030], [2069, 7031], [2069, 7031], [2067, 7033], [2076, 7038], [2075, 7067], [2097, 7074], [2128, 7066], [2138, 7048], [2175, 7035], [2159, 7028], [2106, 7028], [2085, 7003], [2074, 7016], [2076, 7025], [2070, 7030]]]
  }
}, {
  type: "Feature",
  id: "HT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.82,
    "hc-middle-y": 0.96,
    "hc-key": "ht",
    "hc-a2": "HT",
    name: "Haiti",
    labelrank: "5",
    "country-abbrev": "Haiti",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "HTI",
    "iso-a2": "HT",
    "woe-id": "23424839",
    continent: "North America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[2070, 7030], [2069, 7031], [2069, 7031], [2069, 7031], [2070, 7030]]], [[[2075, 7067], [2076, 7038], [2067, 7033], [2068, 7030], [2070, 7030], [2076, 7025], [2074, 7016], [2028, 7023], [2011, 7016], [2000, 7036], [2046, 7028], [2046, 7059], [2025, 7070], [2075, 7067]]]]
  }
}, {
  type: "Feature",
  id: "PG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.14,
    "hc-middle-y": 0.5,
    "hc-key": "pg",
    "hc-a2": "PG",
    name: "Papua New Guinea",
    labelrank: "2",
    "country-abbrev": "P.N.G.",
    subregion: "Melanesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "PNG",
    "iso-a2": "PG",
    "woe-id": "23424926",
    continent: "Oceania"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[8388, 6210], [8388, 6275], [8388, 6402], [8478, 6367], [8493, 6366], [8531, 6335], [8530, 6317], [8580, 6303], [8592, 6281], [8565, 6279], [8572, 6258], [8600, 6241], [8632, 6198], [8684, 6195], [8676, 6166], [8595, 6178], [8568, 6199], [8539, 6240], [8470, 6255], [8460, 6214], [8437, 6203], [8388, 6210]]], [[[8654, 6406], [8646, 6432], [8662, 6408], [8716, 6383], [8749, 6353], [8741, 6336], [8723, 6373], [8654, 6406]]], [[[8645, 6292], [8598, 6309], [8685, 6319], [8703, 6332], [8701, 6355], [8727, 6351], [8719, 6320], [8669, 6294], [8645, 6292]]]]
  }
}, {
  type: "Feature",
  id: "AO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.67,
    "hc-key": "ao",
    "hc-a2": "AO",
    name: "Angola",
    labelrank: "3",
    "country-abbrev": "Ang.",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "AGO",
    "iso-a2": "AO",
    "woe-id": "23424745",
    continent: "Africa"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4566, 6309], [4567, 6317], [4560, 6331], [4583, 6349], [4592, 6342], [4573, 6330], [4566, 6309]]], [[[4898, 5953], [4821, 5941], [4761, 5950], [4752, 5961], [4618, 5960], [4595, 5974], [4553, 5965], [4553, 6009], [4575, 6081], [4609, 6116], [4613, 6163], [4590, 6210], [4601, 6232], [4568, 6298], [4595, 6306], [4697, 6304], [4708, 6263], [4726, 6239], [4778, 6242], [4783, 6272], [4850, 6264], [4851, 6201], [4862, 6185], [4864, 6146], [4915, 6157], [4916, 6093], [4856, 6093], [4856, 5998], [4898, 5953]]]]
  }
}, {
  type: "Feature",
  id: "KH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.84,
    "hc-middle-y": 0.49,
    "hc-key": "kh",
    "hc-a2": "KH",
    name: "Cambodia",
    labelrank: "3",
    "country-abbrev": "Camb.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "KHM",
    "iso-a2": "KH",
    "woe-id": "23424776",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7395, 6915], [7395, 6844], [7342, 6805], [7304, 6787], [7279, 6789], [7258, 6824], [7241, 6881], [7280, 6907], [7325, 6904], [7374, 6904], [7395, 6915]]]
  }
}, {
  type: "Feature",
  id: "VN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.59,
    "hc-middle-y": 0.89,
    "hc-key": "vn",
    "hc-a2": "VN",
    name: "Vietnam",
    labelrank: "2",
    "country-abbrev": "Viet.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "VNM",
    "iso-a2": "VN",
    "woe-id": "23424984",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7304, 6787], [7342, 6805], [7395, 6844], [7395, 6915], [7399, 6932], [7365, 6984], [7311, 7039], [7286, 7055], [7319, 7079], [7292, 7106], [7264, 7103], [7260, 7125], [7234, 7150], [7245, 7162], [7289, 7154], [7329, 7180], [7372, 7161], [7366, 7149], [7409, 7122], [7377, 7105], [7350, 7076], [7338, 7046], [7368, 6999], [7432, 6936], [7452, 6861], [7439, 6815], [7387, 6786], [7371, 6790], [7364, 6761], [7313, 6739], [7314, 6781], [7304, 6787]]]
  }
}, {
  type: "Feature",
  id: "MZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.83,
    "hc-middle-y": 0.28,
    "hc-key": "mz",
    "hc-a2": "MZ",
    name: "Mozambique",
    labelrank: "3",
    "country-abbrev": "Moz.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "MOZ",
    "iso-a2": "MZ",
    "woe-id": "23424902",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5238, 6078], [5234, 6118], [5242, 6136], [5316, 6132], [5404, 6169], [5416, 6039], [5388, 5991], [5305, 5946], [5239, 5885], [5233, 5868], [5258, 5816], [5246, 5739], [5205, 5723], [5169, 5696], [5180, 5668], [5164, 5667], [5157, 5668], [5155, 5685], [5152, 5696], [5153, 5744], [5133, 5807], [5166, 5841], [5184, 5880], [5176, 5898], [5185, 5932], [5182, 5982], [5106, 6014], [5101, 6034], [5189, 6063], [5202, 6045], [5223, 6052], [5220, 6006], [5247, 5987], [5266, 6002], [5268, 6044], [5238, 6078]]]
  }
}, {
  type: "Feature",
  id: "CR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.55,
    "hc-middle-y": 0.31,
    "hc-key": "cr",
    "hc-a2": "CR",
    name: "Costa Rica",
    labelrank: "5",
    "country-abbrev": "C.R.",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "CRI",
    "iso-a2": "CR",
    "woe-id": "23424791",
    continent: "North America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[1722, 6802], [1727, 6789], [1754, 6762], [1740, 6726], [1740, 6726], [1736, 6734], [1656, 6785], [1661, 6807], [1701, 6804], [1722, 6802]]], [[[1744, 6716], [1739, 6725], [1740, 6725], [1740, 6725], [1744, 6716]]]]
  }
}, {
  type: "Feature",
  id: "BJ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.57,
    "hc-middle-y": 0.49,
    "hc-key": "bj",
    "hc-a2": "BJ",
    name: "Benin",
    labelrank: "5",
    "country-abbrev": "Benin",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "BEN",
    "iso-a2": "BJ",
    "woe-id": "23424764",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4311, 6825], [4318, 6792], [4286, 6746], [4284, 6667], [4260, 6664], [4252, 6662], [4252, 6746], [4231, 6804], [4247, 6818], [4275, 6831], [4288, 6846], [4311, 6825]]]
  }
}, {
  type: "Feature",
  id: "NG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.36,
    "hc-middle-y": 0.33,
    "hc-key": "ng",
    "hc-a2": "NG",
    name: "Nigeria",
    labelrank: "2",
    "country-abbrev": "Nigeria",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "NGA",
    "iso-a2": "NG",
    "woe-id": "23424908",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4284, 6667], [4286, 6746], [4318, 6792], [4311, 6825], [4326, 6878], [4368, 6891], [4410, 6864], [4436, 6874], [4490, 6859], [4504, 6872], [4543, 6875], [4574, 6866], [4608, 6885], [4621, 6866], [4639, 6839], [4567, 6725], [4540, 6669], [4518, 6689], [4466, 6651], [4459, 6621], [4388, 6605], [4370, 6615], [4335, 6666], [4284, 6667]]]
  }
}, {
  type: "Feature",
  id: "IR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.58,
    "hc-middle-y": 0.51,
    "hc-key": "ir",
    "hc-a2": "IR",
    name: "Iran",
    labelrank: "2",
    "country-abbrev": "Iran",
    subregion: "Southern Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "IRN",
    "iso-a2": "IR",
    "woe-id": "23424851",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5532, 7628], [5516, 7656], [5510, 7704], [5534, 7714], [5552, 7692], [5573, 7687], [5580, 7689], [5584, 7687], [5627, 7716], [5629, 7685], [5654, 7672], [5659, 7648], [5694, 7636], [5720, 7614], [5744, 7609], [5807, 7617], [5804, 7634], [5849, 7660], [5902, 7666], [5906, 7656], [5949, 7646], [5995, 7610], [6020, 7608], [6022, 7576], [6001, 7491], [6009, 7439], [6035, 7435], [6038, 7418], [6010, 7386], [6041, 7344], [6067, 7334], [6076, 7283], [6039, 7270], [6032, 7238], [5982, 7242], [5905, 7256], [5896, 7290], [5876, 7301], [5830, 7279], [5729, 7324], [5690, 7397], [5657, 7404], [5644, 7390], [5619, 7423], [5623, 7448], [5611, 7469], [5577, 7487], [5551, 7521], [5579, 7582], [5549, 7589], [5532, 7628]]]
  }
}, {
  type: "Feature",
  id: "SV",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.55,
    "hc-key": "sv",
    "hc-a2": "SV",
    name: "El Salvador",
    labelrank: "6",
    "country-abbrev": "El. S.",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "SLV",
    "iso-a2": "SV",
    "woe-id": "23424807",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1598, 6876], [1569, 6871], [1530, 6886], [1530, 6889], [1552, 6907], [1601, 6889], [1598, 6876]]]
  }
}, {
  type: "Feature",
  id: "SL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.48,
    "hc-key": "sl",
    "hc-a2": "SL",
    name: "Sierra Leone",
    labelrank: "4",
    "country-abbrev": "S.L.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "SLE",
    "iso-a2": "SL",
    "woe-id": "23424946",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3863, 6683], [3820, 6702], [3809, 6746], [3833, 6770], [3870, 6774], [3899, 6729], [3889, 6708], [3863, 6683]]]
  }
}, {
  type: "Feature",
  id: "GW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.55,
    "hc-middle-y": 0.49,
    "hc-key": "gw",
    "hc-a2": "GW",
    name: "Guinea Bissau",
    labelrank: "6",
    "country-abbrev": "GnB.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "GNB",
    "iso-a2": "GW",
    "woe-id": "23424929",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3758, 6803], [3732, 6811], [3708, 6844], [3753, 6854], [3797, 6854], [3797, 6825], [3767, 6819], [3758, 6803]]]
  }
}, {
  type: "Feature",
  id: "HR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.35,
    "hc-middle-y": 0.59,
    "hc-key": "hr",
    "hc-a2": "HR",
    name: "Croatia",
    labelrank: "6",
    "country-abbrev": "Cro.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "HRV",
    "iso-a2": "HR",
    "woe-id": "23424843",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4753, 7811], [4732, 7826], [4728, 7828], [4734, 7826], [4751, 7816], [4751, 7814], [4753, 7811]]], [[[4607, 7923], [4659, 7921], [4668, 7949], [4694, 7960], [4719, 7940], [4765, 7939], [4769, 7910], [4768, 7900], [4706, 7915], [4672, 7911], [4685, 7876], [4726, 7830], [4699, 7837], [4645, 7875], [4645, 7908], [4619, 7898], [4607, 7923]]]]
  }
}, {
  type: "Feature",
  id: "BZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.53,
    "hc-middle-y": 0.5,
    "hc-key": "bz",
    "hc-a2": "BZ",
    name: "Belize",
    labelrank: "6",
    "country-abbrev": "Belize",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "BLZ",
    "iso-a2": "BZ",
    "woe-id": "23424760",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1558, 7009], [1567, 7012], [1583, 7030], [1586, 6984], [1565, 6951], [1556, 6951], [1558, 7009]]]
  }
}, {
  type: "Feature",
  id: "ZA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.36,
    "hc-middle-y": 0.7,
    "hc-key": "za",
    "hc-a2": "ZA",
    name: "South Africa",
    labelrank: "2",
    "country-abbrev": "S.Af.",
    subregion: "Southern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "ZAF",
    "iso-a2": "ZA",
    "woe-id": "23424942",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5157, 5668], [5164, 5667], [5180, 5668], [5165, 5613], [5129, 5581], [5106, 5539], [5061, 5492], [5008, 5451], [4942, 5430], [4874, 5436], [4854, 5424], [4787, 5410], [4753, 5441], [4733, 5474], [4746, 5480], [4744, 5511], [4717, 5555], [4693, 5613], [4711, 5630], [4720, 5608], [4771, 5600], [4797, 5617], [4797, 5734], [4822, 5690], [4818, 5666], [4847, 5667], [4878, 5695], [4887, 5716], [4941, 5700], [4963, 5706], [4972, 5734], [5000, 5749], [5006, 5769], [5041, 5799], [5075, 5814], [5104, 5809], [5133, 5807], [5153, 5744], [5152, 5696], [5137, 5702], [5118, 5682], [5128, 5656], [5157, 5668]], [[5040, 5608], [5006, 5579], [5037, 5545], [5078, 5588], [5054, 5613], [5040, 5608]]]
  }
}, {
  type: "Feature",
  id: "CF",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.47,
    "hc-middle-y": 0.46,
    "hc-key": "cf",
    "hc-a2": "CF",
    name: "Central African Republic",
    labelrank: "4",
    "country-abbrev": "C.A.R.",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "CAF",
    "iso-a2": "CF",
    "woe-id": "23424792",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4882, 6802], [4906, 6770], [4901, 6738], [4921, 6735], [4956, 6696], [4987, 6675], [4988, 6658], [5018, 6628], [4963, 6637], [4872, 6602], [4815, 6609], [4789, 6630], [4754, 6606], [4757, 6581], [4722, 6588], [4696, 6581], [4685, 6545], [4682, 6562], [4654, 6590], [4631, 6657], [4663, 6701], [4702, 6702], [4756, 6716], [4771, 6745], [4810, 6749], [4870, 6804], [4882, 6802]]]
  }
}, {
  type: "Feature",
  id: "SD",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.38,
    "hc-key": "sd",
    "hc-a2": "SD",
    name: "Sudan",
    labelrank: "3",
    "country-abbrev": "Sudan",
    subregion: "Northern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "SDN",
    "iso-a2": "SD",
    "woe-id": "-90",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4921, 6735], [4901, 6738], [4906, 6770], [4882, 6802], [4863, 6856], [4859, 6887], [4873, 6898], [4889, 6945], [4916, 6946], [4916, 7061], [4916, 7076], [4945, 7076], [4945, 7138], [5131, 7138], [5299, 7138], [5310, 7102], [5318, 7037], [5350, 7015], [5302, 6987], [5285, 6928], [5288, 6902], [5276, 6855], [5263, 6854], [5238, 6796], [5230, 6801], [5215, 6758], [5189, 6800], [5190, 6840], [5156, 6834], [5166, 6806], [5131, 6768], [5095, 6783], [5060, 6754], [4992, 6760], [4970, 6787], [4948, 6783], [4921, 6735]]]
  }
}, {
  type: "Feature",
  id: "CD",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.58,
    "hc-middle-y": 0.42,
    "hc-key": "cd",
    "hc-a2": "CD",
    name: "Democratic Republic of the Congo",
    labelrank: "2",
    "country-abbrev": "D.R.C.",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "COD",
    "iso-a2": "CD",
    "woe-id": "23424780",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5071, 6380], [5067, 6329], [5079, 6281], [5111, 6236], [5061, 6228], [5045, 6210], [5050, 6201], [5056, 6189], [5046, 6140], [5066, 6112], [5088, 6119], [5088, 6081], [5070, 6080], [5011, 6136], [4996, 6123], [4956, 6134], [4955, 6147], [4925, 6142], [4915, 6157], [4864, 6146], [4862, 6185], [4851, 6201], [4850, 6264], [4783, 6272], [4778, 6242], [4726, 6239], [4708, 6263], [4697, 6304], [4595, 6306], [4573, 6300], [4566, 6309], [4573, 6330], [4592, 6342], [4631, 6353], [4644, 6337], [4685, 6381], [4686, 6416], [4731, 6463], [4740, 6542], [4757, 6581], [4754, 6606], [4789, 6630], [4815, 6609], [4872, 6602], [4963, 6637], [5018, 6628], [5046, 6605], [5088, 6613], [5119, 6582], [5115, 6551], [5132, 6543], [5109, 6523], [5108, 6515], [5093, 6503], [5085, 6476], [5074, 6464], [5084, 6465], [5081, 6452], [5082, 6438], [5075, 6434], [5071, 6429], [5063, 6421], [5061, 6406], [5061, 6400], [5065, 6398], [5072, 6389], [5071, 6380]]]
  }
}, {
  type: "Feature",
  id: "KW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.61,
    "hc-middle-y": 0.4,
    "hc-key": "kw",
    "hc-a2": "KW",
    name: "Kuwait",
    labelrank: "6",
    "country-abbrev": "Kwt.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "KWT",
    "iso-a2": "KW",
    "woe-id": "23424870",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5641, 7344], [5612, 7358], [5585, 7362], [5602, 7390], [5627, 7391], [5631, 7370], [5641, 7344]]]
  }
}, {
  type: "Feature",
  id: "DE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.34,
    "hc-key": "de",
    "hc-a2": "DE",
    name: "Germany",
    labelrank: "2",
    "country-abbrev": "Ger.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "DEU",
    "iso-a2": "DE",
    "woe-id": "23424829",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4477, 8004], [4477, 8003], [4477, 8003], [4477, 8004]]], [[[4461, 8288], [4466, 8289], [4484, 8285], [4544, 8248], [4575, 8271], [4609, 8275], [4620, 8254], [4626, 8249], [4625, 8248], [4625, 8247], [4621, 8251], [4627, 8239], [4623, 8205], [4639, 8194], [4644, 8126], [4575, 8108], [4571, 8083], [4614, 8045], [4582, 8021], [4591, 7997], [4565, 8005], [4530, 7993], [4492, 7999], [4473, 8009], [4477, 8004], [4455, 8001], [4429, 8001], [4447, 8053], [4392, 8072], [4397, 8085], [4386, 8097], [4393, 8105], [4382, 8122], [4393, 8164], [4412, 8180], [4417, 8221], [4422, 8240], [4458, 8233], [4471, 8247], [4461, 8288]]]]
  }
}, {
  type: "Feature",
  id: "BE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.54,
    "hc-middle-y": 0.4,
    "hc-key": "be",
    "hc-a2": "BE",
    name: "Belgium",
    labelrank: "2",
    "country-abbrev": "Belg.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "BEL",
    "iso-a2": "BE",
    "woe-id": "23424757",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4382, 8122], [4393, 8105], [4386, 8097], [4374, 8088], [4376, 8075], [4327, 8092], [4279, 8135], [4297, 8145], [4303, 8146], [4317, 8140], [4329, 8146], [4331, 8144], [4330, 8146], [4353, 8150], [4382, 8122]]]
  }
}, {
  type: "Feature",
  id: "IE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.48,
    "hc-key": "ie",
    "hc-a2": "IE",
    name: "Ireland",
    labelrank: "3",
    "country-abbrev": "Ire.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "IRL",
    "iso-a2": "IE",
    "woe-id": "23424803",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3989, 8295], [3961, 8270], [3987, 8256], [4018, 8256], [4026, 8209], [4015, 8179], [3979, 8174], [3946, 8154], [3913, 8149], [3895, 8167], [3939, 8222], [3907, 8226], [3912, 8265], [3948, 8262], [3958, 8299], [3989, 8295]]]
  }
}, {
  type: "Feature",
  id: "KP",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.32,
    "hc-middle-y": 0.63,
    "hc-key": "kp",
    "hc-a2": "KP",
    name: "North Korea",
    labelrank: "3",
    "country-abbrev": "N.K.",
    subregion: "Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "PRK",
    "iso-a2": "KP",
    "woe-id": "23424865",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[8083, 7807], [8051, 7781], [8053, 7755], [7988, 7717], [7986, 7697], [8013, 7678], [7978, 7667], [7963, 7651], [7931, 7658], [7924, 7646], [7907, 7675], [7927, 7702], [7895, 7730], [7943, 7758], [7962, 7785], [8007, 7774], [8004, 7796], [8053, 7812], [8057, 7831], [8078, 7815], [8081, 7811], [8083, 7807]]]
  }
}, {
  type: "Feature",
  id: "KR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.54,
    "hc-middle-y": 0.5,
    "hc-key": "kr",
    "hc-a2": "KR",
    name: "South Korea",
    labelrank: "2",
    "country-abbrev": "S.K.",
    subregion: "Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "KOR",
    "iso-a2": "KR",
    "woe-id": "23424868",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7963, 7651], [7978, 7667], [8013, 7678], [8042, 7632], [8046, 7573], [8021, 7546], [8004, 7553], [7987, 7536], [7955, 7542], [7963, 7651]]]
  }
}, {
  type: "Feature",
  id: "GY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.26,
    "hc-middle-y": 0.07,
    "hc-key": "gy",
    "hc-a2": "GY",
    name: "Guyana",
    labelrank: "4",
    "country-abbrev": "Guy.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "GUY",
    "iso-a2": "GY",
    "woe-id": "23424836",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2423, 6732], [2450, 6715], [2507, 6658], [2505, 6641], [2481, 6602], [2528, 6536], [2509, 6538], [2459, 6514], [2431, 6534], [2423, 6558], [2437, 6595], [2424, 6629], [2401, 6632], [2382, 6653], [2387, 6672], [2415, 6689], [2408, 6709], [2423, 6732]]]
  }
}, {
  type: "Feature",
  id: "HN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.71,
    "hc-middle-y": 0.09,
    "hc-key": "hn",
    "hc-a2": "HN",
    name: "Honduras",
    labelrank: "5",
    "country-abbrev": "Hond.",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "HND",
    "iso-a2": "HN",
    "woe-id": "23424841",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1586, 6946], [1654, 6955], [1702, 6949], [1737, 6924], [1688, 6919], [1660, 6893], [1630, 6887], [1613, 6864], [1607, 6873], [1598, 6876], [1601, 6889], [1552, 6907], [1558, 6926], [1586, 6946]]]
  }
}, {
  type: "Feature",
  id: "MM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.17,
    "hc-middle-y": 0.49,
    "hc-key": "mm",
    "hc-a2": "MM",
    name: "Myanmar",
    labelrank: "3",
    "country-abbrev": "Myan.",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "MMR",
    "iso-a2": "MM",
    "woe-id": "23424763",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6942, 7109], [6953, 7116], [6951, 7137], [6969, 7150], [6973, 7200], [6996, 7195], [7023, 7255], [7024, 7278], [7074, 7306], [7092, 7333], [7098, 7343], [7132, 7313], [7133, 7260], [7103, 7234], [7101, 7195], [7130, 7203], [7138, 7175], [7157, 7171], [7146, 7143], [7170, 7139], [7177, 7120], [7206, 7124], [7193, 7117], [7175, 7086], [7128, 7066], [7113, 7070], [7095, 7030], [7137, 6959], [7119, 6918], [7146, 6886], [7161, 6829], [7134, 6785], [7129, 6870], [7106, 6921], [7102, 6963], [7088, 6985], [7036, 6946], [7000, 6955], [7012, 7001], [6993, 7058], [6965, 7077], [6942, 7109]]]
  }
}, {
  type: "Feature",
  id: "GA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.36,
    "hc-middle-y": 0.65,
    "hc-key": "ga",
    "hc-a2": "GA",
    name: "Gabon",
    labelrank: "4",
    "country-abbrev": "Gabon",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "GAB",
    "iso-a2": "GA",
    "woe-id": "23424822",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4495, 6508], [4540, 6508], [4540, 6543], [4541, 6547], [4599, 6542], [4597, 6515], [4633, 6506], [4614, 6473], [4634, 6461], [4622, 6405], [4573, 6423], [4547, 6410], [4555, 6369], [4534, 6363], [4479, 6425], [4462, 6461], [4479, 6467], [4480, 6495], [4495, 6508]]]
  }
}, {
  type: "Feature",
  id: "GQ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.53,
    "hc-middle-y": 0.55,
    "hc-key": "gq",
    "hc-a2": "GQ",
    name: "Equatorial Guinea",
    labelrank: "4",
    "country-abbrev": "Eq. G.",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "GNQ",
    "iso-a2": "GQ",
    "woe-id": "23424804",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4540, 6543], [4540, 6508], [4495, 6508], [4481, 6514], [4495, 6548], [4500, 6543], [4540, 6543]]]
  }
}, {
  type: "Feature",
  id: "NI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.84,
    "hc-middle-y": 0.5,
    "hc-key": "ni",
    "hc-a2": "NI",
    name: "Nicaragua",
    labelrank: "5",
    "country-abbrev": "Nic.",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "NIC",
    "iso-a2": "NI",
    "woe-id": "23424915",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1661, 6807], [1603, 6860], [1613, 6864], [1630, 6887], [1660, 6893], [1688, 6919], [1737, 6924], [1715, 6816], [1722, 6802], [1701, 6804], [1661, 6807]]]
  }
}, {
  type: "Feature",
  id: "LV",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.05,
    "hc-middle-y": 0.36,
    "hc-key": "lv",
    "hc-a2": "LV",
    name: "Latvia",
    labelrank: "5",
    "country-abbrev": "Lat.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "LVA",
    "iso-a2": "LV",
    "woe-id": "23424874",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5016, 8399], [5024, 8370], [5039, 8340], [5023, 8325], [4993, 8320], [4942, 8353], [4929, 8345], [4860, 8352], [4829, 8337], [4829, 8370], [4849, 8401], [4875, 8408], [4907, 8375], [4927, 8386], [4925, 8413], [4954, 8422], [4990, 8398], [5016, 8399]]]
  }
}, {
  type: "Feature",
  id: "UG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.16,
    "hc-middle-y": 0.56,
    "hc-key": "ug",
    "hc-a2": "UG",
    name: "Uganda",
    labelrank: "3",
    "country-abbrev": "Uga.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "UGA",
    "iso-a2": "UG",
    "woe-id": "23424974",
    continent: "Africa"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5148, 6449], [5148, 6450], [5149, 6449], [5148, 6449]]], [[[5082, 6438], [5081, 6452], [5084, 6465], [5091, 6474], [5085, 6476], [5093, 6503], [5108, 6515], [5136, 6535], [5132, 6543], [5115, 6551], [5119, 6582], [5198, 6589], [5212, 6603], [5240, 6552], [5242, 6527], [5213, 6486], [5171, 6483], [5147, 6449], [5119, 6449], [5108, 6447], [5092, 6435], [5082, 6438]]]]
  }
}, {
  type: "Feature",
  id: "MW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.16,
    "hc-middle-y": 0.29,
    "hc-key": "mw",
    "hc-a2": "MW",
    name: "Malawi",
    labelrank: "6",
    "country-abbrev": "Mal.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "MWI",
    "iso-a2": "MW",
    "woe-id": "23424889",
    continent: "Africa"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5240, 6141], [5240, 6141], [5240, 6141], [5240, 6141]]], [[[5235, 6145], [5235, 6146], [5234, 6146], [5235, 6145], [5235, 6145]]], [[[5222, 6192], [5219, 6195], [5219, 6195], [5222, 6192]]], [[[5216, 6197], [5215, 6198], [5215, 6197], [5216, 6197]]], [[[5181, 6201], [5195, 6195], [5210, 6191], [5223, 6133], [5222, 6082], [5238, 6078], [5268, 6044], [5266, 6002], [5247, 5987], [5220, 6006], [5223, 6052], [5202, 6045], [5189, 6063], [5178, 6072], [5194, 6107], [5190, 6157], [5203, 6166], [5181, 6201]]]]
  }
}, {
  type: "Feature",
  id: "AM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.1,
    "hc-middle-y": 0.12,
    "hc-key": "am",
    "hc-a2": "AM",
    name: "Armenia",
    labelrank: "6",
    "country-abbrev": "Arm.",
    subregion: "Western Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "ARM",
    "iso-a2": "AM",
    "woe-id": "23424743",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5584, 7687], [5580, 7689], [5573, 7687], [5563, 7710], [5533, 7716], [5500, 7730], [5493, 7765], [5515, 7769], [5539, 7771], [5568, 7734], [5558, 7727], [5584, 7687]], [[5540, 7763], [5540, 7764], [5538, 7764], [5539, 7762], [5540, 7763]], [[5546, 7760], [5545, 7761], [5545, 7761], [5545, 7760], [5546, 7760]], [[5554, 7747], [5555, 7747], [5556, 7749], [5554, 7749], [5554, 7747]]]
  }
}, {
  type: "Feature",
  id: "SX",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.76,
    "hc-middle-y": 0.53,
    "hc-key": "sx",
    "hc-a2": "SX",
    name: "Somaliland",
    labelrank: "5",
    "country-abbrev": "Solnd.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "-99",
    "iso-a2": "SX",
    "woe-id": "-99",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5487, 6819], [5518, 6788], [5562, 6801], [5582, 6795], [5611, 6810], [5656, 6812], [5656, 6758], [5628, 6715], [5598, 6715], [5510, 6744], [5470, 6793], [5478, 6804], [5487, 6819]]]
  }
}, {
  type: "Feature",
  id: "TM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.4,
    "hc-middle-y": 0.42,
    "hc-key": "tm",
    "hc-a2": "TM",
    name: "Turkmenistan",
    labelrank: "4",
    "country-abbrev": "Turkm.",
    subregion: "Central Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "TKM",
    "iso-a2": "TM",
    "woe-id": "23424972",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5898, 7794], [5921, 7785], [5915, 7802], [5943, 7825], [5981, 7807], [5987, 7775], [6043, 7761], [6057, 7726], [6151, 7665], [6179, 7658], [6178, 7635], [6156, 7642], [6126, 7626], [6117, 7598], [6052, 7560], [6022, 7576], [6020, 7608], [5995, 7610], [5949, 7646], [5906, 7656], [5902, 7666], [5849, 7660], [5804, 7634], [5806, 7688], [5794, 7724], [5769, 7728], [5775, 7760], [5798, 7748], [5828, 7765], [5803, 7799], [5792, 7800], [5792, 7800], [5812, 7808], [5851, 7770], [5865, 7773], [5896, 7770], [5898, 7794]]], [[[5780, 7795], [5782, 7800], [5792, 7800], [5792, 7800], [5780, 7795], [5780, 7795], [5780, 7795]]], [[[5780, 7795], [5771, 7775], [5760, 7788], [5780, 7795], [5780, 7795], [5780, 7795]]]]
  }
}, {
  type: "Feature",
  id: "ZM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.36,
    "hc-middle-y": 0.58,
    "hc-key": "zm",
    "hc-a2": "ZM",
    name: "Zambia",
    labelrank: "3",
    "country-abbrev": "Zambia",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "ZMB",
    "iso-a2": "ZM",
    "woe-id": "23425003",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5050, 6201], [5069, 6222], [5061, 6228], [5111, 6236], [5125, 6219], [5129, 6225], [5153, 6211], [5181, 6201], [5203, 6166], [5190, 6157], [5194, 6107], [5178, 6072], [5189, 6063], [5101, 6034], [5106, 6014], [5060, 6001], [5058, 5987], [5038, 5977], [5022, 5969], [5006, 5944], [4996, 5940], [4954, 5949], [4923, 5958], [4898, 5953], [4856, 5998], [4856, 6093], [4916, 6093], [4915, 6157], [4925, 6142], [4955, 6147], [4956, 6134], [4996, 6123], [5011, 6136], [5070, 6080], [5088, 6081], [5088, 6119], [5066, 6112], [5046, 6140], [5056, 6189], [5050, 6201]]]
  }
}, {
  type: "Feature",
  id: "NC",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.56,
    "hc-middle-y": 0.71,
    "hc-key": "nc",
    "hc-a2": "NC",
    name: "Northern Cyprus",
    labelrank: "6",
    "country-abbrev": "N. Cy.",
    subregion: "Western Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "-99",
    "iso-a2": "NC",
    "woe-id": "-90",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5210, 7558], [5206, 7556], [5203, 7556], [5196, 7562], [5175, 7561], [5175, 7561], [5175, 7561], [5175, 7561], [5175, 7561], [5175, 7561], [5231, 7579], [5213, 7557], [5210, 7558]]], [[[5171, 7561], [5173, 7562], [5172, 7561], [5171, 7561]]]]
  }
}, {
  type: "Feature",
  id: "MR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.61,
    "hc-middle-y": 0.63,
    "hc-key": "mr",
    "hc-a2": "MR",
    name: "Mauritania",
    labelrank: "3",
    "country-abbrev": "Mrt.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "MRT",
    "iso-a2": "MR",
    "woe-id": "23424896",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3946, 7304], [4040, 7245], [4061, 7231], [4008, 7231], [4040, 6939], [3886, 6937], [3856, 6941], [3840, 6917], [3779, 6974], [3719, 6968], [3713, 6949], [3728, 7014], [3714, 7058], [3723, 7083], [3698, 7100], [3701, 7117], [3818, 7117], [3818, 7170], [3847, 7183], [3847, 7263], [3946, 7263], [3946, 7304]]]
  }
}, {
  type: "Feature",
  id: "DZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.63,
    "hc-middle-y": 0.5,
    "hc-key": "dz",
    "hc-a2": "DZ",
    name: "Algeria",
    labelrank: "3",
    "country-abbrev": "Alg.",
    subregion: "Northern Africa",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "DZA",
    "iso-a2": "DZ",
    "woe-id": "23424740",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4061, 7231], [4040, 7245], [3946, 7304], [3946, 7316], [3946, 7348], [3977, 7371], [4033, 7378], [4096, 7414], [4095, 7444], [4129, 7460], [4167, 7459], [4173, 7473], [4154, 7497], [4151, 7547], [4138, 7558], [4235, 7605], [4291, 7616], [4346, 7619], [4359, 7611], [4423, 7626], [4459, 7621], [4452, 7604], [4448, 7543], [4426, 7518], [4451, 7473], [4472, 7458], [4486, 7398], [4496, 7363], [4496, 7279], [4483, 7267], [4502, 7227], [4546, 7209], [4559, 7185], [4426, 7103], [4376, 7059], [4329, 7050], [4296, 7050], [4299, 7070], [4260, 7083], [4238, 7110], [4061, 7231]]]
  }
}, {
  type: "Feature",
  id: "LT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.27,
    "hc-middle-y": 0.06,
    "hc-key": "lt",
    "hc-a2": "LT",
    name: "Lithuania",
    labelrank: "5",
    "country-abbrev": "Lith.",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "LTU",
    "iso-a2": "LT",
    "woe-id": "23424875",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4835, 8303], [4832, 8321], [4829, 8337], [4860, 8352], [4929, 8345], [4942, 8353], [4993, 8320], [4998, 8305], [4972, 8290], [4960, 8264], [4927, 8247], [4901, 8249], [4900, 8258], [4880, 8266], [4881, 8288], [4835, 8303]]], [[[4825, 8304], [4830, 8313], [4827, 8304], [4825, 8304]]]]
  }
}, {
  type: "Feature",
  id: "ET",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.58,
    "hc-key": "et",
    "hc-a2": "ET",
    name: "Ethiopia",
    labelrank: "2",
    "country-abbrev": "Eth.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "ETH",
    "iso-a2": "ET",
    "woe-id": "23424808",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5444, 6813], [5441, 6810], [5444, 6807], [5449, 6802], [5478, 6804], [5470, 6793], [5510, 6744], [5598, 6715], [5628, 6715], [5538, 6624], [5509, 6625], [5447, 6596], [5414, 6605], [5377, 6579], [5335, 6585], [5297, 6609], [5270, 6615], [5235, 6675], [5205, 6705], [5185, 6709], [5190, 6729], [5211, 6728], [5215, 6758], [5230, 6801], [5238, 6796], [5263, 6854], [5276, 6855], [5288, 6902], [5328, 6921], [5416, 6897], [5462, 6848], [5443, 6820], [5444, 6813]]]
  }
}, {
  type: "Feature",
  id: "ER",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.29,
    "hc-middle-y": 0.05,
    "hc-key": "er",
    "hc-a2": "ER",
    name: "Eritrea",
    labelrank: "4",
    "country-abbrev": "Erit.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "ERI",
    "iso-a2": "ER",
    "woe-id": "23424806",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5462, 6848], [5416, 6897], [5328, 6921], [5288, 6902], [5285, 6928], [5302, 6987], [5350, 7015], [5382, 6928], [5426, 6913], [5484, 6855], [5471, 6845], [5462, 6848]]]
  }
}, {
  type: "Feature",
  id: "GH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.13,
    "hc-middle-y": 0.77,
    "hc-key": "gh",
    "hc-a2": "GH",
    name: "Ghana",
    labelrank: "3",
    "country-abbrev": "Ghana",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "GHA",
    "iso-a2": "GH",
    "woe-id": "23424824",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4239, 6659], [4142, 6618], [4111, 6629], [4112, 6629], [4116, 6629], [4120, 6631], [4108, 6681], [4130, 6721], [4124, 6759], [4122, 6804], [4199, 6808], [4215, 6781], [4219, 6681], [4239, 6659]]]
  }
}, {
  type: "Feature",
  id: "SI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.57,
    "hc-key": "si",
    "hc-a2": "SI",
    name: "Slovenia",
    labelrank: "6",
    "country-abbrev": "Slo.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "SVN",
    "iso-a2": "SI",
    "woe-id": "23424945",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4607, 7923], [4607, 7925], [4611, 7927], [4601, 7952], [4611, 7961], [4635, 7956], [4682, 7974], [4687, 7974], [4694, 7960], [4668, 7949], [4659, 7921], [4607, 7923]]]
  }
}, {
  type: "Feature",
  id: "GT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.44,
    "hc-middle-y": 0.87,
    "hc-key": "gt",
    "hc-a2": "GT",
    name: "Guatemala",
    labelrank: "3",
    "country-abbrev": "Guat.",
    subregion: "Central America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "GTM",
    "iso-a2": "GT",
    "woe-id": "23424834",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1565, 6951], [1574, 6947], [1586, 6946], [1558, 6926], [1552, 6907], [1530, 6889], [1530, 6886], [1494, 6893], [1466, 6911], [1482, 6956], [1522, 6966], [1491, 6992], [1504, 7009], [1558, 7009], [1556, 6951], [1565, 6951]]]
  }
}, {
  type: "Feature",
  id: "BA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.48,
    "hc-key": "ba",
    "hc-a2": "BA",
    name: "Bosnia and Herzegovina",
    labelrank: "5",
    "country-abbrev": "B.H.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "BIH",
    "iso-a2": "BA",
    "woe-id": "23424761",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4728, 7828], [4725, 7830], [4726, 7830], [4685, 7876], [4672, 7911], [4706, 7915], [4768, 7900], [4779, 7901], [4774, 7851], [4752, 7832], [4751, 7816], [4734, 7826], [4728, 7828]]]
  }
}, {
  type: "Feature",
  id: "JO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.85,
    "hc-key": "jo",
    "hc-a2": "JO",
    name: "Jordan",
    labelrank: "4",
    "country-abbrev": "Jord.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "JOR",
    "iso-a2": "JO",
    "woe-id": "23424860",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5255, 7426], [5258, 7429], [5255, 7431], [5254, 7432], [5255, 7434], [5259, 7434], [5259, 7448], [5259, 7477], [5265, 7480], [5296, 7466], [5355, 7501], [5363, 7472], [5366, 7460], [5301, 7439], [5331, 7407], [5274, 7365], [5241, 7370], [5243, 7376], [5241, 7377], [5247, 7405], [5255, 7426]]]
  }
}, {
  type: "Feature",
  id: "SY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.25,
    "hc-middle-y": 0.54,
    "hc-key": "sy",
    "hc-a2": "SY",
    name: "Syria",
    labelrank: "3",
    "country-abbrev": "Syria",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "SYR",
    "iso-a2": "SY",
    "woe-id": "23424956",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5355, 7501], [5296, 7466], [5265, 7480], [5269, 7487], [5267, 7502], [5290, 7529], [5271, 7544], [5270, 7569], [5270, 7586], [5291, 7617], [5338, 7620], [5384, 7614], [5457, 7634], [5461, 7627], [5432, 7606], [5427, 7548], [5412, 7533], [5355, 7501]]]
  }
}, {
  type: "Feature",
  id: "MC",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.67,
    "hc-key": "mc",
    "hc-a2": "MC",
    name: "Monaco",
    labelrank: "6",
    "country-abbrev": "Mco.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "MCO",
    "iso-a2": "MC",
    "woe-id": "23424892",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4425, 7859], [4424, 7858], [4423, 7858], [4424, 7860], [4425, 7859]]]
  }
}, {
  type: "Feature",
  id: "AL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.39,
    "hc-middle-y": 0.49,
    "hc-key": "al",
    "hc-a2": "AL",
    name: "Albania",
    labelrank: "6",
    "country-abbrev": "Alb.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "ALB",
    "iso-a2": "AL",
    "woe-id": "23424742",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4826, 7757], [4826, 7757], [4825, 7758], [4826, 7757]]], [[[4779, 7800], [4779, 7805], [4780, 7808], [4789, 7820], [4799, 7816], [4812, 7804], [4814, 7792], [4811, 7781], [4816, 7764], [4817, 7758], [4819, 7758], [4822, 7758], [4825, 7758], [4825, 7757], [4826, 7756], [4826, 7756], [4824, 7753], [4826, 7754], [4826, 7753], [4828, 7750], [4827, 7750], [4828, 7750], [4809, 7720], [4798, 7715], [4777, 7749], [4779, 7791], [4778, 7795], [4779, 7800]]], [[[4779, 7807], [4779, 7807], [4779, 7806], [4779, 7807]]]]
  }
}, {
  type: "Feature",
  id: "UY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.81,
    "hc-middle-y": 0.63,
    "hc-key": "uy",
    "hc-a2": "UY",
    name: "Uruguay",
    labelrank: "4",
    "country-abbrev": "Ury.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "URY",
    "iso-a2": "UY",
    "woe-id": "23424979",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2626, 5480], [2612, 5465], [2615, 5450], [2615, 5447], [2620, 5444], [2608, 5422], [2573, 5404], [2537, 5404], [2487, 5420], [2471, 5437], [2477, 5487], [2477, 5505], [2494, 5561], [2517, 5563], [2542, 5531], [2554, 5539], [2626, 5480]]]
  }
}, {
  type: "Feature",
  id: "CNM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.39,
    "hc-middle-y": 0.11,
    "hc-key": "cnm",
    "hc-a2": "CN",
    name: "Cyprus No Mans Area",
    labelrank: "9",
    "country-abbrev": null,
    subregion: "Western Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "-99",
    "iso-a2": null,
    "woe-id": "-99",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[5213, 7557], [5214, 7557], [5213, 7557], [5210, 7557], [5210, 7558], [5213, 7557]]], [[[5171, 7561], [5171, 7561], [5172, 7561], [5173, 7562], [5173, 7562], [5172, 7560], [5171, 7561]]], [[[5175, 7561], [5174, 7561], [5175, 7561], [5175, 7561], [5175, 7561], [5175, 7561]]], [[[5203, 7556], [5205, 7555], [5204, 7555], [5196, 7561], [5175, 7561], [5175, 7561], [5196, 7562], [5203, 7556]]]]
  }
}, {
  type: "Feature",
  id: "MN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.53,
    "hc-key": "mn",
    "hc-a2": "MN",
    name: "Mongolia",
    labelrank: "3",
    "country-abbrev": "Mong.",
    subregion: "Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "MNG",
    "iso-a2": "MN",
    "woe-id": "23424887",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7691, 8008], [7702, 8011], [7698, 8015], [7722, 8015], [7762, 7975], [7756, 7963], [7714, 7968], [7664, 7953], [7637, 7921], [7603, 7919], [7575, 7895], [7528, 7908], [7511, 7885], [7526, 7857], [7453, 7813], [7372, 7807], [7326, 7787], [7282, 7788], [7232, 7803], [7220, 7815], [7064, 7822], [7034, 7879], [6979, 7903], [6901, 7912], [6906, 7963], [6885, 8003], [6847, 8016], [6814, 8039], [6810, 8061], [6945, 8127], [7001, 8115], [7011, 8094], [7093, 8083], [7121, 8113], [7106, 8132], [7139, 8176], [7237, 8144], [7239, 8117], [7280, 8098], [7330, 8111], [7407, 8090], [7425, 8067], [7490, 8060], [7559, 8077], [7596, 8104], [7628, 8089], [7667, 8086], [7632, 8021], [7642, 8005], [7691, 8008]]]
  }
}, {
  type: "Feature",
  id: "RW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.56,
    "hc-key": "rw",
    "hc-a2": "RW",
    name: "Rwanda",
    labelrank: "3",
    "country-abbrev": "Rwa.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "RWA",
    "iso-a2": "RW",
    "woe-id": "23424937",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5065, 6398], [5061, 6400], [5061, 6406], [5075, 6419], [5071, 6429], [5075, 6434], [5082, 6438], [5092, 6435], [5108, 6447], [5119, 6432], [5111, 6408], [5091, 6400], [5065, 6398]]]
  }
}, {
  type: "Feature",
  id: "SO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.39,
    "hc-middle-y": 0.74,
    "hc-key": "so",
    "hc-a2": "SO",
    name: "Somalia",
    labelrank: "6",
    "country-abbrev": "Som.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "SOM",
    "iso-a2": "SO",
    "woe-id": "-90",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5447, 6596], [5509, 6625], [5538, 6624], [5628, 6715], [5656, 6758], [5656, 6812], [5726, 6829], [5713, 6758], [5627, 6610], [5570, 6551], [5494, 6497], [5437, 6429], [5420, 6453], [5420, 6562], [5447, 6596]]]
  }
}, {
  type: "Feature",
  id: "BO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.59,
    "hc-key": "bo",
    "hc-a2": "BO",
    name: "Bolivia",
    labelrank: "3",
    "country-abbrev": "Bolivia",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "BOL",
    "iso-a2": "BO",
    "woe-id": "23424762",
    continent: "South America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[2153, 5996], [2153, 6001], [2157, 5996], [2155, 5997], [2153, 5996]]], [[[2141, 5957], [2137, 5964], [2155, 5986], [2169, 5993], [2145, 6017], [2160, 6058], [2153, 6073], [2166, 6108], [2139, 6155], [2177, 6154], [2226, 6186], [2262, 6192], [2263, 6149], [2293, 6110], [2332, 6104], [2369, 6077], [2409, 6069], [2419, 5995], [2469, 5993], [2471, 5965], [2496, 5937], [2478, 5876], [2450, 5903], [2371, 5892], [2356, 5864], [2345, 5812], [2307, 5819], [2295, 5792], [2287, 5813], [2238, 5826], [2210, 5794], [2189, 5794], [2180, 5842], [2163, 5868], [2173, 5898], [2157, 5913], [2141, 5957]]]]
  }
}, {
  type: "Feature",
  id: "CM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.81,
    "hc-key": "cm",
    "hc-a2": "CM",
    name: "Cameroon",
    labelrank: "3",
    "country-abbrev": "Cam.",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "CMR",
    "iso-a2": "CM",
    "woe-id": "23424785",
    continent: "Africa"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4599, 6542], [4541, 6547], [4540, 6543], [4500, 6543], [4495, 6548], [4490, 6593], [4459, 6621], [4466, 6651], [4518, 6689], [4540, 6669], [4567, 6725], [4639, 6839], [4621, 6866], [4629, 6866], [4627, 6861], [4634, 6863], [4653, 6820], [4651, 6798], [4669, 6774], [4625, 6774], [4618, 6764], [4655, 6729], [4663, 6701], [4631, 6657], [4654, 6590], [4682, 6562], [4685, 6545], [4684, 6530], [4636, 6544], [4599, 6542]]], [[[4631, 6866], [4631, 6866], [4630, 6866], [4631, 6866]]]]
  }
}, {
  type: "Feature",
  id: "CG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.15,
    "hc-middle-y": 0.78,
    "hc-key": "cg",
    "hc-a2": "CG",
    name: "Republic of Congo",
    labelrank: "4",
    "country-abbrev": "Rep. Congo",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "COG",
    "iso-a2": "CG",
    "woe-id": "23424779",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4599, 6542], [4636, 6544], [4684, 6530], [4685, 6545], [4696, 6581], [4722, 6588], [4757, 6581], [4740, 6542], [4731, 6463], [4686, 6416], [4685, 6381], [4644, 6337], [4631, 6353], [4592, 6342], [4583, 6349], [4560, 6331], [4554, 6344], [4534, 6363], [4555, 6369], [4547, 6410], [4573, 6423], [4622, 6405], [4634, 6461], [4614, 6473], [4633, 6506], [4597, 6515], [4599, 6542]]]
  }
}, {
  type: "Feature",
  id: "EH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.41,
    "hc-middle-y": 0.71,
    "hc-key": "eh",
    "hc-a2": "EH",
    name: "Western Sahara",
    labelrank: "7",
    "country-abbrev": "W. Sah.",
    subregion: "Northern Africa",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "ESH",
    "iso-a2": "EH",
    "woe-id": "23424990",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3698, 7100], [3696, 7103], [3699, 7120], [3764, 7121], [3782, 7148], [3788, 7182], [3835, 7226], [3847, 7264], [3866, 7291], [3915, 7290], [3943, 7298], [3946, 7316], [3946, 7304], [3946, 7263], [3847, 7263], [3847, 7183], [3818, 7170], [3818, 7117], [3701, 7117], [3698, 7100]]]
  }
}, {
  type: "Feature",
  id: "RS",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.42,
    "hc-middle-y": 0.52,
    "hc-key": "rs",
    "hc-a2": "RS",
    name: "Republic of Serbia",
    labelrank: "5",
    "country-abbrev": "Serb.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "SRB",
    "iso-a2": "RS",
    "woe-id": "-90",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4774, 7851], [4779, 7901], [4768, 7900], [4769, 7910], [4765, 7939], [4784, 7948], [4805, 7946], [4842, 7910], [4839, 7897], [4877, 7877], [4867, 7861], [4885, 7836], [4867, 7808], [4855, 7808], [4844, 7805], [4850, 7820], [4820, 7842], [4808, 7826], [4786, 7839], [4774, 7851]]]
  }
}, {
  type: "Feature",
  id: "ME",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.42,
    "hc-middle-y": 0.47,
    "hc-key": "me",
    "hc-a2": "ME",
    name: "Montenegro",
    labelrank: "6",
    "country-abbrev": "Mont.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "MNE",
    "iso-a2": "ME",
    "woe-id": "20069817",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4774, 7851], [4786, 7839], [4808, 7826], [4798, 7822], [4799, 7816], [4789, 7820], [4780, 7808], [4779, 7807], [4779, 7806], [4772, 7806], [4779, 7800], [4778, 7795], [4779, 7791], [4761, 7806], [4753, 7811], [4751, 7814], [4751, 7816], [4752, 7832], [4774, 7851]]]
  }
}, {
  type: "Feature",
  id: "TG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.76,
    "hc-middle-y": 0.81,
    "hc-key": "tg",
    "hc-a2": "TG",
    name: "Togo",
    labelrank: "6",
    "country-abbrev": "Togo",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "TGO",
    "iso-a2": "TG",
    "woe-id": "23424965",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4231, 6804], [4252, 6746], [4252, 6662], [4246, 6661], [4239, 6659], [4219, 6681], [4215, 6781], [4199, 6808], [4218, 6804], [4231, 6804]]]
  }
}, {
  type: "Feature",
  id: "LA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.88,
    "hc-middle-y": 0.79,
    "hc-key": "la",
    "hc-a2": "LA",
    name: "Laos",
    labelrank: "4",
    "country-abbrev": "Laos",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "LAO",
    "iso-a2": "LA",
    "woe-id": "23424872",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[7395, 6915], [7374, 6904], [7325, 6904], [7338, 6946], [7313, 6970], [7315, 6996], [7290, 7025], [7272, 7029], [7249, 7010], [7233, 7022], [7205, 6999], [7209, 7061], [7186, 7062], [7175, 7086], [7193, 7117], [7206, 7124], [7222, 7111], [7217, 7146], [7234, 7150], [7260, 7125], [7264, 7103], [7292, 7106], [7319, 7079], [7286, 7055], [7311, 7039], [7365, 6984], [7399, 6932], [7395, 6915]]]
  }
}, {
  type: "Feature",
  id: "AF",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.37,
    "hc-middle-y": 0.52,
    "hc-key": "af",
    "hc-a2": "AF",
    name: "Afghanistan",
    labelrank: "3",
    "country-abbrev": "Afg.",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "AFG",
    "iso-a2": "AF",
    "woe-id": "23424739",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6426, 7631], [6411, 7627], [6416, 7624], [6357, 7617], [6316, 7590], [6330, 7562], [6313, 7524], [6281, 7523], [6290, 7499], [6268, 7491], [6261, 7454], [6226, 7450], [6173, 7421], [6168, 7385], [6106, 7371], [6058, 7372], [6010, 7386], [6038, 7418], [6035, 7435], [6009, 7439], [6001, 7491], [6022, 7576], [6052, 7560], [6117, 7598], [6126, 7626], [6156, 7642], [6178, 7635], [6200, 7629], [6215, 7629], [6259, 7626], [6285, 7641], [6299, 7669], [6329, 7653], [6329, 7613], [6379, 7639], [6426, 7631]]]
  }
}, {
  type: "Feature",
  id: "UA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.7,
    "hc-middle-y": 0.46,
    "hc-key": "ua",
    "hc-a2": "UA",
    name: "Ukraine",
    labelrank: "3",
    "country-abbrev": "Ukr.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "UKR",
    "iso-a2": "UA",
    "woe-id": "23424976",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4861, 8032], [4866, 8042], [4873, 8057], [4876, 8075], [4919, 8114], [4905, 8152], [4928, 8166], [4969, 8168], [5013, 8155], [5074, 8146], [5110, 8154], [5122, 8174], [5147, 8175], [5207, 8185], [5225, 8161], [5218, 8142], [5245, 8140], [5262, 8106], [5315, 8109], [5367, 8087], [5395, 8064], [5382, 8045], [5384, 8010], [5356, 8011], [5338, 7983], [5269, 7966], [5237, 7948], [5260, 7909], [5212, 7882], [5179, 7928], [5206, 7939], [5146, 7950], [5163, 7959], [5129, 7965], [5089, 7927], [5084, 7913], [5059, 7914], [5041, 7922], [5063, 7958], [5097, 7955], [5068, 7999], [5072, 8011], [5028, 8033], [4994, 8026], [4954, 8013], [4883, 8014], [4875, 8020], [4861, 8032]], [[5098, 7955], [5107, 7945], [5109, 7947], [5100, 7956], [5098, 7955]], [[5213, 7945], [5242, 7929], [5237, 7943], [5218, 7952], [5213, 7945]]]
  }
}, {
  type: "Feature",
  id: "SK",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.21,
    "hc-middle-y": 0.52,
    "hc-key": "sk",
    "hc-a2": "SK",
    name: "Slovakia",
    labelrank: "6",
    "country-abbrev": "Svk.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "SVK",
    "iso-a2": "SK",
    "woe-id": "23424877",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4873, 8057], [4866, 8042], [4861, 8032], [4812, 8036], [4795, 8021], [4733, 8007], [4713, 8017], [4704, 8030], [4707, 8039], [4741, 8058], [4763, 8074], [4852, 8069], [4873, 8057]]]
  }
}, {
  type: "Feature",
  id: "JK",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.4,
    "hc-middle-y": 0.63,
    "hc-key": "jk",
    "hc-a2": "JK",
    name: "Siachen Glacier",
    labelrank: "5",
    "country-abbrev": "Siachen",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "-99",
    "iso-a2": "JK",
    "woe-id": "23424928",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6513, 7572], [6490, 7559], [6482, 7577], [6500, 7571], [6513, 7572]]]
  }
}, {
  type: "Feature",
  id: "BG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.76,
    "hc-middle-y": 0.51,
    "hc-key": "bg",
    "hc-a2": "BG",
    name: "Bulgaria",
    labelrank: "4",
    "country-abbrev": "Bulg.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "BGR",
    "iso-a2": "BG",
    "woe-id": "23424771",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5052, 7859], [5026, 7812], [5035, 7796], [5007, 7799], [4985, 7786], [4953, 7770], [4931, 7781], [4884, 7773], [4887, 7787], [4867, 7808], [4885, 7836], [4867, 7861], [4877, 7877], [4896, 7864], [4957, 7856], [5006, 7875], [5052, 7859]]]
  }
}, {
  type: "Feature",
  id: "QA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.36,
    "hc-middle-y": 0.46,
    "hc-key": "qa",
    "hc-a2": "QA",
    name: "Qatar",
    labelrank: "5",
    "country-abbrev": "Qatar",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "QAT",
    "iso-a2": "QA",
    "woe-id": "23424930",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5712, 7224], [5710, 7247], [5735, 7259], [5724, 7220], [5717, 7218], [5712, 7224]]]
  }
}, {
  type: "Feature",
  id: "LI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.61,
    "hc-middle-y": 0.53,
    "hc-key": "li",
    "hc-a2": "LI",
    name: "Liechtenstein",
    labelrank: "6",
    "country-abbrev": "Liech.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "LIE",
    "iso-a2": "LI",
    "woe-id": "23424879",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4487, 7989], [4489, 7983], [4488, 7981], [4485, 7981], [4487, 7989]]]
  }
}, {
  type: "Feature",
  id: "AT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.62,
    "hc-key": "at",
    "hc-a2": "AT",
    name: "Austria",
    labelrank: "4",
    "country-abbrev": "Aust.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "AUT",
    "iso-a2": "AT",
    "woe-id": "23424750",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4488, 7981], [4489, 7983], [4487, 7989], [4490, 7994], [4488, 7998], [4491, 7997], [4492, 7999], [4530, 7993], [4565, 8005], [4591, 7997], [4582, 8021], [4614, 8045], [4640, 8039], [4648, 8053], [4707, 8039], [4704, 8030], [4713, 8017], [4696, 8007], [4682, 7974], [4635, 7956], [4611, 7961], [4572, 7967], [4566, 7982], [4514, 7974], [4504, 7973], [4488, 7981]]]
  }
}, {
  type: "Feature",
  id: "SZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.51,
    "hc-middle-y": 0.45,
    "hc-key": "sz",
    "hc-a2": "SZ",
    name: "Swaziland",
    labelrank: "4",
    "country-abbrev": "Swz.",
    subregion: "Southern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "SWZ",
    "iso-a2": "SZ",
    "woe-id": "23424993",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5152, 5696], [5155, 5685], [5157, 5668], [5128, 5656], [5118, 5682], [5137, 5702], [5152, 5696]]]
  }
}, {
  type: "Feature",
  id: "HU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.27,
    "hc-middle-y": 0.61,
    "hc-key": "hu",
    "hc-a2": "HU",
    name: "Hungary",
    labelrank: "5",
    "country-abbrev": "Hun.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "HUN",
    "iso-a2": "HU",
    "woe-id": "23424844",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4861, 8032], [4875, 8020], [4883, 8014], [4857, 7997], [4831, 7952], [4805, 7946], [4784, 7948], [4765, 7939], [4719, 7940], [4694, 7960], [4687, 7974], [4682, 7974], [4696, 8007], [4713, 8017], [4733, 8007], [4795, 8021], [4812, 8036], [4861, 8032]]]
  }
}, {
  type: "Feature",
  id: "RO",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.67,
    "hc-middle-y": 0.5,
    "hc-key": "ro",
    "hc-a2": "RO",
    name: "Romania",
    labelrank: "3",
    "country-abbrev": "Rom.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "ROU",
    "iso-a2": "RO",
    "woe-id": "23424933",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4877, 7877], [4839, 7897], [4842, 7910], [4805, 7946], [4831, 7952], [4857, 7997], [4883, 8014], [4954, 8013], [4994, 8026], [5005, 8023], [5042, 7965], [5041, 7922], [5059, 7914], [5084, 7913], [5054, 7880], [5052, 7859], [5006, 7875], [4957, 7856], [4896, 7864], [4877, 7877]]]
  }
}, {
  type: "Feature",
  id: "NE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.64,
    "hc-middle-y": 0.53,
    "hc-key": "ne",
    "hc-a2": "NE",
    name: "Niger",
    labelrank: "3",
    "country-abbrev": "Niger",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "NER",
    "iso-a2": "NE",
    "woe-id": "23424906",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4311, 6825], [4288, 6846], [4275, 6831], [4269, 6852], [4233, 6865], [4210, 6922], [4243, 6933], [4308, 6935], [4328, 6967], [4329, 7050], [4376, 7059], [4426, 7103], [4559, 7185], [4604, 7175], [4626, 7157], [4649, 7169], [4655, 7122], [4678, 7087], [4671, 7073], [4663, 6982], [4603, 6906], [4608, 6885], [4574, 6866], [4543, 6875], [4504, 6872], [4490, 6859], [4436, 6874], [4410, 6864], [4368, 6891], [4326, 6878], [4311, 6825]]]
  }
}, {
  type: "Feature",
  id: "LU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.6,
    "hc-key": "lu",
    "hc-a2": "LU",
    name: "Luxembourg",
    labelrank: "6",
    "country-abbrev": "Lux.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "LUX",
    "iso-a2": "LU",
    "woe-id": "23424881",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4392, 8072], [4381, 8071], [4376, 8075], [4374, 8088], [4386, 8097], [4397, 8085], [4392, 8072]]]
  }
}, {
  type: "Feature",
  id: "AD",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.58,
    "hc-middle-y": 0.28,
    "hc-key": "ad",
    "hc-a2": "AD",
    name: "Andorra",
    labelrank: "6",
    "country-abbrev": "And.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "AND",
    "iso-a2": "AD",
    "woe-id": "23424744",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4246, 7818], [4255, 7818], [4255, 7814], [4249, 7812], [4246, 7818]]]
  }
}, {
  type: "Feature",
  id: "CI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.48,
    "hc-key": "ci",
    "hc-a2": "CI",
    name: "Ivory Coast",
    labelrank: "3",
    "country-abbrev": "I.C.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "CIV",
    "iso-a2": "CI",
    "woe-id": "23424854",
    continent: "Africa"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4124, 6759], [4130, 6721], [4108, 6681], [4120, 6631], [4030, 6627], [3980, 6607], [3982, 6650], [3948, 6670], [3952, 6702], [3971, 6757], [3967, 6779], [4019, 6782], [4040, 6787], [4065, 6765], [4109, 6772], [4124, 6759]]], [[[4111, 6629], [4107, 6630], [4112, 6629], [4111, 6629]]]]
  }
}, {
  type: "Feature",
  id: "LR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.96,
    "hc-middle-y": 0.75,
    "hc-key": "lr",
    "hc-a2": "LR",
    name: "Liberia",
    labelrank: "4",
    "country-abbrev": "Liberia",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "LBR",
    "iso-a2": "LR",
    "woe-id": "23424876",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3952, 6702], [3948, 6670], [3982, 6650], [3980, 6607], [3929, 6631], [3863, 6683], [3889, 6708], [3899, 6729], [3922, 6725], [3933, 6691], [3952, 6702]]]
  }
}, {
  type: "Feature",
  id: "BN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.32,
    "hc-middle-y": 0.34,
    "hc-key": "bn",
    "hc-a2": "BN",
    name: "Brunei",
    labelrank: "6",
    "country-abbrev": "Brunei",
    subregion: "South-Eastern Asia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "BRN",
    "iso-a2": "BN",
    "woe-id": "23424773",
    continent: "Asia"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[7618, 6621], [7621, 6622], [7621, 6623], [7627, 6606], [7618, 6621]]], [[[7587, 6614], [7603, 6617], [7616, 6623], [7606, 6597], [7587, 6614]]]]
  }
}, {
  type: "Feature",
  id: "IQ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.46,
    "hc-middle-y": 0.44,
    "hc-key": "iq",
    "hc-a2": "IQ",
    name: "Iraq",
    labelrank: "3",
    "country-abbrev": "Iraq",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "IRQ",
    "iso-a2": "IQ",
    "woe-id": "23424855",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5644, 7390], [5632, 7392], [5627, 7391], [5602, 7390], [5585, 7362], [5530, 7365], [5453, 7426], [5404, 7453], [5366, 7460], [5363, 7472], [5355, 7501], [5412, 7533], [5427, 7548], [5432, 7606], [5461, 7627], [5472, 7635], [5532, 7628], [5549, 7589], [5579, 7582], [5551, 7521], [5577, 7487], [5611, 7469], [5623, 7448], [5619, 7423], [5644, 7390]]]
  }
}, {
  type: "Feature",
  id: "GE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.99,
    "hc-middle-y": 0.82,
    "hc-key": "ge",
    "hc-a2": "GE",
    name: "Georgia",
    labelrank: "5",
    "country-abbrev": "Geo.",
    subregion: "Western Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "GEO",
    "iso-a2": "GE",
    "woe-id": "23424823",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5539, 7771], [5515, 7769], [5493, 7765], [5474, 7782], [5436, 7779], [5436, 7819], [5391, 7846], [5475, 7838], [5508, 7816], [5534, 7823], [5582, 7793], [5584, 7763], [5539, 7771]]]
  }
}, {
  type: "Feature",
  id: "GM",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.51,
    "hc-middle-y": 0.51,
    "hc-key": "gm",
    "hc-a2": "GM",
    name: "Gambia",
    labelrank: "6",
    "country-abbrev": "Gambia",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "GMB",
    "iso-a2": "GM",
    "woe-id": "23424821",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3707, 6866], [3705, 6874], [3713, 6882], [3762, 6888], [3734, 6869], [3707, 6866]]]
  }
}, {
  type: "Feature",
  id: "CH",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.12,
    "hc-middle-y": 0.55,
    "hc-key": "ch",
    "hc-a2": "CH",
    name: "Switzerland",
    labelrank: "4",
    "country-abbrev": "Switz.",
    subregion: "Western Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "CHE",
    "iso-a2": "CH",
    "woe-id": "23424957",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4477, 8004], [4477, 8004], [4477, 8003], [4477, 8003], [4486, 7997], [4488, 7998], [4490, 7994], [4487, 7989], [4485, 7981], [4488, 7981], [4504, 7973], [4514, 7974], [4500, 7955], [4466, 7944], [4444, 7951], [4412, 7939], [4405, 7947], [4405, 7957], [4400, 7961], [4393, 7956], [4389, 7952], [4386, 7963], [4429, 8001], [4455, 8001], [4477, 8004]]]
  }
}, {
  type: "Feature",
  id: "TD",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.47,
    "hc-middle-y": 0.63,
    "hc-key": "td",
    "hc-a2": "TD",
    name: "Chad",
    labelrank: "3",
    "country-abbrev": "Chad",
    subregion: "Middle Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "TCD",
    "iso-a2": "TD",
    "woe-id": "23424777",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4634, 6863], [4642, 6866], [4631, 6866], [4630, 6866], [4628, 6868], [4629, 6866], [4621, 6866], [4608, 6885], [4603, 6906], [4663, 6982], [4671, 7073], [4678, 7087], [4655, 7122], [4649, 7169], [4678, 7183], [4916, 7061], [4916, 6946], [4889, 6945], [4873, 6898], [4859, 6887], [4863, 6856], [4882, 6802], [4870, 6804], [4810, 6749], [4771, 6745], [4756, 6716], [4702, 6702], [4663, 6701], [4655, 6729], [4618, 6764], [4625, 6774], [4669, 6774], [4651, 6798], [4653, 6820], [4634, 6863]]]
  }
}, {
  type: "Feature",
  id: "KV",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.52,
    "hc-key": "kv",
    "hc-a2": "KV",
    name: "Kosovo",
    labelrank: "6",
    "country-abbrev": "Kos.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "-99",
    "iso-a2": "KV",
    "woe-id": "-90",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4814, 7792], [4812, 7804], [4799, 7816], [4798, 7822], [4808, 7826], [4820, 7842], [4850, 7820], [4844, 7805], [4830, 7804], [4814, 7792]]]
  }
}, {
  type: "Feature",
  id: "LB",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.39,
    "hc-middle-y": 0.57,
    "hc-key": "lb",
    "hc-a2": "LB",
    name: "Lebanon",
    labelrank: "5",
    "country-abbrev": "Leb.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "LBN",
    "iso-a2": "LB",
    "woe-id": "23424873",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5246, 7492], [5260, 7519], [5271, 7544], [5290, 7529], [5267, 7502], [5257, 7492], [5246, 7492]]]
  }
}, {
  type: "Feature",
  id: "DJ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.56,
    "hc-middle-y": 0.55,
    "hc-key": "dj",
    "hc-a2": "DJ",
    name: "Djibouti",
    labelrank: "5",
    "country-abbrev": "Dji.",
    subregion: "Eastern Africa",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "DJI",
    "iso-a2": "DJ",
    "woe-id": "23424797",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5478, 6804], [5449, 6802], [5444, 6807], [5447, 6810], [5444, 6813], [5443, 6820], [5462, 6848], [5471, 6845], [5484, 6855], [5490, 6834], [5487, 6819], [5478, 6804]]]
  }
}, {
  type: "Feature",
  id: "BI",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.57,
    "hc-middle-y": 0.47,
    "hc-key": "bi",
    "hc-a2": "BI",
    name: "Burundi",
    labelrank: "6",
    "country-abbrev": "Bur.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "BDI",
    "iso-a2": "BI",
    "woe-id": "23424774",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5084, 6347], [5076, 6364], [5071, 6380], [5072, 6389], [5065, 6398], [5091, 6400], [5111, 6408], [5118, 6383], [5084, 6347]]]
  }
}, {
  type: "Feature",
  id: "SR",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.91,
    "hc-middle-y": 0.09,
    "hc-key": "sr",
    "hc-a2": "SR",
    name: "Suriname",
    labelrank: "4",
    "country-abbrev": "Sur.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "SUR",
    "iso-a2": "SR",
    "woe-id": "23424913",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2583, 6547], [2543, 6553], [2528, 6536], [2481, 6602], [2505, 6641], [2514, 6656], [2601, 6651], [2596, 6636], [2587, 6623], [2601, 6581], [2583, 6547]]]
  }
}, {
  type: "Feature",
  id: "IL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.68,
    "hc-middle-y": 0.1,
    "hc-key": "il",
    "hc-a2": "IL",
    name: "Israel",
    labelrank: "4",
    "country-abbrev": "Isr.",
    subregion: "Western Asia",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "ISR",
    "iso-a2": "IL",
    "woe-id": "23424852",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5219, 7433], [5238, 7465], [5246, 7492], [5257, 7492], [5267, 7502], [5269, 7487], [5265, 7480], [5259, 7477], [5259, 7448], [5254, 7440], [5255, 7434], [5254, 7432], [5255, 7431], [5253, 7429], [5255, 7426], [5247, 7405], [5241, 7377], [5240, 7374], [5239, 7374], [5237, 7382], [5219, 7433]]]
  }
}, {
  type: "Feature",
  id: "ML",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.59,
    "hc-middle-y": 0.38,
    "hc-key": "ml",
    "hc-a2": "ML",
    name: "Mali",
    labelrank: "3",
    "country-abbrev": "Mali",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "MLI",
    "iso-a2": "ML",
    "woe-id": "23424891",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4040, 6787], [4019, 6782], [3967, 6779], [3955, 6815], [3931, 6848], [3886, 6831], [3866, 6846], [3845, 6885], [3840, 6917], [3856, 6941], [3886, 6937], [4040, 6939], [4008, 7231], [4061, 7231], [4238, 7110], [4260, 7083], [4299, 7070], [4296, 7050], [4329, 7050], [4328, 6967], [4308, 6935], [4243, 6933], [4210, 6922], [4183, 6927], [4141, 6899], [4120, 6895], [4099, 6869], [4083, 6876], [4069, 6839], [4051, 6832], [4040, 6787]]]
  }
}, {
  type: "Feature",
  id: "SN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.2,
    "hc-middle-y": 0.55,
    "hc-key": "sn",
    "hc-a2": "SN",
    name: "Senegal",
    labelrank: "3",
    "country-abbrev": "Sen.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "SEN",
    "iso-a2": "SN",
    "woe-id": "23424943",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3708, 6844], [3705, 6859], [3707, 6866], [3734, 6869], [3762, 6888], [3713, 6882], [3695, 6922], [3713, 6949], [3719, 6968], [3779, 6974], [3840, 6917], [3845, 6885], [3866, 6846], [3837, 6843], [3797, 6854], [3753, 6854], [3708, 6844]]]
  }
}, {
  type: "Feature",
  id: "GN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.24,
    "hc-middle-y": 0.51,
    "hc-key": "gn",
    "hc-a2": "GN",
    name: "Guinea",
    labelrank: "3",
    "country-abbrev": "Gin.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "GIN",
    "iso-a2": "GN",
    "woe-id": "23424835",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3866, 6846], [3886, 6831], [3931, 6848], [3955, 6815], [3967, 6779], [3971, 6757], [3952, 6702], [3933, 6691], [3922, 6725], [3899, 6729], [3870, 6774], [3833, 6770], [3809, 6746], [3793, 6770], [3758, 6803], [3767, 6819], [3797, 6825], [3797, 6854], [3837, 6843], [3866, 6846]]]
  }
}, {
  type: "Feature",
  id: "ZW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.81,
    "hc-middle-y": 0.42,
    "hc-key": "zw",
    "hc-a2": "ZW",
    name: "Zimbabwe",
    labelrank: "3",
    "country-abbrev": "Zimb.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "ZWE",
    "iso-a2": "ZW",
    "woe-id": "23425004",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4954, 5949], [4996, 5940], [5006, 5944], [5038, 5977], [5038, 5977], [5058, 5987], [5060, 6001], [5106, 6014], [5182, 5982], [5185, 5932], [5176, 5898], [5184, 5880], [5166, 5841], [5133, 5807], [5104, 5809], [5075, 5814], [5036, 5833], [5026, 5865], [4979, 5896], [4954, 5949]]]
  }
}, {
  type: "Feature",
  id: "PL",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.48,
    "hc-key": "pl",
    "hc-a2": "PL",
    name: "Poland",
    labelrank: "3",
    "country-abbrev": "Pol.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "POL",
    "iso-a2": "PL",
    "woe-id": "23424923",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4786, 8270], [4779, 8263], [4790, 8269], [4878, 8266], [4880, 8266], [4900, 8258], [4901, 8249], [4912, 8198], [4891, 8183], [4905, 8152], [4919, 8114], [4876, 8075], [4873, 8057], [4852, 8069], [4763, 8074], [4755, 8089], [4691, 8116], [4644, 8126], [4639, 8194], [4623, 8205], [4627, 8239], [4638, 8245], [4625, 8247], [4625, 8248], [4626, 8249], [4683, 8263], [4696, 8274], [4748, 8286], [4756, 8269], [4786, 8270], [4786, 8270]]]
  }
}, {
  type: "Feature",
  id: "MK",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.44,
    "hc-key": "mk",
    "hc-a2": "MK",
    name: "Macedonia",
    labelrank: "6",
    "country-abbrev": "Mkd.",
    subregion: "Southern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "MKD",
    "iso-a2": "MK",
    "woe-id": "23424890",
    continent: "Europe"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[4826, 7756], [4826, 7756], [4826, 7756], [4826, 7756]]], [[[4867, 7808], [4887, 7787], [4884, 7773], [4854, 7765], [4831, 7756], [4826, 7762], [4826, 7757], [4825, 7758], [4825, 7758], [4822, 7758], [4819, 7758], [4822, 7765], [4816, 7764], [4811, 7781], [4814, 7792], [4830, 7804], [4844, 7805], [4855, 7808], [4867, 7808]]]]
  }
}, {
  type: "Feature",
  id: "PY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.35,
    "hc-middle-y": 0.36,
    "hc-key": "py",
    "hc-a2": "PY",
    name: "Paraguay",
    labelrank: "4",
    "country-abbrev": "Para.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "PRY",
    "iso-a2": "PY",
    "woe-id": "23424917",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2594, 5755], [2590, 5743], [2583, 5712], [2584, 5709], [2584, 5708], [2578, 5674], [2549, 5649], [2465, 5653], [2496, 5712], [2422, 5757], [2394, 5763], [2345, 5812], [2356, 5864], [2371, 5892], [2450, 5903], [2478, 5876], [2488, 5852], [2483, 5817], [2530, 5817], [2553, 5800], [2559, 5759], [2594, 5755]]]
  }
}, {
  type: "Feature",
  id: "BY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.5,
    "hc-key": "by",
    "hc-a2": "BY",
    name: "Belarus",
    labelrank: "4",
    "country-abbrev": "Bela.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "BLR",
    "iso-a2": "BY",
    "woe-id": "23424765",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4905, 8152], [4891, 8183], [4912, 8198], [4901, 8249], [4927, 8247], [4960, 8264], [4972, 8290], [4998, 8305], [4993, 8320], [5023, 8325], [5039, 8340], [5121, 8317], [5146, 8243], [5175, 8229], [5131, 8212], [5147, 8175], [5122, 8174], [5110, 8154], [5074, 8146], [5013, 8155], [4969, 8168], [4928, 8166], [4905, 8152]]]
  }
}, {
  type: "Feature",
  id: "CZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.56,
    "hc-key": "cz",
    "hc-a2": "CZ",
    name: "Czech Republic",
    labelrank: "5",
    "country-abbrev": "Cz. Rep.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "CZE",
    "iso-a2": "CZ",
    "woe-id": "23424810",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4763, 8074], [4741, 8058], [4707, 8039], [4648, 8053], [4640, 8039], [4614, 8045], [4571, 8083], [4575, 8108], [4644, 8126], [4691, 8116], [4755, 8089], [4763, 8074]]]
  }
}, {
  type: "Feature",
  id: "BF",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.54,
    "hc-key": "bf",
    "hc-a2": "BF",
    name: "Burkina Faso",
    labelrank: "3",
    "country-abbrev": "B.F.",
    subregion: "Western Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "BFA",
    "iso-a2": "BF",
    "woe-id": "23424978",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4231, 6804], [4218, 6804], [4199, 6808], [4122, 6804], [4124, 6759], [4109, 6772], [4065, 6765], [4040, 6787], [4051, 6832], [4069, 6839], [4083, 6876], [4099, 6869], [4120, 6895], [4141, 6899], [4183, 6927], [4210, 6922], [4233, 6865], [4269, 6852], [4275, 6831], [4247, 6818], [4231, 6804]]]
  }
}, {
  type: "Feature",
  id: "NA",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.33,
    "hc-middle-y": 0.37,
    "hc-key": "na",
    "hc-a2": "NA",
    name: "Namibia",
    labelrank: "3",
    "country-abbrev": "Nam.",
    subregion: "Southern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "NAM",
    "iso-a2": "NA",
    "woe-id": "23424987",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4898, 5953], [4923, 5958], [4954, 5949], [4904, 5928], [4895, 5942], [4826, 5933], [4827, 5821], [4797, 5819], [4797, 5734], [4797, 5617], [4771, 5600], [4720, 5608], [4711, 5630], [4693, 5613], [4658, 5652], [4637, 5740], [4631, 5811], [4602, 5855], [4577, 5909], [4561, 5927], [4553, 5965], [4595, 5974], [4618, 5960], [4752, 5961], [4761, 5950], [4821, 5941], [4898, 5953]]]
  }
}, {
  type: "Feature",
  id: "LY",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.51,
    "hc-middle-y": 0.38,
    "hc-key": "ly",
    "hc-a2": "LY",
    name: "Libya",
    labelrank: "3",
    "country-abbrev": "Libya",
    subregion: "Northern Africa",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "LBY",
    "iso-a2": "LY",
    "woe-id": "23424882",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4649, 7169], [4626, 7157], [4604, 7175], [4559, 7185], [4546, 7209], [4502, 7227], [4483, 7267], [4496, 7279], [4496, 7363], [4486, 7398], [4509, 7421], [4504, 7437], [4547, 7471], [4545, 7495], [4570, 7483], [4600, 7486], [4655, 7469], [4680, 7432], [4719, 7426], [4770, 7399], [4790, 7407], [4795, 7448], [4814, 7474], [4846, 7487], [4890, 7477], [4889, 7467], [4945, 7455], [4950, 7445], [4937, 7397], [4945, 7364], [4945, 7138], [4945, 7076], [4916, 7076], [4916, 7061], [4678, 7183], [4649, 7169]]]
  }
}, {
  type: "Feature",
  id: "TN",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.53,
    "hc-middle-y": 0.03,
    "hc-key": "tn",
    "hc-a2": "TN",
    name: "Tunisia",
    labelrank: "3",
    "country-abbrev": "Tun.",
    subregion: "Northern Africa",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "TUN",
    "iso-a2": "TN",
    "woe-id": "23424967",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4545, 7495], [4547, 7471], [4504, 7437], [4509, 7421], [4486, 7398], [4472, 7458], [4451, 7473], [4426, 7518], [4448, 7543], [4452, 7604], [4459, 7621], [4493, 7635], [4535, 7563], [4505, 7533], [4511, 7512], [4532, 7515], [4545, 7495]]]
  }
}, {
  type: "Feature",
  id: "BT",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.48,
    "hc-key": "bt",
    "hc-a2": "BT",
    name: "Bhutan",
    labelrank: "5",
    "country-abbrev": "Bhutan",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "BTN",
    "iso-a2": "BT",
    "woe-id": "23424770",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6842, 7305], [6882, 7338], [6923, 7319], [6937, 7293], [6869, 7285], [6842, 7305]]]
  }
}, {
  type: "Feature",
  id: "MD",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.42,
    "hc-key": "md",
    "hc-a2": "MD",
    name: "Moldova",
    labelrank: "6",
    "country-abbrev": "Mda.",
    subregion: "Eastern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "MDA",
    "iso-a2": "MD",
    "woe-id": "23424885",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5041, 7922], [5042, 7965], [5005, 8023], [4994, 8026], [5028, 8033], [5072, 8011], [5068, 7999], [5097, 7955], [5063, 7958], [5041, 7922]]]
  }
}, {
  type: "Feature",
  id: "SS",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.58,
    "hc-key": "ss",
    "hc-a2": "SS",
    name: "South Sudan",
    labelrank: "3",
    "country-abbrev": "S. Sud.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "SSD",
    "iso-a2": "SS",
    "woe-id": "-99",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5212, 6603], [5198, 6589], [5119, 6582], [5088, 6613], [5046, 6605], [5018, 6628], [4988, 6658], [4987, 6675], [4956, 6696], [4921, 6735], [4948, 6783], [4970, 6787], [4992, 6760], [5060, 6754], [5095, 6783], [5131, 6768], [5166, 6806], [5156, 6834], [5190, 6840], [5189, 6800], [5215, 6758], [5211, 6728], [5190, 6729], [5185, 6709], [5205, 6705], [5235, 6675], [5270, 6615], [5255, 6627], [5212, 6603]]]
  }
}, {
  type: "Feature",
  id: "BW",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.49,
    "hc-middle-y": 0.6,
    "hc-key": "bw",
    "hc-a2": "BW",
    name: "Botswana",
    labelrank: "4",
    "country-abbrev": "Bwa.",
    subregion: "Southern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "BWA",
    "iso-a2": "BW",
    "woe-id": "23424755",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[4954, 5949], [4979, 5896], [5026, 5865], [5036, 5833], [5075, 5814], [5041, 5799], [5006, 5769], [5000, 5749], [4972, 5734], [4963, 5706], [4941, 5700], [4887, 5716], [4878, 5695], [4847, 5667], [4818, 5666], [4822, 5690], [4797, 5734], [4797, 5819], [4827, 5821], [4826, 5933], [4895, 5942], [4904, 5928], [4954, 5949]]]
  }
}, {
  type: "Feature",
  id: "BS",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.8,
    "hc-middle-y": 0.92,
    "hc-key": "bs",
    "hc-a2": "BS",
    name: "The Bahamas",
    labelrank: "4",
    "country-abbrev": "Bhs.",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "BHS",
    "iso-a2": "BS",
    "woe-id": "23424758",
    continent: "North America"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[1956, 7219], [1937, 7241], [1937, 7241], [1937, 7241], [1944, 7236], [1956, 7219], [1956, 7219]]], [[[1956, 7219], [1970, 7205], [1976, 7173], [2045, 7149], [1983, 7165], [1949, 7190], [1966, 7207], [1956, 7219], [1956, 7219]]], [[[1937, 7241], [1911, 7260], [1890, 7236], [1901, 7192], [1881, 7221], [1883, 7237], [1912, 7268], [1937, 7241], [1937, 7241], [1937, 7241]]]]
  }
}, {
  type: "Feature",
  id: "NZ",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.25,
    "hc-middle-y": 0.81,
    "hc-key": "nz",
    "hc-a2": "NZ",
    name: "New Zealand",
    labelrank: "2",
    "country-abbrev": "N.Z.",
    subregion: "Australia and New Zealand",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "NZL",
    "iso-a2": "NZ",
    "woe-id": "23424916",
    continent: "Oceania"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[9238, 4994], [9198, 4996], [9194, 4975], [9181, 5009], [9153, 5008], [9145, 5023], [9159, 5047], [9201, 5088], [9241, 5104], [9282, 5140], [9311, 5200], [9330, 5213], [9341, 5185], [9362, 5199], [9374, 5165], [9321, 5099], [9289, 5079], [9268, 5027], [9238, 4994]]], [[[9429, 5191], [9404, 5174], [9386, 5186], [9404, 5221], [9361, 5252], [9385, 5272], [9393, 5308], [9378, 5347], [9341, 5395], [9364, 5402], [9402, 5361], [9422, 5343], [9427, 5313], [9470, 5301], [9503, 5310], [9483, 5263], [9469, 5264], [9429, 5191]]]]
  }
}, {
  type: "Feature",
  id: "CU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.67,
    "hc-middle-y": 0.64,
    "hc-key": "cu",
    "hc-a2": "CU",
    name: "Cuba",
    labelrank: "3",
    "country-abbrev": "Cuba",
    subregion: "Caribbean",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "CUB",
    "iso-a2": "CU",
    "woe-id": "23424793",
    continent: "North America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1916, 7091], [1870, 7097], [1853, 7124], [1817, 7140], [1776, 7144], [1774, 7159], [1748, 7160], [1696, 7131], [1700, 7149], [1734, 7169], [1770, 7175], [1828, 7171], [1852, 7150], [1867, 7154], [1879, 7155], [1933, 7113], [1986, 7095], [2000, 7078], [1898, 7071], [1916, 7091]]]
  }
}, {
  type: "Feature",
  id: "EC",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.16,
    "hc-middle-y": 0.37,
    "hc-key": "ec",
    "hc-a2": "EC",
    name: "Ecuador",
    labelrank: "3",
    "country-abbrev": "Ecu.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "ECU",
    "iso-a2": "EC",
    "woe-id": "23424801",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[1820, 6379], [1837, 6400], [1803, 6410], [1803, 6447], [1828, 6480], [1827, 6500], [1865, 6521], [1905, 6498], [1940, 6492], [1970, 6476], [1961, 6433], [1928, 6403], [1879, 6379], [1858, 6331], [1815, 6358], [1820, 6379]]]
  }
}, {
  type: "Feature",
  id: "AU",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.53,
    "hc-middle-y": 0.39,
    "hc-key": "au",
    "hc-a2": "AU",
    name: "Australia",
    labelrank: "2",
    "country-abbrev": "Auz.",
    subregion: "Australia and New Zealand",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "AUS",
    "iso-a2": "AU",
    "woe-id": "-90",
    continent: "Oceania"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [[[[8563, 5105], [8537, 5105], [8515, 5139], [8497, 5193], [8499, 5215], [8479, 5229], [8543, 5191], [8602, 5210], [8604, 5168], [8595, 5117], [8581, 5130], [8563, 5105]]], [[[8541, 5953], [8550, 5909], [8629, 5866], [8644, 5812], [8680, 5798], [8682, 5771], [8712, 5753], [8733, 5720], [8756, 5726], [8746, 5701], [8761, 5650], [8762, 5603], [8731, 5487], [8709, 5472], [8660, 5372], [8655, 5318], [8605, 5306], [8551, 5275], [8505, 5283], [8507, 5304], [8464, 5271], [8430, 5288], [8379, 5298], [8351, 5328], [8347, 5368], [8329, 5384], [8261, 5366], [8280, 5383], [8270, 5405], [8300, 5464], [8283, 5464], [8229, 5404], [8216, 5439], [8189, 5463], [8185, 5486], [8128, 5500], [8096, 5519], [8032, 5512], [7981, 5492], [7949, 5494], [7887, 5463], [7870, 5437], [7765, 5438], [7718, 5405], [7680, 5400], [7646, 5408], [7616, 5433], [7637, 5459], [7637, 5513], [7616, 5560], [7616, 5583], [7592, 5627], [7587, 5653], [7556, 5702], [7573, 5710], [7590, 5680], [7592, 5701], [7570, 5741], [7577, 5802], [7645, 5849], [7698, 5861], [7793, 5892], [7834, 5938], [7830, 5965], [7853, 5985], [7871, 5957], [7872, 5998], [7896, 5993], [7897, 6026], [7916, 6045], [7961, 6056], [7971, 6072], [8008, 6042], [8052, 6031], [8043, 6051], [8090, 6125], [8063, 6129], [8073, 6147], [8104, 6146], [8105, 6115], [8141, 6119], [8139, 6152], [8156, 6132], [8212, 6115], [8254, 6129], [8267, 6115], [8237, 6071], [8224, 6036], [8256, 6011], [8329, 5976], [8359, 5951], [8384, 5959], [8408, 6030], [8406, 6107], [8417, 6122], [8422, 6177], [8436, 6161], [8463, 6071], [8476, 6048], [8492, 6058], [8517, 6035], [8519, 5993], [8541, 5953]]]]
  }
}, {
  type: "Feature",
  id: "VE",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.33,
    "hc-key": "ve",
    "hc-a2": "VE",
    name: "Venezuela",
    labelrank: "3",
    "country-abbrev": "Ven.",
    subregion: "South America",
    "region-wb": "Latin America & Caribbean",
    "iso-a3": "VEN",
    "iso-a2": "VE",
    "woe-id": "23424982",
    continent: "South America"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[2087, 6830], [2070, 6823], [2080, 6796], [2064, 6769], [2082, 6746], [2096, 6767], [2080, 6799], [2122, 6818], [2160, 6818], [2188, 6788], [2237, 6794], [2282, 6777], [2307, 6793], [2343, 6797], [2357, 6776], [2400, 6756], [2397, 6742], [2423, 6732], [2408, 6709], [2415, 6689], [2387, 6672], [2382, 6653], [2401, 6632], [2377, 6604], [2286, 6596], [2303, 6552], [2324, 6550], [2301, 6525], [2258, 6498], [2219, 6515], [2210, 6549], [2191, 6564], [2207, 6580], [2190, 6612], [2201, 6662], [2143, 6659], [2123, 6685], [2064, 6688], [2056, 6726], [2037, 6753], [2040, 6787], [2068, 6824], [2087, 6830]]]
  }
}, {
  type: "Feature",
  id: "SB",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.13,
    "hc-middle-y": 0.24,
    "hc-key": "sb",
    "hc-a2": "SB",
    name: "Solomon Islands",
    labelrank: "3",
    "country-abbrev": "S. Is.",
    subregion: "Melanesia",
    "region-wb": "East Asia & Pacific",
    "iso-a3": "SLB",
    "iso-a2": "SB",
    "woe-id": "23424766",
    continent: "Oceania"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[8977, 6187], [8947, 6189], [8947, 6226], [8902, 6255], [8881, 6242], [8899, 6222], [8858, 6239], [8861, 6266], [8912, 6255], [8947, 6233], [8955, 6212], [8982, 6224], [8977, 6187]]]
  }
}, {
  type: "Feature",
  id: "MG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.45,
    "hc-middle-y": 0.48,
    "hc-key": "mg",
    "hc-a2": "MG",
    name: "Madagascar",
    labelrank: "3",
    "country-abbrev": "Mad.",
    subregion: "Eastern Africa",
    "region-wb": "Sub-Saharan Africa",
    "iso-a3": "MDG",
    "iso-a2": "MG",
    "woe-id": "23424883",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5683, 5987], [5616, 5762], [5601, 5727], [5544, 5707], [5511, 5726], [5503, 5774], [5487, 5812], [5495, 5841], [5524, 5882], [5508, 5959], [5523, 5997], [5558, 6004], [5613, 6031], [5635, 6081], [5650, 6080], [5665, 6125], [5686, 6092], [5702, 6020], [5677, 6017], [5683, 5987]]]
  }
}, {
  type: "Feature",
  id: "IS",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.5,
    "hc-key": "is",
    "hc-a2": "IS",
    name: "Iceland",
    labelrank: "3",
    "country-abbrev": "Iceland",
    subregion: "Northern Europe",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "ISL",
    "iso-a2": "IS",
    "woe-id": "23424845",
    continent: "Europe"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[3490, 8732], [3556, 8739], [3551, 8757], [3516, 8766], [3476, 8762], [3500, 8775], [3508, 8796], [3538, 8790], [3534, 8809], [3571, 8786], [3566, 8765], [3584, 8755], [3607, 8792], [3661, 8795], [3682, 8785], [3715, 8796], [3713, 8811], [3768, 8789], [3763, 8773], [3795, 8763], [3803, 8741], [3772, 8709], [3677, 8676], [3648, 8661], [3605, 8668], [3575, 8684], [3530, 8682], [3560, 8708], [3538, 8728], [3490, 8732]]]
  }
}, {
  type: "Feature",
  id: "EG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.5,
    "hc-middle-y": 0.66,
    "hc-key": "eg",
    "hc-a2": "EG",
    name: "Egypt",
    labelrank: "2",
    "country-abbrev": "Egypt",
    subregion: "Northern Africa",
    "region-wb": "Middle East & North Africa",
    "iso-a3": "EGY",
    "iso-a2": "EG",
    "woe-id": "23424802",
    continent: "Africa"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[5239, 7374], [5220, 7318], [5190, 7345], [5169, 7390], [5172, 7358], [5201, 7320], [5213, 7282], [5258, 7199], [5263, 7167], [5299, 7138], [5131, 7138], [4945, 7138], [4945, 7364], [4937, 7397], [4950, 7445], [5015, 7435], [5065, 7418], [5105, 7440], [5140, 7438], [5157, 7425], [5219, 7433], [5237, 7382], [5239, 7374]]]
  }
}, {
  type: "Feature",
  id: "KG",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.48,
    "hc-middle-y": 0.43,
    "hc-key": "kg",
    "hc-a2": "KG",
    name: "Kyrgyzstan",
    labelrank: "4",
    "country-abbrev": "Kgz.",
    subregion: "Central Asia",
    "region-wb": "Europe & Central Asia",
    "iso-a3": "KGZ",
    "iso-a2": "KG",
    "woe-id": "23424864",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6389, 7707], [6348, 7698], [6325, 7713], [6261, 7709], [6280, 7734], [6310, 7734], [6331, 7731], [6374, 7754], [6333, 7777], [6323, 7766], [6286, 7782], [6309, 7805], [6336, 7826], [6385, 7812], [6405, 7842], [6435, 7827], [6531, 7828], [6584, 7803], [6529, 7774], [6521, 7763], [6482, 7759], [6450, 7736], [6446, 7748], [6399, 7728], [6389, 7707]], [[6300, 7721], [6296, 7722], [6299, 7718], [6302, 7720], [6300, 7721]], [[6333, 7723], [6334, 7726], [6331, 7724], [6332, 7723], [6333, 7723]], [[6316, 7728], [6310, 7729], [6312, 7722], [6317, 7722], [6316, 7728]]]
  }
}, {
  type: "Feature",
  id: "NP",
  properties: {
    "hc-group": "admin0",
    "hc-middle-x": 0.52,
    "hc-middle-y": 0.54,
    "hc-key": "np",
    "hc-a2": "NP",
    name: "Nepal",
    labelrank: "3",
    "country-abbrev": "Nepal",
    subregion: "Southern Asia",
    "region-wb": "South Asia",
    "iso-a3": "NPL",
    "iso-a2": "NP",
    "woe-id": "23424911",
    continent: "Asia"
  },
  geometry: {
    type: "Polygon",
    coordinates: [[[6819, 7322], [6820, 7286], [6795, 7274], [6751, 7281], [6714, 7305], [6660, 7310], [6579, 7353], [6589, 7383], [6608, 7397], [6640, 7401], [6683, 7364], [6699, 7367], [6729, 7336], [6756, 7323], [6773, 7330], [6819, 7322]]]
  }
}];
var mapData = {
  title: title,
  version: version,
  type: type,
  copyright: copyright,
  copyrightShort: copyrightShort,
  copyrightUrl: copyrightUrl,
  crs: crs,
  "hc-transform": {
    "default": {
      crs: "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs",
      scale: 0.0000172182781654,
      jsonres: 15.5,
      jsonmarginX: -999,
      jsonmarginY: 9851,
      xoffset: -19495356.3693,
      yoffset: 12635908.1982
    }
  },
  features: features
};
var regions = [{
  name: 'Africa and Near East',
  code: 'AF',
  bubbleCountryCode: 'SD' // Sudan

}, {
  name: 'North America',
  code: 'AM',
  bubbleCountryCode: 'US' // United States

}, {
  name: 'Asia - Pacific',
  code: 'AS',
  bubbleCountryCode: 'MM' // Myanmar

}, {
  name: 'Europe',
  code: 'EU',
  bubbleCountryCode: 'AT' // Austria

}, {
  name: 'Central and South America',
  code: 'LA',
  bubbleCountryCode: 'CO' // Colombia

}, {
  name: 'Others',
  code: 'OTHERS',
  bubbleCountryCode: 'GS' // South Georgia and the South Sandwich Islands

}];
var nearEastCodes = ['AF', // Afghanistan
'DZ', // Algeria
'BH', // Bahrain
'CY', // Cyprus
'EG', // Egypt
'IR', // Iran
'IQ', // Iraq
'IL', // Israel
'JO', // Jordan
'KW', // Kuwait
'LB', // Lebanon
'LY', // Libya
'MR', // Mauritania
'MA', // Morocco
'OM', // Oman
'PS', // Palestinian territories
'PK', // Pakistan
'QA', // Qatar
'SA', // Saudi Arabia
'SY', // Syria
'TN', // Tunisia
'TR', // Turkey
'AE', // United Arab Emirates
'YE', // Yemen
'SX' // Somaliland (St. Marteen)
];
var latinAmericanAndCaribbeanCodes = ['AG', // Antigua & Barbuda
'AI', // Anguilla
'AW', // Aruba
'BS', // Bahamas
'BB', // Barbados
'BM', // Bermuda
'BQ', // Bonaire
'KY', // Cayman Islands
'CU', // Cuba
'CW', // Curacao
'DM', // Dominica
'DO', // Dominican Republic
'GD', // Grenada
'GP', // Guadeloupe
'HT', // Haiti
'JM', // Jamaica
'MQ', // Martinique
'MS', // Montserrat
'PR', // Puerto Rico
'BL', // Saint Barthélemy
'KN', // St. Kitts & Nevis
'LC', // St. Lucia
'MF', // St. Martin
'PM', // St. Pierre and Miquelon
'VC', // St. Vincent and the Grenadines
'TT', // Trinidad & Tobago
'TC', // Turks & Caicos Islands
'VG', // British Virgin Islands
'VI', // US Virgin Islands
'BZ', // Belize
'CR', // Costa Rica
'SV', // El Salvador
'GT', // Guatemala
'HN', // Honduras
'MX', // Mexico
'NI', // Nicaragua
'PA', // Panama
'AR', // Argentina
'BO', // Bolivia
'BR', // Brazil
'CL', // Chile
'CO', // Colombia
'EC', // Ecuador
'GF', // French Guiana
'GY', // Guyana
'PY', // Paraguay
'PE', // Peru
'SR', // Suriname
'UY', // Uruguay
'VE', // Venezuela
'FK' // Falkland Islands
];
var countries = [{
  capital: "Andorra la Vella",
  code: "AD",
  continent: "EU",
  currency: "EUR",
  name: "Andorra",
  phone: "376"
}, {
  capital: "Abu Dhabi",
  code: "AE",
  continent: "AS",
  currency: "AED",
  name: "United Arab Emirates",
  phone: "971"
}, {
  capital: "Kabul",
  code: "AF",
  continent: "AS",
  currency: "AFN",
  name: "Afghanistan",
  phone: "93"
}, {
  capital: "Saint John's",
  code: "AG",
  continent: "NA",
  currency: "XCD",
  name: "Antigua and Barbuda",
  phone: "1268"
}, {
  capital: "The Valley",
  code: "AI",
  continent: "NA",
  currency: "XCD",
  name: "Anguilla",
  phone: "1264"
}, {
  capital: "Tirana",
  code: "AL",
  continent: "EU",
  currency: "ALL",
  name: "Albania",
  phone: "355"
}, {
  capital: "Yerevan",
  code: "AM",
  continent: "AS",
  currency: "AMD",
  name: "Armenia",
  phone: "374"
}, {
  capital: "Luanda",
  code: "AO",
  continent: "AF",
  currency: "AOA",
  name: "Angola",
  phone: "244"
}, {
  capital: "",
  code: "AQ",
  continent: "AN",
  currency: "",
  name: "Antarctica",
  phone: "672"
}, {
  capital: "Buenos Aires",
  code: "AR",
  continent: "SA",
  currency: "ARS",
  name: "Argentina",
  phone: "54"
}, {
  capital: "Pago Pago",
  code: "AS",
  continent: "OC",
  currency: "USD",
  name: "American Samoa",
  phone: "1684"
}, {
  capital: "Vienna",
  code: "AT",
  continent: "EU",
  currency: "EUR",
  name: "Austria",
  phone: "43"
}, {
  capital: "Canberra",
  code: "AU",
  continent: "OC",
  currency: "AUD",
  name: "Australia",
  phone: "61"
}, {
  capital: "Oranjestad",
  code: "AW",
  continent: "NA",
  currency: "AWG",
  name: "Aruba",
  phone: "297"
}, {
  capital: "Mariehamn",
  code: "AX",
  continent: "EU",
  currency: "EUR",
  name: "Åland",
  phone: "358"
}, {
  capital: "Baku",
  code: "AZ",
  continent: "AS",
  currency: "AZN",
  name: "Azerbaijan",
  phone: "994"
}, {
  capital: "Sarajevo",
  code: "BA",
  continent: "EU",
  currency: "BAM",
  name: "Bosnia and Herzegovina",
  phone: "387"
}, {
  capital: "Bridgetown",
  code: "BB",
  continent: "NA",
  currency: "BBD",
  name: "Barbados",
  phone: "1246"
}, {
  capital: "Dhaka",
  code: "BD",
  continent: "AS",
  currency: "BDT",
  name: "Bangladesh",
  phone: "880"
}, {
  capital: "Brussels",
  code: "BE",
  continent: "EU",
  currency: "EUR",
  name: "Belgium",
  phone: "32"
}, {
  capital: "Ouagadougou",
  code: "BF",
  continent: "AF",
  currency: "XOF",
  name: "Burkina Faso",
  phone: "226"
}, {
  capital: "Sofia",
  code: "BG",
  continent: "EU",
  currency: "BGN",
  name: "Bulgaria",
  phone: "359"
}, {
  capital: "Manama",
  code: "BH",
  continent: "AS",
  currency: "BHD",
  name: "Bahrain",
  phone: "973"
}, {
  capital: "Bujumbura",
  code: "BI",
  continent: "AF",
  currency: "BIF",
  name: "Burundi",
  phone: "257"
}, {
  capital: "Porto-Novo",
  code: "BJ",
  continent: "AF",
  currency: "XOF",
  name: "Benin",
  phone: "229"
}, {
  capital: "Gustavia",
  code: "BL",
  continent: "NA",
  currency: "EUR",
  name: "Saint Barthélemy",
  phone: "590"
}, {
  capital: "Hamilton",
  code: "BM",
  continent: "NA",
  currency: "BMD",
  name: "Bermuda",
  phone: "1441"
}, {
  capital: "Bandar Seri Begawan",
  code: "BN",
  continent: "AS",
  currency: "BND",
  name: "Brunei",
  phone: "673"
}, {
  capital: "Sucre",
  code: "BO",
  continent: "SA",
  currency: "BOB,BOV",
  name: "Bolivia",
  phone: "591"
}, {
  capital: "Kralendijk",
  code: "BQ",
  continent: "NA",
  currency: "USD",
  name: "Bonaire",
  phone: "5997"
}, {
  capital: "Brasília",
  code: "BR",
  continent: "SA",
  currency: "BRL",
  name: "Brazil",
  phone: "55"
}, {
  capital: "Nassau",
  code: "BS",
  continent: "NA",
  currency: "BSD",
  name: "Bahamas",
  phone: "1242"
}, {
  capital: "Thimphu",
  code: "BT",
  continent: "AS",
  currency: "BTN,INR",
  name: "Bhutan",
  phone: "975"
}, {
  capital: "",
  code: "BV",
  continent: "AN",
  currency: "NOK",
  name: "Bouvet Island",
  phone: "47"
}, {
  capital: "Gaborone",
  code: "BW",
  continent: "AF",
  currency: "BWP",
  name: "Botswana",
  phone: "267"
}, {
  capital: "Minsk",
  code: "BY",
  continent: "EU",
  currency: "BYR",
  name: "Belarus",
  phone: "375"
}, {
  capital: "Belmopan",
  code: "BZ",
  continent: "NA",
  currency: "BZD",
  name: "Belize",
  phone: "501"
}, {
  capital: "Ottawa",
  code: "CA",
  continent: "NA",
  currency: "CAD",
  name: "Canada",
  phone: "1"
}, {
  capital: "West Island",
  code: "CC",
  continent: "AS",
  currency: "AUD",
  name: "Cocos [Keeling] Islands",
  phone: "61"
}, {
  capital: "Kinshasa",
  code: "CD",
  continent: "AF",
  currency: "CDF",
  name: "Democratic Republic of the Congo",
  phone: "243"
}, {
  capital: "Bangui",
  code: "CF",
  continent: "AF",
  currency: "XAF",
  name: "Central African Republic",
  phone: "236"
}, {
  capital: "Brazzaville",
  code: "CG",
  continent: "AF",
  currency: "XAF",
  name: "Republic of the Congo",
  phone: "242"
}, {
  capital: "Bern",
  code: "CH",
  continent: "EU",
  currency: "CHE,CHF,CHW",
  name: "Switzerland",
  phone: "41"
}, {
  capital: "Yamoussoukro",
  code: "CI",
  continent: "AF",
  currency: "XOF",
  name: "Ivory Coast",
  phone: "225"
}, {
  capital: "Avarua",
  code: "CK",
  continent: "OC",
  currency: "NZD",
  name: "Cook Islands",
  phone: "682"
}, {
  capital: "Santiago",
  code: "CL",
  continent: "SA",
  currency: "CLF,CLP",
  name: "Chile",
  phone: "56"
}, {
  capital: "Yaoundé",
  code: "CM",
  continent: "AF",
  currency: "XAF",
  name: "Cameroon",
  phone: "237"
}, {
  capital: "Beijing",
  code: "CN",
  continent: "AS",
  currency: "CNY",
  name: "China",
  phone: "86"
}, {
  capital: "Bogotá",
  code: "CO",
  continent: "SA",
  currency: "COP",
  name: "Colombia",
  phone: "57"
}, {
  capital: "San José",
  code: "CR",
  continent: "NA",
  currency: "CRC",
  name: "Costa Rica",
  phone: "506"
}, {
  capital: "Havana",
  code: "CU",
  continent: "NA",
  currency: "CUC,CUP",
  name: "Cuba",
  phone: "53"
}, {
  capital: "Praia",
  code: "CV",
  continent: "AF",
  currency: "CVE",
  name: "Cape Verde",
  phone: "238"
}, {
  capital: "Willemstad",
  code: "CW",
  continent: "NA",
  currency: "ANG",
  name: "Curacao",
  phone: "5999"
}, {
  capital: "Flying Fish Cove",
  code: "CX",
  continent: "AS",
  currency: "AUD",
  name: "Christmas Island",
  phone: "61"
}, {
  capital: "Nicosia",
  code: "CY",
  continent: "EU",
  currency: "EUR",
  name: "Cyprus",
  phone: "357"
}, {
  capital: "Prague",
  code: "CZ",
  continent: "EU",
  currency: "CZK",
  name: "Czech Republic",
  phone: "420"
}, {
  capital: "Berlin",
  code: "DE",
  continent: "EU",
  currency: "EUR",
  name: "Germany",
  phone: "49"
}, {
  capital: "Djibouti",
  code: "DJ",
  continent: "AF",
  currency: "DJF",
  name: "Djibouti",
  phone: "253"
}, {
  capital: "Copenhagen",
  code: "DK",
  continent: "EU",
  currency: "DKK",
  name: "Denmark",
  phone: "45"
}, {
  capital: "Roseau",
  code: "DM",
  continent: "NA",
  currency: "XCD",
  name: "Dominica",
  phone: "1767"
}, {
  capital: "Santo Domingo",
  code: "DO",
  continent: "NA",
  currency: "DOP",
  name: "Dominican Republic",
  phone: "1809,1829,1849"
}, {
  capital: "Algiers",
  code: "DZ",
  continent: "AF",
  currency: "DZD",
  name: "Algeria",
  phone: "213"
}, {
  capital: "Quito",
  code: "EC",
  continent: "SA",
  currency: "USD",
  name: "Ecuador",
  phone: "593"
}, {
  capital: "Tallinn",
  code: "EE",
  continent: "EU",
  currency: "EUR",
  name: "Estonia",
  phone: "372"
}, {
  capital: "Cairo",
  code: "EG",
  continent: "AF",
  currency: "EGP",
  name: "Egypt",
  phone: "20"
}, {
  capital: "El Aaiún",
  code: "EH",
  continent: "AF",
  currency: "MAD,DZD,MRO",
  name: "Western Sahara",
  phone: "212"
}, {
  capital: "Asmara",
  code: "ER",
  continent: "AF",
  currency: "ERN",
  name: "Eritrea",
  phone: "291"
}, {
  capital: "Madrid",
  code: "ES",
  continent: "EU",
  currency: "EUR",
  name: "Spain",
  phone: "34"
}, {
  capital: "Addis Ababa",
  code: "ET",
  continent: "AF",
  currency: "ETB",
  name: "Ethiopia",
  phone: "251"
}, {
  capital: "Helsinki",
  code: "FI",
  continent: "EU",
  currency: "EUR",
  name: "Finland",
  phone: "358"
}, {
  capital: "Suva",
  code: "FJ",
  continent: "OC",
  currency: "FJD",
  name: "Fiji",
  phone: "679"
}, {
  capital: "Stanley",
  code: "FK",
  continent: "SA",
  currency: "FKP",
  name: "Falkland Islands",
  phone: "500"
}, {
  capital: "Palikir",
  code: "FM",
  continent: "OC",
  currency: "USD",
  name: "Micronesia",
  phone: "691"
}, {
  capital: "Tórshavn",
  code: "FO",
  continent: "EU",
  currency: "DKK",
  name: "Faroe Islands",
  phone: "298"
}, {
  capital: "Paris",
  code: "FR",
  continent: "EU",
  currency: "EUR",
  name: "France",
  phone: "33"
}, {
  capital: "Libreville",
  code: "GA",
  continent: "AF",
  currency: "XAF",
  name: "Gabon",
  phone: "241"
}, {
  capital: "London",
  code: "GB",
  continent: "EU",
  currency: "GBP",
  name: "United Kingdom",
  phone: "44"
}, {
  capital: "St. George's",
  code: "GD",
  continent: "NA",
  currency: "XCD",
  name: "Grenada",
  phone: "1473"
}, {
  capital: "Tbilisi",
  code: "GE",
  continent: "AS",
  currency: "GEL",
  name: "Georgia",
  phone: "995"
}, {
  capital: "Cayenne",
  code: "GF",
  continent: "SA",
  currency: "EUR",
  name: "French Guiana",
  phone: "594"
}, {
  capital: "St. Peter Port",
  code: "GG",
  continent: "EU",
  currency: "GBP",
  name: "Guernsey",
  phone: "44"
}, {
  capital: "Accra",
  code: "GH",
  continent: "AF",
  currency: "GHS",
  name: "Ghana",
  phone: "233"
}, {
  capital: "Gibraltar",
  code: "GI",
  continent: "EU",
  currency: "GIP",
  name: "Gibraltar",
  phone: "350"
}, {
  capital: "Nuuk",
  code: "GL",
  continent: "NA",
  currency: "DKK",
  name: "Greenland",
  phone: "299"
}, {
  capital: "Banjul",
  code: "GM",
  continent: "AF",
  currency: "GMD",
  name: "Gambia",
  phone: "220"
}, {
  capital: "Conakry",
  code: "GN",
  continent: "AF",
  currency: "GNF",
  name: "Guinea",
  phone: "224"
}, {
  capital: "Basse-Terre",
  code: "GP",
  continent: "NA",
  currency: "EUR",
  name: "Guadeloupe",
  phone: "590"
}, {
  capital: "Malabo",
  code: "GQ",
  continent: "AF",
  currency: "XAF",
  name: "Equatorial Guinea",
  phone: "240"
}, {
  capital: "Athens",
  code: "GR",
  continent: "EU",
  currency: "EUR",
  name: "Greece",
  phone: "30"
}, {
  capital: "King Edward Point",
  code: "GS",
  continent: "AN",
  currency: "GBP",
  name: "South Georgia and the South Sandwich Islands",
  phone: "500"
}, {
  capital: "Guatemala City",
  code: "GT",
  continent: "NA",
  currency: "GTQ",
  name: "Guatemala",
  phone: "502"
}, {
  capital: "Hagåtña",
  code: "GU",
  continent: "OC",
  currency: "USD",
  name: "Guam",
  phone: "1671"
}, {
  capital: "Bissau",
  code: "GW",
  continent: "AF",
  currency: "XOF",
  name: "Guinea-Bissau",
  phone: "245"
}, {
  capital: "Georgetown",
  code: "GY",
  continent: "SA",
  currency: "GYD",
  name: "Guyana",
  phone: "592"
}, {
  capital: "City of Victoria",
  code: "HK",
  continent: "AS",
  currency: "HKD",
  name: "Hong Kong",
  phone: "852"
}, {
  capital: "",
  code: "HM",
  continent: "AN",
  currency: "AUD",
  name: "Heard Island and McDonald Islands",
  phone: "61"
}, {
  capital: "Tegucigalpa",
  code: "HN",
  continent: "NA",
  currency: "HNL",
  name: "Honduras",
  phone: "504"
}, {
  capital: "Zagreb",
  code: "HR",
  continent: "EU",
  currency: "HRK",
  name: "Croatia",
  phone: "385"
}, {
  capital: "Port-au-Prince",
  code: "HT",
  continent: "NA",
  currency: "HTG,USD",
  name: "Haiti",
  phone: "509"
}, {
  capital: "Budapest",
  code: "HU",
  continent: "EU",
  currency: "HUF",
  name: "Hungary",
  phone: "36"
}, {
  capital: "Jakarta",
  code: "ID",
  continent: "AS",
  currency: "IDR",
  name: "Indonesia",
  phone: "62"
}, {
  capital: "Dublin",
  code: "IE",
  continent: "EU",
  currency: "EUR",
  name: "Ireland",
  phone: "353"
}, {
  capital: "Jerusalem",
  code: "IL",
  continent: "AS",
  currency: "ILS",
  name: "Israel",
  phone: "972"
}, {
  capital: "Douglas",
  code: "IM",
  continent: "EU",
  currency: "GBP",
  name: "Isle of Man",
  phone: "44"
}, {
  capital: "New Delhi",
  code: "IN",
  continent: "AS",
  currency: "INR",
  name: "India",
  phone: "91"
}, {
  capital: "Diego Garcia",
  code: "IO",
  continent: "AS",
  currency: "USD",
  name: "British Indian Ocean Territory",
  phone: "246"
}, {
  capital: "Baghdad",
  code: "IQ",
  continent: "AS",
  currency: "IQD",
  name: "Iraq",
  phone: "964"
}, {
  capital: "Tehran",
  code: "IR",
  continent: "AS",
  currency: "IRR",
  name: "Iran",
  phone: "98"
}, {
  capital: "Reykjavik",
  code: "IS",
  continent: "EU",
  currency: "ISK",
  name: "Iceland",
  phone: "354"
}, {
  capital: "Rome",
  code: "IT",
  continent: "EU",
  currency: "EUR",
  name: "Italy",
  phone: "39"
}, {
  capital: "Saint Helier",
  code: "JE",
  continent: "EU",
  currency: "GBP",
  name: "Jersey",
  phone: "44"
}, {
  capital: "Kingston",
  code: "JM",
  continent: "NA",
  currency: "JMD",
  name: "Jamaica",
  phone: "1876"
}, {
  capital: "Amman",
  code: "JO",
  continent: "AS",
  currency: "JOD",
  name: "Jordan",
  phone: "962"
}, {
  capital: "Tokyo",
  code: "JP",
  continent: "AS",
  currency: "JPY",
  name: "Japan",
  phone: "81"
}, {
  capital: "Nairobi",
  code: "KE",
  continent: "AF",
  currency: "KES",
  name: "Kenya",
  phone: "254"
}, {
  capital: "Bishkek",
  code: "KG",
  continent: "AS",
  currency: "KGS",
  name: "Kyrgyzstan",
  phone: "996"
}, {
  capital: "Phnom Penh",
  code: "KH",
  continent: "AS",
  currency: "KHR",
  name: "Cambodia",
  phone: "855"
}, {
  capital: "South Tarawa",
  code: "KI",
  continent: "OC",
  currency: "AUD",
  name: "Kiribati",
  phone: "686"
}, {
  capital: "Moroni",
  code: "KM",
  continent: "AF",
  currency: "KMF",
  name: "Comoros",
  phone: "269"
}, {
  capital: "Basseterre",
  code: "KN",
  continent: "NA",
  currency: "XCD",
  name: "Saint Kitts and Nevis",
  phone: "1869"
}, {
  capital: "Pyongyang",
  code: "KP",
  continent: "AS",
  currency: "KPW",
  name: "North Korea",
  phone: "850"
}, {
  capital: "Seoul",
  code: "KR",
  continent: "AS",
  currency: "KRW",
  name: "South Korea",
  phone: "82"
}, {
  capital: "Kuwait City",
  code: "KW",
  continent: "AS",
  currency: "KWD",
  name: "Kuwait",
  phone: "965"
}, {
  capital: "George Town",
  code: "KY",
  continent: "NA",
  currency: "KYD",
  name: "Cayman Islands",
  phone: "1345"
}, {
  capital: "Astana",
  code: "KZ",
  continent: "AS",
  currency: "KZT",
  name: "Kazakhstan",
  phone: "76,77"
}, {
  capital: "Vientiane",
  code: "LA",
  continent: "AS",
  currency: "LAK",
  name: "Laos",
  phone: "856"
}, {
  capital: "Beirut",
  code: "LB",
  continent: "AS",
  currency: "LBP",
  name: "Lebanon",
  phone: "961"
}, {
  capital: "Castries",
  code: "LC",
  continent: "NA",
  currency: "XCD",
  name: "Saint Lucia",
  phone: "1758"
}, {
  capital: "Vaduz",
  code: "LI",
  continent: "EU",
  currency: "CHF",
  name: "Liechtenstein",
  phone: "423"
}, {
  capital: "Colombo",
  code: "LK",
  continent: "AS",
  currency: "LKR",
  name: "Sri Lanka",
  phone: "94"
}, {
  capital: "Monrovia",
  code: "LR",
  continent: "AF",
  currency: "LRD",
  name: "Liberia",
  phone: "231"
}, {
  capital: "Maseru",
  code: "LS",
  continent: "AF",
  currency: "LSL,ZAR",
  name: "Lesotho",
  phone: "266"
}, {
  capital: "Vilnius",
  code: "LT",
  continent: "EU",
  currency: "LTL",
  name: "Lithuania",
  phone: "370"
}, {
  capital: "Luxembourg",
  code: "LU",
  continent: "EU",
  currency: "EUR",
  name: "Luxembourg",
  phone: "352"
}, {
  capital: "Riga",
  code: "LV",
  continent: "EU",
  currency: "EUR",
  name: "Latvia",
  phone: "371"
}, {
  capital: "Tripoli",
  code: "LY",
  continent: "AF",
  currency: "LYD",
  name: "Libya",
  phone: "218"
}, {
  capital: "Rabat",
  code: "MA",
  continent: "AF",
  currency: "MAD",
  name: "Morocco",
  phone: "212"
}, {
  capital: "Monaco",
  code: "MC",
  continent: "EU",
  currency: "EUR",
  name: "Monaco",
  phone: "377"
}, {
  capital: "Chișinău",
  code: "MD",
  continent: "EU",
  currency: "MDL",
  name: "Moldova",
  phone: "373"
}, {
  capital: "Podgorica",
  code: "ME",
  continent: "EU",
  currency: "EUR",
  name: "Montenegro",
  phone: "382"
}, {
  capital: "Marigot",
  code: "MF",
  continent: "NA",
  currency: "EUR",
  name: "Saint Martin",
  phone: "590"
}, {
  capital: "Antananarivo",
  code: "MG",
  continent: "AF",
  currency: "MGA",
  name: "Madagascar",
  phone: "261"
}, {
  capital: "Majuro",
  code: "MH",
  continent: "OC",
  currency: "USD",
  name: "Marshall Islands",
  phone: "692"
}, {
  capital: "Skopje",
  code: "MK",
  continent: "EU",
  currency: "MKD",
  name: "Macedonia",
  phone: "389"
}, {
  capital: "Bamako",
  code: "ML",
  continent: "AF",
  currency: "XOF",
  name: "Mali",
  phone: "223"
}, {
  capital: "Naypyidaw",
  code: "MM",
  continent: "AS",
  currency: "MMK",
  name: "Myanmar [Burma]",
  phone: "95"
}, {
  capital: "Ulan Bator",
  code: "MN",
  continent: "AS",
  currency: "MNT",
  name: "Mongolia",
  phone: "976"
}, {
  capital: "",
  code: "MO",
  continent: "AS",
  currency: "MOP",
  name: "Macao",
  phone: "853"
}, {
  capital: "Saipan",
  code: "MP",
  continent: "OC",
  currency: "USD",
  name: "Northern Mariana Islands",
  phone: "1670"
}, {
  capital: "Fort-de-France",
  code: "MQ",
  continent: "NA",
  currency: "EUR",
  name: "Martinique",
  phone: "596"
}, {
  capital: "Nouakchott",
  code: "MR",
  continent: "AF",
  currency: "MRO",
  name: "Mauritania",
  phone: "222"
}, {
  capital: "Plymouth",
  code: "MS",
  continent: "NA",
  currency: "XCD",
  name: "Montserrat",
  phone: "1664"
}, {
  capital: "Valletta",
  code: "MT",
  continent: "EU",
  currency: "EUR",
  name: "Malta",
  phone: "356"
}, {
  capital: "Port Louis",
  code: "MU",
  continent: "AF",
  currency: "MUR",
  name: "Mauritius",
  phone: "230"
}, {
  capital: "Malé",
  code: "MV",
  continent: "AS",
  currency: "MVR",
  name: "Maldives",
  phone: "960"
}, {
  capital: "Lilongwe",
  code: "MW",
  continent: "AF",
  currency: "MWK",
  name: "Malawi",
  phone: "265"
}, {
  capital: "Mexico City",
  code: "MX",
  continent: "NA",
  currency: "MXN",
  name: "Mexico",
  phone: "52"
}, {
  capital: "Kuala Lumpur",
  code: "MY",
  continent: "AS",
  currency: "MYR",
  name: "Malaysia",
  phone: "60"
}, {
  capital: "Maputo",
  code: "MZ",
  continent: "AF",
  currency: "MZN",
  name: "Mozambique",
  phone: "258"
}, {
  capital: "Windhoek",
  code: "NA",
  continent: "AF",
  currency: "NAD,ZAR",
  name: "Namibia",
  phone: "264"
}, {
  capital: "Nouméa",
  code: "NC",
  continent: "OC",
  currency: "XPF",
  name: "New Caledonia",
  phone: "687"
}, {
  capital: "Niamey",
  code: "NE",
  continent: "AF",
  currency: "XOF",
  name: "Niger",
  phone: "227"
}, {
  capital: "Kingston",
  code: "NF",
  continent: "OC",
  currency: "AUD",
  name: "Norfolk Island",
  phone: "672"
}, {
  capital: "Abuja",
  code: "NG",
  continent: "AF",
  currency: "NGN",
  name: "Nigeria",
  phone: "234"
}, {
  capital: "Managua",
  code: "NI",
  continent: "NA",
  currency: "NIO",
  name: "Nicaragua",
  phone: "505"
}, {
  capital: "Amsterdam",
  code: "NL",
  continent: "EU",
  currency: "EUR",
  name: "Netherlands",
  phone: "31"
}, {
  capital: "Oslo",
  code: "NO",
  continent: "EU",
  currency: "NOK",
  name: "Norway",
  phone: "47"
}, {
  capital: "Kathmandu",
  code: "NP",
  continent: "AS",
  currency: "NPR",
  name: "Nepal",
  phone: "977"
}, {
  capital: "Yaren",
  code: "NR",
  continent: "OC",
  currency: "AUD",
  name: "Nauru",
  phone: "674"
}, {
  capital: "Alofi",
  code: "NU",
  continent: "OC",
  currency: "NZD",
  name: "Niue",
  phone: "683"
}, {
  capital: "Wellington",
  code: "NZ",
  continent: "OC",
  currency: "NZD",
  name: "New Zealand",
  phone: "64"
}, {
  capital: "Muscat",
  code: "OM",
  continent: "AS",
  currency: "OMR",
  name: "Oman",
  phone: "968"
}, {
  capital: "Panama City",
  code: "PA",
  continent: "NA",
  currency: "PAB,USD",
  name: "Panama",
  phone: "507"
}, {
  capital: "Lima",
  code: "PE",
  continent: "SA",
  currency: "PEN",
  name: "Peru",
  phone: "51"
}, {
  capital: "Papeetē",
  code: "PF",
  continent: "OC",
  currency: "XPF",
  name: "French Polynesia",
  phone: "689"
}, {
  capital: "Port Moresby",
  code: "PG",
  continent: "OC",
  currency: "PGK",
  name: "Papua New Guinea",
  phone: "675"
}, {
  capital: "Manila",
  code: "PH",
  continent: "AS",
  currency: "PHP",
  name: "Philippines",
  phone: "63"
}, {
  capital: "Islamabad",
  code: "PK",
  continent: "AS",
  currency: "PKR",
  name: "Pakistan",
  phone: "92"
}, {
  capital: "Warsaw",
  code: "PL",
  continent: "EU",
  currency: "PLN",
  name: "Poland",
  phone: "48"
}, {
  capital: "Saint-Pierre",
  code: "PM",
  continent: "NA",
  currency: "EUR",
  name: "Saint Pierre and Miquelon",
  phone: "508"
}, {
  capital: "Adamstown",
  code: "PN",
  continent: "OC",
  currency: "NZD",
  name: "Pitcairn Islands",
  phone: "64"
}, {
  capital: "San Juan",
  code: "PR",
  continent: "NA",
  currency: "USD",
  name: "Puerto Rico",
  phone: "1787,1939"
}, {
  capital: "Ramallah",
  code: "PS",
  continent: "AS",
  currency: "ILS",
  name: "Palestine",
  phone: "970"
}, {
  capital: "Lisbon",
  code: "PT",
  continent: "EU",
  currency: "EUR",
  name: "Portugal",
  phone: "351"
}, {
  capital: "Ngerulmud",
  code: "PW",
  continent: "OC",
  currency: "USD",
  name: "Palau",
  phone: "680"
}, {
  capital: "Asunción",
  code: "PY",
  continent: "SA",
  currency: "PYG",
  name: "Paraguay",
  phone: "595"
}, {
  capital: "Doha",
  code: "QA",
  continent: "AS",
  currency: "QAR",
  name: "Qatar",
  phone: "974"
}, {
  capital: "Saint-Denis",
  code: "RE",
  continent: "AF",
  currency: "EUR",
  name: "Réunion",
  phone: "262"
}, {
  capital: "Bucharest",
  code: "RO",
  continent: "EU",
  currency: "RON",
  name: "Romania",
  phone: "40"
}, {
  capital: "Belgrade",
  code: "RS",
  continent: "EU",
  currency: "RSD",
  name: "Serbia",
  phone: "381"
}, {
  capital: "Moscow",
  code: "RU",
  continent: "EU",
  currency: "RUB",
  name: "Russia",
  phone: "7"
}, {
  capital: "Kigali",
  code: "RW",
  continent: "AF",
  currency: "RWF",
  name: "Rwanda",
  phone: "250"
}, {
  capital: "Riyadh",
  code: "SA",
  continent: "AS",
  currency: "SAR",
  name: "Saudi Arabia",
  phone: "966"
}, {
  capital: "Honiara",
  code: "SB",
  continent: "OC",
  currency: "SBD",
  name: "Solomon Islands",
  phone: "677"
}, {
  capital: "Victoria",
  code: "SC",
  continent: "AF",
  currency: "SCR",
  name: "Seychelles",
  phone: "248"
}, {
  capital: "Khartoum",
  code: "SD",
  continent: "AF",
  currency: "SDG",
  name: "Sudan",
  phone: "249"
}, {
  capital: "Stockholm",
  code: "SE",
  continent: "EU",
  currency: "SEK",
  name: "Sweden",
  phone: "46"
}, {
  capital: "Singapore",
  code: "SG",
  continent: "AS",
  currency: "SGD",
  name: "Singapore",
  phone: "65"
}, {
  capital: "Jamestown",
  code: "SH",
  continent: "AF",
  currency: "SHP",
  name: "Saint Helena",
  phone: "290"
}, {
  capital: "Ljubljana",
  code: "SI",
  continent: "EU",
  currency: "EUR",
  name: "Slovenia",
  phone: "386"
}, {
  capital: "Longyearbyen",
  code: "SJ",
  continent: "EU",
  currency: "NOK",
  name: "Svalbard and Jan Mayen",
  phone: "4779"
}, {
  capital: "Bratislava",
  code: "SK",
  continent: "EU",
  currency: "EUR",
  name: "Slovakia",
  phone: "421"
}, {
  capital: "Freetown",
  code: "SL",
  continent: "AF",
  currency: "SLL",
  name: "Sierra Leone",
  phone: "232"
}, {
  capital: "City of San Marino",
  code: "SM",
  continent: "EU",
  currency: "EUR",
  name: "San Marino",
  phone: "378"
}, {
  capital: "Dakar",
  code: "SN",
  continent: "AF",
  currency: "XOF",
  name: "Senegal",
  phone: "221"
}, {
  capital: "Mogadishu",
  code: "SO",
  continent: "AF",
  currency: "SOS",
  name: "Somalia",
  phone: "252"
}, {
  capital: "Paramaribo",
  code: "SR",
  continent: "SA",
  currency: "SRD",
  name: "Suriname",
  phone: "597"
}, {
  capital: "Juba",
  code: "SS",
  continent: "AF",
  currency: "SSP",
  name: "South Sudan",
  phone: "211"
}, {
  capital: "São Tomé",
  code: "ST",
  continent: "AF",
  currency: "STD",
  name: "São Tomé and Príncipe",
  phone: "239"
}, {
  capital: "San Salvador",
  code: "SV",
  continent: "NA",
  currency: "SVC,USD",
  name: "El Salvador",
  phone: "503"
}, {
  capital: "Philipsburg",
  code: "SX",
  continent: "NA",
  currency: "ANG",
  name: "Sint Maarten",
  phone: "1721"
}, {
  capital: "Damascus",
  code: "SY",
  continent: "AS",
  currency: "SYP",
  name: "Syria",
  phone: "963"
}, {
  capital: "Lobamba",
  code: "SZ",
  continent: "AF",
  currency: "SZL",
  name: "Swaziland",
  phone: "268"
}, {
  capital: "Cockburn Town",
  code: "TC",
  continent: "NA",
  currency: "USD",
  name: "Turks and Caicos Islands",
  phone: "1649"
}, {
  capital: "N'Djamena",
  code: "TD",
  continent: "AF",
  currency: "XAF",
  name: "Chad",
  phone: "235"
}, {
  capital: "Port-aux-Français",
  code: "TF",
  continent: "AN",
  currency: "EUR",
  name: "French Southern Territories",
  phone: "262"
}, {
  capital: "Lomé",
  code: "TG",
  continent: "AF",
  currency: "XOF",
  name: "Togo",
  phone: "228"
}, {
  capital: "Bangkok",
  code: "TH",
  continent: "AS",
  currency: "THB",
  name: "Thailand",
  phone: "66"
}, {
  capital: "Dushanbe",
  code: "TJ",
  continent: "AS",
  currency: "TJS",
  name: "Tajikistan",
  phone: "992"
}, {
  capital: "Fakaofo",
  code: "TK",
  continent: "OC",
  currency: "NZD",
  name: "Tokelau",
  phone: "690"
}, {
  capital: "Dili",
  code: "TL",
  continent: "OC",
  currency: "USD",
  name: "East Timor",
  phone: "670"
}, {
  capital: "Ashgabat",
  code: "TM",
  continent: "AS",
  currency: "TMT",
  name: "Turkmenistan",
  phone: "993"
}, {
  capital: "Tunis",
  code: "TN",
  continent: "AF",
  currency: "TND",
  name: "Tunisia",
  phone: "216"
}, {
  capital: "Nuku'alofa",
  code: "TO",
  continent: "OC",
  currency: "TOP",
  name: "Tonga",
  phone: "676"
}, {
  capital: "Ankara",
  code: "TR",
  continent: "AS",
  currency: "TRY",
  name: "Turkey",
  phone: "90"
}, {
  capital: "Port of Spain",
  code: "TT",
  continent: "NA",
  currency: "TTD",
  name: "Trinidad and Tobago",
  phone: "1868"
}, {
  capital: "Funafuti",
  code: "TV",
  continent: "OC",
  currency: "AUD",
  name: "Tuvalu",
  phone: "688"
}, {
  capital: "Taipei",
  code: "TW",
  continent: "AS",
  currency: "TWD",
  name: "Taiwan",
  phone: "886"
}, {
  capital: "Dodoma",
  code: "TZ",
  continent: "AF",
  currency: "TZS",
  name: "Tanzania",
  phone: "255"
}, {
  capital: "Kyiv",
  code: "UA",
  continent: "EU",
  currency: "UAH",
  name: "Ukraine",
  phone: "380"
}, {
  capital: "Kampala",
  code: "UG",
  continent: "AF",
  currency: "UGX",
  name: "Uganda",
  phone: "256"
}, {
  capital: "",
  code: "UM",
  continent: "OC",
  currency: "USD",
  name: "U.S. Minor Outlying Islands",
  phone: "1"
}, {
  capital: "Washington D.C.",
  code: "US",
  continent: "NA",
  currency: "USD,USN,USS",
  name: "United States",
  phone: "1"
}, {
  capital: "Montevideo",
  code: "UY",
  continent: "SA",
  currency: "UYI,UYU",
  name: "Uruguay",
  phone: "598"
}, {
  capital: "Tashkent",
  code: "UZ",
  continent: "AS",
  currency: "UZS",
  name: "Uzbekistan",
  phone: "998"
}, {
  capital: "Vatican City",
  code: "VA",
  continent: "EU",
  currency: "EUR",
  name: "Vatican City",
  phone: "39066,379"
}, {
  capital: "Kingstown",
  code: "VC",
  continent: "NA",
  currency: "XCD",
  name: "Saint Vincent and the Grenadines",
  phone: "1784"
}, {
  capital: "Caracas",
  code: "VE",
  continent: "SA",
  currency: "VEF",
  name: "Venezuela",
  phone: "58"
}, {
  capital: "Road Town",
  code: "VG",
  continent: "NA",
  currency: "USD",
  name: "British Virgin Islands",
  phone: "1284"
}, {
  capital: "Charlotte Amalie",
  code: "VI",
  continent: "NA",
  currency: "USD",
  name: "U.S. Virgin Islands",
  phone: "1340"
}, {
  capital: "Hanoi",
  code: "VN",
  continent: "AS",
  currency: "VND",
  name: "Vietnam",
  phone: "84"
}, {
  capital: "Port Vila",
  code: "VU",
  continent: "OC",
  currency: "VUV",
  name: "Vanuatu",
  phone: "678"
}, {
  capital: "Mata-Utu",
  code: "WF",
  continent: "OC",
  currency: "XPF",
  name: "Wallis and Futuna",
  phone: "681"
}, {
  capital: "Apia",
  code: "WS",
  continent: "OC",
  currency: "WST",
  name: "Samoa",
  phone: "685"
}, {
  capital: "Pristina",
  code: "XK",
  continent: "EU",
  currency: "EUR",
  name: "Kosovo",
  phone: "377,381,383,386"
}, {
  capital: "Sana'a",
  code: "YE",
  continent: "AS",
  currency: "YER",
  name: "Yemen",
  phone: "967"
}, {
  capital: "Mamoudzou",
  code: "YT",
  continent: "AF",
  currency: "EUR",
  name: "Mayotte",
  phone: "262"
}, {
  capital: "Pretoria",
  code: "ZA",
  continent: "AF",
  currency: "ZAR",
  name: "South Africa",
  phone: "27"
}, {
  capital: "Lusaka",
  code: "ZM",
  continent: "AF",
  currency: "ZMK",
  name: "Zambia",
  phone: "260"
}, {
  capital: "Harare",
  code: "ZW",
  continent: "AF",
  currency: "ZWL",
  name: "Zimbabwe",
  phone: "263"
}];

function getDataForBubbles(valuesForRegions) {
  return countries.reduce(function (acc, country) {
    for (var i = 0; i < regions.length; i++) {
      var region = regions[i];

      if (country.code === region.bubbleCountryCode) {
        var regionCode = region.code;
        acc[regionCode].push(country);
        country.z = valuesForRegions[regionCode].weight;
        country.continentName = valuesForRegions[regionCode].name;
        break;
      }
    }

    return acc;
  }, {
    AF: [],
    AM: [],
    AS: [],
    EU: [],
    LA: [],
    OTHERS: []
  });
}

function getDataForAreas(valuesForRegions) {
  return countries.reduce(function (acc, country) {
    var regionCode = 'OTHERS';

    if (country.continent === 'AF' || nearEastCodes.includes(country.code)) {
      // Africa and Near East
      regionCode = 'AF';
      acc.AF.push(country);
    } else if (country.continent === 'NA' && !latinAmericanAndCaribbeanCodes.includes(country.code) && country.code !== 'GL') {
      // North America (not Greenland)
      regionCode = 'AM';
      acc.AM.push(country);
    } else if (country.continent === 'AS' || country.continent === 'OC' || country.code === 'RU') {
      // Asia-Pacific + Rusia
      regionCode = 'AS';
      acc.AS.push(country);
    } else if (country.continent === 'SA' || latinAmericanAndCaribbeanCodes.includes(country.code)) {
      // Latin America
      regionCode = 'LA';
      acc.LA.push(country);
    } else if (country.continent === 'EU' || country.code === 'GL') {
      // Europe
      regionCode = 'EU';
      acc.EU.push(country);
    } else {
      // Others
      acc.OTHERS.push(country);
    }

    country.value = valuesForRegions[regionCode].weight;
    country.continentName = valuesForRegions[regionCode].name;
    return acc;
  }, {
    AF: [],
    AM: [],
    AS: [],
    EU: [],
    LA: [],
    OTHERS: []
  });
}

function getCountriesByRegion(valuesForRegions, options) {
  // complete missing regions
  regions.forEach(function (region) {
    var code = region.code;

    if (!valuesForRegions[code]) {
      valuesForRegions[code] = {
        name: region.name,
        marketValue: 0,
        weight: 0,
        code: code
      };
    }
  });
  var useBubbles = options.useBubbles;

  if (useBubbles) {
    return getDataForBubbles(valuesForRegions);
  }

  return getDataForAreas(valuesForRegions);
}

function hexToRGB$1(color) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!options.opacity) options.opacity = 1;
  var opacity = options.opacity;
  var r = parseInt(color.substring(1, 3), 16);
  var g = parseInt(color.substring(3, 5), 16);
  var b = parseInt(color.substring(5, 7), 16);
  return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
}

function getValuesByRegion(values) {
  var validCodes = [];
  var valuesByRegion = values.reduce(function (acc, region) {
    var code = region.code || 'OTHERS';
    validCodes.push(code);
    acc[code] = {
      name: region.name,
      code: region.code,
      marketValue: region.market_value,
      weight: region.weight * 100
    };
    return acc;
  }, {});
  return {
    valuesByRegion: valuesByRegion,
    validCodes: validCodes
  };
}

function getSeriesFromValues(values, options) {
  var hideZeros = options.hideZeros,
      useOpacity = options.useOpacity,
      colors = options.colors,
      useBubbles = options.useBubbles,
      fixedSize = options.fixedSize;

  var _getValuesByRegion = getValuesByRegion(values),
      valuesByRegion = _getValuesByRegion.valuesByRegion,
      validCodes = _getValuesByRegion.validCodes; // get list of countries and set the correct `value` property for each country


  var countriesByRegion = getCountriesByRegion(valuesByRegion, options);
  var weights = []; // get a sorted array of region codes and their weights, so opacity can be
  // applied

  Object.keys(countriesByRegion).forEach(function (regionCode) {
    weights.push({
      code: regionCode,
      weight: useBubbles ? countriesByRegion[regionCode][0].z : countriesByRegion[regionCode][0].value
    });
  });
  weights.sort(function (a, b) {
    return b.weight - a.weight;
  });
  /**
   * Finally go through the sorted elements and add the series to the final result.
   *  - Color is added here depending on `useOpacity`.
   *  - With this method, the legend will also appear sorted
   *  - If `hideZeros` is `true`, series will be added only when the data exists
   *    for the given region code.
   */

  var opacity = 1;
  var mapColors = helpers.getColors(colors, getGlobalConfig(), Object.keys(countriesByRegion).length);
  var series = [{
    allAreas: true,
    showInLegend: false
  }];
  weights.forEach(function (elem, idx) {
    var regionCode = elem.code;
    var weight = elem.weight;
    var valueIsZero = weight === 0;
    var showCode = validCodes.includes(regionCode);

    if (!hideZeros || showCode && !valueIsZero) {
      var serie = {
        type: useBubbles ? 'mapbubble' : 'map',
        data: countriesByRegion[regionCode],
        joinBy: ['iso-a2', 'code'],
        name: countriesByRegion[regionCode][0].continentName,
        borderWidth: 0.1,
        minSize: fixedSize ? '25%' : '0%',
        maxSize: fixedSize ? '25%' : '30%'
      };

      if (mapColors[idx]) {
        serie.color = hexToRGB$1(mapColors[idx], {
          opacity: opacity
        });
      }

      series.push(serie);
      opacity = useOpacity ? opacity - 0.15 : opacity;
    }
  });
  return series;
}

var AllocationMap = function AllocationMap(props) {
  var data = props.data,
      title$$1 = props.title,
      showLegend = props.showLegend,
      orientation = props.orientation,
      disableLegendClick = props.disableLegendClick,
      language = props.language,
      tooltipOptions = props.tooltipOptions;
  var useBubbles = props.useBubbles;
  var values = data['by_region'];
  var errorsInData = allocationErrors(data);
  var series = getSeriesFromValues(values, props);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var verticalLegendOptions = {
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'middle',
    itemMarginBottom: 7,
    x: 0
  };
  var options = {
    chart: {
      style: {
        fontFamily: 'inherit'
      },
      marginTop: 0,
      map: mapData
    },
    credits: {
      enabled: false
    },
    title: null,
    legend: {
      enabled: showLegend,
      useHTML: true,
      itemStyle: {
        'fontWeight': 'normal',
        'cursor': disableLegendClick ? 'default' : 'pointer'
      },
      navigation: {
        enabled: false
      },
      labelFormatter: function labelFormatter() {
        var value = void 0;

        if (useBubbles) {
          value = this.zData && this.zData[0] ? this.zData[0] : 0;
        } else {
          value = this.valueData && this.valueData[0] ? this.valueData[0] : 0;
        }

        return orientation === 'vertical' ? '<b>' + this.name + '</b><br/> ' + lessThanZero(value, locale) + '%' : '<b>' + this.name + ':</b> ' + lessThanZero(value, locale) + '%';
      }
    },
    plotOptions: {
      map: {
        allAreas: false,
        events: {
          legendItemClick: function legendItemClick() {
            return !disableLegendClick;
          }
        }
      },
      series: {
        tooltip: {
          pointFormatter: function pointFormatter() {
            if (useBubbles) {
              return numberDecimalFormat(this.z, locale) + '%';
            }

            return lessThanZero(this.value, locale) + '%';
          }
        },
        point: {
          events: {
            mouseOver: function mouseOver() {
              this.series.data.map(function (point) {
                point.setState('hover');
              });
            },
            mouseOut: function mouseOut() {
              this.series.data.map(function (point) {
                point.setState('');
              });
            }
          }
        }
      }
    },
    series: series
  };
  Object.assign(options.legend, orientation === 'vertical' ? verticalLegendOptions : null);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title$$1,
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement(HighchartsBase, {
    language: locale,
    options: options,
    constructorType: 'mapChart',
    callback: function callback(chart) {
      // max height should be the container size minus the Title + InfoTooltip height.
      chart.container.parentElement.style.maxHeight = 'calc(100% - 55px)';
      chart.reflow();
    }
  }));
};

AllocationMap.propTypes = {
  data: PropTypes.shape().isRequired,
  title: PropTypes.string,
  language: PropTypes.string,
  showLegend: PropTypes.bool,
  disableLegendClick: PropTypes.bool,
  orientation: OrientationPropType,
  colors: ColorsPropType,
  hideZeros: PropTypes.bool,
  useOpacity: PropTypes.bool,
  useBubbles: PropTypes.bool,
  fixedSize: PropTypes.bool,
  tooltipOptions: TooltipOptionsPropType
};
AllocationMap.propDefs = {
  data: {
    type: 'Object',
    description: 'Data to be displayed in the map. Expects the shape from Core.Analyse Allocation endpoint.'
  },
  title: Defs.titleDef,
  colors: Defs.arrayColorsDef,
  hideZeros: {
    type: 'bool',
    description: 'Whether to hide regions with no allocation assigned to them or not.'
  },
  useOpacity: {
    type: 'bool',
    description: 'Whether to vary the opacity regions based on the allocation assigned to them.'
  },
  useBubbles: {
    type: 'bool',
    description: 'Whether to use bubbles as a display on the map.'
  },
  fixedSize: {
    type: 'bool',
    description: 'Whether the bubbles should have a fixed size or it should vary on the allocation of the region.'
  },
  disableLegendClick: {
    type: 'bool',
    description: 'Disables user interaction with the legend.'
  },
  showLegend: {
    type: 'bool',
    description: 'Whether to show legend or not.'
  },
  orientation: Defs.orientationsDef,
  language: Defs.languageDef,
  tooltipOptions: Defs.tooltipOptionsDef
};
AllocationMap.defaultProps = {
  colors: null,
  title: 'Regional Allocation',
  useOpacity: true,
  hideZeros: true,
  useBubbles: false,
  fixedSize: false,
  orientation: 'horizontal',
  language: '',
  showLegend: true,
  disableLegendClick: false,
  tooltipOptions: {}
};
var umd = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory(exports, React__default);
  })(commonjsGlobal, function (exports, React) {
    var React__default$$1 = 'default' in React ? React['default'] : React;

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === 'function') {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function _objectWithoutProperties(source, excluded) {
      if (source == null) return {};

      var target = _objectWithoutPropertiesLoose(source, excluded);

      var key, i;

      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
          target[key] = source[key];
        }
      }

      return target;
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }

    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      }
    }

    function _iterableToArray(iter) {
      if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }

    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    } // Arbitrary, but ought to be unique to avoid context namespace clashes.


    var CONTEXT_KEY = 'react-accessible-accordion@AccordionContainer';

    var Provider = /*#__PURE__*/function (_Component) {
      _inherits(Provider, _Component);

      function Provider() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Provider);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Provider)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
          items: _this.props.items || []
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addItem", function (newItem) {
          // Need to use callback style otherwise race-conditions are created by concurrent registrations.
          _this.setState(function (state) {
            var items;

            if (state.items.some(function (item) {
              return item.uuid === newItem.uuid;
            })) {
              // eslint-disable-next-line no-console
              console.error("AccordionItem error: One item already has the uuid \"".concat(newItem.uuid, "\". Uuid property must be unique. See: https://github.com/springload/react-accessible-accordion#accordionitem"));
            }

            if (_this.props.accordion && newItem.expanded) {
              // If this is a true accordion and the new item is expanded, then the others must be closed.
              items = _toConsumableArray(state.items.map(function (item) {
                return _objectSpread({}, item, {
                  expanded: false
                });
              })).concat([newItem]);
            } else {
              items = _toConsumableArray(state.items).concat([newItem]);
            }

            return {
              items: items
            };
          });
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeItem", function (key) {
          return _this.setState(function (state) {
            return {
              items: state.items.filter(function (item) {
                return item.uuid !== key;
              })
            };
          });
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setExpanded", function (key, expanded) {
          return _this.setState(function (state) {
            return {
              items: state.items.map(function (item) {
                if (item.uuid === key) {
                  return _objectSpread({}, item, {
                    expanded: expanded
                  });
                }

                if (_this.props.accordion && expanded) {
                  // If this is an accordion, we might need to collapse the other expanded item.
                  return _objectSpread({}, item, {
                    expanded: false
                  });
                }

                return item;
              })
            };
          }, function () {
            if (_this.props.onChange) {
              _this.props.onChange(_this.props.accordion ? key : _this.state.items.filter(function (item) {
                return item.expanded;
              }).map(function (item) {
                return item.uuid;
              }));
            }
          });
        });

        return _this;
      }

      _createClass(Provider, [{
        key: "getChildContext",
        value: function getChildContext() {
          var context = {
            items: this.state.items,
            accordion: !!this.props.accordion,
            addItem: this.addItem,
            removeItem: this.removeItem,
            setExpanded: this.setExpanded
          };
          return _defineProperty({}, CONTEXT_KEY, context);
        }
      }, {
        key: "render",
        value: function render() {
          return this.props.children || null;
        }
      }]);

      return Provider;
    }(React.Component); // eslint-disable-next-line react/no-multi-comp


    _defineProperty(Provider, "childContextTypes", _defineProperty({}, CONTEXT_KEY, function () {
      return null;
    }));

    var Consumer = /*#__PURE__*/function (_Component2) {
      _inherits(Consumer, _Component2);

      function Consumer() {
        _classCallCheck(this, Consumer);

        return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
      }

      _createClass(Consumer, [{
        key: "render",
        value: function render() {
          return this.props.children(this.context[CONTEXT_KEY]);
        }
      }]);

      return Consumer;
    }(React.Component);

    _defineProperty(Consumer, "contextTypes", _defineProperty({}, CONTEXT_KEY, function () {
      return null;
    }));

    var accordionDefaultProps = {
      accordion: true
    };

    var Accordion = function Accordion(_ref) {
      var accordion = _ref.accordion,
          rest = _objectWithoutProperties(_ref, ["accordion"]);

      return React__default$$1.createElement("div", _extends({
        role: accordion ? 'tablist' : null
      }, rest));
    };

    Accordion.defaultProps = accordionDefaultProps;
    var defaultProps = {
      accordion: true,
      onChange: function onChange() {},
      className: 'accordion',
      children: null
    };

    var AccordionWrapper = /*#__PURE__*/function (_Component) {
      _inherits(AccordionWrapper, _Component);

      function AccordionWrapper() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, AccordionWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderAccordion", function (accordionStore) {
          var _this$props = _this.props,
              accordion = _this$props.accordion,
              onChange = _this$props.onChange,
              rest = _objectWithoutProperties(_this$props, ["accordion", "onChange"]);

          return React__default$$1.createElement(Accordion, _extends({
            accordion: accordionStore.accordion
          }, rest));
        });

        return _this;
      }

      _createClass(AccordionWrapper, [{
        key: "render",
        value: function render() {
          return React__default$$1.createElement(Provider, {
            accordion: this.props.accordion,
            onChange: this.props.onChange
          }, React__default$$1.createElement(Consumer, null, this.renderAccordion));
        }
      }]);

      return AccordionWrapper;
    }(React.Component);

    _defineProperty(AccordionWrapper, "defaultProps", defaultProps);
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     *
     * @typechecks
     * 
     */


    function _inheritsLoose$1(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */


    function unwrapExports$$1(x) {
      return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function createCommonjsModule$$1(fn, module) {
      return module = {
        exports: {}
      }, fn(module, module.exports), module.exports;
    }

    var lib = createCommonjsModule$$1(function (module, exports) {
      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
        var currentListeners = [];
        var nextListeners = currentListeners;

        function ensureCanMutateNextListeners() {
          if (nextListeners === currentListeners) {
            nextListeners = currentListeners.slice();
          }
        }

        function listen(listener) {
          if (typeof listener !== 'function') {
            throw new Error('Expected listener to be a function.');
          }

          var isSubscribed = true;
          ensureCanMutateNextListeners();
          nextListeners.push(listener);
          return function () {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
          };
        }

        function emit() {
          currentListeners = nextListeners;
          var listeners = currentListeners;

          for (var i = 0; i < listeners.length; i++) {
            listeners[i].apply(listeners, arguments);
          }
        }

        return {
          listen: listen,
          emit: emit
        };
      };
    });
    unwrapExports$$1(lib);
    var lib_1 = lib.createChangeEmitter;

    function symbolObservablePonyfill(root) {
      var result;
      var Symbol = root.Symbol;

      if (typeof Symbol === 'function') {
        if (Symbol.observable) {
          result = Symbol.observable;
        } else {
          result = Symbol('observable');
          Symbol.observable = result;
        }
      } else {
        result = '@@observable';
      }

      return result;
    }
    /* global window */


    var root;

    if (typeof self !== 'undefined') {
      root = self;
    } else if (typeof window !== 'undefined') {
      root = window;
    } else if (typeof commonjsGlobal !== 'undefined') {
      root = commonjsGlobal;
    } else {
      root = module;
    }

    var result = symbolObservablePonyfill(root);

    var Nothing = /*#__PURE__*/function (_Component) {
      _inheritsLoose$1(Nothing, _Component);

      function Nothing() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = Nothing.prototype;

      _proto.render = function render() {
        return null;
      };

      return Nothing;
    }(React.Component);

    var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
      if (renderPropName === void 0) {
        renderPropName = 'children';
      }

      return function (BaseComponent) {
        var baseFactory = React__default$$1.createFactory(BaseComponent);
        var renderPropsFactory = React__default$$1.createFactory(RenderPropsComponent);

        var FromRenderProps = function FromRenderProps(ownerProps) {
          var _renderPropsFactory;

          return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
            return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
          }, _renderPropsFactory));
        };

        return FromRenderProps;
      };
    };

    var compose = function compose() {
      for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
        funcs[_key] = arguments[_key];
      }

      return funcs.reduce(function (a, b) {
        return function () {
          return a(b.apply(void 0, arguments));
        };
      }, function (arg) {
        return arg;
      });
    };
    /*!
     * consecutive
     * Get consecutive numbers
     * Copyright(c) 2017 ivanoff .$ curl -A cv ivanoff.org.ua
     * MIT Licensed
     */


    var consecutive = function consecutive(begin, base, inc) {
      var number = begin || 0;
      if (typeof base !== 'number') base = 10;
      if (typeof inc !== 'number') inc = 1;
      return function () {
        var res;

        if (typeof base === 'undefined' || base === 10) {
          res = number;
          number += inc;
        } else {
          res = number.toString();
          number = (parseInt(number, base) + inc).toString(base);
        }

        return res;
      };
    }; // Arbitrary, but ought to be unique to avoid context namespace clashes.


    var CONTEXT_KEY$1 = 'react-accessible-accordion@ItemContainer';

    var Provider$1 = /*#__PURE__*/function (_Component) {
      _inherits(Provider, _Component);

      function Provider() {
        _classCallCheck(this, Provider);

        return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
      }

      _createClass(Provider, [{
        key: "getChildContext",
        value: function getChildContext() {
          var uuid = this.props.uuid;
          var context = {
            uuid: uuid
          };
          return _defineProperty({}, CONTEXT_KEY$1, context);
        }
      }, {
        key: "render",
        value: function render() {
          return this.props.children || null;
        }
      }]);

      return Provider;
    }(React.Component);

    _defineProperty(Provider$1, "childContextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
      return null;
    })); // eslint-disable-next-line react/no-multi-comp


    var Consumer$1 = /*#__PURE__*/function (_Component2) {
      _inherits(Consumer, _Component2);

      function Consumer() {
        _classCallCheck(this, Consumer);

        return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
      }

      _createClass(Consumer, [{
        key: "render",
        value: function render() {
          return this.props.children(this.context[CONTEXT_KEY$1]);
        }
      }]);

      return Consumer;
    }(React.Component);

    _defineProperty(Consumer$1, "contextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
      return null;
    }));

    var classnames = createCommonjsModule$$1(function (module) {
      /*!
        Copyright (c) 2016 Jed Watson.
        Licensed under the MIT License (MIT), see
        http://jedwatson.github.io/classnames
      */

      /* global define */
      (function () {
        var hasOwn = {}.hasOwnProperty;

        function classNames() {
          var classes = [];

          for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;

            if (argType === 'string' || argType === 'number') {
              classes.push(arg);
            } else if (Array.isArray(arg)) {
              classes.push(classNames.apply(null, arg));
            } else if (argType === 'object') {
              for (var key in arg) {
                if (hasOwn.call(arg, key) && arg[key]) {
                  classes.push(key);
                }
              }
            }
          }

          return classes.join(' ');
        }

        if (module.exports) {
          module.exports = classNames;
        } else {
          window.classNames = classNames;
        }
      })();
    });

    var AccordionItem = /*#__PURE__*/function (_Component) {
      _inherits(AccordionItem, _Component);

      function AccordionItem() {
        _classCallCheck(this, AccordionItem);

        return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItem).apply(this, arguments));
      }

      _createClass(AccordionItem, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this$props = this.props,
              uuid = _this$props.uuid,
              accordionStore = _this$props.accordionStore,
              disabled = _this$props.disabled;
          accordionStore.addItem({
            uuid: uuid,
            expanded: this.props.expanded || false,
            disabled: disabled
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.props.accordionStore.removeItem(this.props.uuid);
        } // This is here so that the user can dynamically set the 'expanded' state using the 'expanded' prop.

      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props2 = this.props,
              uuid = _this$props2.uuid,
              expanded = _this$props2.expanded,
              accordionStore = _this$props2.accordionStore;

          if (expanded !== prevProps.expanded) {
            accordionStore.setExpanded(uuid, expanded);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props3 = this.props,
              uuid = _this$props3.uuid,
              className = _this$props3.className,
              hideBodyClassName = _this$props3.hideBodyClassName,
              accordionStore = _this$props3.accordionStore,
              disabled = _this$props3.disabled,
              expanded = _this$props3.expanded,
              rest = _objectWithoutProperties(_this$props3, ["uuid", "className", "hideBodyClassName", "accordionStore", "disabled", "expanded"]); // Deliberately not using 'find' because IE compat.


          var currentItem = accordionStore.items.filter(function (item) {
            return item.uuid === uuid;
          })[0];

          if (!currentItem) {
            return null;
          }

          return React__default$$1.createElement("div", _extends({
            className: classnames(className, _defineProperty({}, hideBodyClassName, !currentItem.expanded && hideBodyClassName))
          }, rest));
        }
      }]);

      return AccordionItem;
    }(React.Component);

    var nextUuid = consecutive();

    function resetNextUuid() {
      nextUuid = consecutive();
    }

    var AccordionItemWrapper = /*#__PURE__*/function (_Component) {
      _inherits(AccordionItemWrapper, _Component);

      function AccordionItemWrapper() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, AccordionItemWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "id", nextUuid());

        return _this;
      }

      _createClass(AccordionItemWrapper, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              accordionStore = _this$props.accordionStore,
              uuid = _this$props.uuid,
              rest = _objectWithoutProperties(_this$props, ["accordionStore", "uuid"]);

          var itemUuid = uuid !== undefined ? uuid : this.id;
          return React__default$$1.createElement(Provider$1, {
            uuid: itemUuid
          }, React__default$$1.createElement(AccordionItem, _extends({}, rest, {
            uuid: itemUuid,
            accordionStore: accordionStore
          })));
        }
      }]);

      return AccordionItemWrapper;
    }(React.Component);

    _defineProperty(AccordionItemWrapper, "defaultProps", {
      className: 'accordion__item',
      hideBodyClassName: '',
      disabled: false,
      expanded: false,
      uuid: undefined
    });

    var AccordionItem_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
      return {
        accordionStore: accordionStore
      };
    }))(AccordionItemWrapper);

    var AccordionItemTitle = /*#__PURE__*/function (_Component) {
      _inherits(AccordionItemTitle, _Component);

      function AccordionItemTitle() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, AccordionItemTitle);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemTitle)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
          var _this$props = _this.props,
              uuid = _this$props.uuid,
              expanded = _this$props.expanded,
              setExpanded = _this$props.setExpanded;
          setExpanded(uuid, !expanded);
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyPress", function (evt) {
          if (evt.charCode === 13 || evt.charCode === 32) {
            evt.preventDefault();

            _this.handleClick();
          }
        });

        return _this;
      }

      _createClass(AccordionItemTitle, [{
        key: "render",
        value: function render() {
          var _this$props2 = this.props,
              className = _this$props2.className,
              hideBodyClassName = _this$props2.hideBodyClassName,
              item = _this$props2.item,
              accordion = _this$props2.accordion,
              setExpanded = _this$props2.setExpanded,
              expanded = _this$props2.expanded,
              uuid = _this$props2.uuid,
              disabled = _this$props2.disabled,
              rest = _objectWithoutProperties(_this$props2, ["className", "hideBodyClassName", "item", "accordion", "setExpanded", "expanded", "uuid", "disabled"]);

          var id = "accordion__title-".concat(uuid);
          var ariaControls = "accordion__body-".concat(uuid);
          var role = accordion ? 'tab' : 'button';
          var titleClassName = classnames(className, _defineProperty({}, hideBodyClassName, hideBodyClassName && !expanded));

          if (role === 'tab') {
            return React__default$$1.createElement("div", _extends({
              id: id,
              "aria-selected": expanded,
              "aria-controls": ariaControls,
              className: titleClassName,
              onClick: disabled ? undefined : this.handleClick,
              role: role,
              tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
              ,
              onKeyPress: this.handleKeyPress,
              disabled: disabled
            }, rest));
          }

          return React__default$$1.createElement("div", _extends({
            id: id,
            "aria-expanded": expanded,
            "aria-controls": ariaControls,
            className: titleClassName,
            onClick: disabled ? undefined : this.handleClick,
            role: role,
            tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
            ,
            onKeyPress: this.handleKeyPress,
            disabled: disabled
          }, rest));
        }
      }]);

      return AccordionItemTitle;
    }(React.Component);

    _defineProperty(AccordionItemTitle, "accordionElementName", 'AccordionItemTitle'); // eslint-disable-next-line react/prefer-stateless-function


    var AccordionItemTitleWrapper = /*#__PURE__*/function (_Component) {
      _inherits(AccordionItemTitleWrapper, _Component);

      function AccordionItemTitleWrapper() {
        _classCallCheck(this, AccordionItemTitleWrapper);

        return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemTitleWrapper).apply(this, arguments));
      }

      _createClass(AccordionItemTitleWrapper, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              itemStore = _this$props.itemStore,
              accordionStore = _this$props.accordionStore,
              rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);

          var uuid = itemStore.uuid;
          var items = accordionStore.items,
              accordion = accordionStore.accordion;
          var item = items.filter(function (stateItem) {
            return stateItem.uuid === uuid;
          })[0];
          return React__default$$1.createElement(AccordionItemTitle, _extends({}, rest, item, {
            setExpanded: accordionStore.setExpanded,
            accordion: accordion
          }));
        }
      }]);

      return AccordionItemTitleWrapper;
    }(React.Component);

    _defineProperty(AccordionItemTitleWrapper, "defaultProps", {
      className: 'accordion__title',
      hideBodyClassName: ''
    });

    var AccordionItemTitle_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
      return {
        accordionStore: accordionStore
      };
    }), fromRenderProps(Consumer$1, function (itemStore) {
      return {
        itemStore: itemStore
      };
    }))(AccordionItemTitleWrapper);

    var AccordionItemBody = function AccordionItemBody(props) {
      var className = props.className,
          hideBodyClassName = props.hideBodyClassName,
          uuid = props.uuid,
          expanded = props.expanded,
          disabled = props.disabled,
          accordion = props.accordion,
          rest = _objectWithoutProperties(props, ["className", "hideBodyClassName", "uuid", "expanded", "disabled", "accordion"]);

      return React__default$$1.createElement("div", _extends({
        id: "accordion__body-".concat(uuid),
        className: classnames(className, _defineProperty({}, hideBodyClassName, !expanded)),
        "aria-hidden": !expanded,
        "aria-labelledby": "accordion__title-".concat(uuid),
        role: accordion ? 'tabpanel' : null
      }, rest));
    }; // eslint-disable-next-line react/prefer-stateless-function


    var AccordionItemBodyWrapper = /*#__PURE__*/function (_Component) {
      _inherits(AccordionItemBodyWrapper, _Component);

      function AccordionItemBodyWrapper() {
        _classCallCheck(this, AccordionItemBodyWrapper);

        return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemBodyWrapper).apply(this, arguments));
      }

      _createClass(AccordionItemBodyWrapper, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              itemStore = _this$props.itemStore,
              accordionStore = _this$props.accordionStore,
              rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);

          var uuid = itemStore.uuid;
          var items = accordionStore.items,
              accordion = accordionStore.accordion;
          var item = items.filter(function (stateItem) {
            return stateItem.uuid === uuid;
          })[0];
          return item ? React__default$$1.createElement(AccordionItemBody, _extends({}, rest, item, {
            accordion: accordion
          })) : null;
        }
      }]);

      return AccordionItemBodyWrapper;
    }(React.Component);

    _defineProperty(AccordionItemBodyWrapper, "defaultProps", {
      className: 'accordion__body',
      hideBodyClassName: 'accordion__body--hidden'
    });

    var AccordionItemBody_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
      return {
        accordionStore: accordionStore
      };
    }), fromRenderProps(Consumer$1, function (itemStore) {
      return {
        itemStore: itemStore
      };
    }))(AccordionItemBodyWrapper); // eslint-disable-next-line

    exports.Accordion = AccordionWrapper;
    exports.AccordionItem = AccordionItem_wrapper;
    exports.AccordionItemTitle = AccordionItemTitle_wrapper;
    exports.AccordionItemBody = AccordionItemBody_wrapper;
    exports.resetNextUuid = resetNextUuid;
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
  });
});
unwrapExports(umd);
var umd_1 = umd.Accordion;
var umd_2 = umd.AccordionItem;
var umd_3 = umd.AccordionItemTitle;
var umd_4 = umd.AccordionItemBody;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}

var _arrayMap = arrayMap;
/** `Object#toString` result references. */

var symbolTag$2 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag$2;
}

var isSymbol_1 = isSymbol;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }

  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

var _baseToString = baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */

function toString$1(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString$1;
/** Used to generate unique IDs. */

var idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */

function uniqueId(prefix) {
  var id = ++idCounter;
  return toString_1(prefix) + id;
}

var uniqueId_1 = uniqueId;

var CategoryBtn = function CategoryBtn(props) {
  var id = props.id,
      value = props.value,
      selected = props.selected,
      onChange = props.onChange,
      name = props.name;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement('input', {
    type: 'radio',
    id: 'option-' + id,
    name: 'selector',
    value: value,
    onChange: onChange,
    checked: selected === value
  }), React__default.createElement('label', {
    htmlFor: 'option-' + id
  }, name));
};

CategoryBtn.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  selected: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};
var groups = [{
  id: 0,
  category: 'by_class',
  name: 'Asset Classes',
  icon: 'chart-pie'
}, {
  id: 1,
  category: 'by_region',
  name: 'Regions',
  icon: 'globe'
}, {
  id: 2,
  category: 'by_sector',
  name: 'Sectors',
  icon: 'industry'
}, {
  id: 3,
  category: 'by_currency',
  name: 'Currencies',
  icon: 'euro-sign'
}];
var styles$9 = {
  categorySelectForm: {
    display: 'flex',
    marginBottom: 20,
    boxSizing: 'content-box',
    alignItems: 'center'
  },
  categorySelectGroup: {
    '& input[type=radio]': {
      position: 'absolute',
      visibility: 'hidden',
      display: 'none',
      '& + label': {
        fontSize: '14px',
        height: '28px',
        textAlign: 'center',
        padding: '0 12px',
        lineHeight: '28px',
        verticalAlign: 'middle',
        userSelect: 'none',
        display: 'inline-block',
        cursor: 'pointer',
        fontWeight: 'bold',
        marginLeft: 10,
        borderRadius: 30,
        border: function border(_ref) {
          var colors = _ref.colors;
          return '2px solid ' + colors.secondary;
        },
        color: function color(_ref2) {
          var colors = _ref2.colors;
          return colors.secondary;
        }
      },
      '&:checked + label': {
        color: 'white',
        backgroundColor: function backgroundColor(_ref3) {
          var colors = _ref3.colors;
          return colors.primary;
        },
        border: function border(_ref4) {
          var colors = _ref4.colors;
          return '2px solid ' + colors.primary;
        },
        transition: 'background-color 0.25s linear',
        cursor: 'default'
      },
      '&:not(:checked) + label:hover': {
        color: function color(_ref5) {
          var colors = _ref5.colors;
          return '' + colors.secondaryHover;
        },
        border: function border(_ref6) {
          var colors = _ref6.colors;
          return '2px solid ' + colors.secondaryHover;
        }
      }
    }
  }
};

var CategorySelect = function (_React$Component) {
  inherits(CategorySelect, _React$Component);

  function CategorySelect(props) {
    classCallCheck$1(this, CategorySelect);

    var _this = possibleConstructorReturn(this, (CategorySelect.__proto__ || Object.getPrototypeOf(CategorySelect)).call(this, props));

    _this.idPrefix = uniqueId_1('category-');
    return _this;
  }

  createClass$1(CategorySelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classes = _props.classes,
          selectedOption = _props.selectedOption,
          onOptionChange = _props.onOptionChange;
      var iconBtnGroup = groups.map(function (group) {
        return React__default.createElement(CategoryBtn, {
          id: _this2.idPrefix + '-' + group.category,
          key: _this2.idPrefix + '-' + group.category,
          value: group.category,
          name: group.name,
          onChange: onOptionChange,
          selected: selectedOption
        });
      });
      return React__default.createElement('form', {
        className: classes.categorySelectForm
      }, React__default.createElement('p', null, 'Categories:'), React__default.createElement('div', {
        className: classes.categorySelectGroup
      }, iconBtnGroup));
    }
  }]);
  return CategorySelect;
}(React__default.Component);

CategorySelect.propTypes = {
  classes: PropTypes.shape().isRequired,
  selectedOption: PropTypes.string.isRequired,
  onOptionChange: PropTypes.func.isRequired,
  colors: PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string
  }).isRequired
};
var CategorySelect$1 = injectSheet$1(styles$9, {
  link: true
})(CategorySelect);

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
} //


var _ = {
  get: get$1,
  set: set$1,
  takeRight: takeRight,
  last: last,
  orderBy: orderBy,
  range: range,
  remove: remove,
  clone: clone,
  getFirstDefined: getFirstDefined,
  sum: sum,
  makeTemplateComponent: makeTemplateComponent,
  groupBy: groupBy,
  isArray: isArray$1,
  splitProps: splitProps,
  compactObject: compactObject,
  isSortingDesc: isSortingDesc,
  normalizeComponent: normalizeComponent,
  asPx: asPx
};

function get$1(obj, path, def) {
  if (!path) {
    return obj;
  }

  var pathObj = makePathArray(path);
  var val = void 0;

  try {
    val = pathObj.reduce(function (current, pathPart) {
      return current[pathPart];
    }, obj);
  } catch (e) {// continue regardless of error
  }

  return typeof val !== 'undefined' ? val : def;
}

function set$1() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments[1];
  var value = arguments[2];
  var keys = makePathArray(path);
  var keyPart = void 0;
  var cursor = obj;

  while ((keyPart = keys.shift()) && keys.length) {
    if (!cursor[keyPart]) {
      cursor[keyPart] = {};
    }

    cursor = cursor[keyPart];
  }

  cursor[keyPart] = value;
  return obj;
}

function takeRight(arr, n) {
  var start = n > arr.length ? 0 : arr.length - n;
  return arr.slice(start);
}

function last(arr) {
  return arr[arr.length - 1];
}

function range(n) {
  var arr = [];

  for (var i = 0; i < n; i += 1) {
    arr.push(n);
  }

  return arr;
}

function orderBy(arr, funcs, dirs, indexKey) {
  return arr.sort(function (rowA, rowB) {
    for (var i = 0; i < funcs.length; i += 1) {
      var comp = funcs[i];
      var desc = dirs[i] === false || dirs[i] === 'desc';
      var sortInt = comp(rowA, rowB);

      if (sortInt) {
        return desc ? -sortInt : sortInt;
      }
    } // Use the row index for tie breakers


    return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
  });
}

function remove(a, b) {
  return a.filter(function (o, i) {
    var r = b(o);

    if (r) {
      a.splice(i, 1);
      return true;
    }

    return false;
  });
}

function clone(a) {
  try {
    return JSON.parse(JSON.stringify(a, function (key, value) {
      if (typeof value === 'function') {
        return value.toString();
      }

      return value;
    }));
  } catch (e) {
    return a;
  }
}

function getFirstDefined() {
  for (var i = 0; i < arguments.length; i += 1) {
    if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') {
      return arguments.length <= i ? undefined : arguments[i];
    }
  }
}

function sum(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
}

function makeTemplateComponent(compClass, displayName) {
  if (!displayName) {
    throw new Error('No displayName found for template component:', compClass);
  }

  var cmp = function cmp(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties$1(_ref, ['children', 'className']);

    return React__default.createElement('div', _extends$5({
      className: classnames(compClass, className)
    }, rest), children);
  };

  cmp.displayName = displayName;
  return cmp;
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x, i) {
    var resKey = typeof key === 'function' ? key(x, i) : x[key];
    rv[resKey] = isArray$1(rv[resKey]) ? rv[resKey] : [];
    rv[resKey].push(x);
    return rv;
  }, {});
}

function asPx(value) {
  value = Number(value);
  return Number.isNaN(value) ? null : value + 'px';
}

function isArray$1(a) {
  return Array.isArray(a);
} // ########################################################################
// Non-exported Helpers
// ########################################################################


function makePathArray(obj) {
  return flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
}

function flattenDeep(arr) {
  var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!isArray$1(arr)) {
    newArr.push(arr);
  } else {
    for (var i = 0; i < arr.length; i += 1) {
      flattenDeep(arr[i], newArr);
    }
  }

  return newArr;
}

function splitProps(_ref2) {
  var className = _ref2.className,
      style = _ref2.style,
      rest = _objectWithoutProperties$1(_ref2, ['className', 'style']);

  return {
    className: className,
    style: style,
    rest: rest || {}
  };
}

function compactObject(obj) {
  var newObj = {};

  if (obj) {
    Object.keys(obj).map(function (key) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') {
        newObj[key] = obj[key];
      }

      return true;
    });
  }

  return newObj;
}

function isSortingDesc(d) {
  return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
}

function normalizeComponent(Comp) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;
  return typeof Comp === 'function' ? Object.getPrototypeOf(Comp).isReactComponent ? React__default.createElement(Comp, params) : Comp(params) : fallback;
}

var _createClass$4 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$3(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Lifecycle = function Lifecycle(Base) {
  return function (_Base) {
    _inherits$3(_class, _Base);

    function _class() {
      _classCallCheck$4(this, _class);

      return _possibleConstructorReturn$3(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass$4(_class, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.setStateWithData(this.getDataModel(this.getResolvedState(), true));
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.fireFetchData();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextState) {
        var oldState = this.getResolvedState();
        var newState = this.getResolvedState(nextProps, nextState); // Do a deep compare of new and old `defaultOption` and
        // if they are different reset `option = defaultOption`

        var defaultableOptions = ['sorted', 'filtered', 'resized', 'expanded'];
        defaultableOptions.forEach(function (x) {
          var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));

          if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) {
            newState[x] = newState[defaultName];
          }
        }); // If they change these table options, we need to reset defaults
        // or else we could get into a state where the user has changed the UI
        // and then disabled the ability to change it back.
        // e.g. If `filterable` has changed, set `filtered = defaultFiltered`

        var resettableOptions = ['sortable', 'filterable', 'resizable'];
        resettableOptions.forEach(function (x) {
          if (oldState[x] !== newState[x]) {
            var baseName = x.replace('able', '');
            var optionName = baseName + 'ed';
            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
            newState[optionName] = newState[defaultName];
          }
        }); // Props that trigger a data update

        if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) {
          this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
        }
      }
    }, {
      key: 'setStateWithData',
      value: function setStateWithData(newState, cb) {
        var _this2 = this;

        var oldState = this.getResolvedState();
        var newResolvedState = this.getResolvedState({}, newState);
        var freezeWhenExpanded = newResolvedState.freezeWhenExpanded; // Default to unfrozen state

        newResolvedState.frozen = false; // If freezeWhenExpanded is set, check for frozen conditions

        if (freezeWhenExpanded) {
          // if any rows are expanded, freeze the existing data and sorting
          var keys = Object.keys(newResolvedState.expanded);

          for (var i = 0; i < keys.length; i += 1) {
            if (newResolvedState.expanded[keys[i]]) {
              newResolvedState.frozen = true;
              break;
            }
          }
        } // If the data isn't frozen and either the data or
        // sorting model has changed, update the data


        if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
          // Handle collapseOnsortedChange & collapseOnDataChange
          if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) {
            newResolvedState.expanded = {};
          }

          Object.assign(newResolvedState, this.getSortedData(newResolvedState));
        } // Set page to 0 if filters change


        if (oldState.filtered !== newResolvedState.filtered) {
          newResolvedState.page = 0;
        } // Calculate pageSize all the time


        if (newResolvedState.sortedData) {
          newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
          newResolvedState.page = Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
        }

        return this.setState(newResolvedState, function () {
          if (cb) {
            cb();
          }

          if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) {
            _this2.fireFetchData();
          }
        });
      }
    }]);

    return _class;
  }(Base);
};

var _slicedToArray$1 = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$5 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray$2(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$4(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Methods = function Methods(Base) {
  return function (_Base) {
    _inherits$4(_class, _Base);

    function _class() {
      _classCallCheck$5(this, _class);

      return _possibleConstructorReturn$4(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass$5(_class, [{
      key: 'getResolvedState',
      value: function getResolvedState(props, state) {
        var resolvedState = _extends$6({}, _.compactObject(this.state), _.compactObject(this.props), _.compactObject(state), _.compactObject(props));

        return resolvedState;
      }
    }, {
      key: 'getDataModel',
      value: function getDataModel(newState, dataChanged) {
        var _this2 = this;

        var columns = newState.columns,
            _newState$pivotBy = newState.pivotBy,
            pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy,
            data = newState.data,
            resolveData = newState.resolveData,
            pivotIDKey = newState.pivotIDKey,
            pivotValKey = newState.pivotValKey,
            subRowsKey = newState.subRowsKey,
            aggregatedKey = newState.aggregatedKey,
            nestingLevelKey = newState.nestingLevelKey,
            originalKey = newState.originalKey,
            indexKey = newState.indexKey,
            groupedByPivotKey = newState.groupedByPivotKey,
            SubComponent = newState.SubComponent; // Determine Header Groups

        var hasHeaderGroups = false;
        columns.forEach(function (column) {
          if (column.columns) {
            hasHeaderGroups = true;
          }
        });
        var columnsWithExpander = [].concat(_toConsumableArray$2(columns));
        var expanderColumn = columns.find(function (col) {
          return col.expander || col.columns && col.columns.some(function (col2) {
            return col2.expander;
          });
        }); // The actual expander might be in the columns field of a group column

        if (expanderColumn && !expanderColumn.expander) {
          expanderColumn = expanderColumn.columns.find(function (col) {
            return col.expander;
          });
        } // If we have SubComponent's we need to make sure we have an expander column


        if (SubComponent && !expanderColumn) {
          expanderColumn = {
            expander: true
          };
          columnsWithExpander = [expanderColumn].concat(_toConsumableArray$2(columnsWithExpander));
        }

        var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
          var dcol = void 0;

          if (column.expander) {
            dcol = _extends$6({}, _this2.props.column, _this2.props.expanderDefaults, column);
          } else {
            dcol = _extends$6({}, _this2.props.column, column);
          } // Ensure minWidth is not greater than maxWidth if set


          if (dcol.maxWidth < dcol.minWidth) {
            dcol.minWidth = dcol.maxWidth;
          }

          if (parentColumn) {
            dcol.parentColumn = parentColumn;
          } // First check for string accessor


          if (typeof dcol.accessor === 'string') {
            dcol.id = dcol.id || dcol.accessor;
            var accessorString = dcol.accessor;

            dcol.accessor = function (row) {
              return _.get(row, accessorString);
            };

            return dcol;
          } // Fall back to functional accessor (but require an ID)


          if (dcol.accessor && !dcol.id) {
            console.warn(dcol);
            throw new Error('A column id is required if using a non-string accessor for column above.');
          } // Fall back to an undefined accessor


          if (!dcol.accessor) {
            dcol.accessor = function () {
              return undefined;
            };
          }

          return dcol;
        };

        var allDecoratedColumns = []; // Decorate the columns

        var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
          var decoratedColumn = makeDecoratedColumn(column, parentColumn);
          allDecoratedColumns.push(decoratedColumn);
          return decoratedColumn;
        };

        var decoratedColumns = columnsWithExpander.map(function (column) {
          if (column.columns) {
            return _extends$6({}, column, {
              columns: column.columns.map(function (d) {
                return decorateAndAddToAll(d, column);
              })
            });
          }

          return decorateAndAddToAll(column);
        }); // Build the visible columns, headers and flat column list

        var visibleColumns = decoratedColumns.slice();
        var allVisibleColumns = [];
        visibleColumns = visibleColumns.map(function (column) {
          if (column.columns) {
            var visibleSubColumns = column.columns.filter(function (d) {
              return pivotBy.indexOf(d.id) > -1 ? false : _.getFirstDefined(d.show, true);
            });
            return _extends$6({}, column, {
              columns: visibleSubColumns
            });
          }

          return column;
        });
        visibleColumns = visibleColumns.filter(function (column) {
          return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : _.getFirstDefined(column.show, true);
        }); // Find any custom pivot location

        var pivotIndex = visibleColumns.findIndex(function (col) {
          return col.pivot;
        }); // Handle Pivot Columns

        if (pivotBy.length) {
          // Retrieve the pivot columns in the correct pivot order
          var pivotColumns = [];
          pivotBy.forEach(function (pivotID) {
            var found = allDecoratedColumns.find(function (d) {
              return d.id === pivotID;
            });

            if (found) {
              pivotColumns.push(found);
            }
          });
          var PivotParentColumn = pivotColumns.reduce(function (prev, current) {
            return prev && prev === current.parentColumn && current.parentColumn;
          }, pivotColumns[0].parentColumn);
          var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;

          PivotGroupHeader = PivotGroupHeader || function () {
            return React__default.createElement('strong', null, 'Pivoted');
          };

          var pivotColumnGroup = {
            Header: PivotGroupHeader,
            columns: pivotColumns.map(function (col) {
              return _extends$6({}, _this2.props.pivotDefaults, col, {
                pivoted: true
              });
            }) // Place the pivotColumns back into the visibleColumns

          };

          if (pivotIndex >= 0) {
            pivotColumnGroup = _extends$6({}, visibleColumns[pivotIndex], pivotColumnGroup);
            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
          } else {
            visibleColumns.unshift(pivotColumnGroup);
          }
        } // Build Header Groups


        var headerGroups = [];
        var currentSpan = []; // A convenience function to add a header and reset the currentSpan

        var addHeader = function addHeader(columns, column) {
          headerGroups.push(_extends$6({}, _this2.props.column, column, {
            columns: columns
          }));
          currentSpan = [];
        }; // Build flast list of allVisibleColumns and HeaderGroups


        visibleColumns.forEach(function (column) {
          if (column.columns) {
            allVisibleColumns = allVisibleColumns.concat(column.columns);

            if (currentSpan.length > 0) {
              addHeader(currentSpan);
            }

            addHeader(column.columns, column);
            return;
          }

          allVisibleColumns.push(column);
          currentSpan.push(column);
        });

        if (hasHeaderGroups && currentSpan.length > 0) {
          addHeader(currentSpan);
        } // Access the data


        var accessRow = function accessRow(d, i) {
          var _row;

          var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var row = (_row = {}, _defineProperty$7(_row, originalKey, d), _defineProperty$7(_row, indexKey, i), _defineProperty$7(_row, subRowsKey, d[subRowsKey]), _defineProperty$7(_row, nestingLevelKey, level), _row);
          allDecoratedColumns.forEach(function (column) {
            if (column.expander) return;
            row[column.id] = column.accessor(d);
          });

          if (row[subRowsKey]) {
            row[subRowsKey] = row[subRowsKey].map(function (d, i) {
              return accessRow(d, i, level + 1);
            });
          }

          return row;
        }; // // If the data hasn't changed, just use the cached data


        var resolvedData = this.resolvedData; // If the data has changed, run the data resolver and cache the result

        if (!this.resolvedData || dataChanged) {
          resolvedData = resolveData(data);
          this.resolvedData = resolvedData;
        } // Use the resolved data


        resolvedData = resolvedData.map(function (d, i) {
          return accessRow(d, i);
        }); // TODO: Make it possible to fabricate nested rows without pivoting

        var aggregatingColumns = allVisibleColumns.filter(function (d) {
          return !d.expander && d.aggregate;
        }); // If pivoting, recursively group the data

        var aggregate = function aggregate(rows) {
          var aggregationValues = {};
          aggregatingColumns.forEach(function (column) {
            var values = rows.map(function (d) {
              return d[column.id];
            });
            aggregationValues[column.id] = column.aggregate(values, rows);
          });
          return aggregationValues;
        };

        if (pivotBy.length) {
          var groupRecursively = function groupRecursively(rows, keys) {
            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0; // This is the last level, just return the rows

            if (i === keys.length) {
              return rows;
            } // Group the rows together for this level


            var groupedRows = Object.entries(_.groupBy(rows, keys[i])).map(function (_ref) {
              var _ref3;

              var _ref2 = _slicedToArray$1(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];

              return _ref3 = {}, _defineProperty$7(_ref3, pivotIDKey, keys[i]), _defineProperty$7(_ref3, pivotValKey, key), _defineProperty$7(_ref3, keys[i], key), _defineProperty$7(_ref3, subRowsKey, value), _defineProperty$7(_ref3, nestingLevelKey, i), _defineProperty$7(_ref3, groupedByPivotKey, true), _ref3;
            }); // Recurse into the subRows

            groupedRows = groupedRows.map(function (rowGroup) {
              var _extends2;

              var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
              return _extends$6({}, rowGroup, (_extends2 = {}, _defineProperty$7(_extends2, subRowsKey, subRows), _defineProperty$7(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
            });
            return groupedRows;
          };

          resolvedData = groupRecursively(resolvedData, pivotBy);
        }

        return _extends$6({}, newState, {
          resolvedData: resolvedData,
          allVisibleColumns: allVisibleColumns,
          headerGroups: headerGroups,
          allDecoratedColumns: allDecoratedColumns,
          hasHeaderGroups: hasHeaderGroups
        });
      }
    }, {
      key: 'getSortedData',
      value: function getSortedData(resolvedState) {
        var manual = resolvedState.manual,
            sorted = resolvedState.sorted,
            filtered = resolvedState.filtered,
            defaultFilterMethod = resolvedState.defaultFilterMethod,
            resolvedData = resolvedState.resolvedData,
            allVisibleColumns = resolvedState.allVisibleColumns,
            allDecoratedColumns = resolvedState.allDecoratedColumns;
        var sortMethodsByColumnID = {};
        allDecoratedColumns.filter(function (col) {
          return col.sortMethod;
        }).forEach(function (col) {
          sortMethodsByColumnID[col.id] = col.sortMethod;
        }); // Resolve the data from either manual data or sorted data

        return {
          sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allVisibleColumns), sorted, sortMethodsByColumnID)
        };
      }
    }, {
      key: 'fireFetchData',
      value: function fireFetchData() {
        this.props.onFetchData(this.getResolvedState(), this);
      }
    }, {
      key: 'getPropOrState',
      value: function getPropOrState(key) {
        return _.getFirstDefined(this.props[key], this.state[key]);
      }
    }, {
      key: 'getStateOrProp',
      value: function getStateOrProp(key) {
        return _.getFirstDefined(this.state[key], this.props[key]);
      }
    }, {
      key: 'filterData',
      value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
        var _this3 = this;

        var filteredData = data;

        if (filtered.length) {
          filteredData = filtered.reduce(function (filteredSoFar, nextFilter) {
            var column = allVisibleColumns.find(function (x) {
              return x.id === nextFilter.id;
            }); // Don't filter hidden columns or columns that have had their filters disabled

            if (!column || column.filterable === false) {
              return filteredSoFar;
            }

            var filterMethod = column.filterMethod || defaultFilterMethod; // If 'filterAll' is set to true, pass the entire dataset to the filter method

            if (column.filterAll) {
              return filterMethod(nextFilter, filteredSoFar, column);
            }

            return filteredSoFar.filter(function (row) {
              return filterMethod(nextFilter, row, column);
            });
          }, filteredData); // Apply the filter to the subrows if we are pivoting, and then
          // filter any rows without subcolumns because it would be strange to show

          filteredData = filteredData.map(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return row;
            }

            return _extends$6({}, row, _defineProperty$7({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
          }).filter(function (row) {
            if (!row[_this3.props.subRowsKey]) {
              return true;
            }

            return row[_this3.props.subRowsKey].length > 0;
          });
        }

        return filteredData;
      }
    }, {
      key: 'sortData',
      value: function sortData(data, sorted) {
        var _this4 = this;

        var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (!sorted.length) {
          return data;
        }

        var sortedData = (this.props.orderByMethod || _.orderBy)(data, sorted.map(function (sort) {
          // Support custom sorting methods for each column
          if (sortMethodsByColumnID[sort.id]) {
            return function (a, b) {
              return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
            };
          }

          return function (a, b) {
            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
          };
        }), sorted.map(function (d) {
          return !d.desc;
        }), this.props.indexKey);

        sortedData.forEach(function (row) {
          if (!row[_this4.props.subRowsKey]) {
            return;
          }

          row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
        });
        return sortedData;
      }
    }, {
      key: 'getMinRows',
      value: function getMinRows() {
        return _.getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
      } // User actions

    }, {
      key: 'onPageChange',
      value: function onPageChange(page) {
        var _props = this.props,
            onPageChange = _props.onPageChange,
            collapseOnPageChange = _props.collapseOnPageChange;
        var newState = {
          page: page
        };

        if (collapseOnPageChange) {
          newState.expanded = {};
        }

        this.setStateWithData(newState, function () {
          return onPageChange && onPageChange(page);
        });
      }
    }, {
      key: 'onPageSizeChange',
      value: function onPageSizeChange(newPageSize) {
        var onPageSizeChange = this.props.onPageSizeChange;

        var _getResolvedState = this.getResolvedState(),
            pageSize = _getResolvedState.pageSize,
            page = _getResolvedState.page; // Normalize the page to display


        var currentRow = pageSize * page;
        var newPage = Math.floor(currentRow / newPageSize);
        this.setStateWithData({
          pageSize: newPageSize,
          page: newPage
        }, function () {
          return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
        });
      }
    }, {
      key: 'sortColumn',
      value: function sortColumn(column, additive) {
        var _getResolvedState2 = this.getResolvedState(),
            sorted = _getResolvedState2.sorted,
            skipNextSort = _getResolvedState2.skipNextSort,
            defaultSortDesc = _getResolvedState2.defaultSortDesc;

        var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
        var secondSortDirection = !firstSortDirection; // we can't stop event propagation from the column resize move handlers
        // attached to the document because of react's synthetic events
        // so we have to prevent the sort function from actually sorting
        // if we click on the column resize element within a header.

        if (skipNextSort) {
          this.setStateWithData({
            skipNextSort: false
          });
          return;
        }

        var onSortedChange = this.props.onSortedChange;

        var newSorted = _.clone(sorted || []).map(function (d) {
          d.desc = _.isSortingDesc(d);
          return d;
        });

        if (!_.isArray(column)) {
          // Single-Sort
          var existingIndex = newSorted.findIndex(function (d) {
            return d.id === column.id;
          });

          if (existingIndex > -1) {
            var existing = newSorted[existingIndex];

            if (existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(existingIndex, 1);
              } else {
                existing.desc = firstSortDirection;
                newSorted = [existing];
              }
            } else {
              existing.desc = secondSortDirection;

              if (!additive) {
                newSorted = [existing];
              }
            }
          } else if (additive) {
            newSorted.push({
              id: column.id,
              desc: firstSortDirection
            });
          } else {
            newSorted = [{
              id: column.id,
              desc: firstSortDirection
            }];
          }
        } else {
          // Multi-Sort
          var _existingIndex = newSorted.findIndex(function (d) {
            return d.id === column[0].id;
          }); // Existing Sorted Column


          if (_existingIndex > -1) {
            var _existing = newSorted[_existingIndex];

            if (_existing.desc === secondSortDirection) {
              if (additive) {
                newSorted.splice(_existingIndex, column.length);
              } else {
                column.forEach(function (d, i) {
                  newSorted[_existingIndex + i].desc = firstSortDirection;
                });
              }
            } else {
              column.forEach(function (d, i) {
                newSorted[_existingIndex + i].desc = secondSortDirection;
              });
            }

            if (!additive) {
              newSorted = newSorted.slice(_existingIndex, column.length);
            } // New Sort Column

          } else if (additive) {
            newSorted = newSorted.concat(column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            }));
          } else {
            newSorted = column.map(function (d) {
              return {
                id: d.id,
                desc: firstSortDirection
              };
            });
          }
        }

        this.setStateWithData({
          page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
          sorted: newSorted
        }, function () {
          return onSortedChange && onSortedChange(newSorted, column, additive);
        });
      }
    }, {
      key: 'filterColumn',
      value: function filterColumn(column, value) {
        var _getResolvedState3 = this.getResolvedState(),
            filtered = _getResolvedState3.filtered;

        var onFilteredChange = this.props.onFilteredChange; // Remove old filter first if it exists

        var newFiltering = (filtered || []).filter(function (x) {
          return x.id !== column.id;
        });

        if (value !== '') {
          newFiltering.push({
            id: column.id,
            value: value
          });
        }

        this.setStateWithData({
          filtered: newFiltering
        }, function () {
          return onFilteredChange && onFilteredChange(newFiltering, column, value);
        });
      }
    }, {
      key: 'resizeColumnStart',
      value: function resizeColumnStart(event, column, isTouch) {
        var _this5 = this;

        event.stopPropagation();
        var parentWidth = event.target.parentElement.getBoundingClientRect().width;
        var pageX = void 0;

        if (isTouch) {
          pageX = event.changedTouches[0].pageX;
        } else {
          pageX = event.pageX;
        }

        this.trapEvents = true;
        this.setStateWithData({
          currentlyResizing: {
            id: column.id,
            startX: pageX,
            parentWidth: parentWidth
          }
        }, function () {
          if (isTouch) {
            document.addEventListener('touchmove', _this5.resizeColumnMoving);
            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
            document.addEventListener('touchend', _this5.resizeColumnEnd);
          } else {
            document.addEventListener('mousemove', _this5.resizeColumnMoving);
            document.addEventListener('mouseup', _this5.resizeColumnEnd);
            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
          }
        });
      }
    }, {
      key: 'resizeColumnMoving',
      value: function resizeColumnMoving(event) {
        event.stopPropagation();
        var onResizedChange = this.props.onResizedChange;

        var _getResolvedState4 = this.getResolvedState(),
            resized = _getResolvedState4.resized,
            currentlyResizing = _getResolvedState4.currentlyResizing; // Delete old value


        var newResized = resized.filter(function (x) {
          return x.id !== currentlyResizing.id;
        });
        var pageX = void 0;

        if (event.type === 'touchmove') {
          pageX = event.changedTouches[0].pageX;
        } else if (event.type === 'mousemove') {
          pageX = event.pageX;
        } // Set the min size to 10 to account for margin and border or else the
        // group headers don't line up correctly


        var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, 11);
        newResized.push({
          id: currentlyResizing.id,
          value: newWidth
        });
        this.setStateWithData({
          resized: newResized
        }, function () {
          return onResizedChange && onResizedChange(newResized, event);
        });
      }
    }, {
      key: 'resizeColumnEnd',
      value: function resizeColumnEnd(event) {
        event.stopPropagation();
        var isTouch = event.type === 'touchend' || event.type === 'touchcancel';

        if (isTouch) {
          document.removeEventListener('touchmove', this.resizeColumnMoving);
          document.removeEventListener('touchcancel', this.resizeColumnEnd);
          document.removeEventListener('touchend', this.resizeColumnEnd);
        } // If its a touch event clear the mouse one's as well because sometimes
        // the mouseDown event gets called as well, but the mouseUp event doesn't


        document.removeEventListener('mousemove', this.resizeColumnMoving);
        document.removeEventListener('mouseup', this.resizeColumnEnd);
        document.removeEventListener('mouseleave', this.resizeColumnEnd); // The touch events don't propagate up to the sorting's onMouseDown event so
        // no need to prevent it from happening or else the first click after a touch
        // event resize will not sort the column.

        if (!isTouch) {
          this.setStateWithData({
            skipNextSort: true,
            currentlyResizing: false
          });
        }
      }
    }]);

    return _class;
  }(Base);
};

var _createClass$6 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$5(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} //
// import _ from './utils'


var defaultButton = function defaultButton(props) {
  return React__default.createElement('button', _extends$7({
    type: 'button'
  }, props, {
    className: '-btn'
  }), props.children);
};

var ReactTablePagination = function (_Component) {
  _inherits$5(ReactTablePagination, _Component);

  function ReactTablePagination(props) {
    _classCallCheck$6(this, ReactTablePagination);

    var _this = _possibleConstructorReturn$5(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this));

    _this.getSafePage = _this.getSafePage.bind(_this);
    _this.changePage = _this.changePage.bind(_this);
    _this.applyPage = _this.applyPage.bind(_this);
    _this.state = {
      page: props.page
    };
    return _this;
  }

  _createClass$6(ReactTablePagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        page: nextProps.page
      });
    }
  }, {
    key: 'getSafePage',
    value: function getSafePage(page) {
      if (Number.isNaN(page)) {
        page = this.props.page;
      }

      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: 'changePage',
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({
        page: page
      });

      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: 'applyPage',
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }

      var page = this.state.page;
      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          pages = _props.pages,
          page = _props.page,
          showPageSizeOptions = _props.showPageSizeOptions,
          pageSizeOptions = _props.pageSizeOptions,
          pageSize = _props.pageSize,
          showPageJump = _props.showPageJump,
          canPrevious = _props.canPrevious,
          canNext = _props.canNext,
          onPageSizeChange = _props.onPageSizeChange,
          className = _props.className,
          _props$PreviousCompon = _props.PreviousComponent,
          PreviousComponent = _props$PreviousCompon === undefined ? defaultButton : _props$PreviousCompon,
          _props$NextComponent = _props.NextComponent,
          NextComponent = _props$NextComponent === undefined ? defaultButton : _props$NextComponent;
      return React__default.createElement('div', {
        className: classnames(className, '-pagination'),
        style: this.props.style
      }, React__default.createElement('div', {
        className: '-previous'
      }, React__default.createElement(PreviousComponent, {
        onClick: function onClick() {
          if (!canPrevious) return;

          _this2.changePage(page - 1);
        },
        disabled: !canPrevious
      }, this.props.previousText)), React__default.createElement('div', {
        className: '-center'
      }, React__default.createElement('span', {
        className: '-pageInfo'
      }, this.props.pageText, ' ', showPageJump ? React__default.createElement('div', {
        className: '-pageJump'
      }, React__default.createElement('input', {
        type: this.state.page === '' ? 'text' : 'number',
        onChange: function onChange(e) {
          var val = e.target.value;
          var page = val - 1;

          if (val === '') {
            return _this2.setState({
              page: val
            });
          }

          _this2.setState({
            page: _this2.getSafePage(page)
          });
        },
        value: this.state.page === '' ? '' : this.state.page + 1,
        onBlur: this.applyPage,
        onKeyPress: function onKeyPress(e) {
          if (e.which === 13 || e.keyCode === 13) {
            _this2.applyPage();
          }
        }
      })) : React__default.createElement('span', {
        className: '-currentPage'
      }, page + 1), ' ', this.props.ofText, ' ', React__default.createElement('span', {
        className: '-totalPages'
      }, pages || 1)), showPageSizeOptions && React__default.createElement('span', {
        className: 'select-wrap -pageSizeOptions'
      }, React__default.createElement('select', {
        onChange: function onChange(e) {
          return onPageSizeChange(Number(e.target.value));
        },
        value: pageSize
      }, pageSizeOptions.map(function (option, i) {
        return (// eslint-disable-next-line react/no-array-index-key
          React__default.createElement('option', {
            key: i,
            value: option
          }, option, ' ', _this2.props.rowsText)
        );
      })))), React__default.createElement('div', {
        className: '-next'
      }, React__default.createElement(NextComponent, {
        onClick: function onClick() {
          if (!canNext) return;

          _this2.changePage(page + 1);
        },
        disabled: !canNext
      }, this.props.nextText)));
    }
  }]);

  return ReactTablePagination;
}(Component);

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var emptyObj = function emptyObj() {
  return {};
};

var defaultProps = {
  // General
  data: [],
  resolveData: function resolveData(data) {
    return data;
  },
  loading: false,
  showPagination: true,
  showPaginationTop: false,
  showPaginationBottom: true,
  showPageSizeOptions: true,
  pageSizeOptions: [5, 10, 20, 25, 50, 100],
  defaultPageSize: 20,
  showPageJump: true,
  collapseOnSortingChange: true,
  collapseOnPageChange: true,
  collapseOnDataChange: true,
  freezeWhenExpanded: false,
  sortable: true,
  multiSort: true,
  resizable: true,
  filterable: false,
  defaultSortDesc: false,
  defaultSorted: [],
  defaultFiltered: [],
  defaultResized: [],
  defaultExpanded: {},
  // eslint-disable-next-line no-unused-vars
  defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
    var id = filter.pivotId || filter.id;
    return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
  },
  // eslint-disable-next-line no-unused-vars
  defaultSortMethod: function defaultSortMethod(a, b, desc) {
    // force null and undefined to the bottom
    a = a === null || a === undefined ? '' : a;
    b = b === null || b === undefined ? '' : b; // force any string values to lowercase

    a = typeof a === 'string' ? a.toLowerCase() : a;
    b = typeof b === 'string' ? b.toLowerCase() : b; // Return either 1 or -1 to indicate a sort priority

    if (a > b) {
      return 1;
    }

    if (a < b) {
      return -1;
    } // returning 0, undefined or any falsey value will use subsequent sorts or
    // the index as a tiebreaker


    return 0;
  },
  // Controlled State Props
  // page: undefined,
  // pageSize: undefined,
  // sorted: [],
  // filtered: [],
  // resized: [],
  // expanded: {},
  // Controlled State Callbacks
  onPageChange: undefined,
  onPageSizeChange: undefined,
  onSortedChange: undefined,
  onFilteredChange: undefined,
  onResizedChange: undefined,
  onExpandedChange: undefined,
  // Pivoting
  pivotBy: undefined,
  // Key Constants
  pivotValKey: '_pivotVal',
  pivotIDKey: '_pivotID',
  subRowsKey: '_subRows',
  aggregatedKey: '_aggregated',
  nestingLevelKey: '_nestingLevel',
  originalKey: '_original',
  indexKey: '_index',
  groupedByPivotKey: '_groupedByPivot',
  // Server-side Callbacks
  onFetchData: function onFetchData() {
    return null;
  },
  // Classes
  className: '',
  style: {},
  // Component decorators
  getProps: emptyObj,
  getTableProps: emptyObj,
  getTheadGroupProps: emptyObj,
  getTheadGroupTrProps: emptyObj,
  getTheadGroupThProps: emptyObj,
  getTheadProps: emptyObj,
  getTheadTrProps: emptyObj,
  getTheadThProps: emptyObj,
  getTheadFilterProps: emptyObj,
  getTheadFilterTrProps: emptyObj,
  getTheadFilterThProps: emptyObj,
  getTbodyProps: emptyObj,
  getTrGroupProps: emptyObj,
  getTrProps: emptyObj,
  getTdProps: emptyObj,
  getTfootProps: emptyObj,
  getTfootTrProps: emptyObj,
  getTfootTdProps: emptyObj,
  getPaginationProps: emptyObj,
  getLoadingProps: emptyObj,
  getNoDataProps: emptyObj,
  getResizerProps: emptyObj,
  // Global Column Defaults
  column: {
    // Renderers
    Cell: undefined,
    Header: undefined,
    Footer: undefined,
    Aggregated: undefined,
    Pivot: undefined,
    PivotValue: undefined,
    Expander: undefined,
    Filter: undefined,
    // All Columns
    sortable: undefined,
    // use table default
    resizable: undefined,
    // use table default
    filterable: undefined,
    // use table default
    show: true,
    minWidth: 100,
    // Cells only
    className: '',
    style: {},
    getProps: emptyObj,
    // Pivot only
    aggregate: undefined,
    // Headers only
    headerClassName: '',
    headerStyle: {},
    getHeaderProps: emptyObj,
    // Footers only
    footerClassName: '',
    footerStyle: {},
    getFooterProps: emptyObj,
    filterMethod: undefined,
    filterAll: false,
    sortMethod: undefined
  },
  // Global Expander Column Defaults
  expanderDefaults: {
    sortable: false,
    resizable: false,
    filterable: false,
    width: 35
  },
  pivotDefaults: {// extend the defaults for pivoted columns here
  },
  // Text
  previousText: 'Previous',
  nextText: 'Next',
  loadingText: 'Loading...',
  noDataText: 'No rows found',
  pageText: 'Page',
  ofText: 'of',
  rowsText: 'rows',
  // Components
  TableComponent: function TableComponent(_ref) {
    var children = _ref.children,
        className = _ref.className,
        rest = _objectWithoutProperties$2(_ref, ['children', 'className']);

    return React__default.createElement('div', _extends$8({
      className: classnames('rt-table', className),
      role: 'grid' // tabIndex='0'

    }, rest), children);
  },
  TheadComponent: _.makeTemplateComponent('rt-thead', 'Thead'),
  TbodyComponent: _.makeTemplateComponent('rt-tbody', 'Tbody'),
  TrGroupComponent: function TrGroupComponent(_ref2) {
    var children = _ref2.children,
        className = _ref2.className,
        rest = _objectWithoutProperties$2(_ref2, ['children', 'className']);

    return React__default.createElement('div', _extends$8({
      className: classnames('rt-tr-group', className),
      role: 'rowgroup'
    }, rest), children);
  },
  TrComponent: function TrComponent(_ref3) {
    var children = _ref3.children,
        className = _ref3.className,
        rest = _objectWithoutProperties$2(_ref3, ['children', 'className']);

    return React__default.createElement('div', _extends$8({
      className: classnames('rt-tr', className),
      role: 'row'
    }, rest), children);
  },
  ThComponent: function ThComponent(_ref4) {
    var toggleSort = _ref4.toggleSort,
        className = _ref4.className,
        children = _ref4.children,
        rest = _objectWithoutProperties$2(_ref4, ['toggleSort', 'className', 'children']);

    return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
      React__default.createElement('div', _extends$8({
        className: classnames('rt-th', className),
        onClick: function onClick(e) {
          return toggleSort && toggleSort(e);
        },
        role: 'columnheader',
        tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly

      }, rest), children)
    );
  },
  TdComponent: function TdComponent(_ref5) {
    var toggleSort = _ref5.toggleSort,
        className = _ref5.className,
        children = _ref5.children,
        rest = _objectWithoutProperties$2(_ref5, ['toggleSort', 'className', 'children']);

    return React__default.createElement('div', _extends$8({
      className: classnames('rt-td', className),
      role: 'gridcell'
    }, rest), children);
  },
  TfootComponent: _.makeTemplateComponent('rt-tfoot', 'Tfoot'),
  FilterComponent: function FilterComponent(_ref6) {
    var filter = _ref6.filter,
        _onChange = _ref6.onChange;
    return React__default.createElement('input', {
      type: 'text',
      style: {
        width: '100%'
      },
      value: filter ? filter.value : '',
      onChange: function onChange(event) {
        return _onChange(event.target.value);
      }
    });
  },
  ExpanderComponent: function ExpanderComponent(_ref7) {
    var isExpanded = _ref7.isExpanded;
    return React__default.createElement('div', {
      className: classnames('rt-expander', isExpanded && '-open')
    }, "\u2022");
  },
  PivotValueComponent: function PivotValueComponent(_ref8) {
    var subRows = _ref8.subRows,
        value = _ref8.value;
    return React__default.createElement('span', null, value, ' ', subRows && '(' + subRows.length + ')');
  },
  AggregatedComponent: function AggregatedComponent(_ref9) {
    var subRows = _ref9.subRows,
        column = _ref9.column;
    var previewValues = subRows.filter(function (d) {
      return typeof d[column.id] !== 'undefined';
    }).map(function (row, i) {
      return (// eslint-disable-next-line react/no-array-index-key
        React__default.createElement('span', {
          key: i
        }, row[column.id], i < subRows.length - 1 ? ', ' : '')
      );
    });
    return React__default.createElement('span', null, previewValues);
  },
  PivotComponent: undefined,
  // this is a computed default generated using
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: ReactTablePagination,
  PreviousComponent: undefined,
  NextComponent: undefined,
  LoadingComponent: function LoadingComponent(_ref10) {
    var className = _ref10.className,
        loading = _ref10.loading,
        loadingText = _ref10.loadingText,
        rest = _objectWithoutProperties$2(_ref10, ['className', 'loading', 'loadingText']);

    return React__default.createElement('div', _extends$8({
      className: classnames('-loading', {
        '-active': loading
      }, className)
    }, rest), React__default.createElement('div', {
      className: '-loading-inner'
    }, loadingText));
  },
  NoDataComponent: _.makeTemplateComponent('rt-noData', 'NoData'),
  ResizerComponent: _.makeTemplateComponent('rt-resizer', 'Resizer'),
  PadRowComponent: function PadRowComponent() {
    return React__default.createElement('span', null, '\xA0');
  }
};
var propTypes$2 = {
  // General
  data: PropTypes.any,
  loading: PropTypes.bool,
  showPagination: PropTypes.bool,
  showPaginationTop: PropTypes.bool,
  showPaginationBottom: PropTypes.bool,
  showPageSizeOptions: PropTypes.bool,
  pageSizeOptions: PropTypes.array,
  defaultPageSize: PropTypes.number,
  showPageJump: PropTypes.bool,
  collapseOnSortingChange: PropTypes.bool,
  collapseOnPageChange: PropTypes.bool,
  collapseOnDataChange: PropTypes.bool,
  freezeWhenExpanded: PropTypes.bool,
  sortable: PropTypes.bool,
  resizable: PropTypes.bool,
  filterable: PropTypes.bool,
  defaultSortDesc: PropTypes.bool,
  defaultSorted: PropTypes.array,
  defaultFiltered: PropTypes.array,
  defaultResized: PropTypes.array,
  defaultExpanded: PropTypes.object,
  defaultFilterMethod: PropTypes.func,
  defaultSortMethod: PropTypes.func,
  // Controlled State Callbacks
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  onResizedChange: PropTypes.func,
  onExpandedChange: PropTypes.func,
  // Pivoting
  pivotBy: PropTypes.array,
  // Key Constants
  pivotValKey: PropTypes.string,
  pivotIDKey: PropTypes.string,
  subRowsKey: PropTypes.string,
  aggregatedKey: PropTypes.string,
  nestingLevelKey: PropTypes.string,
  originalKey: PropTypes.string,
  indexKey: PropTypes.string,
  groupedByPivotKey: PropTypes.string,
  // Server-side Callbacks
  onFetchData: PropTypes.func,
  // Classes
  className: PropTypes.string,
  style: PropTypes.object,
  // Component decorators
  getProps: PropTypes.func,
  getTableProps: PropTypes.func,
  getTheadGroupProps: PropTypes.func,
  getTheadGroupTrProps: PropTypes.func,
  getTheadGroupThProps: PropTypes.func,
  getTheadProps: PropTypes.func,
  getTheadTrProps: PropTypes.func,
  getTheadThProps: PropTypes.func,
  getTheadFilterProps: PropTypes.func,
  getTheadFilterTrProps: PropTypes.func,
  getTheadFilterThProps: PropTypes.func,
  getTbodyProps: PropTypes.func,
  getTrGroupProps: PropTypes.func,
  getTrProps: PropTypes.func,
  getTdProps: PropTypes.func,
  getTfootProps: PropTypes.func,
  getTfootTrProps: PropTypes.func,
  getTfootTdProps: PropTypes.func,
  getPaginationProps: PropTypes.func,
  getLoadingProps: PropTypes.func,
  getNoDataProps: PropTypes.func,
  getResizerProps: PropTypes.func,
  // Global Column Defaults
  columns: PropTypes.arrayOf(PropTypes.shape({
    // Renderers
    Cell: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
    Header: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
    Footer: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
    Aggregated: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
    Pivot: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
    PivotValue: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
    Expander: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func]),
    Filter: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    // All Columns
    sortable: PropTypes.bool,
    // use table default
    resizable: PropTypes.bool,
    // use table default
    filterable: PropTypes.bool,
    // use table default
    show: PropTypes.bool,
    minWidth: PropTypes.number,
    // Cells only
    className: PropTypes.string,
    style: PropTypes.object,
    getProps: PropTypes.func,
    // Pivot only
    aggregate: PropTypes.func,
    // Headers only
    headerClassName: PropTypes.string,
    headerStyle: PropTypes.object,
    getHeaderProps: PropTypes.func,
    // Footers only
    footerClassName: PropTypes.string,
    footerStyle: PropTypes.object,
    getFooterProps: PropTypes.object,
    filterMethod: PropTypes.func,
    filterAll: PropTypes.bool,
    sortMethod: PropTypes.func
  })),
  // Global Expander Column Defaults
  expanderDefaults: PropTypes.shape({
    sortable: PropTypes.bool,
    resizable: PropTypes.bool,
    filterable: PropTypes.bool,
    width: PropTypes.number
  }),
  pivotDefaults: PropTypes.object,
  // Text
  previousText: PropTypes.node,
  nextText: PropTypes.node,
  loadingText: PropTypes.node,
  noDataText: PropTypes.node,
  pageText: PropTypes.node,
  ofText: PropTypes.node,
  rowsText: PropTypes.node,
  // Components
  TableComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  TheadComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  TbodyComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  TrGroupComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  TrComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  ThComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  TdComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  TfootComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  FilterComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  ExpanderComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  PivotValueComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  AggregatedComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  // this is a computed default generated using
  PivotComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  // the ExpanderComponent and PivotValueComponent at run-time in methods.js
  PaginationComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  PreviousComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  NextComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  LoadingComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  NoDataComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  ResizerComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  PadRowComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
};

var _slicedToArray$2 = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass$7 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn$6(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ReactTable = function (_Methods) {
  _inherits$6(ReactTable, _Methods);

  function ReactTable(props) {
    _classCallCheck$7(this, ReactTable);

    var _this = _possibleConstructorReturn$6(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));

    _this.getResolvedState = _this.getResolvedState.bind(_this);
    _this.getDataModel = _this.getDataModel.bind(_this);
    _this.getSortedData = _this.getSortedData.bind(_this);
    _this.fireFetchData = _this.fireFetchData.bind(_this);
    _this.getPropOrState = _this.getPropOrState.bind(_this);
    _this.getStateOrProp = _this.getStateOrProp.bind(_this);
    _this.filterData = _this.filterData.bind(_this);
    _this.sortData = _this.sortData.bind(_this);
    _this.getMinRows = _this.getMinRows.bind(_this);
    _this.onPageChange = _this.onPageChange.bind(_this);
    _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
    _this.sortColumn = _this.sortColumn.bind(_this);
    _this.filterColumn = _this.filterColumn.bind(_this);
    _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
    _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
    _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);
    _this.state = {
      page: 0,
      pageSize: props.defaultPageSize,
      sorted: props.defaultSorted,
      expanded: props.defaultExpanded,
      filtered: props.defaultFiltered,
      resized: props.defaultResized,
      currentlyResizing: false,
      skipNextSort: false
    };
    return _this;
  }

  _createClass$7(ReactTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var resolvedState = this.getResolvedState();
      var children = resolvedState.children,
          className = resolvedState.className,
          style = resolvedState.style,
          getProps = resolvedState.getProps,
          getTableProps = resolvedState.getTableProps,
          getTheadGroupProps = resolvedState.getTheadGroupProps,
          getTheadGroupTrProps = resolvedState.getTheadGroupTrProps,
          getTheadGroupThProps = resolvedState.getTheadGroupThProps,
          getTheadProps = resolvedState.getTheadProps,
          getTheadTrProps = resolvedState.getTheadTrProps,
          getTheadThProps = resolvedState.getTheadThProps,
          getTheadFilterProps = resolvedState.getTheadFilterProps,
          getTheadFilterTrProps = resolvedState.getTheadFilterTrProps,
          getTheadFilterThProps = resolvedState.getTheadFilterThProps,
          getTbodyProps = resolvedState.getTbodyProps,
          getTrGroupProps = resolvedState.getTrGroupProps,
          getTrProps = resolvedState.getTrProps,
          getTdProps = resolvedState.getTdProps,
          getTfootProps = resolvedState.getTfootProps,
          getTfootTrProps = resolvedState.getTfootTrProps,
          getTfootTdProps = resolvedState.getTfootTdProps,
          getPaginationProps = resolvedState.getPaginationProps,
          getLoadingProps = resolvedState.getLoadingProps,
          getNoDataProps = resolvedState.getNoDataProps,
          getResizerProps = resolvedState.getResizerProps,
          showPagination = resolvedState.showPagination,
          showPaginationTop = resolvedState.showPaginationTop,
          showPaginationBottom = resolvedState.showPaginationBottom,
          manual = resolvedState.manual,
          loadingText = resolvedState.loadingText,
          noDataText = resolvedState.noDataText,
          sortable = resolvedState.sortable,
          multiSort = resolvedState.multiSort,
          resizable = resolvedState.resizable,
          filterable = resolvedState.filterable,
          pivotIDKey = resolvedState.pivotIDKey,
          pivotValKey = resolvedState.pivotValKey,
          pivotBy = resolvedState.pivotBy,
          subRowsKey = resolvedState.subRowsKey,
          aggregatedKey = resolvedState.aggregatedKey,
          originalKey = resolvedState.originalKey,
          indexKey = resolvedState.indexKey,
          groupedByPivotKey = resolvedState.groupedByPivotKey,
          loading = resolvedState.loading,
          pageSize = resolvedState.pageSize,
          page = resolvedState.page,
          sorted = resolvedState.sorted,
          filtered = resolvedState.filtered,
          resized = resolvedState.resized,
          expanded = resolvedState.expanded,
          pages = resolvedState.pages,
          onExpandedChange = resolvedState.onExpandedChange,
          TableComponent = resolvedState.TableComponent,
          TheadComponent = resolvedState.TheadComponent,
          TbodyComponent = resolvedState.TbodyComponent,
          TrGroupComponent = resolvedState.TrGroupComponent,
          TrComponent = resolvedState.TrComponent,
          ThComponent = resolvedState.ThComponent,
          TdComponent = resolvedState.TdComponent,
          TfootComponent = resolvedState.TfootComponent,
          PaginationComponent = resolvedState.PaginationComponent,
          LoadingComponent = resolvedState.LoadingComponent,
          SubComponent = resolvedState.SubComponent,
          NoDataComponent = resolvedState.NoDataComponent,
          ResizerComponent = resolvedState.ResizerComponent,
          ExpanderComponent = resolvedState.ExpanderComponent,
          PivotValueComponent = resolvedState.PivotValueComponent,
          PivotComponent = resolvedState.PivotComponent,
          AggregatedComponent = resolvedState.AggregatedComponent,
          FilterComponent = resolvedState.FilterComponent,
          PadRowComponent = resolvedState.PadRowComponent,
          resolvedData = resolvedState.resolvedData,
          allVisibleColumns = resolvedState.allVisibleColumns,
          headerGroups = resolvedState.headerGroups,
          hasHeaderGroups = resolvedState.hasHeaderGroups,
          sortedData = resolvedState.sortedData,
          currentlyResizing = resolvedState.currentlyResizing; // Pagination

      var startRow = pageSize * page;
      var endRow = startRow + pageSize;
      var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
      var minRows = this.getMinRows();

      var padRows = _.range(Math.max(minRows - pageRows.length, 0));

      var hasColumnFooter = allVisibleColumns.some(function (d) {
        return d.Footer;
      });
      var hasFilters = filterable || allVisibleColumns.some(function (d) {
        return d.filterable;
      });

      var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        return [rows.map(function (row, i) {
          index += 1;

          var rowWithViewIndex = _extends$9({}, row, {
            _viewIndex: index
          });

          var newPath = path.concat([i]);

          if (rowWithViewIndex[subRowsKey] && _.get(expanded, newPath)) {
            var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);

            var _recurseRowsViewIndex2 = _slicedToArray$2(_recurseRowsViewIndex, 2);

            rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
            index = _recurseRowsViewIndex2[1];
          }

          return rowWithViewIndex;
        }), index];
      };

      var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);

      var _recurseRowsViewIndex4 = _slicedToArray$2(_recurseRowsViewIndex3, 1);

      pageRows = _recurseRowsViewIndex4[0];
      var canPrevious = page > 0;
      var canNext = page + 1 < pages;

      var rowMinWidth = _.sum(allVisibleColumns.map(function (d) {
        var resizedColumn = resized.find(function (x) {
          return x.id === d.id;
        }) || {};
        return _.getFirstDefined(resizedColumn.value, d.width, d.minWidth);
      }));

      var rowIndex = -1;

      var finalState = _extends$9({}, resolvedState, {
        startRow: startRow,
        endRow: endRow,
        pageRows: pageRows,
        minRows: minRows,
        padRows: padRows,
        hasColumnFooter: hasColumnFooter,
        canPrevious: canPrevious,
        canNext: canNext,
        rowMinWidth: rowMinWidth
      });

      var rootProps = _.splitProps(getProps(finalState, undefined, undefined, this));

      var tableProps = _.splitProps(getTableProps(finalState, undefined, undefined, this));

      var tBodyProps = _.splitProps(getTbodyProps(finalState, undefined, undefined, this));

      var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
      var noDataProps = getNoDataProps(finalState, undefined, undefined, this); // Visual Components

      var makeHeaderGroup = function makeHeaderGroup(column, i) {
        var resizedValue = function resizedValue(col) {
          return (resized.find(function (x) {
            return x.id === col.id;
          }) || {}).value;
        };

        var flex = _.sum(column.columns.map(function (col) {
          return col.width || resizedValue(col) ? 0 : col.minWidth;
        }));

        var width = _.sum(column.columns.map(function (col) {
          return _.getFirstDefined(resizedValue(col), col.width, col.minWidth);
        }));

        var maxWidth = _.sum(column.columns.map(function (col) {
          return _.getFirstDefined(resizedValue(col), col.width, col.maxWidth);
        }));

        var theadGroupThProps = _.splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));

        var columnHeaderProps = _.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadGroupThProps.className, columnHeaderProps.className];

        var styles = _extends$9({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);

        var rest = _extends$9({}, theadGroupThProps.rest, columnHeaderProps.rest);

        var flexStyles = {
          flex: flex + ' 0 auto',
          width: _.asPx(width),
          maxWidth: _.asPx(maxWidth)
        };
        return React__default.createElement(ThComponent, _extends$9({
          key: i + '-' + column.id,
          className: classnames(classes),
          style: _extends$9({}, styles, flexStyles)
        }, rest), _.normalizeComponent(column.Header, {
          data: sortedData,
          column: column
        }));
      };

      var makeHeaderGroups = function makeHeaderGroups() {
        var theadGroupProps = _.splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));

        var theadGroupTrProps = _.splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));

        return React__default.createElement(TheadComponent, _extends$9({
          className: classnames('-headerGroups', theadGroupProps.className),
          style: _extends$9({}, theadGroupProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, theadGroupProps.rest), React__default.createElement(TrComponent, _extends$9({
          className: theadGroupTrProps.className,
          style: theadGroupTrProps.style
        }, theadGroupTrProps.rest), headerGroups.map(makeHeaderGroup)));
      };

      var makeHeader = function makeHeader(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var sort = sorted.find(function (d) {
          return d.id === column.id;
        });
        var show = typeof column.show === 'function' ? column.show() : column.show;

        var width = _.getFirstDefined(resizedCol.value, column.width, column.minWidth);

        var maxWidth = _.getFirstDefined(resizedCol.value, column.width, column.maxWidth);

        var theadThProps = _.splitProps(getTheadThProps(finalState, undefined, column, _this2));

        var columnHeaderProps = _.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadThProps.className, columnHeaderProps.className];

        var styles = _extends$9({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);

        var rest = _extends$9({}, theadThProps.rest, columnHeaderProps.rest);

        var isResizable = _.getFirstDefined(column.resizable, resizable, false);

        var resizer = isResizable ? React__default.createElement(ResizerComponent, _extends$9({
          onMouseDown: function onMouseDown(e) {
            return _this2.resizeColumnStart(e, column, false);
          },
          onTouchStart: function onTouchStart(e) {
            return _this2.resizeColumnStart(e, column, true);
          }
        }, getResizerProps('finalState', undefined, column, _this2))) : null;

        var isSortable = _.getFirstDefined(column.sortable, sortable, false);

        return React__default.createElement(ThComponent, _extends$9({
          key: i + '-' + column.id,
          className: classnames(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
          style: _extends$9({}, styles, {
            flex: width + ' 0 auto',
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth)
          }),
          toggleSort: function toggleSort(e) {
            if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
          }
        }, rest), React__default.createElement('div', {
          className: classnames(isResizable && 'rt-resizable-header-content')
        }, _.normalizeComponent(column.Header, {
          data: sortedData,
          column: column
        })), resizer);
      };

      var makeHeaders = function makeHeaders() {
        var theadProps = _.splitProps(getTheadProps(finalState, undefined, undefined, _this2));

        var theadTrProps = _.splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));

        return React__default.createElement(TheadComponent, _extends$9({
          className: classnames('-header', theadProps.className),
          style: _extends$9({}, theadProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, theadProps.rest), React__default.createElement(TrComponent, _extends$9({
          className: theadTrProps.className,
          style: theadTrProps.style
        }, theadTrProps.rest), allVisibleColumns.map(makeHeader)));
      };

      var makeFilter = function makeFilter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};

        var width = _.getFirstDefined(resizedCol.value, column.width, column.minWidth);

        var maxWidth = _.getFirstDefined(resizedCol.value, column.width, column.maxWidth);

        var theadFilterThProps = _.splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));

        var columnHeaderProps = _.splitProps(column.getHeaderProps(finalState, undefined, column, _this2));

        var classes = [column.headerClassName, theadFilterThProps.className, columnHeaderProps.className];

        var styles = _extends$9({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);

        var rest = _extends$9({}, theadFilterThProps.rest, columnHeaderProps.rest);

        var filter = filtered.find(function (filter) {
          return filter.id === column.id;
        });
        var ResolvedFilterComponent = column.Filter || FilterComponent;

        var isFilterable = _.getFirstDefined(column.filterable, filterable, false);

        return React__default.createElement(ThComponent, _extends$9({
          key: i + '-' + column.id,
          className: classnames(classes),
          style: _extends$9({}, styles, {
            flex: width + ' 0 auto',
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth)
          })
        }, rest), isFilterable ? _.normalizeComponent(ResolvedFilterComponent, {
          column: column,
          filter: filter,
          onChange: function onChange(value) {
            return _this2.filterColumn(column, value);
          }
        }, defaultProps.column.Filter) : null);
      };

      var makeFilters = function makeFilters() {
        var theadFilterProps = _.splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));

        var theadFilterTrProps = _.splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));

        return React__default.createElement(TheadComponent, _extends$9({
          className: classnames('-filters', theadFilterProps.className),
          style: _extends$9({}, theadFilterProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, theadFilterProps.rest), React__default.createElement(TrComponent, _extends$9({
          className: theadFilterTrProps.className,
          style: theadFilterTrProps.style
        }, theadFilterTrProps.rest), allVisibleColumns.map(makeFilter)));
      };

      var makePageRow = function makePageRow(row, i) {
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var rowInfo = {
          original: row[originalKey],
          row: row,
          index: row[indexKey],
          viewIndex: rowIndex += 1,
          pageSize: pageSize,
          page: page,
          level: path.length,
          nestingPath: path.concat([i]),
          aggregated: row[aggregatedKey],
          groupedByPivot: row[groupedByPivotKey],
          subRows: row[subRowsKey]
        };

        var isExpanded = _.get(expanded, rowInfo.nestingPath);

        var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);

        var trProps = _.splitProps(getTrProps(finalState, rowInfo, undefined, _this2));

        return React__default.createElement(TrGroupComponent, _extends$9({
          key: rowInfo.nestingPath.join('_')
        }, trGroupProps), React__default.createElement(TrComponent, _extends$9({
          className: classnames(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
          style: trProps.style
        }, trProps.rest), allVisibleColumns.map(function (column, i2) {
          var resizedCol = resized.find(function (x) {
            return x.id === column.id;
          }) || {};
          var show = typeof column.show === 'function' ? column.show() : column.show;

          var width = _.getFirstDefined(resizedCol.value, column.width, column.minWidth);

          var maxWidth = _.getFirstDefined(resizedCol.value, column.width, column.maxWidth);

          var tdProps = _.splitProps(getTdProps(finalState, rowInfo, column, _this2));

          var columnProps = _.splitProps(column.getProps(finalState, rowInfo, column, _this2));

          var classes = [tdProps.className, column.className, columnProps.className];

          var styles = _extends$9({}, tdProps.style, column.style, columnProps.style);

          var cellInfo = _extends$9({}, rowInfo, {
            isExpanded: isExpanded,
            column: _extends$9({}, column),
            value: rowInfo.row[column.id],
            pivoted: column.pivoted,
            expander: column.expander,
            resized: resized,
            show: show,
            width: width,
            maxWidth: maxWidth,
            tdProps: tdProps,
            columnProps: columnProps,
            classes: classes,
            styles: styles
          });

          var value = cellInfo.value;
          var useOnExpanderClick = void 0;
          var isBranch = void 0;
          var isPreview = void 0;

          var onExpanderClick = function onExpanderClick(e) {
            var newExpanded = _.clone(expanded);

            if (isExpanded) {
              newExpanded = _.set(newExpanded, cellInfo.nestingPath, false);
            } else {
              newExpanded = _.set(newExpanded, cellInfo.nestingPath, {});
            }

            return _this2.setStateWithData({
              expanded: newExpanded
            }, function () {
              return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e);
            });
          }; // Default to a standard cell


          var resolvedCell = _.normalizeComponent(column.Cell, cellInfo, value); // Resolve Renderers


          var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
          var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
          var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;

          var DefaultResolvedPivotComponent = PivotComponent || function (props) {
            return React__default.createElement('div', null, React__default.createElement(ResolvedExpanderComponent, props), React__default.createElement(ResolvedPivotValueComponent, props));
          };

          var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent; // Is this cell expandable?

          if (cellInfo.pivoted || cellInfo.expander) {
            // Make it expandable by defualt
            cellInfo.expandable = true;
            useOnExpanderClick = true; // If pivoted, has no subRows, and does not have a subComponent,
            // do not make expandable

            if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) {
              cellInfo.expandable = false;
            }
          }

          if (cellInfo.pivoted) {
            // Is this column a branch?
            isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows; // Should this column be blank?

            isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows; // Pivot Cell Render Override

            if (isBranch) {
              // isPivot
              resolvedCell = _.normalizeComponent(ResolvedPivotComponent, _extends$9({}, cellInfo, {
                value: row[pivotValKey]
              }), row[pivotValKey]);
            } else if (isPreview) {
              // Show the pivot preview
              resolvedCell = _.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
            } else {
              resolvedCell = null;
            }
          } else if (cellInfo.aggregated) {
            resolvedCell = _.normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
          }

          if (cellInfo.expander) {
            resolvedCell = _.normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);

            if (pivotBy) {
              if (cellInfo.groupedByPivot) {
                resolvedCell = null;
              }

              if (!cellInfo.subRows && !SubComponent) {
                resolvedCell = null;
              }
            }
          }

          var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function () {}; // If there are multiple onClick events, make sure they don't
          // override eachother. This should maybe be expanded to handle all
          // function attributes

          var interactionProps = {
            onClick: resolvedOnExpanderClick
          };

          if (tdProps.rest.onClick) {
            interactionProps.onClick = function (e) {
              tdProps.rest.onClick(e, function () {
                return resolvedOnExpanderClick(e);
              });
            };
          }

          if (columnProps.rest.onClick) {
            interactionProps.onClick = function (e) {
              columnProps.rest.onClick(e, function () {
                return resolvedOnExpanderClick(e);
              });
            };
          } // Return the cell


          return React__default.createElement(TdComponent // eslint-disable-next-line react/no-array-index-key
          , _extends$9({
            key: i2 + '-' + column.id,
            className: classnames(classes, !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
            style: _extends$9({}, styles, {
              flex: width + ' 0 auto',
              width: _.asPx(width),
              maxWidth: _.asPx(maxWidth)
            })
          }, tdProps.rest, columnProps.rest, interactionProps), resolvedCell);
        })), rowInfo.subRows && isExpanded && rowInfo.subRows.map(function (d, i) {
          return makePageRow(d, i, rowInfo.nestingPath);
        }), SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo));
      };

      var makePadColumn = function makePadColumn(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;

        var width = _.getFirstDefined(resizedCol.value, column.width, column.minWidth);

        var flex = width;

        var maxWidth = _.getFirstDefined(resizedCol.value, column.width, column.maxWidth);

        var tdProps = _.splitProps(getTdProps(finalState, undefined, column, _this2));

        var columnProps = _.splitProps(column.getProps(finalState, undefined, column, _this2));

        var classes = [tdProps.className, column.className, columnProps.className];

        var styles = _extends$9({}, tdProps.style, column.style, columnProps.style);

        return React__default.createElement(TdComponent, _extends$9({
          key: i + '-' + column.id,
          className: classnames(classes, !show && 'hidden'),
          style: _extends$9({}, styles, {
            flex: flex + ' 0 auto',
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth)
          })
        }, tdProps.rest), _.normalizeComponent(PadRowComponent));
      };

      var makePadRow = function makePadRow(row, i) {
        var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);

        var trProps = _.splitProps(getTrProps(finalState, undefined, undefined, _this2));

        return React__default.createElement(TrGroupComponent, _extends$9({
          key: i
        }, trGroupProps), React__default.createElement(TrComponent, {
          className: classnames('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
          style: trProps.style || {}
        }, allVisibleColumns.map(makePadColumn)));
      };

      var makeColumnFooter = function makeColumnFooter(column, i) {
        var resizedCol = resized.find(function (x) {
          return x.id === column.id;
        }) || {};
        var show = typeof column.show === 'function' ? column.show() : column.show;

        var width = _.getFirstDefined(resizedCol.value, column.width, column.minWidth);

        var maxWidth = _.getFirstDefined(resizedCol.value, column.width, column.maxWidth);

        var tFootTdProps = _.splitProps(getTfootTdProps(finalState, undefined, undefined, _this2));

        var columnProps = _.splitProps(column.getProps(finalState, undefined, column, _this2));

        var columnFooterProps = _.splitProps(column.getFooterProps(finalState, undefined, column, _this2));

        var classes = [tFootTdProps.className, column.className, columnProps.className, columnFooterProps.className];

        var styles = _extends$9({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);

        return React__default.createElement(TdComponent, _extends$9({
          key: i + '-' + column.id,
          className: classnames(classes, !show && 'hidden'),
          style: _extends$9({}, styles, {
            flex: width + ' 0 auto',
            width: _.asPx(width),
            maxWidth: _.asPx(maxWidth)
          })
        }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest), _.normalizeComponent(column.Footer, {
          data: sortedData,
          column: column
        }));
      };

      var makeColumnFooters = function makeColumnFooters() {
        var tFootProps = getTfootProps(finalState, undefined, undefined, _this2);

        var tFootTrProps = _.splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));

        return React__default.createElement(TfootComponent, _extends$9({
          className: tFootProps.className,
          style: _extends$9({}, tFootProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, tFootProps.rest), React__default.createElement(TrComponent, _extends$9({
          className: classnames(tFootTrProps.className),
          style: tFootTrProps.style
        }, tFootTrProps.rest), allVisibleColumns.map(makeColumnFooter)));
      };

      var makePagination = function makePagination() {
        var paginationProps = _.splitProps(getPaginationProps(finalState, undefined, undefined, _this2));

        return React__default.createElement(PaginationComponent, _extends$9({}, resolvedState, {
          pages: pages,
          canPrevious: canPrevious,
          canNext: canNext,
          onPageChange: _this2.onPageChange,
          onPageSizeChange: _this2.onPageSizeChange,
          className: paginationProps.className,
          style: paginationProps.style
        }, paginationProps.rest));
      };

      var makeTable = function makeTable() {
        var pagination = makePagination();
        return React__default.createElement('div', _extends$9({
          className: classnames('ReactTable', className, rootProps.className),
          style: _extends$9({}, style, rootProps.style)
        }, rootProps.rest), showPagination && showPaginationTop ? React__default.createElement('div', {
          className: 'pagination-top'
        }, pagination) : null, React__default.createElement(TableComponent, _extends$9({
          className: classnames(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
          style: tableProps.style
        }, tableProps.rest), hasHeaderGroups ? makeHeaderGroups() : null, makeHeaders(), hasFilters ? makeFilters() : null, React__default.createElement(TbodyComponent, _extends$9({
          className: classnames(tBodyProps.className),
          style: _extends$9({}, tBodyProps.style, {
            minWidth: rowMinWidth + 'px'
          })
        }, tBodyProps.rest), pageRows.map(function (d, i) {
          return makePageRow(d, i);
        }), padRows.map(makePadRow)), hasColumnFooter ? makeColumnFooters() : null), showPagination && showPaginationBottom ? React__default.createElement('div', {
          className: 'pagination-bottom'
        }, pagination) : null, !pageRows.length && React__default.createElement(NoDataComponent, noDataProps, _.normalizeComponent(noDataText)), React__default.createElement(LoadingComponent, _extends$9({
          loading: loading,
          loadingText: loadingText
        }, loadingProps)));
      }; // childProps are optionally passed to a function-as-a-child


      return children ? children(finalState, makeTable, this) : makeTable();
    }
  }]);

  return ReactTable;
}(Methods(Lifecycle(Component)));

ReactTable.propTypes = propTypes$2;
ReactTable.defaultProps = defaultProps;
var css$2 = ".ReactTable{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border:1px solid rgba(0,0,0,0.1);}.ReactTable *{box-sizing:border-box}.ReactTable .rt-table{-webkit-box-flex:1;-ms-flex:auto 1;flex:auto 1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%;border-collapse:collapse;overflow:auto}.ReactTable .rt-thead{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.ReactTable .rt-thead.-headerGroups{background:rgba(0,0,0,0.03);border-bottom:1px solid rgba(0,0,0,0.05)}.ReactTable .rt-thead.-filters{border-bottom:1px solid rgba(0,0,0,0.05);}.ReactTable .rt-thead.-filters input,.ReactTable .rt-thead.-filters select{border:1px solid rgba(0,0,0,0.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:normal;outline:none}.ReactTable .rt-thead.-filters .rt-th{border-right:1px solid rgba(0,0,0,0.02)}.ReactTable .rt-thead.-header{box-shadow:0 2px 15px 0 rgba(0,0,0,0.15)}.ReactTable .rt-thead .rt-tr{text-align:center}.ReactTable .rt-thead .rt-th,.ReactTable .rt-thead .rt-td{padding:5px 5px;line-height:normal;position:relative;border-right:1px solid rgba(0,0,0,0.05);transition:box-shadow .3s cubic-bezier(.175,.885,.32,1.275);box-shadow:inset 0 0 0 0 transparent;}.ReactTable .rt-thead .rt-th.-sort-asc,.ReactTable .rt-thead .rt-td.-sort-asc{box-shadow:inset 0 3px 0 0 rgba(0,0,0,0.6)}.ReactTable .rt-thead .rt-th.-sort-desc,.ReactTable .rt-thead .rt-td.-sort-desc{box-shadow:inset 0 -3px 0 0 rgba(0,0,0,0.6)}.ReactTable .rt-thead .rt-th.-cursor-pointer,.ReactTable .rt-thead .rt-td.-cursor-pointer{cursor:pointer}.ReactTable .rt-thead .rt-th:last-child,.ReactTable .rt-thead .rt-td:last-child{border-right:0}.ReactTable .rt-thead .rt-resizable-header{overflow:visible;}.ReactTable .rt-thead .rt-resizable-header:last-child{overflow:hidden}.ReactTable .rt-thead .rt-resizable-header-content{overflow:hidden;text-overflow:ellipsis}.ReactTable .rt-thead .rt-header-pivot{border-right-color:#f7f7f7}.ReactTable .rt-thead .rt-header-pivot:after,.ReactTable .rt-thead .rt-header-pivot:before{left:100%;top:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.ReactTable .rt-thead .rt-header-pivot:after{border-color:rgba(255,255,255,0);border-left-color:#fff;border-width:8px;margin-top:-8px}.ReactTable .rt-thead .rt-header-pivot:before{border-color:rgba(102,102,102,0);border-left-color:#f7f7f7;border-width:10px;margin-top:-10px}.ReactTable .rt-tbody{-webkit-box-flex:99999;-ms-flex:99999 1 auto;flex:99999 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:auto;}.ReactTable .rt-tbody .rt-tr-group{border-bottom:solid 1px rgba(0,0,0,0.05);}.ReactTable .rt-tbody .rt-tr-group:last-child{border-bottom:0}.ReactTable .rt-tbody .rt-td{border-right:1px solid rgba(0,0,0,0.02);}.ReactTable .rt-tbody .rt-td:last-child{border-right:0}.ReactTable .rt-tbody .rt-expandable{cursor:pointer;text-overflow:clip}.ReactTable .rt-tr-group{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.ReactTable .rt-tr{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ReactTable .rt-th,.ReactTable .rt-td{-webkit-box-flex:1;-ms-flex:1 0 0px;flex:1 0 0;white-space:nowrap;text-overflow:ellipsis;padding:7px 5px;overflow:hidden;transition:.3s ease;transition-property:width,min-width,padding,opacity;}.ReactTable .rt-th.-hidden,.ReactTable .rt-td.-hidden{width:0 !important;min-width:0 !important;padding:0 !important;border:0 !important;opacity:0 !important}.ReactTable .rt-expander{display:inline-block;position:relative;margin:0;color:transparent;margin:0 10px;}.ReactTable .rt-expander:after{content:'';position:absolute;width:0;height:0;top:50%;left:50%;-webkit-transform:translate(-50%,-50%) rotate(-90deg);transform:translate(-50%,-50%) rotate(-90deg);border-left:5.04px solid transparent;border-right:5.04px solid transparent;border-top:7px solid rgba(0,0,0,0.8);transition:all .3s cubic-bezier(.175,.885,.32,1.275);cursor:pointer}.ReactTable .rt-expander.-open:after{-webkit-transform:translate(-50%,-50%) rotate(0);transform:translate(-50%,-50%) rotate(0)}.ReactTable .rt-resizer{display:inline-block;position:absolute;width:36px;top:0;bottom:0;right:-18px;cursor:col-resize;z-index:10}.ReactTable .rt-tfoot{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;box-shadow:0 0 15px 0 rgba(0,0,0,0.15);}.ReactTable .rt-tfoot .rt-td{border-right:1px solid rgba(0,0,0,0.05);}.ReactTable .rt-tfoot .rt-td:last-child{border-right:0}.ReactTable.-striped .rt-tr.-odd{background:rgba(0,0,0,0.03)}.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover{background:rgba(0,0,0,0.05)}.ReactTable .-pagination{z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:3px;box-shadow:0 0 15px 0 rgba(0,0,0,0.1);border-top:2px solid rgba(0,0,0,0.1);}.ReactTable .-pagination input,.ReactTable .-pagination select{border:1px solid rgba(0,0,0,0.1);background:#fff;padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:normal;outline:none}.ReactTable .-pagination .-btn{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;width:100%;height:100%;border:0;border-radius:3px;padding:6px;font-size:1em;color:rgba(0,0,0,0.6);background:rgba(0,0,0,0.1);transition:all .1s ease;cursor:pointer;outline:none;}.ReactTable .-pagination .-btn[disabled]{opacity:.5;cursor:default}.ReactTable .-pagination .-btn:not([disabled]):hover{background:rgba(0,0,0,0.3);color:#fff}.ReactTable .-pagination .-previous,.ReactTable .-pagination .-next{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center}.ReactTable .-pagination .-center{-webkit-box-flex:1.5;-ms-flex:1.5;flex:1.5;text-align:center;margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.ReactTable .-pagination .-pageInfo{display:inline-block;margin:3px 10px;white-space:nowrap}.ReactTable .-pagination .-pageJump{display:inline-block;}.ReactTable .-pagination .-pageJump input{width:70px;text-align:center}.ReactTable .-pagination .-pageSizeOptions{margin:3px 10px}.ReactTable .rt-noData{display:block;position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background:rgba(255,255,255,0.8);transition:all .3s ease;z-index:1;pointer-events:none;padding:20px;color:rgba(0,0,0,0.5)}.ReactTable .-loading{display:block;position:absolute;left:0;right:0;top:0;bottom:0;background:rgba(255,255,255,0.8);transition:all .3s ease;z-index:-1;opacity:0;pointer-events:none;}.ReactTable .-loading > div{position:absolute;display:block;text-align:center;width:100%;top:50%;left:0;font-size:15px;color:rgba(0,0,0,0.6);-webkit-transform:translateY(-52%);transform:translateY(-52%);transition:all .3s cubic-bezier(.25,.46,.45,.94)}.ReactTable .-loading.-active{opacity:1;z-index:2;pointer-events:all;}.ReactTable .-loading.-active > div{-webkit-transform:translateY(50%);transform:translateY(50%)}.ReactTable .rt-resizing .rt-th,.ReactTable .rt-resizing .rt-td{transition:none !important;cursor:col-resize;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}";
styleInject(css$2);

function getTdProps() {
  return {
    style: {
      borderRight: 'none'
    }
  };
}

function getTrGroupProps(fixedColors) {
  return function () {
    return {
      style: {
        borderColor: fixedColors.divider
      }
    };
  };
}

function getTrProps() {
  return {
    style: {
      padding: '0px 55px 0px 25px'
    }
  };
}

function getTheadThProps(state, rowInfo, column, instance) {
  return {
    style: {
      outline: 'none',
      paddingTop: 8,
      paddingBottom: 9,
      borderRight: 'none',
      textAlign: column.id === 'name' ? 'left' : 'right'
    }
  };
}

function getTheadProps(fixedColors, textColors) {
  return function () {
    return {
      style: {
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: textColors.light,
        backgroundColor: fixedColors.backgroundLight,
        boxShadow: 'none',
        padding: '0 55px 0 25px'
      }
    };
  };
}

function getInnerTrGroupProps(fixedColors) {
  return function () {
    return {
      style: {
        borderColor: fixedColors.divider,
        borderBottomWidth: 0,
        borderTopWidth: 1,
        borderTopStyle: 'solid'
      }
    };
  };
}

function innerTableProps() {
  return {
    style: {
      overflow: 'hidden'
    }
  };
}

var InnerTheadComponent = function InnerTheadComponent() {
  return null;
};

var Expander = function Expander(_ref) {
  var isExpanded = _ref.isExpanded,
      others = objectWithoutProperties(_ref, ['isExpanded']);
  var _others$columnProps$r = others.columnProps.rest,
      colors = _others$columnProps$r.colors,
      textcolors = _others$columnProps$r.textcolors;
  var originalData = others.original;
  var labelStyle = {
    color: originalData.holdings ? colors.secondary : textcolors.dark
  };
  var expanderStyle = {
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    borderStyle: 'solid',
    borderWidth: '0 0 10px 10px',
    borderColor: 'transparent transparent ' + (isExpanded ? textcolors.light : colors.secondary) + ' transparent',
    position: 'absolute'
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement('div', {
    style: labelStyle
  }, React__default.createElement('b', null, originalData.name)), originalData.isin && React__default.createElement('div', {
    style: labelStyle
  }, originalData.isin), originalData.holdings && React__default.createElement('div', {
    style: expanderStyle
  }));
};

Expander.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  columnProps: PropTypes.shape.isRequired
};

var CurrencyCell = function CurrencyCell(props) {
  var language = props.columnProps.rest.language;
  var value = props.value;
  return React__default.createElement('div', null, ' ', numberDecimalFormat(value, language), ' ');
};

CurrencyCell.propTypes = {
  value: PropTypes.number.isRequired,
  columnProps: PropTypes.shape.isRequired
};

var PercentageCell = function PercentageCell(props) {
  var language = props.columnProps.rest.language;
  var value = props.value * 100;
  return React__default.createElement('div', null, ' ', numberDecimalFormat(value, language), ' ');
};

PercentageCell.propTypes = {
  value: PropTypes.number.isRequired,
  columnProps: PropTypes.shape.isRequired
};

var PerformanceCell = function PerformanceCell(props) {
  var original = props.original;
  var _props$columnProps$re = props.columnProps.rest,
      language = _props$columnProps$re.language,
      statuscolors = _props$columnProps$re.statuscolors;
  var performancePercentage = parseFloat(original['30d_performance_pct']) * 100;
  var performanceValue = parseFloat(original['30d_performance_abs']);
  var textStyle = {
    color: performanceValue < 0 ? statuscolors.loss : statuscolors.profit,
    fontSize: 17
  };
  var valuesStyle = {
    flex: 1
  };
  var containerStyle = {
    display: 'flex'
  };
  return React__default.createElement('div', {
    style: containerStyle
  }, React__default.createElement('span', {
    className: 'number',
    style: valuesStyle
  }, numberDecimalFormat(performanceValue, language), '\xA0', performanceValue < 0 ? React__default.createElement(FontAwesomeIcon, {
    style: textStyle,
    icon: faCaretDown
  }) : React__default.createElement(FontAwesomeIcon, {
    style: textStyle,
    icon: faCaretUp
  })), React__default.createElement('span', {
    className: 'number',
    style: valuesStyle
  }, numberDecimalFormat(performancePercentage, language), '\xA0', performanceValue < 0 ? React__default.createElement(FontAwesomeIcon, {
    style: textStyle,
    icon: faCaretDown
  }) : React__default.createElement(FontAwesomeIcon, {
    style: textStyle,
    icon: faCaretUp
  })));
};

PerformanceCell.propTypes = {
  original: PropTypes.shape().isRequired,
  columnProps: PropTypes.shape.isRequired
};
var columns = [{
  expander: true,
  Header: 'Name',
  minWidth: 390,
  style: {
    whiteSpace: 'unset',
    position: 'relative',
    textAlign: 'left',
    padding: '10px 5px'
  },
  accessor: 'name',
  sortable: true,
  Expander: Expander
}, {
  Header: function Header() {
    return React__default.createElement('span', null, 'Price', React__default.createElement('br', null), '(EUR)');
  },
  accessor: 'price',
  minWidth: 80,
  style: {
    textAlign: 'right',
    padding: '10px 5px'
  },
  Cell: CurrencyCell
}, {
  Header: 'Qty',
  accessor: 'quantity',
  minWidth: 80,
  style: {
    textAlign: 'right',
    padding: '10px 5px'
  }
}, {
  Header: function Header() {
    return React__default.createElement('span', null, 'Amount', React__default.createElement('br', null), '(EUR)');
  },
  accessor: 'amount',
  minWidth: 95,
  style: {
    textAlign: 'right',
    padding: '10px 5px'
  },
  Cell: CurrencyCell
}, {
  Header: function Header() {
    return React__default.createElement('span', null, 'Weight', React__default.createElement('br', null), '(%)');
  },
  accessor: 'weight',
  minWidth: 95,
  style: {
    textAlign: 'right',
    padding: '10px 5px'
  },
  Cell: PercentageCell
}, {
  Header: function Header() {
    return React__default.createElement('span', null, '30 Days Performance', React__default.createElement('div', {
      style: {
        display: 'flex'
      }
    }, React__default.createElement('span', {
      style: {
        flex: 1
      }
    }, '(EUR)'), React__default.createElement('span', {
      style: {
        flex: 1
      }
    }, '(%)')));
  },
  accessor: '30d_performance_abs',
  minWidth: 175,
  style: {
    textAlign: 'right',
    padding: '10px 5px'
  },
  Cell: PerformanceCell
}];
var styles$a = {
  collapseHeader: {
    display: 'block',
    position: 'relative',
    textAlign: 'left',
    cursor: 'pointer',
    color: function color(_ref) {
      var fixedColors = _ref.fixedColors;
      return fixedColors.background;
    },
    fontWeight: 400,
    textDecoration: 'none',
    background: function background(_ref2) {
      var colors = _ref2.colors;
      return colors.secondary;
    },
    padding: '8px 0px 8px 25px',
    userSelect: 'none',
    outline: 'unset',
    borderBottom: 'none',
    '& h4': {
      fontSize: 14,
      margin: 0
    },
    '&:hover': {
      background: function background(_ref3) {
        var colors = _ref3.colors;
        return colors.secondaryHover;
      }
    }
  },
  collapseHeaderContent: {
    marginRight: 40
  },
  collapseHeaderHide: {
    borderBottom: function borderBottom(_ref4) {
      var fixedColors = _ref4.fixedColors;
      return '5px solid ' + fixedColors.background;
    },
    '& $collapseArrow::before': {
      transform: 'rotate(225deg)',
      left: 7,
      top: 3
    },
    '& $collapseArrow::after': {
      transform: 'rotate(-225deg)',
      right: 7,
      top: 9
    }
  },
  collapseHeaderPercentage: {
    paddingLeft: 15
  },
  collapseContent: {
    paddingBottom: 10,
    borderTop: 'none',
    textAlign: 'initial',
    animation: 'fadeIn 0.5s',
    '& .ReactTable': {
      border: 'none'
    },
    '& .ReactTable .rt-thead .rt-tr': {
      textAlign: 'left'
    },
    '& .ReactTable .rt-thead .rt-th.-sort-asc': {
      position: 'relative',
      boxShadow: 'none',
      '&::before': {
        content: '""',
        position: 'absolute',
        right: 5,
        top: '50%',
        transform: 'translateY(-50%)',
        borderLeft: '3px solid transparent',
        borderRight: '3px solid transparent',
        borderBottom: function borderBottom(_ref5) {
          var fixedColors = _ref5.fixedColors;
          return '5px solid ' + fixedColors.background;
        }
      }
    },
    '& .ReactTable .rt-thead .rt-th.-sort-desc': {
      positiion: 'relative',
      boxShadow: 'none',
      '&::before': {
        content: '""',
        position: 'absolute',
        right: 5,
        top: '50%',
        transform: 'translateY(-50%)',
        borderTop: function borderTop(_ref6) {
          var fixedColors = _ref6.fixedColors;
          return '5px solid ' + fixedColors.background;
        },
        borderLeft: '3px solid transparent',
        borderRight: '3px solid transparent'
      }
    },
    '& .ReactTable .rt-thead .rt-th:first-of-type, .ReactTable .rt-thead .rt-td:first-of-type': {
      width: '390px !important',
      flex: '390 0 auto !important',
      maxWidth: 'unset !important'
    },
    '& .ReactTable .rt-tbody': {
      overflow: 'unset'
    },
    '& .ReactTable .rt-tbody .rt-td:first-of-type': {
      width: '390px !important',
      flex: '390 0 auto !important',
      maxWidth: 'unset !important'
    }
  },
  collapseContentHide: {
    display: 'none'
  },
  '@keyframes fadeIn': {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  },
  collapseArrow: {
    display: 'inline-block',
    width: 24,
    height: 12,
    position: 'absolute',
    top: '50%',
    right: 10,
    marginTop: -7,
    '&::after, &::before': {
      display: 'block',
      position: 'absolute',
      top: '50%',
      width: 10,
      height: 2,
      backgroundColor: 'currentColor',
      content: "''",
      transition: 'transform 0.25s ease'
    },
    '&::before': {
      left: 4,
      transform: 'rotate(45deg)'
    },
    '&::after': {
      right: 4,
      transform: 'rotate(-45deg)'
    }
  }
};

function CategoryItem(props) {
  var classes = props.classes,
      category = props.category,
      idx = props.idx,
      colors = props.colors,
      fixedColors = props.fixedColors,
      textColors = props.textColors,
      statusColors = props.statusColors,
      language = props.language;
  var data = category.instruments;
  var innerColumns = cloneDeep_1(columns);
  var tableProps = {
    showPagination: false,
    minRows: 0,
    multiSort: false,
    resizable: false,
    filterable: false,
    sortable: false,
    style: {
      fontSize: 14,
      border: null
    } // dynamically add colors to expander column

  };
  columns.forEach(function (column) {
    if (column.Expander) {
      column.getProps = function () {
        return {
          colors: colors,
          textcolors: textColors,
          language: language
        };
      };
    } else {
      column.getProps = function () {
        return {
          statuscolors: statusColors,
          language: language
        };
      };
    }
  });
  innerColumns.forEach(function (column) {
    if (column.Header === 'Name') {
      column.style.paddingLeft = '1rem';
    }
  });
  var categoryWeight = numberDecimalFormat(category.weight * 100, language);
  return React__default.createElement(umd_2, {
    expanded: idx === 0
  }, React__default.createElement(umd_3, {
    className: classes.collapseHeader,
    hideBodyClassName: classes.collapseHeaderHide
  }, React__default.createElement('h4', {
    className: classes.collapseHeaderContent
  }, category.name, React__default.createElement('span', {
    className: classes.collapseHeaderPercentage
  }, categoryWeight, '%')), React__default.createElement('span', {
    className: classes.collapseArrow
  })), React__default.createElement(umd_4, {
    className: classes.collapseContent,
    hideBodyClassName: classes.collapseContentHide
  }, data && React__default.createElement(ReactTable, _extends$4({
    data: data,
    columns: columns,
    getTheadThProps: getTheadThProps,
    getTheadProps: getTheadProps(fixedColors, textColors),
    getTrGroupProps: getTrGroupProps(fixedColors),
    getTrProps: getTrProps,
    getTdProps: getTdProps,
    className: '-highlight'
  }, tableProps, {
    SubComponent: function SubComponent(row) {
      var holdings = row.original.holdings;

      if (holdings) {
        return React__default.createElement(ReactTable, _extends$4({
          data: holdings,
          columns: innerColumns,
          TheadComponent: InnerTheadComponent,
          getTableProps: innerTableProps,
          getTrGroupProps: getInnerTrGroupProps(fixedColors),
          getTrProps: getTrProps,
          getTdProps: getTdProps
        }, tableProps, {
          style: {
            backgroundColor: fixedColors.backgroundLight
          }
        }));
      }

      return null;
    }
  }))));
}

CategoryItem.propTypes = {
  classes: PropTypes.shape().isRequired,
  category: PropTypes.shape().isRequired,
  idx: PropTypes.number.isRequired,
  language: PropTypes.string.isRequired,
  colors: PropTypes.shape({
    primary: PropTypes.string,
    secondary: PropTypes.string
  }).isRequired,
  fixedColors: PropTypes.shape({
    background: PropTypes.string,
    backgroundLight: PropTypes.string
  }).isRequired,
  textColors: PropTypes.shape({
    dark: PropTypes.string,
    light: PropTypes.string
  }).isRequired,
  statusColors: PropTypes.shape({
    loss: PropTypes.string,
    profit: PropTypes.string
  }).isRequired
};
var CategoryItem$1 = injectSheet$1(styles$a)(CategoryItem);

var InstrumentAllocation = function (_React$Component) {
  inherits(InstrumentAllocation, _React$Component);

  function InstrumentAllocation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck$1(this, InstrumentAllocation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InstrumentAllocation.__proto__ || Object.getPrototypeOf(InstrumentAllocation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedOption: 'by_class'
    }, _this.handleOptionChange = function (e) {
      _this.setState({
        selectedOption: e.target.value
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass$1(InstrumentAllocation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          title = _props.title,
          tooltipOptions = _props.tooltipOptions,
          language = _props.language,
          colorsProp = _props.colors,
          fixedColorsProp = _props.fixedColors,
          textColorsProp = _props.textColors,
          statusColorsProp = _props.statusColors;
      var selectedOption = this.state.selectedOption;
      var values = data[selectedOption];
      var errorsInData = allocationErrors(data);
      var locale = helpers.setMainLanguage(language, getGlobalConfig().language); // create an Object-like structure to use colors better

      var _normalizeColors = normalizeColors$2({
        colors: colorsProp,
        fixedColors: fixedColorsProp,
        textColors: textColorsProp,
        statusColors: statusColorsProp
      }),
          colors = _normalizeColors.colors,
          fixedColors = _normalizeColors.fixedColors,
          textColors = _normalizeColors.textColors,
          statusColors = _normalizeColors.statusColors;

      return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
        title: title,
        errorsInData: errorsInData,
        tooltipOptions: tooltipOptions
      }), React__default.createElement(CategorySelect$1, {
        selectedOption: selectedOption,
        onOptionChange: this.handleOptionChange,
        colors: colors
      }), React__default.createElement(umd_1, {
        accordion: false
      }, values.map(function (category, index) {
        return React__default.createElement(CategoryItem$1, {
          category: category,
          colors: colors,
          fixedColors: fixedColors,
          textColors: textColors,
          statusColors: statusColors,
          language: locale,
          idx: index,
          key: category.name
        });
      })));
    }
  }]);
  return InstrumentAllocation;
}(React__default.Component); // TODO: At the moment colors for this table are passed as an array. An object
// may fit better in order to expose a better way to style the table.


InstrumentAllocation.propTypes = {
  data: PropTypes.shape().isRequired,
  title: PropTypes.string,
  colors: ColorsPropType,
  fixedColors: ColorsPropType,
  textColors: ColorsPropType,
  statusColors: ColorsPropType,
  language: PropTypes.string
};
InstrumentAllocation.propDefs = {
  data: {
    type: 'Object',
    description: 'Data to display in the table. Should be related to Core.Analyse data structure.'
  },
  colors: Defs.colorsDef,
  fixedColors: Defs.fixedColorsDef,
  textColors: Defs.textColorsDef,
  statusColors: Defs.statusColorsDef,
  title: Defs.titleDef,
  language: Defs.languageDef
};
InstrumentAllocation.defaultProps = {
  colors: null,
  fixedColors: null,
  textColors: null,
  statusColors: null,
  title: null,
  language: ''
};

function normalizeColors$2(_ref2) {
  var colors = _ref2.colors,
      fixedColors = _ref2.fixedColors,
      textColors = _ref2.textColors,
      statusColors = _ref2.statusColors;
  var globalTheme = getGlobalConfig().theme;
  var finalColors = helpers.valueOrDefault(colors, {
    primary: globalTheme.main.primary,
    secondary: globalTheme.main.secondary,
    secondaryHover: globalTheme.tints.secondary[1]
  });
  var finalFixedColors = helpers.valueOrDefault(fixedColors, {
    background: globalTheme.extra.background,
    backgroundLight: globalTheme.extra.backgroundLight,
    divider: globalTheme.extra.lightGrey
  });
  var finalTextColors = helpers.valueOrDefault(textColors, globalTheme.text);
  var finalStatusColors = helpers.valueOrDefault(statusColors, globalTheme.status);

  if (Array.isArray(finalColors)) {
    finalColors = {
      primary: helpers.valueAtIndexOrDefault(finalColors, 0, globalTheme.main.primary),
      secondary: helpers.valueAtIndexOrDefault(finalColors, 1, globalTheme.main.secondary),
      secondaryHover: helpers.valueAtIndexOrDefault(finalColors, 2, globalTheme.tints.secondary[1])
    };
  }

  if (Array.isArray(finalFixedColors)) {
    finalFixedColors = {
      background: helpers.valueAtIndexOrDefault(finalFixedColors, 0, globalTheme.extra.background),
      backgroundLight: helpers.valueAtIndexOrDefault(finalFixedColors, 1, globalTheme.extra.backgroundLight),
      divider: helpers.valueAtIndexOrDefault(finalFixedColors, 2, globalTheme.extra.lightGrey)
    };
  }

  if (Array.isArray(finalTextColors)) {
    finalTextColors = {
      dark: helpers.valueAtIndexOrDefault(finalTextColors, 0, globalTheme.text.dark),
      light: helpers.valueAtIndexOrDefault(finalTextColors, 1, globalTheme.text.light)
    };
  }

  if (Array.isArray(finalStatusColors)) {
    finalStatusColors = {
      loss: helpers.valueAtIndexOrDefault(finalStatusColors, 0, globalTheme.status.loss),
      profit: helpers.valueAtIndexOrDefault(finalStatusColors, 1, globalTheme.status.profit)
    };
  }

  return {
    colors: finalColors,
    fixedColors: finalFixedColors,
    textColors: finalTextColors,
    statusColors: finalStatusColors
  };
}

var styles$b = {
  chart: {
    '& .highcharts-root .highcharts-yaxis-labels text:first-of-type': {
      textAnchor: 'start'
    }
  }
};

function ProgressComparisonChart(props) {
  var value = props.value,
      valueLabel = props.valueLabel,
      target = props.target,
      targetLabel = props.targetLabel,
      title = props.title,
      suffix = props.suffix,
      language = props.language,
      colors = props.colors,
      classes = props.classes,
      chartOptions = props.chartOptions,
      errorsInData = props.errorsInData;
  var theme = getGlobalConfig().theme;
  var initialColor = helpers.valueAtIndexOrDefault(colors, 0, theme.main.secondary);
  var endColor = helpers.valueAtIndexOrDefault(colors, 1, theme.main.secondary);
  var targetColor = helpers.valueAtIndexOrDefault(colors, 2, theme.main.tertiary);
  var bandColor = helpers.valueAtIndexOrDefault(colors, 3, theme.extra.lightGrey);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var options = {
    chart: {
      height: 78,
      inverted: true,
      type: 'bar',
      spacingTop: 25,
      spacingBottom: 10,
      spacingLeft: 0,
      spacingRight: 0
    },
    title: null,
    legend: {
      enabled: false
    },
    xAxis: {
      categories: [valueLabel],
      labels: {
        useHTML: true,
        formatter: function formatter() {
          return '<div style="width: 55px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">' + valueLabel + '</div>';
        }
      }
    },
    yAxis: {
      title: null,
      max: Math.max(target ? target : 0, value) * 2,
      visible: true,
      gridLineColor: 'rgba(0, 0, 0, 0)',
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      maxPadding: 0.1,
      labels: {
        align: 'right',
        style: {
          color: getGlobalConfig().theme.text.light,
          fontSize: '12px'
        },
        formatter: function formatter() {
          return '' + this.value.toFixed(0) + suffix;
        },
        autoRotation: false,
        overflow: false
      },
      tickPositioner: function tickPositioner() {
        return [this.min, this.max];
      },
      events: {
        afterSetExtremes: function afterSetExtremes(event) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = this.chart.yAxis[0].plotLinesAndBands[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var plot = _step.value;

              if (plot.id === 'plot-band') {
                plot.destroy();
                this.chart.yAxis[0].addPlotBand({
                  from: 0,
                  to: event.max,
                  color: bandColor,
                  id: 'plot-band'
                });
                this.chart.reflow();
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      },
      plotLines: target ? [{
        value: target,
        zIndex: 5,
        width: 5,
        color: targetColor,
        label: {
          style: {
            color: getGlobalConfig().theme.text.dark,
            fontSize: '12px'
          },
          text: targetLabel,
          rotation: 0,
          align: 'center',
          verticalAlign: 'top',
          y: -7,
          x: 0
        }
      }] : undefined
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        }
      },
      series: {
        dataLabels: {
          enabled: true,
          crop: false,
          overflow: 'none'
        },
        pointPadding: 0,
        groupPadding: 0,
        borderWidth: 0,
        color: {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1
          },
          stops: [[0, initialColor], [1, endColor]]
        }
      }
    },
    series: [{
      dataLabels: [{
        formatter: function formatter() {
          return '' + numberDecimalFormat(this.point.y, locale) + suffix;
        },
        y: -1,
        style: {
          color: endColor,
          fontWeight: 'bold',
          textOutline: '0px',
          fontSize: '12px'
        }
      }],
      data: [{
        y: value,
        target: target
      }]
    }],
    tooltip: {
      formatter: function formatter() {
        return '<b>' + numberDecimalFormat(this.point.y, locale) + suffix + '</b> ' + (this.point.target ? 'compared to ' + numberDecimalFormat(this.point.target, locale) + suffix : '');
      }
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    }
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData
  }), React__default.createElement('div', {
    className: classes.chart
  }, React__default.createElement(HighchartsBase, {
    options: merge_1(options, chartOptions),
    language: locale,
    callback: function callback(chart) {
      chart.yAxis[0].addPlotBand({
        from: 0,
        to: chart.yAxis[0].max,
        color: bandColor,
        id: 'plot-band'
      });
      chart.reflow();
    }
  })));
}

ProgressComparisonChart.propTypes = {
  value: PropTypes.number.isRequired,
  target: PropTypes.number,
  title: PropTypes.string.isRequired,
  classes: PropTypes.shape().isRequired,
  valueLabel: PropTypes.string,
  targetLabel: PropTypes.string,
  colors: ColorsPropType,
  suffix: PropTypes.string,
  language: PropTypes.string,
  chartOptions: PropTypes.shape(),
  errorsInData: PropTypes.arrayOf(PropTypes.shape())
};
ProgressComparisonChart.defaultProps = {
  colors: null,
  targetLabel: 'Target',
  valueLabel: 'Value',
  language: '',
  suffix: '',
  chartOptions: {},
  errorsInData: []
};
ProgressComparisonChart.propDefs = {
  classes: Defs.classesDef,
  value: {
    type: 'number',
    description: 'Data to be displayed in the chart.'
  },
  valueLabel: {
    type: 'string',
    description: 'Label to be shown under the value line.'
  },
  target: {
    type: 'number',
    description: 'Value to compare.'
  },
  targetLabel: {
    type: 'string',
    description: 'Label to be shown under the target line.'
  },
  title: Defs.titleDef,
  suffix: {
    type: 'string',
    description: 'Add a suffix to all values(percentage or currency for example)'
  },
  colors: Defs.arrayColorsDef,
  language: Defs.languageDef,
  chartOptions: Defs.chartOptionsDef
};
var ProgressComparisonChart$1 = injectSheet$1(styles$b)(ProgressComparisonChart);

function riskMetricsErrors(data) {
  if (!data || !data['by_components']) {
    return null;
  }

  return data['by_components'].filter(function (item) {
    if (item.error) {
      return item;
    }
  });
}

function ValueAtRiskChart(props) {
  var data = props.data,
      benchmarkData = props.benchmarkData,
      benchmarkName = props.benchmarkName,
      others = objectWithoutProperties(props, ['data', 'benchmarkData', 'benchmarkName']);
  var errorsInData = riskMetricsErrors(data);
  return React__default.createElement(ProgressComparisonChart$1, _extends$4({
    title: 'Value at Risk',
    value: Math.abs(data.risk_metrics['var_mc']) * 100,
    valueLabel: 'V@R',
    target: Math.abs(benchmarkData.risk_metrics['var_mc']) * 100,
    targetLabel: benchmarkName,
    suffix: '%',
    errorsInData: errorsInData
  }, others));
}

ValueAtRiskChart.propTypes = {
  data: PropTypes.shape().isRequired,
  benchmarkData: PropTypes.shape().isRequired,
  benchmarkName: PropTypes.string
};
ValueAtRiskChart.defaultProps = {
  benchmarkName: 'S&P500'
};
ValueAtRiskChart.propDefs = {
  data: {
    type: 'Object',
    description: 'Data to be displayed in the chart, expects the shape of Core.Analyse Risk Metrics endpoint.'
  },
  benchmarkData: {
    type: 'Object',
    description: 'Benchmark Data to be displayed in the chart, expects the shape of Core.Analyse Risk Metrics endpoint.'
  },
  benchmarkName: {
    type: 'string',
    description: 'Label to be shown for the benchmark'
  }
};

function VolatilityChart(props) {
  var data = props.data,
      benchmarkData = props.benchmarkData,
      benchmarkName = props.benchmarkName,
      others = objectWithoutProperties(props, ['data', 'benchmarkData', 'benchmarkName']);
  var errorsInData = riskMetricsErrors(data);
  return React__default.createElement(ProgressComparisonChart$1, _extends$4({
    title: 'Volatility',
    value: Math.abs(data.risk_metrics['volatility_annual']) * 100,
    valueLabel: 'Vol.',
    target: benchmarkData ? Math.abs(benchmarkData.risk_metrics['volatility_annual']) * 100 : undefined,
    targetLabel: benchmarkName,
    suffix: '%',
    errorsInData: errorsInData
  }, others));
}

VolatilityChart.propTypes = {
  data: PropTypes.shape().isRequired,
  benchmarkData: PropTypes.shape(),
  benchmarkName: PropTypes.string
};
VolatilityChart.defaultProps = {
  benchmarkName: 'S&P500'
};
VolatilityChart.propDefs = {
  data: {
    type: 'Object',
    description: 'Data to be displayed in the chart, expects the shape of Core.Analyse Risk Metrics endpoint.'
  },
  benchmarkData: {
    type: 'Object',
    description: 'Benchmark Data to be displayed in the chart, expects the shape of Core.Analyse Risk Metrics endpoint.'
  },
  benchmarkName: {
    type: 'string',
    description: 'Label to be shown for the benchmark'
  }
};

function dateLangFormat(value, lang) {
  var locale = lang.toUpperCase();

  switch (locale) {
    case 'DE':
      return new Date(value).toLocaleDateString('de-DE', {
        timeZone: 'UTC',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });

    case 'EN':
    default:
      return new Date(value).toLocaleDateString('en-US', {
        timeZone: 'UTC',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });
  }
}

var styles$c = {
  chart: {
    '& .highcharts-root .highcharts-yaxis-labels text:first-of-type': {
      textAnchor: 'start'
    }
  },
  recoveryDetail: {
    fontSize: 12,
    '& p': {
      marginTop: 0
    }
  },
  recoveryTextDetail: {
    color: function color(_ref) {
      var textColors = _ref.textColors;
      return textColors.dark;
    },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: 5
  }
};

function MDDRecoveryChartWrapper(props) {
  var globalTheme = getGlobalConfig().theme;
  var textColors = helpers.valueOrDefault(globalTheme.text);
  return React__default.createElement(StyledMDDRecoveryChart, _extends$4({
    textColors: textColors
  }, props));
}

function MDDRecoveryChart(props) {
  var title = props.title,
      data = props.data,
      colors = props.colors,
      daysLabel = props.daysLabel,
      recoveryLabel = props.recoveryLabel,
      notYetRecovered = props.notYetRecovered,
      language = props.language,
      classes = props.classes,
      chartOptions = props.chartOptions;
  var mddValue = data.risk_metrics.mdd * 100;
  var theme = getGlobalConfig().theme;
  var mainColor = helpers.valueAtIndexOrDefault(colors, 0, theme.main.secondary);
  var secondColor = helpers.valueAtIndexOrDefault(colors, 1, theme.extra.lightGrey);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var mddStart = data.risk_metrics.mdd_peak_date;
  var mddEnd = data.risk_metrics.mdd_date;
  var recovery = data.risk_metrics.recovery_days;
  var recoveryEnd = data.risk_metrics.recovery_date;
  var errorsInData = riskMetricsErrors(data);
  var options = {
    chart: {
      type: 'bar',
      height: 55,
      spacingBottom: 11,
      spacingTop: 2,
      spacingLeft: 0,
      spacingRight: 0,
      plotBackgroundColor: secondColor,
      style: {
        fontFamily: 'inherit'
      }
    },
    title: null,
    legend: {
      enabled: false
    },
    colors: [mainColor],
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function formatter() {
        return '<span>' + mddStart + ' - ' + mddEnd + '</span>';
      }
    },
    xAxis: {
      categories: ['Max Loss'],
      labels: {
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          color: theme.text.dark
        }
      }
    },
    yAxis: {
      title: null,
      min: 0,
      max: mddValue < -10 ? -100 : Math.floor(mddValue * 5),
      tickPositioner: function tickPositioner() {
        return [this.max, this.min];
      },
      labels: {
        align: 'right',
        style: {
          color: theme.text.light,
          fontSize: '12px'
        },
        formatter: function formatter() {
          return this.value + '%';
        },
        autoRotation: false,
        overflow: false
      }
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          inside: false
        }
      },
      series: {
        stacking: 'normal',
        pointPadding: 0,
        groupPadding: 0,
        borderWidth: 0
      }
    },
    series: [{
      dataLabels: {
        formatter: function formatter() {
          return numberDecimalFormat(this.point.y, locale) + '%';
        },
        y: -1,
        style: {
          color: mainColor,
          fontWeight: 'bold',
          textOutline: '0px',
          fontSize: '12px'
        }
      },
      data: [mddValue]
    }]
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData
  }), React__default.createElement('div', {
    className: classes.chart
  }, React__default.createElement(HighchartsBase, {
    options: merge_1(options, chartOptions),
    language: locale
  })), React__default.createElement('div', {
    className: classes.recoveryDetail
  }, React__default.createElement('p', {
    className: classes.recoveryTextDetail
  }, recoveryEnd ? React__default.createElement(React__default.Fragment, null, React__default.createElement('b', null, recoveryLabel + ': ' + recovery + ' ' + daysLabel), '\xA0 (', dateLangFormat(mddStart, locale) + ' - ' + dateLangFormat(mddEnd, locale), ')') : React__default.createElement(React__default.Fragment, null, React__default.createElement('b', null, recoveryLabel + ':'), '\xA0 ', notYetRecovered + ' ' + dateLangFormat(mddEnd, locale)))));
}

MDDRecoveryChart.propTypes = {
  data: PropTypes.shape().isRequired,
  classes: PropTypes.shape().isRequired,
  title: PropTypes.node.isRequired,
  colors: ColorsPropType,
  daysLabel: PropTypes.string,
  recoveryLabel: PropTypes.string,
  language: PropTypes.string,
  notYetRecovered: PropTypes.string,
  chartOptions: PropTypes.shape()
};
MDDRecoveryChart.defaultProps = {
  colors: null,
  assetsInfo: null,
  daysLabel: 'days',
  recoveryLabel: 'Recovery',
  notYetRecovered: 'Has not recovered since',
  language: '',
  chartOptions: {}
};
MDDRecoveryChart.propDefs = {
  classes: Defs.classesDef,
  data: {
    type: 'Object',
    description: 'Data to be displayed. Expects the shape of Core.Analyse Risk metrics endpoint.'
  },
  title: Defs.titleDef,
  colors: Defs.arrayColorsDef,
  daysLabel: {
    type: 'string',
    description: 'String to be used as time measure for the recovery days. Defaults to English `days´.'
  },
  recoveryLabel: {
    type: 'string',
    description: 'String to be used as title for the recovery days. Defaults to English `Recovery´.'
  },
  notYetRecovered: {
    type: 'string',
    description: 'String to be used in the axis label for the recovery days if portfolio has not been recovered. Defaults to English `Has not recovered since´.'
  },
  language: Defs.languageDef,
  chartOptions: Defs.chartOptionsDef
};
var StyledMDDRecoveryChart = injectSheet$1(styles$c)(MDDRecoveryChart);

function getTheadThProps$1() {
  return {
    style: {
      outline: 'none'
    }
  };
}

function getTheadProps$1(colors, fixedColors) {
  return function () {
    return {
      style: {
        fontSize: 12,
        fontWeight: 'bold',
        color: colors.secondary,
        backgroundColor: fixedColors.backgroundLight
      }
    };
  };
}

function getTrGroupProps$1(fixedColors) {
  return function () {
    return {
      style: {
        borderBottom: '1px solid ' + fixedColors.lightGrey
      }
    };
  };
}

function getTdProps$1(tableState, rowInfo, columnInfo) {
  var sortedId = tableState && tableState.sorted && tableState.sorted[0] && tableState.sorted[0].id ? tableState.sorted[0].id : '';
  var cellId = columnInfo.id;
  return {
    style: {
      border: 'none',
      fontWeight: cellId === sortedId ? 'bold' : 'normal'
    }
  };
}

function getThProps() {
  return {
    style: {
      border: 'none'
    }
  };
}

var IndicatorCell = function IndicatorCell(props) {
  var locale = props.columnProps.rest.locale;
  var value = props.value;
  return numberDecimalFormat(value, locale);
};

IndicatorCell.propTypes = {
  value: PropTypes.number.isRequired,
  columnProps: PropTypes.shape.isRequired
};

var InstrumentsCell = function InstrumentsCell(props) {
  var value = props.value;
  var valueStyle = {
    fontWeight: 'bold',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
  return React__default.createElement('span', {
    style: valueStyle
  }, React__default.createElement(Tooltip$3, {
    tooltip: value
  }, value));
};

InstrumentsCell.propTypes = {
  value: PropTypes.number.isRequired
};
var columns$1 = [{
  Header: function Header() {
    return React__default.createElement(React__default.Fragment, null, 'Instrument Name', React__default.createElement('span', {
      className: 'caret'
    }), React__default.createElement('br', null), 'Portfolio');
  },
  headerStyle: {
    textAlign: 'left',
    textTransform: 'uppercase'
  },
  accessor: 'instrument',
  style: {
    position: 'relative'
  },
  minWidth: 180,
  Cell: InstrumentsCell
}, {
  Header: function Header() {
    return React__default.createElement(React__default.Fragment, null, 'ISIN', React__default.createElement('span', {
      className: 'caret'
    }));
  },
  headerStyle: {
    textAlign: 'left'
  },
  accessor: 'isin',
  minWidth: 100
}, {
  Header: function Header() {
    return React__default.createElement(Tooltip$3, {
      tooltip: 'Value at Risk'
    }, React__default.createElement('span', null, 'V@R', React__default.createElement('span', {
      className: 'caret'
    }), React__default.createElement('br', null), '(%)'));
  },
  headerStyle: {
    textAlign: 'right',
    paddingRight: 25
  },
  id: 'V@R',
  accessor: function accessor(d) {
    return Math.abs(d.var_hp);
  },
  style: {
    textAlign: 'right',
    paddingRight: 25
  },
  minWidth: 80,
  Cell: IndicatorCell
}, {
  Header: function Header() {
    return React__default.createElement(React__default.Fragment, null, 'Volatility', React__default.createElement('span', {
      className: 'caret'
    }), React__default.createElement('br', null), '(%)');
  },
  headerStyle: {
    textAlign: 'right',
    textTransform: 'uppercase',
    paddingRight: 25
  },
  accessor: 'volatility_annual',
  style: {
    textAlign: 'right',
    paddingRight: 25
  },
  minWidth: 100,
  Cell: IndicatorCell
}, {
  Header: function Header() {
    return React__default.createElement(Tooltip$3, {
      tooltip: 'Maximum Drawdown'
    }, React__default.createElement(React__default.Fragment, null, 'MDD', React__default.createElement('span', {
      className: 'caret'
    }), React__default.createElement('br', null), '(%)'));
  },
  headerStyle: {
    textAlign: 'right',
    paddingRight: 25
  },
  accessor: 'mdd',
  style: {
    textAlign: 'right',
    paddingRight: 25
  },
  minWidth: 80,
  Cell: IndicatorCell
}, {
  Header: function Header() {
    return React__default.createElement(Tooltip$3, {
      tooltip: 'Marginal Value at Risk'
    }, React__default.createElement(React__default.Fragment, null, 'mV@R', React__default.createElement('span', {
      className: 'caret'
    }), React__default.createElement('br', null), '(%)'));
  },
  headerStyle: {
    textAlign: 'right',
    paddingRight: 25
  },
  id: 'mV@R',
  accessor: function accessor(d) {
    return Math.abs(d.mvar_hp);
  },
  style: {
    textAlign: 'right',
    paddingRight: 25
  },
  minWidth: 80,
  Cell: IndicatorCell
}, {
  Header: function Header() {
    return React__default.createElement(Tooltip$3, {
      tooltip: 'Incremental Value at Risk'
    }, React__default.createElement(React__default.Fragment, null, 'iV@R', React__default.createElement('span', {
      className: 'caret'
    }), React__default.createElement('br', null), '(%)'));
  },
  headerStyle: {
    textAlign: 'right',
    paddingRight: 25
  },
  id: 'iV@R',
  accessor: function accessor(d) {
    return d.ivar_hp * -1;
  },
  style: {
    textAlign: 'right',
    paddingRight: 25
  },
  minWidth: 80,
  Cell: IndicatorCell
}, {
  Header: function Header() {
    return React__default.createElement(Tooltip$3, {
      tooltip: 'Conditional Value at Risk'
    }, React__default.createElement(React__default.Fragment, null, 'cV@R', React__default.createElement('span', {
      className: 'caret'
    }), React__default.createElement('br', null), '(%)'));
  },
  headerStyle: {
    textAlign: 'right',
    paddingRight: 25
  },
  id: 'cV@R',
  accessor: function accessor(d) {
    return Math.abs(d.cvar_hp);
  },
  style: {
    textAlign: 'right',
    paddingRight: 25
  },
  minWidth: 80,
  Cell: IndicatorCell
}];
var styles$d = {
  instrumentRiskMetricsWrapper: {
    height: '100%',
    '& .ReactTable': {
      border: 'none',
      maxHeight: 'calc(100% - 47px)' // 47px is for title's height.

    },
    '& .ReactTable .rt-thead.-header': {
      boxShadow: 'none'
    },
    '& .ReactTable .rt-thead .rt-th': {
      border: 'none'
    },
    '& .ReactTable .rt-thead .rt-th, .ReactTable .rt-thead .rt-td': {
      padding: '8px 10px'
    },
    '& .ReactTable .rt-th, .ReactTable .rt-td': {
      padding: '8px 10px'
    },
    '& .ReactTable .rt-thead .rt-th.-sort-desc, & .ReactTable .rt-thead .rt-th.-sort-asc': {
      boxShadow: 'none'
    },
    '& .ReactTable .rt-thead .rt-th.-sort-asc .caret, & .ReactTable .rt-thead .rt-th.-sort-desc .caret': {
      display: 'inline-block',
      width: 24,
      height: 12,
      position: 'absolute',
      '&::after, &::before': {
        display: 'block',
        position: 'absolute',
        top: '50%',
        width: 10,
        height: 2,
        backgroundColor: 'currentColor',
        content: "''",
        transition: 'transform 0.25s ease'
      }
    },
    '& .ReactTable .rt-thead .rt-th.-sort-asc .caret': {
      '&::before': {
        right: 10,
        transform: 'rotate(-45deg)'
      },
      '&::after': {
        right: 4,
        transform: 'rotate(45deg)'
      }
    },
    '& .ReactTable .rt-thead .rt-th.-sort-desc .caret': {
      display: 'inline-block',
      width: 24,
      height: 12,
      position: 'absolute',
      '&::after, &::before': {
        display: 'block',
        position: 'absolute',
        top: '50%',
        width: 10,
        height: 2,
        backgroundColor: 'currentColor',
        content: "''",
        transition: 'transform 0.25s ease'
      },
      '&::before': {
        right: 10,
        transform: 'rotate(45deg)'
      },
      '&::after': {
        right: 4,
        transform: 'rotate(-45deg)'
      }
    },
    '& .ReactTable .rt-tbody': {
      overflowX: 'hidden'
    }
  }
};

function InstrumentRiskMetrics(props) {
  var title = props.title,
      data = props.data,
      colorsProp = props.colors,
      fixedColorsProp = props.fixedColors,
      textColorsProp = props.textColors,
      assetsInfo = props.assetsInfo,
      tooltipOptions = props.tooltipOptions,
      classes = props.classes,
      language = props.language;
  var errorsInData = riskMetricsErrors(data);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language); // it creates an Object-like structure to use colors better

  var _normalizeColors = normalizeColors$3({
    colors: colorsProp,
    fixedColors: fixedColorsProp,
    textColors: textColorsProp
  }),
      colors = _normalizeColors.colors,
      fixedColors = _normalizeColors.fixedColors,
      textColors = _normalizeColors.textColors;

  var tableProps = {
    showPagination: false,
    minRows: 0,
    multiSort: false,
    resizable: false,
    filterable: false,
    style: {
      color: textColors.dark,
      fontSize: 11
    }
  };
  columns$1.forEach(function (column) {
    column.getProps = function () {
      return {
        locale: locale
      };
    };
  });
  var tableData = data.by_components.filter(function (component) {
    return !component.error;
  }).map(function (component) {
    component.risk_metrics.instrument = extractAssetInfo(assetsInfo, component.isin, 'name', component.isin);
    component.risk_metrics.isin = component.isin;
    return component.risk_metrics;
  });
  return React__default.createElement('div', {
    className: classes.instrumentRiskMetricsWrapper
  }, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement(ReactTable, _extends$4({
    data: tableData,
    columns: columns$1,
    defaultSorted: [{
      id: 'instrument'
    }],
    getTheadThProps: getTheadThProps$1,
    getTrGroupProps: getTrGroupProps$1(fixedColors),
    getTdProps: getTdProps$1,
    getThProps: getThProps,
    getTheadProps: getTheadProps$1(colors, fixedColors),
    pageSize: tableData.length,
    className: '-highlight'
  }, tableProps)));
}

InstrumentRiskMetrics.propTypes = {
  title: PropTypes.node.isRequired,
  data: PropTypes.shape().isRequired,
  classes: PropTypes.shape().isRequired,
  assetsInfo: PropTypes.shape().isRequired,
  language: PropTypes.string,
  colors: ColorsPropType,
  fixedColors: ColorsPropType,
  textColors: ColorsPropType,
  tooltipOptions: TooltipOptionsPropType
};
InstrumentRiskMetrics.defaultProps = {
  colors: null,
  fixedColors: null,
  textColors: null,
  language: ''
};
InstrumentRiskMetrics.propDefs = {
  title: Defs.titleDef,
  data: {
    type: 'Object',
    description: 'Data to be displayed in the chart, expects the shape of Core.Analyse Risk Metrics endpoint.'
  },
  assetsInfo: {
    type: 'Object',
    description: 'Additional asset information to extract instruments\' name.'
  },
  language: Defs.languageDef,
  classes: Defs.classesDef,
  colors: Defs.colorsDef,
  fixedColors: Defs.fixedColorsDef,
  textColors: Defs.textColorsDef,
  tooltipOptions: Defs.tooltipOptionsDef
};

function normalizeColors$3(_ref) {
  var colors = _ref.colors,
      fixedColors = _ref.fixedColors,
      textColors = _ref.textColors;
  var globalTheme = getGlobalConfig().theme;
  var finalColors = helpers.valueOrDefault(colors, {
    primary: globalTheme.shades.secondary[2],
    secondary: globalTheme.main.secondary
  });
  var finalFixedColors = helpers.valueOrDefault(fixedColors, globalTheme.extra);
  var finalTextColors = helpers.valueOrDefault(textColors, globalTheme.text);

  if (Array.isArray(finalColors)) {
    finalColors = {
      primary: helpers.valueAtIndexOrDefault(finalColors, 0, globalTheme.shades.secondary[2]),
      secondary: helpers.valueAtIndexOrDefault(finalColors, 1, globalTheme.main.secondary)
    };
  }

  if (Array.isArray(finalFixedColors)) {
    finalFixedColors = {
      background: helpers.valueAtIndexOrDefault(finalFixedColors, 0, globalTheme.extra.background),
      backgroundLight: helpers.valueAtIndexOrDefault(finalFixedColors, 1, globalTheme.extra.backgroundLight)
    };
  }

  if (Array.isArray(finalTextColors)) {
    finalTextColors = {
      dark: helpers.valueAtIndexOrDefault(finalTextColors, 0, globalTheme.text.dark),
      light: helpers.valueAtIndexOrDefault(finalTextColors, 1, globalTheme.text.light)
    };
  }

  return {
    colors: finalColors,
    fixedColors: finalFixedColors,
    textColors: finalTextColors
  };
}

var InstrumentRiskMetrics$1 = injectSheet$1(styles$d)(InstrumentRiskMetrics);

function AllocationTreeMapChart(props) {
  var data = props.data,
      title = props.title,
      group = props.group,
      orientation = props.orientation,
      colors = props.colors,
      gradient = props.gradient,
      showColorAxis = props.showColorAxis,
      showLegend = props.showLegend,
      legendTitle = props.legendTitle,
      language = props.language,
      tooltipOptions = props.tooltipOptions;
  var values = data[group];
  var errorsInData = allocationErrors(data);
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var verticalLegendOptions = {
    layout: ORIENTATION.VERTICAL,
    align: 'right',
    verticalAlign: 'middle'
  };
  var horizontalLegendOptions = {
    layout: ORIENTATION.HORIZONTAL,
    alignColumns: false,
    align: 'center',
    verticalAlign: 'bottom'
  };
  var options = {
    chart: {
      type: 'treemap',
      style: {
        fontFamily: 'inherit'
      }
    },
    colorAxis: undefined,
    colors: undefined,
    credits: {
      enabled: false
    },
    legend: {
      enabled: showLegend,
      title: {
        text: legendTitle
      }
    },
    plotOptions: {
      treemap: {
        layoutAlgorith: 'squarified',
        colorByPoint: Boolean(colors),
        showInLegend: true
      }
    },
    series: [{
      data: dataFormatter$3(values),
      legendType: 'point'
    }],
    title: null,
    tooltip: {
      formatter: function formatter() {
        var weight = numberDecimalFormat(Number(this.point.value), locale, {
          style: 'percent',
          minimumFractionDigits: 2
        });
        var value = numberDecimalFormat(Number(this.point.marketValue), locale, {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'code'
        });
        return '<b>' + this.point.name + ':</b> <br> Weight: ' + weight + '<br>\n            Value: ' + value;
      },
      followPointer: true
    }
  };
  Object.assign(options.legend, orientation === ORIENTATION.VERTICAL ? verticalLegendOptions : horizontalLegendOptions);

  if (!colors) {
    options.colorAxis = {
      minColor: helpers.valueOrDefault(gradient.min, getGlobalConfig().theme.tints.primary[4]),
      maxColor: helpers.valueOrDefault(gradient.max, getGlobalConfig().theme.main.primary),
      showInLegend: showColorAxis
    };
  } else {
    options.colors = helpers.getColors(colors, getGlobalConfig(), values.length);
  }

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement(HighchartsBase, {
    language: locale,
    options: options,
    callback: function callback(chart) {
      // Fix to show correct colors in legend items.
      chart.reflow();
    }
  }));
}

AllocationTreeMapChart.propTypes = {
  data: PropTypes.shape().isRequired,
  title: PropTypes.node.isRequired,
  group: AllocationGroupPropType.isRequired,
  language: PropTypes.string,
  orientation: OrientationPropType,
  colors: ColorsPropType,
  gradient: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string
  }),
  showColorAxis: PropTypes.bool,
  showLegend: PropTypes.bool,
  legendTitle: PropTypes.node,
  tooltipOptions: TooltipOptionsPropType
};
AllocationTreeMapChart.propDefs = {
  data: {
    type: 'Object',
    description: 'Data to be displayed. Expects the shape of the response from Core.Analyse Allocation Endpoint'
  },
  title: Defs.titleDef,
  language: Defs.languageDef,
  group: Defs.allocationGroupsDef,
  orientation: Defs.orientationsDef,
  gradient: {
    type: 'Object',
    description: '\n      Object with the following properties to generate colors:\'\n      <ul>\n        <li>min</li>\n        <li>max</li>\n      </ul>\n    '
  },
  colors: {
    type: Defs.arrayColorsDef.type,
    description: Defs.arrayColorsDef.description + '. Has higher priority than the property <b>gradient</b>.'
  },
  showColorAxis: {
    type: 'bool',
    description: 'Whether to show color axis or not'
  },
  showLegend: {
    type: 'bool',
    description: 'Whether to show legend or not'
  },
  legendTitle: {
    type: 'string',
    description: 'Title to be shown in the legend'
  },
  tooltipOptions: Defs.tooltipOptionsDef
};
AllocationTreeMapChart.defaultProps = {
  orientation: ORIENTATION.HORIZONTAL,
  colors: null,
  gradient: {
    min: null,
    max: null
  },
  language: '',
  showColorAxis: true,
  showLegend: true,
  tooltipOptions: {}
};

function dataFormatter$3(data) {
  var formattedData = data.map(function (item, index) {
    return {
      name: item.name,
      value: item.weight,
      colorValue: item.weight * 100,
      marketValue: item.market_value
    };
  });
  return formattedData;
}

function performanceTimeseriesErrors(data) {
  if (!data || !data.warning) {
    return [];
  }

  if (_typeof$2(data.warning) === 'object') {
    return data.warning.isins;
  } else {
    // TEMPORARY WORKAROUND
    var start = data.warning.indexOf('[');
    var end = data.warning.indexOf(']') + 1;
    var listStr = data.warning.substring(start, end);
    listStr = listStr.split('\'').join('"');
    var list = JSON.parse(listStr);
    return list;
  }
}

function PerformanceComparisonChart(props) {
  var title = props.title,
      language = props.language,
      tooltipOptions = props.tooltipOptions,
      data = props.data,
      chartOptions = props.chartOptions,
      colors = props.colors,
      seriesNames = props.seriesNames;
  var errors = [];
  data.map(function (dataset) {
    errors.push(performanceTimeseriesErrors(dataset));
  });
  var errorSet = new Set(errors.flat());
  var errorsInData = Array.from(errorSet).map(function (isin) {
    return {
      isin: isin
    };
  });
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);
  var options = {
    plotOptions: {
      series: {
        compare: 'percent',
        compareBase: 100,
        showInNavigator: true,
        states: {
          hover: {
            lineWidth: 2
          }
        }
      }
    },
    legend: {
      enabled: true,
      align: 'left'
    },
    rangeSelector: {
      enabled: false,
      inputEnabled: false
    },
    chart: {
      height: 450,
      style: {
        fontFamily: 'inherit'
      }
    },
    title: null,
    navigator: {
      enabled: false
    },
    scrollbar: {
      enabled: false
    },
    colors: helpers.getColors(colors, getGlobalConfig(), data.length),
    credits: {
      enabled: false
    },
    yAxis: {
      opposite: false,
      labels: {
        formatter: function formatter() {
          return this.value;
        }
      },
      plotLines: [{
        value: 0,
        width: 2
      }]
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)<br/>',
      valueDecimals: 2,
      split: true
    },
    series: data.map(function (dataset, i) {
      var name = helpers.valueOrDefault(helpers.valueAtIndexOrDefault(seriesNames, i, dataset.name), 'Series ' + (i + 1));
      return {
        name: name,
        data: dataFormatter$4(dataset),
        tooltip: {
          valueDecimals: 2
        }
      };
    })
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ChartTitleWrapper, {
    title: title,
    errorsInData: errorsInData,
    tooltipOptions: tooltipOptions
  }), React__default.createElement(HighchartsBase, {
    language: locale,
    options: merge_1(options, chartOptions),
    constructorType: 'stockChart'
  }));
}

PerformanceComparisonChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  title: PropTypes.node.isRequired,
  language: PropTypes.string,
  chartOptions: PropTypes.shape(),
  colors: ColorsPropType,
  seriesNames: PropTypes.arrayOf(PropTypes.string)
};
PerformanceComparisonChart.defaultProps = {
  language: '',
  chartOptions: {},
  colors: null,
  seriesNames: []
};
PerformanceComparisonChart.propDefs = {
  data: {
    type: 'array',
    description: 'Data to be displayed in the chart. A list of historical values is required.'
  },
  title: Defs.titleDef,
  chartOptions: Defs.chartOptionsDef,
  colors: Defs.arrayColorsDef,
  language: Defs.languageDef,
  seriesNames: {
    type: 'array',
    description: 'Names for each of the series in the chart.'
  }
};

function dataFormatter$4(data) {
  var formattedData = data.portfolio.map(function (portfolio) {
    return [Date.parse(portfolio.date), portfolio.value];
  });
  return formattedData;
}

function getTheadProps$2(textColors, fixedColors) {
  return function () {
    return {
      style: {
        fontSize: 12,
        backgroundColor: fixedColors.backgroundLight,
        fontWeight: 'bold',
        height: 45,
        color: textColors.light
      }
    };
  };
}

function getTrGroupProps$2(fixedColors) {
  return function () {
    return {
      style: {
        borderBottom: '1px solid ' + fixedColors.lightGrey
      }
    };
  };
}

var IndicatorCell$1 = function IndicatorCell(props) {
  var original = props.original;
  var statuscolors = props.columnProps.rest.statuscolors;

  var compareFunc = function compareFunc(a, b) {
    return a <= b;
  };

  if (typeof original.compare === 'function') {
    compareFunc = original.compare;
  }

  var iconStyle = {
    color: compareFunc(original.portfolio, original.benchmark) ? statuscolors.profit : statuscolors.loss
  };
  return React__default.createElement(FontAwesomeIcon, {
    icon: faCircle,
    style: iconStyle
  });
};

IndicatorCell$1.propTypes = {
  original: PropTypes.shape.isRequired,
  columnProps: PropTypes.shape.isRequired
};

function valueAccesor(d, key) {
  var unit = '';

  if (d.unit) {
    unit = d.unit;
  }

  return (typeof d[key] === 'number' ? d[key].toFixed(2) : d[key]) + unit;
}

var columns$2 = [{
  Header: 'Risk Indicator',
  headerStyle: {
    textAlign: 'left',
    textTransform: 'uppercase'
  },
  accessor: 'label',
  style: {
    fontWeight: 'bold'
  },
  sortable: false
}, {
  Header: 'Portfolio',
  headerStyle: {
    textAlign: 'right',
    textTransform: 'uppercase'
  },
  id: 'portfolioVal',
  accessor: function accessor(d) {
    return valueAccesor(d, 'portfolio');
  },
  style: {
    textAlign: 'right'
  },
  sortable: false
}, {
  Header: 'benchmark',
  headerStyle: {
    textAlign: 'right',
    textTransform: 'uppercase'
  },
  id: 'benchmark',
  accessor: function accessor(d) {
    return valueAccesor(d, 'benchmark');
  },
  style: {
    textAlign: 'right'
  },
  sortable: false
}, {
  Header: '',
  accessor: 'portfolio',
  style: {
    textAlign: 'center'
  },
  width: 50,
  sortable: false,
  Cell: IndicatorCell$1
}];
var styles$e = {
  benchmarkRiskMetricsWrapper: {
    '& .ReactTable': {
      border: 'none'
    },
    '& .ReactTable .rt-thead.-header': {
      boxShadow: 'none'
    },
    '& .ReactTable .rt-thead .rt-th': {
      border: 'none',
      padding: [[5, 10]]
    },
    '& .ReactTable .rt-td': {
      padding: [[7, 10]]
    }
  }
};

function BenchmarkRiskMetrics(props) {
  var title = props.title,
      data = props.data,
      benchmark = props.benchmark,
      fixedColorsProp = props.fixedColors,
      textColorsProp = props.textColors,
      statusColorsProp = props.statusColors,
      classes = props.classes,
      language = props.language,
      subHeaderComponent = props.subHeaderComponent;
  var locale = helpers.setMainLanguage(language, getGlobalConfig().language);

  var _normalizeColors = normalizeColors$4({
    fixedColors: fixedColorsProp,
    textColors: textColorsProp,
    statusColors: statusColorsProp
  }),
      fixedColors = _normalizeColors.fixedColors,
      textColors = _normalizeColors.textColors,
      statusColors = _normalizeColors.statusColors;

  var tableProps = {
    showPagination: false,
    minRows: 0,
    multiSort: false,
    resizable: false,
    filterable: false,
    style: {
      color: textColors.dark,
      fontSize: 11
    }
  };
  columns$2.forEach(function (column) {
    column.getProps = function () {
      return {
        statuscolors: statusColors,
        locale: locale
      };
    };

    if (column.id === 'benchmark') {
      column.Header = benchmark;
    }
  });
  return React__default.createElement('div', {
    className: classes.benchmarkRiskMetricsWrapper
  }, React__default.createElement(ChartTitleWrapper, {
    title: title
  }), subHeaderComponent(), React__default.createElement(ReactTable, _extends$4({
    data: data,
    columns: columns$2,
    getTrGroupProps: getTrGroupProps$2(fixedColors),
    getTheadProps: getTheadProps$2(textColors, fixedColors),
    getHeaderProps: function getHeaderProps() {
      return {
        bmTitle: benchmark
      };
    }
  }, tableProps)));
}

BenchmarkRiskMetrics.propTypes = {
  classes: PropTypes.shape().isRequired,
  title: PropTypes.node,
  language: PropTypes.string,
  data: PropTypes.array,
  benchmark: PropTypes.string,
  subHeaderComponent: PropTypes.func,
  fixedColors: ColorsPropType,
  textColors: ColorsPropType,
  statusColors: ColorsPropType
};
BenchmarkRiskMetrics.propDefs = {
  classes: PropTypes.shape().isRequired,
  title: Defs.titleDef,
  language: Defs.languageDef,
  data: {
    type: 'list',
    description: '\n      List of objects with the following keys:\n      \n label: string with metric name\n      \n compare: func used to compare the metrics, defaults to <=\n      \n portfolio: number with the value for the metric for the portfolio\n      \n benchmark: number with the value for the metric for the benchmark '
  },
  subHeaderComponent: {
    type: 'function',
    description: 'In case some content is required below title, pass this function that should return the desired component.'
  }
};
BenchmarkRiskMetrics.defaultProps = {
  language: '',
  title: null,
  data: [],
  subHeaderComponent: function subHeaderComponent() {
    return null;
  }
};

function normalizeColors$4(_ref) {
  var fixedColors = _ref.fixedColors,
      textColors = _ref.textColors,
      statusColors = _ref.statusColors;
  var globalTheme = getGlobalConfig().theme;
  var finalFixedColors = helpers.valueOrDefault(fixedColors, globalTheme.extra);
  var finalTextColors = helpers.valueOrDefault(textColors, globalTheme.text);
  var finalStatusColors = helpers.valueOrDefault(statusColors, globalTheme.status);

  if (Array.isArray(finalFixedColors)) {
    finalFixedColors = {
      background: helpers.valueAtIndexOrDefault(finalFixedColors, 0, globalTheme.extra.background),
      backgroundLight: helpers.valueAtIndexOrDefault(finalFixedColors, 1, globalTheme.extra.backgroundLight)
    };
  }

  if (Array.isArray(finalTextColors)) {
    finalTextColors = {
      dark: helpers.valueAtIndexOrDefault(finalTextColors, 0, globalTheme.text.dark),
      light: helpers.valueAtIndexOrDefault(finalTextColors, 1, globalTheme.text.light)
    };
  }

  if (Array.isArray(finalStatusColors)) {
    finalStatusColors = {
      loss: helpers.valueAtIndexOrDefault(finalStatusColors, 0, globalTheme.status.loss),
      profit: helpers.valueAtIndexOrDefault(finalStatusColors, 1, globalTheme.status.profit)
    };
  }

  return {
    fixedColors: finalFixedColors,
    textColors: finalTextColors,
    statusColors: finalStatusColors
  };
}

var BenchmarkRiskMetrics$1 = injectSheet$1(styles$e)(BenchmarkRiskMetrics);
export { defaultColors as colors, setGlobalConfig, HistoricalValueChart, PerformanceAttributionChart$1 as PerformanceAttributionChart, IndicatorCard$1 as IndicatorCard, ProfitLossesList$1 as ProfitLossesList, AllocationPieChart, AllocationBarChart, AllocationMap, InstrumentAllocation, ProgressComparisonChart$1 as ProgressComparisonChart, ValueAtRiskChart, VolatilityChart, MDDRecoveryChartWrapper as MDDRecoveryChart, InstrumentRiskMetrics$1 as InstrumentRiskMetrics, AllocationTreeMapChart, InfoTooltip$1 as InfoTooltip, PerformanceComparisonChart, BenchmarkRiskMetrics$1 as BenchmarkRiskMetrics };